export const visionData = {
  "f518354a-b482-4c56-88a9-2dc2912890c1": {
    "career": "Research Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Strong research sector but not on CSOL"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Life-science researchers prioritized for permanent residency"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Fast-track visas for scientific researchers"
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Biopharma R&D prioritized for health resilience"
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Biomedical scientists on critical list"
      },
      "japan": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP scheme rewards biotech researchers"
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan targets pharma R&D talent"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Limited slots; case-by-case academic hiring"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "Developing biotech hubs under Vision 2030"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Singapore Economy 2030",
        "reason": "Biomedical research cornerstone of 2030 roadmap"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Operation 300bn",
        "reason": "Biotech research labs in 300bn manufacturing push"
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "89",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences R&D listed in IS-8"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "94",
        "policy": "CHIPS and Science Act",
        "reason": "Biotech R&D grants and visa pathways expanded"
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "National Master Plan 2021-2030",
        "reason": "Biotech researchers needed for health-tech push"
      }
    }
  },
  "c20d754e-2f8d-43c9-b3f4-b76f58a1a363": {
    "career": "Lecturer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "67",
        "policy": "",
        "reason": "Universities hire internationally via TSS visas"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Express Entry Category-Based Selection",
        "reason": "French-speaking lecturers earn extra CRS points"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Points system favours PhD academics"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "",
        "reason": "Third-level colleges hire; not a shortage occupation"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points for PhD educators"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Private universities attract foreign lecturers"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Universities recruit but role not on Green List"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Private universities expanding under Vision 2030"
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "71",
        "policy": "",
        "reason": "Autonomous universities recruit global faculty"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Knowledge-economy push increases higher-ed demand"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "",
        "reason": "UK universities actively recruit global lecturers"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Universities sponsor visas for qualified faculty"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "257b735b-2d81-4e04-b1c4-97ade0e8e91f": {
    "career": "Research Associate",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Migration Strategy 2023",
        "reason": "Climate adaptation research demand rising"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Sustainability researchers valued, esp. French speakers"
      },
      "germany": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Renewable-energy research central to Energiewende"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Asta Cita",
        "reason": "Climate resilience research for archipelago"
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "",
        "reason": "Climate targets driving environmental research hiring"
      },
      "japan": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Highly Skilled Professional visa",
        "reason": "Renewable-energy research scores HSP points"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Green economy push includes environmental studies"
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Migrant Category",
        "reason": "Conservation research supports biodiversity goals"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Megaprojects need environmental impact studies"
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Green Plan 2030",
        "reason": "Green Plan funds sustainability R&D"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "We the UAE 2031",
        "reason": "Sustainability initiatives hire environmental researchers"
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean-energy R&D explicitly supported"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "93",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds climate and environmental research jobs"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "National Master Plan 2021-2030",
        "reason": "Offshore wind projects need impact researchers"
      }
    }
  },
  "59be814c-3bb0-41a2-a6a7-da30e5a76934": {
    "career": "Data Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Migration Strategy 2023",
        "reason": "Growing demand for software and data roles."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Express Entry Category-Based Selection",
        "reason": "AI & data specialists on priority list."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialists shortage explicitly named."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech & AI listed, but early stage."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Data scientists on critical skills list."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "AI/ML researchers fast-tracked."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "AI talent supports semiconductor ambitions."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Digital talent welcome but not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "AI focus, but localisation priority first."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "National AI Strategy 2.0",
        "reason": "Aggressive hiring of AI/data talent."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "UAE Centennial 2071",
        "reason": "AI specialists key for diversification."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital/AI specialists explicitly prioritised."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "93",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds AI, big-data R&D and talent."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "AI engineers useful to chip sector."
      }
    }
  },
  "f16446a4-b6c2-4255-a947-c18d3c93bc3c": {
    "career": "Project Manager",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Construction project managers explicitly listed."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Construction managers in demand."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Engineering PMs support industrial builds."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "RPJPN 2025-2045",
        "reason": "Capital relocation projects emerging."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Construction PM recognised shortage."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Skilled managers valued but not priority."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industry 4.0 projects need coordination."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Green List (Tier 2)",
        "reason": "Large rebuild projects seek PMs."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "NEOM and mega-projects crave experienced PMs."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Manufacturing 2030",
        "reason": "Precision-engineering projects need PMs."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing projects need coordination."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "73",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Advanced manufacturing & defence projects."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Billions in projects need PM oversight."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "National Master Plan 2021-2030",
        "reason": "Infrastructure build-out ongoing."
      }
    }
  },
  "34fbd2d0-c339-4b46-9f98-0d60ad8515e8": {
    "career": "Operations Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Migration Strategy 2023",
        "reason": "Service economy seeks experienced managers."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Management talent stream open."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "General managers only adjacent priority."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "New capital build needs ops talent."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Managers adjacent to listed skills."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Senior managers valued but Japanese language barrier."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Manufacturing push needs ops oversight."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Migrant Category",
        "reason": "Managers welcome but not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Vision 2030",
        "reason": "Diversifying industries need ops leadership."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Economy 2030",
        "reason": "Regional HQs need operations leadership."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "We the UAE 2031",
        "reason": "Logistics and tourism hub demands ops excellence."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Advanced manufacturing needs operations leads."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "New facilities need experienced ops leaders."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "National Master Plan 2021-2030",
        "reason": "Industrial expansion demands managers slowly."
      }
    }
  },
  "610f01b8-6a5f-480f-b8eb-be27a315e521": {
    "career": "Financial Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Finance roles normal demand, no migration priority"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Demand exists; not on priority lists"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Finance jobs open but not shortage occupation"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Quants and analysts for IFSC"
      },
      "japan": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Fintech expansion needs analysts"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Singapore Economy 2030",
        "reason": "Global sustainable-finance centre"
      },
      "uae": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "We the UAE 2031",
        "reason": "Financial hub, DIFC growth"
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "95",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City prioritises financial services talent"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Large finance market but no policy boost"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "38f72e32-7313-4e61-8dce-e155b441f8cd": {
    "career": "International Business and Finance Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Generic demand, not on CSOL"
      },
      "canada": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Multinationals need managers; not shortage"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "FDI inflows need cross-border expertise"
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "IFSC houses global treasury centres"
      },
      "japan": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Islamic finance growth needs managers"
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Vision 2030",
        "reason": "Mega-projects seek global finance managers"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Singapore Economy 2030",
        "reason": "Asia-Pac HQ hub; strong finance ecosystem"
      },
      "uae": {
        "tier": "Tier 1",
        "score": "95",
        "policy": "UAE Centennial 2071",
        "reason": "Regional HQs and free zones recruit cross-border managers"
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City needs international finance leadership"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Global HQs need managers; no targeted policy"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "3630805c-5317-4df1-877c-a73dfb7e1965": {
    "career": "Business Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Consultancies hire; not on CSOL"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Demand exists within tech sector"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "IT-business bridge valued for digitalisation"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Tech multinationals need analysts"
      },
      "japan": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "NIMP 2030",
        "reason": "Industry 4.0 projects seek analysts"
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "Transformation projects need analysts"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "National AI Strategy 2.0",
        "reason": "Digital transformation hub values BA talent"
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Operation 300bn",
        "reason": "Public-sector and fintech reforms hire analysts"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital/AI initiatives require BA skillset"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Digital projects need analysts; no federal priority"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "64b38bd7-2a25-4633-8aec-701860a9ee79": {
    "career": "Academic Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Migration Strategy 2023",
        "reason": "Academic appointments on priority skilled visas"
      },
      "canada": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities recruit social-science researchers for growth"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Universities seek international psychology PhDs"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Research roles adjacent to ICT list"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Cognitive science funding limited but present"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "MADANI Economy",
        "reason": "Limited humanities R&D slots"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Limited psychology research demand"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "New universities need social research"
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "National AI Strategy 2.0",
        "reason": "Govt funds cognition-AI joint labs"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "We the UAE 2031",
        "reason": "Higher-ed expansion includes psychology research"
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "R&D funding protects behavioral science posts"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "NSF boost funds behavioral science PhD hires"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "81a642df-9fb4-4955-93a2-a2407231b46b": {
    "career": "Mechanical Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Mining and construction shortages"
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Occupation on direct invitation list"
      },
      "germany": {
        "tier": "Tier 1",
        "score": "95",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Automotive/mechatronics deficit"
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV battery plants growing"
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List includes mech engineers but smaller scale"
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics and auto sectors recruit engineers"
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "EV and aerospace push"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Some demand but lower volume"
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Renewable and megaproject mechanical systems"
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Manufacturing 2030",
        "reason": "Precision-engineering roadmap demands mechanical talent"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing push"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "EV and aerospace manufacturing targets"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA-funded factories need mechanical design"
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "National Master Plan 2021-2030",
        "reason": "Manufacturing upgrading needs mechanical skills"
      }
    }
  },
  "ea499e7d-e01f-4040-b988-afdc25243e0c": {
    "career": "Systems Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Digital-skills shortage lists systems analysts"
      },
      "canada": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Role explicitly prioritised for PR"
      },
      "germany": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialists get fast-track visas"
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "RPJPN 2025-2045",
        "reason": "Fintech and e-commerce scaling"
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Role on critical list in tech hub"
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "Enterprise IT modernisation"
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "MADANI Economy",
        "reason": "Digital government and banking modernisation"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Some demand but small market"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Government digitisation projects need analysts"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "National AI Strategy 2.0",
        "reason": "Enterprise digitalisation priority"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "UAE Centennial 2071",
        "reason": "Smart government initiatives"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital specialists shortage"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "CHIPS and Science Act",
        "reason": "Federal IT modernisation creates analyst demand"
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "National Master Plan 2021-2030",
        "reason": "E-commerce boom drives demand"
      }
    }
  },
  "e01e5c9d-149f-4220-b5cc-8ca335eacfd3": {
    "career": "Marketing Manager",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Tech multinationals’ EMEA HQs need marketing managers"
      },
      "japan": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Vision 2030",
        "reason": "Tourism & entertainment projects need senior marketing talent"
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Regional HQ hub creates steady demand for marketing leadership"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Creative-media leadership roles classed as priority under diversification"
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Large creative industry still demands experienced marketers"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Services-heavy economy still hires many marketing leaders"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      }
    }
  },
  "d8596cf5-5fcf-4154-b656-dd35d69ef298": {
    "career": "Academic Instructor",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Universities actively recruit international academics"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Education occupations eligible under points system"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Opportunity Card facilitates hiring foreign lecturers"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "",
        "reason": "Growing university sector welcomes qualified lecturers"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Highly Skilled Professional visa",
        "reason": "Universities seek English-speaking social science faculty"
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Small but steady demand at universities and polytechnics"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "New universities in KAEC and NEOM seek faculty"
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "",
        "reason": "Global campus hub; universities sponsor teaching passes"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "International branch campuses hire expat instructors"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Research-intensive universities rely on global talent"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "",
        "reason": "Largest higher-ed sector, universities sponsor lecturer visas"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      }
    }
  },
  "51f69e2f-9986-44a6-a2aa-996ed0a2a32d": {
    "career": "Management Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Services economy relies on advisory talent"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Consultants support digital transformation of SMEs"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Industry 4.0 projects hire external consultants"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Multinational HQs purchase strategy services"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Corporate restructuring drives advisory demand"
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "Mega-projects need strategic advisory support"
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Singapore Economy 2030",
        "reason": "Regional HQs seek consultants for ASEAN expansion"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "UAE Centennial 2071",
        "reason": "Diversification pushes demand for top-tier consultants"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City and tech sectors regularly engage consultants"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "",
        "reason": "High demand for strategic advisory across growth sectors"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      }
    }
  },
  "43b68f0f-8443-460a-9aa7-a974f26ba18c": {
    "career": "Software Developer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Software developers explicitly listed, visas fast-tracked"
      },
      "canada": {
        "tier": "Tier 1",
        "score": "95",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Software engineers on priority list, clear immigration pathway"
      },
      "germany": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Acute IT shortage; Blue Card streamlined for developers"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Digital economy growth, but immigration limited"
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Software engineering on Critical Skills list for permits"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "IT welcomed; language barrier significant"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Semiconductor software niche, wages lower"
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Software engineers on Green List but small market"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Growing tech hubs, yet Saudization uncertainties"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "National AI Strategy 2.0",
        "reason": "Digital jobs critical; Tech.Pass eases entry"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "UAE Centennial 2071",
        "reason": "Tech talent sought, but local hiring preference rises"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital specialists valued but salary threshold high"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "CHIPS and Science Act",
        "reason": "Needed for semiconductor R&D software, but visa caps restrict"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Need embedded software, remuneration modest"
      }
    }
  },
  "e149be07-2a9d-4d94-b6c1-014e57c48462": {
    "career": "European Studies Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Limited humanities openings; research funding tight"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "",
        "reason": "Academic researchers welcomed under Global Skills pathways"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Universities seek lecturers in EU integration and culture"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "18",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Small but steady demand at EU agencies in Dublin"
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "22",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "EU Centre at NUS offers limited research posts"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Niche demand in diplomacy schools, few roles"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "",
        "reason": "Russell Group universities recruit European historians"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Universities and think tanks hire humanities PhDs; H-1B competitive"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "18",
        "policy": "",
        "reason": ""
      }
    }
  },
  "1cc62e76-c981-472b-a6cb-993a0200ef23": {
    "career": "Strategy Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Demand exists, yet not on priority lists"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Consulting roles open but not shortage-listed"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Need for industrial transformation advice, but language barrier"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "RPJPN 2025-2045",
        "reason": "Capital relocation drives project consulting"
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "",
        "reason": "Growing tech HQs require advice but few slots"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Consulting firms hire foreigners; language proficiency essential"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "Industrial upgrades need advice, but salary lower"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Small market, few visas for consultants"
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Vision 2030",
        "reason": "Mega-projects need strategic advisors"
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Singapore Economy 2030",
        "reason": "Regional HQs and funds rely on consultants"
      },
      "uae": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "We the UAE 2031",
        "reason": "High demand across finance, tourism, sustainability"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City and tech clusters hire consultants"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "",
        "reason": "Largest consulting market; H-1B cap but steady demand"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b03a9c92-1db0-44d6-baa8-fdf431ed5d85": {
    "career": "International Business Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Business managers useful yet not CSOL-listed"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Management adjacent but not on priority lists"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Supportive to export firms, not shortage occupation"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Multinationals’ EMEA HQs require managers"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Inbound FDI reforms widen demand modestly"
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Needed in multinationals, not Green-List role"
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Vision 2030",
        "reason": "Megaprojects seek global strategy leaders"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Singapore Economy 2030",
        "reason": "Trade hub prizes international business leadership"
      },
      "uae": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "We the UAE 2031",
        "reason": "Regional HQ hub needs cross-border managers"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "City of London demands global operations talent"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "General and Operations Managers absolute-growth role"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "8ce3ddd5-c829-4699-acd9-13e085d514c2": {
    "career": "Social Work Student",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Regional areas need community workers"
      },
      "canada": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Chronic shortage in social services"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Aging population drives moderate demand"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Demand exists but not on critical list"
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Migrant Category",
        "reason": "Rural and Māori communities lack practitioners"
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Care economy large absolute-growth sector"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a330b618-c73a-4509-8b08-b2e914a62b74": {
    "career": "Electrical Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Chronic shortage across mining and renewables"
      },
      "canada": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Listed tech occupation with fast visa lane"
      },
      "germany": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Automotive & renewables need EEs"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "EV battery projects emerging but early stage"
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Med-tech and semiconductor plants expanding"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Demand exists but domestic grads plentiful"
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Semiconductor fabs scaling up"
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Infrastructure upgrades require engineers"
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Vision 2030",
        "reason": "Renewable megaprojects like NEOM hiring EEs"
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Manufacturing 2030",
        "reason": "Chip design, data-centre power systems"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing & grid projects"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Offshore wind and EV sectors need EEs"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "95",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Grid modernisation & chip fabs need EE talent"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "59",
        "policy": "",
        "reason": "EE helpful to semi strategy but not yet scarce"
      }
    }
  },
  "d8598b2c-51c4-419a-8508-9034c755ef8d": {
    "career": "IT Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Digital and cyber roles on CSOL need consultants"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Tech occupations fast-track under new IT stream"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Industry-4.0 projects lack IT advisors"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "RPJPN 2025-2045",
        "reason": "E-gov and fintech growth need consultants"
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Adjacency to software engineer shortage"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "IT specialists category includes consulting"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industry4.0 rollout needs advisory support"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "General ICT skills shortfall"
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Vision 2030",
        "reason": "Mega-projects require digital-transformation consulting"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "National AI Strategy 2.0",
        "reason": "Aggressive digital-transformation agenda"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Nationwide smart-government push needs IT consultants"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital sector growth fuels consulting demand"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Federal IT modernisation creates advisory demand"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Digitalisation of fabs needs external IT advisors"
      }
    }
  },
  "2fbb022b-95ab-4ae7-9943-ee492cad5e88": {
    "career": "Nanobiologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Research visas available but not priority list"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Welcomes advanced researchers broadly"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Biotech R&D talent shortage"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Early-stage biopharma capacity"
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Medtech and pharma R&D hub"
      },
      "japan": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Highly Skilled Professional visa",
        "reason": "Nanotech and biotech researchers favoured"
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Pharma and medical-device R&D incentives"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Limited nanoscale research ecosystem"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Vision 2030",
        "reason": "Emerging biotech focus still small"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Singapore Green Plan 2030",
        "reason": "Heavy investment in biomedical nanotech"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Operation 300bn",
        "reason": "Investing in genomic and nano-medicine research"
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences mega-cluster needs nanospecialists"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "95",
        "policy": "CHIPS and Science Act",
        "reason": "Major funding for biotech and nanotech R&D"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Biotech sector still nascent"
      }
    }
  },
  "0bfb0f31-93d9-4853-93ed-27cc55ec4e72": {
    "career": "Product Developer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Mechanical engineers moderately sought"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "General engineer demand"
      },
      "germany": {
        "tier": "Tier 1",
        "score": "95",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Automotive and machinery need mechanical developers"
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel-based EV manufacturing expansion"
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Mechanical engineers for medtech sector"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics and auto seek mechanical talent"
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Aerospace and EV product engineering priority"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Focus on civil not mechanical"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Manufacturing diversification just starting"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Manufacturing 2030",
        "reason": "Precision-engineering product developers needed"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing push but small base"
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Advanced manufacturing engineers on priority list"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "EV and clean-tech manufacturing boom"
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "National Master Plan 2021-2030",
        "reason": "Electronics and machinery export push"
      }
    }
  },
  "e2444687-98f8-4b47-aea6-4d522af150d9": {
    "career": "Journalism Instructor",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Migration Strategy 2023",
        "reason": "Universities list journalism lecturers on skills demand lists"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Strategy welcomes experienced lecturers for expanding programs"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Points awarded for doctorate-level teaching talent"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Lecturers qualify under tertiary-teaching occupation code"
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National AI Strategy 2.0",
        "reason": "Need instructors to teach AI-augmented news production"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Media hubs need faculty but no dedicated visa fast-track"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Strategy backs creative-industry education capacity"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "CHIPS and Science Act",
        "reason": "Science Act funds university hiring, incl. media-literacy faculty"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "942859d6-5105-497d-aac7-3920eceff6b2": {
    "career": "Chemistry Instructor",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Migration Strategy 2023",
        "reason": "STEM lecturer roles on university shortage lists"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities recruit foreign STEM lecturers aggressively"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Universities seek chemistry faculty for industrial clusters"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel battery goals need chemistry educators"
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Chemistry lecturers fall under higher-education lecturer category"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Visa fast-tracks PhD STEM educators"
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan funds chemical-industry training capacity"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Tertiary chemistry lecturers gain bonus points"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Growing petrochemical R&D universities need instructors"
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Manufacturing 2030",
        "reason": "Precision-chemistry sector drives demand for teaching talent"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing shift drives demand for STEM faculty"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "69",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-science push funds chemistry teaching posts"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds STEM faculty hiring in materials and chemical sciences"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National Master Plan 2021-2030",
        "reason": "Universities scaling chemistry programs to support semiconductors"
      }
    }
  },
  "24e0986b-7002-424e-b6d9-9d626219f987": {
    "career": "Auditor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Financial services sector seeks auditors but not priority"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Finance professionals receive moderate CRS boosts"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Accounting professionals eligible under new points system"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "SOE reforms require auditing talent"
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Big Four struggle to fill external audit roles"
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "MADANI Economy",
        "reason": "Islamic finance growth needs skilled auditors"
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Privatisation wave drives audit demand"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Singapore Economy 2030",
        "reason": "Global HQ hub depends on rigorous external audits"
      },
      "uae": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai and Abu Dhabi push to be global audit hubs"
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London lists senior accounting as shortage"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Large federal projects create compliance audit work"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "2aec51d1-0c44-41e7-95ba-4471a25a71a4": {
    "career": "Advocacy Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Social-science roles accepted but not priority"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Eligible only via general Express Entry stream"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Services role; no specific shortage listing"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Qualifies via Critical Skills points, not listed occupation"
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Can qualify under Skilled Migrant points, not green list"
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Green Plan 2030",
        "reason": "Policy communication roles in NGOs and sustainability"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Communication specialists aid sustainability and social initiatives"
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Third-sector advocacy roles exist, not on shortage list"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "NGO advocacy exists but not policy-listed shortage"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "122ae213-d52c-4ffc-8d4c-218bc6106499": {
    "career": "English Teacher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Regional schools need English teachers"
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "K-12 teachers on priority list, acute shortages"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Language teacher shortages in many states"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Growing demand in private international schools"
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Can enter via general work permit; not critical list"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "JET Programme recruits native English assistants annually"
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Green List (Tier 2)",
        "reason": "Primary teachers in critical shortage"
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "International schools hire foreign English teachers"
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Teacher demand exists but no special federal visa pathway"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Private English centres hire many foreigners"
      }
    }
  },
  "fd3ef739-f592-4e9c-b62e-5046203d9114": {
    "career": "Cinema Studies Lecturer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Migration Strategy 2023",
        "reason": "Creative-arts lecturers needed in growing film sector"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities competing for arts faculty"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Film-studies faculty counted as academic specialists"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Jakarta film schools hire foreign lecturers occasionally"
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Growing screen industry but limited academic openings"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Some roles at art universities; visa possible"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Government boosting creative education sector"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Smaller market but Weta driven film schools hire"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "NEOM’s media hubs need academic trainers"
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Economy 2030",
        "reason": "Arts universities expanding media programs"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Dubai film schools expanding faculty"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industries universities seek film scholars"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Research universities hire media scholars; H-1B viable"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "acb98af6-29cf-4612-96ed-311d53176aa1": {
    "career": "Design Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Mechanical engineers explicitly listed on CSOL"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Mechanical engineers on national shortage list"
      },
      "germany": {
        "tier": "Tier 1",
        "score": "95",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Nationwide shortage of mechanical and automotive engineers"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV battery plants need mechanical designers"
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Mechanical engineers on critical skills list"
      },
      "japan": {
        "tier": "Tier 1",
        "score": "87",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics and automotive sectors need designers"
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Aerospace and semiconductor equipment design shortages"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Some demand in manufacturing, not on Green List"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Industrial megaprojects require mechanical systems designers"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Manufacturing 2030",
        "reason": "Precision-engineering hub values mechanical design expertise"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing push seeks design engineers"
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "EV, aerospace and clean-energy design priority"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "EV and infrastructure manufacturing need mechanical design talent"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "National Master Plan 2021-2030",
        "reason": "Electronics manufacturing growing; demand emerging"
      }
    }
  },
  "109002a2-5c8d-47ab-a9ed-7dfeb1dd6c4e": {
    "career": "Global Healthcare Admin",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Role exists; not on priority lists"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Healthcare managers targeted for system efficiency"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Hospital admin demand, no specific shortage policy"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "New health insurance scheme needs administrators"
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Some demand in private hospitals"
      },
      "japan": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "MADANI Economy",
        "reason": "Growing medical tourism needs hospital managers"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Limited but steady hospital management needs"
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "93",
        "policy": "Vision 2030",
        "reason": "New medical cities require experienced healthcare administrators"
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Economy 2030",
        "reason": "Ageing population spurs health-system managers"
      },
      "uae": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "We the UAE 2031",
        "reason": "Medical tourism expansion demands admins"
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "NHS restructuring limits external admin hiring"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Hospitals hire admins but no immigration incentives"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Private hospital sector expanding slowly"
      }
    }
  },
  "427ef070-be0e-424c-a010-6dd0c0ba3024": {
    "career": "Forecaster",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Data analysts appear on occupation list"
      },
      "canada": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "AI and data specialists prioritised"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Industry needs statisticians for forecasting"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "RPJPN 2025-2045",
        "reason": "Infrastructure and agri projects need demand forecasts"
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Data scientists and statisticians in shortage"
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "Supply-chain forecasting for robotics firms"
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "MADANI Economy",
        "reason": "Industry 4.0 initiatives value predictive analytics"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Demand in energy and weather services only"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Logistics and energy need demand forecasters"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "National AI Strategy 2.0",
        "reason": "Finance and maritime sectors hire AI-driven forecasters"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "UAE Centennial 2071",
        "reason": "Finance and ports use forecasting talent"
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Finance and advanced manufacturing rely on AI forecasting"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "CHIPS and Science Act",
        "reason": "AI research funding covers data forecasting roles"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Electronics supply chain forecasting emerging"
      }
    }
  },
  "4980ec5d-8151-4f09-91d2-52f32d4dc56b": {
    "career": "Sustainability Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Net-zero transition and green building boom."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "",
        "reason": "Sustainability valued but not priority occupation."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "EU ESG rules drive consultancy needs."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Renewable projects need some advisors."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Green finance niche, limited openings."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Corporate interest growing but domestic hires preferred."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "Industrial decarbonization emerging."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Small market, some green projects."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Mega-projects mandate rigorous sustainability frameworks."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Green Plan 2030",
        "reason": "City-state aims to be sustainability hub."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Net-zero 2050 pushes sustainability advisory."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Offshore wind and ESG reporting talent gaps."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Corporate decarbonization credits fuel consultant demand."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "28705507-428e-4e77-980a-3658e79b1a9a": {
    "career": "Chemist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Mining and materials labs demand chemists."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Pharma and mining labs seek chemists."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Chemical industry shortage of specialists."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV battery materials research."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Major pharma-biotech cluster needs chemists."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "63",
        "policy": "Highly Skilled Professional visa",
        "reason": "Semiconductor materials and pharma."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Specialty chemicals prioritized."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Limited but steady agri-chem demand."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Growing domestic pharma needs chemists."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Singapore Economy 2030",
        "reason": "Biomed & advanced materials R&D hub."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Operation 300bn",
        "reason": "Building life-science manufacturing base."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences and clean energy materials R&D."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Advanced battery and pharma R&D subsidies."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National Master Plan 2021-2030",
        "reason": "Semiconductor chemistry developing."
      }
    }
  },
  "64a9feff-382e-4838-adf8-162ebb410dbf": {
    "career": "Research Fellow",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Universities recruiting CS researchers."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Canada courts AI academics."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "AI research centres expanding."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "AI university labs expanding."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "AI research roles in industry-university labs."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics & AI priority."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "National AI centres growing."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Limited university positions."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "KAUST and NEOM digital labs hiring."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "National AI Strategy 2.0",
        "reason": "A*STAR and universities aggressively recruit."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "UAE Centennial 2071",
        "reason": "Big spend on AI institutes."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Government funds semiconductor & AI R&D."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "95",
        "policy": "CHIPS and Science Act",
        "reason": "Massive AI and quantum research funding."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Emerging AI research ecosystem."
      }
    }
  },
  "04c5eb62-6359-4370-8e9e-82fa744a89f7": {
    "career": "Physicist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "SKA radio-telescope hub needs astronomers"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Canada Research Chairs recruit astrophysics PhDs"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Max Planck institutes hire foreign physicists"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Small but welcoming astrophysics groups"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "JAXA labs hire foreign astrophysicists"
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Limited posts but universities open to researchers"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Vision 2030",
        "reason": "Nascent Space Commission funding research labs"
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National AI Strategy 2.0",
        "reason": "Data-heavy astronomy overlaps with AI research"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "We the UAE 2031",
        "reason": "Mohammed bin Rashid Space Centre recruits scientists"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "UKRI finances astronomy centres and telescopes"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "NSF and NASA pouring funds into astrophysics"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "0e81803d-c7c0-4b90-b2a2-2a92c78a0294": {
    "career": "Business Development Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Services sector growth but not on CSOL"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "General operations managers in growth list"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Positions exist, not immigration priority"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel/EV firms chasing foreign clients"
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Tech HQs need BD, not on critical list"
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "MADANI Economy",
        "reason": "Industrial strategy needs market expansion roles"
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Vision 2030",
        "reason": "Mega-projects need partnership-hunters urgently"
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Economy 2030",
        "reason": "Financial & tech hubs aggressively hire BD leads"
      },
      "uae": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Operation 300bn",
        "reason": "Diversification drive fuels demand for biz-dev talent"
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "",
        "reason": "City firms hire but no priority visa"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "",
        "reason": "Services economy values deal-makers, no specific visa boost"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Growing tech exports require BD but not priority"
      }
    }
  },
  "e054019a-1441-4564-9c56-004c270c12fe": {
    "career": "Translator",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Bilingual government services need certified translators"
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Highly Skilled Professional visa",
        "reason": "Export-oriented firms need English localisation"
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Tourism push needs multilingual content"
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Singapore Economy 2030",
        "reason": "Regional HQs localise Asian markets content"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Multicultural hub requires legal & media translators"
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Publishing and courts seek Asian-language specialists"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Large demand for Asian-language media localisation"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a0a4489c-c8da-4f98-bd7d-d9db9011eca9": {
    "career": "MRes Pharmacology Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Biomedical roles moderately valued"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Health-science researchers targeted category"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Life-science adjacent to shortage list"
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Biopharma research focus"
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma scientists listed; big manufacturing hub"
      },
      "japan": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Highly Skilled Professional visa",
        "reason": "Biotech researchers score maximum points"
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Pharma R&D in priority sectors"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Research welcomed, not shortage"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Early-stage pharma R&D push"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Singapore Economy 2030",
        "reason": "Biomedical hub seeks researchers"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "We the UAE 2031",
        "reason": "Biotech research clusters growing"
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences R&D explicit priority"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "95",
        "policy": "CHIPS and Science Act",
        "reason": "Biotech R&D funding surge; NIH-NSF grants align"
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "National Master Plan 2021-2030",
        "reason": "Biotech researchers encouraged"
      }
    }
  },
  "d0275986-ac00-4aba-8b14-f4b73ff85051": {
    "career": "Clinical Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Migration Strategy 2023",
        "reason": "Mental-health need yet outside core list"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Allied health shortages include psychologists"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Growing demand, not listed"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Allied health demand, moderate"
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Clinical psychologists on allied health list"
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Vision 2030",
        "reason": "Expanding mental-health services"
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Mental-health push, no dedicated visa"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "We the UAE 2031",
        "reason": "Rapid clinic growth, expat hiring"
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "NHS gaps though not on shortage list"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "High demand but no dedicated visa preference"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "1be85b0e-a1a7-4548-89f1-96b8cabda000": {
    "career": "MFA Photographer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Arts roles welcome yet not prioritized"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Creative visas exist but limited quotas"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Artist visa option, competitive"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Growing entertainment and events scene needs photographers"
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Niche creative visas, limited slots"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "UAE Centennial 2071",
        "reason": "Creative media production prioritized in Dubai"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry seniors on priority list"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Large market but no immigration priority"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "002ac061-e4a0-43d4-abfc-f23ac4f80573": {
    "career": "Software Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Migration Strategy 2023",
        "reason": "Seeks senior software specialists"
      },
      "canada": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Software & AI on fast-track list"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Shortage of advanced IT researchers"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Growing but early-stage tech scene"
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Multinational R&D centres hiring"
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "Incentives for AI/robotics research"
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Semiconductor & software R&D push"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Small but growing deep-tech scene"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "AI R&D hubs emerging in NEOM"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "National AI Strategy 2.0",
        "reason": "Aggressive hiring of AI researchers"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "UAE Centennial 2071",
        "reason": "AI research a national priority"
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "87",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Targeted visas for AI researchers"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "94",
        "policy": "CHIPS and Science Act",
        "reason": "Funds frontier AI & software R&D labs"
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Needs AI & chip software talent"
      }
    }
  },
  "0867b904-a302-4a8d-9675-0120505310e1": {
    "career": "Environmental Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Demand in mining remediation"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Climate adaptation expertise valued"
      },
      "germany": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Renewable push needs env scientists"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "RPJPN 2025-2045",
        "reason": "Forestry & mining impact studies"
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Growing but small green sector"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Decarbonization research demand"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "MADANI Economy",
        "reason": "Environmental compliance ramping up"
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Ecosystem management shortage"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Sustainability teams for mega-projects"
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Singapore Green Plan 2030",
        "reason": "Carbon services hub growth"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Needs carbon management skills"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean energy & ESG reporting"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Massive funding for climate research"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Offshore wind EIA needs"
      }
    }
  },
  "c6687542-5243-42b5-a2a1-54b8572d0361": {
    "career": "General Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Needed across sectors but not listed"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Demand in services economy"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Industry seeks ops leaders"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "New capital city projects"
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Multinationals need site GMs"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Corporate demand but high local competition"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Manufacturing plants need ops GMs"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "SME-heavy market needs managers"
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Mega-projects need hospitality & ops GMs"
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Regional HQs hire experienced GMs"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "UAE Centennial 2071",
        "reason": "Tourism, logistics demand senior managers"
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "General managers still vital in City firms"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Operations managers in WEF growth list"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Export factories scaling up management"
      }
    }
  },
  "33503e68-76a9-4ad8-bd9e-59be45549aae": {
    "career": "Instructor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "STEM focus; humanities adjacent demand"
      },
      "canada": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Express Entry Category-Based Selection",
        "reason": "K-12 teachers explicitly listed shortage"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Need STEM teachers; humanities indirect openings"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Green List (Tier 2)",
        "reason": "Secondary teachers on shortage list"
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Teachers removed from 2025 shortage list"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Teacher shortages but no immigration priority"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "6d512eea-c1d0-40d9-ae47-d3f4fd755935": {
    "career": "Software Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Software developers on core list"
      },
      "canada": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Express Entry Category-Based Selection",
        "reason": "IT occupations fast-track PR"
      },
      "germany": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialists shortage pathway"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech and e-commerce expansion"
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Software engineers critical skill"
      },
      "japan": {
        "tier": "Tier 2",
        "score": "67",
        "policy": "Highly Skilled Professional visa",
        "reason": "Point-based fast track for AI/software"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "NIMP 2030",
        "reason": "Industry 4.0 pushes software demand"
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 1)",
        "reason": "Software engineers green-listed"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Fintech and AI hubs growing"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "National AI Strategy 2.0",
        "reason": "Tech Pass routes for top engineers"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "We the UAE 2031",
        "reason": "Digital talent visa incentives"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital specialists prioritised"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "95",
        "policy": "CHIPS and Science Act",
        "reason": "Huge demand for AI and semiconductor software"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Chip software tools needed"
      }
    }
  },
  "1e9fe8a4-2a05-479c-8cee-836c2b8976fa": {
    "career": "IT Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Digital transformation priority"
      },
      "canada": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Senior IT roles fast-tracked"
      },
      "germany": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialists urgently needed"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "RPJPN 2025-2045",
        "reason": "Digitalisation across ministries"
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "77",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Senior ICT roles eligible"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Points system values management experience"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "MADANI Economy",
        "reason": "Industry 4.0 needs IT leadership"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Green List covers engineers more than managers"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "Digital government projects expanding"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "Singapore Economy 2030",
        "reason": "Tech-heavy economy values experienced managers"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "UAE Centennial 2071",
        "reason": "Smart-city and fintech push"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital transformation high on agenda"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Digital infrastructure modernisation needs leadership"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "d9348880-7f63-490b-a2fe-442dfab1107a": {
    "career": "Instructional Coordinator",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "STEM-curriculum reform needs coordinators"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Curriculum experts strengthen teacher shortage response"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Adjacency to teacher shortages but not listed"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Skilled Migrant Category",
        "reason": "Diverse classrooms require modern curricula"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Education quality focus; locals preferred"
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "EdTech startups value curriculum designers"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Private schools hiring for curriculum upgrades"
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Education support role; domestic supply adequate"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "aa2d3217-de0d-41a4-88a6-905f8e581634": {
    "career": "Mechanical-Aerospace Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Mechanical engineers on shortage list"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Growing Quebec aerospace cluster"
      },
      "germany": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe demand for mechanical & auto engineers"
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "69",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV and aircraft manufacturing push"
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Mechanical engineers in med-tech and pharma plants"
      },
      "japan": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics and aerospace engineers welcomed"
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Aerospace a named growth sector"
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Mechanical engineers explicitly listed"
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Vision 2030",
        "reason": "Aerospace and defence megaprojects"
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Manufacturing 2030",
        "reason": "Precision engineering & aerospace MRO demand"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing expansion"
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Aerospace & EV engineering priority"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "95",
        "policy": "CHIPS and Science Act",
        "reason": "Advanced manufacturing and space priorities"
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "National Master Plan 2021-2030",
        "reason": "Aircraft and electronics manufacturing growth"
      }
    }
  },
  "95ae3493-253e-45e7-9f4c-0eaa37ee26fc": {
    "career": "Cultural Analyst",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Research economy adjacent need"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "RPJPN 2025-2045",
        "reason": "Nation-building and creative economy"
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "26",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Cultural branding for tourism"
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Tourism megaprojects need cultural insight"
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Media and tourism sectors need insights"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "We the UAE 2031",
        "reason": "Heritage tourism and media demand"
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries value senior analysts"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Creative strategy roles exist but not visa-prioritized"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "24",
        "policy": "",
        "reason": ""
      }
    }
  },
  "31a1c06e-2417-452a-9eab-7aff8925d29c": {
    "career": "MA Physicist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Limited but growing telescope projects in WA"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Research talent stream welcomes advanced scientists"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Blue-card path for researchers, not explicit shortage"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP fast-tracks fundamental science talent"
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Vision 2030",
        "reason": "Investing heavily in space science programs"
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "National AI Strategy 2.0",
        "reason": "General research funding, not specific shortage"
      },
      "uae": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "We the UAE 2031",
        "reason": "Mohammed bin Rashid Space Centre hiring astrophysicists"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Space science listed under IS-8 R&D"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "94",
        "policy": "CHIPS and Science Act",
        "reason": "NASA, DOE grants boost astrophysics data research"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "582ac50a-9815-4973-95c5-de946293f807": {
    "career": "Accountant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Accountants removed from core skills list in 2024"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Occupation common but not on targeted shortage list"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "No shortage; German language barrier for foreign CAs"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Financial services hub in Dublin"
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Islamic finance growth needs some CPAs"
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Growing private sector needs IFRS talent"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Economy 2030",
        "reason": "Regional HQs require IFRS and tax specialists"
      },
      "uae": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai IFC seeks qualified accountants"
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London demands ACCA/ACA professionals"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Services economy needs CPAs but not policy priority"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "37c8b909-5c5d-42e4-b9e6-9b2814670582": {
    "career": "Civil Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "95",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Listed shortage; fast visa pathway"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Infrastructure and housing push needs engineers"
      },
      "germany": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Urgent need for civil/structural engineers"
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital Nusantara requires huge civil workforce"
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Housing and data-centre builds"
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Aging workforce in construction sector"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "NIMP 2030",
        "reason": "Industrial park and EV plant projects"
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Direct residence pathway for civil engineers"
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Vision 2030",
        "reason": "Mega-projects NEOM and Red Sea demand civil talent"
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Green Plan 2030",
        "reason": "Underground and green-building projects"
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Operation 300bn",
        "reason": "Massive real-estate and infrastructure expansion"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "",
        "reason": "HS2 and offshore wind need specialists, but visa caps"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Funding surge but domestic supply sufficient"
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "National Master Plan 2021-2030",
        "reason": "Transport and energy infra boom"
      }
    }
  },
  "5a1f3682-d108-42c4-8c45-0cc543c01d85": {
    "career": "QA Officer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Small biopharma sector limits dedicated visas"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Pharma QA helpful but not on priority list"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Shortage of chemical-process quality specialists"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Large pharma cluster urgently needs quality officers"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Pharma QA valued but not on HSP list"
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan highlights pharma manufacturing growth"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Limited scale of pharma production"
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Manufacturing 2030",
        "reason": "Biopharma hub emphasises strict GMP quality roles"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Operation 300bn",
        "reason": "Nascent pharma manufacturing cluster needs QA"
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences QA roles exist but not shortage"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Biomanufacturing expansion needs GMP compliance experts"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Early-stage pharma sector, some demand"
      }
    }
  },
  "65df5a94-c083-4376-afec-902ca0b9f85c": {
    "career": "Systems Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Limited high-tech manufacturing footprint"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Automation specialists welcome in manufacturing hubs"
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Industry 4.0 drives demand for systems engineers"
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV battery and nickel projects require systems design"
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Medtech and pharma plants need automation expertise"
      },
      "japan": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Highly Skilled Professional visa",
        "reason": "Semiconductor and robotics giants hire systems engineers"
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Semiconductor fabs expanding rapidly"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Niche opportunities in small plants"
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Megaprojects and renewables need complex systems"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Manufacturing 2030",
        "reason": "Precision-engineering hub hiring for smart-factory builds"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Operation 300bn",
        "reason": "Growing advanced manufacturing base"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "EV and aerospace sectors prioritise systems skills"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "95",
        "policy": "CHIPS and Science Act",
        "reason": "Advanced fab and EV plants need systems integration"
      },
      "vietnam": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Electronics mega-plants need systems integration"
      }
    }
  },
  "a9a71aa7-a14e-4cd2-8818-b01cda481a22": {
    "career": "Microbiologist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Agri-bio and medical research hubs growing"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Life-science researchers welcomed under talent stream"
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Biotech and pharma clusters need researchers"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Limited research infrastructure"
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Med-tech and pharma research parks hiring"
      },
      "japan": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Highly Skilled Professional visa",
        "reason": "Biotech research priority for HSP"
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "MADANI Economy",
        "reason": "Biopharma manufacturing scaling up"
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Migrant Category",
        "reason": "Food safety and agri-bio research demand"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Emerging biotech initiatives"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Singapore Economy 2030",
        "reason": "Government backs biomedical sciences strongly"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Developing biotech and genomic medicine hubs"
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences R&D is a named pillar"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "95",
        "policy": "CHIPS and Science Act",
        "reason": "Massive biotech R&D funding needs microbiologists"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Biotech sector small but growing"
      }
    }
  },
  "6e6df09c-723a-4652-b816-8d460639d0d3": {
    "career": "Secondary Education Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Secondary STEM teachers on CSOL"
      },
      "canada": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Express Entry Category-Based Selection",
        "reason": "K-12 teachers explicitly prioritised"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Shortage of STEM school teachers"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Education roles not on critical list"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Teaching not covered by SSW/HSP lists"
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Secondary teachers on Green List"
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "No longer on shortage list after 2025"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Teacher shortages but no dedicated visa track"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "5ef596e5-92e5-485a-b38d-acfe975c77be": {
    "career": "Modern Languages Teacher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Some secondary language shortages"
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Bilingual French-English education priority"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Focus on STEM teacher shortages"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Not on Critical Skills list"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "JET hires but not skilled-visa priority"
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Secondary teachers, incl. languages, on list"
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Removed from shortage list July 2025"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Language teachers in demand but no visa priority"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "853e2bf2-3937-44f5-8c9f-be310b8db95d": {
    "career": "Biomedical Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Health and med-tech skills sought"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Life-science researchers prioritised under STEM"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Seeks medical lab scientists"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Biopharma in vision 2045 but talent demand nascent"
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Biomed scientists on critical list"
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "Biotech researchers eligible for fast-track"
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Biomed & med-device focus sector"
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Migrant Category",
        "reason": "Recognises medical laboratory scientists"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Growing biotech but still emerging"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Singapore Economy 2030",
        "reason": "Biomed one of five growth pillars"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "We the UAE 2031",
        "reason": "Investing in biotech hubs"
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences one of IS-8 pillars"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Boosts biotech & life-science R&D funding"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Early-stage biotech push"
      }
    }
  },
  "cd786040-0083-4771-ba0c-891e56378189": {
    "career": "Nurse Educator",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Nurse educators on CSOL to upskill workforce"
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Category targets health occupations incl. nurse instructors"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Acute nursing gap; educators facilitate training"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Nursing academics qualify under health skills"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Ageing population; educator roles possible but niche"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Private hospitals import some nursing faculty"
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Green List fast-tracks nurse lecturers"
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Hospital expansion needs clinical teaching staff"
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Healthcare training institutes recruit experienced RNs"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "We the UAE 2031",
        "reason": "Medical-education hubs recruiting foreign faculty"
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Educator demand exists, but not on shortage list"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Nursing shortage, but educator roles not immigration-listed"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "42f16390-e4ec-4629-a0b1-c4dcd48aa786": {
    "career": "Chief Executive Officer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Business talent visas exist but limited quotas"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Express Entry accepts but no special stream"
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Principal Hub scheme eases visas for regional HQ CEOs"
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Megaprojects recruit foreign C-suite leadership"
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Economy 2030",
        "reason": "COMPASS visa favors experienced corporate leaders"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "UAE Centennial 2071",
        "reason": "Free-zone HQs grant Golden Visas to CEOs"
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Global Business Mobility route covers executive transfers"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "General managers show growth but not immigration priority"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a4d1427d-d5a3-4a54-a0be-5843b099206a": {
    "career": "Civil & Environmental Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "95",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Top-priority on CSOL for mega-projects"
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Civil engineers named shortage occupation"
      },
      "germany": {
        "tier": "Tier 1",
        "score": "89",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Renewables and rail upgrades need civil experts"
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital city needs civil/environment engineers"
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Housing and data-centre builds need civil expertise"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Quake-resistant retrofits create steady demand"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "",
        "reason": "Nusantara spill-over and flood control projects"
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Fast-track residency for infrastructure engineers"
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Vision 2030",
        "reason": "NEOM and giga-projects hire thousands of civil engineers"
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Underground MRT extensions require specialists"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Operation 300bn",
        "reason": "Smart-city and transport projects continue"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean energy and HS2 boost demand"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "$1.2T rebuild needs civil talent"
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "79",
        "policy": "National Master Plan 2021-2030",
        "reason": "Transport corridors and offshore wind ports"
      }
    }
  },
  "90a722be-12c0-4a38-b050-ec89bc846724": {
    "career": "Law Lecturer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Universities recruit overseas lecturers for LLB and JD programmes"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Lecturers eligible but not on priority lists"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Points scheme accepts researchers/lecturers"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "New capital spurs higher-ed hiring"
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Universities hire but not on Critical Skills list"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP category covers university faculty"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "MADANI Economy",
        "reason": "English-medium law schools importing lecturers"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Migrant Category",
        "reason": "Tertiary teaching recognised but not shortage"
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Vision 2030",
        "reason": "Expanding universities seek foreign law academics"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Economy 2030",
        "reason": "Research universities grow law & fintech programmes"
      },
      "uae": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "We the UAE 2031",
        "reason": "Knowledge-economy push drives demand for lecturers"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "",
        "reason": "Global Talent & university sponsorship for law scholars"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "",
        "reason": "Universities hire foreign law faculty via cap-exempt H-1B"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "National Master Plan 2021-2030",
        "reason": "Private universities recruiting overseas faculty"
      }
    }
  },
  "d080a24e-0cc2-4dcd-836a-5204d71964c4": {
    "career": "Sales Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Services sector growth keeps demand for sales managers"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "",
        "reason": "Express Entry favours management experience though not priority"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Industrial exporters value B2B sales leadership"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Consumer boom drives demand but localisation rules apply"
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Tech multinationals’ EMEA HQs need sales leadership"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Cultural barriers limit foreign managers but niche openings exist"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "ASEAN sales hubs growing under NIMP 2030"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Small market but open to experienced managers"
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Vision 2030",
        "reason": "Mega-projects need aggressive sales talent in tourism & real estate"
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Singapore Economy 2030",
        "reason": "Regional HQs need APAC sales leaders"
      },
      "uae": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "We the UAE 2031",
        "reason": "Regional trade hub hungry for multilingual sales leaders"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Financial & tech sectors compete for top sales managers"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Large services economy needs experienced revenue leaders"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Export-oriented firms add sales managers cautiously"
      }
    }
  },
  "2979c114-2f40-45dd-8e49-6da963d59b0a": {
    "career": "Product Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Growing SaaS sector needs PM skillset"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Digital roles favoured under tech category"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Auto & AI firms hire tech PMs"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "RPJPN 2025-2045",
        "reason": "E-commerce giants hire but prefer local staff"
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "US tech EMEA HQs in Dublin require PMs"
      },
      "japan": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics & AI firms value global PMs"
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "NIMP 2030",
        "reason": "Semiconductor & EV supply chain digitisation needs PMs"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Small but active tech startups"
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Vision 2030",
        "reason": "NEOM and fintech projects seek product talent"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "National AI Strategy 2.0",
        "reason": "Regional HQs need PMs for AI, fintech, SaaS"
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "UAE Centennial 2071",
        "reason": "Fintech and AI hubs recruit experienced PMs"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Scale-ups and banks need digital product leadership"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "94",
        "policy": "CHIPS and Science Act",
        "reason": "Tech firms need PMs for AI and semiconductor products"
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Fast-growing tech platforms attract PM talent"
      }
    }
  },
  "1bed5555-e23c-4627-9423-b4116739a9db": {
    "career": "Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Consulting not on Core Skills list"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Business services outside priority immigration lists"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "47",
        "policy": "",
        "reason": "No explicit shortage but welcome under Blue Card"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "",
        "reason": "Strategic advisers needed but not prioritized"
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Professional services expansion supports consultants"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP welcomes management specialists"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Consultants only indirectly support NIMP projects"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Green List excludes generic consulting roles"
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Megaprojects demand strategic advisory talent"
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "National AI Strategy 2.0",
        "reason": "AI transformation drives demand for consultants"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Professional-services hub growing in DIFC"
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Strategy lists senior consulting as priority"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Advisers help implement IRA corporate transitions"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Advisory roles peripheral to semiconductor push"
      }
    }
  },
  "d040907c-ef65-4246-8a90-84894a44d4dc": {
    "career": "Creative Director",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Not on Migration Strategy lists"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Role outside Express Entry priorities"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Creative roles not priority occupations"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Creative economy growing but not prioritized"
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Dublin tech marketing hubs value senior creatives"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "",
        "reason": "Need exists but visa priority elsewhere"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Creative economy not in NIMP focus"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Green List excludes creative leadership"
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Vision 2030",
        "reason": "Entertainment megaprojects need world-class creative direction"
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Singapore Economy 2030",
        "reason": "Digital media cluster hires creative leaders"
      },
      "uae": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "UAE Centennial 2071",
        "reason": "Media free-zones aggressively hire creative directors"
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "95",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries designated growth sector"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "",
        "reason": "Large advertising and tech sectors seek senior creatives"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Industrial strategy centers on engineering, not design"
      }
    }
  },
  "f121d539-e747-4a2a-879f-4420ec5b72e1": {
    "career": "Teacher",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Secondary STEM and early-childhood urgently needed"
      },
      "canada": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Teachers on targeted shortage lists"
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe shortage of STEM teachers"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Need exists but not on critical list"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "EFL teachers common but low visa priority"
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Teachers explicitly on Green List"
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Private schools hire expatriate teachers"
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Chronic shortages but no special immigration push"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "9e8f44d0-c1da-4e15-8629-67ea89a81588": {
    "career": "Comparative Biomed Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Biomedical research listed under medical scientists"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Strategy targets health and life-sciences researchers"
      },
      "germany": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Biotech scientists prioritized for visa fast-track"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Life-science research nascent; adjacent to biopharma goals"
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Biopharma cluster needs scientists"
      },
      "japan": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP favours biotech researchers"
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan backs pharmaceutical R&D expansion"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Science roles valued but not shortage listed"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Emerging biotech hubs within NEOM health projects"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "91",
        "policy": "Singapore Economy 2030",
        "reason": "Biomedical sciences anchor manufacturing strategy"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "Plans include biotech innovation clusters"
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences R&D core pillar"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "93",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds biotech R&D and preclinical labs"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Biotech emerging, still small demand"
      }
    }
  },
  "db6e1a7d-f03f-4e09-9197-67c2ad6efaea": {
    "career": "Program Coordinator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Community program managers sometimes needed in rural"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Express Entry Category-Based Selection",
        "reason": "French-speaking service managers favored"
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "NGO and tech-event coordination demand"
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Non-profit program roles in social services"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "47",
        "policy": "Vision 2030",
        "reason": "Tourism and social programs need coordinators"
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "",
        "reason": "Services economy uses coordinators"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "We the UAE 2031",
        "reason": "Government initiatives hire program coordinators"
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Service-sector management adjacent"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "General and operations managers growth category"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "244bb3cd-b063-40bd-8d11-e51d1df18c4e": {
    "career": "Economist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "Migration Strategy 2023",
        "reason": "Transition to renewables needs economic analysis"
      },
      "canada": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Green economy modeling skills prioritized"
      },
      "germany": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Renewable transition demands environmental economic expertise"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "RPJPN 2025-2045",
        "reason": "Resource-rich economy mapping externalities"
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Sustainable finance cluster hires economists"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Green growth strategy requires some environmental economists"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "MADANI Economy",
        "reason": "Green growth pillars include environmental valuation"
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Migrant Category",
        "reason": "Climate adaptation economics valued"
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Diversification projects require environmental cost-benefit studies"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Singapore Green Plan 2030",
        "reason": "Carbon pricing policy needs economic expertise"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Sustainability finance metrics need economists"
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean energy policy requires economic modeling"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Need economists to analyze decarbonization incentives"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National Master Plan 2021-2030",
        "reason": "Infrastructure planning needs environmental cost analysis"
      }
    }
  },
  "4f35aaf0-a3b7-4a79-b36d-bc9a3f618a38": {
    "career": "Geographer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Environmental scientists/geospatial analysts adjacent to list"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Express Entry Category-Based Selection",
        "reason": "NOC lists geoscientists—fast-track immigration"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Geodata specialists classified under IT demand"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "GIS analysts sometimes qualify as software specialists"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-city spatial-data engineers welcomed"
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Migrant Category",
        "reason": "Environmental planning relies on GIS abilities"
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "National AI Strategy 2.0",
        "reason": "Urban-planning geospatial experts needed"
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Geospatial inputs for clean-energy siting"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Supports GIS mapping for infrastructure planning"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "997f85d9-5637-489c-86f5-cd7c6bf3cc52": {
    "career": "Global Business Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Growing Asia-Pacific trade needs managers"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Plenty of roles but not shortage-listed"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Export industries seek managers, no fast-track"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Trade liberalisation fuels management demand"
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "",
        "reason": "Multinational tech hubs seek operations managers"
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Industrial expansion needs global operators"
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Mega-projects require international business leadership"
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Economy 2030",
        "reason": "Asia HQs recruit seasoned global managers"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "We the UAE 2031",
        "reason": "Regional HQ hub needs cross-border managers"
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City financial services favour global managers"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Service economy demands experienced general managers"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "3fb39819-b75f-4edf-8f87-0d48031ebde9": {
    "career": "Power Systems Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Renewables and mining electrification drive demand"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Electrical engineers on shortage list"
      },
      "germany": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Energiewende requires grid integration experts"
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "67",
        "policy": "RPJPN 2025-2045",
        "reason": "Geothermal and transmission expansion"
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Electrical engineers classed as critical skills"
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-grid and renewable integration priorities"
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "EV and renewable manufacturing growth"
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Clean-energy projects need electrical specialists"
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Vision 2030",
        "reason": "NEOM renewable megaprojects expanding grid"
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "71",
        "policy": "Singapore Green Plan 2030",
        "reason": "Grid resilience for data centres and renewables"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Operation 300bn",
        "reason": "Energy transition calls for grid experts"
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Offshore wind, nuclear and hydrogen expansion"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "95",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Grid modernisation and renewables boom need power engineers"
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "National Master Plan 2021-2030",
        "reason": "LNG-to-power and offshore wind grids"
      }
    }
  },
  "c353b497-7950-47a4-9b9c-f6993b583c3d": {
    "career": "Historian",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Migration Strategy 2023",
        "reason": "Academic researchers eligible but not on core shortage list"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities use strategy to hire humanities faculty"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Research institutes actively recruit foreign historians"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "18",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Some demand for research lecturers"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Highly Skilled Professional visa",
        "reason": "Universities sponsor foreign humanities PhDs"
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Historians qualify under academic skill codes"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Heritage-tourism megaprojects need cultural historians"
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Singapore Economy 2030",
        "reason": "National Archives and universities seek history scholars"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "We the UAE 2031",
        "reason": "Museums like Louvre Abu Dhabi hire heritage experts"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries export heritage content globally"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "CHIPS and Science Act",
        "reason": "NSF funds humanities research and museum digitization"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4ae2e4ac-32b7-4a21-9a5c-0f6900e0b0c9": {
    "career": "Applied Economist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Government agencies recruit economic modellers"
      },
      "canada": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "NOC includes economists for policy research"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Economic institutes and ministries hire analysts"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Development agencies require economists"
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma and finance clusters need economic analysts"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Highly Skilled Professional visa",
        "reason": "Policy institutes welcome foreign economists"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Islamic finance growth needs economic expertise"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Limited but steady demand in Treasury and banks"
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Vision 2030",
        "reason": "Diversification plans rely on economic modelling"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Singapore Economy 2030",
        "reason": "Trade-oriented economy hires economists for policy and finance"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "UAE Centennial 2071",
        "reason": "Free-zone authorities hire policy economists"
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Financial services and think tanks need economists"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Need economists to model climate-policy impacts and incentives"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "National Master Plan 2021-2030",
        "reason": "Planning ministries employ applied economists"
      }
    }
  },
  "7886f199-02df-41de-b2bc-263f1d04a59d": {
    "career": "MBA Graduate can pursue roles such as Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Construction and business managers in demand"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Experienced managers score highly in CRS system"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "67",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Mittelstand firms seek international management talent"
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Capital relocation and infra require managers"
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Multinationals need middle managers but not shortage"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Score-based visa rewards MBA qualification"
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industrial expansion demands capable managers"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Managers valued but not in critical shortage"
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Vision 2030",
        "reason": "Megaprojects like NEOM need seasoned managers"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Singapore Economy 2030",
        "reason": "Headquarters functions need globally trained managers"
      },
      "uae": {
        "tier": "Tier 1",
        "score": "91",
        "policy": "We the UAE 2031",
        "reason": "Diversified economy recruits global business leaders"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Advanced sectors require project and operations managers"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Large federal projects require operations managers"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National Master Plan 2021-2030",
        "reason": "FDI factories need operations leadership"
      }
    }
  },
  "9e8dc53a-6126-4a33-8516-532fcd7814ea": {
    "career": "Administrative Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Demand in corporate services but not on CSOL"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Large services sector, admin gaps outside shortages"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Support roles for Mittelstand global firms"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "New capital project spurs admin hiring"
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Multinationals in Dublin need back-office management"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Ageing workforce opens mid-management slots"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "NIMP firms need process-oriented managers"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Small but growing corporate sector needs ops"
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Mega-projects need senior administration leaders"
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Economy 2030",
        "reason": "Headquarters hub constantly recruits operations leads"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "We the UAE 2031",
        "reason": "Logistics and tourism firms hire experienced ops heads"
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Services economy still hungry for ops talent"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Services growth needs operations managers"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Rapidly scaling tech factories add admin layers"
      }
    }
  },
  "ad989a5f-547a-4341-b81f-ea5f4078fca6": {
    "career": "Marketing Strategist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Creative sector growing yet unlisted in CSOL"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Demand exists but not immigration priority"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "International brands seek strategists, not priority"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "E-commerce boom creating marketing demand"
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Tech multinationals need regional marketing brains"
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Brands expanding across ASEAN need strategists"
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Tourism and sports projects need global-level marketing"
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Economy 2030",
        "reason": "Regional HQs base marketing strategy teams here"
      },
      "uae": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "We the UAE 2031",
        "reason": "Dubai positions itself as global creative hub"
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry senior roles on priority list"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Huge ad industry still needs strategy brains"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "de67c65e-6eb0-4a1c-9f0a-0486a9c45419": {
    "career": "Financial Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Banks recruit, but role absent from CSOL"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Financial services hires, yet not in shortage list"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Frankfurt finance cluster needs advisers"
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech growth and rising middle class wealth"
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "IFSC seeks quants and advisers"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Tokyo finance centre recruits HSP scorers"
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "MADANI Economy",
        "reason": "Islamic finance expansion needs consultants"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Small financial sector still employs consultants"
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Diversifying economy fuels wealth-management demand"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Singapore Economy 2030",
        "reason": "Sustainable finance and wealth hubs prioritise advisors"
      },
      "uae": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "We the UAE 2031",
        "reason": "Dubai/Abu Dhabi grow as global finance hubs"
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London prioritises financial services talent"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Demand exists but no special immigration channel"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Growing fintech firms require advisory talent"
      }
    }
  },
  "ed6d5fd2-1a9b-4c75-be25-126b47a1c513": {
    "career": "Educator",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Secondary teachers on CSOL fast-track visas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Express Entry Category-Based Selection",
        "reason": "K-12 and early-childhood teachers explicitly targeted."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Shortage of qualified school teachers, eased recognition rules."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Hiring demand but not on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Private English teaching demand, no skilled-visa priority."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Primary/secondary teachers gain straight-to-residence pathway."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Teacher demand exists, removed from shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "State-level teacher shortages, no dedicated federal visa."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "1f54acb7-dff0-49d2-bb6a-db5321c05c11": {
    "career": "Geneticist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Emerging biotech cluster, limited visa priority."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Research talent welcomed, not on priority lists."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Life-science institutes recruiting under Opportunity Card."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Biopharma talent helpful for health goals, no visa boost."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Biomedical scientists on critical skills visa list."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "Fast-track for biotech researchers."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Pharma scientists prioritised in NIMP."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Small biotech sector, niche openings."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Investing in genomics and precision medicine."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Singapore Economy 2030",
        "reason": "Biomedical sciences key pillar; generous R&D visas."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "79",
        "policy": "We the UAE 2031",
        "reason": "Biotech R&D highlighted as future economy pillar."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "94",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life sciences named top national growth sector."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "",
        "reason": "Huge biotech funding but no dedicated immigration priority."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "",
        "reason": "Agritech biotech encouraged, limited dedicated scheme."
      }
    }
  },
  "e61dbb42-baa1-4f18-af91-d1e7cc24a3c1": {
    "career": "Art Director",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Film sector hiring, not on CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Advertising and film hubs need talent, no visa boost."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Growing film/game sector, no special visa."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Anime/game studios value senior art direction talent."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Niche film work (Weta) but limited visas."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Vision 2030",
        "reason": "Mega entertainment projects need senior creative leads."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Regional ad agencies recruit, not priority industry."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "We the UAE 2031",
        "reason": "Dubai Media City attracts global art directors."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry seniors explicitly prioritised."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Large creative industry but no immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "304cc60f-08dd-4662-823b-62dab60cc25a": {
    "career": "Math Lecturer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "STEM lecturers included under higher-education teachers"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Welcomes French-speaking STEM academics for universities"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Universities fast-track foreign STEM professors"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Expanding STEM universities for EV economy"
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Third-level lecturers in maths on critical list"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "Universities hire foreign maths PhDs under HSP"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "NIMP 2030",
        "reason": "STEM faculty needed for semiconductor talent pipeline"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "General skills pathway covers tertiary lecturers"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Vision 2030",
        "reason": "Building STEM universities at NEOM needs faculty"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "National AI Strategy 2.0",
        "reason": "Aggressive hiring of maths faculty to fuel AI talent"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Attracting global STEM academics to new research hubs"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "STEM teaching supports advanced manufacturing goals"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "CHIPS and Science Act",
        "reason": "STEM faculty funding to grow semiconductor-AI workforce"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Scholarships to bring in STEM lecturers"
      }
    }
  },
  "2c980394-3daa-4a59-a52b-e9db9cf6ea59": {
    "career": "International Relations Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Migration Strategy 2023",
        "reason": "Think-tank roles fall under professional migration"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Express Entry Category-Based Selection",
        "reason": "French-speaking policy professionals welcomed"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Policy analysts qualify via points system"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "41",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Limited but recognised under professional services"
      },
      "japan": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Small demand in foreign-policy units"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Hiring foreign policy advisors for global investments"
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Singapore Economy 2030",
        "reason": "Regional diplomacy think tanks headquartered here"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Diplomacy hub needs specialists on trade and climate"
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Trade deals create analyst roles"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Global climate diplomacy needs policy analysts"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      }
    }
  },
  "bea87a2a-ce6c-42ac-8348-35cbbeb52c1e": {
    "career": "Criminology Advisor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Migration Strategy 2023",
        "reason": "Justice departments recruit criminologists"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Social services analysts listed under shortage"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Police research institutes hire foreign experts"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Forensic services on skills list"
      },
      "japan": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Skilled Migrant Category",
        "reason": "Demand in corrections and policy units"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Vision 2030",
        "reason": "Smart-city security needs crime analysts"
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "47",
        "policy": "Singapore Green Plan 2030",
        "reason": "Safe-city programme values crime data specialists"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Operation 300bn",
        "reason": "Predictive policing initiatives seek advisors"
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "AI-driven security sector needs criminologists"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Grants fund community safety and analytics experts"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      }
    }
  },
  "d161545b-bca7-4114-b91b-02d135a559dd": {
    "career": "Museum Technician",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Arts roles outside CSOL priority lists"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Heritage institutions hire, no special visa stream"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Cultural jobs allowed but not shortage-listed"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "15",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Creative sector small; not on Green List"
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "New mega-museums need artifact specialists"
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Museums support tourism; niche demand exists"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "We the UAE 2031",
        "reason": "Tourism push funds museum development"
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Creative industries backed, but tech roles peripheral"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Cultural sector hiring but not federally prioritized"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "15",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b5271462-efe6-40c5-9af6-ea7e6ec69e05": {
    "career": "Behavioral Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Mental-health professionals in national shortage lists"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Allied health shortages include behaviour therapy"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Psychologists needed for ageing population care"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Allied health demand, yet not critical list"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Limited but recognised clinical psychology need"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Private hospitals hiring; no official fast-track"
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Migrant Category",
        "reason": "Severe shortage of mental-health specialists"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Healthcare expansion requires behavioural services"
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Government focus on mental health awareness"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "We the UAE 2031",
        "reason": "Growing mental-health market in private hospitals"
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "NHS demand but not on shortage list"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "High demand but no federal visa priority"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "9af56cfd-6e84-4493-906b-cc6f2142f2ae": {
    "career": "Marketing Specialist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "E-commerce boom needs digital marketing"
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Tourism and giga-projects need brand promotion"
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Economy 2030",
        "reason": "Regional marketing hubs despite no formal shortage"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Regional HQs seek digital marketers"
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Creative sector value; not on shortage list"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Large services economy still hires marketers"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "e7a504b0-c907-4240-bd3e-17305d52d3cc": {
    "career": "Built Environment Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Migration Strategy 2023",
        "reason": "Civil engineers on Core Skills list"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Civil engineers eligible but not top shortage"
      },
      "germany": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Urgent demand for civil/construction engineers"
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "New capital project demands infrastructure engineers"
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Civil engineers named on critical list"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Engineers possible but under mid-skill route"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Not core focus of NIMP 2030"
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Civil/structural engineers on Tier-1 Green List"
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Mega-projects need built-environment engineers"
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Role largely filled locally"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Operation 300bn",
        "reason": "Smart-city construction still high priority"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean energy infrastructure requires civil talent"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA funds climate-resilient buildings and bridges"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "National Master Plan 2021-2030",
        "reason": "Infrastructure expansion but domestic supply adequate"
      }
    }
  },
  "934ef79e-fbbc-40a0-bfa8-9f759a2d5eb0": {
    "career": "Nurse Practitioner",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Migration Strategy 2023",
        "reason": "Nurse practitioners urgently needed"
      },
      "canada": {
        "tier": "Tier 1",
        "score": "95",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Nurses top shortage occupation"
      },
      "germany": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe nursing shortages"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Localization policies limit foreign nurses"
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "",
        "reason": "HSE still recruiting overseas nurses"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Nursing care listed, NP role niche"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Local training supply adequate"
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "NPs on Green List Tier-1"
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Vision 2030",
        "reason": "Health-tourism expansion hiring foreign NPs"
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Hospitals import experienced nurses"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Hospital growth driving demand"
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Clinical care roles deprioritised post-2025"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "",
        "reason": "Shortage acknowledged but no special visa track"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Budget limits foreign NPs"
      }
    }
  },
  "95e3f144-291a-45ad-b720-3f91bc51bb94": {
    "career": "Environmental Geoscientist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Mining and remediation demand geoscience"
      },
      "canada": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Resource sector needs environmental geoscientists"
      },
      "germany": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Renewables and waste sites require experts"
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "RPJPN 2025-2045",
        "reason": "Nickel/EV mining boom needs environmental oversight"
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Infrastructure and pharma projects need env consultants"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Quake & geothermal research niche"
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "MADANI Economy",
        "reason": "Mining and environmental monitoring priorities"
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Migrant Category",
        "reason": "Earthquake and climate risks drive demand"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Limited focus on environmental assessment"
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Most geoscience work outsourced regionally"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Demand low; desert geology niche"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "CCUS and hydrogen storage need geoscientists"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds remediation and critical-minerals work"
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "National Master Plan 2021-2030",
        "reason": "Offshore wind and mining need assessments"
      }
    }
  },
  "a308fcbb-65c0-48d2-94ec-c5f3213679e5": {
    "career": "Qualified Secondary Teacher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "STEM-subject secondary teachers prioritised"
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Teachers on national shortage list"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Recruiting foreign teachers for bilingual/STEM gaps"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Some regional demand; no priority list"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "JET hires but not skills-visa priority"
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Secondary teachers on Green List pathway"
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Schools hiring but shortage visa withdrawn"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Local shortages, no federal visa route"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "78ee942e-3d42-443b-ab1f-85fa84a2ba5f": {
    "career": "MRes Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Seeks postgraduate research talent"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Eases visas for researchers"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Fast-tracks highly skilled researchers"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Research roles supported but not priority list"
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "Fast points for postgraduate researchers"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "Research incentives in public universities"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Points awarded for research degrees"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Universities expanding research capacity"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "National AI Strategy 2.0",
        "reason": "Government funds humanities-tech research"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "UAE Centennial 2071",
        "reason": "Strategic push for R&D talent"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Funds academic-industry research"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "CHIPS and Science Act",
        "reason": "Act boosts university research funding"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b1dcb908-ffb3-441f-be49-fb09f0d032e1": {
    "career": "Literature Professor",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Academics qualify under research talent stream"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Universities hire PhDs; no shortage list"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Card covers university lecturers"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Some vacancies; not priority occupation"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "English-literature faculty sought"
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Limited university spots, some demand"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Foreign faculty hired for new universities"
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Economy 2030",
        "reason": "Local universities import senior faculty"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "UAE Centennial 2071",
        "reason": "Expansion of private universities"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "",
        "reason": "Russell Group still recruits global scholars"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "",
        "reason": "Large tenure-track market despite tight budgets"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "959a8730-8867-4262-8712-8e229c59c871": {
    "career": "Biology Education Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Migration Strategy 2023",
        "reason": "Secondary STEM teachers in core shortage"
      },
      "canada": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Express Entry Category-Based Selection",
        "reason": "K-12 teachers on priority list"
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe shortage of STEM teachers"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Demand exists in private exam-prep sector"
      },
      "japan": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Biology teachers explicitly listed"
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "MOE hires foreign STEM curriculum specialists"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Private schools import specialist science educators"
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Independent schools recruit overseas biology teachers"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds STEM-education initiatives"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      }
    }
  },
  "1e538066-8d90-463a-8d74-04f8e85092a0": {
    "career": "Brand Manager",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "CPG multinationals base EMEA marketing in Dublin"
      },
      "japan": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Tourism and entertainment megaprojects need branding"
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Regional APAC brand hubs located here"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "We the UAE 2031",
        "reason": "Consumer and tourism sectors expanding"
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "53",
        "policy": "",
        "reason": "Creative industries employ seasoned brand leaders"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Large consumer brands need strategic marketers"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      }
    }
  },
  "86f6e7b3-5e87-44bf-aba4-8702f2347af1": {
    "career": "Criminal Justice Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "",
        "reason": "Criminology institutes need researchers"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Government supports policing reform research"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Federal crime office invests in analytics"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "ESRI undertakes justice policy projects"
      },
      "japan": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Small but growing justice analytics teams"
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National AI Strategy 2.0",
        "reason": "Gov funds crime data pilots"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Dubai Police sponsors academic crime labs"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "",
        "reason": "Home Office funds evidence-based policing research"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "",
        "reason": "NIJ and DOJ fund large crime studies"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      }
    }
  },
  "d51c2bce-3a4a-4498-ba9e-408bc40e8342": {
    "career": "Biomedical Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Med-tech adjacent to CSOL but not explicit"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "STEM healthcare engineers on shortage lists"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Engineering shortages include medical device sector"
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Biopharma and device R&D incentives"
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Med-tech engineers explicitly listed"
      },
      "japan": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Highly Skilled Professional visa",
        "reason": "Aging society invests in biotech devices"
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Medical device engineering focus area"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Green List excludes but hospitals import device talent"
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Local med-tech manufacturing push"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "87",
        "policy": "Singapore Economy 2030",
        "reason": "Biomedical manufacturing pillar of economy"
      },
      "uae": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Operation 300bn",
        "reason": "Advanced medical devices part of diversification drive"
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences and med-tech R&D priority"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Biotech-device R&D qualifies for CHIPS life-science funds"
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National Master Plan 2021-2030",
        "reason": "Emerging biotech and med-tech cluster"
      }
    }
  },
  "6c119949-ddb5-4d0b-be13-d48c209d72c7": {
    "career": "Music Educator",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Express Entry Category-Based Selection",
        "reason": "French-speaking K-12 teachers in demand"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Education roles earn Opportunity Card points"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "41",
        "policy": "",
        "reason": "Community arts programmes seek instructors"
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Rural schools need specialist arts teachers"
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "",
        "reason": "Creative SG encourages arts education talent"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "International schools hire arts educators"
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Arts teachers useful but not shortage priority"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a6ab9433-a6c7-47cc-a78d-6495c9bf4571": {
    "career": "Clinical Nurse Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "ICU and aged-care nurse shortage critical"
      },
      "canada": {
        "tier": "Tier 1",
        "score": "95",
        "policy": "Express Entry Category-Based Selection",
        "reason": "CNS fast-tracked under healthcare shortage"
      },
      "germany": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe hospital nurse shortage"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Growing healthcare sector, credential recognition tough"
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Hospitals recruiting overseas CNS"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Nursing care demand; CNS level rare"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Private hospitals hire but limited quota"
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "87",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Immediate residency for specialist nurses"
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Hospital expansion demands advanced nurses"
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Singapore Green Plan 2030",
        "reason": "Ageing population drives demand"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "We the UAE 2031",
        "reason": "Healthcare city projects need CNS"
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "CNS remains on shortage list"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "",
        "reason": "Shortage exists but no dedicated visa pathway"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "c895cee8-64fd-4759-86fb-6a5e1efa5598": {
    "career": "Computer Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Listed under software/ICT engineering"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Actively courting chip and AI talent"
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe shortage of IT hardware engineers"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Early-stage semi packaging ambitions"
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Intel/Apple fabs need hardware talent"
      },
      "japan": {
        "tier": "Tier 2",
        "score": "67",
        "policy": "Highly Skilled Professional visa",
        "reason": "Government subsidies for domestic chip comeback"
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Huge incentives for IC design and packaging"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "General ICT shortage, small chip sector"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Building AI and defense electronics hubs"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Manufacturing 2030",
        "reason": "World-class fabs and generous R&D grants"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing push includes semiconductors"
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Chip design priority but limited visa slots"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "95",
        "policy": "CHIPS and Science Act",
        "reason": "Billions for semiconductor R&D and fabs"
      },
      "vietnam": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Aggressive growth in chip design centres"
      }
    }
  },
  "a5a458d5-1d21-46bc-b397-3a4b734bfee6": {
    "career": "Music Lecturer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Robust tertiary arts sector needs lecturers"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "",
        "reason": "Francophone institutions hire music academics"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "",
        "reason": "Strong conservatory tradition and aging faculty"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "",
        "reason": "New arts universities under 2045 vision"
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Growing creative-arts colleges"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Conservatories seek Western musicologists"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Private universities adding music programs"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Small but stable demand at universities"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "New entertainment academies emerging"
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "61",
        "policy": "",
        "reason": "Yong Siew Toh and LASALLE hire global faculty"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "We the UAE 2031",
        "reason": "Cultural hubs recruiting arts faculty"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "World-leading conservatories and research funding"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "",
        "reason": "University arts programs still expanding"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Cultural institutes modernising curricula"
      }
    }
  },
  "2282024f-91d3-4655-8db0-41a533ba973c": {
    "career": "Mechanical Engineering Practitioner",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Chronic shortage in mining and infra projects"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Engineers on priority list"
      },
      "germany": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Heartland of automotive and machinery"
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV battery and infra boom"
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Med-tech manufacturing needs mechanical talent"
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics and automotive sectors ageing"
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "67",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Aerospace and EV supply chain push"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Green List (Tier 2)",
        "reason": "Listed but small market"
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Giga-projects need mechanical systems experts"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Singapore Economy 2030",
        "reason": "Precision engineering and aerospace MRO focus"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Operation 300bn",
        "reason": "Industrial diversification drives demand"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "EV and aerospace clusters expanding"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "93",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Massive spend on transport and clean tech"
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "National Master Plan 2021-2030",
        "reason": "Manufacturing upgrade to high-tech machinery"
      }
    }
  },
  "8673466f-7641-4d83-be84-68a87948b21d": {
    "career": "Supply Chain Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Supports construction supply chains"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Transport & logistics occupations targeted"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Logistics sector talent gaps"
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV battery supply chains critical"
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Export pharma needs logistics"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Highly Skilled Professional visa",
        "reason": "Manufacturing supply chain optimisation"
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Electronics export targets require SCM"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Migrant Category",
        "reason": "Import-dependent economy needs planners"
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Vision 2030",
        "reason": "Mega-projects demand world-class logistics"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Economy 2030",
        "reason": "Regional logistics & trade flagship"
      },
      "uae": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "We the UAE 2031",
        "reason": "Global trade hub prioritises supply chain"
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Advanced manufacturing resilience"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Reshoring needs logistics leadership"
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Export-oriented logistics focus"
      }
    }
  },
  "c6c160a8-2e6a-4360-bdc5-e527aa56f159": {
    "career": "Entrepreneur",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Global Talent visa encourages founders"
      },
      "canada": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Start-up visa & funding schemes"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Berlin & Munich start-up ecosystems"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Digital economy push"
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Start-Up Entrepreneur Programme"
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "Special zones for foreign founders"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "SME digitalisation incentives"
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Skilled Migrant Category",
        "reason": "Entrepreneur Work Visa pathway"
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Vision 2030",
        "reason": "Massive funding for new ventures"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "95",
        "policy": "National AI Strategy 2.0",
        "reason": "EntrePass & deep-tech funding"
      },
      "uae": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "UAE Centennial 2071",
        "reason": "Free-zones & Golden Visa for founders"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Innovator Founder visa route"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "CHIPS and Science Act",
        "reason": "Start-ups tapped for tech reshoring"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "National Master Plan 2021-2030",
        "reason": "Fintech & e-commerce start-ups rising"
      }
    }
  },
  "b96f717c-067d-4e03-ad95-c3939a93fb60": {
    "career": "Educational Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Migration Strategy 2023",
        "reason": "STEM teacher gaps need curriculum advisors"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Severe teacher shortages; consulting adjacent"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "School reform requires experts"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "International student advisory demand"
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Teacher shortages; consultancy valued"
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Some specialist education roles"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Advisory role linked to expanding ed-tech"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "d0580d13-7b55-48ef-a051-2fc6a13768d3": {
    "career": "Physics Education Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "95",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Secondary STEM teachers critically needed"
      },
      "canada": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Physics teachers on shortage list"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Demand for Gymnasium physics educators"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Periodic STEM teacher shortages"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "ALT science roles exist, limited priority"
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Secondary physics teachers fast-tracked"
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "MOE hires foreign physics teachers case-by-case"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "International schools recruit expat physics teachers"
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "STEM teacher vacancies but off shortage list"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "STEM teacher shortages, no national visa boost"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b40fb531-439d-4870-a7ef-41d5814b004c": {
    "career": "Tax Consultant",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "FDI surge needs tax planning"
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "MNC headquarters need transfer-pricing specialists"
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Islamic finance growth drives tax advisory demand"
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "VAT and corporate reforms require advisors"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Economy 2030",
        "reason": "Asia-Pacific tax headquarters destination"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Regional financial hub needs cross-border tax expertise"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City firms recruit international tax talent"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "High demand but no immigration priority"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "cbcc79d9-6fed-4f6e-9642-be358bcc8c56": {
    "career": "Chemical Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Processing and mining projects need expertise"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Petrochem and cleantech require engineers"
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Hydrogen and chemicals clusters hiring"
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "RPJPN 2025-2045",
        "reason": "Nickel/EV battery processing plants"
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Biopharma and process industries"
      },
      "japan": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Highly Skilled Professional visa",
        "reason": "Battery and semiconductor chemicals"
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Specialty chemicals and fabs expansion"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Limited but some dairy/energy process roles"
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Vision 2030",
        "reason": "Mega petrochemical and hydrogen projects"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "Manufacturing 2030",
        "reason": "Petrochemicals and biopharma hub"
      },
      "uae": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Operation 300bn",
        "reason": "Hydrogen and advanced manufacturing push"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "CCUS and green hydrogen initiatives"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Clean energy and advanced manufacturing expansion"
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Electronics chemicals & LNG projects"
      }
    }
  },
  "ca8af6b6-1209-4ec5-940f-0cb840b2a2d8": {
    "career": "Strategy Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "Advisory skills aid resource-sector diversification."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Supports scaling tech-services companies."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Industrial Mittelstand seeks strategic planning talent."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Tech MNC HQs need planning analysts."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Global firms need bilingual strategists."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "MADANI Economy",
        "reason": "Industrial upgrading needs strategy support."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Megaprojects demand corporate strategy expertise."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Singapore Economy 2030",
        "reason": "Regional HQs hire analysts for APAC growth."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Diversification drives demand for strategy analysts."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Advanced-manufacturing firms require strategic insights."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Managers needed for new infrastructure-fund analysis."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b0c7d9d6-23e3-40ef-b24a-ec97bae281d7": {
    "career": "Business Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Resource companies seek experienced managers."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Tech and services scale-ups need managers."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Export-driven SMEs need global managers."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV supply-chain projects need management talent."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "MNC HQs require business operations heads."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "Global-minded managers welcomed amid aging workforce."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "53",
        "policy": "MADANI Economy",
        "reason": "Industry 4.0 roll-out needs managers."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Construction boom needs site managers."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Vision 2030",
        "reason": "Giga-projects require seasoned business managers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Singapore Economy 2030",
        "reason": "Regional HQs hire seasoned business leaders."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "We the UAE 2031",
        "reason": "Diversified economy prizes experienced managers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Advanced manufacturing needs operational leadership."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Clean-energy firms need operations leadership."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National Master Plan 2021-2030",
        "reason": "Foreign factories seek bilingual managers."
      }
    }
  },
  "a495e206-958b-4b65-8ba5-d38ad653b9cc": {
    "career": "Social Worker",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Listed shortage; ageing and rural needs."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Shortage occupation; fast-track residency."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Elderly care and integration services shortage."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Healthcare system lacks social workers."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Nursing care visa overlaps with social work."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "On Green List; straight-to-residence pathway."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Local councils recruit internationally."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Health funding indirectly boosts community services."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "04d982e7-6774-43b4-a4d4-32e02c145289": {
    "career": "Exercise Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Sport-centric culture needs exercise science support"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Growing sports medicine but not on priority lists"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Bundesliga and rehab clinics create adjacent demand"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "22",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "29",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Sports and wellness push for mega-projects"
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Dubai fitness and sports tourism initiatives"
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "47",
        "policy": "",
        "reason": "Elite sport institutes need physiologists"
      },
      "united_states": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "7515de34-9aff-49a0-a07d-4da93c6fe33e": {
    "career": "Advocacy Worker",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "NGOs campaign on environment and social justice"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Robust civil society and Indigenous rights work"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "",
        "reason": "Strong tradition of civic advocacy"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "18",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "15",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "22",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Historic hubs for human-rights organisations"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Large nonprofit sector needs policy advocates"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      }
    }
  },
  "e9d9e397-c24b-42d3-ac50-bf69f3ba058c": {
    "career": "Biotechnologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Listed under life sciences but not top priority"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Actively courting life-science researchers"
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Strong pharma and industrial biotech demand"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Biopharma research in early growth stage"
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma and medtech cluster centred around Dublin and Cork"
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "Biotech startups aligned with ageing-society needs"
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan highlights pharma and medical devices"
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Skilled Migrant Category",
        "reason": "Needs biotech talent for agritech innovations"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Emerging biotech hubs, early-stage"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "89",
        "policy": "Singapore Economy 2030",
        "reason": "Biomedical hub with aggressive talent schemes"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Operation 300bn",
        "reason": "Building biotech manufacturing capability"
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences R&D designated strategic sector"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "95",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Massive funding for biotech manufacturing and R&D"
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "National Master Plan 2021-2030",
        "reason": "Targets biotech to boost agriculture and healthcare"
      }
    }
  },
  "c3706cf4-8726-4492-ba0d-e9a34a99d786": {
    "career": "Molecular Biologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Medical research centres create steady but limited demand."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Express Entry favors STEM, biotech skills shortages."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Healthtech innovation needs molecular scientists under Skilled Immigration Act."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Biopharma researchers needed for Emas 2045 health goals."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma-heavy economy urgently needs biotech scientists."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP visa invites biotech researchers for drug discovery."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "NIMP 2030 lists pharma scientists as priority."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Agri-biotech innovation generates adjacent need."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Vision 2030 growing pharma-biotech manufacturing capability."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Singapore Green Plan 2030",
        "reason": "Biomedicine pillar under Green Plan 2030 manufacturing roadmap."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Operation 300bn",
        "reason": "Operation 300bn targets domestic biotech production."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life sciences are IS-8 flagship growth sector."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "95",
        "policy": "CHIPS and Science Act",
        "reason": "Biotech R&D prioritized under CHIPS bioeconomy funding."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "National Master Plan 2021-2030",
        "reason": "Strategy wants biotech researchers for health, agriculture."
      }
    }
  },
  "e8cde7ed-9fef-4a3a-89df-3bd33d25b08b": {
    "career": "Quantitative Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Migration list omits finance; markets smaller."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Category selection doesn’t prioritize finance; moderate openings."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Strong banking; not on policy lists."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Fintech expanding but quant sophistication limited."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "IFSC needs quants for hedge-fund administration."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Finance sector mature; policy neutral."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "MADANI Economy",
        "reason": "MADANI Islamic finance growth needs quants."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Small finance market; few quant roles."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Vision 2030",
        "reason": "Vision 2030 fintech push creates quant demand."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Singapore Economy 2030",
        "reason": "Global fintech hub under Economy 2030 needs quants."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "UAE Centennial 2071",
        "reason": "Fintech hub DIFC seeks quant talent."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London financial services prioritized."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Large finance sector; policy neutral but demand high."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Emerging fintech sector but nascent quant demand."
      }
    }
  },
  "58b87bc3-98c2-417c-af5e-be4d17c768b5": {
    "career": "Consulting Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Renewable transition spurs environment consulting roles."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Climate commitments drive moderate consultant demand."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Energiewende demands extensive environmental assessments."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital Nusantara needs environmental assessments."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Environmental consulting demand steady but not prioritized."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Policy focus elsewhere; limited consulting roles."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "MADANI Economy",
        "reason": "Industrial plan includes green tech, some consulting need."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Green List excludes; sustainability still important."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Vision 2030 resorts, megaprojects need impact assessments."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Singapore Green Plan 2030",
        "reason": "Green Plan 2030 drives high demand for sustainability consultants."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "We the UAE 2031",
        "reason": "We the UAE 2031 targets sustainability expertise."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean energy strategy supports environmental consulting spaces."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds climate projects; need environmental consultants."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Infrastructure boom needs environmental compliance advice."
      }
    }
  },
  "29e557da-9b78-41eb-ae1f-7dd3e55507d3": {
    "career": "Market Research Analyst",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Services economy needs analysts yet not on Critical Skills list"
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Data-driven services economy demands insights despite no quota"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Consumer insights support tourism & media growth sectors"
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Role supports creative industry but absent from shortage list"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Service-economy demand but not a targeted immigration category"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "1f8a474e-7a9f-468a-9035-0d46aa3bdbf3": {
    "career": "English Language Arts Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Regional schools face severe teacher gaps"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "K-12 teachers included in new shortage category"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Demand for qualified teachers for integration schooling"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Primary and secondary teachers fast-tracked"
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Private international schools hire expat English specialists"
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Teacher shortages exist but not federally prioritised for visas"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "30c8e441-34f7-474d-a39b-210f387b2e0e": {
    "career": "Sustainable Civil Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "95",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Urgent need during nationwide infrastructure boom"
      },
      "canada": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Civil engineers on priority shortage list"
      },
      "germany": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Transport and renewable projects require engineers"
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nusantara new capital requires sustainable engineering"
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Civil engineers officially on critical list"
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-city and disaster-resilient projects"
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Green infrastructure aligns with advanced materials push"
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Civil/structural engineers fast-tracked for residency"
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Vision 2030",
        "reason": "Megaprojects like NEOM need sustainable expertise"
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Green Plan 2030",
        "reason": "Coastal defence and green building projects"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Operation 300bn",
        "reason": "Smart city expansion drives demand for civil talent"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean energy and rail upgrades need engineers"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Massive federal spend on resilient, green infrastructure"
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "National Master Plan 2021-2030",
        "reason": "Major transport and renewable projects underway"
      }
    }
  },
  "1ef565dd-298a-4410-ba07-15517f3dd0a2": {
    "career": "Conservation Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL lists environmental scientists as shortage"
      },
      "canada": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Stream for agri-environment professionals"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Renewables expansion needs impact assessments"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "RPJPN 2025-2045",
        "reason": "Rainforest conservation in Nusantara build-out"
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Consultancies hiring but not on critical list"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Localised eco-restoration; language barrier"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industrial sites need sustainability audits"
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "95",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Green List explicitly names conservation scientists"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Eco-tourism megaprojects require habitat management"
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Singapore Green Plan 2030",
        "reason": "Urban biodiversity corridors need monitoring"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "We the UAE 2031",
        "reason": "Mangrove restoration projects create niche roles"
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Net-zero infrastructure requires ecological surveys"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds land restoration; moderate scientist demand"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "41",
        "policy": "National Master Plan 2021-2030",
        "reason": "Hydropower projects mandate impact studies"
      }
    }
  },
  "155612fe-5b55-418d-89b5-fba733957a92": {
    "career": "Electronic Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Migration Strategy 2023",
        "reason": "Listed under electrical shortages"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Telecom and embedded systems demand"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "79",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Auto electronics and Industry 4.0"
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV battery electronics demand"
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Medtech and chip giants hiring"
      },
      "japan": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics and semiconductor core priority"
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "IC design and wafer fab boom"
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Migrant Category",
        "reason": "Small but growing tech manufacturing"
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Smart-city and defense electronics"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Manufacturing 2030",
        "reason": "Precision electronics hub status"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing push"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "77",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Semiconductor and EV supply chain"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "95",
        "policy": "CHIPS and Science Act",
        "reason": "Massive semiconductor fab expansion"
      },
      "vietnam": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Government-backed chip design push"
      }
    }
  },
  "ddfd702f-e5c7-44d6-9fac-f4c6e1b1a171": {
    "career": "Clinical Psychologist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Migration Strategy 2023",
        "reason": "Critical shortage in mental-health workforce"
      },
      "canada": {
        "tier": "Tier 1",
        "score": "95",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Health shortage stream includes psychologists"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Need therapists for aging population"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "",
        "reason": "Post-pandemic demand rising; few permits"
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Mental-health professionals in demand"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Licensing language barrier limits foreign entry"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "Urban clinics hiring; rural gap"
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Psychologists on Green List"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Hospital expansion includes behavioral health"
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Government funding mental-wellness programs"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Community wellness initiatives"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "NHS struggles to fill posts"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Rising mental-health demand; licensure state-specific"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Stigma slows sector growth"
      }
    }
  },
  "7edf9fa7-881e-49c1-9447-29b1f782dda0": {
    "career": "Mathematics Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL covers data analysts needing math depth"
      },
      "canada": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Program favours AI, data and math researchers"
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Research institutes hire mathematicians for industry 4.0"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV/mining modelling needs some maths"
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Lists AI/data roles grounded in mathematics"
      },
      "japan": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP welcomes algorithm/AI researchers"
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Semiconductor sector needs applied mathematicians"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Few research posts; small demand"
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Vision 2030",
        "reason": "AI-driven megaprojects need modelling experts"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "National AI Strategy 2.0",
        "reason": "Aggressive hiring of theoretical scientists for AI"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing needs algorithmic optimisation"
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 targets digital, AI, semiconductor maths talent"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "95",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds advanced math for AI, quantum, chips"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "",
        "reason": "Growing chip sector; limited pure research"
      }
    }
  },
  "c01fa162-51d5-4714-b408-8671a38fe79b": {
    "career": "Economics Educator",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Universities list economics lecturers on CSOL"
      },
      "canada": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Teacher shortages include economics instructors"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Research universities sponsor lecturers"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Occasional openings at foreign-owned universities"
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "",
        "reason": "Business schools seek PhD economists"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Some English-medium universities hire foreigners"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "International branch campuses need lecturers"
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Secondary commerce teachers on shortage list"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Private universities expanding economics programmes"
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "",
        "reason": "NUS/NTU recruit research-active economists"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "We the UAE 2031",
        "reason": "Branch campuses hire foreign economics faculty"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Russell-group universities recruit globally"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Universities hire, but not immigration priority"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "",
        "reason": "Growing private universities; limited slots"
      }
    }
  },
  "4535bee0-af74-478c-a425-1e2e12e0a323": {
    "career": "Business Economist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Roles exist in treasury and banks"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Banks and policy units hire economists"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Industry 4.0 firms need demand forecasters"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Infrastructure financing needs some economists"
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Financial services quants in demand"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Highly Skilled Professional visa",
        "reason": "Some demand in fintech, policy think-tanks"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "MADANI Economy",
        "reason": "Islamic finance growth needs analysts"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Small economy, limited openings"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Vision 2030",
        "reason": "Economic diversification demands analysts"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Singapore Economy 2030",
        "reason": "Sustainable finance hub seeks economic strategists"
      },
      "uae": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "We the UAE 2031",
        "reason": "Regional financial hub needs economists"
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "London financial services prioritise economic analysts"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "",
        "reason": "Strong demand in finance & consulting, no specific visa boost"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Emerging fintech sector; few senior roles"
      }
    }
  },
  "a3edb4f7-bbe0-4485-a831-9b3d66e5eef1": {
    "career": "Construction Manager",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Construction project managers on shortage list"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Strong demand for infrastructure and housing projects"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Civil engineering and site management shortages"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital city driving project demand"
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Construction PMs eligible for fast visas"
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "SSW covers construction supervisors"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Industrial plan focuses more on factories than buildings"
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Listed construction project managers fast-tracked"
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "89",
        "policy": "Vision 2030",
        "reason": "Mega-projects (NEOM, Red Sea) need senior site managers"
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Tight quotas; locals preferred for site supervision"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "We the UAE 2031",
        "reason": "Ongoing real-estate and tourism builds"
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Demand exists but not on shortage lists"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "93",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Massive public-works funding needs experienced construction PMs"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Transport infrastructure push needs civil pros"
      }
    }
  },
  "a5f12578-2c11-4ce2-9d1b-ada1d8697a93": {
    "career": "Psychologist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Migration Strategy 2023",
        "reason": "Registered psychologists on priority pathways"
      },
      "canada": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Mental-health practitioners in healthcare shortage list"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Allied health shortage, ageing population"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Needs exist; not on critical list"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Language barrier limits foreign practice"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Mental-health recognised yet not policy priority"
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Migrant Category",
        "reason": "Mental-health workforce gaps"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "Growing private healthcare sector"
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Some demand; locals preferred"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "UAE Centennial 2071",
        "reason": "Demand in private clinics; licensing strict"
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "NHS shortages but no immigration fast-track"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "High demand but no federal immigration priority"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "cdb09df2-dc2c-46a2-a15a-006b02c0898c": {
    "career": "Sport Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Strong sports culture; limited immigration pathways"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Growing sport tech; not in priority list"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Elite football clubs hire specialists locally"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Niche hiring only"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Local language and certification barriers"
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "",
        "reason": "Rugby institutes use local talent"
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Investing heavily in sports performance centres"
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Sports hub hires selectively"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "We the UAE 2031",
        "reason": "Sports academies and wellness tourism push"
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Premier League demand; no shortage route"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Demand from pro teams; no formal visa priority"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "0e70e72b-bf16-4bfe-94ca-fe722b895f80": {
    "career": "Infrastructure Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL lists civil/infrastructure engineering shortages."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Civil engineers on shortage list."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Demand for infrastructure upgrades, rail and energy grids."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital Nusantara drives infrastructure analytics need."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Civil engineers remain on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "SSW covers construction; analyst roles adjacent."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Infrastructure roles helpful to NIMP but not core."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Green List explicitly names civil/structural engineers."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Vision 2030",
        "reason": "Mega-projects (NEOM, Red Sea) need infrastructure analysts."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Limited slots; infra largely built-out."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Smart-city and logistics goals drive infra analytics."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Demand exists but not on priority lists."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA funds need analysts for bridges, roads, utilities."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "National Master Plan 2021-2030",
        "reason": "Transport infrastructure engineers prioritised."
      }
    }
  },
  "8801cecd-0e2e-455d-87ed-ac36766a7cfb": {
    "career": "Cultural Studies Professor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Academic hiring steady but off CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Universities hire, but not immigration priority."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Card favours researchers with PhDs."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "",
        "reason": "Academic roles exist; not on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP visa suits PhD researchers."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Limited university openings; not on Green List."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "National AI Strategy 2.0",
        "reason": "Research universities value humanities-tech crossover."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Global branch campuses hire humanities faculty."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "",
        "reason": "Universities recruit, but no priority listing."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Research universities recruit globally despite no special act."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "d6f0bcbf-798b-4895-bfaf-92b66db3a7e3": {
    "career": "Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Local promotion preferred over sponsored visas."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Openings exist, not on priority list."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Management roles often filled locally."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Government pushing localisation of leadership roles."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Visa priority given to technical specialists."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Language barriers; HSP focuses on engineers."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Industrial plan stresses technical, not managerial visas."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Small market; few visas for generic managers."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Mega-projects seek experienced international leadership."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Singapore Economy 2030",
        "reason": "Regional HQs need strategic managers with digital know-how."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Operation 300bn",
        "reason": "Diverse economy attracts strategic managers."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Points system favours STEM over generic managers."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "",
        "reason": "General & operations managers in top growth category."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "",
        "reason": "Local talent pool preferred for management."
      }
    }
  },
  "d3845af4-40d4-4bad-8f62-944d23891b13": {
    "career": "International Relations Officer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Management role adjacent to services economy"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Useful for foreign service, but no formal priority"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Role valued but outside Skilled Immigration priorities"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Limited but present in EU institutions"
      },
      "japan": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Needed for global tourism and investment outreach"
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Economy 2030",
        "reason": "Global trade hub values diplomatic liaisons"
      },
      "uae": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "We the UAE 2031",
        "reason": "Hub for diplomacy, trade and multilateral bodies"
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "London hosts many NGOs; still not priority list"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Supports diplomacy; not on shortage lists"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "6dd40d6b-eb6c-4a95-9fed-d27b3839f122": {
    "career": "Corporate Finance Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Role exists, not CSOL priority"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Financial sector healthy; not on Express Entry list"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Finance roles present but outside shortage focus"
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech and capital-market expansion needs specialists"
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Financial services quants and treasury centres"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Tokyo finance strong; not under HSP priority"
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "MADANI Economy",
        "reason": "Growth in Islamic finance and capital markets"
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Financial diversification and PIF investments need talent"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Singapore Economy 2030",
        "reason": "Global hub for sustainable and corporate finance"
      },
      "uae": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "We the UAE 2031",
        "reason": "DIFC/ADGM expanding global finance hub"
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London financial services priority"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Finance strong but not policy-priority"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Finance expanding but tech roles prioritised"
      }
    }
  },
  "30f66245-eeb6-40ca-a651-9c5917a3bd78": {
    "career": "Religious Studies Lecturer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "",
        "reason": "Academia seeks humanities staff; not CSOL"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Universities value multicultural religion scholarship"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "",
        "reason": "Strong theological faculties need lecturers"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "State Islamic universities need lecturers"
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Limited posts; some demand in theology colleges"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Private universities hire humanities foreign faculty"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Islamic studies institutions recruit lecturers"
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "",
        "reason": "Universities face lecturer shortages"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Islamic universities expanding programs"
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Limited posts; humanities valued but small hiring"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Private universities hire, but role not prioritised"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "69",
        "policy": "",
        "reason": "Russell Group demand for subject specialists"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Research universities actively hire humanities faculty"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Growing but small humanities departments"
      }
    }
  },
  "eadb9349-0571-4e4b-ad09-cc3eace60787": {
    "career": "Risk Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Finance sector demand exists; not on CSOL"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Banks hiring; not on category-based priority list"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Frankfurt finance hub needs risk skills, not priority list"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List includes financial quants, risk modeling"
      },
      "japan": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "MADANI Economy",
        "reason": "Islamic finance expansion needs risk expertise"
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Financial sector diversification pushing demand for risk professionals"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Singapore Economy 2030",
        "reason": "Global risk, fintech hub seeks sustainable finance risk analysts"
      },
      "uae": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "We the UAE 2031",
        "reason": "DIFC prioritizes financial risk and fintech regulation"
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City financial services core, risk quant talent shortage"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Financial centers need risk talent, but no targeted visa priority"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a73e6a3f-87a5-4fe7-bd32-2ba407aeda73": {
    "career": "History Professor",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "67",
        "policy": "",
        "reason": "Universities sponsor lecturers despite no CSOL listing"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Universities use Express Entry for academics, but not priority"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "",
        "reason": "Fachkräfte law eases hiring for researchers"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "",
        "reason": "Universities recruit, but not Critical Skills list"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Foreign faculty welcomed in global universities"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Private universities hire expat academics"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Some university demand, not on Green List"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "New universities need humanities faculty"
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "NUS & NTU hire research academics"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Academic city expansion requires professors"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "69",
        "policy": "",
        "reason": "Russell Group hires international historians"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Research universities recruit international humanities faculty"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      }
    }
  },
  "0f1388ec-869e-4198-9e89-7af3cecbc159": {
    "career": "MPA Graduate: Gov Policy Advisor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Public sector cautious on foreign advisors"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Government hires locals; limited visa pathways"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Language barrier, few visas for policy staff"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "RPJPN 2025-2045",
        "reason": "Capital relocation drives advisory needs"
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Small demand in government consultancies"
      },
      "japan": {
        "tier": "Not a fit",
        "score": "0",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "Economic plan needs policy talent, limited visas"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Small market; public roles citizen-preferred"
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Vision 2030",
        "reason": "Major reforms create demand for policy strategists"
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Singapore Economy 2030",
        "reason": "GovTech, ministries hire policy analysts"
      },
      "uae": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "We the UAE 2031",
        "reason": "Government accelerators recruit global policy talent"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Policy units on clean energy need advisors"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Think tanks hire, H-1B available, no priority"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National Master Plan 2021-2030",
        "reason": "Planning agencies need advisors, language challenge"
      }
    }
  },
  "58a4bf4c-46c2-426e-afb8-24a72671e13c": {
    "career": "Statistician",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Data analysts listed; stats adjacent"
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Explicit shortage for data scientists/statisticians"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialists include data/statistics roles"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech/agri-data growth requires analysts"
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Data scientist/statistician explicitly listed"
      },
      "japan": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Highly Skilled Professional visa",
        "reason": "AI/ML researchers welcomed; stats core skill"
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "NIMP 2030",
        "reason": "Industry 4.0 analytics needs statisticians"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "General demand for analysts, not on Green List"
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "AI-driven megaprojects need data analysts"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "National AI Strategy 2.0",
        "reason": "Stats essential for AI hub ambitions"
      },
      "uae": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "We the UAE 2031",
        "reason": "Data science a core pillar for diversification"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital/AI priority includes statisticians"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "CHIPS and Science Act",
        "reason": "Supports AI research; statisticians underpin modelling"
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "AI/ML engineers demand statistical talent"
      }
    }
  },
  "84457214-7291-446d-8c4a-a2b3868814c2": {
    "career": "Materials Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Civil engineers/materials on shortage list"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Infrastructure and clean-tech projects need materials experts"
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Shortage of civil/materials engineers for energy retrofits"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital construction needs materials expertise"
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "",
        "reason": "Demand modest; some pharma plant builds"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-city and earthquake materials research niche"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "NIMP 2030",
        "reason": "Advanced materials a targeted sector"
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 2)",
        "reason": "Seismic-resilient construction needs materials know-how"
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "87",
        "policy": "Vision 2030",
        "reason": "NEOM and giga-projects require advanced materials"
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Green Plan 2030",
        "reason": "Focus on sustainable building materials R&D"
      },
      "uae": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Operation 300bn",
        "reason": "Mega construction/advanced manufacturing push"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean-energy infrastructure needs materials engineers"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "93",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Huge demand for durable, green construction materials"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "National Master Plan 2021-2030",
        "reason": "Infrastructure boom drives moderate demand"
      }
    }
  },
  "4bb62245-1b00-4bf5-a402-bc604ba1c777": {
    "career": "PhD Philosopher",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Academic roles limited; competitive"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Universities recruit but no explicit shortage"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Strong humanities tradition; research visas available"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Limited but existing humanities funding"
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Small academic market, some demand"
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "Singapore Economy 2030",
        "reason": "Ethics teaching rising in tech sector"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "UAE Centennial 2071",
        "reason": "Private universities hire liberal-arts faculty"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "World-class philosophy departments attract talent"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "CHIPS and Science Act",
        "reason": "Research funding indirectly supports humanities posts"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "23498d45-c948-4a09-a404-6f3c4b32c92a": {
    "career": "Physics Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Radio-telescope facilities seek PhDs"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Limited but growing basic-science grants"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Max Planck institutes hire foreign physicists"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Small but active astrophysics centres"
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "JAXA and Subaru Telescope hiring"
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "University posts occasional"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "King Abdulaziz Space City growth"
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "",
        "reason": "Limited roles in fundamental physics"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Emirates Mars Mission boosts astrophysics demand"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "UK Space Agency funds astronomy research"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "94",
        "policy": "CHIPS and Science Act",
        "reason": "Massive NSF & NASA astrophysics funding"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "9b02b2cb-455e-42c7-ab71-95ed723837d5": {
    "career": "Human Geographer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Environmental scientists on shortage list"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Express Entry Category-Based Selection",
        "reason": "STEM and climate professionals welcomed"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Sustainability roles adjacent demand"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Some roles in wind-farm siting"
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Green List (Tier 2)",
        "reason": "Strong demand for environmental planners"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Vision 2030",
        "reason": "Mega-city sustainability needs"
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Green Plan 2030",
        "reason": "City-state focuses on coastal resilience"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Urban resilience projects"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Net-zero planning requires spatial analysts"
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Climate adaptation planning funds"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4125cb8a-fece-405f-adc7-64e84c18c61b": {
    "career": "Information Systems Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Software and cyber on shortage list"
      },
      "canada": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "IT specialists fast-tracked under STEM"
      },
      "germany": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Urgent need for IT system integrators"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Digitalisation of government services"
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Multinationals hiring cloud architects"
      },
      "japan": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Highly Skilled Professional visa",
        "reason": "Corporate systems modernisation push"
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "67",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industry 4.0 and fintech growth"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Opportunities but smaller market"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "Smart-city and fintech projects"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "National AI Strategy 2.0",
        "reason": "Financial and AI hub needs systems engineers"
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Operation 300bn",
        "reason": "Digital transformation across government and finance"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital and cyber specialists prized"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "95",
        "policy": "CHIPS and Science Act",
        "reason": "Huge demand for enterprise and AI systems architects"
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Large demand for IT systems in manufacturing"
      }
    }
  },
  "040715ee-ff43-400e-a71e-f3cd16da2967": {
    "career": "Engineering Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Engineers listed on CSOL"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "STEM engineers fast-tracked"
      },
      "germany": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe shortage of engineering physicists"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV battery materials require physics expertise"
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Engineers on critical skills list"
      },
      "japan": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Highly Skilled Professional visa",
        "reason": "Semiconductor/robotics engineers prioritised"
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Semiconductor engineer shortage"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Some demand but not on Green List"
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Advanced manufacturing projects need specialists"
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Manufacturing 2030",
        "reason": "Precision-engineering & semiconductor hub"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Operation 300bn",
        "reason": "Industrial diversification needs engineers"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Semiconductor & clean-energy engineering focus"
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "95",
        "policy": "CHIPS and Science Act",
        "reason": "Semiconductor and quantum R&D heavily funded"
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Design engineers urgently needed"
      }
    }
  },
  "9859f08b-1b5e-4f9e-a8e8-191344455d06": {
    "career": "Design Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Niche opportunities in product firms"
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Some demand, not immigration priority"
      },
      "germany": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Auto & appliance makers need designers"
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Growing but still niche"
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Design roles exist but not priority"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Consumer-electronics design culture"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Emerging but not strategic"
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Small market, limited roles"
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Vision 2030",
        "reason": "Giga-projects demand world-class design"
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Economy 2030",
        "reason": "Design supports high-end manufacturing exports"
      },
      "uae": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "We the UAE 2031",
        "reason": "Creative industry expansion"
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "94",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry seniors prioritised"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Large consumer-product sector values industrial design"
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "",
        "reason": "Manufacturing hub, limited consultant roles"
      }
    }
  },
  "3d58e6b1-9555-46bc-a3e1-229d983764e6": {
    "career": "Criminological Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Crime-policy research funding available"
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "",
        "reason": "Universities and justice agencies hire researchers"
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Research institutes seek social scientists"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Research councils support limited posts"
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Academic openings exist but scarce"
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Limited but present in justice ministry"
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "",
        "reason": "Government social science research units"
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Some roles in policy think-tanks"
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "",
        "reason": "Home Office & academia fund criminology"
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "",
        "reason": "NIJ and universities fund criminology studies"
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "72ef0667-5e27-4602-9f7a-282b270c5f38": {
    "career": "Global Sport Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Sports-centric economy and frequent global events; still outside CSOL priority occupations."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Growing professional leagues and 2026 FIFA World Cup co-host, yet not on Express Entry priority lists."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Gigantic state funding for sports leagues, events and tourism (e.g., LIV Golf, Riyadh Season) explicitly recruits foreign expertise."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai & Abu Dhabi invest in Formula 1, IPL, UFC and sports tech, attracting global sport managers."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Premier League and frequent mega-events drive private demand, yet Home Office shortage list excludes sports managers."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Massive private‐sector sports market and 2028 LA Olympics create demand, but no dedicated immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "02752f08-e9d6-4a67-a36c-821c79d74008": {
    "career": "Humanities Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "University hiring exists yet Migration Strategy priorities lie elsewhere."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Academic roles possible but Express Entry emphasises STEM and health."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Germany welcomes academics via Opportunity Card, including humanities if applicant scores enough points."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Academic openings exist, but Critical Skills list omits humanities."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Flagship universities value humanities for global rankings, but national priority is tech."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Private universities in Dubai hire liberal-arts faculty; not a strategic immigration priority."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Russell Group universities recruit internationally; Global Talent visa covers arts and humanities scholars."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "",
        "reason": "Universities remain major employers for humanities research despite no specific federal talent policy."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "201826e4-5331-4325-9176-d9f5d039c023": {
    "career": "Primary Education Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Primary and early-childhood educators appear on CSOL and state nomination lists."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Elementary teachers explicitly targeted under French-speakers and education streams."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe shortage of Grundschule teachers; states recruit abroad."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Demand exists, yet Critical Skills list focuses on STEM teachers."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Green List (Tier 2)",
        "reason": "Primary teachers on Tier-2 list offer streamlined Work to Residence path."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Private international schools hire expats, but not a federal priority occupation."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Recent policy removed primary teachers from shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Teacher shortages persist, but no federal immigration pathway dedicated to K-12 educators."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "82d5a73c-0333-4283-a594-45a986e1576d": {
    "career": "Philosophy Lecturer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "53",
        "policy": "",
        "reason": "University sector recruits lecturers on general Skilled visas despite no CSOL listing."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Some tenure tracks open, but not on Express Entry priority list."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Strong humanities tradition; Opportunity Card welcomes academic lecturers."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Openings rare, but universities sponsor General Employment Permits."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "NUS and NTU hire philosophy faculty to boost rankings, though nation focuses on tech."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Private universities in Abu Dhabi/Dubai sometimes seek liberal-arts faculty."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Global Talent visa covers academic faculty; UK universities value philosophy for research rankings."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Hundreds of philosophy departments hire globally via H-1B and O-1 visas."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "26",
        "policy": "",
        "reason": ""
      }
    }
  },
  "002dee6f-df70-43f0-89dc-fcb37f285c67": {
    "career": "Political Advisor",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "EU think-tanks in Berlin hire specialists, yet language and citizenship often required for government roles."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Government programmes contract foreign policy consultants for economic diversification and global positioning."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "GovTech and economic agencies contract foreign policy researchers for regional analysis, though citizen preference applies."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "UAE Centennial 2071",
        "reason": "Strategic policy units and royal courts bring in global advisors on energy, trade, and diplomacy."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Think-tanks and consultancy firms sponsor visas, though official civil-service roles reserved for nationals."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Campaigns and think-tanks hire globally using O-1 for individuals with extraordinary ability."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "00ee002b-152f-478c-918e-3d0aeeceadf7": {
    "career": "Biologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Biotech roles exist but are outside the core skills occupation list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "STEM stream welcomes biologists but they are not on priority shortage lists."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Pharma and bioeconomy clusters seek researchers; fast-track visas for STEM graduates."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Biopharma research ambitions exist, yet hiring is early-stage and small-scale."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Biomedical scientists and biologists are on the critical list to support pharma exports."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points favour life-science PhDs but no dedicated shortage category."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan highlights biotech and pharma manufacturing; labs import foreign scientists."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Migrant Category",
        "reason": "Limited but growing biotech research, mainly in agri-life sciences."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Vision 2030",
        "reason": "Government funds emerging biotech parks, yet talent demand still modest."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Economy 2030",
        "reason": "Biopolis and A*STAR aggressively recruit global biologists for biomedical R&D."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai Science Park and Abu Dhabi BioHub recruit researchers but not formal shortage."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life sciences is a named pillar; visas and grants aggressively court biologists."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds biomanufacturing, ARPA-H and NIH grants expand demand for life-science researchers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "National Master Plan 2021-2030",
        "reason": "Biotech is strategic but ecosystems still nascent; few research openings."
      }
    }
  },
  "14c6b8b5-b4d2-4ff6-8078-4edd62b404ce": {
    "career": "Composer",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Booming local film and music scenes but no formal immigration incentives."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on critical list; niche openings in film-friendly tax incentive projects."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Anime and game industries need music but no special visa priority."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Massive investment in entertainment, live shows and film production creates high demand for composers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Singapore Economy 2030",
        "reason": "Creative cluster exists yet not a national priority; niche advertising work."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi media cities commission original music for adverts, films and events."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries named a growth sector; London’s scoring stages and game studios hire composers."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "No direct policy, but Hollywood and gaming industries sustain private demand for original scores."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "fd2db72b-dc7f-4852-b769-9ae8eef3316f": {
    "career": "Electrical-Biomedical Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Electrical engineers are on CSOL; biomedical specialty is welcome within health-tech firms."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "STEM fast-track covers biomedical and electrical engineers but not singled out."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Medical-device clusters in Bavaria and Baden-Württemberg recruit foreign biomedical engineers."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "RPJPN 2025-2045",
        "reason": "Healthcare expansion exists but engineering shortage lists favour EV and infrastructure."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Med-tech engineers top the list to support Galway and Limerick device factories."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP favours robotics & med-device engineers for ageing-society solutions."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan names medical devices as growth area; Penang factories hire biomedical talent."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 2)",
        "reason": "Electrical engineers listed; hospital device projects add niche biomedical demand."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "New hospitals and med-tech parks need engineers but policy focus is broader healthcare."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Singapore Economy 2030",
        "reason": "Biomedical manufacturing is a national pillar; EDB offers fast passes for med-tech engineers."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Operation 300bn",
        "reason": "Industrial strategy includes medical devices; visas available but not shortage-listed."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences pillar funds med-tech; Skilled Worker visa covers biomedical engineers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA subsidises med-tech manufacturing and R&D, boosting demand for biomedical engineers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Focus on semiconductors; med-tech growth early-stage."
      }
    }
  },
  "d57a17ab-a83f-4d23-9e6e-09529ce41d30": {
    "career": "Musicologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Migration Strategy 2023",
        "reason": "Universities hire international academics, yet musicology is not shortage-listed."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Humanities PhDs can immigrate but not priority; limited tenure-track roles."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Strong funding for cultural research; German universities value international musicologists."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on critical list; occasional positions in conservatoires."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Universities sponsor humanities researchers; ethnomusicology interest in traditional arts."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Few specialist roles; immigration points available but competition tough."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Arts faculties expanding yet still small; roles tied to heritage music projects."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "41",
        "policy": "Singapore Economy 2030",
        "reason": "Universities hire selectively for Southeast Asian music studies; not a policy priority."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "We the UAE 2031",
        "reason": "New universities and cultural institutes recruit humanities faculty occasionally."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry university courses attract funding; Global Talent Visa supports researchers."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "CHIPS and Science Act",
        "reason": "No direct provision; universities independently sponsor arts researchers via H-1B-cap exempt visas."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "bf97460e-902b-416a-b0c9-26529ac3e3c3": {
    "career": "Research Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Civil engineers on CSOL; universities and CSIRO recruit research talent."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Civil engineers are invited through STEM streams but research roles less prioritised."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Focus on sustainable construction and rail upgrades needs research engineers."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "New capital Nusantara and huge infrastructure push need research on tropical materials."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Civil engineers on list; research posts in universities and offshore wind sector."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Highly Skilled Professional visa",
        "reason": "Aging infrastructure and earthquake tech labs recruit foreign researchers."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Large rail, port and flood-mitigation projects require civil R&D."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 2)",
        "reason": "Seismic-resilient building research attracts foreign civil engineers."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Mega-projects like NEOM and The Line fund large R&D labs for future-city infrastructure."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Green Plan 2030",
        "reason": "Limited land but ongoing deep-tunnel and reclaimed land R&D keep some roles open."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Operation 300bn",
        "reason": "Smart-city and sustainable construction initiatives need civil research specialists."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean-energy and HS2 rail drive demand for advanced civil engineering research."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA funds R&D on resilient materials and smart infrastructure, boosting civil research roles."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "National Master Plan 2021-2030",
        "reason": "Transport and offshore wind expansion create research niches but not top-tier."
      }
    }
  },
  "d9da849d-f770-4209-b739-c566774c09dc": {
    "career": "Journalist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "24",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "We the UAE 2031",
        "reason": "Dubai seeks senior creative & media talent for global content hubs, but numbers remain small."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry seniors listed, yet visa routes competitive and limited."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Large private media market and O-1 visa path, but no federal talent-shortage policy for journalism."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "22",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4be606db-5194-41d3-add8-f6e1bc50d5e9": {
    "career": "Content Writer",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Dubai content hubs hire English writers, but supply is ample and freelance visas costly."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Creative sector large but sponsorship rare; not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Huge marketing sector creates demand but no federal shortage designation."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4ccab7b8-7e26-4177-9ea8-53882cdbfad2": {
    "career": "Product Designer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Migration Strategy 2023",
        "reason": "Core Skills list values manufacturing engineers; designers adjacent and sometimes sponsored."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "No explicit priority but consumer-product firms recruit via standard Express Entry."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Strong automotive and consumer-goods sectors need industrial design blended with engineering."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Med-tech assembly plants occasionally sponsor design talent."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Highly Skilled Professional visa",
        "reason": "Automotive and consumer electronics value design-engineers; language a hurdle."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Growing EV and appliance clusters creating moderate demand for design skills."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Manufacturing 2030",
        "reason": "Precision-engineering hub uses product designers for med-tech and electronics prototypes."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Manufacturing base small; design work outsourced."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry seniors and EV/aerospace manufacturing seek experienced industrial designers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Advanced manufacturing resurgence demands industrial designers for EVs, medical devices and consumer hardware."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "6afd3bd4-2245-467b-ba85-a68775d9b75f": {
    "career": "Data Science Innovator",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Migration Strategy 2023",
        "reason": "Software, cyber and data roles high on Core Skills list."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "AI/ML explicitly prioritised in category-based Express Entry draws."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialists have relaxed visa rules, including AI."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech and EV supply-chain need data talent, yet bureaucracy stiff."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "81",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Data scientists and AI engineers explicitly listed for fast permits."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Highly Skilled Professional visa",
        "reason": "AI/ML researchers get points-based fast track."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "MADANI Economy",
        "reason": "Industry 4.0 and fintech growth spur moderate AI demand."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Green List covers software engineers; AI specialism indirectly helpful."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "National AI centre and NEOM recruit global data talent."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "National AI Strategy 2.0",
        "reason": "Government aims to triple AI talent pool; Tech.Pass eases entry."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi free zones give Golden Visas to AI experts."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital/AI shortage list; Global Talent visa fast-tracks data scientists."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Massive funding for AI, semiconductor R&D and advanced analytics."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "AI engineers needed for e-commerce/fintech but visas limited."
      }
    }
  },
  "5d9c623a-c12d-42df-9aff-4355cfaa6983": {
    "career": "Green Chemistry Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Chemical and environmental engineers on skills list; green process R&D encouraged."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Environmental scientists and chemists invited under STEM stream."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Energy transition drives demand for sustainable chemistry in industrial clusters."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "RPJPN 2025-2045",
        "reason": "Nickel and battery sector exploring cleaner processes; few research visas yet."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Biopharma and med-tech manufacturing need sustainable process chemists."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Chemical companies pivot to green materials; points-based visa eases PhD entry."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Focus on specialty chemicals and EV supply chain opens niche for green chemistry."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Limited but growing biotech and clean-tech research funding."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Vision 2030",
        "reason": "Petrochemical giants fund CO₂-free processes and green hydrogen research."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Singapore Green Plan 2030",
        "reason": "Petrochemical hub funding carbon-neutral pathways; A*STAR recruits sustainable chemists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Operation 300bn",
        "reason": "Clean-tech and green materials part of industrial diversification."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "81",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean energy and life-sciences R&D receive grants, visas for chemists fast-tracked."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds non-toxic, low-carbon materials and battery chemistries."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Government eyes green manufacturing, but R&D budget modest."
      }
    }
  },
  "2ad5d5c8-779c-4179-ac36-b12bf7f57b33": {
    "career": "Astrophysicist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Global Talent visa welcomes space researchers but astronomy is not on the Core Skills Occupation List."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "STEM PhDs score maximum CRS points and qualify under the 'French or STEM' category, easing permanent residence."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Law streamlines residence for researchers; Max Planck & ESO repeatedly recruit astrophysicists."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List omits astrophysics, but Science Foundation Ireland funds limited astronomy posts."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "NAOJ and JAXA hire foreign PhDs; HSP visa awards maximum points for publications."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "University lecturers earn high points but astrophysics is absent from Green List priority roles."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Economy 2030",
        "reason": "Small astronomy groups at NUS/NTU; not a national priority but Employment Pass is obtainable for top researchers."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "UAE Centennial 2071",
        "reason": "UAE Space Agency funds some deep-space missions, yet openings are limited and highly competitive."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 highlights space science R&D; Global Talent visa specifically lists astrophysics researchers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "CHIPS and Science Act",
        "reason": "Act injects billions into NSF and NASA astrophysics grants; O-1/H-1B research categories fast-track PhD scientists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "eebe0c79-3370-4e8e-83e4-f214c7a64ffe": {
    "career": "Brand Management Educator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "University Lecturer (nec) remains on medium-long term list, allowing sponsorship."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Academics with PhDs earn CRS bonuses even if marketing isn’t a listed priority."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Act facilitates residence for professors, but marketing is not shortage field."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Lecturer roles can be sponsored but marketing is not on critical list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Lecturers gain points but face limited slots in business schools."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry focus helps, yet business-school hiring is steady not priority."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct tie, but U.S. universities hire international marketing faculty under H-1B cap-exempt rules."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "0102d045-6c07-47a4-834d-31fc4d69a5f9": {
    "career": "AI Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Migration Strategy 2023",
        "reason": "Software developers, cyber and data analysts—AI roles qualify for direct permanent residency pathways."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "New tech-talent streams give two-week work permits and fast PR for AI and data scientists."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Blue Card salary floor cut for IT specialists; AI hubs in Munich and Berlin hiring aggressively."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "RPJPN 2025-2045",
        "reason": "‘Digital Indonesian’ pillar funds AI centres for fintech and e-commerce; visas available but bureaucracy heavier."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Software engineers and data scientists are critical skills with stamp-4 residency after two years."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Highly Skilled Professional visa",
        "reason": "AI researchers get maximum points; salary bonuses and accelerated permanent residency."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan prioritises Industry 4.0 and AI adoption; Digital Nomad Visa launched for data/AI workers."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Migrant Category",
        "reason": "Software engineers including AI are on Green List Tier 1 with automatic residence after two years."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "National Strategy for Data & AI funds NEOM tech clusters and major AI talent imports."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "National AI Strategy 2.0",
        "reason": "AI/ML engineers are explicit Tier 1; Tech.Pass and ONE Pass give five-year visas for top talent."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Operation 300bn",
        "reason": "Golden Visa lists AI specialists; government aims to triple AI’s GDP share by 2031."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 names AI, semiconductor and cyber as flagship sectors; Global Talent Visa fast-tracks experts."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Bill pours USD 52 B into advanced computing and funds thousands of AI/ML research and fab jobs."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Strategy calls for 50k AI engineers by 2030 to support chip design and smart manufacturing."
      }
    }
  },
  "5f9201cc-62a3-48b1-a0a9-b90dc2534e4d": {
    "career": "Health Promotion Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Aged-care and preventive-health positions qualify under broader healthcare occupation codes."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Healthcare workers category welcomes public-health professionals, easing PR with lower CRS cut-offs."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Public-health graduates can get EU Blue Card; demand rising for preventive medicine experts."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List omits health promotion, but HSE sponsors with case-by-case permits."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "SSW covers nursing care, not preventive health; opportunities exist only in English-language NGOs."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Skilled Migrant Category",
        "reason": "Public-health advisers earn high points and are often sponsored by DHBs."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Obesity and lifestyle diseases drive demand for community health workers in mega-projects like NEOM."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Green Plan 2030",
        "reason": "HealthySG preventive initiative could sponsor specialists, but locals preferred."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Government targets preventative care; visas available but role not formally prioritised."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "NHS recruits public-health practitioners via skilled-worker visa though not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Community health programmes get new funding but role is not an immigration shortage occupation."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "6a805a48-8559-4e0a-950c-3d0f4e9e2bcd": {
    "career": "Integrated Designer",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Points-based card allows creative professionals if they score high on experience and language."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Megaprojects need branding and experience design for tourism and sports events."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Dubai Media City and Expo city hire senior designers; talent visas available for creatives with awards."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries (film, gaming) are flagship sectors, driving demand for multidisciplinary designers."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Creative roles not targeted, but U.S. design agencies sponsor proven talent on O-1 visas."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "16691262-5464-4cfd-949d-fcc1ea19bcbf": {
    "career": "Project Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Civil/electrical engineers and construction project managers are priority shortage roles on the CSOL."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Construction managers and transport-infrastructure engineers receive additional CRS points due to housing and transit backlogs."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Civil and mechanical engineers qualify for fast-track residence as Germany renovates rail, roads and renewables."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital Nusantara plus EV and port megaprojects create headline demand for project engineers."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Some civil engineers invited, but total quota small and construction slowdown lowers urgency."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "SSW covers construction trades rather than white-collar project engineers; limited HSP demand."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Focus is on factory automation; civil project engineering only indirectly supported."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Civil engineers are on the Green List for expedited residence to rebuild cyclone-damaged infrastructure."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Vision 2030",
        "reason": "Gigaprojects such as NEOM, Red Sea and Qiddiya urgently hire project engineers for multi-billion-dollar builds."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Singapore Green Plan 2030",
        "reason": "Limited land means fewer large civil builds; project engineering roles exist but not priority."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "We the UAE 2031",
        "reason": "New rail, ports and industrial zones raise steady demand, but Emiratisation keeps scores below Tier-1."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Only niche advanced-manufacturing projects; general construction engineering no longer on shortage list."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "USD1.2 trillion infrastructure spend creates sustained demand for engineers to plan and deliver bridges, transit, power and broadband projects."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National Master Plan 2021-2030",
        "reason": "Massive highway, airport and power-plant buildout needs multidisciplinary project engineers, but visa processes still evolving."
      }
    }
  },
  "f1ca6567-4ee5-492f-8345-4d496401f7df": {
    "career": "Epidemiologist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "State nomination lists include public-health academics; pandemic preparedness keeps steady demand."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Public-health scientists gain extra points under health-priority streams, though not explicitly named."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Hospitals need infection-control experts but lack a dedicated visa code for epidemiologists."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Epidemiology units expanding post-COVID but prioritise local Bahasa speakers."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Biomedical and data-analytics professions fast-tracked; Health Service Executive recruits outbreak analysts."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Research posts limited; language barrier restricts field-investigation roles."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "Government discusses disease-surveillance upgrades but concrete hiring plans small."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Small research sector; roles exist mainly within universities, limiting immigration slots."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "New public-health authority and digital health push seek disease-surveillance specialists."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "National AI Strategy 2.0",
        "reason": "Genomic-surveillance and pandemic-preparedness hub seeks data-savvy epidemiologists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s DHCC and Abu Dhabi’s ADPHC invest in outbreak analytics talent."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences priority includes population-health research; NHS shows chronic shortage of epidemiologists."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "",
        "reason": "NIH and CDC fund large-scale disease-surveillance programs; H-1B STEM quota often unused for public-health PhDs."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Public-health funding modest; few openings for foreign specialists."
      }
    }
  },
  "ddb773a5-3000-4c0f-9c05-8756fa6c6cbc": {
    "career": "Geologist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Iron-ore, lithium and rare-earth mining giants offer visas and fast PR to geologists."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Battery-metal exploration in Ontario and Quebec places geologists on provincial priority lists."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Need for geothermal and hydrogen storage mapping, but bureaucracy slows hiring."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel, cobalt and copper mines expand to feed EV battery supply chain."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "",
        "reason": "Small-scale zinc and quarry operations; few visas for geologists."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "Some demand for geothermal and earthquake research but language barrier high."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Tin and rare-earth exploration revived for semiconductor supply chain."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Some geothermal roles, yet total mining sector small."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Ma'aden expansion and mineral-strategy pivot require exploration geologists."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Operation 300bn",
        "reason": "Limited natural-resource sector; geologists mainly in niche groundwater studies."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "North Sea decommissioning offers some roles but immigration priority low."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Funding for critical-minerals exploration and carbon-storage projects boosts demand for field geologists."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National Master Plan 2021-2030",
        "reason": "Rare-earth mining in Northern Highlands needs foreign geologists."
      }
    }
  },
  "3d12a491-f2e8-4981-8f05-b39dd3c1e3d3": {
    "career": "Digital Marketing Director",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Mega-tourism and entertainment projects need senior digital marketing talent."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "Creative-media covered, but high local talent pool keeps role Tier-3."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "We the UAE 2031",
        "reason": "Dubai positions itself as MENA media hub; senior creatives fast-tracked through Golden Visa."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry visas cover senior digital content leaders, though quotas limited."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "No national visa priority, but market size offers private-sector demand."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "3a731dbc-d596-45b7-9bf3-c27f13fbdacd": {
    "career": "Electronic Systems Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Electrical/electronic engineers are long-term skills shortages."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Chip design and EV battery plants seek electronics engineers under STEM stream."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Automotive and industrial mechatronics firms race for electronics systems talent."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Focus on battery, less on complex electronics; limited demand."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Medtech and chip-design multinationals actively sponsor electronic systems engineers."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics and semiconductor giants (TSMC Kumamoto) headhunt foreign electronics engineers."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Penang’s electronics cluster and new wafer-fab projects list electronics engineers as critical."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Niche avionics and defence electronics roles; small market keeps score lower."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Vision 2030",
        "reason": "Defence electronics growing but localisation priorities limit foreign hiring."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Manufacturing 2030",
        "reason": "Precision-engineering and chip-packaging plants urgently need electronic systems engineers."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Operation 300bn",
        "reason": "Some demand in space and drone tech; overall market limited."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Semiconductor specialists and defence electronics engineers on shortage list."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "USD280 billion incentives for semiconductor R&D and advanced electronics boost demand for systems engineers."
      },
      "vietnam": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Government targets 50,000 chip engineers by 2030; aggressive visa incentives offered."
      }
    }
  },
  "c48b7bb4-4ff8-429b-b25a-04d562ca6453": {
    "career": "English Lecturer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Universities can nominate lecturers via employer-sponsored visas even though the job is absent from CSOL."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Post-secondary institutions recruit foreign lecturers and Express Entry rewards advanced degrees and teaching experience, yet the occupation is not on targeted shortage lists."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Points for advanced degree, language skills and experience make the new card a realistic route for university teaching staff."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "",
        "reason": "Third-level colleges sponsor permits; advanced degrees score highly even if the role is absent from Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Universities employ foreign English faculty under Instructor/Professor visa, but quotas are limited."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Tertiary educators can gain work visas, but only STEM teachers appear on the Green List."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Private universities hire expatriate faculty, but humanities teaching is not in any priority list."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "We the UAE 2031",
        "reason": "Branch-campus universities hire expatriate lecturers, but no dedicated immigration fast-track exists."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Universities sponsor Skilled-Worker visas for lecturers, although the role is not on the Shortage List."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "",
        "reason": "Universities regularly sponsor H-1B and J-1 visas for English composition and ESL lecturers, but the role is not a federal talent-shortage priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "0922fafa-6d93-4366-9501-6ecfceb18c05": {
    "career": "UX Designer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "",
        "reason": "Tech employers sponsor designers through Temporary Skill Shortage visas outside the CSOL."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Digital-tech expansion values UX talent; no formal shortage code but easy entry via Global Talent Stream."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Points-based system favours IT and design professionals with degrees and experience."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Digital services boom fuels some demand though not listed as a strategic shortage."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "While UX isn’t individually named, tech multinationals in Dublin obtain critical-skills permits for digital designers."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Points system rewards design-tech talent but language barrier keeps volume low."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "MADANI Economy",
        "reason": "E-commerce and fintech growth create openings, yet the occupation is not on priority lists."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Design roles exist in digital product firms but are not on the Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Massive tourism and smart-city projects need UX, yet localisation rules limit blanket recruitment."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "National AI Strategy 2.0",
        "reason": "AI-driven product companies hire UX talent; COMPASS framework assigns bonus points for tech roles."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "UAE Centennial 2071",
        "reason": "Fintech and e-commerce hubs in DIFC/ADGM actively import UX specialists."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital and creative industries backfill UX talent through Skilled-Worker visas."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "CHIPS and Science Act",
        "reason": "Booming hardware-software ecosystems drive demand for product and interface designers, although not explicitly listed as a shortage occupation."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National Master Plan 2021-2030",
        "reason": "Startup ecosystem needs UX but government prioritises semiconductor and AI engineers."
      }
    }
  },
  "b5e02922-cfb0-41e1-9a10-34dd40b2325c": {
    "career": "Community Support Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Aged-care reforms create vacancies, yet position is not on Core Skills list."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Care-economy expansion and provincial nominee programs actively recruit social-service and settlement workers."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Shortages in elder and youth care allow easier recognition of social-work degrees."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Limited quotas; priority given to nurses and medical social workers."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "SSW nursing-care category accepts support staff after language exam."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Some NGOs sponsor visas, but role not on Green List."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Growing mental-health and social-care demand, but no national visa priority for community workers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "f1941626-fb81-401e-a500-058aa2bc4360": {
    "career": "Jazz Studies Professor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Universities sponsor visas but performing-arts roles are not on CSOL."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Few specialised jazz faculty openings; possible through employer-specific LMIA exemption for arts professionals."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Music Hochschulen hire international professors; points system recognises artistic excellence."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Jazz schools in Tokyo hire foreign faculty under Instructor visa, but Japanese fluency preferred."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Yong Siew Toh Conservatory hires foreign faculty, but humanities not on priority lists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Private arts institutes occasionally import jazz faculty, but numbers are small."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Royal Academy and conservatoires sponsor visas for specialist professors despite no formal shortage designation."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Conservatories and liberal-arts colleges sponsor O-1 or H-1B for distinguished musicians, but music academia is niche."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "793d9884-9abd-4f69-9867-a4b3f0b40f4f": {
    "career": "Chemistry Lecturer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "",
        "reason": "STEM lecturers sponsored by universities, though not explicitly on CSOL."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities leverage streamlined work permits to recruit PhD chemists into lecturer and researcher roles."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Acute shortage of science faculty; Act eases residence permits for PhD chemists."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "RPJPN 2025-2045",
        "reason": "Resource-processing industrialisation needs chemistry educators, though hiring numbers remain small."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma corridor around Cork and Galway drives university demand for chem lecturers/researchers."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "Category grants fast-track residency to PhD chemists joining universities."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Advanced materials and specialty-chem goals increase need for chemistry educators."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Universities sponsor work visas; STEM lecturers align with research-commercialisation agenda."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Growing research universities and petrochemical R&D labs create moderate demand."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Economy 2030",
        "reason": "Biomed and advanced-materials clusters partner with universities, attracting overseas chem lecturers."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Operation 300bn",
        "reason": "Khalifa University and petrochemical clusters import chemistry faculty for R&D programmes."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences R&D push funds chemistry departments and eases Skilled-Worker visa sponsorship."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Massive federal STEM funding boosts hiring of chemistry faculty for research and teaching."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National Master Plan 2021-2030",
        "reason": "Pharma and semiconductor sectors push universities to hire foreign STEM faculty."
      }
    }
  },
  "8d7077e3-1228-4458-ae92-3539a8a6cae6": {
    "career": "Digital Media Instructor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Migration Strategy lists secondary STEM teachers; creative-arts lecturers get only discretionary visas."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Express Entry favours STEM teachers, not post-secondary media instructors; possible via general skilled stream only."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Fachkräftegesetz eases university hiring, yet shortages focus on engineering and nursing, not arts educators."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Critical Skills List ignores arts academics; standard researcher visa possible with employer sponsorship."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s media free zones value training, yet visa priority is for senior creators, not lecturers."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "University lecturers are eligible for Skilled-Worker visas but not on temporary shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Universities hire design faculty, but teaching roles are not covered by industrial-subsidy legislation."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "03d6f27c-f5f8-4ae4-b192-06a5bcfe88b1": {
    "career": "International Relations Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Higher-education sector can sponsor Global Talent visas for social-science researchers."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities use streamlined work permits for research faculty."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Opportunity Card awards points for PhD holders in research."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Universities can issue Hosting Agreements that bypass labour-market tests."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Highly Skilled Professional visa",
        "reason": "Points system values publications, yet social-science funding is limited."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "NIMP 2030 targets industrial tech research, not social science."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Universities can sponsor, yet role absent from Green List priorities."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Growth of policy institutes around NEOM opens limited slots for foreign researchers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "",
        "reason": "Universities and S. Rajaratnam School offer research passes for geopolitics specialists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "UAE Centennial 2071",
        "reason": "Abu Dhabi think-tanks recruit internationally but no fast-track scheme."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Academic researchers benefit from salary-based fast-track visas though not on shortage list."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "",
        "reason": "Universities and think-tanks hire foreign PhDs under H-1B cap-exempt research visas."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "69c9c244-26b6-4490-8db1-743968907880": {
    "career": "Religious Studies Professor",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Higher-Education sector can nominate professors for Employer-Sponsored visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Strategy supports global academic recruitment even in humanities."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Points for PhD and German proficiency allow smooth entry for lecturers."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Hosting Agreement streamlines immigration for researchers."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Highly Skilled Professional visa",
        "reason": "Buddhist-studies programmes hire, but limited positions and Japanese fluency needed."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "",
        "reason": "No shortage listing; individual university sponsorship required."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Vision 2030",
        "reason": "Islamic-studies faculty are hired, but localisation policies tighten quotas."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "",
        "reason": "National universities fund Asian-religion research and grant EP passes."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "UAE Centennial 2071",
        "reason": "Private universities recruit religion scholars for comparative courses."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "",
        "reason": "Universities can sponsor; humanities not on shortage list but high salary eases process."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "",
        "reason": "Universities freely sponsor humanities faculty under uncapped research visas."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      }
    }
  },
  "6e02030d-b658-44c1-85c5-26da927698b5": {
    "career": "Financial Accountant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "CSOL gives only regional demand for external auditors, not generic accountants."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Express Entry points moderate; occupation not in category-based priority list."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Possible with Ausbildung equivalence but not a shortage occupation."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Growing IPO pipeline needs CAs yet localisation rules apply."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Financial services growth in Dublin keeps demand for chartered accountants."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Islamic finance expansion opens roles, but no fast-track for foreigners."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Green List excludes accountants; standard work visa route."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Vision 2030",
        "reason": "Fintech and IPO surge demand IFRS-fluent accountants."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Singapore Economy 2030",
        "reason": "Push for sustainable finance raises demand for global accountants specialized in carbon reporting."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai DIFC courts global CPAs for regional financial-services hub."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Senior accounting on IS-8 priority; Big Four actively sponsor visas."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Accountants not covered by industrial acts; H-1B possible but competitive."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Foreign accountants hired in multinationals, not nationally prioritised."
      }
    }
  },
  "f11f7ecc-e28b-4011-b2ef-d03dbafc66c0": {
    "career": "Healthcare Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Aged-care reforms require advisory talent in operations and quality."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Healthcare system expansion values management experts though not explicitly listed."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Hospitals hire foreign consultants for digitalisation and efficiency projects."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Universal health-cover reforms need advisors, but foreign hiring restricted."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "HSE modernisation plans create advisory roles; employer sponsorship required."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Private hospital expansion creates some demand, but no fast-track visas."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Health NZ restructuring opens management-consulting contracts, but role not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Vision 2030",
        "reason": "Mega-hospital and medical-city projects aggressively import healthcare strategists."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Singapore Green Plan 2030",
        "reason": "Consultants support ageing-population initiatives though not in top demand list."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Abu Dhabi and Dubai target world-class healthcare systems, recruiting consultants for JCI accreditation."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "NHS hires management consultants, but immigration priority now on life-science R&D rather than services."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Digital health infrastructure funding drives demand for strategy consultants."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Healthcare PPP projects hire consultants, yet local expertise preferred."
      }
    }
  },
  "3f62beeb-1681-4191-bea2-ef6b99876a4c": {
    "career": "Visual Arts Instructor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Secondary teachers are on CSOL but STEM is preferred; arts teachers can still obtain points with state sponsorship."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "K-12 teachers are on several Provincial Nominee lists, though arts subjects rank below STEM."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Qualified teachers qualify for Blue Card; shortage greatest in STEM but arts vacancies exist."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Skilled Migrant Category",
        "reason": "Chronic teacher shortages across subjects mean registered arts teachers can obtain points though not on Green List."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Art & design teachers are outside current shortage list but schools still issue visas when unable to hire locally."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "General academic roles remain eligible for O-1/H-1B but arts teaching is not a named national priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "cdd7b5ff-2dc6-4f69-818b-6b0581b8f963": {
    "career": "Theoretical Computer Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Universities seek researchers for ARC Centres of Excellence in quantum and algorithms."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Pan-Canadian AI strategy funds theoretical CS chairs and grants; Global Talent Stream fast-tracks visas."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Max Planck and TU systems hire Blue Card holders in theoretical informatics and cryptography."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Science Foundation Ireland funds algorithmic research aligned with big-tech EMEA HQs."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Highly Skilled Professional visa",
        "reason": "RIKEN and NII recruit for quantum algorithms and formal verification."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Small academic market but universities grant research visas for computing theory groups."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "KAUST funds pure CS research as part of AI push, though fewer positions."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "National AI Strategy 2.0",
        "reason": "A*STAR and NUS fund algorithmic game theory and formal methods groups; EP passes streamlined."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "UAE Centennial 2071",
        "reason": "MBZUAI and ADIA research labs recruit theoreticians in algorithms and cryptography."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "UKRI and Alan Turing Institute back foundational computer science; Global Talent visa covers academia."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Government pouring billions into fundamental computing research, quantum algorithms and complexity theory."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "0e151a4a-c5a1-4d6a-9de1-7939132cf7a8": {
    "career": "Gallery Curator",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Berlin and Munich museums hire international curators under Blue Card for cultural sector strength."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Curators outside critical list; roles limited."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Cultural institutions prefer Japanese language expertise; few foreign curator jobs."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Small market; few roles justify visa sponsorship."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Giga-projects (AlUla, Diriyah) aggressively recruit global museum and heritage curators."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Singapore Economy 2030",
        "reason": "National Gallery occasionally recruits international talent but role not in strategic lists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Louvre Abu Dhabi and other cultural districts hire foreign curators to boost creative economy."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries named pillar; museums seek specialised curators though sponsorship budgets vary."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Arts and culture grants exist but not a talent-shortage priority; O-1 visas possible for distinguished curators."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b0d6ef6c-23e7-4f63-841e-cab0256b29b1": {
    "career": "Computer Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Computer scientists and software devs firmly on CSOL with points advantages."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Category-based Express Entry prioritises software & AI talent; numerous research grants."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialists fast-tracked even without degree if skills verified; strong demand in automotive and industrial sectors."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech and e-commerce scale-ups import experienced CS talent."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Software & data roles dominate MNC campuses around Dublin and Cork."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Highly Skilled Professional visa",
        "reason": "Tech talent points system favours CS degrees and salary levels."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "NIMP 2030",
        "reason": "Push for semiconductor and Industry 4.0 drives need for computer scientists."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Software engineers on Green List; pure research roles fewer but visas available."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "NEOM and fintech initiatives hire AI and data scientists."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "National AI Strategy 2.0",
        "reason": "EP Complementarity Assessment points favour AI & CS PhDs; demand high in finance, biotech, defence tech."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Operation 300bn",
        "reason": "Golden Visa for tech professionals; demand across fintech, AI labs, government."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital & AI pillar names computer science as critical; Global Talent visa custom-built."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Massive funding for AI, semiconductor R&D and advanced computing demands computer scientists across academia and industry."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Growing AI and chip sectors seek senior CS expertise."
      }
    }
  },
  "fcdabdc7-854b-4051-bde3-7c50892518c9": {
    "career": "Hospitality Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Hospitality managers removed from priority lists; temporary visas possible but limited PR pathways."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Some provincial streams target tourism supervisors in Atlantic and rural areas."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Focus on trades and IT; hotel managers rarely sponsored."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Bali and new capital Nusantara recruit foreign expertise for upscale hotels."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Hotel staff on SSW; managerial roles possible after in-country promotion."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "MADANI Economy",
        "reason": "Tourism sectors recover but focus on local talent."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Skilled Migrant Category",
        "reason": "Hospitality roles mostly filled by working-holiday staff; manager visas possible but low points."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Mega tourism projects need experienced managers for luxury resorts and heritage sites."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Singapore Economy 2030",
        "reason": "Service sector EP quotas tightened; only ultra-luxury chains hire foreign GMs selectively."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi expand upscale hotels and grant five-year Green Visas to experienced managers."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "035ffbbb-15e8-4787-b527-31d96ee98deb": {
    "career": "Environmental Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Environmental and civil engineers regularly appear on state nomination lists for major infrastructure and mine-rehab projects."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Role falls under engineering occupations frequently invited for permanent residency."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Renewable-energy and wastewater engineers are priority to hit 2030 climate targets."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "63",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel & EV boom mandates environmental remediation specialists."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Civil/environmental engineers invited for new wastewater and data-centre cooling projects."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "67",
        "policy": "Highly Skilled Professional visa",
        "reason": "Renewable-energy and smart-city programmes recruit environmental engineers with point-based fast track."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Heavy focus on green manufacturing and river-clean up initiatives."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Listed under civil & environmental engineering for fast-track residence."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Gigawatt-scale solar, desalination and NEOM need environmental compliance specialists."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Green Plan 2030",
        "reason": "Carbon-management, coastal protection and waste-to-energy projects recruit environmental engineers."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "81",
        "policy": "We the UAE 2031",
        "reason": "Net-zero push and mega-projects create strong pull for waste-, water- and air-quality engineers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Offshore wind, hydrogen and nuclear expansion list environmental engineers on shortage registers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Massive funding for carbon capture, water infrastructure and clean-tech drives high demand for environmental engineers."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "National Master Plan 2021-2030",
        "reason": "Offshore wind and LNG projects require EIA and pollution-control experts."
      }
    }
  },
  "39305e8a-b306-4d8b-807b-99e08ab3638f": {
    "career": "Illustrator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Illustration not on Core Skills list; some state visas possible for senior animators."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Creative roles occasionally invited but not priority."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Points system allows artists, but no shortage preference."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "41",
        "policy": "Asta Cita",
        "reason": "Creative economy is growing but prioritises local talent under 'Bangga Buatan Indonesia'."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on critical list; limited by portfolio-based hiring."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "47",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "No direct path; some anime studios sponsor top talent."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "MADANI Economy",
        "reason": "Creative roles encouraged domestically but not immigration priority."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Creative arts receive few points and rare employer sponsorship."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Cultural and entertainment push hires illustrators for theme parks and media hubs."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Singapore Economy 2030",
        "reason": "Illustrators only qualify under broad EP framework, no priority list."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "We the UAE 2031",
        "reason": "Dubai Media City seeks illustrators for gaming, advertising and ed-tech content."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries visa routes favour experienced illustrators in film, TV, publishing."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "No direct policy linkage, but O-1 visa keeps niche creative talent pathway open."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Strategy focuses on tech manufacturing, not arts."
      }
    }
  },
  "99b20942-4e4c-49ce-8f1c-69d959caabb2": {
    "career": "Chemical Biology Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Medical research institutes sponsor PhD scientists through Global Talent visa."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Biotech researchers get priority work permits under Global Skills Stream."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Points system favours PhD scientists in pharma clusters like Munich and Heidelberg."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "RPJPN 2025-2045",
        "reason": "Biopharma is listed but local talent is prioritised over foreign PhDs."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma corridor needs chemical biologists for biologics and vaccine lines."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Highly Skilled Professional visa",
        "reason": "Biotech and regenerative-medicine labs offer fast-track points."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan names pharma and medical devices as growth engines requiring R&D talent."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Some university posts, but limited industrial biotech sector."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "KAUST recruits biotech researchers, yet numbers are small."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "81",
        "policy": "Singapore Economy 2030",
        "reason": "Biomedical research is a flagship; A*STAR offers generous grants to chemical biologists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Operation 300bn",
        "reason": "Start-up biotech scene emerging in Abu Dhabi’s research hubs."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences pillar targets drug-discovery and synthetic-biology researchers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act allocates billions to biotech and life-science R&D centres."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "National Master Plan 2021-2030",
        "reason": "Nascent biotech sector; limited high-end research funding."
      }
    }
  },
  "b798ef42-fa3f-4fed-ae3b-673a09fdd31f": {
    "career": "Finance Quant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Quant finance is niche; some spots via Global Talent visa."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Financial analysts are welcomed but not priority category."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Fin-tech hubs in Frankfurt/Berlin hire but not shortage-listed."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech is targeted but immigration path unclear for quants."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Dublin’s hedge-fund and aircraft-leasing sectors need quant risk analysts."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Highly Skilled Professional visa",
        "reason": "Tokyo’s banks hire quants but focus is on locals with language skills."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "MADANI Economy",
        "reason": "Islamic finance uses quants but prefers domestic talent."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Small financial market; few openings for quants."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Riyadh’s emerging fintech sector recruits risk-model specialists."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "National AI Strategy 2.0",
        "reason": "Sustainable and algorithmic finance roles are explicitly prioritised."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "81",
        "policy": "UAE Centennial 2071",
        "reason": "DIFC and ADGM push to be global quant-trading hubs."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London lists quantitative finance and AI trading as priority skills."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "CHIPS and Science Act",
        "reason": "No direct policy; Wall Street still hires, but immigration is standard H-1B competition."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "ace84de3-93f2-48e6-b6dd-fe12d77338dc": {
    "career": "Accounting Associate",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Accountants appear on lists intermittently due to local oversupply."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Accountants can qualify under business stream but not targeted category."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "German language & local GAAP limit demand for foreign associates."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "RPJPN 2025-2045",
        "reason": "Local talent surplus for entry accounting roles."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Qualified accountants remain on list due to audit-firm demand."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "MADANI Economy",
        "reason": "Junior roles filled locally; foreign hires need specialised IFRS skills."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Migrant Category",
        "reason": "Qualified accountants get points but associate-level roles rarely sponsored."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Vision 2030",
        "reason": "Saudization prioritises local graduates for junior accounting."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Economy 2030",
        "reason": "EP benchmark salaries make junior accountants expensive to hire from abroad."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "Finance hub hires expat accountants but prefers certified seniors."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Junior accountancy is not on shortage list after 2025 refresh."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct link; routine accounting still eligible via H-1B but not prioritised."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      }
    }
  },
  "31f7bbea-6e0a-458e-8326-604a709b2e74": {
    "career": "International Education Officer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "International education is a top export; strategy encourages overseas staff to grow student numbers."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Roles exist in colleges yet not listed in Category-Based Selection streams."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Universities expanding English courses need mobility officers, but outside Skilled Immigration Act priority list."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Growing international student numbers; limited but present openings."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Universities seek to internationalise, yet role not featured in visa priorities."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "MADANI Economy",
        "reason": "Malaysia markets itself as regional education hub, modest recruitment of foreign officers."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Government promotes study-abroad programmes, yet immigration list focuses on teachers not admin staff."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "New international universities and scholarship schemes create moderate demand for global education specialists."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Universities recruit globally but role is outside National AI/Manufacturing priority lists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "We the UAE 2031",
        "reason": "Dubai/Abu Dhabi position themselves as education hubs and recruit foreign officers."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Universities rely on overseas enrolment; roles available though not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Universities hire for global student recruitment; demand exists but no dedicated immigration channel."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "60ebc94e-dbe8-4009-8eef-5890280b0a52": {
    "career": "NGO Coordinator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Active aid sector, but occupation not on CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Social and community workers stream can cover NGO coordinators."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Many humanitarian NGOs headquartered in Berlin; immigration pathway general."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "We the UAE 2031",
        "reason": "Dubai hosts international foundations but roles competitive."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Many global charities; Skilled Worker visa possible though not priority."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Largest nonprofit market globally; no dedicated visa but roles plentiful."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b7e443cc-4cfb-42e8-8670-b7fea78d9c6c": {
    "career": "Exercise Science Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Sports performance roles fall under health science; Australia invests heavily in elite sport."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Growing university sports science labs; general Express Entry possible."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Bundesliga clubs hire analysts, but immigration list focuses on nurses/engineers."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "High-performance sport NZ hires few foreigners; general visa possible."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Investment in sports leagues creates some analyst demand."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Sports hub hosts events, but role outside Tier-1 lists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Hosting events like IPL, UFC drives need for sports science consultants."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "53",
        "policy": "",
        "reason": "Premier League clubs employ sports scientists; not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Sports analytics booming in pro leagues though not covered by federal talent policies."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4f3dea2e-6c86-433d-9efe-a4803fb4e1b0": {
    "career": "International Relations Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "",
        "reason": "Defense and Indo-Pacific strategy firms employ consultants via general skilled visa."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Think-tanks and government contractors hire but no priority stream."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Berlin policy institutes hire foreign analysts; immigration pathways general."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Corporates need Indo-Pacific risk analysis; HSP covers analysts."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "Mega-projects need geopolitical risk advice for FDI."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "ASEAN policy institutes hire but role not in Tier-1 lists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Dubai think-tanks and sovereign funds seek global affairs advisors."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Consultancies support defence, trade, and City clients on geopolitics."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Geopolitical advisory ties into supply-chain and trade compliance for IRA projects."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a0b7fbaa-5f4a-4c5a-b04c-180f10bdf443": {
    "career": "Sociology Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Academic stream fast-tracks PhD researchers, including social sciences."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities actively recruit social scientists for multicultural studies."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "German research institutes welcome sociologists; EU Blue Card readily issued."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Third-level teaching/research roles supported under Critical Skills permits."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "Select universities seek English-speaking social scientists."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Universities hire but social science not on Green List."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Economy 2030",
        "reason": "Social research on ageing population funded; A*STAR, universities sponsor talent."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Growing federal policy think-tanks need social data analysts."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "UKRI funds large social research, Global Talent Visa covers sociologists."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Large NSF-funded social science projects evaluate IIJA community impacts; universities sponsor visas."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "ccaf5e7a-41b9-49d3-825e-6398725a388b": {
    "career": "Cybersecurity Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Cyber security engineer/analyst on CSOL with 4-year temporary-resident pathways and state sponsorship."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Cybersecurity professionals explicitly prioritised and receive extra CRS points for fast permanent residency."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT-security specialists may enter without degree if experience; eased Blue Card salary thresholds."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Government CERT hiring, but talent drive mainly around EV and energy."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Cyber-security professional explicitly listed; 2-year Critical Skills Permit leads to Stamp 4 residency."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points for cyber talent, but Japanese-language workplace limits broader uptake."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "MADANI Economy",
        "reason": "Cyber-security mentioned as enabling sector, but incentives focus on semiconductors and automation."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Migrant Category",
        "reason": "Not on Green List but earns high ANZSCO points and sector agreements are forming."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Digital-government and fintech projects boost demand yet localisation rules limit foreign hiring."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "National AI Strategy 2.0",
        "reason": "Cybersecurity is a declared core pillar; Tech.Pass and COMPASS points favour senior analysts."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "We the UAE 2031",
        "reason": "National cyber-security council and Golden Visa for specialised tech talent."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital/cyber specialists on Shortage List; fast Skilled-Worker visa with salary concessions."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Critical-infrastructure cyber resilience funding but not listed as a primary talent-shortage occupation."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "National Master Plan 2021-2030",
        "reason": "E-commerce expansion needs security yet no dedicated visa priority."
      }
    }
  },
  "27fcc54c-e9b2-4392-bfb2-3900e75e2066": {
    "career": "Marine Environmental Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Migration Strategy 2023",
        "reason": "Great Barrier Reef restoration projects drive state-nominated visas for marine science specialists."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Blue Economy strategy promotes marine scientists, yet category-based Express Entry not finalised."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "North-Sea offshore wind expansion needs environmental assessments; general STEM visa route applies."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Coral-reef protection within tourism corridors; foreign experts hired on project basis only."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Marine Institute projects offer roles, but not on critical list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Marine pollution and fisheries reform create research grants, but visa categories not tailored."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "MADANI Economy",
        "reason": "Blue economy is an emerging theme; currently limited immigration incentives."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Skilled Migrant Category",
        "reason": "Strong demand in NIWA and fisheries science, but role not on Green List yet."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Red Sea giga-projects require EIA specialists, but Saudization slows foreign hiring."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Singapore Green Plan 2030",
        "reason": "Limited shoreline; focus on urban sustainability over marine research."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Mangrove restoration and coastal tourism spur some demand, not nationally prioritised."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Offshore wind and North Sea decommissioning need marine ecologists; short-term shortage provisions exist."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Coastal resilience and offshore-wind grants fund marine impact studies, but not an explicit shortage occupation."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National Master Plan 2021-2030",
        "reason": "Coastal aquaculture needs science input; domestic graduates preferred."
      }
    }
  },
  "fb23ac97-a929-4d0a-832d-d00d78e981e3": {
    "career": "Psychology Instructor",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Higher-education lecturer on medium-term skill list."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities may fast-track foreign faculty under research streams."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Points awarded for doctorates and teaching experience in shortage regions."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Third-level lecturers qualify for Critical Skills Permit if salary threshold met."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points possible, but Japanese-language instruction limits openings."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "Private universities hire expatriate lecturers on Employment Pass, no priority."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Need exists, but no dedicated Green-List priority."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Economy 2030",
        "reason": "Universities recruit research-active faculty; COMPASS framework rewards PhD talent."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "UAE Centennial 2071",
        "reason": "Private universities recruit foreign faculty, but no special visa concessions."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "University teaching still qualifies for skilled-worker visa though not on shortage list."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "CHIPS and Science Act",
        "reason": "STEM teaching incentives spill into social-science faculty hiring, but not a named priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "989b290d-a39e-4c37-9b88-12369498b118": {
    "career": "Business Psychologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Migration Strategy 2023",
        "reason": "Occupational psychologists possible under Medium-Term list but hiring numbers small."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Role fits under general management consultants; not on targeted lists."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Points route available but companies rarely sponsor."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Talent development handled internally; limited visa pathways."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on list; general work permit available."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Corporate culture limits external consultants; Japanese fluency essential."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "MADANI Economy",
        "reason": "Role exists mainly in multinationals; not prioritised."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Migrant Category",
        "reason": "Low national priority; roles exist in corporate HQs only."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Large transformation projects create need for change-management coaching."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Economy 2030",
        "reason": "COMPASS framework recognises HR specialists, but points competition is strong."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "We the UAE 2031",
        "reason": "Multinationals look for talent-development consultants, but no visa concessions."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Professional psychologists can obtain chartered status and Skilled-Worker visas under health & care codes."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Indirect demand through productivity and change-management in clean-tech firms; no specific visa priority."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Local companies seldom hire external organisational psychologists."
      }
    }
  },
  "36ca9570-76bd-42b4-8fba-769c34252ea7": {
    "career": "Clinical Research Coordinator",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Migration Strategy 2023",
        "reason": "Clinical research associate listed in health-and-science stream for priority visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Healthcare and life-science professionals awarded category points though role not singled out."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Pharma hub needs trial staff; Blue Card available for STEM graduates."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Vaccine and tropical-disease trials create limited niche demand."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma & med-tech cluster in Cork/Dublin; CRC listed under health-associate professionals."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "Government funds regenerative-medicine trials; English-language CRCs welcomed in global studies."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "NIMP 2030",
        "reason": "Growing medical-device trials; MSC status firms sponsor."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Migrant Category",
        "reason": "Small but growing CRO sector; standard visa path."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "New biotech parks in NEOM require clinical trial talent; Green Card-style premium residency offered."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Green Plan 2030",
        "reason": "Biomed city and Health Sciences Authority fast-track trial personnel via Tech.Pass/COMPASS."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai Science Park and Abu Dhabi’s G42 actively sponsor CRCs."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences priority includes clinical trials; shortage occupation concessions apply."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA boosts biotech and NIH funding; life-science clinical talent on fast H-1B cap-exempt routes."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "National Master Plan 2021-2030",
        "reason": "Early-stage biotech trials need coordinators, but local CROs pay modestly."
      }
    }
  },
  "7d0ace25-59e3-4eb9-ae06-2a20c621150f": {
    "career": "Mental Health Counselor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Role is adjacent to listed mental-health nurses and often accepted under community-health ANZSCO codes."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Care-economy and allied-health occupations receive extra CRS points and faster PR processing."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Licensed psychotherapists are explicitly needed; counsellors can qualify once credentials are recognised."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Clinical psychologists included; counsellors obtain General Work Permits with moderate processing priority."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Counsellors and clinical psychologists sit on Tier-2 list with streamlined residence pathways."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Private hospitals hire licensed counsellors but role not in talent-visa priority segments."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "NHS recruits psychological practitioners, yet occupation removed from Shortage List in 2025."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Severe domestic shortage after COVID-19 but no dedicated visa; hires usually through generic H-1B healthcare petitions."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "13b82fe7-08c5-4d91-8d91-ab4438a1e828": {
    "career": "Biology Instructor",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "STEM teachers are prioritised; university lecturers receive points but no dedicated fast lane."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Strategy offers fast-track PR for science faculty to address professor shortages."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Universities recruit international STEM lecturers via Chancenkarte amid faculty aging."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Higher-ed hiring mainly local; foreign faculty limited to specialist research chairs."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Life-science researchers on list; lecturers usually gain Critical-Skills permits."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "University posts can sponsor HSP visa with points for PhD and publications."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "Growth in biotech teaching exists but no explicit immigration incentive."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "No special immigration priority, but universities may sponsor Exceptional Talent visas."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Vision 2030 emphasises applied biotech R&D, not academic teaching roles."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Singapore Economy 2030",
        "reason": "Autonomous universities hire foreign biology lecturers to support biomedical cluster."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "UAE Centennial 2071",
        "reason": "New universities hire STEM faculty, yet biology lecturers are not priority-visa category."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-science push increases need for university instructors; Skilled Worker visa available."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds university STEM talent pipelines and grants visas for research instructors."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Recruitment focuses on applied manufacturing and semiconductors, not university faculty."
      }
    }
  },
  "6f8e275e-8201-442d-ae05-6a60e77f4e2d": {
    "career": "Sociology Lecturer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Humanities lecturers not on core list but still earn skilled-visa points."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities can fast-track lecturers in humanities facing retirement gaps."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Universities fill demographic gaps in social sciences via Chancenkarte."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List covers lecturers broadly; social sciences accepted on a case-by-case basis."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "No shortage policy but individual universities may sponsor."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "Autonomous universities hire selected social scientists for public-policy research."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "UAE Centennial 2071",
        "reason": "Private universities recruit humanities faculty but role not in talent-visa fast lanes."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Social-impact research tied to creative industries; Skilled Worker visa route viable."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act’s education funding extends to social-science faculty for ethics and societal-impact studies."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "dd0b483b-269f-41dc-9875-ec32ca9c7d1a": {
    "career": "Geology Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL lists mining and petroleum geoscientists; visas processed in weeks."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Battery-metal exploration makes geoscientists attractive under Express Entry STEM stream."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Renewable-energy storage projects need geoscience, but role not on top shortage list."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Massive nickel and geothermal projects drive urgent need for exploration geologists."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Limited mining sector; geoscience hiring modest."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points possible for geothermal and earthquake-risk research."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan supports rare-earth exploration, needing some geologists."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Green-hydrogen projects create some demand; not a formal shortage occupation."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "Large mining concessions and underground CO₂ storage require research geologists."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Operation 300bn",
        "reason": "CCUS and geothermal pilots need geoscience expertise, but small headcount."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "CCUS and offshore wind foundations create some geoscientist roles."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds critical-mineral mapping, carbon-capture sites and geothermal R&D, boosting geologist demand."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Strategy includes upstream minerals, requiring geological surveys."
      }
    }
  },
  "21de18f9-3678-445d-9ac8-fdad3dc4cc43": {
    "career": "Slavic Instructor",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Universities can sponsor language lecturers, but not a priority occupation."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Demand for Slavic lecturers in universities due to proximity to Eastern Europe."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Some language lecturing posts, but no shortage recognition."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "No immigration priority for niche language teaching."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Universities maintain Russian-studies departments; Skilled-Worker visa route used."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds critical-language programmes tied to national-security workforce."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "9376f8cc-cd5f-49de-ad59-4a7933aa523f": {
    "career": "Secondary Mathematics Teacher",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Maths teachers on CSOL; states sponsor visas for regional high-school shortages."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Secondary STEM teachers explicitly prioritised under French-speakers and education shortage streams."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe lack of STEM teachers; Opportunity Card awards points for teaching degrees."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "STEM teaching occasionally regionally sponsored, but not on national critical list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Secondary mathematics listed for direct residence pathway."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Private schools recruit STEM teachers, but not part of federal priority sectors."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Maths teachers on shortage list until 2025, but post-2025 status uncertain."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No dedicated teacher visa, but STEM-education funding creates limited demand in charter and shortage districts."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "f2675443-82f5-4742-a604-b48ccdca8f72": {
    "career": "Business Analytics Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Migration Strategy 2023",
        "reason": "Data and systems analysts classed as medium-term skilled occupations."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Data analysts qualify under digital talent track, though priority goes to AI specialists."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialists pathway accepts analytics professionals without German degree requirement."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Data analysts and BI specialists are explicitly listed, feeding pharma and tech multinationals."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "Data scientists qualify, but language requirement limits uptake."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industry 4.0 pushes for analytics, yet focus remains on engineering talent."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Skilled Migrant Category",
        "reason": "Points awarded for data roles, but not on immediate Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Growing fintech and tourism analytics needs, yet visas focus on senior AI experts."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "National AI Strategy 2.0",
        "reason": "Data analysts qualify for Tech.Pass and COMPASS bonus, though AI engineers get first pick."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "UAE Centennial 2071",
        "reason": "Financial centres actively hire analytics talent for fintech and retail sectors."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital, AI, and data competencies are headline priorities; fast-track visas under Scale-up route."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "CHIPS and Science Act",
        "reason": "Demand for data talent across semiconductor and clean-tech firms; STEM OPT and H-1B favour analytics roles."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Openings in e-commerce analytics, but preference for local hires."
      }
    }
  },
  "9842d912-f597-4f29-8c93-5427c6828a12": {
    "career": "Motion Graphics Instructor",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Growing animation outsourcing market needs trainers, but visas limited."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on list, but film-tech tax incentives create limited demand in private institutes."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Anime studios occasionally hire foreign trainers; language barrier remains high."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Kuala Lumpur’s creative clusters run training programmes for game/film VFX."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Massive entertainment and media academies seek international trainers for film and animation."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Singapore Economy 2030",
        "reason": "Game and media industries value instructors, but not top-tier shortage."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai Media City and Abu Dhabi’s twofour54 offer visas to creative-skills instructors to upskill local talent."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries a headline pillar; colleges recruit motion graphics tutors for booming VFX sector."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "CHIPS and Science Act",
        "reason": "Creative educators benefit indirectly from booming media tech, but not an immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "c036c68f-149e-406c-9501-bcce4f5f7fcf": {
    "career": "Psychology Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Global Talent visa targets health and research academics, including psychology."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities fast-track researchers with PhDs, though grants smaller than US."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Max Planck and Leibniz institutes actively recruit cognitive scientists under Blue Card."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "SFI grants hire post-docs in cognitive and health psychology, though not on critical list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Universities recruit brain-science PhDs; language hurdles remain."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Universities hire, but limited positions and funding."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "NEOM and research universities fund human-factors labs, yet numbers small."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Singapore Economy 2030",
        "reason": "A*STAR funds social-behavioural research for aging and education tech."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "We the UAE 2031",
        "reason": "MBR University and NYUAD offer psychology research posts within Golden Visa scheme."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Behavioural science feeds UK health and defence R&D; Global Talent visa supports researchers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Large federal R&D funding and NIH grants welcome behavioural and cognitive researchers; J-1 and O-1 visas common."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "51458e25-d82b-4a20-83c0-dc6495006d1b": {
    "career": "Therapist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "Psychotherapists and counsellors on medium-term skilled list; Medicare funding expanded for mental health."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Mental-health counsellors fall under health-care shortage, fast-tracked for permanent residence."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz",
        "reason": "Ageing population drives demand; foreign therapists welcomed after licence recognition."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Counsellors and psychologists qualify for Critical Skills Employment Permit."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Clinical psychologists listed; counsellors get points although not direct residence pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Hospitals hire foreign mental-health staff, but local licensure is restrictive."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Singapore Green Plan 2030",
        "reason": "Growing mental-health awareness; foreign counsellors need Allied Health Professions Council registration."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Demand in private hospitals; DHA licence required, not a headline sector."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Clinical psychologists on list, but immigration caps tightening post-2025."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Indirect funding for community clinics, yet immigration pathways limited outside H-1B cap."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "5f399b2c-241a-4b3d-af22-19b690239e35": {
    "career": "Content Strategist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "None",
        "reason": "Express Entry does not prioritise marketing or communications; demand exists only through normal labour market."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "None",
        "reason": "Fachkräfte law allows generic creative workers, but no fast-track or shortage recognition."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Mega-projects require English-language content for tourism and branding but local hiring preferences remain."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "None",
        "reason": "Media jobs exist but are not on priority lists; EP quotas tightening for generic marketing."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Dubai/Abu Dhabi media hubs seek senior content creators for regional campaigns."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "None",
        "reason": "Creative sector growth, but role not on Shortage List; standard Skilled Worker visa applies."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "None",
        "reason": "Creative industry roles supported by strong private-sector demand but not specifically named in federal priority lists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "ed38c7a6-6384-4f09-bd1c-b9cd57142cf8": {
    "career": "ML Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Software developers and data scientists on CSOL; streamlined visas but smaller ecosystem."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Canada opened dedicated AI/tech work permits and Express Entry category for data/ML specialists."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialists obtain EU Blue Card without degree if skilled; AI hubs in Munich and Berlin."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech and e-commerce expansion; skills in demand yet bureaucracy heavy."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "AI/ML explicitly listed; quick 2-year critical skills permit to PR."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Highly Skilled Professional visa",
        "reason": "AI researchers gain maximum HSP points and 1-year PR eligibility."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "MADANI Economy",
        "reason": "Government pushing Industry 4.0; demand building but salaries lower."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Migrant Category",
        "reason": "Tech talent welcomed but no dedicated AI shortage list yet."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Government investing billions in national AI centre and smart-city NEOM."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "National AI Strategy 2.0",
        "reason": "AI Engineers top of COMPASS points; attractive salaries and R&D grants."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "UAE Centennial 2071",
        "reason": "AI named core pillar; Golden Visa fast-track for data scientists and ML engineers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital and semiconductor specialists on shortage list; Tech Nation route revived under new scheme."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds AI R&D and domestic talent; H-1B demand exceptionally high for ML roles."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "AI engineers needed for chip design and fintech but immigration processes nascent."
      }
    }
  },
  "7935e53b-bebb-46c2-b900-e75e4608518d": {
    "career": "Urban Ecologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Migration Strategy 2023",
        "reason": "Ecologists not on priority list but urban-greening projects in major metros create some demand."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Environmental professionals fall under ‘STEM’ category; cities investing in biodiversity strategies."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Strong municipal focus on sustainable urban planning under EU Green Deal."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital Nusantara promises ‘forest city’ concept requiring ecological expertise."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Role aligns with biodiversity targets but not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "NEOM and other giga-projects include vast ecological restoration components."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Singapore Green Plan 2030",
        "reason": "City in Nature initiative opens limited specialist roles."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "We the UAE 2031",
        "reason": "Limited but growing interest in urban biodiversity within sustainability agenda."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Mandatory biodiversity net-gain in planning law raises consultancy demand."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Federal funding for green infrastructure and climate-resilient cities increases demand for ecological expertise."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4e5f011b-653b-4a99-9329-13bc4ef63abf": {
    "career": "Information Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "ICT business and systems analysts appear on CSOL; information science overlaps."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Broad STEM category includes data and information professionals."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialists, especially in data governance, receive Blue Card fast track."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Data management and cloud roles covered under ICT categories."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Points available for data management, though fewer openings in English."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "Industry 4.0 push needs information governance, but competition with local graduates."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Skilled Migrant Category",
        "reason": "Demand exists but role not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Vision 2030",
        "reason": "Smart-city data platforms need information architecture talent."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Economy 2030",
        "reason": "Data governance a national initiative under IMDA; strong but not Tier-1 AI list."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Operation 300bn",
        "reason": "Digital transformation drives need for enterprise information governance."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Data specialists eligible for Skilled Worker visa and shortage designation."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "CHIPS and Science Act",
        "reason": "Data management critical to federally funded research and semiconductor supply-chain analytics."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "8109bd5f-1017-444d-9040-0bd858aace0a": {
    "career": "Nanomedicine Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Migration Strategy 2023",
        "reason": "Researchers eligible under Global Talent visa but funding limited."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Biotech and life-sciences targeted for high-skill visas, though niche."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Strong pharma and nanotech clusters in Berlin and Heidelberg."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma and medtech manufacturing hub actively seeks nanotech researchers."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Highly Skilled Professional visa",
        "reason": "Advanced materials and biotech national priorities."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "NIMP 2030",
        "reason": "Medical device cluster exploring nano-coatings but still emerging."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "King Abdullah City for Science funds nanotech health projects."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Singapore Economy 2030",
        "reason": "A*STAR funds nanomedicine; BioMedTech industry is Tier-1 priority."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai Science Park and Khalifa University investing in nano-drug research."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences R&D is a flagship pillar; fast-track Global Talent visas."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA and NIH grants boost advanced drug-delivery and biotech manufacturing."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "806c80de-25b0-461f-ac41-246298159cda": {
    "career": "HR Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Employers sponsor HR managers for major construction and mining firms, but role is off the Core Skills list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "General management roles welcomed in multinationals, yet not a priority occupation for points-based selection."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "HR not on critical list; only possible via General Employment Permit with strict salary thresholds."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Mega-projects hire foreign HR leaders to implement Saudisation targets, yet no dedicated visa lane."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Economy 2030",
        "reason": "Enterprises can obtain Employment Passes for HR leaders, but role sits outside top-tier priority sectors."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "We the UAE 2031",
        "reason": "Free-zone multinationals routinely sponsor HR managers, but policy spotlights tech and manufacturing, not HR."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Firms can sponsor HR managers under general SOC code, still lower priority than STEM shortages."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Large federal projects scaling fast need experienced HR to hire, train and retain skilled labour but HR itself is not a named shortage."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      }
    }
  },
  "528ee92c-108b-48be-9cd6-534d376ebf32": {
    "career": "Sports Business Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Migration Strategy 2023",
        "reason": "Sport-mad culture and upcoming Olympics spur hiring yet occupation absent from Core Skills list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Growing NHL and MLS franchises hire managers but role not on priority lists."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Government exploring sports tourism to leverage new capital city but still emerging."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "No targeted pathways for sports administrators."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Massive investment in football clubs, e-sports, and mega-events drives urgent need for international sports business talent."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "UAE Centennial 2071",
        "reason": "Abu Dhabi and Dubai push global tournaments and sports media, creating strong but secondary demand."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry focus includes sport media rights; Premier League clubs sponsor skilled managers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Billions for stadium upgrades and city redevelopment create demand for professionals commercialising sports venues."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "7ce42d4b-c2bb-42f9-9904-f4f8a0c808d2": {
    "career": "Sign Language Interpreter",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Migration Strategy 2023",
        "reason": "National Disability Insurance Scheme funds interpreter services but role not on Core Skills list so slightly lower."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Official bilingualism and accessibility laws create steady demand; NOC system recognises interpreters."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Inclusion legislation drives need; some Länder sponsor BSL/DGS interpreters."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Interpreters excluded from critical list; limited posts."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "NZSL interpreter shortage recognised regionally, but not yet on Green List."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Singapore Green Plan 2030",
        "reason": "Government pushes inclusive society; limited but growing interpreter hiring."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "Expo legacy pushes accessibility, but demand remains modest."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "59",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Equality Act mandates interpreters; sponsorship possible through healthcare providers but not on shortage list."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Federal contracts require ADA compliance; chronic shortage of certified ASL interpreters."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "bd080c3e-0a6b-41c1-b234-0b5676ba41f0": {
    "career": "Theatre Actor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Migration Strategy 2023",
        "reason": "Government funds performing-arts centres but actor visas capped."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Program targets tech; arts visas limited and highly competitive."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Actors not on list; only limited cultural visas."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "New theatres and festivals in Riyadh need foreign performers for rapid cultural expansion."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Economy 2030",
        "reason": "Esplanade and theatre companies hire foreign talent case-by-case, outside core policy sectors."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai’s creative-free zones sponsor artists, but competition high."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries are a core pillar; London’s West End draws and sponsors international talent."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Urban revitalisation grants include performing-arts venues, indirectly creating acting work."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "31",
        "policy": "",
        "reason": ""
      }
    }
  },
  "53a1bd24-a5e4-490b-b782-babe8247a186": {
    "career": "Export Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Migration Strategy 2023",
        "reason": "Visa lists stress engineers and trades over commercial staff."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Trade managers welcome but not priority occupation."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Export-driven Mittelstand regularly sponsors specialists to grow non-EU markets."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel and EV supply-chain firms require export compliance expertise."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Export-heavy pharma and tech firms sponsor applicants via General Employment route."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Language barrier; companies prefer Japanese staff for export paperwork."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan aims to triple high-tech exports; firms need specialists for new markets."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "Diversification push creates openings to grow non-oil exports but technical roles prioritised."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Singapore Economy 2030",
        "reason": "Global trading hub needs export managers but role is supporting, not headline priority."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Operation 300bn",
        "reason": "Manufacturing growth targets hinge on exporting; free-zones aggressively recruit export managers."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Post-Brexit trade deals raise demand, yet no special visa concessions."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Clean-tech firms need managers to navigate export incentives and compliance, but role not singled out."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "National Master Plan 2021-2030",
        "reason": "Export-led manufacturing seeks managers familiar with EU and US compliance."
      }
    }
  },
  "f9dbdcfa-8e13-4c43-afda-a06a049c870c": {
    "career": "Geography Teacher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Secondary STEM teachers on CSOL; Geography often classed under STEM-Humanities crossover, easing state visa sponsorship."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Primary and secondary teachers (all subjects) receive extra CRS points under Category-Based Selection."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe shortages of secondary teachers; Länder fast-track non-EU educators in shortage subjects including geography."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Only maths, science and languages enjoy critical-skills status; humanities teachers receive no fast-track."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 2)",
        "reason": "Secondary school teachers on Green List; geography meets social-science criteria."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Private international schools hire geography teachers, but not listed as a strategic skill."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Geography excluded from shortage list after 2025; still possible under general teacher visa but no priority points."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA funds climate-resilience education modules and schools value AP Human Geography teachers, but profession not on any Federal skills list."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "26",
        "policy": "",
        "reason": ""
      }
    }
  },
  "7a62385c-5af3-4673-895f-98431d4ecf43": {
    "career": "Civil Engineering Practitioner",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Listed as priority occupation; engineers receive fast-track visas and state sponsorship."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Civil engineers on Category-Based Selection list; provinces running PNP draws specifically for infrastructure talent."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Massive housing and rail upgrades need civil engineers; Opportunity Card gives points for the degree."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "51",
        "policy": "RPJPN 2025-2045",
        "reason": "Nusantara capital relocation fuels demand; bureaucratic licensing hurdles keep score moderate."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Civil engineers are critical skills, but market size is smaller than UK/CA/AU."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Construction engineers welcomed under SSW visas, yet language barrier reduces attractiveness."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "NIMP 2030",
        "reason": "Infrastructure upgrades planned, but preference for local PE licence holders."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Civil and structural engineers are on Tier 1 Green List enabling straight-to-residence visas."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Vision 2030",
        "reason": "Mega-projects (NEOM, Red Sea) recruit thousands of civil engineers from abroad."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Singapore Green Plan 2030",
        "reason": "Focus on green buildings keeps niche demand, but local engineer supply adequate."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Operation 300bn",
        "reason": "Mass urban development and rail corridors increase demand, though Emiratisation preference lowers score."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean energy and HS2 rail drive shortage; civil engineers qualify for Skilled Worker visas."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA allocates US$1.2 trn to roads, bridges, broadband and water infrastructure, driving demand for civil engineers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "National Master Plan 2021-2030",
        "reason": "Transport and power projects need civil talent, though salaries are lower for expats."
      }
    }
  },
  "6c936cfd-8e10-409f-8c0c-4d51ff050ad3": {
    "career": "School Music Director",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Migration Strategy 2023",
        "reason": "Limited state nominations for arts teachers; preference remains for secondary STEM."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Music teachers eligible under general K-12 category, but lower CSR weighting than STEM/health."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "24",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Green List (Tier 2)",
        "reason": "Secondary teachers on Green List but music is lower priority, still acceptable."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Private schools hire music directors for IB/IGCSE, yet not a strategic skill."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "49",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Music teachers excluded from shortage list, but academies may sponsor under general teacher visa."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Some IIJA school renovation grants include arts facilities, but no immigration priority for arts educators."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "27",
        "policy": "",
        "reason": ""
      }
    }
  },
  "8af5f603-c9ad-46ab-b246-1caa4f78cd31": {
    "career": "PR Specialist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Tourism and giga-projects need English PR talent, but Saudization caps expat numbers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "National AI Strategy 2.0",
        "reason": "Regional HQs in Singapore still hire English-language PR talent, but role not strategic."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "Dubai agencies recruit global PR talent for finance and hospitality sectors."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries valued, but PR not on shortage list; sponsorship possible only for senior roles."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "59",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Clean-tech companies funded by IRA hire PR teams, but role not on any skills list."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "9990a34e-2514-4bb8-8812-0523bf3d5228": {
    "career": "AI for Games Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Migration Strategy 2023",
        "reason": "Digital games tax offset spurs hiring, but AI specialism not separately prioritised."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Montreal and Vancouver game clusters get fast-track visas for AI engineers."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Gaming hubs in Berlin and Hamburg sponsor visas, though AI gaming niche still small."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "RPJPN 2025-2045",
        "reason": "E-sports and mobile games growing; AI specialists valued yet visas bureaucratic."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Software engineers with AI get critical skills permits; gaming tax credit launched 2024."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Highly Skilled Professional visa",
        "reason": "Console giants seek AI talent; HSP visa gives 1-year PR track."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "NIMP 2030",
        "reason": "Malaysia Digital initiative includes game dev AI grants, but ecosystem still emerging."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Skilled Migrant Category",
        "reason": "Weta Gameshop and indie studios hire AI talent, but visa points moderate."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Savvy Games Group investing $38 bn in AAA studios; AI gameplay engineers in demand."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "National AI Strategy 2.0",
        "reason": "Ubisoft, Riot, and Garena headquarters sponsor AI engineers under Tech.Pass."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "UAE Centennial 2071",
        "reason": "Abu Dhabi Creative Media Zone offers incentives for gaming startups needing AI expertise."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries named pillar; London & Guildford studios struggle to source AI engineers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Frontier AI and gaming engines enjoy tax credits and R&D funds; Silicon Valley studios aggressively hire."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Mobile game studios booming; AI hire demand moderate."
      }
    }
  },
  "f4abac4a-236e-4356-ba7a-356380a9b3a9": {
    "career": "Advanced Accountant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Accountants can earn points yet are absent from the Core Skills Occupation List."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Qualifies under general skilled stream but finance occupations are not a 2026 priority category."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Recognised profession, but shortage lists focus on engineers, IT and healthcare."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Vision calls for stronger capital markets; accountants useful but not headline skill."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on list, yet Dublin’s financial cluster sponsors many chartered accountants via Critical Skills route."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Highly Skilled Professional visa",
        "reason": "Accounting qualifies for HSP but ranks below tech and semiconductor priorities."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "MADANI Economy",
        "reason": "Islamic-finance growth needs accountants, though policy emphasis is on manufacturing and semiconductors."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Possible via points system; not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Financial-sector expansion needs IFRS talent but policy spotlights other sectors first."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Singapore Economy 2030",
        "reason": "Sustainable-finance reporting rules fuel demand for Chartered Accountants, though not a core Tier-1 sector."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai–Abu Dhabi push to be global finance hubs drives demand for senior accountants and IFRS experts."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Senior accounting and professional-services roles are explicitly listed as strategic shortages."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Demand for CPAs rises with IRA-linked tax credits, but accountants are not a named federal shortage occupation."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "IFRS rollout creates demand but no dedicated talent scheme."
      }
    }
  },
  "cddfd9c5-0ce5-4cf1-a955-8b8151572cf3": {
    "career": "Fashion Educator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Creative-arts lecturers migrate via general skilled visa; fashion not on CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Positions exist in Toronto and Montreal colleges but outside Express Entry priority streams."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Academic roles count for points yet policy prefers STEM."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Jakarta fashion schools hire expatriate mentors; not a government priority skill."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "",
        "reason": "Niche openings at NCAD and Limerick; not on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Bunka and other colleges recruit English-speaking lecturers but outside HSP focus areas."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "KL’s textile industry supports some teaching roles, yet policy favours high-tech manufacturing."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Design institutes hire occasionally; no Green List coverage."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Emerging fashion hubs in Riyadh/NEOM seek educators for local talent build-up."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "LaSalle & NAFA hire fashion educators, yet sector is outside Tier-1 lists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai Design District colleges and institutes actively recruit international fashion faculty."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "London’s universities and art schools need lecturers; Higher-education visa is streamlined."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Design schools in New York and California continually hire fashion faculty, though not a federal priority."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Growing garment sector needs training but no national talent programme."
      }
    }
  },
  "3a52ef8e-7864-4eb3-8a79-d36ead4ab9d4": {
    "career": "Healthcare Biologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Research visas exist but life sciences not on 2023 Core Skills list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Biotech scientists welcome under global talent stream though not a target category."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Streamlined visa for scientists; biotech clusters in Munich and Heidelberg recruiting."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "RPJPN 2025-2045",
        "reason": "2045 vision prioritises biopharma research capacity; foreign experts receive expedited permits."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Med-tech corridor around Galway–Limerick actively sponsors biomedical scientists."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "Biotech researchers obtain top HSP points; Osaka/Kanagawa pharma clusters hiring."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan names pharma scientists as strategic for export growth."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Biotech research roles qualify for Skilled Migrant Category but not Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "New research centres need biomedical talent, yet energy and tourism take precedence."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Economy 2030",
        "reason": "Biomed is a top pillar; A*STAR and Biopolis recruit global healthcare biologists on five-year passes."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "We the UAE 2031",
        "reason": "Abu Dhabi Biotech Hub and Dubai Science Park offer Golden Visas to researchers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life sciences are a flagship pillar; fast-track Global Talent visa available."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Massive federal grants for biotech and life-science R&D create strong demand for biomedical researchers."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National Master Plan 2021-2030",
        "reason": "Government funds vaccine and pharma R&D, opening slots for biologists."
      }
    }
  },
  "dced7b1a-b2ef-4feb-9f7c-deb58599a31c": {
    "career": "Media Educator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Lecturer positions possible via skilled visa; media isn’t on CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Communication faculty eligible for general work visas; not in Express Entry priority."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Academic roles score points, but STEM outweighs media in priority lists."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Openings exist in Dublin colleges yet not on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Private universities recruit English-speaking faculty but media isn’t HSP focus."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Polytechs recruit media tutors; outside Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Vision 2030",
        "reason": "Entertainment & media schools being launched, but faculty hiring still limited."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Fine arts universities hire some media lecturers but sector not Tier-1."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Dubai media academies hire educators to upskill local content creators."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Universities welcome media lecturers; not on shortage list but Global Talent visa covers academia."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Universities hire journalism professors but role isn’t part of national talent programmes."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "70fe2bd8-cc1b-4920-a76e-bdbfbf89c837": {
    "career": "Production Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Large productions in Sydney and Queensland need managers, though not on CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Toronto and Vancouver studios recruit, yet immigration policy spotlights tech and healthcare."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Berlin’s film sector hires freelancers; no national talent scheme for this role."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Jakarta and Bali host shoots, but creative roles not in 2045 priority list."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Screen Ireland funding boosts demand, but role outside Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Anime and live-action shoots hire freelancers; immigration priority lies elsewhere."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Iskandar Malaysia Studios attracts productions needing managers, but NIMP focuses on hardware sectors."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Wellington productions seek managers but Green List focuses on engineers."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Vision 2030",
        "reason": "Gigantic entertainment projects (NEOM, AlUla) urgently need film & live-event production managers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "MediaCorp and Marina Bay event circuits need managers; still outside Tier-1 categories."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai Studio City and Abu Dhabi Film Commission offer incentives for productions that hire seasoned managers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries (film, TV, theatre) are a named pillar; shortage of experienced production managers."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Hollywood and streaming giants hire experienced production managers, but role isn’t federally prioritised."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Growing film outsourcing market yet no dedicated visa path."
      }
    }
  },
  "87aa1cec-1880-4f9b-a450-d6afcd44e636": {
    "career": "Space Physicist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Square Kilometre Array and space agency create some demand, but not listed shortage."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Canada courts astrophysicists for observatory projects (e.g., CSA, NRC Herzberg) via STEM-priority streams."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Max-Planck and ESA centres hire non-EU physicists under relaxed STEM visa rules."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Ireland funds astrophysics academically but offers few dedicated immigration incentives."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Highly Skilled Professional visa",
        "reason": "JAXA and ISAS labs prioritise foreign researchers; HSP fast-tracks STEM doctorates."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Small but growing astrophysics community around Dark Sky reserves; visas available but few roles."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "King Abdulaziz City for Science & Technology invests in space research yet positions remain limited."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National AI Strategy 2.0",
        "reason": "Small space research group; interest mainly in downstream satellite data analytics."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Operation 300bn",
        "reason": "Emirates Mars Mission and Mohammed bin Rashid Space Centre aggressively recruit international space scientists."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "UK Space Agency and Rutherford Appleton Laboratory need heliophysics talent; Skilled Worker visa supports."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "NASA and NSF receive fresh science funding; CHIPS Act explicitly boosts physical-science research and visas for STEM PhDs."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4b218c33-56f1-4279-af0e-d27860309e64": {
    "career": "Advanced Analytics Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Core Skills List flags data analysts and software professionals."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Data scientists in priority list; managers qualify under STEM stream."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Fast-track Blue Card for IT and analytics professionals."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech growth drives some need yet immigration pathways unclear."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Analytics managers fall under data scientist category, highly favoured for visas."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points favour AI/data talent; large gaps in analytics leadership."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "MADANI Economy",
        "reason": "Industry 4.0 plan values data roles, but few dedicated visas."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Data roles present but not on Green List; standard points route."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "Smart-city projects need analytics, but localisation policies add friction."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "National AI Strategy 2.0",
        "reason": "Government funds AI/analytics hubs; EP Complementarity Assessment scores favour data leaders."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi push big-data across fintech and logistics sectors."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital & AI segment prioritises data leadership on Skilled Worker visas."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds AI and data R&D; firms aggressively hire analytics leaders."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Data analytics supports e-commerce, but not explicit priority."
      }
    }
  },
  "4c4d3458-8ece-4b17-a84e-3a7c4ffc9144": {
    "career": "Māori Language Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Parallel interest in Aboriginal languages but limited dedicated positions."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Linguistics PhDs qualify under STEM/Humanities stream, yet field not priority."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Skilled Migrant Category",
        "reason": "Government funds Te Reo revitalisation; universities and iwi seek researchers urgently."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Some universities fund indigenous studies, but no targeted visa support."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "016e3202-f53e-40c4-9528-1ee3deba1688": {
    "career": "Applied HR Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Only senior HR directors in large firms secure nomination."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "HR managers qualify under management NOC but not priority stream."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Companies prefer German-speaking locals for HR compliance roles."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Critical Skills list omits HR."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Language barrier limits foreign HR hiring."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Preference for local HR professionals familiar with labour law."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Skilled Migrant Category",
        "reason": "Possible via points, but not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Vision 2030",
        "reason": "Mega-projects need expatriate HR leaders to build multinational workforces."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Economy 2030",
        "reason": "Tech firms need strategic HR; EP points favour high-salary HR managers."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Global firms in DIFC/ADGM recruit HR managers to navigate multicultural labour laws."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "HR not on Shortage List; sponsorship possible but competitive."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Generic management role; no specific federal talent programme."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "12179b26-a9fc-4881-bb51-72b2329022b4": {
    "career": "Chemical Biologist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Core Skills List covers medtech and pharma R&D roles."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Biotech scientists sit high on STEM points grid."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Pharma clusters in Hessen recruit foreign chemical biologists."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "RPJPN 2025-2045",
        "reason": "Focus on biopharma manufacturing, not basic chemical biology research."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma giants in Cork/Limerick actively sponsor chemical biologists."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Highly Skilled Professional visa",
        "reason": "Biotech research institutes recruit foreign PhDs with fast-track residency."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan lists pharma and medical devices; limited senior R&D openings."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Biotech sector small but growing—standard points route."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Vision 2030",
        "reason": "NEOM and KAUST invest in health-tech and genomics labs."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Singapore Green Plan 2030",
        "reason": "Biopolis and A*STAR aggressively court chemical biologists under biomedical pillar."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Operation 300bn",
        "reason": "Biotech manufacturing corridors need R&D talent."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences pillar funds chemical biology and offers Global Talent visas."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act channels billions to NSF biotech and advanced manufacturing, easing O-1/H-1B for PhD scientists."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Biotech sector emerging; few advanced research posts."
      }
    }
  },
  "d245aa5a-0c4d-4c68-8676-8d08bce9a271": {
    "career": "Sports Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "Sports administration sits on neither core nor priority lists; possible under general manager stream."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Managers admitted under general management NOC; no dedicated sports quota, still viable for French-speaking applicants."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Open to graduates in business management; sports business is niche but eligible with points."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Jakarta and new capital plan to grow sports tourism; demand exists but not prioritized."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Sports administrators fall outside critical list; entry possible via general employment permit."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Highly Skilled Professional visa",
        "reason": "Professional club and Olympic legacy projects hire foreign sports business talent under general ‘entertainment & management’ rubric."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "MADANI Economy",
        "reason": "Government promotes sports tourism (motorsport, badminton), but not a formal priority."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Skilled Migrant Category",
        "reason": "May qualify as corporate services manager; not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Vision 2030",
        "reason": "Massive investment in sports leagues, events and clubs (e.g., Newcastle, LIV Golf) creates direct demand for sports business leadership."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "49",
        "policy": "Singapore Economy 2030",
        "reason": "Sports Hub and F1 need managers but role outside named priority sectors, passes possible under COMPASS."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi bid for global sporting events and need experienced managers in club, venue and event operations."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Premier League drives hiring, but sports management is not on shortage list; sponsorship visas still possible."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Sports franchises benefit indirectly from stadium and tourism infrastructure funding, but role is not a named shortage."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "41",
        "policy": "National Master Plan 2021-2030",
        "reason": "Sports event hosting (F1, SEA Games) modestly increases demand; visas available under general manager class."
      }
    }
  },
  "f89f8097-40aa-4ab0-9414-6cb2231fca20": {
    "career": "Advocacy Coordinator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Migration Strategy 2023",
        "reason": "Falls under Community and Welfare Managers—eligible but not on core list."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Express Entry Category-Based Selection",
        "reason": "French-speaking community advocacy counts toward points; social-impact workers needed in newcomer settlement."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Civil-society groups require coordinators, and Opportunity Card recognises degree holders with German/English skills."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "RPJPN 2025-2045",
        "reason": "Environmental NGOs active around deforestation; visas possible via social-cultural route."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Role outside critical list; general employment permit possible."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Skilled Migrant Category",
        "reason": "Some demand in environmental NGOs; not Green-List."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "49",
        "policy": "National AI Strategy 2.0",
        "reason": "Many regional HQs of non-profits lobby ASEAN issues; passes under COMPASS."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "We the UAE 2031",
        "reason": "International organisations in Dubai need policy coordinators, but visas discretionary."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Think-tanks and charities sponsor under SOC 2444 though not shortage; civil-society funding stable."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Non-profits lobby on climate and social equity clauses; role fits broader civil society ecosystem though not visa-prioritized."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "24",
        "policy": "",
        "reason": ""
      }
    }
  },
  "7ea3f476-7636-41eb-bb24-20ce603e613a": {
    "career": "AI Developer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Software engineers and data scientists are core-skills; AI developers receive priority processing."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Canada brands itself as global AI hub (Toronto, Montreal) and fast-tracks AI/ML talent through dedicated streams."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Nation funds AI centers (Cyber Valley); visa points favor IT specialists without German degree."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech and e-commerce unicorns need AI yet immigration pathways less streamlined."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "AI/ML on critical list; big tech European HQs cluster in Dublin."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "67",
        "policy": "Highly Skilled Professional visa",
        "reason": "Govt funds AI robotics; HSP gives 80-point preferential processing to AI researchers."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "NIMP 2030",
        "reason": "AI critical for Industry 4.0 adoption; still emerging ecosystem."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Skilled Migrant Category",
        "reason": "AI engineers qualify under software category though not Green-List Tier-1 yet."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Vision 2030",
        "reason": "Neom and SDAIA invest heavily in AI for smart cities and Arabic LLMs; offers attractive packages."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "National AI Strategy 2.0",
        "reason": "AI forms pillar of economic plan; Tech.Pass and COMPASS give clear fast-track."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "UAE Centennial 2071",
        "reason": "Government Chief AI Office and Operation 300bn attract AI talent with Golden-Visa and startup grants."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "AI ranked as strategic tech; Global Talent visa fast-tracks developers working on approved endorsements."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Massive federal incentives for frontier AI research, semiconductor and talent visas (O-1, H-1B) keep demand extremely high."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "AI skills support chip and e-commerce goals; demand growing but salaries lower."
      }
    }
  },
  "54c59d08-2590-45c4-a6c3-0a03e0a7998e": {
    "career": "Global Business Development Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Corporate sales managers eligible for Temporary Skill Shortage visa though not on core list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Falls under corporate sales manager code; points-based but no dedicated stream."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Management professionals with strong German can score enough points, yet not a shortage."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "49",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV and infrastructure firms need overseas investment liaisons; visas available though bureaucratic."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Role outside list, but MNCs can sponsor if salary exceeds €64k."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "47",
        "policy": "Highly Skilled Professional visa",
        "reason": "English-speaking biz-dev welcomed in tech startups, points for salary and degree."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "NIMP 2030",
        "reason": "Export-oriented manufacturers need global sales leads, yet not officially scarce."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Migrant Category",
        "reason": "Business development included under ANZSCO 2251; standard points apply."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Mega-projects courting foreign investors crave global deal-makers to secure tenants and sponsorship."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Economy 2030",
        "reason": "HQ hub for APAC biz-dev; EP under COMPASS category though role not tier-1."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s free zones and Operation 300bn need managers to open new markets; Golden Visa for executives."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "High-growth tech firms hire yet SOC code not in shortage list; sponsorship possible at £45k+."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "59",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Clean-tech companies need deal-makers worldwide, but role not formally prioritised in visas."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National Master Plan 2021-2030",
        "reason": "Tech and manufacturing parks recruit expat biz-dev, but no policy incentives."
      }
    }
  },
  "441eb481-1973-4d01-8add-0d95b833588d": {
    "career": "MRes Neuroscience Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Medical researchers fall under priority pathway—MRFF funds brain research."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Health and life-science researchers receive prioritised work permits and research chairs."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz",
        "reason": "Max Planck and DZNE recruit international neuroscientists; Blue Card simplified."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Biomedical scientists on critical list; Trinity College and RCSI run world-class neuro labs."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "RIKEN Brain Science Institute is global magnet, HSP points for publications."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "NIMP 2030",
        "reason": "Brain and cognitive research emerging; limited but growing grants."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Small but active Centre for Brain Research; standard points route."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "King Faisal Specialist Hospital funds neuro-degeneration research to localise therapies."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Singapore Green Plan 2030",
        "reason": "A*STAR’s Brain•Insight Centre and rich medtech funding make neuroscience a priority; S-Pass exemption for researchers."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai Science Park and Khalifa University expand neurotech labs needing researchers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life sciences a strategic pillar; Wellcome Trust and UKRI grants plus Global Talent visa."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Funding boost for brain-computer interface, Alzheimer’s research and bio-tech; NIH grants enable visa sponsorship."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4bf3ddad-1c7d-4c7e-ab18-9eee363a2d41": {
    "career": "Performance Studies Writer",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "22",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Growing entertainment sector seeks content creators, but niche fit."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s media free zones attract cultural writers, yet not a formal shortage."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries listed, but policy stresses senior production roles over criticism."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Large performing-arts economy offers opportunities, but role not singled out by federal talent policies."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "094f7205-8b7c-415c-9fde-ac5100c91c73": {
    "career": "Electrical Machines Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Electrical engineers appear on CSOL, with shortages in grid modernisation and mining equipment."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Electrical engineers are priority STEM occupations for permanent residence."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Industry 4.0 and e-mobility create urgent need for electric-machine experts."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel-based EV battery value chain requires electrical-machine know-how."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Electrical engineers are critical-skills migrants eligible for fast permits."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "69",
        "policy": "Highly Skilled Professional visa",
        "reason": "Automotive electrification and robotics maintain demand for motor designers."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "EV and semiconductor equipment sectors need electric-drive experts."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Electrical engineers on Tier 1 list for fast-track residence."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "Mega-projects require power-generation and electric-drive talent."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Manufacturing 2030",
        "reason": "Focus is on precision electronics rather than large-machine design, but adjacent skills useful."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing push needs engineers, but preference for automation/AI specialists."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Offshore wind and EV supply chain highlight electrical-machine skills."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "EV, renewable-energy and manufacturing incentives drive high demand for motor and generator specialists."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Electronics manufacturing and wind-power segments growing rapidly."
      }
    }
  },
  "d97a55ce-77da-4239-b151-5f530955f714": {
    "career": "Legal Research Associate",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Legal sector not on Express Entry priority lists, but firms sometimes hire foreign LL.M. graduates."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "22",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "41",
        "policy": "",
        "reason": "Tech-driven law firms in Dublin require research but no critical-skills listing."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "26",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Vision 2030",
        "reason": "International law firms in Riyadh hire researchers for IPO and project-finance work."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "",
        "reason": "International arbitration hub hires researchers, but preference is for local admission."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "UAE Centennial 2071",
        "reason": "DIFC courts attract common-law talent, but visas favour qualified lawyers, not researchers."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Magic-Circle firms use legal researchers, yet role not on Shortage List."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Role exists in large law firms but not sponsored under any federal talent initiative."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "22",
        "policy": "",
        "reason": ""
      }
    }
  },
  "18300766-353a-4e9b-ab5d-e216521abc28": {
    "career": "Interior Designer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Appears on Medium-Term Skilled list intermittently for hotel and retail fit-outs."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Immigration points possible but occupation not priority."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "49",
        "policy": "",
        "reason": "Tourism-driven resort design offers openings."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Hospitality growth drives demand though not on NIMP list."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Luxury tourism giga-projects and NEOM demand high-end interior talent."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "",
        "reason": "High-rise refurbishments and luxury retail fit-outs, but no policy priority."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "We the UAE 2031",
        "reason": "Dubai/Abu Dhabi hospitality pipeline constantly recruits international designers."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "",
        "reason": "Creative sector strong but no formal shortage listing."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Strong market but no federal shortage policy; state licensure varies."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Rapid hotel and retail construction needs designers."
      }
    }
  },
  "a23d9765-001f-4305-aedf-379738c6b580": {
    "career": "Law Professor",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Migration Strategy 2023",
        "reason": "Higher-education teaching appears on skilled occupation lists."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities use streamlined work permits for tenure-track faculty."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Universities recruit international professors, though German proficiency often needed."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Third-level lecturers are on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Highly Skilled Professional visa",
        "reason": "English-language faculties hire comparative law scholars."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "MADANI Economy",
        "reason": "Foreign faculty sought for international branch campuses."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Small number of law schools but professors qualify for skilled visas."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Vision 2030",
        "reason": "New private universities import international faculty to raise academic standards."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "71",
        "policy": "Singapore Economy 2030",
        "reason": "National University Law and SMU recruit global scholars; EP process streamlined."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "59",
        "policy": "UAE Centennial 2071",
        "reason": "Global campus hubs in Dubai/Abu Dhabi routinely hire foreign law academics."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Higher education lecturers are on Skilled Worker route with reduced salary thresholds."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "CHIPS and Science Act",
        "reason": "Academic roles qualify for J-1/H-1B; US universities value comparative law scholars."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "e47bf595-12c8-48d8-9220-52718ec9eeae": {
    "career": "Pharmacologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Pharmacology research is welcomed but not on the Core Skills Occupation List."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Canada courts health researchers; pharma scientists receive streamlined work permits though not named shortage."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Germany’s life-science clusters (BioNTech, Bayer) hire foreign pharmacologists via Blue Card routes."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Biopharma mentioned but early-stage; limited specialist visa pathways today."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharmaceutical scientists are on the list; country hosts Pfizer, J&J, Novartis plants."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "Biotech researchers receive point bonuses under HSP framework."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan prioritises pharma and medical devices; foreign R&D scientists welcomed."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "No Green-List mention, but PhD researchers can gain points under general skills."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Pharma R&D parks in NEOM and Riyadh recruit specialists, yet quotas favour nationals."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Singapore Economy 2030",
        "reason": "Biomedical scientists are explicitly Tier-1; A*STAR and pharma MNCs sponsor EPs."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Operation 300bn",
        "reason": "Dubai Science Park attracts biotech talent; Golden Visa available for health researchers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences is a named pillar; Global Talent visa fast-tracks pharmacologists."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Biotech and drug-discovery R&D are explicitly funded under IRA life-sciences provisions."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National Master Plan 2021-2030",
        "reason": "Country growing pharma export base but policy focus lies more on semiconductors."
      }
    }
  },
  "390f787a-5b00-4325-a4b8-a9127368c968": {
    "career": "Anthropologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "University roles exist but anthropology not on shortage lists."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Academic researchers and museum curators qualify under French-speaker and PhD streams."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Points for PhD, research publications; Berlin museums actively recruit foreign specialists."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on list; only occasional academic openings."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Academic positions possible through general points, yet not priority."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Economy 2030",
        "reason": "Universities occasionally sponsor humanities faculty but STEM dominates hiring."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Universities can sponsor visas; heritage consultancies need archaeologists/anthropologists."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Cultural-resource management hires anthropologists for federally funded construction surveys."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "0cdf54d4-9c29-49cb-923a-a165ff28c7c0": {
    "career": "Biostatistician",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Data analysts on CSOL; biotech hubs in Melbourne recruit biostatisticians."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Data scientists and health researchers enjoy expedited work permits."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Pharma analytics roles qualify for EU Blue Card; data skills in shortage."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Biopharma research in early growth phase."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Biostatisticians listed; pharma corridor around Cork/Galway constantly hiring."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points for health data experts supporting ageing-society research."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "NIMP 2030",
        "reason": "Pharma analytics emerging but still small market."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Not on Green List but earns high qualification points."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Health data initiatives at NEOM create niche demand."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "National AI Strategy 2.0",
        "reason": "Public-health analytics part of AI roadmap; EP processed quickly."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Genomics centres and Dubai Health Authority hire data biostatisticians under Golden Visa."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-science pillar plus NHS Genomics programmes need biostatistics talent."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds clinical trials and AI-driven health analytics needing biostatistics."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "National Master Plan 2021-2030",
        "reason": "Healthcare analytics demand rising yet not policy priority."
      }
    }
  },
  "46ad723c-2a04-4d40-9b8d-0851f974fb15": {
    "career": "Writing Instructor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "English-language teachers exist but not on shortage list."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Express Entry Category-Based Selection",
        "reason": "French-speaking educators get extra points; colleges sponsor teaching staff."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "International schools hire English instructors; points possible but limited demand."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on list but universities may sponsor specialist roles."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Economy 2030",
        "reason": "Private universities hire writing lecturers, but role not in Tier-1 list."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "Private universities hire ESL composition instructors; not strategic priority."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry pillar values advanced writing pedagogy; visas via academic sponsorship."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Community-college upskilling grants fund adjunct writing instructors."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "99991e7c-c537-4760-b863-d797682fe70a": {
    "career": "Diplomatic Officer",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "15",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "15",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "15",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "15",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "15",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "15",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Not a fit",
        "score": "15",
        "policy": "",
        "reason": ""
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b9d3e0c0-1996-46ad-8e0f-2ed88c6dcde6": {
    "career": "Religious Studies Associate",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Humanities academics can be hired by universities, yet role absent from CSOL priorities."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Academic hires qualify under general Express Entry but field not on category-based list."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Act eases residence for researchers; theology/religious studies departments recruit international talent."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Some demand at autonomous universities for religion-in-Asia researchers but not a policy focus."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "",
        "reason": "Universities sponsor Skilled Worker visas; UK a traditional hub for Asian-religion research."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "",
        "reason": "Universities regularly sponsor H-1B and J-1 visas for humanities researchers and lecturers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "3f5425bf-cbd7-45c0-a145-0f35e46d41b2": {
    "career": "Early Childhood Educator",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Listed as priority; regional visas fast-track early-childhood teachers."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Occupation explicitly prioritised for permanent residence to address daycare shortages."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe Kita teacher shortage; relaxed rules for qualified foreign educators."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Listed on Green List Tier 2 with pathway to residence after two years."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Foreign preschool teachers allowed but quotas tight; not part of national AI/green talent push."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Private nurseries hire foreigners but not a national priority."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Child-care roles removed from shortage list in 2025; visas possible but sponsor numbers small."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Demand exists, but no dedicated federal immigration channel; visas depend on individual employers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b35eddd3-6627-495f-917a-ee62b0983360": {
    "career": "Geotechnical Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Civil/mining engineers high on CSOL; regional visas fast-track infrastructure specialists."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Civil engineers prioritised; geotech qualifies under broader category."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Renewable and transport projects need geotechnical input; pathway simplified for engineers."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital Nusantara sits on soft soils; foreign geotech firms already active."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Critical Skills List includes civil engineers; geotechnical often accepted within that."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Earthquake-prone nation values soil experts, though language still barrier."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Infra and semiconductor fabs need foundation engineers but not formally prioritised."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Green List covers civil/structural; geotech adjacent but accepted case-by-case."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Vision 2030",
        "reason": "NEOM, Red Sea and metro projects crave geotech expertise for challenging desert soils."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Green Plan 2030",
        "reason": "Underground storage caverns, MRT expansion, and land reclamation need advanced geotech."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "We the UAE 2031",
        "reason": "Mega-projects in Dubai & Abu Dhabi need ground engineering to manage reclaimed land."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "HS2, offshore wind foundations and flood defences fuel demand for specialist geotech skills."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Massive federal spend on bridges, tunnels, dams drives demand for foundation and soil experts."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "National Master Plan 2021-2030",
        "reason": "Rail and port expansions require ground investigations, attracting foreign consultants."
      }
    }
  },
  "b78eb216-fbc1-4d89-9155-a8bf0c62d07f": {
    "career": "Art Educator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "CSOL focuses on STEM teachers; art roles possible but not prioritised."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "K-12 teachers eligible under Express Entry, yet art not on category-based list."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Teacher shortage mainly in STEM; art educators hired case-by-case with German fluency."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Green List covers primary and secondary STEM; art fits under general teaching permits."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "International schools hire expat art teachers, but role not nationally prioritised."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Art teachers needed in some districts, but no dedicated immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "bee0f4b1-1cfd-4783-ba5d-51960c2652eb": {
    "career": "Media Analyst",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Entertainment and sports push creates some demand for media insight specialists."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Regional HQs employ media analysts, though not in official talent lists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Dubai Media City hosts many firms analysing global Arabic-language coverage."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry recognised; London newsrooms need data-driven media analysts."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Role exists in large media and tech firms, but not attached to federal talent policy."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "ec8a9b6b-3777-4b4e-8c98-360ac12f6bec": {
    "career": "Corporate Accountant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Accounting is outside CSOL priority but companies keep hiring for compliance and audit cycles."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Accountants fall under general skilled stream, not one of the targeted shortage categories."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Open to any qualified professional, yet accountants are not on the acute-shortage list."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "SOE reporting upgrades welcome expertise, still foreigners face localisation quotas."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "While not explicitly named, Big-4 and fund-administration demand places accountants on trusted-partner visa pathways."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Highly Skilled Professional visa",
        "reason": "Corporate-governance reforms create need, but language and J-GAAP knowledge gatekeep most foreign hires."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Manufacturing expansion needs cost accountants, yet no dedicated immigration priority."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "Skilled Migrant Category",
        "reason": "Corporate finance skills receive points but no fast-track Green-List status."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Vision 2030",
        "reason": "Diversifying SOEs and giga-projects hire foreign accountants but Saudization keeps it off top tier."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Economy 2030",
        "reason": "Push for sustainable-finance disclosures boosts demand for ESG-savvy corporate accountants."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai/Abu Dhabi financial centres court ACCA/CPA talent to build global reporting standards."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "London’s financial-services cluster lists senior accounting as a shortage occupation, giving clear visa advantages."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Clean-energy manufacturers formed under IRA still need accountants for federal-credit tracking and SEC reporting but role is not a stated priority."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Export firms require IFRS reporting, but engineers—not accountants—drive visa incentives."
      }
    }
  },
  "ea6ecf98-749e-4355-b4f9-d3c88417a589": {
    "career": "Public Administrator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "States can sponsor experienced administrators though role isn’t on CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Local governments recruit foreign managers occasionally but no dedicated stream."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Language barrier keeps most admin roles Tier-3 despite visa points."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "RPJPN 2025-2045",
        "reason": "Civil-service reform occasionally uses foreign consultants, not core staff."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on Critical Skills list; NGOs occasionally sponsor."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Language and local-law knowledge limit openings."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "MADANI Economy",
        "reason": "Governance reforms welcome expertise, but public roles favour citizens."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "47",
        "policy": "Skilled Migrant Category",
        "reason": "Councils fill planning/admin gaps but no fast-track Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Government transformation programmes import experienced public-sector managers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "41",
        "policy": "National AI Strategy 2.0",
        "reason": "Digital-gov teams hire project managers, but citizens still preferred for true public-admin posts."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Smart-city and digital-government projects recruit global public-admin talent."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Civil Service mostly recruits domestically; some council roles possible via Skilled Worker visa."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Federal grants require administrators to oversee project compliance, yet hiring prioritises citizens."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Modernisation projects exist yet Vietnamese language preference dominates hiring."
      }
    }
  },
  "58cf10f1-a0ab-47ed-b87a-db4849794990": {
    "career": "Entry-Level Data Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Data scientists explicitly listed; priority processing and state nomination available."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "AI and data roles enjoy fast-track work permits and PR points."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT Spezialist track eases visa but language hurdles lower score."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "E-commerce and fintech explosion drives analytics hiring."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Data scientists on list; two-year Critical Skills work permit available."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "AI/ML researchers gain fast points, English-only roles growing."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industry 4.0 push makes analytics staff highly sought after."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Migrant Category",
        "reason": "No Green-List role yet; tech firms still able to sponsor through points system."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "National Data & AI Authority funds large analytics programmes."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "National AI Strategy 2.0",
        "reason": "Nation wants 15,000 new AI professionals; COMPASS visa points favour data roles."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Operation 300bn",
        "reason": "Golden Visa for AI specialists attracts junior data talent too."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital/AI is a stated pillar; Skilled Worker visa shortage occupation."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Frontier AI, semiconductor and R&D funds make data scientists a prime immigration target."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "AI/ML engineers and data talent underpin chip design ambitions."
      }
    }
  },
  "7f0e9ed2-f6f2-48e2-9ad5-fd09769ac2d8": {
    "career": "Portfolio Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Not on CSOL; sponsorship possible only via big banks."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Financial services roles gain points but aren’t in targeted shortage streams."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Frankfurt funds hire, yet German-language client reporting keeps demand moderate."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Sovereign funds recruit selectively; Bahasa fluency preferred."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Dublin’s funds industry sponsors non-EU portfolio professionals under Critical Skills."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Highly Skilled Professional visa",
        "reason": "Tokyo’s asset-management push ongoing, but Japanese language remains gate."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Islamic finance growth drives demand, yet locals are preferred for Sharia compliance."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Small capital-markets sector limits openings for foreign fund managers."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Public Investment Fund expands; seeks experienced portfolio talent."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Singapore Economy 2030",
        "reason": "Global sustainable-finance hub offers ONE Pass for high-earning portfolio managers."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai DIFC and Abu Dhabi ADGM grant Golden Visas to senior fund managers to build global finance hub."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London lists senior finance as strategic; shortage-occupation visa concessions apply."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Green-energy boom seeds new ETFs and funds requiring skilled managers, but no visa fast track exists."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Nascent capital markets limit foreign openings."
      }
    }
  },
  "1f124dc8-410f-4103-84fb-62d3c74d57c2": {
    "career": "Qualified Art Teacher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Regional schools list secondary teachers, including arts, for skilled visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "K-12 teachers are a flagged shortage, boosting provincial nominee chances."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Nationwide teacher shortage extends to arts; visa path exists with B2 German."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Art not on list; rural schools still sponsor individually."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Green List (Tier 2)",
        "reason": "Secondary school teachers are on the list; art included where shortages exist."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Private international schools hire art teachers but no special visa concessions."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Teacher visas available but art is not on the shortage list after 2025."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct policy link; some districts sponsor teachers due to shortages."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "0abcafab-e42f-4b2b-8b39-eed232dbea05": {
    "career": "Automotive Manufacturing Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "List favours civil and mining, but core manufacturing skills still count toward points-based visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Express Entry Category-Based Selection",
        "reason": "New battery-EV corridor (Ontario-Quebec) actively invites engineers under Express Entry STEM & trades streams."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Germany’s auto giants pivot to e-mobility and urgently recruit production engineers."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel-to-battery value chain needs engineers experienced in vehicle assembly."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List covers mechanical/electrical engineers; limited domestic auto sector keeps demand modest."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Highly Skilled Professional visa",
        "reason": "Major OEMs (Toyota, Honda) globalise EV lines and use fast-track HSP visas for experts."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "NIMP prioritises EV component manufacturing and welcomes foreign process engineers."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Skilled Migrant Category",
        "reason": "Small EV assembly pilots; engineering background earns points but occupation not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "NEOM’s smart-mobility projects and new Ceer EV brand need automotive process talent."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Manufacturing 2030",
        "reason": "Focus is on precision-engineering; auto talent considered but not top-tier."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Operation 300bn",
        "reason": "Abu Dhabi targets advanced manufacturing and could include niche EV assembly lines."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 names auto/EV manufacturing as a priority; several plants in Midlands recruit overseas engineers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA pours billions into EV and battery plants, creating high demand for process and manufacturing engineers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "National Master Plan 2021-2030",
        "reason": "VinFast’s rapid scale-up creates spill-over demand for automotive manufacturing know-how."
      }
    }
  },
  "643b7548-5064-4190-9ff9-e4072d6d6b0f": {
    "career": "Advanced Social Worker",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Aged-care reforms push states to sponsor experienced social workers."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Social workers explicitly targeted under healthcare category for permanent residency."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Elder-care facilities recruit foreign Sozialpädagogen, but language barrier is high."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Medical social workers listed; CORU registration still required."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Migrant Category",
        "reason": "Social workers allowed fast-track residence for child-protection roles."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Child and family social workers remain on shortage list despite 2025 cuts."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "No dedicated visa, but licensed clinical social workers find H-1B spots in hospitals."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a55f2d44-4072-4e53-a574-4da532e903f6": {
    "career": "Fashion Designer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Migration Strategy 2023",
        "reason": "Creative roles get points but sit low on occupation lists."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Strategy covers creative industries broadly but no dedicated stream."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Opportunity Card gives points for creative portfolios, yet demand is small."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Small industry; visas possible but not prioritised."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "Tokyo’s streetwear scene imports designers via HSP creative category."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Entertainment & lifestyle pillars spawn Riyadh fashion week; foreign talent invited."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Economy 2030",
        "reason": "Lifestyle & design cluster offers EntrePass but not top tier."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai Design District actively sponsors senior fashion creatives under creative-media priority."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 highlights creative industries; Global Talent visa has a fashion pathway."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "",
        "reason": "Large fashion market; O-1 visas possible but not a named federal priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b6953110-3479-48c2-b08d-9754b159ed99": {
    "career": "Diplomat",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      }
    }
  },
  "fb510bec-ff23-492b-a025-519a3ded72cb": {
    "career": "Mass Communication Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Migration Strategy 2023",
        "reason": "Communications roles earn some points but no shortage listing."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Strategy includes creative sectors yet gives priority to tech first."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Entertainment and sports mega-projects need English-language media specialists."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Economy 2030",
        "reason": "Niche demand in regional HQs, but quotas favour locals for comms."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Dubai media city offers visas for experienced communicators in creative economy."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry seniors prioritised; Global Talent visa covers communications experts."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Field open but not targeted by federal talent acts."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "e691a043-b14e-4ac0-8768-3ebe5bd9ffd8": {
    "career": "Cultural Resource Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Major mining, road and defence builds require Aboriginal cultural heritage officers even though occupation is not on CSOL; states sponsor experienced managers."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Environmental assessment and Indigenous consultation rules create regional shortages; CRS gives extra points for heritage professionals with French or rural experience."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Museum and heritage employers can hire non-EU experts but language and limited openings keep demand moderate."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Borobudur and Nusantara projects hire some foreign heritage experts, but localisation push limits numbers."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Occasional state heritage hires; not on critical list, so only general work permits available."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Migrant Category",
        "reason": "Infrastructure rebuild and Māori heritage obligations create steady yet small market for qualified managers."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "63",
        "policy": "Vision 2030",
        "reason": "Gigaprojects like AlUla, Diriyah Gate and NEOM need international heritage specialists to curate tourism assets."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Abu Dhabi and Dubai museums import heritage talent, but roles are few and often senior-level."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Large infrastructure (HS2) sustains demand, yet no formal shortage listing keeps immigration pathways generic."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Every federally-funded infrastructure project must complete Section 106 reviews, fuelling steady demand for heritage compliance managers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "ec2dd030-2c50-47fa-b9ae-4e6bf06d49f1": {
    "career": "Entrepreneurship Lead",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Global Talent visas for digital founders exist, yet few salaried ‘lead’ openings; market small."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Start-up Visa exists, but roles are not on targeted occupation lists; demand localised in Toronto/Waterloo hubs."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Berlin startups value such talent but visa points favour tech specialists over ecosystem managers."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "RPJPN 2025-2045",
        "reason": "Govt accelerators for EV and fintech welcome foreign incubation experts via tech-talent visa."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Enterprise Ireland prefers founders and tech specialists; support roles face standard permits."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Government accelerators in semiconductor and aerospace need mentors, but hiring often local."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "NEOM and Monsha’at aggressively hire accelerator heads to groom local founders."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "National AI Strategy 2.0",
        "reason": "Startup SG and AI hubs routinely recruit program heads to scale deep-tech founders."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai Future Foundation and ADGM hubs court global entrepreneurship coaches for fintech and AI clusters."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Innovate UK funding and university spin-outs need incubation leaders, though role isn’t on shortage list."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Massive R&D grants and startup accelerators around semiconductors and deep-tech need experienced ecosystem builders."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "VC-backed tech parks look for foreign mentors yet visas remain case-by-case."
      }
    }
  },
  "a207f6c6-31ff-4550-9466-7785d7d9f5c7": {
    "career": "Global Studies Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Migration Strategy 2023",
        "reason": "Canberra’s focus on Asia-Pacific security drives hiring in policy institutes and universities."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Ottawa funds Indo-Pacific Strategy research; universities hire comparative-politics scholars."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "German foundations (Konrad-Adenauer, Heinrich-Böll) recruit global affairs analysts for outreach."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "RPJPN 2025-2045",
        "reason": "Regional NGOs and aid agencies need country experts but numbers small."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Some EU policy research centres exist; no shortage listing."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Highly Skilled Professional visa",
        "reason": "Policy research institutes hire Asia specialists; Japanese language often mandatory."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Giga-projects hire cultural advisors, yet roles skew to Arabic speakers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Singapore Economy 2030",
        "reason": "Lee Kuan Yew School and ISEAS recruit Asian-studies researchers; EP quotas moderate but doable."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai-based geopolitical forums and media outlets absorb some specialists."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "London think-tanks, BBC and universities remain heavyweight employers for global affairs talent."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Think-tanks analysing trade, security and tech supply-chains receive federal grants, boosting demand for area experts."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "6d3a3e5f-2097-4c51-aad3-446714a79f96": {
    "career": "Pharmaceutical Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Medicinal chemists and pharmacologists sit on CSOL; fast-track visas available."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Post-COVID biomanufacturing push and generous R&D tax incentives attract scientists via Global Talent Stream."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "BioNTech and Bayer expand RNA and cell-therapy labs; shortages in medicinal chemistry."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Biopharma focus for vaccines shows potential, yet regulatory hurdles remain."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Eight of the top ten pharma giants run plants here; scientists on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Highly Skilled Professional visa",
        "reason": "Big pharma (Takeda) recruits foreign PhDs, yet language and seniority requirements narrow field."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan prioritises pharma and medical devices, offering tax breaks for R&D scientists."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Vision 2030",
        "reason": "King Abdullah City for Science & Technology invests in local drug R&D, hiring expats."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Singapore Green Plan 2030",
        "reason": "A*STAR and Tuas pharma hub expand biologics and cell therapy, recruiting international scientists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Operation 300bn",
        "reason": "Growing generics and biotech clusters in Dubai Science Park recruit niche expertise."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences pillar grants speed up hiring across Oxford-Cambridge arc."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA’s biomanufacturing tax credits and BARDA funds fuel record hiring in drug discovery and mRNA scale-up."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "National Master Plan 2021-2030",
        "reason": "Nascent biotech parks need expertise but visa/onboarding still immature."
      }
    }
  },
  "61f7a191-5a80-447f-b0b5-8e8ea6d07316": {
    "career": "Music Technologist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Toronto’s game-audio and film industries offer some roles but not immigration priority."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Berlin’s electronic-music tech scene (Ableton, Native Instruments) imports specialist developers via Blue Card."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Growing game studios need audio programmers, though visas tougher."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Game-audio and vocaloid companies recruit niche foreign engineers with strong portfolios."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Singapore Economy 2030",
        "reason": "Esports and immersive-media clusters hire sound-tech developers under tech visa exemptions."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai studios and XR companies hire some sound-tech talent."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "London’s film/gaming sectors and immersive-audio R&D fall under creative-industry focus."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Growth in spatial-audio chips and creator-economy tech fuels hiring in DAW and plugin companies."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "27",
        "policy": "",
        "reason": ""
      }
    }
  },
  "92f5dfe5-d52a-4516-8586-9bb3306846f1": {
    "career": "Philosophy Instructor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL lists ‘University Lecturer,’ yet humanities specialisms receive lower invitation points than STEM."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Academic lecturers qualify for Express Entry as ‘university professors’ but are not one of the priority occupation pools."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Universities can directly hire foreign lecturers under Blue Card rules; humanities still count as ‘academic specialists.’"
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Universities hire internationally but humanities not on Critical Skills List, so standard General Employment Permit applies."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Lecturers can obtain Professor subclass, but incentives target STEM and robotics first."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Skilled Migrant Category",
        "reason": "University lecturer is eligible for Skilled Migrant visa, but not on the high-priority Green List."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Universities sponsor foreign humanities faculty, but role is outside National AI Strategy 2.0 priorities."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "We the UAE 2031",
        "reason": "Private universities recruit expatriate lecturers, yet humanities not in strategic visa priority lanes."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "‘Higher-education teaching professionals’ remain shortage-listed, easing visa sponsorship despite lower industrial urgency."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "",
        "reason": "Universities routinely sponsor H-1B for humanities faculty, but role is not singled out in recent federal talent priorities."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "1b8ad120-9876-4023-960b-7577722750e7": {
    "career": "Educational Psychologist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Psychologists (including educational) sit on CSOL, enabling 189/190 visas with points advantage."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Allied health professionals score extra points; provincial programmes list psychologists as priority."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Licensed psychologists accepted but language requirement and focus on nursing reduce urgency."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Not on Critical Skills List; eligible for General Employment Permit with employer proof of need."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Limited school-based psychologist demand; language barrier significant."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 2)",
        "reason": "Clinical & educational psychologists appear on Green List giving fast-track residency."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "MOE hires educational psychologists, but they are outside the National AI Strategy talent list."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Private schools employ expatriate psychologists, yet role not singled out in talent agenda."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Educational psychologists were removed from shortage list in 2024, but sponsorship still feasible."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "School districts hire psychologists, but federal immigration focus is elsewhere; visa sponsorship possible yet competitive."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "34b2c513-e108-44cb-89f8-586922255ea6": {
    "career": "Biochemical Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Chemical engineers listed, but government focus skews to mining and construction."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Biomanufacturing is a named priority; engineers get streamlined work permits and PR pathways."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz",
        "reason": "Strong pharma and industrial biotech clusters urgently recruit process engineers."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Push to build biopharma capacity for regional markets."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma giants in Cork and Dublin drive constant shortages of bioprocess engineers."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Highly Skilled Professional visa",
        "reason": "Biotech researchers qualify for top-tier points; domestic aging issues fuel drug R&D."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "NIMP lists pharma and medical devices as strategic growth areas needing foreign talent."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Green List (Tier 2)",
        "reason": "Some demand in dairy biotech, yet not core Green List occupation."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Mega-projects include biopharma zones; foreign expertise sought for new manufacturing plants."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Singapore Economy 2030",
        "reason": "Biomed manufacturing is a flagship sector; EDB grants and ONE Pass target biochemical engineers."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Operation 300bn",
        "reason": "Industrial strategy targets biotech and med-tech, opening Golden Visa for engineers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences pillar offers fast visa and R&D tax credits for biochemical engineers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Federal billions for biotech and bio-manufacturing make biochemical engineers one of the most courted STEM groups."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "National Master Plan 2021-2030",
        "reason": "Government incentivises biotech parks and vaccine manufacturing requiring process engineers."
      }
    }
  },
  "a7c9275a-ca16-4c3b-9c85-f51cd6bc0c75": {
    "career": "Finance Coordinator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Migration Strategy focuses on nurses, engineers, tech—not financial clerks."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Express Entry prioritises skilled trades and tech, not junior finance admins."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Finance coordinators fall outside Critical Skills; some firms use General Employment Permit."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Vision 2030",
        "reason": "Financial services growth in Riyadh and NEOM needs mid-level coordinators, eased by new corporate visas."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Green Plan 2030",
        "reason": "Sustainable-finance push raises demand for mid-level operations roles with ESG literacy."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai International Financial Centre expansion maintains demand for finance support talent."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City financial services prioritise senior talent; junior coordinators still sponsorable but not shortage."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Generic finance roles not targeted by federal talent programmes; employer sponsorship rare."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "61eed133-45cd-4205-9d04-4224b69aec97": {
    "career": "Digital Marketing Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Marketing managers recently removed from priority lists to manage migration numbers."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Express Entry prioritises tech and trades; marketing roles rarely receive LMIA approval."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Tech multinationals always hire marketers, yet Critical Skills list excludes the occupation."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Massive tourism projects fuel demand for senior digital marketing strategists."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Global brands hire regional marketing managers, but role sits outside Manufacturing 2030 priorities."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai’s media and e-commerce hubs sponsor experienced digital marketers for Golden Visa."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative sector push keeps demand for marketing leads, though not on official shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Role exists but no alignment with federal industrial policies aimed at manufacturing and clean energy."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "eb0cd0e2-68db-41f7-9750-f44f3d0b96fc": {
    "career": "GIS Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "GIS supports mining, bush-fire modelling and transport projects classified under data analyst and environmental engineer codes."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "GIS skills valued in natural-resource, forestry and municipal planning streams inside the broader IT occupation codes."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Geospatial analysts assist renewable-energy siting but the occupation is only indirectly referenced."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "New capital Nusantara and mining projects require spatial data but occupation not fast-tracked."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Tech multinationals and pharma clusters use location analytics, but immigration priority is moderate."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-city pilots create some demand for GIS yet numbers are small."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industrial-park planning and environmental compliance need GIS support but not core to policy."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Civil-infrastructure and disaster-management roles list GIS as preferred but not critical-skill."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Mega-projects like NEOM rely on advanced spatial data for urban and tourism master-plans."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National AI Strategy 2.0",
        "reason": "Urban digital twins use geospatial data, but GIS is a supporting rather than priority role."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Operation 300bn",
        "reason": "Smart-city, logistics and environmental monitoring initiatives need geospatial specialists."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Offshore wind and infrastructure build-out use GIS, yet it is not on the shortage list."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Federal funds for highways, broadband and climate resilience require geospatial mapping and asset inventories."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "National Master Plan 2021-2030",
        "reason": "Transport and offshore wind corridors require mapping expertise, creating ancillary demand."
      }
    }
  },
  "b04e630f-8a59-410f-872f-03eadfef9a6f": {
    "career": "Materials Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Critical-minerals processing and renewable projects draw on metallurgical and composite expertise."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "EV supply-chain and clean-tech clusters need alloy, cathode and polymer specialists."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Automotive and green-hydrogen industries face shortages of materials engineers."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel-to-EV battery value chain needs metallurgists and cathode specialists."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Med-tech and pharma manufacturing need polymer and biocompatible material experts."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics and semiconductor giants prize new alloys and dielectrics."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan singles out advanced materials as a strategic pillar alongside semiconductors."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Construction and manufacturing sectors create some openings but role not on critical list."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Aerospace, EV and defence manufacturing parks require materials expertise."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Manufacturing 2030",
        "reason": "Precision-engineering and semiconductor fabs invest in materials innovation but role is supporting, not headline."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing push seeks composite and additive-manufacturing specialists."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean-energy, aerospace and EV battery hubs list materials science as a core capability."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Advanced battery, semiconductor and defense materials receive massive federal R&D incentives."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Chip-packaging and battery plants require materials R&D support."
      }
    }
  },
  "6c456fd0-adfc-49fb-996f-3fa641fbaad0": {
    "career": "Nanodevice Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "CSIRO and university fabs seek nanofab talent though numbers are small."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Quantum and photonics hubs in Ontario and Québec recruit nanoelectronics engineers."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Europe’s semiconductor expansion and Fraunhofer institutes list nanofab roles."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "RPJPN 2025-2045",
        "reason": "Plans for local chip packaging create supporting demand."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Intel’s expansion and Tyndall Institute hire nanofabrication engineers."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Highly Skilled Professional visa",
        "reason": "Government pushes domestic 2-nm production and advanced sensor R&D."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Wafer-fab expansion and MEMS packaging prioritise nanoscale talent."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Some university research posts, but limited industrial fabs."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "KAUST and NEOM tech parks fund nano-sensor R&D for energy and health."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Manufacturing 2030",
        "reason": "National strategy targets leading-edge fabs and quantum chips—direct fit."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "UAE Centennial 2071",
        "reason": "Masdar and Khalifa University invest in nano-electronics and photonics research."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Semiconductor and quantum technology clusters need nanodevice talent."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Federal subsidies target sub-5-nm fabs and quantum devices requiring nano-scale expertise."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Government incentives for design centers and advanced packaging include nanodevice specialists."
      }
    }
  },
  "72cdbbbc-3366-4b23-85b3-57096ed5afb8": {
    "career": "Community Development Officer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Regional development grants mention community engagement but occupation not on CSOL."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Express Entry Category-Based Selection",
        "reason": "French-speaking social and community workers gain extra CRS points in Atlantic and Northern regions."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Integration projects hire social workers, though preference given to EU residents."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Māori and Pacific community initiatives create niche openings for experienced officers."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Most community roles removed from shortage list after 2025."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Grant programs for rural broadband and resilient housing require community liaisons."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "c11de114-9f04-4428-9d0f-2640b2a6ed34": {
    "career": "Studio Practice Specialist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Artists can immigrate through the Self-Employed stream, not priority."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Berlin offers artist visas but limited quotas and proof of income required."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Government funds new museums and cultural festivals, importing studio art trainers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "Arts House residencies exist, but role not a strategic talent category."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Dubai Culture’s golden visa for creative talent explicitly covers established artists."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry Tier 1 visa recognises exceptional talent in visual arts."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Public-art commissions rise with infrastructure revamps but no dedicated visa priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "37a346c4-a4af-4013-a40d-b17ae98479c7": {
    "career": "Musicology Lecturer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Migration Strategy 2023",
        "reason": "‘University Lecturer’ sits on the Medium/Long-Term Skill List, giving 4-year Temporary Skill Shortage visas and PR pathways for regional campuses."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Express Entry Category-Based Selection",
        "reason": "University lecturers with PhDs qualify under Express Entry; French or minority-language music research is a bonus but not a core shortage."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Conservatoires in Bavaria, Berlin and Leipzig actively recruit foreign PhD holders; Blue Card available if you secure a tenure-track role."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Academic lecturing is eligible for Critical Skills permit, though arts funding is tight."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "National universities occasionally hire foreign musicologists to teach in English, but slots are few."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Universities can sponsor under SMC, but music is not on the Green List, so competition and points threshold remain high."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Economy 2030",
        "reason": "Yong Siew Toh Conservatory and LASALLE occasionally hire foreign PhDs; COMPASS points favourable for niche expertise."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Private universities in Dubai/Sharjah hire expat faculty, but arts programmes are small and not a national priority."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Higher-education teaching professionals can obtain Skilled Worker visas; UK conservatoires value South-Asian classical expertise."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "U.S. universities freely sponsor H-1B cap-exempt positions for humanities faculty, and music programs value ethnomusicology expertise."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "1aa83d8c-4782-4e06-b52a-e0f80e52120f": {
    "career": "Automotive Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL covers mechanical engineers generally, yet domestic auto production is limited after 2017 plant closures."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Ontario’s auto plants hire, but the occupation is not on priority lists; Express Entry points still help."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Home to VW, BMW, Mercedes; major push toward e-mobility and autonomous driving, Blue Card fast-tracks qualified engineers."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Huge nickel/EV battery programme and new Hyundai, Wuling plants demand vehicle and power-train expertise."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List covers mechanical engineers, yet Ireland lacks large-scale vehicle manufacturing."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "Toyota, Honda and Nissan seek talent for hybrids and hydrogen cars; English-speaking engineers can get points-based HSP visa."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "NIMP 2030 names EV engineers as critical to grow Proton, Perodua and new battery ventures."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Mechanical engineers are on Tier 2, but auto R&D presence is small."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "NEOM’s electric vehicle project and local assembly plants seek EV engineers, though scale is still ramping."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Green Plan 2030",
        "reason": "Small auto manufacturing base; demand limited to R&D labs for autonomous shuttles."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Operation 300bn",
        "reason": "Manufacturing diversification includes mobility tech, but hiring is smaller than oil & aerospace."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 prioritises advanced auto/EV and battery manufacturing; Jaguar-Land Rover, Nissan, and Formula E teams recruit globally."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA pours billions into EV manufacturing and battery supply chains, creating strong demand for vehicle and power-train engineers."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "VinFast EV push needs auto systems and battery engineers though policy focuses more on semiconductors."
      }
    }
  },
  "c47610f3-6e8f-408f-9b06-41df4c8a567d": {
    "career": "Criminal Justice Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "State police employ few foreigners; crime-policy researchers get employer-sponsored university visas."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Public-safety roles are province controlled; some demand for policy analysts in Ottawa, but not on priority lists."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Research roles in Garda Síochána and NGOs exist but are small and not on Critical Skills list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Some openings in corrections and social-policy research, but strict background checks and preference for citizens."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National AI Strategy 2.0",
        "reason": "Home Team Science & Tech Agency hires foreign crime-data specialists, but numbers are limited."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "We the UAE 2031",
        "reason": "Think-tanks and Dubai Police Innovation Lab hire foreign crime-data experts on limited contracts."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Home Office and private justice charities recruit criminologists and policy analysts; security clearance still a hurdle."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "",
        "reason": "Federal and state agencies recruit analysts for crime prevention, counter-terrorism and reform projects; universities offer OPT-STEM-extension pathways for criminology grads."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "ed2a30dc-72ae-42c1-9d02-0cdff0afcc54": {
    "career": "Data Science Strategist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Migration Strategy 2023",
        "reason": "Core Skills List includes software engineers and data analysts; PR pathways favourable but quota-limited."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Canada’s Global Talent Stream fast-tracks AI and data scientists with two-week LMIA exemptions."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz",
        "reason": "Blue Card for IT specialists simplified in 2024; Berlin start-ups chase data leaders."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "RPJPN 2025-2045",
        "reason": "Fintech boom needs data expertise, yet expatriate quotas per company cap numbers."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Data scientists on Critical Skills list; multinational tech HQs in Dublin hunt for strategic leads."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "Point-based HSP visa favours AI experts; language remains barrier but salaries high in Tokyo."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industry 4.0 roll-out needs data-driven manufacturing leads; MSC visas available."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Software engineers on list, but senior strategy roles few."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "Neom and Saudi Data & AI Authority hire data strategists to diversify the economy."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "National AI Strategy 2.0",
        "reason": "EP/S Pass COMPASS gives bonus points for AI specialists; nation aims for 15,000 more by 2030."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai and Abu Dhabi free zones grant 10-year Golden Visas to AI professionals."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital & AI declared key pillar; Scale-up visas suit experienced data leaders."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Massive federal funding for AI and semiconductor research drives demand for senior data leaders across industries."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Start-ups and banks hire data talent, but visas stricter."
      }
    }
  },
  "4fac5e0c-9396-4a2b-8c0e-d3cd1ee618ff": {
    "career": "International Business Strategist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Management consultants remain on Short-Term list only; visas capped at 2-year terms."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Business consultants qualify, yet CRS cut-offs rising and occupation not prioritised."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Possible via points system, but manufacturing strategy experts preferred over generic business roles."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "RPJPN 2025-2045",
        "reason": "Nusantara capital move sparks demand for consultants, but localisation rules cap expats."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Finance strategists valued, yet not on Critical Skills list; hosting via intra-company transfer common."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points award consulting experience, but Japanese language often required for client work."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Government courting foreign investors needs strategy consultants; EP approvals moderate."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Mega-projects hire consultants to craft diversification playbooks; generous expat packages."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Economy 2030",
        "reason": "Regional HQ hub needs strategists; COMPASS framework rewards high salaries and sectoral priorities like fintech and green trade."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai’s free-zone HQs need strategists for MENA expansion and offer 10-year Golden Visas for high earners."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Scale-up visa helps, but role not on shortage list; consulting houses still sponsor."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Role is common but not singled out by federal talent programmes; H-1B competition high."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National Master Plan 2021-2030",
        "reason": "FDI boom offers roles, yet quotas for foreign managers per firm."
      }
    }
  },
  "05952e69-e063-498a-95e4-1e85ac1f7dea": {
    "career": "Mechanical-Industrial Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Mechanical/industrial and production engineers appear on CSOL and on every state-nomination list."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Mechanical and industrial engineers are on Canada’s core engineering shortage lists and receive extra CRS points."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Germany’s Mittelstand and auto sector face acute shortages of mechanical and production engineers."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel/EV battery plants need process engineers but language/regulatory barriers keep scores moderate."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List covers mechanical engineers, yet absolute hiring volume is modest."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "59",
        "policy": "Highly Skilled Professional visa",
        "reason": "Aging workforce in robotics and auto sectors makes HSP points high for mechanical designers."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Push for aerospace, EV and semiconductor equipment raises steady need for mechanical/industrial talent."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Mechanical and industrial engineers qualify for fast-track residence via Green List Tier 2."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Mega-projects (NEOM, Red Sea) need plant and process engineers, but roles skew toward civil/electrical."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Manufacturing 2030",
        "reason": "Precision-engineering and semiconductor equipment firms actively offer EPs to experienced mechanical/industrial engineers."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Operation 300bn",
        "reason": "Diversifying into advanced manufacturing creates some demand for industrial engineers, but scaled hiring is limited."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Offshore wind, aerospace and auto/EV clusters actively recruit mechanical engineers under Skilled Worker visa."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Massive spend on advanced manufacturing, EV plants and resilient supply-chains is driving demand for mechanical & industrial engineers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "National Master Plan 2021-2030",
        "reason": "Electronics and transport build-out creates pockets of demand, but wages remain low for foreign engineers."
      }
    }
  },
  "6162a82a-4caf-41a9-b75e-61bff163c4eb": {
    "career": "Biochem Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Migration Strategy 2023",
        "reason": "Medical-research institutes secure visas for biochem PhDs, though numbers are smaller than IT/engineering."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Biotech hubs in Toronto/Montreal actively recruit PhDs under STEM stream with expedited permits."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Bio-pharma clusters in Hessen and Bavaria lack enough lab scientists, easing Blue Card routes."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "RPJPN 2025-2045",
        "reason": "Biopharma is listed, but regulatory uncertainty and low R&D spend limit hiring."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma giants in Cork and Dublin rely on international biochem PhDs; Critical Skills permit grants 2-year stamp 4."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Highly Skilled Professional visa",
        "reason": "Growing bio-startup ecosystem in Kobe & Tsukuba gains HSP points for researchers with PhDs."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "63",
        "policy": "MADANI Economy",
        "reason": "Strategic focus on pharma and med-devices boosts need for biochem R&D staff."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Limited but growing demand via agri-biotech; funding caps keep volumes low."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "New biotech parks planned, yet present lab capacity remains nascent."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Singapore Economy 2030",
        "reason": "Biomed Hub, A*STAR and pharma MNCs aggressively sponsor EPs for biochem and protein engineers."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Government is wooing biotech researchers for new genomic and precision-medicine initiatives."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences designated as a growth pillar; visas fast-track lab scientists via Global Talent route."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds biomanufacturing and climate-bio solutions, expanding NIH & DOE grant pools for biochem R&D."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "National Master Plan 2021-2030",
        "reason": "Early-stage biotech sector offers few senior research posts for foreigners."
      }
    }
  },
  "66c57ada-3d96-46d9-8045-9853bac34424": {
    "career": "Management Associate",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Business generalists receive no category points; only French speakers might gain a small edge."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Highly Skilled Professional visa",
        "reason": "Corporate graduate tracks exist, but language barrier lowers practicality."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "MADANI Economy",
        "reason": "Local university graduates fill most junior management roles; visas focus on technical talent."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Mega-projects hire management trainees but prefer Saudi nationals under Saudization quotas."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Economy 2030",
        "reason": "MNCs run structured associate programs and get EPs, but role is not on priority lists so score moderate."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "UAE Centennial 2071",
        "reason": "Free-zone MNCs recruit management associates yet no immigration fast-track exists."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "No shortage list coverage; only graduate schemes at sponsoring firms are viable."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Generic business graduates are not a policy focus; hiring driven by corporate demand, not immigration incentives."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "62cad3c0-fe13-40b3-ac90-255d1c3fd2b4": {
    "career": "Political Economist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Migration Strategy 2023",
        "reason": "Universities can sponsor Global Talent visas, but humanities quotas are small."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Academic roles qualify for work permits, yet competition is intense and funding limited."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Research institutes and EU policy centres value economists; new points system helps PhDs."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Economists appear on lists, but funding and tenure-track spots are scarce."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Highly Skilled Professional visa",
        "reason": "Some university posts available, yet Japanese language often required."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Social-science academics face limited openings outside a few universities."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Singapore Economy 2030",
        "reason": "Lee Kuan Yew School and ADB offices attract international political-economy scholars."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Regional think-tanks employ some foreign economists, but roles are senior and specialised."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "LSE, Oxford and Treasury recruit political economists for research on regulation and trade."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Think-tanks and universities hire researchers to assess policy impacts, but not a formally prioritised occupation."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "ccb31acb-bc38-4ad9-a96c-2df1ab17daf4": {
    "career": "Info Systems Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "ICT managers are on the Medium-Long-Term list, enabling 4-year TSS visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Express Entry Category-Based Selection",
        "reason": "IT managers fall under STEM NOC codes with strong CRS scores."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Digitalisation drive opens Blue Card routes for experienced IT managers."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Large digital banks seek IT leaders, but expatriate licence fees and localisation reduce demand."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "ICT managers are explicitly listed; hires receive immediate Stamp 4 after two years."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "59",
        "policy": "Highly Skilled Professional visa",
        "reason": "Points system rewards management experience, but language remains a hurdle."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "MADANI Economy",
        "reason": "Shared-services centres grow, yet foreign manager quotas are tightening."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "ICT managers are on Tier 2; job offer plus NZQA assessment required."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "Government entities upgrading systems hire expatriate IT managers, but Arabic fluency preferred."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "National AI Strategy 2.0",
        "reason": "Banks and data-center operators hire IT managers, though EP passes require high salaries."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Fintech and logistics giants recruit IT managers under Golden Visa criteria."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital transformation in public sector and finance fuels Skilled-Worker sponsorships for ICT managers."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Digital modernisation funding boosts demand for IT managers across public infrastructure projects."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "2f01a446-655c-4727-996c-9d89af3f6052": {
    "career": "Curator",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Mega-projects (NEOM, AlUla) building museums and require experienced curators."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Vibrant arts scene but no dedicated visa priority."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Government invests in world-class museums (Louvre Abu Dhabi) and fast-tracks senior creative hires."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry shortage visas cover senior museum professionals."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Large museum sector but no immigration incentives for arts jobs."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "42c04fc7-33b9-4d85-88b4-35afee63f3aa": {
    "career": "Lab Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "STEM visas exist but lab management not on CSOL priority list."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "STEM researchers score high CRS but role not singled out for fast-track."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Science roles welcome but quota space favours engineers."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Biopharma growth and halal vaccine projects seek lab leadership."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma and med-tech labs dominate Ireland's FDI sites; managers on shortage list."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP explicitly lists biotech researchers and fast-tracks lab leaders."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Biotech and medical device clusters expanding under NIMP need lab supervision talent."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Green List focuses on clinicians and software engineers."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "New biotech and health research centres seek experienced lab managers."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Singapore Economy 2030",
        "reason": "Biomed Hub and A*STAR provide Employment Pass priority for lab managers."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "UAE Centennial 2071",
        "reason": "Abu Dhabi's biotech hubs offer Golden Visas for lab leaders."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences R&D is a headline priority; skilled-worker visas fast-track laboratory seniors."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds biomanufacturing and advanced R&D, expanding lab operations staff."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "National Master Plan 2021-2030",
        "reason": "Growing pharma and agritech sectors recruiting experienced lab staff."
      }
    }
  },
  "9d4b5a44-e010-4225-996d-2461da1b5496": {
    "career": "Earth Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Environmental scientists on CSOL; mining-heavy economy values geoscience skills."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Role eligible under general Express Entry but not a named shortage."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Renewable energy build-out and environmental remediation boost demand for earth scientists."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "RPJPN 2025-2045",
        "reason": "Geothermal and critical-minerals exploration relies on earth-science talent."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Critical Skills list omits geoscience."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Renewable-energy geologists can qualify under HSP but numbers are small."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "MADANI Economy",
        "reason": "Carbon-storage and oil exploration require earth scientists, yet not a headline priority."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Green List covers civil engineers; geoscientists receive standard skilled-migrant points."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Carbon-storage studies and groundwater mapping create limited but real geoscience roles."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Some demand in carbon capture projects, not on shortage lists."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Offshore wind and CCUS projects call for subsurface expertise, but no fast-track."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA funds climate resilience and geological surveys, driving demand for geoscientists."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "National Master Plan 2021-2030",
        "reason": "Offshore wind and LNG-to-power projects need marine geology advice."
      }
    }
  },
  "14433ef5-7174-4c5e-aa97-b231203fca71": {
    "career": "Mining Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL names mining engineers; visas processed in weeks for remote sites."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Metals and potash sectors list mining engineers, fast CRS points in resource provinces."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Coal exit reduces demand; only small potash industry hires."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel and EV-battery ambitions hinge on mining engineers."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "Critical-minerals projects in overseas assets seek Japanese-sponsored engineers."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Tin and rare-earth expansions require mining engineering expertise."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Vision 2030",
        "reason": "Massive investment in gold, phosphate and rare-earth mines needs engineers."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "No dedicated visa priority, but critical-minerals push creates some need."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Bauxite and rare-earth development for semiconductor supply chain boosts demand."
      }
    }
  },
  "1e048391-6279-4d8b-bdb6-c4873d7e2e72": {
    "career": "Engineering Associate",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Civil, electrical and mechanical technician roles on CSOL for regional visas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Technologists and associate engineers fast-tracked, especially in construction and manufacturing."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Acute shortage of technologists to support automotive and industrial platforms."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "RPJPN 2025-2045",
        "reason": "Infrastructure in new capital raises demand for associate engineers."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Civil/mechanical technician grades listed as critical skills."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Industrial machinery and construction SSW categories accept diploma engineers."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industry 4.0 upgrades need automation associates."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Migrant Category",
        "reason": "Construction boom values diploma-level engineers, although not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Mega-projects employ many engineering technicians for supervision and BIM."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Prefers degree engineers; diploma roles filled locally."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing expansion needs associate engineers in factories."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Infrastructure and clean-energy projects open roles, though visas focus on chartered engineers."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Demand exists in infrastructure projects but no specific visa priority."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "National Master Plan 2021-2030",
        "reason": "Electronics manufacturing hubs recruiting diploma engineers."
      }
    }
  },
  "0cac8b1e-c810-47c7-9351-08fd0c33032d": {
    "career": "Speech-Language Pathologist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "Allied-health professionals on Core Skills Occupation List with regional visa incentives."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "SLPs fall under health-care practitioners on priority list and qualify for fast PR."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe shortage of therapists; recognition pathway and Opportunity Card points."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Speech and language therapists explicitly listed for Critical Skills Permit."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Hospitals hire foreign therapists, but language barrier and no dedicated quota."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Speech therapists on Green List Tier 2 with work-to-residence route."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Large hospital expansion and rehab centres recruit foreign SLPs."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Green Plan 2030",
        "reason": "Healthcare manpower needed, but SLP not on priority hiring lists; EP attainable case-by-case."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Healthcare specialists fast-tracked for Golden Visa; private clinics hiring."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "SLPs included on shortage list but visa caps tighter than top destinations."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "—",
        "reason": "Allied-health shortages exist but no federal talent scheme; state licensure only."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a63e0fb3-bb13-45fc-8979-9e26218e55a1": {
    "career": "Chemistry Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Chemical and materials scientists on priority list for resources and clean-energy projects."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "STEM researchers welcome but not singled out for expedited visas."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Strong demand for industrial chemists in green-hydrogen and pharma clusters."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel battery value-chain drives moderate demand for electro-chemists."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma and med-tech multinationals need synthetic and analytical chemists."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "Semiconductor and battery chemistry R&D firms offer point-based fast visa."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Specialty-chemical and semiconductor materials labs expanding."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Visas possible but chemistry not on Green List; limited openings."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Neom and Aramco fund materials and hydrogen research; foreign PhDs recruited."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Singapore Economy 2030",
        "reason": "Biomed and specialty-chem R&D granted five-year Employment Passes under Tech.Pass."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing and pharma R&D zones hiring chemists with Golden Visa eligibility."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences pillar funds drug discovery; Global Talent visa fast-track for researchers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "CHIPS and Science Act",
        "reason": "Funding for materials science, battery and semiconductor chemistry labs."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Need for materials chemists growing but immigration channels nascent."
      }
    }
  },
  "33543210-ed59-4a91-acf4-931ff385f056": {
    "career": "Engineering Mechanic",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Mechanical fitters and plant technicians on shortage list for regional visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Industrial mechanics listed under skilled trades with extra CRS points."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Industrial mechatronics and machinery maintenance face acute shortages; streamlined Ausbildung recognition."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "RPJPN 2025-2045",
        "reason": "EV and mineral plants lack experienced equipment maintenance talent."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "—",
        "reason": "Manufacturing growth moderate; roles fill locally first."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Industrial machinery maintenance is an SSW field allowing five-year visas."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "NIMP 2030",
        "reason": "Automation and semiconductor fabs need maintenance mechanics."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Maintenance fitters on Tier 2 with work-to-residence pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Megaprojects need equipment maintenance staff; employers sponsor visas quickly."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Manufacturing 2030",
        "reason": "Precision-engineering sector hires but prefers local diploma holders; EP possible for senior specialists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Operation 300bn",
        "reason": "Industrial diversification raises demand but preference for subcontracted labour."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Mechanical technicians eligible but cap space limited."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Modernisation spending raises demand for maintenance techs but no visa fast-track."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "National Master Plan 2021-2030",
        "reason": "Electronics manufacturing parks recruit foreign lead mechanics."
      }
    }
  },
  "4b316668-af54-482f-9639-e0ec5f397382": {
    "career": "HR Director",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Management roles eligible yet not prioritised in points grid."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Multinationals in NEOM seek experienced expat HR leaders."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "—",
        "reason": "EP possible but HR not on National AI Strategy priority list."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai and Abu Dhabi free zones sponsor senior HR professionals for Golden Visa."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "—",
        "reason": "Eligible under Skilled Worker visa but not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "—",
        "reason": "No federal priority, but senior managers obtain H-1B/O-1 case-by-case."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "3c21e17f-1fb2-4ca0-b17b-847eb830c0d7": {
    "career": "Anthropology Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "—",
        "reason": "Universities sponsor Global Talent visas under Academia stream."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Academic PhDs attract points; SSHRC funds social-science research."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Blue Card available for post-docs; Max Planck Institutes recruit."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "—",
        "reason": "Some post-doc funding but not on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "—",
        "reason": "Language barrier and limited slots for foreign social scientists."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Economy 2030",
        "reason": "Universities fund area-studies research; EP available but competitive."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "UAE Centennial 2071",
        "reason": "NYU-Abu Dhabi and museums hire cultural researchers on academic visas."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "—",
        "reason": "Universities sponsor Skilled Worker and Global Talent visas; heritage sector active."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "—",
        "reason": "Universities and museums sponsor J-1/H-1B visas for researchers despite no federal priority scheme."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "3640559d-cd5c-4705-98a0-a13514687d8b": {
    "career": "Marketing Director",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "Massive tourism and entertainment projects require senior brand strategists, though Saudization limits foreign hiring."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "Creative-media sector growing, but marketing leadership is not on any priority visa list."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "Growth of creative & media hubs opens senior marketing spots, but no official shortage designation."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry senior roles are mentioned, but visa path still competitive and capped."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Major federally funded projects need public-outreach and branding expertise, but role is not on any shortage list."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "c8f03e32-60ec-46e2-aea3-ff7b9fa19786": {
    "career": "Political Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Migration Strategy 2023",
        "reason": "Universities can sponsor humanities researchers under Global Talent stream."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Strategy makes research academics eligible for fast-track work permits."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Card awards points for doctorates and research offers, including social sciences."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "PhD-level researchers qualify for Research Host Agreement route."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Points system rewards published research; humanities allowed though not prioritized."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Migrant Category",
        "reason": "Academic roles possible, but not priority area."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "National AI Strategy 2.0",
        "reason": "Policy institutes hire for governance studies but it’s niche."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "UAE Centennial 2071",
        "reason": "Think-tanks in Abu Dhabi recruit, yet not a listed shortage skill."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Universities and policy institutes can sponsor under Skilled Worker visa even though field isn’t on shortage list."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "CHIPS and Science Act",
        "reason": "Act boosts federal social-science funding via NSF; universities hire foreign researchers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "c43ca635-8832-420d-a571-0663f7559c7b": {
    "career": "Project Coordinator",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL lists construction project managers; coordinators fit feeder stream."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Construction managers receive provincial nominations, though coordinator is a junior tier."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Massive housing and rail upgrades need site coordination talent."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "RPJPN 2025-2045",
        "reason": "Nusantara capital build drives need for project staff, but bureaucracy high."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List lists construction PMs; coordinators treated as general admin."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Green List (Tier 2)",
        "reason": "Senior PMs on list; coordinators possible with employer sponsorship."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Mega-cities (NEOM, Red Sea) create thousands of coordinator posts."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Green Plan 2030",
        "reason": "Construction roles mainly filled by regional labour under quota, not EP holders."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Operation 300bn",
        "reason": "New industrial zones and transport corridors hire bilingual coordinators."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Shortage list covers only senior engineers; juniors still sponsorable."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "US$1 trn infrastructure spend fuels demand for construction project staff."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "National Master Plan 2021-2030",
        "reason": "Infrastructure boom creates some demand, but no special visa."
      }
    }
  },
  "e9494f4c-c46e-4d34-b4da-2e32372364f6": {
    "career": "Research Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Data analysts on new Core Skills List, but quotas limited."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Dedicated AI talent stream offers 2-week work permits for data scientists."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialists can move without degree if experience proven; demand acute."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech boom needs analysts, but immigration still bureaucratic."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Data scientists explicitly listed, offering immediate Stamp 4 residence."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Highly Skilled Professional visa",
        "reason": "High points for AI researchers with PhDs and high salaries."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan names AI and Industry 4.0 analytics as core skills."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Software engineers listed; data roles accepted under same ANZSCO code."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "Smart-city and fintech projects recruit data teams, but localisation rising."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "National AI Strategy 2.0",
        "reason": "AI/ML specialists qualify for 5-year Tech.Pass and fast-track PR."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai, Abu Dhabi free-zones compete for AI labs with 10-year Golden Visas."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital and AI roles prioritised; Global Talent visa available."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act pours billions into AI and data-science R&D, accelerating visas for researchers."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Strategy includes AI/ML engineers to support chip ecosystem."
      }
    }
  },
  "4bdf95f9-d9bb-4f64-8a23-339da8d6da9e": {
    "career": "Aeronautical Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Defence aerospace projects seek engineers, though numbers modest."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Not on targeted list, but individual firms still sponsor."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Airbus Hamburg and space start-ups lobby for easier visas."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "RPJPN 2025-2045",
        "reason": "Plans for domestic aircraft manufacturing, but early stage."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "No major aerospace manufacturing."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Highly Skilled Professional visa",
        "reason": "Mitsubishi, JAXA hire under HSP points system."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "NIMP names aerospace as a focus, especially MRO and drones."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Military aerospace and new airlines recruit foreign engineers urgently."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Economy 2030",
        "reason": "Aerospace MRO hub at Seletar seeks engineers, but quotas tight."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "UAE Centennial 2071",
        "reason": "Space programme (Mars Mission) and MRO giants need talent, 10-year Golden Visa available."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Aerospace and defence engineers are named priority occupations."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds aerospace R&D, hypersonics and advanced materials, driving talent demand."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National Master Plan 2021-2030",
        "reason": "Small but growing drone/aerospace cluster."
      }
    }
  },
  "f4882f97-2402-4fb1-9c3a-dea3a380f77c": {
    "career": "Cybersecurity Project Lead",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "‘Cyber Security Engineer/Lead’ sits on the CSOL giving fast-track visas and state nominations."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Cyber-security professionals receive highest CRS bumps under new tech stream and are actively invited to apply."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT-Spezialisten may enter without degree if experienced; cyber-security programme managers meet shortage criteria."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Government mentions cybersecurity but prioritises EV and minerals engineers."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "‘ICT security specialist’ on Critical Skills list with two-year work-to-residency pathway."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Highly Skilled Professional visa",
        "reason": "Role fits IT category but not singled out; language barrier keeps demand moderate."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "MADANI Economy",
        "reason": "Digital-trust mentioned but incentives focus on semiconductor and aerospace ahead of security management."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "No Green List listing but points available for senior ICT security managers."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Massive investments in fintech and defence create steady demand for cyber leads, yet expatriate quotas are tightening."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "National AI Strategy 2.0",
        "reason": "Cybersecurity engineers included in Tech@SG pass but competition and local-hire quotas keep it Tier 2."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "National AI and digital-trust push elevates need for programme-level cyber talent across banking and government."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Cybersecurity specialists are explicitly listed; fast-track Skilled-Worker visas and NCSC funding."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Critical-infrastructure cyber-resilience funds create demand for security programme managers but role not explicitly listed as a top-priority occupation."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "National Master Plan 2021-2030",
        "reason": "ICT push leans toward AI and e-commerce; cyber programmes still nascent."
      }
    }
  },
  "f310dfcb-0521-480e-97af-31a2c11638c5": {
    "career": "Process Designer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Migration Strategy 2023",
        "reason": "Engineering shortages skew civil and mining; chemical process sits lower priority."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Chem-process roles recognised but trail health-care and digital occupations."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Green-chemistry push and industrial decarbonisation create solid need for process design experts."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel-to-battery and green-hydrogen megaprojects urgently need chemical process designers."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List focuses on pharma-operations roles rather than early-stage process design."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Openings exist in specialty-chem but language and age-seniority norms slow entry."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Specialty chemicals and advanced materials headline initiatives—process designers are critical hires."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Small petrochemical base limits openings to niche fertiliser plants."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Refinery upgrades, hydrogen and ammonia plants require experienced process designers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Singapore Green Plan 2030",
        "reason": "Petrochem cluster mature; incremental hiring only for carbon-capture pilots."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Operation 300bn",
        "reason": "Industrial diversification and green-hydrogen projects create moderate demand."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "CCUS and sustainable aviation-fuel pilots need chemical process expertise."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Battery, hydrogen and bio-manufacturing tax credits drive demand for chemical process engineers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Demand is growing in chip-chem supply chain but still emerging."
      }
    }
  },
  "50536a30-78d6-4cf9-8f22-5c07ab226f25": {
    "career": "Applied Physicist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "Physics academics listed, but limited spots compared with mining engineers."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Research chairs and public labs recruit, but quota priority is healthcare and ICT."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Max Planck and DESY hire astrophysicists; new points system rewards STEM doctorates."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Physics researchers welcome, but not on priority list."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "Subaru and JAXA hire foreign astrophysicists; HSP gives fast permanent residency."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Skilled Migrant Category",
        "reason": "Small astronomy community centres on one radio observatory."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Vision 2030",
        "reason": "King Abdullah Space Center funds astrophysics to support new satellite programmes."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Economy 2030",
        "reason": "Grants exist for quantum and photonics physics, but astronomy investment limited."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Emirates Mars Mission and Dubai Space Centre create niche roles for space physicists."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "UKRI funds large astronomy collaborations; Global Talent visa eases entry."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "CHIPS and Science Act",
        "reason": "Large NSF funding for basic physics and space telescopes, yet immigration favours engineering first."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "46e0b272-a394-4754-94bf-99ebf6ef78f3": {
    "career": "Embedded Systems Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Electronics engineers listed but demand smaller than mining/civil."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Encourages hardware start-ups but primary focus remains software."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "81",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Automotive and industrial IoT giants urgently seek embedded developers."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "69",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV battery and smart-manufacturing initiatives growing, but ecosystem early."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Most hardware design is in multinational outposts; fewer greenfield projects."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics and auto suppliers need C/C++ embedded talent; HSP eases immigration."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Government aims to be global embedded-systems hub for chip packaging and IoT."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Skilled Migrant Category",
        "reason": "Few large electronics manufacturers; roles limited to agritech start-ups."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Defence and smart-city programmes create moderate embedded-system demand."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Manufacturing 2030",
        "reason": "Precision-engineering and robotics clusters list embedded specialists for priority EP processing."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "67",
        "policy": "Operation 300bn",
        "reason": "Drone and robotics clusters recruit embedded engineers though visa policy is broad."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Semiconductor and aerospace R&D hubs list embedded roles on shortage list."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Massive subsidies for semiconductor R&D and edge-device design put embedded talent at the centre."
      },
      "vietnam": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Chip-design start-ups and EMS firms aggressively courting embedded engineers."
      }
    }
  },
  "72cbbada-9752-49c1-8d69-0ff7942f5455": {
    "career": "Enzymologist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Migration Strategy 2023",
        "reason": "Biotech on priority list only for senior medical scientists; enzyme research moderate."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Biotech clusters in Toronto and Vancouver hire but not an official priority stream."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Industrial biotech and pharma need enzyme experts for biocatalysis scale-up."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Focus on biopharma production and palm-oil enzyme applications."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "81",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma scientists are fast-tracked; enzyme specialists valued in biologics."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Highly Skilled Professional visa",
        "reason": "Biotech researchers qualify for HSP, but ageing corporate labs slow hiring."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan names pharmaceuticals and medical devices—enzyme R&D central to biologics manufacturing."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Green List (Tier 2)",
        "reason": "Food biotech roles exist but few in number."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Major investment in biopharma and precision medicine creates research posts."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Green Plan 2030",
        "reason": "A*STAR pours funds into enzyme engineering for sustainable biomanufacturing."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "We the UAE 2031",
        "reason": "New biotech free-zones in Dubai require enzyme R&D for diagnostics and therapeutics."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences growth pillar funds enzyme engineering for pharma and green chemistry."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Bio-based fuels, green chemistry and biotech tax incentives expand enzyme discovery programmes."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "National Master Plan 2021-2030",
        "reason": "Government promotes agritech and biotech but funding still growing."
      }
    }
  },
  "a34aabc8-7d9f-47a3-9b82-8f72ee3a7449": {
    "career": "Hardware Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Electrical/electronic engineers on shortage list—consultants welcomed for defence and mining automation projects."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "IT and engineering occupations fast-tracked; hardware specialists lumped with software/electrical engineers."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Automotive and industrial firms need external electronics advisors for EV and Industry 4.0 lines."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV battery and electronics clusters need advice on testing hardware and supply-chain localisation."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Large U.S. chip fabs in Ireland source external hardware experts for process optimisation."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "Highly Skilled Professional visa",
        "reason": "Government courting semiconductor talent; consultants obtain top-tier HSP fast points."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Nation doubling down on IC design and packaging; outside consultants in high demand for tech transfer."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Green List (Tier 2)",
        "reason": "Some demand for electronics engineers in renewable projects, but consulting niche is small."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Mega-projects (NEOM) and defence localisation need hardware advisors for IoT and smart-city builds."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Manufacturing 2030",
        "reason": "Semiconductor hub funds precision-hardware experts; consulting services qualify for Tech.Pass."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Operation 300bn",
        "reason": "Push for advanced manufacturing and space tech creates consulting gigs in component selection and reliability."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 flags semiconductors/advanced manufacturing; consultants help scale local chip prototypes."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Huge incentives for semiconductor design/fab and electronics experts; consulting demand from new fabs and reshoring projects."
      },
      "vietnam": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Aggressive targets for chip design centres; foreign consultants hired to upskill local teams rapidly."
      }
    }
  },
  "19ae2061-9034-4539-a230-cda678d4af59": {
    "career": "Landscape Architect",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Urban greening in heat-struck cities gives some openings, but not officially prioritised."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Not on priority list; opportunities tied to municipal hiring only."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Sustainability focus in urban renewal, yet other engineers ranked higher."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital Nusantara requires large-scale sustainable landscape design talent."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Aging cities retrofit green spaces, yet few visas earmarked for this niche."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "MADANI Economy",
        "reason": "Eco-tourism initiatives create intermittent need, not formally prioritised."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Migrant Category",
        "reason": "Tourism landscape projects exist but quotas small."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Gigaprojects like NEOM and The Line need vast desert landscaping and public-realm design."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Green Plan 2030",
        "reason": "Ambition to be 'City in Nature' raises demand for skilled landscape architects."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Smart-city and tourism hubs invest heavily in parks, promenades and resort landscapes."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Brownfield regeneration budgets exist but role not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Federal funds for parks and green storm-water projects generate moderate demand."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "National Master Plan 2021-2030",
        "reason": "Urban green corridors planned in Hanoi/Ho Chi Minh; limited expatriate hiring."
      }
    }
  },
  "31d2a255-690b-4a00-914d-2940b6e92e5e": {
    "career": "Music Education Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Migration Strategy 2023",
        "reason": "Universities vie for international PhDs to lift research rankings."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities recruit PhDs broadly, especially bilingual or diversity researchers."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Strong public funding for musicology; easy English-language research posts."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not listed, but tax incentives for R&D cover arts grants too."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Music pedagogy research exists, but language barrier limits roles."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "MADANI Economy",
        "reason": "Private universities hire occasionally; not a policy priority."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Some roles at conservatories, but small market."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Vision 2030",
        "reason": "Entertainment push funds music academies, yet research focus limited."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National AI Strategy 2.0",
        "reason": "NAFA/Yong Siew Toh hire foreign scholars, but not policy-backed priority."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai cultural hubs sponsor limited education research posts."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Russell Group universities compete globally for arts scholars."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "No direct alignment; still strong academic grants culture supporting arts research."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "192b8f4a-10fb-4b3a-88d4-666eae5d10eb": {
    "career": "Research Technician",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Migration Strategy 2023",
        "reason": "CSIRO and AIMS need technicians for reef and fisheries projects."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Oceans tech clusters in Halifax and BC recruit lab and field techs."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Some positions at Helmholtz marine centres, but German language needed."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Asta Cita",
        "reason": "Marine biodiversity hotspots need technicians, but wages low."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Marine Institute Galway recruits seasonal technicians."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "JAMSTEC deep-sea programmes require skilled techs."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "MADANI Economy",
        "reason": "Coral restoration and aquaculture grants modest."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Green List (Tier 2)",
        "reason": "NIWA and universities require field technicians for aquaculture studies."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Red Sea giga-projects fund coral research, but limited roles."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Green Plan 2030",
        "reason": "Coastal protection R&D funds limited technician slots."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Marine conservation labs small; hiring occasional techs."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "UKRI funds marine robotics, needing support staff."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "CHIPS and Science Act",
        "reason": "Marine labs receive NSF boosts for climate and ocean tech."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "National Master Plan 2021-2030",
        "reason": "Fisheries research growing but local hires preferred."
      }
    }
  },
  "c6af610e-9a18-455d-985f-6087c8740a9f": {
    "career": "Marketing Coordinator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Migration Strategy 2023",
        "reason": "Marketing removed from core skills list; few visa points."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Occupation not prioritised; open permits only if employer sponsors."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Possible under points system, but German-language barrier."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "E-commerce growth but junior roles filled locally."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on list; tech multinationals sometimes sponsor via intra-company transfer."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "MADANI Economy",
        "reason": "Digital-marketing roles exist but locals available."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Role not on Green List; low points weight."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Vision 2030",
        "reason": "Tourism boom creates some English-language marketing jobs."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "MOM tighter on generic marketing passes; only senior strategists prioritised."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Dubai agencies hire expat coordinators but preference for experienced managers."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries strong, yet visa salary threshold high for junior coordinators."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Clean-tech firms need comms staff, but role not policy-driven."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "06755920-975a-4a0b-9165-975a1c933fcb": {
    "career": "Bioscientist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Biotech not core list but visas available under ‘medical researcher’ stream."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Program funds life-sciences clusters in Toronto and Vancouver, offers work permits to researchers."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Pharma and bio-industry qualify as STEM; English-speaking labs sponsor visas."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Bio-pharma research promoted yet visa pathways nascent."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma/biotech corridor ‘Silicon Docks of Biopharma’ needs molecular biologists."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "Regenerative medicine labs recruit foreign PhDs under fast-track points."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan names pharma scientists and medical-device R&D as priority."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "47",
        "policy": "Skilled Migrant Category",
        "reason": "Limited biotech firms but PhD scientists score high points."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Vision 2030",
        "reason": "NEOM and biotech parks recruit niche genomic researchers."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Economy 2030",
        "reason": "Biomed hub (A*STAR, Biopolis) actively grants EPs to bioscientists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Operation 300bn",
        "reason": "Dubai Science Park and Abu Dhabi's biomanufacturing push need researchers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences is priority; fast-track visas for lab scientists."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act pours billions into biotech R&D, gene-editing and bio-manufacturing labs need PhD scientists."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National Master Plan 2021-2030",
        "reason": "Growing agri-biotech and vaccine manufacturing but still emerging."
      }
    }
  },
  "b55dbf75-af3b-49ef-bbc4-5254e0a6e889": {
    "career": "Math Education Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Secondary STEM teachers on shortage list; fast 482 visas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Early-childhood and K-12 teachers explicitly prioritized; math specialists earn extra CRS points."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe shortage of STEM teachers; Länder sponsor English-speaking educators."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "41",
        "policy": "RPJPN 2025-2045",
        "reason": "Some IB schools hire foreigners; bureaucracy heavy."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List covers STEM lecturers, not school specialists; modest demand."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "English-medium international schools hire, but outside priority schemes."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "MADANI Economy",
        "reason": "Education reforms ongoing yet no dedicated visa priority."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Green List (Tier 2)",
        "reason": "Secondary maths teachers gain straight-to-residency pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Vision 2030",
        "reason": "International schools hire math specialists, but Saudization limits public roles."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "49",
        "policy": "Singapore Economy 2030",
        "reason": "MOE prefers citizens; only private tuition centres hire expats."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "Private IB/IGCSE schools recruit expatriate math curriculum leads."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Math teachers removed in 2025, but academies still sponsor visas selectively."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "STEM outreach grants create some curriculum roles but not immigration priority."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "National Master Plan 2021-2030",
        "reason": "Growing demand in international schools but few immigration perks."
      }
    }
  },
  "22c9c236-b57b-4c14-a49e-05236dddb72f": {
    "career": "Business Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "Role exists on general skilled list but strict points requirement."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Management consultants eligible yet not priority category; CRS points moderate."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Business analysts qualify via points but not shortage occupation."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "41",
        "policy": "RPJPN 2025-2045",
        "reason": "Management consultants needed for Nusantara project but bureaucracy heavy."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Consulting not on critical list; employers must prove labour market test."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Possible via points but language barrier limits demand."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "MADANI Economy",
        "reason": "Strategy consultants hired for industrial master plan but no special visa."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Consultants must meet high salary thresholds; few visas granted."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Mega-projects hire strategy consultants to diversify economy."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Singapore Economy 2030",
        "reason": "Consultants welcomed but earning thresholds high; not top-tier priority."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai and Abu Dhabi free zones issue quick permits for consulting talent."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "71",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Financial services and digital clusters rely on management consultants; skilled-worker visas common."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Corporate transformations create advisory work but no dedicated immigration pathway."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "National Master Plan 2021-2030",
        "reason": "FDI projects employ advisors yet still emerging market."
      }
    }
  },
  "a1efcff6-d6ce-4883-8645-83bcb778e666": {
    "career": "Clinical Social Worker",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Social workers on medium-term list; PR pathway after licensing."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Care-economy shortages; provinces nominate licensed social workers."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Demand in eldercare, but language requirements stringent."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on list; public service caps visas."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Role not recognised in visa categories."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "MADANI Economy",
        "reason": "Limited recognition of foreign licences."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "53",
        "policy": "Skilled Migrant Category",
        "reason": "Qualified social workers eligible yet salary thresholds high."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Vision 2030",
        "reason": "Hospitals hire therapists, but localisation limits roles."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "MOH limits foreign social-work licenses."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Private hospitals recruit, but licensing onerous."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Clinical social workers on shortage list until 2027 review."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Behavioral-health grants expand therapy services, but not immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4bcddd71-811e-426a-815e-e7f2ff2371d4": {
    "career": "Cyber Security E-Learning Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Cybersecurity trainers on priority visas to upskill workforce."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Cybersecurity specialists top priority; training roles qualify under NOC 21220."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz",
        "reason": "IT specialists can immigrate without degree; e-learning firms growing."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech boom creates need for cybersecurity upskilling; limited specialist visas."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Cybersecurity lecturers/trainers on critical list."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP welcomes cyber experts; language barrier lower for online course roles."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "MADANI Economy",
        "reason": "National Cyber Security Strategy funds training programs."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Limited but rising demand for cyber trainers."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Government funds cyber academies for national defense and banking."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "National AI Strategy 2.0",
        "reason": "GovTech funds cyber-upskilling; e-learning creators can obtain Tech.Pass."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "We the UAE 2031",
        "reason": "Dubai Cyber Innovation Park sponsors visas for training experts."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital/cyber on shortage list; ed-tech London sector booming."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "CHIPS and Science Act",
        "reason": "Funds cybersecurity workforce programs; ed-tech creators welcomed on H-1B via training providers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Cyber training demand rising but visas still case-by-case."
      }
    }
  },
  "e294d7a7-e595-48e4-9aca-238b3c507015": {
    "career": "Global Studies Professor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "",
        "reason": "Migration list favours STEM and healthcare; humanities academics still obtain university-sponsored visas case-by-case."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities qualify under broad research talent stream, yet humanities is lower priority than STEM."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Universities can directly sponsor professors; Germany actively recruits international faculty."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Universities recruit selectively; Critical Skills list excludes most humanities."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP covers professors generally, but funding concentrated in tech."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "International branch campuses hire some faculty; national plans focus on industry 4.0, not humanities."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Universities hire some foreign faculty, but not on Green List priorities."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Vision 2030",
        "reason": "New private universities in NEOM seek international faculty, though humanities demand modest."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "NUS/NTU recruit globally, but national talent lists emphasise tech and finance."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "We the UAE 2031",
        "reason": "Branch campuses (NYUAD, Sorbonne) recruit globally, but policy favours tech, not social science."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Global Talent visa and university sponsorship make the UK a major destination for political science academics."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Research universities hire heavily, but role not singled-out in federal talent policy."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a6c123ac-54bf-46b2-983c-9edd83566fa2": {
    "career": "International Hospitality Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Tourism rebound creates vacancies, yet CSOL omits generic hospitality managers."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Category-based Express Entry favours transport and trades, not hotel management."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "",
        "reason": "Bali and new capital need hotel talent, but localisation rules rising."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Hotel staff and managers included in SSW; rapid inbound-tourism growth."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Tourism recovery, but NIMP prioritises manufacturing over services."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Tourism-heavy economy recruits hotel managers, but not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Mega-projects (NEOM, Red Sea, AlUla) urgently need global hospitality leaders."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Tourism significant, yet national talent lists focus on tech/finance."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai & Abu Dhabi push luxury tourism; golden visas for experienced managers."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Large hospitality sector, but immigration policy does not prioritise it."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Resort expansion hiring foreigners, yet no dedicated visa priority."
      }
    }
  },
  "aee8382f-1cbd-4a63-a8b7-879cee581a10": {
    "career": "Investment Banker",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Sydney IB market smaller; migration lists focus on engineers."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Express Entry includes finance but favours tech; IB roles limited to Toronto."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Frankfurt banks recruit EU talent first; no immigration priority."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Sovereign-fund and mineral IPOs generate some IB demand, but not a priority list."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Dublin’s IFSC targets investment and structured-finance roles on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "IB hiring exists but language barrier and domestic talent pool dominant."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "MADANI Economy",
        "reason": "Islamic finance grows, yet list prioritises manufacturing talent."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Sovereign wealth fund and giga-projects drive demand for corporate finance expertise."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Economy 2030",
        "reason": "Global banking hub with tailored visas; policy lists fintech, but IB piggybacks."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "UAE Centennial 2071",
        "reason": "DIFC/ADGM hubs offer golden visas to senior bankers to grow regional capital markets."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London is explicitly named under financial-services pillar with visa pathways."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "",
        "reason": "Wall Street dominates deal flow, though finance not in federal priority acts."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4b349e46-dab5-4b1f-8a83-28da6d02fd02": {
    "career": "Public Health Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "Epidemiologists & health managers on core skills list post-COVID."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Healthcare and French-speaking public-health pros receive top points."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe shortage in public-health authorities; fast-track for qualified specialists."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "RPJPN 2025-2045",
        "reason": "Health resilience goal opens limited expatriate expert slots."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Health specialists included within medical scientists stream."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Health sector values language fluency; visas doable but limited."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Government ups epidemiology capacity, yet foreign hiring selective."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Health system lists public-health medicine specialists for straight-to-residence visas."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Expanding preventative-care programs within massive healthcare investment."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "MOH Office for Healthcare Transformation imports niche public-health talent despite tech focus."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "We the UAE 2031",
        "reason": "National strategy highlights disease surveillance and health data analytics."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "NHS hires overseas public-health consultants, though list prioritises life-sciences R&D."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "CDC and state agencies recruit, but no dedicated immigration priority."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "International NGOs hire, but no national priority."
      }
    }
  },
  "40654cb7-7849-4309-bdea-0a9924027d9c": {
    "career": "Aerospace Structures Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Growing space agency yet not on CSOL; case-by-case sponsorship."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Montreal aerospace cluster hires, but not explicit priority."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz",
        "reason": "Airbus and ESA need engineers; easier visas for STEM."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "47",
        "policy": "",
        "reason": "PTDI and satellite projects exist but list prefers EV and geothermal."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Aerospace manufacturing small; not on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP targets aerospace and robotics engineers for JAXA and Mitsubishi."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Aerospace is flagship sector; Selangor hub courting foreign engineers."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Rocket Lab hires few specialists; no Green List mention."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Military aviation manufacturing and newly announced space program recruit expats."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Singapore Economy 2030",
        "reason": "Aerospace MRO and additive-manufacturing expansion need structural design skills."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Operation 300bn",
        "reason": "UAE Space Agency & Strata MRO need composite-structure talent."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Aerospace and defense engineering explicitly prioritised; visas streamlined."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Defense, space, and advanced manufacturing funding escalate demand for structural engineers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Nascent aerospace ambitions; some supplier jobs, not policy priority."
      }
    }
  },
  "3af72e5c-45e7-4429-b855-119f099d06d1": {
    "career": "Gender Studies Educator",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Global Talent and university-sponsored visas target high-skill educators to strengthen tertiary sector."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "PhD-holders gain extra points; universities actively hire lecturers in humanities and sponsor visas."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "New rules ease residence for doctorate-level lecturers at German universities."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Lecturers not on list but universities can issue Hosting Agreements for researchers."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "PhD educators meet points threshold; demand modest in gender studies."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Points system welcomes PhD lecturers though role not on Green List."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "National AI Strategy 2.0",
        "reason": "Humanities faculty hired, but quotas favour tech fields; teaching pass still obtainable."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "UAE Centennial 2071",
        "reason": "Knowledge-economy push keeps some demand for university lecturers but humanities is peripheral."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Universities freely sponsor lecturers even if subject is not on shortage list."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "CHIPS and Science Act",
        "reason": "Universities receive federal research funding and can sponsor H-1B cap-exempt faculty posts in social sciences."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "d3777aa1-28cf-45f6-a50f-1359dd435849": {
    "career": "Marine Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Great Barrier Reef and offshore energy drive urgent demand; fast-track visas for environmental scientists."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Atlantic and Pacific coast provinces actively recruit marine researchers for fisheries and climate work."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "North Sea research institutes hire scientists, but field is niche and German language often required."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Huge archipelago invests in coral, mangrove and blue carbon research."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Marine Institute projects linked to Atlantic Strategy give limited openings."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "Island nation invests in fisheries tech and tsunami research, valuing English-speaking PhDs."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Blue-economy rhetoric exists but funding still emerging; postings concentrated in Sabah/Sarawak."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "List names marine scientists for climate adaptation and fisheries sustainability; pathway to residence."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Red Sea giga-projects need coral and environmental experts, though roles are project-based."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Green Plan 2030",
        "reason": "Limited coastline but funds urban coastal resilience studies and tropical marine labs."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Coastal development and mangrove restoration create moderate demand for marine ecology specialists."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Offshore wind expansion funds marine impact studies; universities can sponsor Skilled-Worker visas."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Climate provisions fund ocean-carbon and coastal resilience research through NOAA, universities and startups."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National Master Plan 2021-2030",
        "reason": "Government targets sustainable fisheries and offshore wind, requiring marine impact scientists."
      }
    }
  },
  "9f2e0517-6b07-4f79-811c-9762c2a4e3ee": {
    "career": "Music Program Administrator",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "31",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List focuses on tech and pharma, not arts management."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Huge investment in entertainment sector opens limited management posts for international talent."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Singapore Economy 2030",
        "reason": "Arts managers exist but Employment Pass quota tightening reduces entry chances."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Dubai Opera and Abu Dhabi festivals recruit experienced arts managers on project visas."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry growth supports sponsorship for seasoned administrators, but not on shortage list."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Arts organisations still sponsor visas via O-1 but role not policy-driven."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "31",
        "policy": "",
        "reason": ""
      }
    }
  },
  "e5fb3385-ec06-47ef-9d75-f889f19123a0": {
    "career": "Global HR Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Migration Strategy 2023",
        "reason": "Employer-sponsored visas available, but HR not on Core Skills list."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Senior corporate managers can use Global Talent Stream though preference given to tech roles."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Managers with German language and global experience can qualify; not shortage occupation."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV and infra projects import HR expertise short-term."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Tech multinationals can sponsor HR managers under intra-company transfer."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points reward management experience; bilingual demand moderate."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Manufacturing push needs HR leaders; liberal EP rules for senior roles."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "HR management not on Green List; points threshold high."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Mega-projects recruit expat HR leaders to implement Saudization and talent pipelines."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Singapore Economy 2030",
        "reason": "Global HQs base HR in Singapore; COMPASS framework scores favour seasoned managers."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Free zones and multinationals constantly hire global HR leaders to manage diverse workforces."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Large corporates sponsor senior HR under Skilled-Worker visa despite no shortage listing."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Large clean-tech firms need HR leaders, but role not immigration-priority; H-1B possible with sponsorship."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "National Master Plan 2021-2030",
        "reason": "FDI plants hire expat HR to establish systems, but permits capped."
      }
    }
  },
  "76bb0e4d-c397-41a5-a01d-4aeb0d637de3": {
    "career": "Physics Instructor",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Secondary STEM teacher shortages extend to college physics lecturers via skilled visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "PhD instructors earn extra CRS points; demand in French and remote colleges."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Research universities sponsor English-taught physics and astrophysics programs."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Physics lecturers not on list but research institutes issue Hosting Agreements."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Physics PhDs meet points; English-medium programmes limited."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Migrant Category",
        "reason": "STEM teachers earn high points though not explicitly on Green List for tertiary level."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "New science universities (KAUST, NEOM) hire international physics faculty."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Economy 2030",
        "reason": "Rising physics enrolments and space ambitions create limited openings at NUS/NTU."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Branch campuses of US/UK universities recruit physics instructors under Employment Pass."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Universities can sponsor lecturers; astrophysics tied to space strategy."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "CHIPS and Science Act",
        "reason": "Act pours funds into STEM education; universities sponsor H-1B cap-exempt physics faculty."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      }
    }
  },
  "6393c6d4-9a4e-46b0-bcc3-8317994a7dcd": {
    "career": "Structural Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "‘Structural Engineer 233214’ sits on CSOL; visas fast-tracked for major infrastructure and mining projects."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Civil/structural engineers receive extra CRS points under the 2024 STEM-Engineering draw."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Acute shortage of Bauingenieure for rail, housing and wind-farm foundations; Opportunity Card simplifies recognition."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nusantara new capital drives roles, but Bahasa licensing exams limit access."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "National Development Plan 2030 earmarks €165 bn; structural engineers on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Highly Skilled Professional visa",
        "reason": "Earthquake-resilient design specialists gain extra points in HSP scoring table."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industrial park expansions create some demand, but preference for local PE licence."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "‘Structural Engineer’ is Tier 1 Green List—direct residence pathway after two years."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Vision 2030",
        "reason": "NEOM, Red Sea and giga-projects need seismic-ready structural design expertise."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "Most structural work fulfilled by regional firms; only niche high-rise specialists recruited."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Operation 300bn",
        "reason": "Smart-city, rail and mega-tower pipelines keep demand high, but local licence required."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Shortage list covers civil engineers for HS2 and offshore wind foundations."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "US$1.2 trillion for bridges, tunnels and resilience—federal contractors urgently need licensed structural engineers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "National Master Plan 2021-2030",
        "reason": "Transport corridor boom needs bridge engineers, yet salary levels suppress foreign hiring."
      }
    }
  },
  "b5261a85-68d4-40f5-9405-ab3fe18b6797": {
    "career": "Corporate Finance Associate",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "Banking roles compete with domestic graduates; only niche M&A talent sponsored."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Finance professionals welcomed, yet not in category-based draws; CRS score must be high."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Possible via points system, but finance not a listed shortage occupation."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Capital-market reforms open doors, but Bahasa and local CPA expected."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "IFSC lists financial analysts and fund accountants as critical skills."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Tokyo’s new asset-management push offers points, but language barrier high."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "MADANI Economy",
        "reason": "Kuala Lumpur promotes Islamic corporate-finance talent for sukuk structuring."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Sector small; roles filled locally unless Big-4 urgently require expertise."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Privatisation wave and sovereign-wealth deals need valuation analysts."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Economy 2030",
        "reason": "Global treasury hub status keeps steady demand for associates experienced in cross-border deals."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai DIFC courts global corporate-finance talent; Golden Visa available for professionals earning AED 30k+."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London M&A and PE roles explicitly prioritised under financial-services pillar."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Clean-energy tax-credit deals create specialised modelling roles, but no dedicated visa priority."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National Master Plan 2021-2030",
        "reason": "Fast-growing economy, yet corporate finance still largely domestic."
      }
    }
  },
  "edd7b9c6-7c15-4a09-bfce-4d0242c4a244": {
    "career": "Maori Language Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Migration Strategy 2023",
        "reason": "Universities fund Indigenous language centres; academic visas available."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Parallel First Nations revitalisation creates openings for comparative linguists."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Humanities researchers possible through Blue Card, but funding scarce."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Gaelic language revitalisation intersects with Māori comparative studies."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Skilled Migrant Category",
        "reason": "Government goal of 1 million speakers by 2040 drives strong demand for Te Reo scholars."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Economy 2030",
        "reason": "Niche roles in language-technology labs; very limited openings."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Some Celtic-language institutes hire comparative scholars, but funding tight."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "CHIPS and Science Act",
        "reason": "Grants support indigenous-language AI datasets, but visas competitive."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "cb7bec3c-3f69-4892-8b80-e6bba7d620e8": {
    "career": "Architect-Urban Designer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Major city-reshaping projects in Melbourne and Sydney actively sponsor architects."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Large housing targets create demand; architects qualify under FSWP."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Green urban renewal needs talent but language and registration hurdles remain."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "New capital Nusantara is a once-in-a-generation urban-design opportunity."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Some shortages for urban-renewal projects, but limited overall volume."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-city pilots welcome overseas architects with IoT expertise."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industrial-park townships need planners, but foreign registration difficult."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Only specific infrastructure architects on list; others go through general route."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "NEOM, Red Sea and Diriyah hire global urban designers at scale."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Economy 2030",
        "reason": "Redevelopment ongoing, but supply of local architects meets most needs."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Constant skyline reinvention in Dubai/Abu Dhabi drives Golden Visa offers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry pillar supports sustainable urban-design talent."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Federal funding for transit-oriented development boosts need for urban designers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National Master Plan 2021-2030",
        "reason": "Rapid urbanisation, yet fees low versus global market."
      }
    }
  },
  "0102b255-709c-48cd-98e0-a9e8df6817fe": {
    "career": "Digital Business Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Migration Strategy 2023",
        "reason": "Digital-skills shortages recognised, yet generic managers face points-test competition."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Demand exists, but not in category-based draws; general Express Entry route only."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Eligible via points, but no official shortage listing for business managers."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "E-commerce boom continues, yet Bahasa and local network expected for managerial posts."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "ICT project managers on list, but generic business roles less prioritised."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "Digital-transformation push under DX Strategy, yet Japanese fluency demanded."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Industry 4.0 roll-outs require talent, but local hires preferred."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Small market—higher points required unless salary very high."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Vision 2030",
        "reason": "State-owned firms racing to digitise operations recruit experienced transformation managers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Singapore Economy 2030",
        "reason": "Headquarters of many SEA tech firms; EP salary benchmark suits experienced digital managers."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "We the UAE 2031",
        "reason": "E-commerce, fintech and logistics giants look for digital P&L leaders; Golden Visa available."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital pillar values managers who can scale AI and cyber projects."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "CHIPS and Science Act",
        "reason": "Tech firms need managers who align hardware, software and revenue during digital expansion."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "National Master Plan 2021-2030",
        "reason": "Digital-economy targets create some roles, salaries modest for expats."
      }
    }
  },
  "ef382fc3-e40d-44b8-829a-057977fb2dfa": {
    "career": "Finance Educator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Lecturers are eligible for skilled visas, but finance is outside the Core Skills Occupation List."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Academic instructors can qualify under general skilled stream, yet finance teaching is not on targeted shortage lists."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Universities may sponsor, though finance lecturers are not on priority shortage lists."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Finance lecturers can use general work permits; not on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Universities hire foreign professors via HSP, but finance not a highlighted shortage."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Primary need is STEM and primary teachers; finance faculty fall under general skilled migration only."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Economy 2030",
        "reason": "Business schools and finance hub create lecturer demand, yet educators are not on priority lists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "International campuses in Dubai/Abu Dhabi recruit finance faculty, but outside stated national priorities."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Business schools recruit globally, yet the occupation is not on the shortage list."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Universities freely sponsor H-1B cap-exempt faculty; steady demand for finance MBAs but not a federal shortage occupation."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "7397866c-b28b-4907-a248-7c5861f9c8df": {
    "career": "Systems Architect",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Software and systems engineers are on CSOL; architect roles qualify though not singled out."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Software and AI architects receive priority work-permit processing under tech streams."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT-Spezialisten fast-track welcomes experienced system architects for Industry 4.0 firms."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV and data-centre expansion needs architecture talent, but bureaucracy heavier."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Systems and software architects listed; stamp-4 residency after two years."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP gives points for master's + high salary; robotics and semiconductor firms need architects."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan emphasises semiconductor and automation systems—architect skills in demand."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Software engineers on Green List; senior architects qualify with salary above threshold."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Mega-projects at NEOM and fintech push demand for senior system architecture talent."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "National AI Strategy 2.0",
        "reason": "Tier-1 tech pass for senior architects building AI platforms and semicon control systems."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Operation 300bn",
        "reason": "Push for advanced manufacturing and cloud services needs architects; long-term Golden Visa available."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital, semiconductor and AI are IS-8 pillars; senior architects qualify for fast visas."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Architects for complex semiconductor, AI and cloud systems are directly supported by new R&D funding and immigration priorities."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "System architects crucial for new chip design centres and cloud providers."
      }
    }
  },
  "1277732c-5e45-47f2-ab1e-fc0dcf3a7d45": {
    "career": "Elementary Education Coordinator",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Primary teaching and curriculum leaders are on CSOL with points boost."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Primary teachers are priority; coordination roles often bundled and qualify under same NOC."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe shortage of early-years teachers; coordinators benefit though paperwork complex."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Some shortages in rural schools; coordinators may secure work permits but no critical-skills status."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Primary teachers explicitly Tier-1; curriculum coordinators gain straight residence pathway."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Private international schools hire coordinators but not a national priority."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "States control hiring; federal lists do not prioritise K-12 coordinators."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "e4d45798-df99-4f67-be6d-7a0362a319bf": {
    "career": "School Business Leader",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Migration Strategy 2023",
        "reason": "Education admin roles can obtain visas via employer sponsorship though not on CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Fits general management NOC; not prioritised but possible with high CRS score."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Private international schools expanding; admin managers imported but not priority."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Booming private education sector hires business managers though role not strategic priority."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Academy trusts recruit School Business Managers; shortage localised but visas possible with sponsorship."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Districts may sponsor, but role not on any federal shortage or STEM list."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "6b78129a-6455-4f6f-b302-9faa48bbaee1": {
    "career": "Urban Education Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Equity specialists needed in low-SES suburbs, but not on CSOL."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Toronto, Vancouver boards hire urban education consultants under general skilled streams."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Some demand in immigrant-heavy cities; visa possible through NGOs."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Māori/Pasifika education initiatives may sponsor specialists under general skilled rules."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Dubai schools in low-income areas hire for inclusion projects, but limited quota."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Academy trusts in deprived boroughs sponsor occasionally; not on shortage list."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Big-city districts and nonprofits sponsor experts to close achievement gaps though no federal shortage designation."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "99d7e3f9-6365-4809-a552-41604257118f": {
    "career": "Diplomatic Studies Associate",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "General skilled-visa points possible for social-science researchers; not on core list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Open category for French/English bilingual policy analysts yet role not explicitly prioritised."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Political-science researchers qualify under academic track but no shortage listing."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Academia path possible, but role not on Critical Skills list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Academic research roles gain points but not on Green List."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Economy 2030",
        "reason": "RSIS and Lee Kuan Yew School recruit international researchers; strategic studies aligned with national agenda."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "We the UAE 2031",
        "reason": "Abu Dhabi & Dubai host growing policy institutes but hiring is niche."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "",
        "reason": "London think-tanks and universities recruit global IR talent under Skilled Worker visa."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Think-tanks and university institutes hire foreign IR analysts on H-1B, but no dedicated talent policy."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4f088327-f9dd-4e6f-83e6-9ce8815a85a3": {
    "career": "Environmental Manager",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Large mining and infrastructure projects mandatorily hire environmental officers to keep licences."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Carbon-pricing regime and mining projects make certified environmental professionals highly sought for Express Entry."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Energiewende and strict EU ESG reporting create shortage of Umweltmanager in industry."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel/EV supply chain must meet global ESG, yet preference for local hires."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma and data-centre clusters recruit EHS managers to meet EU directives."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Corporate ESG pressure exists but domestic talent supply adequate; immigration possible case-by-case."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Semiconductor and chemicals plants expanding under NIMP need compliance staff, yet visa slots limited."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Migrant Category",
        "reason": "Renewable projects and biodiversity offsets require compliance managers though role not on Green List Tier 1."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Giga-projects (NEOM, Red Sea) need sustainability oversight for international investment standards."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Singapore Green Plan 2030",
        "reason": "Mandatory sustainability reporting drives demand for qualified environmental managers in finance and industry."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Operation 300bn",
        "reason": "Industrial decarbonisation plans demand ISO-14001 managers in manufacturing zones."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Offshore wind and EV initiatives require environmental governance to secure permits and funding."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds clean-energy plants that must meet strict environmental-compliance requirements, driving demand for EHS managers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National Master Plan 2021-2030",
        "reason": "Foreign-owned factories face rising ESG audits, but localisation push keeps scores moderate."
      }
    }
  },
  "3dc9878c-444f-4167-92fb-cea602a0e63e": {
    "career": "Language Instructor",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Regional schools face shortages; state visas available for language teachers."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "French-immersion and newcomer-ESL teachers included in teaching shortage lists."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Integration courses need certified German-as-second-language teachers; visas streamlined."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "International schools recruit ESL teachers, but quota controls persist."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Role outside Critical Skills; possible through general work permit."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Public JET and eikaiwa schools routinely sponsor Instructor visa, but not on shortage lists."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "MADANI Economy",
        "reason": "Demand for international-school teachers exists, yet local hire preference."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Migrant Category",
        "reason": "ESOL and Māori-medium shortages open pathways even if not Green-List Tier 1."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Economy 2030",
        "reason": "Hiring very selective; MoE prioritises citizens, some private centres sponsor."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Huge private ELT market, but degree + CELTA usually enough under skilled visa."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Post-2025 languages no longer on shortage list; independent schools still sponsor visas."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Private language schools hire on H-1B cap-exempt, but not a national shortage role."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National Master Plan 2021-2030",
        "reason": "Booming ELT market; easier work permits outside national priority list."
      }
    }
  },
  "a29ba2b7-d653-4a9f-ba83-8499cb2a20b2": {
    "career": "Theatre Instructor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Some state nomination for creative educators, yet not on CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Arts educators can qualify under general stream; no dedicated shortage."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Public conservatories occasionally hire international faculty under academic provisions."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Economy 2030",
        "reason": "Arts schools occasionally import specialist acting coaches; strict quotas apply."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "We the UAE 2031",
        "reason": "Dubai creative-arts schools employ overseas instructors but visas discretionary."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "London drama schools world-renowned; Skilled Worker route possible but competitive."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "University drama departments sponsor visas, but field not on priority lists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "d09d17ae-4220-4d85-bbd6-4e275a7dce83": {
    "career": "Wildlife Biologist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Bushfire recovery and biodiversity offsets raise demand for ecology experts."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Conservation scientists included under agri-science and natural-resources priority streams."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Renewable projects require species impact assessments, but German language expected."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Orangutan and coral-reef conservation rely on international biologists under NGO visas."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Wind-farm EIAs drive some hiring, but permit routes general."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Endangered-species research grants exist; immigration pathway case-by-case."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "MADANI Economy",
        "reason": "Rainforest conservation NGOs need biologists; not an industrial priority."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Migrant Category",
        "reason": "Predator-free 2050 plan employs field biologists though not Green-List Tier 1."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Biodiversity-net-gain rules fuel ecology consultancies yet not shortage-listed."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA funds habitat restorations requiring field biologists for impact studies."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National Master Plan 2021-2030",
        "reason": "Mekong biodiversity projects create limited foreign-hire slots."
      }
    }
  },
  "c3f4d863-d879-4e92-8527-59bbfad625a0": {
    "career": "Gender and Politics Specialist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Express Entry Category-Based Selection",
        "reason": "French-speaking social scientists can gain points; not an occupation-shortage priority."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Universities can sponsor visas for political-science lecturers under the general skilled visa pathway."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "24",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "27",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "49",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Universities may hire political scientists, but they are not on the shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Academic social-science roles obtain H-1B visas but are not listed in strategic talent programmes."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "24",
        "policy": "",
        "reason": ""
      }
    }
  },
  "41196711-c330-4e96-8885-b80047cd40a0": {
    "career": "NGO Director",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Community-services managers can migrate under the general skilled list, yet no priority points."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Social-services managers earn CRS points but are not priority occupations."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Leadership roles in health NGOs possible under general management codes."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "RPJPN 2025-2045",
        "reason": "National plan encourages global health partnerships; visas still discretionary."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Critical Skills List targets tech, pharma and engineering, not NGO leadership."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Skilled Migrant Category",
        "reason": "Green List omits NGO leadership, but skilled migrant route allows entry with high points."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Charity-sector leaders can be sponsored, but not on shortage list."
      },
      "united_states": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "605ef760-22e0-4798-be06-24002f7608a1": {
    "career": "QA Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Construction surge requires site QA inspectors to meet safety standards."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Civil engineering technologists are sought but QA is not in top shortage tier."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Strict DIN norms and renewable infrastructure create high demand for quality specialists."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "RPJPN 2025-2045",
        "reason": "Nusantara capital construction opens some space for foreign QA experts."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Construction QA fits SSW construction category but not high-skill tier."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Infrastructure and semiconductor fabs drive moderate need for QA engineers."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Rebuild after earthquakes keeps QA roles busy in civil projects."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Vision 2030",
        "reason": "Mega-projects like NEOM need rigorous on-site quality oversight."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Operation 300bn",
        "reason": "Smart-city and transport projects require material and workmanship verification."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "HS2 and offshore wind foundations need QA staff despite not being on shortage list."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Massive federal rebuild needs quality control experts on roads, bridges and broadband projects."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "National Master Plan 2021-2030",
        "reason": "Transport and power builds require QA but local hiring preferred."
      }
    }
  },
  "aee0eb2e-e6ec-4123-99cf-86e6187e1b27": {
    "career": "Data Science Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Migration Strategy 2023",
        "reason": "Digital skills valued, but data science lumped with general software list."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "New stream fast-tracks AI and data-science leaders to permanent residence."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Blue Card favours IT specialists; demand high but paperwork heavier."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech expansion needs data talent, yet immigration still opaque."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Multinationals in Dublin aggressively hire senior data science talent."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points favour AI researchers but language expectations remain."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "MADANI Economy",
        "reason": "Growing analytics hubs but incentives aimed more at manufacturing engineers."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "59",
        "policy": "",
        "reason": "Green List covers software engineers, not explicitly data science leads."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Kingdom invests in AI hubs, importing data leaders for megacity projects."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "National AI Strategy 2.0",
        "reason": "Tech.Pass and COMPASS accelerate visas for senior data leaders driving AI R&D."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "We the UAE 2031",
        "reason": "Golden Visa targets data scientists for fintech and logistics platforms."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "AI and cyber are explicit pillar industries with fast visa endorsements."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Frontier AI and semiconductor R&D explicitly prioritised for visas and funding."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "AI skills helpful but semiconductor emphasis dominates."
      }
    }
  },
  "8527c667-5950-4a09-abf2-ca6fd8a85f25": {
    "career": "Food Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Agricultural innovation roles supported but not core shortage."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "71",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Agri-food technologists gain extra CRS points, especially French speakers."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Food technologists included in general skilled migration, moderate demand in vegan products."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Food security and palm-oil diversification drive need for food technologists."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "",
        "reason": "Large dairy processors hire some scientists but visas competitive."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "MADANI Economy",
        "reason": "Halal food innovation creates moderate demand for R&D specialists."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Dairy sector urgently needs food scientists for value-added exports."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Food security initiatives open some R&D posts in arid-crop technology."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Singapore Green Plan 2030",
        "reason": "City bets on urban farming and cultured meat, importing niche food-science talent."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "59",
        "policy": "",
        "reason": "Food innovation exists but not on shortage lists post-Brexit."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Alt-protein and climate-smart agriculture grants create demand for food R&D talent."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Seafood-processing upgrades require food safety scientists, but local talent preferred."
      }
    }
  },
  "cfec2a63-6858-4ef5-9304-057270c12636": {
    "career": "Data Miner",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "The list names software and data professionals as priority skilled migrants."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Data scientists and AI specialists are one of the newest fast-track immigration categories."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialists, including data analysts, can obtain work visas without degree equivalence."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech push demands data skills, but no dedicated fast-track yet."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Data scientists and analytics roles qualify for immediate Critical Skills permits."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Highly Skilled Professional visa",
        "reason": "AI/ML researchers get preferential points and five-year renewable status."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industry 4.0 adoption needs data talent, but policy spotlights engineers over analysts."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Points granted for ICT roles but not singled out on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Mega-projects need analytics talent, but priority is construction and tourism leadership."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "National AI Strategy 2.0",
        "reason": "Data engineers and miners eligible for COMPASS bonus points under Tech@SG."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing and fintech clusters recruit data specialists for industrial AI."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital/AI specialists are on the shortage list with fast-tracked Global Talent visas."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Big-data and AI analytics talent directly supports federally funded semiconductor and AI R&D hubs."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "AI/ML skills valued to boost semiconductor sector, yet immigration paths still forming."
      }
    }
  },
  "96d83cda-4c87-4ae6-ba36-27e7821a9c7d": {
    "career": "Screenwriter",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Creative roles get standard points; big-budget productions seek local writers first."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Film incentives exist, yet no dedicated immigration stream for writers."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Vision 2030",
        "reason": "Government funds film studios in NEOM and seeks international storytelling talent."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "We the UAE 2031",
        "reason": "Dubai Media City offers freelance visas for senior media professionals."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Film & TV creative leaders qualify for Global Talent visas under Creative route."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Not directly targeted but O-1 visa path for creative talent keeps Hollywood accessible."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "415f840b-13cc-41cc-8f53-985a912b6d37": {
    "career": "Chief Marketing Officer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "Senior managers earn points but no fast-track for marketing."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Business managers can immigrate via points, yet marketing is not a priority stream."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "General managers eligible yet STEM and trades take precedence."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "CMO not on list; companies may still obtain work permits case-by-case."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Tourism and entertainment push needs marketing heads, but Saudization quotas apply."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Singapore Economy 2030",
        "reason": "Brands hire CMOs, but COMPASS framework gives no bonus points to generic marketing."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "UAE Centennial 2071",
        "reason": "Free-zones recruit global CMOs for fintech and hospitality growth."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry scale-ups can sponsor Global Business Mobility visas for CMOs."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Corporate leaders still hired, but role not explicitly incentivised by policy."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "f3fac8ec-7fa0-43f9-8bc4-9db371fc5627": {
    "career": "Clinical Psychology Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Migration Strategy 2023",
        "reason": "Mental-health researchers fall under health shortage categories and university sponsorship."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Healthcare and research psychologists get dedicated points and fast processing."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Universities can sponsor non-EU psychologists; clinical roles in shortage."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Clinical psychologists on list; research posts qualify for Critical Skills permit."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Highly Skilled Professional visa",
        "reason": "Points mainly for STEM researchers; psychology lower demand."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "MADANI Economy",
        "reason": "Healthcare expansion ongoing but not a current immigration spotlight."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Clinical psychologists on Tier 1; researchers benefit indirectly."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "New hospitals recruit mental-health staff, but research posts fewer."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Green Plan 2030",
        "reason": "Mental-health R&D is emerging but not yet a priority immigration track."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Academic health centres expanding yet clinical licences tightly controlled."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences R&D visas exist, but NHS focuses on medtech over psychology."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "CHIPS and Science Act",
        "reason": "Federal R&D funding covers mental-health AI projects, enabling research visas."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "0cc9867b-797e-4c36-b6b1-8f778cac1bba": {
    "career": "EU Law Specialist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Trade-law advisors gain points, yet EU expertise not singled out."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Germany seeks EU-law jurists for federal ministries and corporate compliance."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "EU law solicitors qualify for Critical Skills permits in Dublin’s financial hub."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Economy 2030",
        "reason": "Regional HQs hire EU lawyers for GDPR and competition advice, yet no fast-track."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "We the UAE 2031",
        "reason": "Free-zone firms value EU trade knowledge but sponsor only senior lawyers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Post-Brexit firms need EU law expertise for cross-border deals; sponsored via Global Business Mobility."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "CHIPS and Science Act",
        "reason": "Corporations need EU regulatory counsel for transatlantic trade but no visa priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "ab772c7a-0ccc-4a2f-96d3-ebf9dab550c8": {
    "career": "Manufacturing Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Industrial & mechanical engineers included on long-term skills list for visa sponsorship."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Industrial and production engineers receive extra CRS points and are on many Provincial Nominee lists."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Acute shortage of mechanical/production engineers for Mittelstand and auto sector reshoring."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel-to-battery and EV plants bring steady demand for manufacturing expertise."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Some demand in med-device and pharma plants but fewer overall slots."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "Highly Skilled Professional visa",
        "reason": "Semiconductor and robotics plants aggressively recruit foreign manufacturing engineers."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Expanding semiconductor back-end and EV supply chain needs process engineers."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Occasional demand in food-processing plants but not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Mega-projects and defense localisation require advanced manufacturing capability."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Manufacturing 2030",
        "reason": "Precision-engineering and biomedical manufacturing encourage hiring of experienced process engineers."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Operation 300bn",
        "reason": "10-year plan to grow industrial GDP creates roles in smart factories."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Advanced manufacturing, EV battery and aerospace clusters on shortage lists."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Large federal funding for advanced manufacturing, EV and semiconductor plants needs process and industrial engineers."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "National Master Plan 2021-2030",
        "reason": "Electronics export boom and new fabs require manufacturing optimisation talent."
      }
    }
  },
  "6797a728-b170-4d49-84c9-ed86e9670c96": {
    "career": "Music Historian",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "Academic hiring possible; not an occupation in shortage lists."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities may sponsor specialists but role not on priority list."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Strong classical heritage keeps demand for musicologists in museums and opera houses."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Occasional university posts; not on critical list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "UK universities and heritage institutions employ music historians; creative industries value archival expertise."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "CHIPS and Science Act",
        "reason": "National Endowment for Humanities still funds academic musicology though not a STEM priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "6a129cd9-f09f-4f07-b7af-af2a480a3933": {
    "career": "Urban Geographer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Some state lists include spatial scientists but not nationwide shortage."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Provincial programs seek GIS and urban planning professionals."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Urban planning demand exists, yet preference is EU talent."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "RPJPN 2025-2045",
        "reason": "Relocation of capital to Nusantara drives need for urban geographers."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-city pilots recruit some GIS experts but language barrier high."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "MADANI Economy",
        "reason": "KL urban renewal opens limited roles for foreign consultants."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Regional councils hire GIS analysts; not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "NEOM and other giga-projects require experts in spatial planning and liveability metrics."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Singapore Green Plan 2030",
        "reason": "Limited slots due to small size; expertise valued for liveability studies."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Smart-city and sustainability initiatives in Dubai and Abu Dhabi need urban geography skill sets."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Levelling-up and HS2 projects look for urban geospatial analysts."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Massive spending on transit and climate-resilient cities needs spatial analysis experts."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "National Master Plan 2021-2030",
        "reason": "Rapid urbanisation and metro projects increase demand for spatial planning."
      }
    }
  },
  "87485b8c-2538-47b4-bd40-54a3a84c76e7": {
    "career": "Biology Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Medical and life-science researchers on long-term skills list."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Specific streams for biotech scientists and academic hires."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Pharma and bio-manufacturing clusters face talent gaps."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Biopharma ambitions exist but regulatory hurdles slow foreign researcher intake."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma and med-tech multinationals aggressively hire biologists."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "Biotech and regenerative medicine are priority HSP areas."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Government targets vaccine and bio-manufacturing self-sufficiency."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Some openings in agri-biotech but limited funding."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Emerging biotech parks recruit foreign PhDs, but scale still small."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Green Plan 2030",
        "reason": "Biomed research is a core Economic Development Board focus with generous grants."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "UAE Centennial 2071",
        "reason": "Government funds genome and precision-medicine programs seeking researchers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences super-clusters around Oxford–Cambridge actively sponsor visas."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Major funding for biotech, mRNA, and climate-tech biology with streamlined visas for researchers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National Master Plan 2021-2030",
        "reason": "Early-stage biotech sector, selective foreign hiring."
      }
    }
  },
  "6874d163-44d5-45b8-9c43-079a4385fde0": {
    "career": "Cultural Advisor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Migration Strategy 2023",
        "reason": "Roles exist in tourism and corporate training but outside skills lists."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Diversity policies create some demand, yet not a listed priority occupation."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Corporate cross-cultural roles exist, visa route possible but not prioritised."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Tourism development and foreign investment negotiations need cultural insight."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Global tech firms sometimes recruit, yet not on official list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "MADANI Economy",
        "reason": "Tourism promotions and multinational hubs create modest demand."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Tourism and entertainment boom needs experts in cultural sensitivity and heritage presentation."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "Regional HQs use cross-cultural trainers, but not a strategic priority."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Dubai Expo legacy and global corporates hire advisors for intercultural training."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Multinationals and creative sector demand, but no shortage designation."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Multinational firms value cultural consultants for global teams, but no formal immigration incentive."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "5e5e32d3-27d2-49d1-918f-419a09b2a024": {
    "career": "Global Hospitality Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Visitor-economy recovery creates demand, but role is absent from Core Skills Occupation List."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Tourism labour shortages exist, yet managers are not on the targeted occupation list."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nusantara capital city will require hotel leadership yet not an immigration priority."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "SSW covers hotel staff; managers can leverage HSP points but remain peripheral."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Tourism recovery is backed but not core to industrial master plan."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Tourism is key to GDP; senior hotel managers occasionally obtain points-based visas."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Mega-projects (NEOM, Red Sea, AlUla) need international hotel brand leadership immediately."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai & Abu Dhabi target 40 M visitors; programme lists tourism/hospitality leadership as strategic."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Strategy centres on creative and clean tech; hospitality only benefits indirectly from events."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA indirectly funds destination redevelopment, but hospitality management is not a named priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "fbdcda08-1f6e-4fba-82f3-e6e7d02039ac": {
    "career": "School Counselor",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Secondary teachers are on CSOL; states add ‘School Psychologist/Counsellor’ to shortage lists."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Express Entry Category-Based Selection",
        "reason": "K-12 educators are targeted; mental-health focus in schools drives demand for licensed counselors."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Shortage of school support staff, especially in bilingual schools and refugee integration programs."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List excludes counsellors; Catholic schools recruit but require EU teaching council registration."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 2)",
        "reason": "Education sector recovery plan includes incentives for guidance counsellors in rural areas."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Private international schools hire expat counsellors but no fast-track visa."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Counsellors removed from shortage list in 2025; standard visa possible but competitive."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Federal grants for school rebuilding often include funding for support staff, yet no dedicated immigration channel."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "bae6c044-63ef-40f8-afb5-4ade9b7ce2e6": {
    "career": "Social Media Manager",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Tourism and sports projects hire digital storytellers, but Saudization applies."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Economy 2030",
        "reason": "Content roles exist in fintech and tourism marketing, but quotas tight."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Creative & media production is a named focus; Free-zones issue quick visas."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries growth supports demand, yet not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Clean-tech firms need digital outreach, but role not policy-driven."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b6f1c140-a285-48c6-a319-c8dce2be570b": {
    "career": "International Marketing Manager",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Export-heavy Mittelstand occasionally sponsors English-speaking marketers, but language a barrier."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Tourism and EV industries need global promotion, yet no dedicated visa."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Mega-projects aggressively recruit brand and destination marketing leaders to attract FDI and tourists."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Singapore Economy 2030",
        "reason": "Headquarters hub hires regional marketers, but EP criteria are salary-weighted."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "We the UAE 2031",
        "reason": "Free-zones court senior marketing talent for fintech, aviation and luxury retail."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry expansion needs export marketers; no shortage listing though."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Clean-tech exporters need global marketers, but role not named in policy."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "f161f10f-e23d-43b1-8a27-3f70c299b43f": {
    "career": "Supply Chain Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Construction and manufacturing boom lists Procurement and Supply Chain Managers at state level."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Transport and logistics occupations newly prioritised for category-based invitations."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Automotive and industrial exporters cite acute need for supply-chain digitalisation talent."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "RPJPN 2025-2045",
        "reason": "Critical minerals and EV battery chains create pockets of demand."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma and med-tech exports rely on supply-chain planners; roles often on permit lists."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Highly Skilled Professional visa",
        "reason": "Manufacturers digitalise procurement but language skills limit foreign hiring."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "NIMP 2030",
        "reason": "Semiconductor and EV ambitions demand supply-chain optimisation talent."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Migrant Category",
        "reason": "Import-heavy economy values specialists but points threshold high."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Mega-projects and defence manufacturing require global sourcing expertise."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Singapore Economy 2030",
        "reason": "Regional trade hub invests in supply-chain digital twins and cold chain."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Operation 300bn",
        "reason": "Logistics & trade corridor plans make supply-chain talent strategic."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "EV, aerospace and pharma clusters need resilient supply chains post-Brexit."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Reshoring and infrastructure spend need logistics and procurement experts immediately."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "59",
        "policy": "National Master Plan 2021-2030",
        "reason": "Export manufacturing scale-up needs specialists though local talent pipeline growing."
      }
    }
  },
  "83356990-f471-4937-8f43-f7cda4fa0bf2": {
    "career": "Cyber Security Manager",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL lists cyber security specialists and managers for priority visas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "IT–cybersecurity stream offers fast-track PR for experienced managers."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Blue Card salary waivers apply to IT-security experts managing critical systems."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech expansion needs security oversight, but work-permit quotas tight."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Cyber-security consultants/managers on list gain two-year critical-skills permits."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Highly Skilled Professional visa",
        "reason": "IT-security earns high points though not headline occupation."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industry 4.0 targets increase demand but immigration preference is manufacturing engineers."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Migrant Category",
        "reason": "Tech roles earn points but cyber leadership not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Fintech and smart-city projects create need, yet no dedicated immigration lane."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "National AI Strategy 2.0",
        "reason": "COMPASS boosts for cyber specialists supporting AI adoption."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "We the UAE 2031",
        "reason": "National cyber-resilience push favours experienced security managers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital & cyber specialists are explicit shortage occupations with visa concessions."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA funds state and utility cyber-programs, raising demand for senior security leadership."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National Master Plan 2021-2030",
        "reason": "Digital economy goals need cyber talent, yet hiring skews to locals."
      }
    }
  },
  "d246980a-47fe-4028-9f25-a40c7cc5688c": {
    "career": "New Media Producer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "Creative media not on CSOL; visas possible but competitive."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Creative professionals can get Global Talent Stream but are not priority."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "No formal inclusion; roles possible in Dublin’s tech media hubs."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Media producers not on SSW; HSP possible but difficult without Japanese fluency."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Massive investment in entertainment and digital content for NEOM and mega-events."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "Government funds digital content but quotas favour regional creators."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai Media City offers incentives and Golden Visas for senior content creators."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry growth targets cover film, TV and online media with special visas."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Not directly targeted; demand driven by private streaming wars, not policy."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "d164a76a-a200-4084-a4de-08a9005b6b56": {
    "career": "Engineering Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Engineering management appears on state nomination lists for infrastructure projects."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Senior software and engineering managers receive high CRS points under IT categories."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Auto and renewables clusters actively recruit tech-savvy engineering managers."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "RPJPN 2025-2045",
        "reason": "Battery-EV build-out attracts technical managers, yet localisation targets rising."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Multinationals in med-tech and semiconductors need engineering managers; fast permit route."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points awarded, yet Japanese fluency often gatekeeps leadership roles."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Growth in semiconductors offers roles but local leadership preferred."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Points available but preference for hands-on civil and software roles."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Mega-projects (NEOM, Red Sea) require experienced engineering leadership."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Manufacturing 2030",
        "reason": "Precision-engineering plants value experienced tech managers; COMPASS points help."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Operation 300bn",
        "reason": "Industrial diversification needs managers who can deliver advanced manufacturing lines."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Advanced manufacturing and digital pillars explicitly list engineering leadership."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Massive semiconductor and advanced-tech build-out needs leaders who can run cross-functional engineering teams."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "47",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Foreign managers welcome short-term, long-term visas remain complex."
      }
    }
  },
  "43540ff0-a890-4c05-92c0-08b9977132e3": {
    "career": "Ethnographer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Migration Strategy 2023",
        "reason": "Research‐stream visas cover social scientists though not priority."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities recruit PhD researchers and offer LMIA exemptions."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Points system recognises PhD holders; Max Planck institutes hire ethnographers."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on list, but universities may sponsor PhDs."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Singapore Economy 2030",
        "reason": "NUS and SMU fund urban ethnography, but slots are few."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "UAE Centennial 2071",
        "reason": "Government think-tanks occasionally hire cultural researchers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry R&D funds ethnographic studies in gaming and media."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "No direct policy but US academia funds social-science grants; visas via J-1/H-1B."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4c3984d3-fbbb-4110-a383-3d4be8e6648c": {
    "career": "Fitness Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "Sports managers possible under general skilled visas, not on CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Health-promotion roles possible but not prioritised for visas."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Bali wellness hubs hire foreign talent on limited permits."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "MADANI Economy",
        "reason": "Wellness tourism growing, yet immigration preference for locals."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Points awarded but few employer sponsors."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Government invests in sports clubs and wellness resorts, importing experienced fitness managers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Green Plan 2030",
        "reason": "ActiveSG drives local hiring; foreign managers possible in boutique gyms."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Luxury gyms and hotel spas hire foreign managers and offer long-term cultural visas."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct tie; demand driven by private wellness sector not policy."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b648f92d-71e7-4c87-a8b4-63673da7eb8e": {
    "career": "Interior Architect",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "High construction activity keeps demand steady, but interior architects are peripheral to the CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Interior architects qualify as skilled trades under Express Entry, yet the occupation is not singled out for fast-track."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Role fits the general ‘academic specialist’ pathway but is not on any shortage list."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "New capital city Nusantara needs architects, including interiors, yet official lists emphasise civil engineers."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "MADANI Economy",
        "reason": "Tourism-driven hotel development offers some demand, but not considered a strategic skill."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Migrant Category",
        "reason": "Interior design experience helps for points but the occupation is absent from Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Mega-projects (NEOM, Red Sea) demand luxury interior spaces, making experienced designers attractive hires."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Green Plan 2030",
        "reason": "Green-building retrofits occasionally require interior architects, but the occupation is not Tier-1."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai and Abu Dhabi keep importing interior architects for hospitality, retail and residential fit-outs."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry pillar values design skills, but policy focus is on digital/film rather than interiors."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Large federal spending on building retrofit and public-space modernisation needs interior architecture talent, but the role is not explicitly prioritised."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "30d1dd70-a2c4-4c53-8e80-9aa5ae01486e": {
    "career": "Studio Artist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Massive investment in entertainment districts creates demand for performers and studio talent."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Government funds arts festivals, but immigration priority remains tech and finance."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "We the UAE 2031",
        "reason": "Dubai Studio City and Abu Dhabi’s twofour54 attract international artists for media production."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries are a named pillar, though residence routes favour established talent."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Robust commercial arts scene, yet no federal talent policy prioritises performing artists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "29774b90-2d3e-47e4-bdbf-3bc7faa62d93": {
    "career": "Mining Geologist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Lithium, iron ore and rare-earth booms put geologists on priority visas with fast tracks to PR."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Mining is core to export economy; skilled geologists score highly but not explicitly in Category list."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Germany funds raw-materials exploration abroad; limited domestic field roles."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel and copper mining for EV batteries puts exploration geologists on fast-track permits."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Some zinc and lithium projects; geologists admissible though not headline roles."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "Securing overseas mineral supply is strategic; geologists valued in R&D mapping."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "NIMP 2030",
        "reason": "Tin and rare-earth exploration modestly active, but not a headline skill."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Small mining sector; points available but few openings."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Vision 2030",
        "reason": "Large-scale exploration targets for gold, copper and phosphate need foreign geologists."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Operation 300bn",
        "reason": "Limited mining; demand exists in offshore consultancy supporting regional projects."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Critical-minerals strategy funds research, but field jobs mainly overseas."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Critical-minerals push (lithium, nickel) boosts hiring of exploration geologists."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "National Master Plan 2021-2030",
        "reason": "Government ramps up bauxite and rare-earth extraction; foreign expertise welcome."
      }
    }
  },
  "98fa9a29-82b0-439c-8c93-5b30c79cc650": {
    "career": "Research Psychologist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Migration Strategy 2023",
        "reason": "Applied psychology researchers qualify under the academic visa stream, though not on CSOL."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities recruit PhDs for cognition, aging and Indigenous mental-health research under fast-track visas."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Strong funding for human-machine interaction and UX psychology in EU Horizon projects."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on list, but SFI funds cognitive science; visas available through research bodies."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Some demand for aging-society cognitive studies, yet not a highlighted field."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Universities hire, but no shortage listing."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National AI Strategy 2.0",
        "reason": "Human-AI interaction research grants create some openings for cognitive psychologists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Government wants behavioural insights for public policy; researchers welcomed but not prioritised."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 life-sciences pillar funds brain and behavioural research; Global Talent visa fast for academics."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act pours billions into behavioural science, AI-human interaction and mental-health R&D grants."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "df93908d-4810-4fd7-ad84-209915fd8bfc": {
    "career": "Socio-legal Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Academic visa stream available though strategic lists favour STEM."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities recruit interdisciplinary legal scholars under Global Talent Stream."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "EU funded projects on digital rights and governance seek socio-legal researchers."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Data-protection hub encourages socio-legal research, yet not on critical list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Universities hire selectively; no national shortage."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Economy 2030",
        "reason": "Focus on fintech regulation and tech governance opens limited research posts."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "Think-tanks study fintech and space law; niche but growing demand."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Tech-regulation and AI ethics are hot academic funding areas; Global Talent visa open."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Social-sciences funding examines tech policy, ethics and regulatory impacts."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "7f87d222-69c3-4592-85c7-0c5aac9a5a54": {
    "career": "Assessment Coordinator",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Secondary-school education managers appear on CSOL, easing visas for assessment specialists."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "K-12 teachers and French-speaking educators receive extra CRS points; assessment roles bundled within education shortage."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "School administrators included in recognised shortage of educators; Blue Card salary threshold lowered."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "22",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Education managers outside critical list; general work permit possible with employer sponsorship."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Skilled Migrant Category",
        "reason": "Education managers can claim skill points though not on Green List."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "24",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Singapore Economy 2030",
        "reason": "International schools hire assessment experts but role not on official shortage lists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "We the UAE 2031",
        "reason": "Private-school growth sustains demand, but role not singled out for Golden Visa priority."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Education administration not on federal priority lists; demand exists at district level but no dedicated immigration channel."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "18",
        "policy": "",
        "reason": ""
      }
    }
  },
  "744cc213-0505-4c29-b92e-e241d05a2796": {
    "career": "French Instructor",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Migration Strategy 2023",
        "reason": "Some states list language teachers as regional shortages though not on national CSOL."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Bilingual French educators get priority and bonus CRS points under the French-speaking stream."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Demand for foreign-language teachers in Gymnasium; schools can sponsor under ‘educators’ category."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "French teachers can still gain General Employment Permit; not critical skills."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "26",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "24",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Migrant Category",
        "reason": "Secondary language teachers can claim points but not on Green List."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Economy 2030",
        "reason": "International schools need French, but not on shortage list; EP possible if salary fits."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "We the UAE 2031",
        "reason": "Premium private schools hire French staff, but visa priority modest."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "World-language teachers hired, but no federal shortage category after 2025."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "22",
        "policy": "",
        "reason": ""
      }
    }
  },
  "46d545d1-2c4b-43aa-b4bc-f6e01641a1ec": {
    "career": "Neuroscientist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Medical researchers can access Global Talent visa but competition is stiff."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Research scientists qualify for streamlined work permits though neuroscience isn’t a named shortage."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Max Planck and DZNE hiring; Blue Card points weighted for STEM PhDs."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Biomedical scientists are critical; SFI and pharma cluster fund brain research roles."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Highly Skilled Professional visa",
        "reason": "RIKEN and Brain/MINDS project seek foreign neuroscientists; points bonus for PhD holders."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "NIMP 2030",
        "reason": "Some openings in neuro-device R&D, but not a targeted occupation."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Migrant Category",
        "reason": "Small but steady demand in universities; general points system applies."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Vision 2030",
        "reason": "New research centres at NEOM and KAUST recruit neuroscience PhDs for biotech ambitions."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "National AI Strategy 2.0",
        "reason": "A*STAR’s Neurobiology Institute and AI-neuroscience crossover research are high-priority, with streamlined EP and five-year passes."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai Science Park offers Golden Visa for high-impact researchers though numbers limited."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences R&D a flagship pillar; Global Talent Visa fast-tracks neuroscientists."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "CHIPS funds fundamental brain research, BRAIN Initiative grants, and visas via O-1/H-1B exemptions for researchers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "9983290e-ed20-47ee-a5ea-a3a3df7ac877": {
    "career": "Biomaterials Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Biomedical engineer is an ANZSCO shortage occupation eligible for Skilled Independent visa."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Biomedical engineers qualify under STEM; several provincial nominee streams highlight med-tech."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Med-tech hubs in Tuttlingen and Munich seek biomaterials experts; Blue Card accessible."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Developing biopharma hubs, seeking technology transfer from expats."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Med-tech engineers are critical; Galway-Limerick device cluster aggressively hiring."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "Biomaterials tied to aging-society medical device push; points bonus for patents."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Medical device engineers explicitly prioritised for Penang and Selangor clusters with fast-track passes."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Small med-tech sector offers roles but not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Building local biotech clusters; initial demand for implant materials expertise."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Green Plan 2030",
        "reason": "Med-tech engineers qualify for five-year EP under Tech.Pass; strong biomedical cluster."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing agenda includes medical devices, allowing Golden Visa for specialised engineers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences pillar funds med-tech R&D; HealthTech Catapult sponsors Global Talent visas."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds biomanufacturing and advanced materials for medical devices; STEM OPT and O-1 pathways friendly."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "National Master Plan 2021-2030",
        "reason": "Biopharma growth includes implantables; foreign experts welcomed though no dedicated program."
      }
    }
  },
  "803b94c8-0346-4a4e-884f-94a0df025d29": {
    "career": "Religious Studies Consultant",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Express Entry Category-Based Selection",
        "reason": "French-speaking humanities PhDs get extra points, yet role not on shortage list."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Universities may sponsor theologians; consulting niche but Blue Card possible with PhD."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Government wants experts for spiritual tourism in Bali and Java."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "MADANI Economy",
        "reason": "Halal industry and interfaith programs occasionally hire scholars."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Vision 2030",
        "reason": "Heritage and religious tourism projects need scholars to curate museums and pilgrim experiences."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Economy 2030",
        "reason": "Inter-religious harmony programs hire consultants, but quota small."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Interfaith initiatives and museum districts employ consultants on tolerance and curation."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Heritage sector hires consultants; Global Talent arts route available for noted scholars."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Academic humanities not prioritised, but visas possible for specialised cultural consultants in diversity projects."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "24",
        "policy": "",
        "reason": ""
      }
    }
  },
  "1d57edc3-b10a-4589-be98-965998fa856c": {
    "career": "Marine Chemist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Environmental scientists appear on CSOL; maritime chemistry is a niche variant."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Green-tech cluster seeks environmental scientists; marine chemistry fits indirectly, hence moderate priority."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Chemical and environmental scientists welcomed, yet no acute shortage for marine specialty."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Maritime nation needs water-quality experts for nickel tailings and coastal tourism."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "Blue-economy R&D and coastal disaster mitigation fund research chemists; HSP points favour PhD holders."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Marine ecology part of sustainability pillar but not headline occupation."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Environmental scientists listed; marine chemists considered a sub-set with limited openings."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Singapore Green Plan 2030",
        "reason": "World’s busiest bunkering port invests in marine pollution control and R&D, raising demand for marine chemists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "We the UAE 2031",
        "reason": "Port sustainability drives some demand but no formal shortage designation."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Coastal renewable projects need water-quality specialists; immigration pathways remain general."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Environmental monitoring of coastal and port projects aids IRA clean-energy and clean-water goals, but role is not explicitly listed."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "National Master Plan 2021-2030",
        "reason": "Offshore wind and aquaculture growth create supporting roles for marine chemists."
      }
    }
  },
  "c044e5db-6986-4142-9219-9e8a4423de4f": {
    "career": "Math Educator",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Secondary STEM teachers on CSOL with expedited visas and permanent residency pathways."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "K-12 teachers explicitly prioritised; French-speaking maths teachers get fast-track points."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Acute shortage of STEM teachers; foreign educators receive qualification recognition support."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Maths teachers sometimes added to supplementary lists; demand region-specific."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Programme focuses on care and trades; maths teaching visas exist mainly for universities."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Primary and secondary teachers listed, offering direct residence visas."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Economy 2030",
        "reason": "MOE hires mostly citizens; private tuition centres hire foreigners case-by-case."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "UAE Centennial 2071",
        "reason": "Hundreds of private international schools recruit maths teachers, yet no national skills list."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Teacher shortages exist, but immigration pathways remain state-by-state and outside federal priority lists."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National Master Plan 2021-2030",
        "reason": "International schools hire expatriate maths teachers but outside strategic talent schemes."
      }
    }
  },
  "d454d8e5-83d9-466e-97b6-07c6979ec8a5": {
    "career": "Theoretical Astronomer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Square Kilometre Array and optical telescopes drive demand for PhD astronomers."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Government funds astrophysics clusters in Québec and British Columbia but at smaller scale."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Max Planck Institutes recruit overseas astronomers; streamlined Blue Card path for researchers."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on list, but Science Foundation Ireland funds niche astronomy groups."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "NAOJ and JAXA recruit theorists; HSP points help high-degree holders."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Limited but growing radio-astronomy linked to SKA project; places are few."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "National AI Strategy 2.0",
        "reason": "Space science is small but A*STAR funds computational cosmology projects."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "UAE Centennial 2071",
        "reason": "Mohammed bin Rashid Space Centre funds some theoretical work; small intake."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "UKRI and STFC fund cosmology; Global Talent Visa fast-tracks researchers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act pours billions into fundamental physics and space science; research visas plentiful."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b0e094fd-57d2-4458-97d7-15a638a6ca1c": {
    "career": "Animator",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Tax credits make Vancouver and Montréal hubs, yet animators not on priority list."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "RPJPN 2025-2045",
        "reason": "Creative economy noted, yet visas favour domestic talent."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Cartoon Saloon and other studios hire, but not on critical list."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "Anime industry massive; HSP route open for senior creatives."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "NIMP 2030",
        "reason": "Animation supported under digital-economy push but below semiconductor priorities."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Weta digital recruits specialists but numbers are limited and outside green list."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "New entertainment mega-projects need animation for theme parks and media."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Economy 2030",
        "reason": "Some VFX studios; creative roles receive personalised employment passes case-by-case."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai Media City targets global animation; creative talent visas fast-tracked."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Film/TV/gaming in IS-8; Global Talent Visa lists senior animators."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct policy, but biggest global animation market offers O-1 visas for extraordinary talent."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "62656b31-4a0b-4fd6-8008-ba1f0f0e0c33": {
    "career": "Criminal Psychologist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Clinical and forensic psychologists on CSOL with priority processing."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Allied health professionals, including psychologists, receive additional CRS points."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe shortage of psychotherapists; law reforms ease foreign qualification recognition."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Clinical psychologists included; forensic specialism limited but qualifies through broader category."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Clinical psychologists on Green List but forensic niche smaller."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Hospitals expanding behavioural-health services, yet localisation preferences apply."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Green Plan 2030",
        "reason": "Prison Services and the State Courts hire forensic psychologists, but numbers are limited."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "UAE Centennial 2071",
        "reason": "Demand for forensic mental-health experts in growing court and prison system; DHA offers fast-track licences."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "NHS recruits clinical psychologists, but forensic roles are small and sponsorship budgets tight."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Mental-health shortage acknowledged, but immigration pathways vary by state licensing boards."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "894e05c3-4278-4c0a-a506-2e3db688ad2a": {
    "career": "Geography Education Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Secondary teachers on State CSOL; geography accepted under humanities."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Secondary-school teacher shortages qualify; social-science teachers receive extra CRS points."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Acute teacher shortages in Gymnasium subjects, including geography/social studies."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List includes secondary teachers but prioritises STEM; humanities acceptable yet less favoured."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 2)",
        "reason": "Secondary-school teachers (all specialisations) granted fast-track residency."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Only indirect demand via expanded K-12 STEM grants; geography not a listed shortage subject."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4b28d21a-d94f-497e-8544-4d5b8c976ca2": {
    "career": "Publisher",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Migration Strategy 2023",
        "reason": "Publishing not on Core Skills list; possible under general skilled visas with higher points."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Creative-industry visas exist yet focus is on digital media, not traditional publishing."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Creative fields allowed but compete for limited points; no shortage designation."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "Media sector grants available but competition heavy; not in Tier-1 list."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai’s publishing free zone offers 100% ownership; still not a skills-shortage field."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries prioritised but funding tilts toward screen and gaming rather than print."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "No direct incentives, but U.S. remains the world’s largest publishing market offering robust private demand."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "5c2fbc87-3a1f-49d7-8e8c-7bf4efcd9ae6": {
    "career": "Comparative Law Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Academic stream visas available but competitive; not on CSOL."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities seek legal scholars, especially bilingual ones, via expedited research permits."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Strong civil-law tradition and EU research funding attract comparative scholars."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Universities can fast-track lecturer visas, but competition is high."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Some universities hire for civil-common law comparison; language bar remains."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Legal reforms open niche advisory posts but few research chairs."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National AI Strategy 2.0",
        "reason": "Singapore Management University funds comparative-law & tech policy centres."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai legal free-zone courts fund comparative-law think tanks."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Leading common-law scholarship and Horizon Europe grants for legal research."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act boosts federal research funding; top law schools lead global comparative-law scholarship."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "36cd7572-46de-4958-9a58-32c7b74e12f3": {
    "career": "Forensic Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "State police labs recruit overseas when local supply tight."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Forensic roles fit under biological scientists; moderate demand."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Forensic chemists qualify as natural scientists but not shortage-listed."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Lab scientists can obtain permits, but openings limited."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "National Police Agency recruits foreign PhDs for DNA work."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Green List (Tier 2)",
        "reason": "Forensic roles occasionally sponsored under laboratory scientist code."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Modernising security services; foreign forensic experts contracted on mega-projects."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "Health Sciences Authority invites foreign experts, but numbers small."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Dubai Police forensics unit hires niche experts on special visas."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Home Office funds digital forensics; talent shortages moderate."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Federal grants upgrade crime labs, increasing forensic hiring."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "5c8e961e-1a33-47ea-bf33-7565e0479889": {
    "career": "Mathematician",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Mathematicians classified under 'ICT & Data Scientists' shortage roles."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "AI institutes and banks aggressively recruit PhD mathematicians."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Demand from automotive, cryptography and Fraunhofer institutes."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Tech multinationals and pharma biostatistics demand PhD talent."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics, quantum and cryptography labs recruit international mathematicians."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Green List (Tier 2)",
        "reason": "Limited but consistent university and analytics openings."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Vision 2030",
        "reason": "KAUST and NEOM hire theoreticians for AI and energy optimisation."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "National AI Strategy 2.0",
        "reason": "AI safety, fintech risk and quantum computing rely on advanced math talent."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Operation 300bn",
        "reason": "Fintech and space programmes create specialised math roles."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Advanced manufacturing, finance and cyber depend on high-level mathematicians."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Massive federal funding for fundamental math supporting AI, quantum and semiconductor R&D."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "0ec8429b-e835-4173-a2ab-f4466a7f91ca": {
    "career": "AI Software Developer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "On priority list, but behind healthcare and construction."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Dedicated draws for software and AI engineers seeking PR."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe shortage of IT specialists; easier Blue Card rules."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "AI demand tied to fintech; hiring still nascent."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Software engineers on list with two-year work-to-residence path."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "Fast-track points for AI researchers, but language barrier."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "63",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan funds AI adoption in manufacturing; salaries lower."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Software developers listed, yet annual quota small."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Government AI mega-projects, but demand mainly for senior experts."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "89",
        "policy": "National AI Strategy 2.0",
        "reason": "Top-tier priority with Tech.Pass and generous R&D grants."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "We the UAE 2031",
        "reason": "Golden Visa available for AI coders; market size limited."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital & AI top pillar; Global Talent visa route."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Massive grants and fast-track visas for frontier AI R&D talent."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "AI talent sought for chip design support, yet ecosystem young."
      }
    }
  },
  "22f24f37-4400-412b-b232-b897a4ce4c4f": {
    "career": "Clinical Pharmacist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Pharmacists on Medium-Long-Term List enabling long-stay visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Healthcare occupations get extra CRS points; some provinces list pharmacists."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Streamlined pathway for regulated health professions including pharmacy."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Not on Critical Skills List; limited hospital demand."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Local graduate oversupply; foreign hiring minimal."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Pharmacists on Tier-1 list with immediate residence pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "New hospitals under mega-projects actively recruit clinical pharmacists."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Hospitals hire foreigners case-by-case but not a national priority."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "63",
        "policy": "We the UAE 2031",
        "reason": "Health-sector expansion; DHA grants fast licences to experienced pharmacists."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Pharmacists recently removed from official shortage list, but NHS still hires."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Demand exists but no dedicated immigration lane for pharmacists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "6fc64bd3-d411-43f4-9ecb-009a685f0f7a": {
    "career": "Global Finance Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Finance not on core occupation lists."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Express Entry focuses on tech, healthcare, trades rather than finance."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Financial roles rely on EU talent; few visa incentives."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech and digital banking expansion seek experienced talent."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Quants and risk specialists on list; fast residence."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Tokyo pushes fintech but Japanese required for most roles."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "MADANI Economy",
        "reason": "Islamic finance hub needs global specialists."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Rapid growth in capital markets and sovereign wealth funds."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "Singapore Economy 2030",
        "reason": "Top Asian finance centre; Monetary Authority offers FinTech talent passes."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "UAE Centennial 2071",
        "reason": "DIFC/ADGM target global finance talent; Golden Visa available."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London financial services explicitly prioritised."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Strong job market but no immigration priority for generic finance roles."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "78265d02-e2ed-45b0-9f72-068f4dc02827": {
    "career": "Materials Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Migration Strategy 2023",
        "reason": "Needed for critical minerals processing; listed under advanced manufacturing."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Some demand in battery research but not front-line priority."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Auto & renewable sectors hungry for new materials expertise."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel & EV battery value chain needs materials expertise."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Med-tech manufacturing needs materials scientists but no special visa lane."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Highly Skilled Professional visa",
        "reason": "Semiconductor & robotics sectors prize materials R&D talent."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan highlights advanced materials as growth engine for E&E."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Small R&D market; case-by-case recruitment only."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "NEOM and mining projects require materials labs but in limited numbers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Manufacturing 2030",
        "reason": "Invests in nanomaterials R&D though not top-five priority."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing push still early-stage."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Advanced manufacturing and clean energy pillars depend on new materials."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds advanced materials for semiconductors, batteries and quantum."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "National Master Plan 2021-2030",
        "reason": "Targets battery and semiconductor materials but industry still maturing."
      }
    }
  },
  "5bd76225-4a73-4ef7-9934-3dbc88c9ce65": {
    "career": "Medical Humanities Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Interest growing but not on priority occupation lists."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "",
        "reason": "Academic roles qualify under Express Entry if PhD; small cohort."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Humanities PhDs can secure research visas though funding limited."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Small but active research community; few positions."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Isolated programs; Japanese language usually required."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Few dedicated programs; hiring rare."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Selective funding for bioethics but tiny hiring numbers."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "",
        "reason": "Well-established medical humanities centres at top universities."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Universities fund narrative medicine programs; H-1B viable but competitive."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "d12c0c72-ba16-4bb4-9a19-a69787e8aa27": {
    "career": "Medical Microbiologist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL lists medical laboratory scientists among national shortages."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Healthcare stream prioritises laboratory scientists for public-health capacity."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Hospitals face acute shortage of microbiology specialists for antimicrobial stewardship."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Biopharma R&D is nascent; limited dedicated microbiology demand."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma-biotech cluster lists microbiologists on its critical-skills visa route."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP fast-tracks biotech researchers to combat ageing-related diseases."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan promotes pharma manufacturing but microbiology hiring still moderate."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Green List covers pathology and laboratory scientists for fast-track residency."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Biotech parks are emerging but demand for microbiologists still modest and Saudization applies."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Singapore Economy 2030",
        "reason": "Biomedical sciences pillar drives steady hiring of microbiologists for translational research."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "We the UAE 2031",
        "reason": "Dubai Science Park recruits senior microbiology researchers but numbers are limited."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life sciences is a core high-growth pillar; NHS pathology overhaul needs microbiologists."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "CHIPS and Science Act",
        "reason": "Billions for advanced biotech and pathogen-surveillance labs create strong demand for microbiology researchers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "National Master Plan 2021-2030",
        "reason": "Early-stage pharma ambitions create some openings but not yet priority skill."
      }
    }
  },
  "d9d312cb-2949-451c-936b-8d0d654f848c": {
    "career": "Visual Anthropologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Not on CSOL; occasional academic sponsorship only."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "No dedicated stream, but universities can hire through regular pathways."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Public universities hire social-science researchers under Blue Card."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Humanities not on list; only case-by-case hiring."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Not on Green List; limited roles in small universities."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "New museums and heritage projects sometimes need cultural researchers."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "We the UAE 2031",
        "reason": "Media free zones and museums hire ethnographic storytellers for cultural diplomacy."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industries pillar funds film-heritage research; universities support visas."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "CHIPS and Science Act",
        "reason": "NSF social-science grants fund ethnographic film projects; universities sponsor H-1Bs."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "6515f717-ffab-45c3-9f7b-1dc822e0d124": {
    "career": "Broadcast Journalist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Journalism absent from CSOL; sponsorship rare."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Not a priority occupation; French-language roles limited."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "German-language requirement restricts foreign broadcasters."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Journalism not on list; few openings."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Vision 2030",
        "reason": "English-language TV channels for tourism and giga-projects actively recruit global talent."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Economy 2030",
        "reason": "Mediacorp and CNA hire regional English broadcasters to bolster global content hub."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi media free zones position UAE as regional broadcast hub."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industries pillar and legacy broadcasters like BBC sponsor visas."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "CHIPS and Science Act",
        "reason": "No specific incentives; standard employer-sponsored routes with tight competition."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "c6a6d334-8f9e-4d25-ab57-1f10bbc4647d": {
    "career": "Chemical Engineering Advisor",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Mining and LNG sectors list chemical engineers as high-priority occupations."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Seeks chemical engineers for petrochem, battery and LNG projects."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Rhine-Ruhr chemical and pharma giants need experienced process advisors."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel-to-EV battery conversion requires chemical-process expertise."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma-bio manufacturing hub continually hires chemical engineers."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "Semiconductor and materials sectors recruit senior process engineers."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Specialty-chemical expansion is a headline sector, making advisors top-tier hires."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Only niche chemical roles on list; small market."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Downstream petrochem and specialty-chemical expansion demands seasoned advisors."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Manufacturing 2030",
        "reason": "Jurong Island petrochem hub needs advisors for efficiency and decarbonisation."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing roadmap covers chemical-process optimisation."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean-energy and hydrogen projects require chemical-process expertise."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds clean chemicals, hydrogen and carbon capture, boosting need for senior process experts."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Electronics and chemical plants growing but still emerging."
      }
    }
  },
  "f8749006-d663-4f6c-b305-21de399c856c": {
    "career": "Health Services Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Aged-care reform creates demand for facility managers though not top-tier."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Healthcare category accepts managers to ease system backlog."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Hospital administration shortages growing with ageing population."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "New private hospitals prefer local managers to meet language/regulation needs."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List focuses on clinical rather than administrative skills."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "Priority remains clinical staff; admin roles less favoured for visas."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Some health service managerial roles qualify for fast-track residence."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Mega-hospitals in medical cities aggressively hire global managers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Economy 2030",
        "reason": "Ageing population drives demand for operations managers, though not on shortage list."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "UAE Centennial 2071",
        "reason": "Medical-tourism ambitions require experienced hospital leaders."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "NHS hires managers but role not on shortage list post-Brexit."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Hospital modernisation funding indirectly increases admin hires but no shortage visa."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Health-system expansion focuses on doctors over managers."
      }
    }
  },
  "d629fd2c-4dda-4716-a95b-89fb0a75763c": {
    "career": "Industrial Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Industrial and production engineers appear on CSOL for defence, mining-equipment and food-processing plants."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Manufacturing clusters in Ontario and Quebec seek process-optimisation talent; listed under broader engineering NOC codes."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Germany’s Mittelstand and auto sector urgently recruit IE graduates to digitise Industrie 4.0 lines."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel/EV battery plants require lean-production specialists, though bureaucracy slows visas."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Listed under ‘production and process engineer’, mainly for pharma and med-device plants."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics and auto giants hire IEs to implement smart-factory upgrades, but language barrier limits uptake."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Semiconductor and EV supply-chain expansion puts industrial engineers on the urgent-need list."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Migrant Category",
        "reason": "Manufacturing is small but green-tech firms need limited numbers of process engineers."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Mega-projects building new plants in NEOM seek lean-manufacturing know-how, but numbers are moderate."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "59",
        "policy": "Manufacturing 2030",
        "reason": "Focus is on semiconductor precision; some roles open for senior IEs but quotas are tight."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Operation 300bn",
        "reason": "Plan to grow manufacturing GDP requires some industrial-engineering talent, yet heavy preference for automation vendors."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 prioritises advanced manufacturing (EV, aerospace) where industrial engineers design efficient lines."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Billions funnelled into re-shoring and modernising factories, boosting demand for engineers who can cut waste and integrate automation."
      },
      "vietnam": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "National Master Plan 2021-2030",
        "reason": "Electronics and offshore-wind factories scaling fast, creating direct demand for process-optimisation experts."
      }
    }
  },
  "3127e8f6-94e7-4f4b-a330-51152ac13f81": {
    "career": "Sacred Music Instructor",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Arts educators are admissible but receive no priority points."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Strong church-music tradition opens some cathedral-school roles, but not a shortage occupation."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Singapore Economy 2030",
        "reason": "Some churches hire foreign music directors under cultural-arts quotas, but not a priority."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "We the UAE 2031",
        "reason": "Churches in free zones may hire expat choir directors, but visas issued under generic arts codes."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Some cathedral schools recruit organists and choir trainers, yet numbers are tiny."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct alignment; only religious-worker visas provide limited pathways."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "2092b5db-a268-4408-99fd-402fd74b3111": {
    "career": "Veterinary Microbiologist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Veterinarians (including specialists) appear on CSOL due to rural shortages and bio-security focus."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Veterinarians and animal-health scientists receive extra CRS points under healthcare stream."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Animal-health labs and agribusinesses recruit foreign vet scientists to meet EU bio-security rules."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Large poultry sector needs disease labs, but hiring focus is regional."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Listed under veterinary practitioners; Ireland’s huge dairy sector needs pathogen experts."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Agricultural universities hire foreign PhDs, but language requirement is steep."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "MADANI Economy",
        "reason": "Halal meat safety drives moderate demand for veterinary microbiology skills."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Veterinarians are Tier 1 shortage; microbiology specialism welcomed for dairy and bio-security."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Expanding poultry and camel-health sectors require disease-control experts, but numbers limited."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Green Plan 2030",
        "reason": "Urban farms and pet biotech create niche openings for animal-pathogen researchers."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "High-tech desert farming prompts some demand for zoonotic-disease specialists."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Rural vet shortages include some lab-based roles, yet funding uncertain after Brexit."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds One-Health and zoonotic-disease labs, but vets not on explicit shortage list."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National Master Plan 2021-2030",
        "reason": "Swine-flu outbreaks create some openings, though local grads fill most roles."
      }
    }
  },
  "31692bba-590f-445d-8353-953ac8f5726e": {
    "career": "Business Administrator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "Management consultants prioritised over generic administrators."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Business managers qualify but receive no additional category points."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Possible under experience-based points, yet not a shortage."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on list, but multinationals continue hiring graduates locally."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Language requirement and preference for local MBAs limit viability."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Vision 2030",
        "reason": "Private-sector growth needs managers, but Saudization quotas limit expat admin."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Singapore Economy 2030",
        "reason": "Employment Pass possible, but points system rewards tech/finance skills over generic admin."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "UAE Centennial 2071",
        "reason": "Plenty of roles, yet preference for finance/AI specialists over generic admin."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Demand exists across sectors, but no immigration priority."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Generic management roles exist across IRA-funded projects but are not priority occupations."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "9de29df3-34e4-45bc-9227-047665570640": {
    "career": "Criminal Justice Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Migration Strategy 2023",
        "reason": "Some state police forces outsource reform projects, but numbers are small."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Public-safety stream values criminology specialists for policing reforms."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Consulting firms hire for prison-overcrowding studies, yet German fluency required."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on list, but NGO and EU-funded justice projects hire specialists."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "National AI Strategy 2.0",
        "reason": "AI-governance projects open limited slots for foreign legal-ethics consultants."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Smart-city policing projects need policy advisors, yet Emiratisation constraints apply."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Home Office funds data-driven crime-reduction pilots where consultants shape ethics and governance."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Large federal grants require compliance audits and policy evaluation, creating consulting demand."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "7568a4c0-6105-4b96-8f5b-b917a28963ba": {
    "career": "Online Education Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "STEM and early-years teachers are listed; e-learning experts may qualify only under generic ICT streams."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Teaching occupations are targeted, yet online-only specialists are peripheral to priority classroom roles."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Digital-skills trainers can apply, but no explicit demand signal for online instructional design."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Mass upskilling push opens consulting opportunities, yet permits prioritise engineers over educators."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Digital learning roles may enter under generic ICT headings, but not on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Ed-tech founders qualify on points, yet there is no dedicated category."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "MADANI Economy",
        "reason": "Government promotes lifelong learning, though immigration focus remains on manufacturing engineers."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Teacher shortages exist, yet Green List omits ed-tech; applicants must show exceptional digital pedagogy."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Kingdom is spending heavily on virtual universities and upskilling nationals, drawing ed-tech talent."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "National AI Strategy 2.0",
        "reason": "SkillsFuture funds online learning content, but immigration priority is AI talent, not educators."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Drive to position UAE as regional e-learning hub creates mid-level demand for online course designers."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 emphasises creative industries but does not treat generic online education as a shortage."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Ed-tech platforms benefit indirectly from broadband and digital-skills funding, but the role is not a named shortage occupation."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "National Master Plan 2021-2030",
        "reason": "Digital-skills training is encouraged, but foreign hiring quotas stay tight outside semiconductors."
      }
    }
  },
  "9d2e3381-68a3-4703-b485-94f29a695de3": {
    "career": "Event Coordinator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Tourism supports demand but visas focus on chefs and managers, not coordinators."
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Events sector can hire, but preference is EU labour; limited visa pathways."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Government pushes for high-end tourism events in Bali and Nusantara."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "MADANI Economy",
        "reason": "MICE tourism is growing, but visas prioritise manufacturing engineers over service roles."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Mega-projects (NEOM, AlUla) need world-class event planners to attract 100M tourists."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Economy 2030",
        "reason": "City-state positions itself as Asia’s conference capital, importing senior event talent."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi bid for global expos, requiring experienced coordinators year-round."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative sector visas exist but events are not in the shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Large conventions arise from infrastructure upgrades, yet the occupation is not immigration-priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "34b43434-4635-49d8-ba04-65d44fcc8b13": {
    "career": "Professional Architect",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Listed as priority due to housing and infrastructure pipeline across states."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Mass immigration targets housing shortages; architects secure high CRS points under construction occupations."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe shortage of Bauvorlageberechtigte architects amid energy-efficient retrofits."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital Nusantara needs designers, yet foreign architect quotas remain small."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Architects not on list, but construction growth offers general employment permits."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-city projects create some slots, yet language and licensing barriers persist."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "NIMP 2030",
        "reason": "Industrial master plan focuses on factories, relying more on engineers than architects."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Earthquake-resilient building push places architects on Tier 2 with fast-track residency."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Vision 2030",
        "reason": "Gigaprojects (NEOM, Red Sea) aggressively recruit global design talent."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Green Plan 2030",
        "reason": "Green buildings drive niche demand; however PE-Architect licence tough for foreigners."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "We the UAE 2031",
        "reason": "Sustainable-city initiatives and luxury towers keep demand high."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Occupations list includes architects linked to housing targets."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Billions in public works spur demand but architects face strict licensing and domestic supply."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National Master Plan 2021-2030",
        "reason": "Urbanisation fuels demand, but local licensing tight and salaries low for foreigners."
      }
    }
  },
  "57cbcc8a-7e78-4317-9aef-392d14de79f1": {
    "career": "Aviation Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Some defence aerospace roles qualify, yet not on top shortage list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Aerospace cluster in Quebec recruits, but occupation not singled out for fast-track."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Airbus and MTU need engineers, though broader engineering shortages take precedence."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Aircraft leasing hub needs finance, not many design engineers."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "Mitsubishi SpaceJet cancellation reduced demand, yet HSP covers aerospace R&D."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Country targets aerospace MRO and components, wooing foreign engineers to Selangor hub."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Vision 2030",
        "reason": "NEOM airport, defence and space initiatives source foreign aerospace talent."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Singapore Economy 2030",
        "reason": "Aerospace MRO and emerging space tech are highlighted sectors; foreign engineers welcomed under Tech.Pass."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Operation 300bn",
        "reason": "Mohammed bin Rashid Space Centre and Emirates Engineering expand aerospace hiring."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 lists aerospace and defence engineers as critical to innovation."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Aerospace and advanced manufacturing subsidies drive demand for aeronautical engineers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "766d5bdd-38e4-4aa8-99b5-e345a60101eb": {
    "career": "Brand Designer",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Entertainment and sports marketing boom needs branding experts."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Economy 2030",
        "reason": "DesignSingapore Council supports branding excellence, but visas favour tech."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Creative-media initiatives in Dubai Design District attract senior designers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries listed, but only senior talent qualifies for visas."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Indirect marketing spend rises with infrastructure projects, but no immigration pathways."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "f2848e19-a747-48a3-8407-06998d0fe97f": {
    "career": "Experimental Psychologist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Migration Strategy 2023",
        "reason": "Academic Stream visas support researchers, yet psychology shortages focus on clinicians, not experimental."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities recruit cognitive-science PhDs; easier PR via academic LMIA exemptions though not on priority list."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Opportunity Card recognises research PhDs; Max Planck and university labs hire cognitive scientists."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "PhD researchers welcomed via host-based Critical Skills, but psychology excluded from official list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points for PhD and publications; limited openings outside robotics-focused cognition labs."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Migrant Category",
        "reason": "Some demand in university research but not on Green List, so standard points route."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "National AI Strategy 2.0",
        "reason": "A*STAR and universities fund human-AI interaction studies; not a formal shortage but EP points favour PhDs."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "UAE Centennial 2071",
        "reason": "Growth in academic hubs (NYUAD) and UX labs but niche; Golden Visa for PhD holders helps."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Research visas support behavioural science for AI ethics and defence, though not shortage."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "CHIPS and Science Act",
        "reason": "Large NSF-funded behavioural labs and NIH grants; H-1B cap exempt in universities, but not listed as shortage."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4849d8a1-52fc-47d6-ba5d-687a66b26e29": {
    "career": "Game Programmer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Software developers on CSOL; several tax-incentivised studios in Melbourne and Sydney."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Montreal/Vancouver gaming clusters recruit under software-engineer NOC; expedited visas and permanent residency."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Blue Card for IT specialists; Berlin/Hamburg indie scene, but not priority occupation."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Software developer on critical list; Dublin hosts Riot, Activision support centres."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "Nintendo, Square Enix hire foreign engine/AI programmers; HSP points for STEM."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "Emerging game outsourcing sector; IT visas possible but not priority."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Skilled Migrant Category",
        "reason": "Wellington’s Wētā and growing indie studios hire, yet outside Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Esports and entertainment push creates demand, but visas favour senior talent."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "National AI Strategy 2.0",
        "reason": "Sea (Garena), Ubisoft Singapore hire AI/graphics talent; COMPASS points favour top salaries."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s gaming and metaverse strategy offers Golden Visas for specialised programmers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Gaming counted under creative digital; Studios can sponsor Skilled Worker visas quickly."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "AAA studios and startups need real-time graphics, AI and engine programmers; STEM OPT and O-1 pathways abundant."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Growing mobile-game studios; tech visas possible though focus is hardware."
      }
    }
  },
  "6b47b62e-b79d-4900-b68f-8fc39e9a7b04": {
    "career": "Agricultural Biotechnologist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Agri-scientist on CSOL; drought-resistant crop R&D urgently needed amid climate change."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Express Entry Category-Based Selection",
        "reason": "NOC 21110 agri-scientists targeted for food security; provincial streams fast-track PhDs."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Bioeconomy drive and Fraunhofer institutes hiring, though not top shortage."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Food security and palm-oil sustainability create demand for crop geneticists."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Biotech manufacturing strong, yet agricultural biotech posts fewer; standard permit possible."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Highly Skilled Professional visa",
        "reason": "Emerging CRISPR rice programs; HSP points for PhD help entry."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan highlights specialty chemicals and agri-biotech; BioNexus incentives for scientists."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Agricultural scientists specifically on Green List; straight-to-residence pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Food-security projects in desert farming use biotech, but roles are limited."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Singapore Green Plan 2030",
        "reason": "Urban farming R&D at A*STAR; COMPASS points favor high earners, but small sector."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Vertical farming startups seek biotech talent; not a formal shortage."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 covers life sciences; Gene-edited crop trials increasing, but visas via general skilled route."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "US funds climate-smart crops and biofuels; USDA grants and O-1 for extraordinary scientists."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "59",
        "policy": "National Master Plan 2021-2030",
        "reason": "Push for agri innovation; foreign experts welcomed on project visas."
      }
    }
  },
  "5f288cb5-0b12-4e0b-a1a1-1d1e3c1454b2": {
    "career": "Astrophysics Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Migration Strategy 2023",
        "reason": "SKA radio-telescope projects seek PhDs, but small intake."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Canadian Space Agency funds JWST science; research chairs offer PR pathway."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Max Planck Institute for Astrophysics recruits globally under Blue Card."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Radio astronomy clusters growing but small; standard research permits."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Highly Skilled Professional visa",
        "reason": "JAXA and Subaru telescope need instrumentation specialists; HSP fast track."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Singapore Economy 2030",
        "reason": "Small but growing space tech cluster; research roles limited."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "UAE Centennial 2071",
        "reason": "Mohammed bin Rashid Space Centre and Mars mission actively recruit foreign astrophysicists; Golden Visa available."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 prioritises space science; UKRI and SKA telescope in Jodrell Bank hiring."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Massive NASA, NSF and Space Force funding for cosmology, instrumentation and data analysis."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "0f036b99-a4ff-41c3-9995-7ea2f0f31146": {
    "career": "Brand Strategist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "New capital city Nusantara requires branding experts for tourism and investment attraction."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Tourism and entertainment initiatives hire senior brand experts to reposition the nation."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Economy 2030",
        "reason": "Regional HQs need strategists, but COMPASS sorting favours high salaries; not a priority sector."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s push to be global media hub drives demand for branding talent; freelance visas available."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry seniors valued, but Skilled Worker sponsorship uncommon for juniors."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Large consumer market means jobs, but no immigration priority; H-1B lottery only."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "f6fe29f2-1e18-4411-9812-8b17e68d3cb8": {
    "career": "Indigenous Studies Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "Aboriginal-focused research roles are funded; academic visas fast-tracked under the new skills pathway."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Universities and government reconciliation programmes actively recruit scholars on Indigenous issues and offer dedicated immigration points for researchers."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Universities can sponsor social-science researchers, but not an explicit shortage."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Some demand for local culture specialists, but limited foreign hiring."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Academic roles possible via research visas, but not priority."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Universities value area-studies scholars, yet no dedicated track."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Strong demand for Māori studies lecturers; academic visas simplified."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Economy 2030",
        "reason": "Universities hire humanities faculty, yet role not on strategic lists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "We the UAE 2031",
        "reason": "Museums hire some heritage researchers, but openings are few."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Universities sponsor humanities lecturers though not on shortage lists."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Research universities hire humanities PhDs; H-1B cap exempt for academia."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a97fb554-50a7-4aff-9f06-4c4b7527f7d8": {
    "career": "Finance Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Accounting roles appear, yet general finance managers are lower priority."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Open to skilled workers but finance not on targeted lists."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Blue Card possible though finance not shortage occupation."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Rapid fintech and EV investment fuel demand for finance leadership."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "IFSC in Dublin hires financial managers, especially with fintech or funds expertise."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Open for bilingual finance leaders but smaller opportunity pool."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "MADANI Economy",
        "reason": "Kuala Lumpur aims to grow Islamic finance, creating mid-senior finance roles."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Points-based system accepts managers but no fast track."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Mega-projects and sovereign funds need corporate finance leadership."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Economy 2030",
        "reason": "Regional HQs seek finance managers, though EP quotas are tightening."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai and Abu Dhabi financial centres court experienced finance managers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London remains a global finance hub with Skilled Worker visas."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Indirect demand via large infrastructure budgets but no visa priority."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Industrial focus; finance roles secondary."
      }
    }
  },
  "be67dad5-6ceb-4e22-8019-83c61285215a": {
    "career": "Renewable Energy Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Wind, solar and green-hydrogen projects on priority occupation list."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Clean-tech firms can sponsor under engineering and French-speaker streams."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Energiewende drives urgent need for renewable engineers."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "World’s largest geothermal potential and new EV battery plants."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Offshore wind licensing round accelerates demand."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Highly Skilled Professional visa",
        "reason": "Floating offshore wind and hydrogen R&D need talent."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "NIMP 2030",
        "reason": "Targets 70% RE capacity; solar manufacturing hub hiring engineers."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Onshore wind and geothermal expansion require engineers."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Vision 2030",
        "reason": "NEOM and Red Sea solar parks demand specialists."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Green Plan 2030",
        "reason": "Limited land; focus is carbon services, not large-scale RE engineering."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Operation 300bn",
        "reason": "Masdar and DP World invest in solar and green hydrogen."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Offshore wind and CCUS feature in IS-8 priority sectors."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Massive federal tax credits for solar, wind, hydrogen and battery plants."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "National Master Plan 2021-2030",
        "reason": "Offshore wind and LNG-to-power projects require expertise."
      }
    }
  },
  "13ec56d4-2d12-475e-8bcf-758bd8685cf0": {
    "career": "Architect",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Migration Strategy 2023",
        "reason": "Urban-renewal projects seek registered architects."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Large immigration points for professional licences; housing push."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Blue Card possible but German language and licence required."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "New capital Nusantara needs thousands of architects."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Some openings linked to housing crisis but not on critical list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "License conversion and language limit opportunities."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "NIMP 2030",
        "reason": "Focus on industrial plants rather than signature architecture."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Construction shortage yet small market size."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "NEOM, The Line and giga-projects create unprecedented design demand."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Green Plan 2030",
        "reason": "Strict foreign-talent quotas; local firms dominate."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s skyline and COP28 sustainability goals fuel hiring."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Heritage restorations and HS2 keep demand steady, but visa caps apply."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Public works boom increases demand though not on shortage list."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National Master Plan 2021-2030",
        "reason": "Rapid urbanisation but local firms meet demand."
      }
    }
  },
  "5a4264f8-5b1d-4d07-a694-ae36f01f1a91": {
    "career": "Graduate RN",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "ICU and mental-health RNs are on core skills list with fast visas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Registered nurses top priority; streamlined provincial nominee pathways."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe shortage; state-funded adaptation programmes for foreign RNs."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Nurses remain eligible but caps tightened."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Nursing care workers needed, but language and exam barriers."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Local supply adequate; foreign nurse hiring limited."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Direct residence pathway for registered nurses."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Large public-private hospital expansion relies on expatriate nurses."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Economy 2030",
        "reason": "Hospitals hire foreign RNs, but quota pressure keeps scores moderate."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Upgrading healthcare clusters; DHA and HAAD licensing streamlined."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Nursing removed from shortage list after 2025 but trusts still hire."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "CHIPS and Science Act",
        "reason": "No specific nurse visa; H-1B hard, but hospitals still sponsor EB-3."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "d08d749c-d67d-4471-8432-6cc5b9b041be": {
    "career": "HR Consultant",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Rapid industrial hiring sparks need for workforce consultants, but not formally prioritised."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "HR not on list; some demand in multinationals’ EMEA HQs."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "MADANI Economy",
        "reason": "Industrial Master Plan calls for upskilling, opening some space for HR expertise."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Large giga-projects require organisational design and talent management specialists."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "We the UAE 2031",
        "reason": "Ambitious diversification agenda drives demand for HR and change-management consultants."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "People-strategy skills valued but not on official shortage lists."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Corporate expansions under IRA need workforce planning, but HR is not a named priority occupation."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "52f705c6-bab6-43b2-864c-229dcd3a8374": {
    "career": "Multimedia Journalist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Government is investing heavily in entertainment, sports and media hubs."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Economy 2030",
        "reason": "Media industry small; Employment Passes scrutinise salary and experience."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Dubai Media City and Abu Dhabi creative clusters draw experienced multimedia reporters."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries listed, but visas limited to senior talent."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Large media market still hires storytellers, but no immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "3e3b55c7-b21e-48db-9275-8267d1d03fae": {
    "career": "R&D Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Life-science researchers eligible but below healthcare and engineering shortages."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Biochemists receive priority processing and 3-year open work permits."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Blue Card welcomes STEM PhDs though biotech not singled out."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Biopharma R&D identified, yet visa bureaucracy remains."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma and med-tech scientists on list; direct Critical Skills Permit."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Highly Skilled Professional visa",
        "reason": "Biotech researchers qualify for top HSP points."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Pharma scientists are a headline focus, but intake numbers smaller than Tier-1 nations."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Migrant Category",
        "reason": "Research scientists get points but Green List focuses on clinicians and engineers."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "NEOM and pharma clusters need biotech R&D talent."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "81",
        "policy": "Singapore Economy 2030",
        "reason": "Biomedical scientists on national shortage lists; five-year Employment Pass possible."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "67",
        "policy": "Operation 300bn",
        "reason": "Dubai Science Park seeks biopharma researchers; 10-year Golden Visa possible."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences R&D named pillar; Global Talent visa fast-tracks researchers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds cutting-edge biotech and materials research, with fast O-1/H-1B routes for PhD scientists."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National Master Plan 2021-2030",
        "reason": "Government courting biotech investors; migration pathways still maturing."
      }
    }
  },
  "7aad6403-6173-4d0b-85dc-eeef55036755": {
    "career": "Mathematics Instructor",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Secondary STEM teachers explicitly listed."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Secondary STEM teachers receive extra points, aiding math educators."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe shortage of STEM teachers in schools and Berufsschulen."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Preference for local teachers in national curriculum."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Math teachers not on list; some demand in private schools."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Secondary STEM teachers on Tier 1 list."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "MOE cautious on foreign teacher quotas; some room in private tuition."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Private international schools hire expat math teachers, but no priority visa."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds STEM education programmes; colleges recruit math teachers but not on shortage list."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "14c2d9a4-d186-4c74-960a-b0f675e76940": {
    "career": "Nursing School Administrator",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Migration Strategy 2023",
        "reason": "Core Skills List highlights nursing; teacher-administrators support training capacity."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Severe nurse shortages make education administrators valuable though not formally listed."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Massive nurse gap drives need for training programme managers."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Government boosting nursing schools to enable overseas deployment."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Nurse tutors sometimes approved, but admin leadership outside formal list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Healthcare education expanding; deans often hired internationally."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "RNs on Tier 1; admin educators indirectly benefit."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "New hospitals require academic leadership, but Saudization limits visas."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Green Plan 2030",
        "reason": "MOH upsizes nurse training; foreign administrators hired sparingly."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "Private universities seek experienced nurse educators, visas given case-by-case."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds healthcare workforce pipelines; nursing education leaders in demand."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "National Master Plan 2021-2030",
        "reason": "Domestic universities expanding nursing programmes, but visas limited."
      }
    }
  },
  "5aa127e8-9622-46e4-9281-a412ff6e5e4a": {
    "career": "Youth Theatre Coordinator",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Kingdom invests heavily in live entertainment districts; youth programmes align with diversification goals."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Creative visas exist but competitive; not in Singapore Economy 2030 priority list."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "We the UAE 2031",
        "reason": "Dubai & Abu Dhabi fund community arts hubs to boost creative economy."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 values creative industry seniors; youth coordinators may access skilled-worker visas but lower priority."
      },
      "united_states": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "f18bc6f9-c0fb-428d-9f49-085c29ef074a": {
    "career": "Actuary",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "CSOL focuses on engineers and nurses; actuaries obtain visas via general skilled stream."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Finance roles not in category-based Express Entry, yet insurers still sponsor experienced fellows."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Financial services hiring steady but not prioritised under Skilled Immigration Act."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Financial-services quants and risk modellers explicitly welcomed."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Large life insurers can sponsor, although not a named priority."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "Islamic finance growth creates need, but not top-tier occupation."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Not on Green List; insurers may still use Accredited Employer Work Visa."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "Expanding insurance and takaful markets need actuarial risk experts."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Singapore Economy 2030",
        "reason": "Hub for sustainable and re-insurance; MAS issues fast-track passes for experienced actuaries."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai International Financial Centre positions actuaries as critical talent for insurance and fintech."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London’s financial-services pillar lists actuarial science among shortage professions."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "",
        "reason": "Strong private demand in insurance and pensions, but not covered by IIJA/IRA incentives."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "7c70d181-1e09-40f7-9f39-1cc347f835e5": {
    "career": "Econometrician",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Data analysts and economists appear on CSOL, granting priority visas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Data scientists and statisticians receive targeted invitations with fast PR."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialists and quantitative analysts qualify for Blue Card with reduced salary threshold."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "RPJPN 2025-2045",
        "reason": "Macro-modelling talent sought for capital-move planning, still secondary."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Listings cover data scientists and statisticians; straightforward Critical-Skills permit."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Points-based system rewards PhDs but econometrics not named priority."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Government analytics units recruit, yet not on official priority lists."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Migrant Category",
        "reason": "Government recruits economic modellers for Treasury, but not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Economic-diversification projects need data-driven policy advisors."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "National AI Strategy 2.0",
        "reason": "Econometrics overlaps with data science; agencies issue COMPASS fast-track passes."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Think-tanks and sovereign funds hire econometricians for scenario planning."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "HM Treasury and fintechs need advanced econometrics, but not in shortage list."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "CHIPS and Science Act",
        "reason": "Advanced data analytics supports economic modelling for tech-policy impact studies; H-1B demand steady."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Local need growing for development economics, but no dedicated visa route."
      }
    }
  },
  "7eddd000-9df0-49b3-b66c-da9db6d94859": {
    "career": "Media Producer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Screen Australia provides grants, but occupation not on CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Express Entry ignores creative roles; film visas province-specific."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Screen Ireland offers tax credits but no immigration priority."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Vision 2030",
        "reason": "State-backed giga-projects fund film and live-media production to boost tourism."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "",
        "reason": "IMDA grants encourage content producers for regional streaming, albeit not top-tier priority."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "We the UAE 2031",
        "reason": "Abu Dhabi & Dubai free zones recruit producers to scale regional streaming content."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industries pillar lists film & TV as growth export sector with visa concessions."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "No federal visa priority, though Hollywood demand exists via O-1 talent route."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "2ed401b6-b6a5-45be-9ec8-d0e9c64d6b03": {
    "career": "History Teacher",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL lists secondary STEM teachers; humanities get general skilled visa with higher points."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Express Entry Category-Based Selection",
        "reason": "K-12 teachers named in category-based draws; humanities accepted though STEM prioritised."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Regional states recruit teachers, but focus on STEM and early-years."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Teachers can obtain points, yet Green List prefers primary and STEM."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Private international schools hire expat history teachers, but no government priority."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Teacher shortages exist but federal industrial bills offer no immigration route."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "9bfc46e7-6256-4c8b-87ba-008b887aa451": {
    "career": "Spanish Lecturer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Migration Strategy 2023",
        "reason": "Lecturers accepted under higher-education stream but not on Core Skills Occupation List."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Academic roles qualify under general skilled stream, yet languages other than French are low priority."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "41",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Universities can sponsor lecturers; language teaching not shortage field."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Skilled Worker visa covers lecturers, yet Modern Industrial Strategy prioritises STEM/creative, not Spanish."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Universities hire foreign-language lecturers but no dedicated federal talent policy."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "af86bcb6-aec5-4d04-bd53-132f65c9fcf5": {
    "career": "Management Accountant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "Accountants removed from Core Skills list in 2023 review; still possible via points."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Accountants eligible under skilled stream, yet not on priority lists."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Accounting professionals accepted, but shortages lie elsewhere."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "State-owned enterprises recruiting finance talent for nickel/EV expansion."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Multinationals in Dublin need management accountants; role explicitly listed."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Industry 4.0 firms require cost analysts but not headline shortage."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Mega-projects and state entities need cost-control specialists during rapid diversification."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Singapore Economy 2030",
        "reason": "Push for sustainable finance raises demand for management accountants with ESG costing skills."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "UAE Centennial 2071",
        "reason": "Financial services expansion in DIFC seeks CIMA/ACCA talent for corporate strategy."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London remains global hub; senior accounting on shortage list, fast visa lanes."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "",
        "reason": "Strong demand in corporate FP&A, but no federal talent programme targeting accountants."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "47",
        "policy": "",
        "reason": "FDI factories need costing skills; no formal talent scheme yet."
      }
    }
  },
  "c100cb21-5450-4325-b766-201d6dee18a1": {
    "career": "Political Analyst",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "EU institutions and Berlin think tanks recruit, but role not on shortage lists."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Vision 2030",
        "reason": "Government advisory units hire foreign analysts for reforms."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Regional think tanks based in Singapore recruit analysts for ASEAN studies."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "We the UAE 2031",
        "reason": "Dubai think tanks and media require regional analysts but in small numbers."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Westminster ecosystem offers roles yet not part of skill-shortage visa list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Think-tank and media hiring healthy, but no dedicated immigration lane."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "1862459b-995c-4199-a4a6-a5fe17b5a78c": {
    "career": "Political Sociologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Universities can sponsor, though Migration Strategy leans STEM."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Research chairs accept social scientists, but STEM favoured."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Humboldt Fellowships attract sociologists; points scheme values PhDs."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "IRC fellowships available but competitive; not on Critical Skills list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Autonomous universities offer Global Talent visas, but quotas small."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Foreign faculty sought for new social science programmes."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Russell Group universities sponsor global talent visas for social scientists."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Universities recruit social-science PhDs; National Science Foundation funds related research."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "c101ecda-32c5-4c83-911e-eb6f43a30cc0": {
    "career": "Information Systems Developer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Software engineers on priority list with streamlined visas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Software developers top the dedicated tech draw for fast PR."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz",
        "reason": "IT specialists get Blue Card with reduced salary threshold."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "RPJPN 2025-2045",
        "reason": "Digital public infrastructure and fintech expansion require developers."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Software developers/high-level IS specialists explicitly listed."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Highly Skilled Professional visa",
        "reason": "Points-based HSP fast-tracks IT engineers."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industry 4.0 rollout needs enterprise software for automation."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Experienced software developers qualify for Straight-to-Residence pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Digital transformation of public services needs systems developers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "National AI Strategy 2.0",
        "reason": "Need for engineers to build secure information systems for AI projects."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Operation 300bn",
        "reason": "Fintech and AI push raises demand for enterprise software talent."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Full-stack developers remain on shortage list despite review."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "CHIPS and Science Act",
        "reason": "Software talent needed for semiconductor design tools and digital twins."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "67",
        "policy": "National Master Plan 2021-2030",
        "reason": "E-commerce and fintech growth drives demand for system developers."
      }
    }
  },
  "e81e571b-b6fe-47bc-baa0-597a3e7dcf21": {
    "career": "Security Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "Migration Strategy 2023",
        "reason": "‘Core Skills Occupation List’ lists Cyber Security Engineer/Analyst; employers sponsor quickly due to national skills gap."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Cyber-security is an explicit target occupation under the 2024 tech draw, easing PR and fast-tracking work permits."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "81",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT-security specialists now qualify without formal degree if experience + salary meet new points system."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Digital trust listed, but localisation rules and pay packages deter many migrants."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Cyber-security specialists qualify for Critical Skills permit but numbers capped annually."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points favour AI/cyber engineers, offering 1-year to PR, but language barrier persists."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industry 4.0 rollout includes cyber, yet salaries lower and permits less streamlined."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Tech talent welcomed but cyber is not on Green List, so no fast-track incentives."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Mega-projects (NEOM, Red Sea) require cyber defences yet hiring is ad-hoc, project-based."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "National AI Strategy 2.0",
        "reason": "Cyber-security sits alongside AI as strategic pillar; COMPASS visa scoring rewards proven specialists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Government pushes for national cyber-shield; Golden Visa available for proven experts."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital/cyber/AI occupations receive fast visa processing and lower salary threshold."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Federal funds pour into cyber-resilience for semiconductor, energy and transport systems, driving demand for senior security advisers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Government notes cyber as supporting skill for fabs, but still emerging career route for foreigners."
      }
    }
  },
  "395c899d-17a1-4bd7-8580-b70050079fff": {
    "career": "Sustainable Construction Manager",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Construction Project Managers and civil engineers with sustainability credentials get priority visas for infrastructure and net-zero housing."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Green-building expertise valued for mass housing retrofits, but not yet a separate express-entry category."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Nation needs civil engineers versed in Passivhaus and timber construction to meet EU climate goals."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital Nusantara set ambitious eco-targets, attracting green-construction talent."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Civil engineers qualify but sustainability specialism not singled out; limited housing output caps demand."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-city pilots value green expertise, but language plus seniority requirements narrow foreign opportunities."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan references green buildings, yet budget emphasis on factories not commercial sites."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Construction Project Managers on Tier 1 list; rebuild after cyclones must meet carbon-zero code."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Vision 2030",
        "reason": "Giga-projects promise entire renewable cities; LEED-skilled managers recruited at premium packages."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Singapore Green Plan 2030",
        "reason": "Super-tall retrofits pursue net-zero, yet tight local PM licence makes foreign entry tough."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Operation 300bn",
        "reason": "Sustainable tourism and real-estate pushes create roles, but preference for GCC experience."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Offshore wind and green-building programs require managers, yet visa shortage list no longer includes generic construction roles."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Federal money mandates low-carbon materials and energy-efficient building standards, raising demand for managers who can hit sustainability targets."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National Master Plan 2021-2030",
        "reason": "Rapid urbanisation needs construction PMs, but cost-competitiveness trumps sustainability today."
      }
    }
  },
  "8bd8dd4d-a98c-4ceb-bb06-d8ecde4f9e53": {
    "career": "Supply Chain Associate",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Lists transport planners, not entry-level supply-chain analysts."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Transport occupations preferred over white-collar supply-chain grads."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Industrial firms need logistics, yet English-only junior roles scarce."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "RPJPN 2025-2045",
        "reason": "Nickel and EV supply chains create analyst roles in free-trade zones."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Tech logistics startups hire but role not on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "SSW covers warehouse labor, not analyst roles; language hurdles."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "MADANI Economy",
        "reason": "Port Klang expansion and e-commerce growth need supply-chain planners; expatriate quotas still apply."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Focus on truck drivers and construction trades over analysts."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Mega-logistics hubs (NEOM, Jazan) hire foreign graduates for planning teams."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Singapore Economy 2030",
        "reason": "Logistics 2.0 initiative seeks data-driven supply-chain talent; COMPASS tests favour STEM grads."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "We the UAE 2031",
        "reason": "Dubai aims to be top global logistics hub, offering Golden Visa for supply-chain specialists."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "No shortage visa; employers expect local experience."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Reshoring and port upgrades create junior logistics roles, but no dedicated visa route."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "National Master Plan 2021-2030",
        "reason": "Export-manufacturing boom demands young logistics analysts familiar with ERP."
      }
    }
  },
  "e0967731-2598-4239-845b-22d1a511e312": {
    "career": "Animal Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Agri-scientists and livestock nutritionists feature on priority list to boost export farming."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Agriculture and French-speaking STEM researchers receive extra CRS points; prairie provinces sponsor animal science PhDs."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Most roles in German language university labs; limited farm-based openings for foreigners."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Food security strategy funds cattle and feed efficiency labs; foreign PhDs can secure research visas."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Beef and dairy sector funds research; Agri-food scientists qualify for Critical Skills permits."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-farm initiatives recruit livestock researchers; points favour PhDs."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "MADANI Economy",
        "reason": "aquaculture R&D hiring small; poultry majors rely on local grads."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Dairy-heavy economy urgently needs animal scientists for methane-reduction research; permanent residency fast-tracked."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Focus on food security, yet prefers agronomists over animal scientists due to limited grazing land."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Green Plan 2030",
        "reason": "City-state focuses on cell-based meat scientists, a tiny sub-segment."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Desert agriculture projects exist, but animal science roles niche and often local-only."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-science R&D funding includes animal health, yet post-Brexit visas competitive."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds agri-tech and biotech, including precision livestock research, but no special visa priority."
      },
      "vietnam": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "National Master Plan 2021-2030",
        "reason": "Pig and poultry sectors modernising; foreign animal nutrition experts sought for disease control."
      }
    }
  },
  "58f36323-c8fa-4641-85cc-af9da8cf9f74": {
    "career": "IT Project Manager",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "Migration Strategy 2023",
        "reason": "Software Project Manager on CSOL; employers can sponsor in weeks."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Tech draws invite IT managers; easier PR for French-speaking candidates."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "81",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT managers qualify through new Opportunity Card points even without German degree."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Foreign IT PMs need strong Bahasa and local partner to secure work permit."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Software development managers squarely on list; fast two-year to PR."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points reward PMs with PMP certs and high salaries."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "NIMP 2030",
        "reason": "Digitalisation projects need PMs, yet salaries modest and EP quotas tight."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "IT PM roles exist but not on Green List; points threshold high."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Digital-government and fintech programmes create contract PM roles."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Singapore Economy 2030",
        "reason": "Fintech and public cloud projects abundant; COMPASS points favour experienced PMs over newcomers."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "UAE Centennial 2071",
        "reason": "Smart-city and banking transformations pull in experienced PMs; Golden Visa possible."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital projects funded, but PM roles not on shortage list so sponsorship slower."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Massive federal tech programmes need PMs to coordinate hardware-software rollouts."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Local firms prefer Vietnamese PMs; English-only management roles limited."
      }
    }
  },
  "226f7ada-1924-4b20-81de-869a0c568d74": {
    "career": "Media Strategist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Entertainment and sports sectors under Vision 2030 demand senior media planners for mega-projects like NEOM."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Singapore Economy 2030",
        "reason": "Creative services allowed on EP, but not in national priority clusters, so pass requirements are higher."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Media production is a named priority; Dubai Media City aggressively sponsors experienced strategists."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry seniors qualify for Skilled Worker visas, especially in film/TV advertising clusters."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Large advertising industry offers jobs, but no dedicated immigration incentives for marketing roles."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "27",
        "policy": "",
        "reason": ""
      }
    }
  },
  "bff7d3ac-65f1-4dff-8e8a-12e5522627a4": {
    "career": "Accounting Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Migration Strategy 2023",
        "reason": "Occupation lists favour auditors over general accounting managers."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Finance not in 2025 category picks, yet CRS points still reward CPAs."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List includes accountants in financial services and multinational HQs."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "MADANI Economy",
        "reason": "Islamic finance expansion boosts demand for experienced accountants in Kuala Lumpur."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Mega-projects need finance oversight, but Saudisation limits mid-level roles."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Singapore Economy 2030",
        "reason": "Sustainable-finance push values regional accounting leadership, but quotas are controlled."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Operation 300bn",
        "reason": "Dubai and Abu Dhabi financial centres aggressively sponsor senior finance talent."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London financial services explicitly prioritised; accounting managers gain fast visa processing."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "No specific visa priority, but steady demand in large corporations and Big 4."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "fe33c366-7dd4-4c35-af0a-a04e2dcc30f4": {
    "career": "Health and Sports Educator",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Secondary teachers in demand; states sponsor physical education teachers."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Teachers and early-childhood educators are priority; PE fits under school teaching NOC."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Teacher shortages exist but preferential for STEM; PE still gets points."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Primary and secondary teachers are on the list, covering PE specialists."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Government pushes sports participation, opening roles in academies and schools."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Private schools hire many PE staff, but not a formal immigration priority."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Schools hire PE teachers locally; no federal shortage classification."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "d7f660be-2517-4c26-bcdb-6a574880b30f": {
    "career": "Legal Administrator",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "27",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Work permits possible for large Dublin firms, though not on Critical Skills list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "International firms in Riyadh need bilingual document handlers for privatization deals."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Singapore Economy 2030",
        "reason": "International arbitration hub needs English-speaking legal support, but EP salary bar is high."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai International Financial Centre hosts many firms hiring paralegals on work visas."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Large law firms can sponsor but legal support not explicitly prioritised."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Large law firms hire paralegals, but no immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "27",
        "policy": "",
        "reason": ""
      }
    }
  },
  "34425ef1-8f2b-4bbf-a61a-65451064d176": {
    "career": "Fashion Marketing Manager",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Luxury retail growth under Vision 2030 needs brand managers for new malls."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Singapore Economy 2030",
        "reason": "Regional fashion HQs in Singapore hire marketers, though not a national priority."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "We the UAE 2031",
        "reason": "Dubai Fashion Avenue and e-commerce boom actively recruit fashion marketing leaders."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry visas cover fashion, especially London fashion houses."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Strong fashion industry but no immigration incentives for marketing."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a11c0549-b617-443d-9ab8-0a5220294a27": {
    "career": "Marketing Education Specialist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "24",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "22",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "24",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Mega-projects need brand storytellers and training teams for hospitality workforce, but role is peripheral."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Creative-media sector expansion offers some demand for trainers who upskill marketing talent."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Modern Industrial Strategy focuses on creative industry seniors, but teaching marketing is not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Role is supportive; no direct mention in federal talent policies focused on hard-tech manufacturing or energy."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "24",
        "policy": "",
        "reason": ""
      }
    }
  },
  "6638bb08-ba79-44b9-92f2-3bfd1cebf8d9": {
    "career": "Nutrition Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Dietitians appear under health professionals eligible for skilled visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Allied-health and French-speaking professionals rewarded with extra CRS points."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Hospitals seeking allied health to ease chronic shortages."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Migrant Category",
        "reason": "Not on Green List, yet general health shortages give points under SMC."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "New world-class hospitals and sports projects need clinical and sports nutritionists."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "",
        "reason": "MOH lists dietitians as allied-health shortage, but they are quota-controlled."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "UAE Centennial 2071",
        "reason": "Wellness tourism and diabetes clinics fuel demand for licensed dietitians."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Dietitians can get Skilled Worker visas but not on shortage list, so higher salary threshold applies."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "High obesity burden keeps demand, but no dedicated federal visa stream for dietitians."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4dfa050a-463a-4c17-aae2-6a38651e0634": {
    "career": "Research Biochemist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Pharma and med-tech precincts listed under National Reconstruction Fund priority."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Ottawa courting life-science researchers for pharma clusters in Toronto and Montréal."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Bio-pharma giants in Rhine-Main need researchers; fast-track Blue Card."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Plans to localise biopharma manufacture; research roles emerging."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma and biopharma dominate exports; biochemists on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Highly Skilled Professional visa",
        "reason": "Government funds regenerative medicine and biotech startups; HSP gives fast PR."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Biopharma listed but ecosystem still maturing—demand moderate."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Limited but growing biotech sector; standard Skilled Migrant pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "KAUST and NEOM laboratories ramp up biotech research hiring."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Singapore Economy 2030",
        "reason": "Biomedical sciences form core of RIE2025 funding; tight but well-paid market."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Operation 300bn",
        "reason": "Biotech named as strategic manufacturing pillar; Golden Visa available for PhDs."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences R&D is flagship pillar; Global Talent visa eases entry."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act pours billions into biotech, mRNA and advanced materials R&D labs."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "National Master Plan 2021-2030",
        "reason": "Government wants biotech talent for vaccines and agri-biotech but scale small."
      }
    }
  },
  "5fbc95ef-a023-4179-850c-316e07ce0789": {
    "career": "Computer Science Teacher",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Secondary STEM teacher critical shortage; priority visa processing."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Secondary STEM teachers on targeted shortage list; provinces offer immediate permanent residence."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "German states desperate for STEM teachers; relaxed recognition rules."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Secondary technology teachers on Green List with straight-to-residence path."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Private international schools hire, but no strategic visa priority."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "STEM teachers removed from shortage list July 2025; still possible but harder."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Teacher shortages exist, but no federal specialised visa for K-12 educators."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "8821c963-461a-44d2-a64d-40fa78e376d2": {
    "career": "Environmental Designer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Construction boom needs project managers; sustainable interiors remain niche."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Federal retrofit incentives indirectly boost need for interior environmental designers."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Strict energy-efficiency rules spark strong demand for designers versed in Passivhaus standards."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "RPJPN 2025-2045",
        "reason": "Capital relocation to Nusantara drives sustainable design demand, though visas still ad-hoc."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Critical Skills List omits architecture and design."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-city architects explicitly welcomed; interior environmental design overlaps."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Green building push under MADANI Economy, but visas favour engineers."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Luxury tourism projects require sustainable guest-experience design."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Green Plan promotes retrofit grants but interior design not on priority list."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Operation 300bn",
        "reason": "Net-zero buildings and Expo legacy sites hire green interior experts."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Net-zero retrofit programs create some roles but not visa priority."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Green buildings get tax credits, creating demand for sustainability-minded designers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Rapid urbanisation needs designers, yet no dedicated talent scheme."
      }
    }
  },
  "2e443f0d-4fc1-4654-845f-4539a0b0cec8": {
    "career": "Marketing Associate",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Tourism mega-projects (NEOM, Red Sea) allocate budgets to brand promotion, opening junior marketing roles."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "We the UAE 2031",
        "reason": "Strategy highlights creative & media production; agencies recruit associates for content and social media."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries are a named pillar; entry-level marketers support film, TV and gaming exports."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Clean-energy projects funded by the IRA need consumer outreach and digital campaigns, creating peripheral demand for junior marketing staff."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "5a94bcaa-c515-41fd-a810-f2aa8307d4db": {
    "career": "Retail Marketing Manager",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Expanding luxury malls and tourism zones actively recruit retail marketing leaders for international brands."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Retail marketing roles exist but are outside Singapore's priority occupation lists; EP approvals tighter."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai’s retail hub status aligns with government push for tourism and creative media talent."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry growth supports demand for omnichannel retail marketers, especially in fashion and gaming merchandise."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Large-scale revitalisation projects spur malls and transit retail needing marketing leadership, though not a formal priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "71214e50-3788-46f8-a401-e5bca9556201": {
    "career": "Author",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Program has a creative-arts stream encouraging French and multicultural literature exports."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Publishing scene vibrant but not on priority occupation list; EP quotas apply."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s ambition to be a regional publishing hub opens festival and residency opportunities."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry pillar supports publishing, with grants and Global Talent visa for exceptional authors."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "While not a policy target, the US remains the largest publishing market offering ample opportunities for writers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b458e279-113f-486c-b20d-ba9f95d0494f": {
    "career": "Corporate Finance Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "CSOL emphasises engineers and tech; corporate finance listed only for very senior roles."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Financial managers qualify under broad business stream but not category-based priority."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Opportunity Card favours STEM; finance managers must compete with EU talent."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV and infrastructure investments require project finance skills, but localisation push keeps it Tier 3."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Finance managers align with Ireland’s hub for multinational treasury and funds."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Highly Skilled Professional visa",
        "reason": "Visa points favour finance professionals with advanced degrees but language barriers persist."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "MADANI Economy",
        "reason": "Islamic finance and regional HQs in Kuala Lumpur create demand for corporate finance leaders."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Mega-projects and sovereign funds hire finance talent, but localisation policies intensify competition."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Singapore Economy 2030",
        "reason": "Sustainable and fintech finance are priority sectors; EP approvals favourable for experienced managers."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "UAE Centennial 2071",
        "reason": "DIFC and ADGM position UAE as regional financial hub, actively importing corporate finance expertise."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Financial services are a named pillar; City of London firms sponsor corporate finance talent aggressively."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Large federal projects need finance managers for capital allocation, though the occupation is not formally prioritised."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "1b25297d-be72-4fb8-8306-2816690152f3": {
    "career": "Community Advocate",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Migration Strategy 2023",
        "reason": "Regional health programmes sponsor community outreach workers, especially in Indigenous areas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Healthcare and social-service workers gain extra points, and community advocacy aligns with public-health outreach."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Social workers are recognised shortage occupation; advocacy overlaps though language is a barrier."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "NGOs may use general employment permits for social advocates, but not a critical-skills role."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Migrant Category",
        "reason": "Government funds community health promoters for Māori and Pasifika populations; roles qualify for points."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Social-service agencies may hire foreigners as community engagement managers, but quotas apply."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Non-profits addressing migrant welfare recruit advocates, though visas are case-by-case."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Community outreach roles can sponsor visas under health/social care employers even without shortage listing."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA allocates community grants for environmental justice, needing advocates to engage affected populations."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "bbc68078-59a5-4677-b5f1-3c426151a867": {
    "career": "Consulting Associate",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Generic consulting not on Core Skills list, but employers sponsor when digital skills scarce."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Tech-focused analysts welcomed, yet not on category-based priority list."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialists easier to enter; consulting tag adds no extra advantage."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Tech consulting supports multinational HQs though not on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Possible under general IT/AI category, but competition for points high."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Consulting demand exists for NIMP 2030 projects, yet no special immigration lane."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "No Green List item; visas possible via employer accreditation only."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Gigaproject ministries hire consultants to steer digital transformation."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "National AI Strategy 2.0",
        "reason": "Tech consultants welcomed under Employment Pass, but not on strategic shortage list."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Operation 300bn",
        "reason": "Consultancies expanding in AI, fintech and manufacturing clusters of Dubai/Abu Dhabi."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Senior consulting is IS-8 priority; associates enter via Skilled Worker visa."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Role not specifically backed by IIJA/IRA, but plentiful H-1B demand for tech-savvy analysts."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "c9407464-1e18-4408-bba9-c2099697c04b": {
    "career": "Earth Resources Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Migration Strategy 2023",
        "reason": "Mining and civil engineers head the Core Skills list; visas processed in weeks."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Mining provinces nominate earth-resources engineers for copper, potash and lithium projects."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Limited domestic mining, some demand in geothermal and recycling sectors."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV-battery mineral extraction central; foreign specialists fast-tracked."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Mining sector tiny; few visas issued."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Highly Skilled Professional visa",
        "reason": "Battery-metal recycling R&D offers limited slots."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Tin and rare-earth projects create some openings."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Green List covers civil not mining engineers; possible via general skilled route."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Vision 2030",
        "reason": "Huge investments in phosphate, gold and critical minerals need extraction experts."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "No domestic mining; skills not in demand."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Some demand for carbon-capture storage sites, but small mining industry."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Niche roles in Cornwall lithium and North Sea CCS; not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Critical-minerals projects need engineers, but no dedicated visa priority."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Nickel and bauxite push needs engineers, but preference for local hires."
      }
    }
  },
  "2222f224-e180-4acc-b732-41967205a7a1": {
    "career": "Public Health Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Aged-care reforms drive demand for health-service managers."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Provinces prioritise health-services leadership to cut wait times."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Hospitals recruit internationally, but managers must speak B2 German."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "HSE occasionally recruits, not on Critical Skills list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Medical-tourism boom needs managers, but immigration quotas limited."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "District health boards recruit managers through Skilled Migrant Category."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Mega-hospitals like King Salman Medical City need public-health leadership."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Hospitals hire, yet role not on shortage list; EP eligibility still good."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai Health Strategy 2030 fast-tracks senior health managers for medical tourism."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "NHS hires some overseas managers but shortage list focuses on clinicians."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "No special visa, but hospitals sponsor MPH graduates on H-1B cap-exempt slots."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "82b84d7a-c7e2-4ea5-9bc9-1e3557b95a92": {
    "career": "Community Outreach Worker",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Some states sponsor community workers under social-welfare codes."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Provincial nominee streams sometimes list social-service workers, especially francophones."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Municipal agencies recruit foreigners with B2 German; no national shortage tag."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Shortage in social care exists but not on Critical Skills list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Community workers eligible under Skilled Migrant Category if employer accredited."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Social services mainly Saudized; NGOs limited."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Some social-service agencies hire foreigners on S Pass, but quota tight."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Few visas for foreign outreach roles; preference for Emiratis in social sector."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Some charities sponsor visa under social worker SOC code, but limited."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Role relies on local funding, not federal immigration priorities."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "ba05aa9c-138f-424e-a777-a26ee74df003": {
    "career": "Secondary Education Coordinator",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "STEM secondary teachers & curriculum leads fast-tracked on CSOL."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Secondary teachers on priority list; coordinators qualify with B.Ed + experience."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "STEM teacher shortages; coordinators possible with German fluency."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Some school leadership shortages outside Dublin, but not on Critical list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "JET focuses on assistant language teachers, not coordinators."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Private schools hire, yet occupation not prioritised for permits."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Secondary teachers directly resident-eligible; leadership roles valued."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "International schools hire foreigners, but preference shifting to Saudis."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "MOE rarely hires foreigners for public schools; private IB schools possible."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Plenty of jobs in private schools, yet not a strategic sector."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Maths and science teachers shortage; coordinators possible via same SOC."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "No national shortage; visas possible only via private schools."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "144d6448-a8c6-4949-b197-2e6a2401c1aa": {
    "career": "Secondary English Teacher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Several states list secondary teachers; English not STEM but still accepted under regional visas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "English and French secondary teachers are explicitly prioritised for permanent residence to address rural and Francophone shortages."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe teacher gaps allow non-EU language teachers fast-track recognition in many Länder."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List omits secondary teachers; demand exists but without streamlined visa support."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "JET and eikaiwa hire English teachers on general visas, but not under priority schemes."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "List favours STEM; English teachers get points only for hard-to-staff locations."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Singapore Green Plan 2030",
        "reason": "MOE rarely sponsors foreign English teachers; jobs exist only in tuition centres."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "We the UAE 2031",
        "reason": "Private British and IB schools recruit many English teachers, but not part of national talent strategy."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "English no longer on shortage list, yet academy chains still sponsor visas for experienced teachers."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Teacher shortages exist but no federal immigration or industrial policy directly targets K-12 English educators."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "National Master Plan 2021-2030",
        "reason": "High private-sector demand for ESL teachers, yet outside core industrial policy."
      }
    }
  },
  "8639925f-d480-424c-bfd3-4757fa5752cd": {
    "career": "Clinical Psych Associate",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "Psychologists and counsellors are on multiple state skilled lists due to rural shortages."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Mental-health professionals receive priority points; provinces offer fast-track licences."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Reform eases recognition of foreign mental-health practitioners for hospitals and rehab clinics."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Clinical psychologists are on the list, offering 2-year work permits leading to residence."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "Growing private hospital sector recruits some expatriate psychologists, but not priority."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Clinical psychologists on Tier 1; streamlined residence after two years."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "New focus on mental health in mega-projects, but hiring prefers Western-licensed psychologists."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "National AI Strategy 2.0",
        "reason": "MOH publishes shortage lists, but foreign psychologists face strict registration and limited quota."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "UAE Centennial 2071",
        "reason": "Hospitals and wellness resorts sponsor visas for mental-health specialists to meet rising demand."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Clinical psychology traineeships accept overseas applicants under shortage occupation code."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Mental-health demand high but no national visa preference; state licensure controls hiring."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "078e55d8-a8fc-477f-936e-45c4032ae028": {
    "career": "Data Analytics Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Migration Strategy 2023",
        "reason": "Digital data roles appear on most state nomination lists, though not top-tier."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Canada courts data scientists and analytics managers under tech streams."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Blue Card points favour IT/data specialists to digitise Mittelstand."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech and e-commerce boom requires analytics, yet foreign hiring is modest."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Analytics managers on CSOL, accelerated residency to feed Big Tech hubs."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Highly Skilled Professional visa",
        "reason": "Data scientists qualify for fast-track HSP but language limits daily work."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan emphasises Industry 4.0 analytics for semiconductor and aerospace supply chains."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Migrant Category",
        "reason": "Data roles earn points but are not on the narrow Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "59",
        "policy": "Vision 2030",
        "reason": "Mega-projects need analytics talent for tourism, logistics and smart-city dashboards."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "National AI Strategy 2.0",
        "reason": "Analytics leadership is core to Singapore’s AI ambition and earns COMPASS bonus points."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Operation 300bn",
        "reason": "Fintech and manufacturing drives create strong market for data analytics leaders."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital/AI specialists are a formal pillar, easing visas for experienced managers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds AI & data initiatives across sectors, driving demand for analytics leadership."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Digital analytics supports e-commerce and chip ambitions but talent visas still forming."
      }
    }
  },
  "54927f9c-6e68-4896-84ec-06fed8cd6a90": {
    "career": "Digital Marketer",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "31",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Tourism mega-projects contract digital marketers, but visas tied to specific employers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Economy 2030",
        "reason": "Digital marketing roles qualify under general EP, but not in Tier 1 tech lists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "We the UAE 2031",
        "reason": "Dubai positions itself as regional digital-media hub; creative professionals enjoy five-year Green Visas."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry senior roles, including digital marketing directors, are part of IS-8 creative pillar."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Role not covered by federal industrial acts, but tech startups still file H-1Bs."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "e18b7328-678c-47e6-9439-04b7896ce3e5": {
    "career": "Game Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Interactive-media roles eligible in some states but not nationally prioritised."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Quebec and Ontario give tax credits to studios and facilitate Global Talent Stream visas."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Game devs qualify under IT specialist track, but no dedicated incentives."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Game devs classified under software engineers on CSOL; tax incentives attract studios."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Highly Skilled Professional visa",
        "reason": "Major game companies sponsor visas, but language fluency is often required."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "53",
        "policy": "NIMP 2030",
        "reason": "Plan funds digital-content clusters, including game dev tax breaks."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Vision 2030",
        "reason": "Esports and gaming hubs planned under NEOM, yet early stage."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Singapore Economy 2030",
        "reason": "Government grants for AAA studios and esports under digital-media cluster."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Abu Dhabi gaming clusters recruit talent but not formally prioritised."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industries pillar explicitly lists video-game development; Tech Nation visa revived under new scheme."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Large industry demand but no federal policy; visas via generic tech categories."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "51",
        "policy": "National Master Plan 2021-2030",
        "reason": "Mobile-game outsourcing sector growing; foreign seniors welcomed but not priority."
      }
    }
  },
  "da172c05-9d1d-4963-a31a-891e81458cab": {
    "career": "International Accountant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Generic accounting roles removed from the current shortage list; immigration possible but not prioritised."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Accountants qualify for Express Entry as skilled professionals, yet category draws focus on STEM and health."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Finance graduates welcomed under points system, but no targeted incentives for accountants."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Ongoing tax-reform needs talent, yet localisation rules limit foreign licences."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Big-4 and tech multinationals in Dublin need IFRS/US-GAAP accountants; on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Qualifies for HSP points, but not an officially designated shortage occupation."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "MADANI Economy",
        "reason": "Islamic-finance growth spurs niche demand for IFRS and Sharia-compliant accounting, yet numbers small."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Eligible as skilled occupation, yet not on Green List priority."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "IFRS roll-out and capital-market expansion create clear demand for bilingual, cross-border accountants."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Singapore Economy 2030",
        "reason": "Regional HQs require transfer-pricing and ESG-reporting expertise; not core Tier-1, but Employment Pass processing is speedy."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi aim to be global finance hubs; IFRS/transfer-pricing experts fast-tracked for Golden Visa."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Senior accounting and audit professionals explicitly listed for shortage visas in the City of London."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Global companies headquartered in the U.S. need SEC/GAAP filings, but accountants are not on any federal talent-shortage list."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Open to foreign CPAs in FDI firms, but no policy incentives."
      }
    }
  },
  "671a4a88-bbc8-4803-ba0a-d7268d69af0a": {
    "career": "Chemical Process Designer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Mining, LNG and fertiliser sectors keep chemical engineers on shortage list with fast-track visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Cleantech clusters in Ontario and Quebec seek chemical engineers for cathode and bio-fuel facilities."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "BASF-led chemical belt faces retirement cliff; Opportunity Card eases entry for process specialists."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel-to-battery refining boom drives demand for solvent extraction and leaching process designers."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Biopharma plants hire chemical engineers, yet numbers modest."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "Battery-materials and specialty-chemicals firms compete globally for process experts."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Specialty chemicals and semiconductor wet-process clusters label chemical engineers as top priority."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Small demand in dairy and biotech plants—eligible but few openings."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "73",
        "policy": "Vision 2030",
        "reason": "Mega-refineries and green-hydrogen projects at NEOM need advanced process design."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Manufacturing 2030",
        "reason": "Process engineering roles exist in petrochemicals and pharma, but hiring is selective rather than shortage-driven."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Operation 300bn",
        "reason": "Abu Dhabi chemical hub recruiting process designers for specialty polymers and fertilisers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "CCUS, green hydrogen and pharma sectors seek process talent, but visa quotas limited."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Battery, hydrogen and carbon-capture plants funded by IRA require process engineers to scale safely."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Wet-bench and CMP chemical processes need design oversight for new fabs."
      }
    }
  },
  "569ddb91-0bd1-41d0-be30-dbff89a6373e": {
    "career": "Early Childhood Education Director",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Child-care centre managers on priority list with regional visa concessions."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Early-childhood educators and supervisors named in category-based draws with bonus CRS points."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe Kita-teacher shortage; directors with German B2 language get accelerated Blue Card."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "ECE not on critical list but centres can sponsor under general work permit with salary threshold."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Child-care shortages exist, yet SSW covers nursing care, not ECE; visas possible but not prioritised."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "ECE teachers on Green List; director roles qualify after experience but ranking slightly lower."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Economy 2030",
        "reason": "MOE allows foreign preschool leaders, but quota is limited and childcare not on national shortage list."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "ECE is state-level matter; federal bills offer indirect childcare grants but no immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "ff5ad8fb-ae09-4516-9e97-a24eb66b191a": {
    "career": "Instrumental Instructor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Music teachers possible under general skilled visas, yet not listed as shortage."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Arts occupations qualify under points system but receive no targeted draws."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Freiberufler visas available for artists but not priority; income proof required."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Cultural visas exist, but instructor demand mostly local."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Performing-arts teachers fall under general points route with high thresholds."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "New entertainment sector funds music academies, opening niche instructor roles."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Singapore Economy 2030",
        "reason": "Music schools hire under general EP; arts not on shortage lists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai’s creative clusters hire instrument tutors for expat schools; not a shortage occupation."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry seniors Listed, but instrumental teaching roles get only standard visas."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Role unrelated to federal talent programs; freelance visas remain scarce."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "706e948e-fbf2-4a4f-bb83-5cf8b3ab05f7": {
    "career": "Marine Mammal Biologist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Great Barrier Reef conservation drives demand for marine researchers in universities and CSIRO."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Arctic climate research and Atlantic fisheries need marine-mammal monitoring expertise."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "North Sea institutes hire, but not classified as shortage."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Coral-reef conservation needs biologists but preference given to local talent."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Marine Institute contracts researchers though not listed as critical skill."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "Fisheries Agency funds cetacean by-catch studies; HSP visa rewards PhDs."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "Limited roles in coastal biodiversity NGOs; not a national priority."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Department of Conservation hires specialists for whale and dolphin protection."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Red Sea giga-projects include marine monitoring, but roles are limited and project-based."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Green Plan 2030",
        "reason": "Small but growing marine biodiversity labs; positions scarce."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "UAE Centennial 2071",
        "reason": "Mangrove and dugong conservation programmes hire a handful of researchers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Offshore-wind expansion requires environmental impact studies on marine mammals."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA funds coastal resilience and NOAA grants, creating research posts for marine scientists."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National Master Plan 2021-2030",
        "reason": "Marine protected-area expansion creates some research grants but no immigration perks."
      }
    }
  },
  "176b2815-3b06-46e9-b4d3-95dd76767959": {
    "career": "Sound Instructor",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Cultural mega-projects need audio trainers for new concert halls and entertainment zones."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "We the UAE 2031",
        "reason": "Dubai/Abu Dhabi media-city growth needs technical sound educators, but not explicitly prioritised."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry demand exists, yet immigration priority limited to senior creatives."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Large private music-production schools and streaming boom create hiring, but no federal priority programme."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "7e22abcb-cf28-4dd2-85e6-61588c99295c": {
    "career": "Urban Studies Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Listed civil and construction PM skills overlap with urban planning expertise."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Civil-infrastructure roles adjacent, but urban planning not specifically prioritised."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Renewable-energy and housing drives city-planning projects; planners recognised under civil engineering."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital Nusantara and coastal resilience give planners top billing."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Critical Skills List omits planning, but data-centre expansion needs specialists."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-city pilots need planners with GIS; immigration pathway exists but small scale."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "Urban-renewal projects linked to manufacturing hubs create limited openings."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Skilled Migrant Category",
        "reason": "Rebuilding and climate-resilient townships need planners, though not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Gigaprojects like NEOM demand large numbers of urban-planning specialists immediately."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Green Plan 2030",
        "reason": "Land-scarce city values planners, but tight labour market and local graduates suffice."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Smart-city and sustainability goals fuel high recruitment of urban analysts."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Levelling-up and housing initiatives create steady but not shortage-list demand."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Massive federal spend on transport and housing drives demand for planners."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "53",
        "policy": "National Master Plan 2021-2030",
        "reason": "Rapid urbanisation and transport corridors require planning expertise, albeit modest visa facilitation."
      }
    }
  },
  "b0d1a305-ecd8-43eb-8d70-311af2816289": {
    "career": "Applied Anthropologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Migration lists omit anthropology, but mining and community projects need cultural experts."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Express Entry gives generic points; social-science roles not targeted."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "",
        "reason": "Tech UX hubs in Dublin employ applied anthropologists via general work permits."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "National AI Strategy 2.0",
        "reason": "Fintech and AI firms use ethnographic UX, but supply is small and hiring selective."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "We the UAE 2031",
        "reason": "Cultural-district projects sometimes recruit ethnographers for museum content."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Creative-industries strategy values consumer insight researchers, but not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Tech firms hire ethnographers for UX and DEI, though no specific policy driver."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "2b548cad-bec4-4804-9d07-b0716093c0f7": {
    "career": "Cost Estimator",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Major infrastructure and housing demand estimators under construction PM rubric."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Construction trades stream values quantity-surveying skills."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Housing retrofit and renewable projects require cost professionals."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital project increases demand, yet localisation policy prefers Indonesians."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "",
        "reason": "Data-centre and housing boom raises demand for quantity surveyors."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Construction firms use HSP visa for related engineers; estimator pathway less clear."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "NIMP 2030",
        "reason": "Industrial parks expansion needs cost control talent, but local graduates plentiful."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Migrant Category",
        "reason": "Rebuild and climate adaptation works need estimators though not Green-listed."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Vision 2030",
        "reason": "NEOM and giga-projects recruit international quantity surveyors at scale."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Tight manpower quotas and mature supply of quantity surveyors."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Operation 300bn",
        "reason": "Mega real-estate and industrial builds require tight cost management."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "HS2 and offshore wind supply chains need estimators, but role not on shortage list."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "US$1.2 trn projects need accurate cost control talent."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National Master Plan 2021-2030",
        "reason": "Infrastructure surge creates some estimator roles, limited visa support."
      }
    }
  },
  "fe3c942a-7fe0-4ccf-93b4-2c2647478b68": {
    "career": "Counseling Psychologist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "Mental-health practitioners are high-need and on state nomination lists."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Healthcare stream explicitly lists psychologists due to severe shortages."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Demand in hospitals and refugee support, but language hurdles lower score."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Public health system lists clinical psychologists on critical-skills permits."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Psychologists on Tier 1—direct residence path."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Hospital expansion and mental-health awareness drive demand."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Growing demand in schools and hospitals but tight licence caps."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Private clinics and tele-health platforms recruit licensed counsellors."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "NHS vacancies exist but immigration rules prioritise doctors and nurses."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "",
        "reason": "Soaring mental-health demand; no federal visa priority but H-1B and J-1 options used."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "7b085e02-43b2-45d7-bcde-6191cd908811": {
    "career": "Child Development Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL lists early-childhood teachers; employers can sponsor visas quickly for child-development professionals."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Early-childhood educators are a named priority occupation; extra CRS points and dedicated invitation rounds available."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe shortage of Kita (day-care) educators; streamlined Blue Card rules for qualified child-development specialists."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on Critical Skills list; general employment permit possible but wage thresholds apply."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "73",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Primary teachers and early-childhood educators on Green List enable Straight-to-Residence visas."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Private nurseries expanding, but no official shortage list; visas possible yet competitive with local graduates."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Teachers were removed in 2025; schools still hire but without shortage-occupation concessions."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Act funds new childcare facilities, creating demand for qualified child-development staff, but role is not formally on any shortage list."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b5b1f05b-26fe-4d9e-bf3a-4637135690ea": {
    "career": "Chief Financial Officer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "List focuses on engineers and nurses; CFO roles follow standard employer-sponsored route with no fast track."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Strategy courts senior executives yet places higher emphasis on tech than finance chiefs."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Possible Blue Card for finance execs, but German-language requirement limits openings."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "SOEs and EV-battery giants hunt experienced CFOs for IPO readiness."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "While not on the list, multinational HQs in Dublin regularly sponsor high-salary CFO roles under general permit."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "High-points system rewards executive pay and experience, but few companies recruit non-Japanese CFOs."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "MADANI Economy",
        "reason": "Islamic-finance push opens some CFO posts; no dedicated fast-track."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Megaprojects (NEOM, Red Sea) seek international CFOs to handle multi-billion-dollar budgets."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "National AI Strategy 2.0",
        "reason": "MAS drives sustainable-finance growth; global CFOs welcomed under ONE Pass but not a critical-shortage occupation."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "UAE Centennial 2071",
        "reason": "Financial-services expansion in DIFC and ADGM makes top-tier CFOs a critical talent import."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "London’s global finance hub values senior finance leadership; Skilled Worker visa salary thresholds easy for CFO pay."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Major clean-energy firms funded by IRA need seasoned finance leaders, but no immigration priority for CFOs."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "9a623cef-071d-41ab-bda8-afbd9bc6535a": {
    "career": "Employee Relations Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "Not on Core Skills list; sponsorship possible but capped."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Strategy emphasises tech talent; HR roles access general work permits only."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Points system allows HR professionals, but German language is a de-facto barrier."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "RPJPN 2025-2045",
        "reason": "Labour regulations push companies to use Indonesian HR managers."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on Critical Skills list; general permit option only."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "MADANI Economy",
        "reason": "Government encourages localisation of HR functions."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "ER roles compete for limited points; STEM dominates quota."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Vision 2030",
        "reason": "Saudization pushes companies to hire local HR staff."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Singapore Economy 2030",
        "reason": "Companies still issue EPs for senior HR roles, although quota tightened."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "We the UAE 2031",
        "reason": "Multinationals in free zones recruit experienced ER talent, but no shortage designation."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "HR removed from shortage list in 2025; sponsorship now requires full salary thresholds."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Large federally funded projects expand unionised workforces, increasing need for ER specialists, yet no visa priority."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "ER specialism not targeted; manufacturing HR favours locals."
      }
    }
  },
  "7f22e8f3-63b3-4d29-8746-4df8d4a09a0e": {
    "career": "Industrial Designer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Industrial design sits adjacent to manufacturing engineers; some state nomination pathways exist."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Not a named occupation, but STEM degrees and design portfolios score well under points system."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Automotive and consumer-goods clusters in Bavaria and Baden-Württemberg actively sponsor product designers."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Product design roles tied to EV manufacturing; still emerging."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on list; med-tech firms sometimes sponsor under general permit."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics and consumer electronics giants recruit foreign product designers via HSP."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan’s EV and aerospace streams need design talent, but not shortage-listed."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Small market; roles exist but no priority status."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Tourism and retail megaprojects create limited demand for experiential product design."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Manufacturing 2030",
        "reason": "High-value manufacturing requires design for precision instruments; ONE Pass eases senior hires."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Operation 300bn",
        "reason": "Manufacturing push includes consumer products; visas available but not prioritised."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry pillar lists industrial/UX designers; London studios sponsor visas."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Boom in advanced hardware and consumer devices requires product designers with CAD and human-factors expertise."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Electronics OEMs growing; design roles exist but local skills supply adequate."
      }
    }
  },
  "5fb3b406-ad41-4dd1-8e15-f28aa71cc20d": {
    "career": "Reading Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Secondary and special-needs teachers on CSOL; reading specialists eligible for skilled visas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "K-12 teachers are a priority category; literacy specialists readily qualify."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "STEM teachers prioritised, but literacy roles still enjoy easier recognition in shortage regions."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Teaching roles fall outside Critical Skills; general permit route exists but competitive."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Primary and secondary teachers on Tier 1 allow direct residence pathways."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "We the UAE 2031",
        "reason": "Private international schools recruit, but not a government priority."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Teachers removed from shortage list; sponsorship possible only at high salary bands."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "New school infrastructure funds indirectly raise demand for literacy experts, but no federal shortage listing."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "606d433f-70a6-4735-a9fb-a3bcf7de9aae": {
    "career": "Clinical Instructor",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Migration Strategy 2023",
        "reason": "Severe allied-health shortages; teaching posts eligible for health-care visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Physiotherapists fall under healthcare priority; instructors help expand training capacity."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Physiotherapy educators included in broader healthcare shortage lists."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Physiotherapists are critical; instructors can piggy-back, though not explicit."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Ageing care sector needs rehab educators, yet immigration route is narrow."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Green List covers physiotherapists; instructors bundled into same immigration code."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Vision 2030",
        "reason": "New medical universities opening, but Saudization prefers local faculty."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "MOH trains its own therapists; foreign instructors hired case-by-case, not a policy focus."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "We the UAE 2031",
        "reason": "Private hospitals hire expat educators for CPD, yet not on priority list."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Universities recruit internationally, but clinical teaching posts not on Shortage List."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Universities and hospitals look for licensed PT educators, but no dedicated federal talent policy."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "aac6bf36-3092-4c60-b2b8-de0e1cbe92af": {
    "career": "Fine Art Photographer",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Berlin’s art scene welcomes freelancers, yet outside immigration priority."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Vision 2030",
        "reason": "State-funded galleries seek talent for cultural tourism projects."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Grants for galleries exist, but not in National AI/Manufacturing priorities."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Dubai art fairs create gigs, but still niche and project-based."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry recognised, but immigration gate is Global Talent visa, not shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Large art market and O-1 visa for extraordinary artists, but no priority policy."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "cdf993d3-2a4f-4632-9ee2-383112cc1c29": {
    "career": "Producer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Local quotas limit foreign producers; some international projects in Queensland."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Tax credits fuel production growth in Vancouver/Toronto, yet not on Express Entry list."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Film funds attract co-productions, but immigration still general artist visa."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Streaming boom creates co-production roles, but outside policy lists."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Growing animation sector, but producers not on Critical Skills list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Pinewood Iskandar incentives, but not on NIMP priorities."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Weta-driven projects hire producers, but not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Kingdom pouring billions into film and entertainment; senior producers fast-tracked."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Government grants media funds; still secondary to tech focus."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi free zones give Golden Visas to creative-media executives."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Film, TV and gaming leaders specifically highlighted; Global Talent visa streamlined."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "",
        "reason": "Hollywood remains world’s biggest film market, but no specific immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "175350e8-6125-4062-b7a7-7873f222a3fb": {
    "career": "Public Health Advocate",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Migration Strategy 2023",
        "reason": "Workforce shortages in community health and health-promotion recognised in regional visas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Healthcare and French-speaking applicants prioritised; advocates often registered nurses or MPH grads."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Public-health professionals improve ageing population outcomes; demand rising."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Public-health physicians and analysts remain on list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Health promotion specialists included in wider healthcare shortage categories."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Lifestyle-disease programmes funded, but local hiring preferred."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "MOH funds campaigns; import of foreign advocates limited."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Government pushes wellness campaigns; foreign specialists welcomed but not prioritised."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "NHS hires health-promotion officers, but removed from shortage list in 2025."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "NGOs and CDC fellowships exist, but role not mentioned in federal talent programmes."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "531456a5-19f9-48e5-b011-f28ffb2f66c6": {
    "career": "Research Chemist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "CSOL lists chemical engineers, but pure researchers face limited sponsored roles."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Life-science and cleantech labs compete for PhDs; not core Express Entry priority."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Chemical and pharmaceutical giants struggle to fill R&D posts."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Critical-minerals processing needs chemists, yet immigration capped."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma and med-tech manufacturing clusters need synthetic and analytical chemists."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "Semiconductor and battery firms sponsor chemists for materials innovation."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Specialty chemicals and advanced materials sit at the heart of NIMP priorities."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "NEOM and Aramco fund materials R&D, but oil focus fluctuates."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Economy 2030",
        "reason": "Biomed and battery research hubs exist, but quota-managed."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Operation 300bn",
        "reason": "Abu Dhabi’s pharma parks hire chemists, yet talent list mainly engineers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences R&D and clean-energy chemistry explicitly prioritised."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Battery materials and green-hydrogen R&D need chemists."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Materials labs emerging for chip packaging, but still early-stage."
      }
    }
  },
  "4d664aef-969e-4f00-bb55-9d599d139ed0": {
    "career": "Social Studies Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Humanities teachers are eligible but below STEM and trades on points tables and state nominations."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Category draws focus on French, early-childhood and STEM; social-studies teachers rely on general CRS points."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Schools struggle mainly for STEM; social-science educators qualify only under general skilled route."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Skilled Migrant Category",
        "reason": "Green List excludes social-studies; migration possible with standard points if you hold teaching registration."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "K-12 humanities teachers can access H-1B or EB-2 visas but are not on any U.S. priority list."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "3b200237-6700-4964-b926-baa56db0c2f2": {
    "career": "Theatre Practitioner",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "No dedicated immigration stream; arts council grants exist but are competitive."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Vision 2030",
        "reason": "New mega-entertainment districts recruit international performers for festivals and resorts."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi push live entertainment to boost tourism."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry seniors mentioned, but visa sponsorship remains employer-driven."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Artists can secure O-1 visas but theatre is not federally prioritized."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "2ae26ad0-0bee-4af2-8ed5-c994103c2a5d": {
    "career": "Applied Sociologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "Occupation list recognises ‘Social Professionals nec’ with moderate points weight."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Social scientists welcomed under general research stream, yet no category draws."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Sociologists can score on qualification points but are not shortage."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Qualifies for Stamp 1 employment permit under general category."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Universities can sponsor Skilled Worker visas; not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Roles in UX research and public policy qualify for H-1B but lack priority status."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "13d6ae16-caf2-4a6e-a660-e4df867a6ad3": {
    "career": "Asian Studies Professor",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Migration Strategy 2023",
        "reason": "Universities sponsor academic visas; humanities not on priority list but academia enjoys streamlined processing."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Canada recruits researchers through Global Talent Stream and university LMIA exemptions."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Universities can hire non-EU professors; points granted for PhD and salary level."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Universities may sponsor, but Critical Skills list centres on STEM."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Foreign scholars in international relations gain HSP points though demand limited."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Migrant Category",
        "reason": "Professor roles qualify for high points but no dedicated shortcut."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Economy 2030",
        "reason": "NUS and NTU recruit Asia scholars to support regional expertise despite broader STEM tilt."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Branch campuses hire foreign faculty, but no federal priority for humanities."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Global Talent visa fast-tracks distinguished researchers; Asia expertise valued post-Brexit."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "",
        "reason": "Top U.S. universities invest heavily in Asian studies; O-1 and EB-2 NIW favour distinguished academics."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "f7f13b90-151a-49d3-8255-720953697f66": {
    "career": "Banquet/Event Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Migration Strategy 2023",
        "reason": "Hospitality managers are eligible under ANZSCO 141111 yet not priority."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Provincial nominee streams for tourism exist but are small and competitive."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Mega-projects (NEOM, Red Sea) urgently need international banquet and conference management talent."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "MICE hub needs event staff but passes judged on salary rather than shortage."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Expo legacy and constant MICE events drive demand for experienced event managers."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b146ae89-c6d5-4a3c-9125-7988a5caacd5": {
    "career": "Educational Data Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Migration Strategy 2023",
        "reason": "Core list names software developers and data analysts, with strong ed-tech cluster in Melbourne and Sydney schools adopting analytics."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Data scientists are an explicit priority occupation, and provinces fund digital-learning initiatives for remote communities."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialists fast-tracked; Länder push digital-schooling after COVID, creating steady but modest demand."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Digital-learning ambitions exist, though immigration priority is for engineers in energy and minerals."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Data scientists qualify for fast permits; growing ed-tech exports from Dublin create openings."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "AI researchers favored, but education vertical is niche and mostly domestic-language products."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "MADANI Economy",
        "reason": "AI talent encouraged, yet education analytics market small outside Kuala Lumpur."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Digital skills welcome but education analytics not on Green List, so only general ICT pathway available."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Smart-campus projects need data talent, yet most hiring is outsourced vendors, limiting direct roles."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "National AI Strategy 2.0",
        "reason": "AI talent fast-tracked; Ministry of Education runs large-scale learning-analytics pilots."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "We the UAE 2031",
        "reason": "Smart-school pilots in Abu Dhabi require analytics, but not listed among top talent visas."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "AI and digital specialists on Shortage List; universities racing to prove learning-outcome gains."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Federal grants pour into AI-driven learning analytics; universities and ed-techs recruit specialists to turn student data into adaptive tools."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "National Master Plan 2021-2030",
        "reason": "Focus on semiconductor and manufacturing AI; ed-tech demand rising but not policy-backed."
      }
    }
  },
  "d07e0b06-baf1-44b7-8a21-2029c5c06211": {
    "career": "Field Geologist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Mineral exploration drives a chronic shortage of geologists across WA and Queensland mines."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Geoscientists fall under engineering and mineral-resource categories, vital to large mining sector."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Renewable-energy and tunnelling projects hire some geologists, yet not on priority lists."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel-rich EV battery push needs foreign geologists to map new deposits."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List focuses on IT and pharma; geology roles exist mainly in niche consultancies."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "NIMP 2030",
        "reason": "Some demand for rare-earth exploration, but expatriate quotas tighten."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Skilled Migrant Category",
        "reason": "Seismic risk mapping and infrastructure rebuilds after earthquakes require geoscience skills."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Massive investment in mineral extraction and megacity groundwork fuels high demand."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Operation 300bn",
        "reason": "Large infrastructure and groundwater projects need geotechnical surveys, though volumes smaller than KSA."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Limited openings tied to offshore wind and HS2 rail; not a shortage occupation."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Act funds critical-minerals mapping and highway tunnelling, creating steady but modest demand for field studies."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "National Master Plan 2021-2030",
        "reason": "Nickel and bauxite exploration rising, yet local talent preferred; permits restrictive."
      }
    }
  },
  "0199bbd7-b7e6-4f74-91d8-500546327801": {
    "career": "Innovation Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Migration Strategy 2023",
        "reason": "No specific pathway; corporate demand exists but not prioritised."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Programme targets deep-tech founders rather than generic consultants."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Card awards points for management experience, yet innovation consulting not shortage field."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "RPJPN 2025-2045",
        "reason": "Some space for consultants in state-owned enterprise reform, but no priority lane."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List focuses on tech talent; consulting demand exists but without fast-track."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "Gigaprojects hire strategy advisors, but visas prioritise engineers and hospitality executives."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Singapore Economy 2030",
        "reason": "Management consultants eligible for Employment Pass but not on Tech.Pass priority."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai’s free zones give Golden Visas to innovation specialists consulting on fintech and AI."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "53",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital and creative sectors hire consultants, though role not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Clean-tech subsidies create advisory projects, but role not immigration-priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "c8c38b1c-2afe-4c11-8696-7b9981cc52ef": {
    "career": "MPhil Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "Universities hire humanities tutors, but visa priority goes to STEM teachers."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Programme welcomes academic researchers yet emphasises STEM and AI."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Card assigns extra points for doctorates; DAAD funds humanities fellowships."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List excludes humanities; some post-doc grants available."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Skilled Migrant Category",
        "reason": "Humanities academics can qualify, yet few openings compared to STEM."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "Universities hire humanities PhDs but no dedicated visa track."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "UAE Centennial 2071",
        "reason": "Branch campuses hire humanities researchers, although grants small."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Universities can sponsor researchers easily; UKRI funds arts councils."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "CHIPS and Science Act",
        "reason": "Act boosts research fellowships, though humanities funding trails STEM."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "19ffa7e7-f1bc-4eaa-824c-cddc13d93891": {
    "career": "Tax Manager",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Accountants welcome yet overshadowed by IT and health occupations."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Financial-services expansion in Dublin keeps qualified tax professionals on employer-sponsored permits."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Vision 2030",
        "reason": "New corporate tax and VAT regimes create advisory roles, but Saudization limits numbers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Singapore Economy 2030",
        "reason": "Regional HQs require tax planning; Employment Pass accessible but not on shortage lists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Introduction of 9% corporate tax drives strong need for experienced managers, with Golden Visa options for finance professionals."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Financial services hub recruits tax experts, but role not on shortage list."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "New green-energy credits complicate compliance, boosting demand but not an immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "c8a4041f-2aa4-49a2-a95d-d8593c9d31e7": {
    "career": "Developmental Psychologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Mental-health expansion funds but occupation not on Core Skills list—slots exist mainly in universities."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Allied-health and French-speaking researchers score extra CRS points, making academic psychologists competitive."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Universities recruit English-speaking researchers; however, clinical licensing hurdles keep numbers limited."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Some openings in child-services NGOs, but not on Critical Skills list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Child-wellbeing focus in Ministry of Education drives some hiring, but few permanent visas available."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Early-childhood initiatives offer limited research posts but psychology not in National AI Strategy priority."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Universities hire PhDs, yet the Skilled Worker shortage list excludes psychology—standard visa route only."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "",
        "reason": "Large university system funds child-development labs and mental-health grants, creating steady demand for PhD psychologists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "6ed6cce4-b45d-460b-adde-8c78c25a2d61": {
    "career": "Engineering Technologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Engineers listed, yet technologist subclass competes with local TAFE graduates."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Manufacturing tech is welcomed but priority given to pure software roles."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "National shortage of mechatronics and production technologists in Mittelstand factories."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel-to-EV battery plants hiring line-automation technologists."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Some med-device factories hire, but list prefers design engineers."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics and semiconductor fabs woo mid-career technologists with points-based HSP visa."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "NIMP scales up semiconductor back-end and aerospace composites needing applied technologists."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Gigaprojects and new industrial zones need automation specialists."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Manufacturing 2030",
        "reason": "Precision-engineering sector values hands-on technologists for smart factories."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing push in Abu Dhabi creates demand for process technologists."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 backs EV and aerospace plants requiring manufacturing technologists."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Billions allocated to modernise factories and reshore manufacturing need hands-on technologists for automation lines."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Chip-packaging plants hunt for process-improvement technologists."
      }
    }
  },
  "daa0c594-9370-432f-bdc6-8aedc75aecec": {
    "career": "Global Health Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Migration Strategy 2023",
        "reason": "State health departments list public-health management shortages."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Health-system leadership and French language earn top CRS; provinces actively recruit for public-health management."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Hospitals and NGOs seek programme managers to integrate migrant health services."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "RPJPN 2025-2045",
        "reason": "Expansion of universal health insurance sparks need, but Bahasa fluency expected."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Public-health managers hired ad-hoc; not on Critical Skills list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Some roles in regional WHO hubs; quotas limited."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Migrant Category",
        "reason": "Pacific-island health programmes drive limited but high-priority hiring."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Mega-hospital projects and Hajj health logistics require experienced global-health leaders."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Green Plan 2030",
        "reason": "Regional disease-surveillance hub recruits global-health programme managers."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi position themselves as medical-tourism hubs, incentivising health-system managers."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "NHS hires managers but visa cap and budget cuts limit sponsorship."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "USAID contracts employ many, but not a formal immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "c58ad17f-0f32-4479-b148-b4849d057a12": {
    "career": "Public Health Dentist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Migration Strategy 2023",
        "reason": "State health services list dental officers for rural clinics."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Shortage of dentists in northern provinces; French skills boost CRS."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Municipal health offices need community dentists, though B2 German a must."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "HSE hires sporadically; Critical Skills list excludes dentistry."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 2)",
        "reason": "School dental service vacancies grant fast-track residency."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Government drives preventive clinics to cut expensive restorations."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Polyclinics hire, but quota tight and boards require top-50 dental school degree."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "We the UAE 2031",
        "reason": "Population-wide screening initiatives open roles for community dentists."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "NHS struggles to sponsor visas; dentistry not on shortage list post-2025."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Rural oral-health grants recruit dentists, but immigration caps apply."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "9027d4d7-7dea-4fb0-9c2f-b17b140f01eb": {
    "career": "Screen Production Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Screen Australia funds projects, but immigration focus elsewhere."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Tax-credit film hubs hire, yet occupation not prioritised for visas."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Asta Cita",
        "reason": "Tourism-driven creative hub in Bali offers limited opportunities."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Weta-led productions hire freelancers; no formal shortage status."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Massive investment in film cities and entertainment parks needs production crew."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "MediaCorp and regional streaming shoots hire freelancers, but not policy priority."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai Studio City incentives attract foreign screen professionals."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries listed as strategic; studios around London and Manchester expanding."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Hollywood still the largest employer, but immigration preference low."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "6ba263ea-c5b3-4a23-8b23-03e9c3832fc5": {
    "career": "Actuarial Modeler",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Migration Strategy 2023",
        "reason": "Actuaries neither on Core Skills list nor regional lists; recruitment possible but no fast-track."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Finance professionals can still qualify via points and French-speaker stream, yet not an explicit shortage occupation."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Can come under general STEM/finance points, yet not named shortage."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Actuaries/financial quants explicitly listed; 2-year Critical-Skills permit leads to immediate PR."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Points for finance specialists but insurers hire mainly domestic talent."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "Islamic-finance insurers growing; no dedicated pathway but demand exists."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Low but steady demand in a small insurance market; not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Expanding insurance and pensions sector needs risk experts but no dedicated visa incentive."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Singapore Economy 2030",
        "reason": "Sustainable-finance push values actuaries; COMPASS framework gives bonus to financial-risk specialists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai’s DIFC positions insurance & fintech growth; actuarial skills get Golden Visa points."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Financial-services shortage list prioritises City risk & actuarial quants; fast-track Skilled Worker visas."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "—",
        "reason": "Large insurance sector needs actuarial talent but generic finance is not a federal immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "f9c51598-fd12-4122-a7ac-918dd47a686c": {
    "career": "Dance Studies Professor",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Migration Strategy 2023",
        "reason": "University-sponsored visas available; arts lecturers not priority but still sponsored."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Academics score high on CRS; arts funding encourages diversity hires."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Points system supports PhD academics; arts funding modest."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Academics eligible for Critical-Skills if salary threshold met, though arts not listed."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Universities can sponsor, but English-taught dance programs rare."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Small university sector makes roles scarce; no fast-track list."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "LaSalle & NAFA hire foreign faculty, but arts not a manpower shortage."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "We the UAE 2031",
        "reason": "Private universities hire liberal-arts faculty, but immigration priority is STEM/finance."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry support and Global Talent route for arts scholars."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "—",
        "reason": "Universities routinely sponsor O-1/H-1B for arts faculty, though not a federal shortage field."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "57123e0e-24ca-4cff-98a9-be9b6c14a3d4": {
    "career": "Engineering Project Manager",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Construction project managers are explicitly listed for priority visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Construction managers and engineers receive additional CRS points and provincial nominations."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Major renewable-energy and rail projects need bilingual engineering PMs."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "RPJPN 2025-2045",
        "reason": "Nusantara capital build-out and EV battery plants require foreign PM expertise."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Civil/mechanical/electrical engineers on list; PM experience boosts salary threshold."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-city and semiconductor fabs value foreign project managers with bilingual skills."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "EV and semiconductor plant roll-outs need experienced PM talent."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Construction project managers on Tier-1 list with direct pathway to residency."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Vision 2030",
        "reason": "NEOM, Red Sea and giga-projects are hiring thousands of engineering managers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Manufacturing 2030",
        "reason": "Wafer-fab expansions and data-centres look for PMP-certified engineering managers."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "Operation 300bn",
        "reason": "Advanced-manufacturing and mega real-estate projects offer Golden Visas for senior PMs."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean-energy and advanced-manufacturing clusters need PMs, but general shortage list closed in 2025."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Federal trillions for bridges, EV charging and semiconductors create massive demand for engineering PMs."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "National Master Plan 2021-2030",
        "reason": "Infrastructure and offshore-wind projects recruit expat engineering managers."
      }
    }
  },
  "398f3504-87e6-49fe-be0e-554e1a3097c1": {
    "career": "Forensic Psychologist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Clinical & forensic psychologists on priority list with regional sponsorship."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Psychologists awarded additional CRS points under healthcare stream."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Mental-health staff shortage exists, but language/ licensing hurdles lower attractiveness."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Psychologists not on list but can enter via general employment permit with high salary."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "—",
        "reason": "Strict licensing in Japanese; few English-language forensic roles."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Clinical psychologists on Green List; forensic subspecialty accepted."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Prisons and new mental-health facilities recruit expats; licensing bureaucracy still evolving."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Green Plan 2030",
        "reason": "Prisons and IMH recruit expat psychologists but roles are few and competitive."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "Courts and hospitals hire forensic psychologists, but role is niche."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Clinical psychologists on shortage list; forensic roles compete within NHS security services."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "—",
        "reason": "Criminal-justice system hires via J-1/H-1B; mental-health talent shortage supports visas but not a named priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "aeb979d5-9257-498a-a07c-1a88408ae175": {
    "career": "Procurement Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Some state nomination for supply-chain managers, yet not core skill."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Manufacturing supply-chain talent welcomed but not on targeted lists."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Advanced-manufacturing clusters need global procurement to mitigate supplier risk."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel/EV ecosystem relies on global sourcing; expatriate managers get KITAS easier."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Procurement not on list but eligible via general employment permit if >€34k salary."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Manufacturers value bilingual procurement talent; HSP points for salary and degree."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Electronics and EV supply chains need strategic sourcing managers."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Roles exist but few immigration incentives."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Mega-projects require experienced procurement professionals across construction and defense."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Singapore Economy 2030",
        "reason": "Regional HQs run APAC procurement from Singapore; COMPASS favours supply-chain leadership."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Operation 300bn",
        "reason": "Manufacturing and logistics sectors value global sourcing experts; Golden Visa possible at AED 30k+ salary."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Manufacturing/localisation push increases demand but visa requires sponsorship and high salary."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Clean-energy build-out spurs supply-chain hiring, yet no special visa provisions."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "National Master Plan 2021-2030",
        "reason": "Electronics exports grow; foreign procurement experts hired though no fast-track."
      }
    }
  },
  "ea2bf717-4588-4424-85c4-c178f80c5864": {
    "career": "Academic Advisor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Teacher shortages indirectly raise demand for school support staff such as advisors."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Education occupations weighted; advisors sometimes grouped with counsellors for immigration points."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Universities allowed to directly recruit non-EU staff, though no shortage designation."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Points for education professionals; advisors accepted but not on Green List."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "We the UAE 2031",
        "reason": "Rapid expansion of international schools/universities creates some openings for advisors."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Universities hire many advisors but role not referenced in federal priority lists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "146f1440-54d9-4275-8dfb-ea59dd27c547": {
    "career": "AI Integrator",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Migration Strategy 2023",
        "reason": "Digital skills welcomed but not on Core Skills top list."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Category explicitly lists AI/ML specialists for fast-track PR."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz",
        "reason": "IT Spezialist visa lets AI experts skip degree requirement if experienced."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "AI linked to fintech and e-commerce; still early-stage demand."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "AI/ML engineers on list; integrator role accepted under same code."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "AI researchers fast-tracked; enterprise integrators qualify if senior."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Automation emphasis, but AI integrators secondary to hardware engineers."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Migrant Category",
        "reason": "Points possible, yet not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "73",
        "policy": "Vision 2030",
        "reason": "Nation building AI hubs at NEOM; integrators needed."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "National AI Strategy 2.0",
        "reason": "Explicit need for professionals to embed AI in finance, logistics, healthcare."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "UAE Centennial 2071",
        "reason": "Government champions AI Everywhere agenda; Golden Visa for tech talent."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital/AI top sector; Scale-up visa streamlines entry."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds AI adoption across industries; firms scramble for integrators."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Strategy mentions AI but prioritises chip talent first."
      }
    }
  },
  "21c197f1-d633-48e0-af1d-520315b0456c": {
    "career": "Writing Workshop Facilitator",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai creative-zone free-lancer visas make workshops feasible."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "53",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries valued; Global Talent route possible but competitive."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Creative-industry roles accepted but not prioritised for visas."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "5007399c-48ff-4541-8a58-9db22693ce3c": {
    "career": "Biomechanical Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Medical device engineers sometimes sponsored under biomedical engineer code."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Med-tech engineers welcome, but not top-tier shortage."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Medical technology hub needs engineers; Blue Card straightforward."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Domestic demand emerging for prosthetics and implants."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "81",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Ireland is EU’s med-tech hub; biomechanical engineers on list."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Highly Skilled Professional visa",
        "reason": "Bio-robotics and prosthetics research funded under HSP."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan targets medical device export growth."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Green List (Tier 2)",
        "reason": "List includes biomedical engineers for future shortages."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Growing med-tech manufacturing but early stage."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Singapore Green Plan 2030",
        "reason": "Biomedicine one of Singapore’s five manufacturing pillars; generous R&D grants."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing push includes medical devices."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences and med-tech designated high-growth sector."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act earmarks billions for biotech and advanced materials."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "National Master Plan 2021-2030",
        "reason": "Biotech a noted sector but behind chips and energy."
      }
    }
  },
  "6257969d-8018-464b-9445-f5b34e63ff00": {
    "career": "Observational Astronomer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Square Kilometre Array and optical observatories boost demand for astronomers."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Research chairs available, but not shortage occupation."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Max Planck institutes recruit foreign astrophysicists easily through Blue Card."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Highly Skilled Professional visa",
        "reason": "Subaru telescope and JAXA projects recruit foreign astronomers."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Small astronomy community; points possible but limited roles."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "UKRI funds large telescope projects; global talent visa applies."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds NSF and NASA astrophysics missions and facilities."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "6f3fccc8-4bc9-4fcc-98a8-46bc5b36f0b4": {
    "career": "Political Philosopher",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Academics can qualify through French-language or PhD points, yet not an explicit shortage."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Universities hire international humanities PhDs, but not shortage-listed."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "24",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Singapore Economy 2030",
        "reason": "MOE hires philosophy lecturers but role is peripheral to national tech agenda."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Global Talent visa covers humanities academics though not shortage-listed."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "CHIPS and Science Act",
        "reason": "Act boosts NSF social-science funding and visas for research faculty, but demand is niche."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "24",
        "policy": "",
        "reason": ""
      }
    }
  },
  "7c40ba4c-1d5e-4446-827d-018eac245cf4": {
    "career": "Education Sociologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Migration Strategy 2023",
        "reason": "Research academics can obtain visas, but not shortage-listed."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities and policy institutes hire PhDs; points for French or PhD increase visa chances."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Card rewards advanced degrees; education research welcomed in DAAD and Max Planck institutes."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List excludes social-science researchers."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "26",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "National Institute of Education hires researchers; still peripheral to tech agenda."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Global Talent route covers social scientists plus ESRC grants on education inequality."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "CHIPS and Science Act",
        "reason": "NSF funds social-science research on STEM education and inequality; universities recruit internationals."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "af9f36e9-f1e7-49db-8920-0652529e4741": {
    "career": "Graphic Communicator",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Vision 2030",
        "reason": "Entertainment and tourism projects need branding, opening contracts for experienced creatives."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "National AI Strategy 2.0",
        "reason": "Designers needed in UI/UX for digital services, yet not in top talent list."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s media free-zones grant easy visas for creative talent though not formal shortage listing."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry visas recognise experienced designers under ‘arts and culture’ route."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Creative roles serve public outreach for infrastructure projects, but no immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4b1a1a9a-d37a-4bd1-8ed9-796954fca27d": {
    "career": "Reporter",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "27",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "31",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Singapore Economy 2030",
        "reason": "International bureaus base correspondents here, but permits capped."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Dubai Media City issues permits but competitive and regulated."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative visas cover experienced journalists for UK media houses."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Local-news grants may open roles, yet visas for reporters are limited."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "253f1918-90b3-4762-abdb-c7d1c0453a1b": {
    "career": "Biomathematician",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Migration Strategy 2023",
        "reason": "Bioinformatics included under ‘medical scientists’ shortage."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "AI-driven health research and pharma hubs in Toronto/Montreal seek biomath skillsets."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Max Planck and biotech clusters hire computational biologists; Blue Card pathway easy."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma and med-tech giants need mathematical modellers."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Highly Skilled Professional visa",
        "reason": "Riken and AIST recruit computational biology PhDs."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Listed as ‘biotechnologist’ Tier-2; limited spots."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Genomics centres like KACST expanding; niche but growing."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Singapore Green Plan 2030",
        "reason": "A*STAR and Genome Institute hire biomathematicians for precision medicine."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Operation 300bn",
        "reason": "Biotech free-zones (Dubai Science Park) court computational biology talent."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences super-cluster and Global Talent visa prioritise bioinformatics and modelling."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Funds cross-disciplinary biotech and computational biology; NIH and pharma recruit international PhDs."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      }
    }
  },
  "e5942cc3-e6ff-4068-a77a-99565a00fa1e": {
    "career": "Filmmaker",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Location incentives exist but no nationwide shortage list for filmmakers."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Federal and provincial tax credits plus immigrant streams for cultural workers fuel Toronto/Vancouver production hubs."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Berlin’s indie scene draws artists, yet film roles compete with EU talent and are not shortage-listed."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Screen Ireland incentives draw crews, yet directors are not on critical list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Weta and Auckland studios create demand, but entry is project-based rather than a formal shortage occupation."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Vision 2030",
        "reason": "Massive investment in entertainment cities (NEOM, AlUla) needs directors for local content."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Singapore Economy 2030",
        "reason": "Media industry support, yet filmmaking not in Tier-1 talent pass; competition intense."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Dubai Studios City offers 100% foreign ownership and golden visas for creative talent."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Film & high-end TV are explicitly named creative clusters with tax reliefs and Shortage Occupation concessions."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "CHIPS and Science Act",
        "reason": "Hollywood is still the world’s largest film market, attracting O-1/B1 creative visas despite no explicit film policy."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "dc71679b-0182-4447-b750-75b7a3ea762a": {
    "career": "Music Teacher",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "STEM teachers prioritized; music teachers accepted mainly in regional schools."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Nationwide shortage of K-12 educators; provinces issue PNP invites for arts teachers."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Teacher demand high, but music vacancies fewer and language barrier steep."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Teacher shortages mainly in maths and Irish; arts teachers possible via general work permit."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Green List covers primary/secondary teachers; music gets points but no fast-track."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Music excluded from post-2025 shortage list though academies recruit internationally."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "CHIPS and Science Act",
        "reason": "Teacher shortages exist but arts subjects get less visa sponsorship."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "31",
        "policy": "",
        "reason": ""
      }
    }
  },
  "26d3f81d-d439-4559-99b8-7b90643fbbae": {
    "career": "Urban Sustainability Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Urban infill and renewable projects need sustainability expertise, though not formally shortage-listed."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Cities pledge net-zero by 2040, opening PNP streams for green professionals."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz",
        "reason": "Energiewende and EU taxonomy reporting boost demand for LEED/DGNB consultants."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital Nusantara drives some sustainability advisory contracts."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Large data-centre pipeline seeking carbon-neutral planning."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-city pilots add roles, but language and local licensure limit access."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Sustainability reporting requirements grow, yet immigration preference is industrial engineers."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Migrant Category",
        "reason": "Climate-resilient rebuilding after storms requires planners with sustainability skills."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Vision 2030",
        "reason": "Smart-city megaprojects (NEOM) recruit global sustainability experts."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Singapore Green Plan 2030",
        "reason": "Carbon tax and green mark scheme create steady consultant demand."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Operation 300bn",
        "reason": "Green Building Regulations and COP28 legacy fuel consultant demand."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Net-zero strategy names clean-growth and built-environment decarbonisation specialists as priority."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Billions for climate-resilient transit and buildings drive demand for sustainability advisers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "National Master Plan 2021-2030",
        "reason": "Urbanisation rapid but consultant visas ad-hoc."
      }
    }
  },
  "9bf4f5c4-d677-4e75-a2a7-85118fecf962": {
    "career": "Healthcare Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Migration Strategy 2023",
        "reason": "Public hospitals in regional areas advertise for overseas health administrators."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Provinces list health services managers under critical occupations amid ageing population."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Hospital consolidation needs managers with international quality-improvement expertise."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "RPJPN 2025-2045",
        "reason": "Private hospital boom but foreign exec roles limited post-covid."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Acute shortage of clinical directors, though preference for EU applicants."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "Medical tourism hub growth requires managers, but locals preferred."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Te Whatu Ora seeks clinical services managers for over-stretched districts."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Privatisation of state hospitals makes experienced international managers top-priority hires."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Singapore Economy 2030",
        "reason": "Ageing population and JCI accreditation push raise demand for experienced managers."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "UAE Centennial 2071",
        "reason": "Government targets world-class hospital clusters; golden visa available for healthcare executives."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "NHS trusts outsource some senior management roles but immigration rules tightened."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Medicare modernisation and digital-health funding spur administrative leadership demand."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "aec5db40-52b4-4430-bb69-17b5aaf9afb9": {
    "career": "Policy Advocate",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Non-profit sector uses standard work permits; advocacy not a category-based selection."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Points for social-science grads, but limited NGO sponsorship."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "NGO hiring possible under general permits."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Think-tanks in London hire, but not shortage-listed."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "DC think-tanks sponsor advocacy visas, but not on priority lists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "54ecab9e-f3b1-4a4f-ba6b-979dcb6ce488": {
    "career": "Preservation Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Migration Strategy 2023",
        "reason": "Museums recruit internationally when skills are rare, yet role not on Core Skills Occupation List."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Occasional demand through cultural-heritage streams; not a named priority occupation."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Heritage conservation recognised craft; Blue Card possible, but not a shortage occupation."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Mega-projects like AlUla need artifact and site conservation expertise."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Museums such as Louvre Abu Dhabi import conservation talent for tourism strategy."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry senior talent, including heritage conservation, supported via Global Talent Visa."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Large museum and archive sector employs conservators, but the role is outside CHIPS/IRA/IIJA priority lists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "38a52716-2566-4112-b2cc-5c3410d0d3c7": {
    "career": "Quantity Surveyor",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "QS explicitly on CSOL; shortages in major transport, mining and housing projects."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Construction estimators can qualify under general engineering streams, but not singled out."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Energy-efficient retrofits need cost engineers; QS experience eases visa via Opportunity Card."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "New capital Nusantara and EV plants spike demand for cost engineers."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Construction cost consultants included under construction PM category."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Construction category focuses on site trades, not professional QS roles."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Large industrial builds need cost controls, but QS not on priority immigration list."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Quantity Surveyor appears on Tier 1 list—direct residency path."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Gigaprojects (NEOM, Red Sea) aggressively recruit international QS talent."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Economy 2030",
        "reason": "Focus on advanced manufacturing rather than construction cost management."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Operation 300bn",
        "reason": "Mega-developments in Abu Dhabi/Dubai rely on expatriate QS professionals."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "While not officially listed, industry lobbying keeps QS visas moving due to housing backlog."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Massive infra spend drives demand, but QS is not a visa-priority occupation."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "National Master Plan 2021-2030",
        "reason": "Infrastructure boom creates openings, yet local talent supply keeps it off priority list."
      }
    }
  },
  "bd44cb8c-664a-4f8c-9d1d-a71b270b6cb0": {
    "career": "International Sales Director",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Migration Strategy focuses on STEM and construction, not sales management."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "No dedicated immigration stream for generic sales leadership."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Possible Blue Card via salary, yet not shortage-listed."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "47",
        "policy": "",
        "reason": "Growing EV and mineral sectors may hire, yet visa priority low."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Multinationals hire sales leaders locally; not on Critical Skills list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "NIMP 2030 emphasises manufacturing exports; sales roles secondary."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Growing non-oil exports need sales talent, but Saudization reduces expat priority."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Singapore Economy 2030",
        "reason": "Regional HQs seek sales directors; COMPASS salary thresholds enable passes."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "UAE Centennial 2071",
        "reason": "Trade and logistics hub actively courts senior commercial leaders."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Visa possible via salary, yet not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Role valuable but not linked to federal industrial policies."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Export-oriented tech firms need sales, but immigration favours engineers."
      }
    }
  },
  "ee808574-4a6b-48e7-a7ed-dcc30eea6d27": {
    "career": "News Producer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "General Skilled Migration focuses on STEM, not journalism."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Media roles rarely given immigration priority."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Producer roles possible in international outlets, but no policy support."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "State-backed entertainment hubs need experienced producers, but content controls are strict."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Some English-language outlets hire, but not in National AI Strategy priority."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Dubai Media City offers visas for senior broadcast talent."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry senior roles, including broadcast producers, qualify for Global Talent visas."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "",
        "reason": "Huge private media market; no special visa, but O-1 for exceptional producers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "6c301aa2-5956-4f89-9a9b-2e2feb75c5e5": {
    "career": "Chemistry Teacher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Secondary science teachers flagged as national shortage."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Secondary STEM teachers on targeted draws in multiple provinces."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Länder actively recruit international STEM teachers for Gymnasium level."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "STEM teachers in demand but not on Critical Skills list; school sponsorship possible."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Secondary Chemistry Teacher appears on Tier 1 with direct residency."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Teacher shortages exist but K-12 teaching lacks federal immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "be6a7629-82e2-4dc8-bfd6-db901cf16f2c": {
    "career": "Medical Science Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL lists medical scientists and clinical researchers for priority visas to support biotech clusters in Melbourne & Sydney."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Express Entry awards extra points for PhD STEM researchers; provinces court pharma and vaccine talent."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Germany fast-tracks life-science PhDs for R&D roles in its large pharma/med-tech corridor."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List explicitly names biopharma scientists; generous R&D tax credits and fast work permits."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP gives point bonuses for biotech researchers joining national regenerative-medicine programs."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan promotes pharma and med-device R&D, but scale still moderate."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Biotech is small but growing; visas available yet openings limited to a few university spin-offs."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Mega-projects include genomic and vaccine hubs (NEOM BioTech Valley) seeking global research talent."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Singapore Economy 2030",
        "reason": "Biomedical Sciences hub offers RIE2025 grants and fast EP passes for senior researchers."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "UAE Centennial 2071",
        "reason": "Golden Visa for PhD scientists; Dubai Science Park expanding clinical trials and stem-cell labs."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences pillar funds drug discovery and welcomes overseas PhDs via Global Talent visa."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA pours billions into biomanufacturing and NIH-linked labs, sharply expanding demand for biomedical research talent."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Government courting vaccine and pharma specialists to move value chain upstream."
      }
    }
  },
  "40eb1dcd-e244-48f6-add3-59c3e4cecad2": {
    "career": "Network Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL lists network and security engineers; visas processed in weeks to support 5G roll-out."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "IT & networking occupations enjoy dedicated draws and quick PR pathways amid talent shortages."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe shortage of IT infrastructure staff for Industry 4.0 factories and data centres."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "RPJPN 2025-2045",
        "reason": "Growing demand in Jakarta’s data centres but bureaucracy slows foreign hiring."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Hyperscale data centres around Dublin struggle to find Cisco/JNCIA talent."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "5G rollout and robotics factories create steady, though Japanese-language heavy, demand."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan emphasises cloud and data-centre connectivity along the Kulim – Johor corridor."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Roles exist but in small numbers within telecom duopoly Spark-Vodafone."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "NEOM and smart-city projects need large-scale network backbone talent."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "National AI Strategy 2.0",
        "reason": "Gigantic data-centre footprint and SEA subsea cables keep demand strong for senior network talent."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Operation 300bn",
        "reason": "Dubai & Abu Dhabi free-zones woo network engineers for data-center and fintech clusters."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Open roles in fibre deployment and cyber-secure networks, though salary thresholds apply."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA funds nationwide broadband upgrades, driving hiring for network design and deployment specialists."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Strategy includes supporting digital infrastructure, requiring skilled network engineers."
      }
    }
  },
  "b1cfd9e9-9e67-4751-a271-08e9d22e4571": {
    "career": "Strategy Support",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Management consultants only on secondary lists; visas possible yet competitive."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "General business analysts accepted but no dedicated immigration stream."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Points system rewards degrees, but generic business roles rank low."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on Critical list; possible only via General Work Permit."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Vision 2030",
        "reason": "Consultants hired for giga-projects, yet Saudization favours locals for mid-tier roles."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "EP possible for consultants, but role not on priority tech/green list."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Dubai continues to import analysts for finance and logistics, though not on priority list."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Professional services recognised but visa salary floor steep for junior staff."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Corporate recipients of IRA funds seek analysts, yet role not policy-prioritised."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "64dcf9fb-a1f7-42a6-af35-aaa4c14f6a39": {
    "career": "Textile Designer",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Vision targets high-value textiles; Bandung fashion week showcases global collaboration."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Traditional textile hubs in Kyoto aim to revive craft with global designers."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Government pushing halal fashion exports; designers with digital-printing skills welcomed."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "We the UAE 2031",
        "reason": "Dubai Design District promotes regional fashion, yet competition from local talent."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative sector support; Global Talent visa possible for award-winning designers."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "US creative visas possible; industry concentrated in NY and outdoor-gear brands, not policy-driven."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "National Master Plan 2021-2030",
        "reason": "World’s second-largest apparel exporter upgrading to design-led value; foreign talent allowed in FTZs."
      }
    }
  },
  "00eab020-8ae9-479e-9302-92d791dac277": {
    "career": "Visual Designer",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Vision 2030",
        "reason": "Events and entertainment push demand for motion/visual designers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "DesignSingapore Council grants, but passes favour tech over pure design."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Media City hires designers, but not immigration-priority."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries recognised; Global Talent visa possible for award-winners only."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Creative roles still migrate via O-1 or H-1B but not policy-favoured."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "3db919ba-04a3-46e6-a68c-e0458ebb44e9": {
    "career": "Wine Business Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Migration Strategy 2023",
        "reason": "South Australian wine exports create regional shortages for sales/production managers, though not on core skills list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Stream for agri-food and hospitality can cover vineyard supervisors, yet demand is moderate."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Mosel/Rhein wine regions recruit oenology graduates; visa points possible but not priority."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "18",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Migrant Category",
        "reason": "Marlborough wineries lobby for management talent; wine is a top-five export sector."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "High-end wine trading hub creates limited but quality opportunities; not on priority list."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Viticulture hubs (Napa, Oregon) rely on experienced managers, but no dedicated federal immigration incentive."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "2f023a79-27ae-4326-a80e-bbf9133bd62c": {
    "career": "Attorney",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Lawyers can migrate via general skilled visas, yet not on CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Provincial bar mobility possible; not listed as critical skill."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Foreign-qualified lawyers limited to international firms; German Staatsexamen usually required."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Post-Brexit relocation of firms to Dublin creates openings for common-law lawyers."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Foreign legal consultants permitted but numerically restricted."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Islamic finance expansion draws some cross-border legal talent, but not priority."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Small bar; limited spots for overseas lawyers."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Mega-projects need contract attorneys and international arbitration specialists."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "",
        "reason": "International arbitration hub licences selected foreign law firms; competitive but accessible."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "We the UAE 2031",
        "reason": "DIFC and ADGM courts recruit common-law practitioners for regional deals."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London’s legal services export focus keeps steady demand for solicitors."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Massive legal market; no shortage policy but demand for licensed attorneys remains high."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "ae5d7252-606a-4bb7-8840-825a5b354685": {
    "career": "Cloud Security Dev",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Cloud security engineers listed under ICT security; fast PR pathways."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Dedicated streams for AI and cybersecurity specialists with expedited permanent residency."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialists can migrate without degree if skills proven; cyber gaps acute."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech boom drives demand; immigration still bureaucratic."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Cloud security engineers explicitly on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points favour AI/cyber talent amid shortage."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "NIMP 2030",
        "reason": "Industry 4.0 push includes cloud security for semiconductor supply chain."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Software engineers including security assessed as Tier 1 shortage."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Massive investment in cloud data centres and cyber defence for NEOM and Aramco."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "National AI Strategy 2.0",
        "reason": "Cybersecurity is core to digital trust; Tech.Pass and COMPASS favour experts."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Operation 300bn",
        "reason": "Fintech and federal cloud projects hunt for senior security architects."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital & cyber security named as priority cluster; visas fast-tracked."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds cybersecurity R&D and talent for national cloud and semiconductor supply chains."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Growth of domestic cloud providers needs security engineers."
      }
    }
  },
  "0ed4daa7-fa05-4f18-88b0-10f393b26a37": {
    "career": "Commercial Lawyer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "General skilled visas possible; not on CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Corporate law market steady; immigration not prioritised."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Requires dual-language ability; limited openings."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Post-Brexit corporate relocations increase commercial law workload."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Foreign Legal Consultant licences limited in number."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Islamic finance law creates niche, but quotas low."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Small market; commercial roles exist but few visas granted."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Giga-projects require contract drafting, PPP, and arbitration experts."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "",
        "reason": "Foreign law practice licences granted to serve regional M&A and arbitration."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "We the UAE 2031",
        "reason": "International free-zone courts (DIFC/ADGM) recruit common-law commercial lawyers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London’s global finance hub makes commercial solicitors a core export service."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "",
        "reason": "Deal-making, M&A and tech IPO pipeline sustain demand, though not shortage-listed."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "1170e9cb-5398-435e-9224-ac0346bdc988": {
    "career": "Engineering Business Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Construction and mining projects demand tech-savvy managers for PM roles."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Civil and project engineering managers score high CRS points in construction boom."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Auto and renewable sectors hunt hybrid engineering-business talent for scale-ups."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "RPJPN 2025-2045",
        "reason": "EV battery and mining projects rely on dual-skilled managers."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Med-tech and pharma plants seek engineering management talent."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-factory initiatives open slots, but language barrier high."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "NIMP 2030",
        "reason": "Semiconductor fabs need managers who grasp both processes and cost control."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Infrastructure upgrades create limited openings; not on green list."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "NEOM and Red Sea mega-projects need bilingually competent engineering managers."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Manufacturing 2030",
        "reason": "High-value precision manufacturing needs managers fluent in tech and ROI metrics."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing push values leaders who can bridge factory floor and balance sheet."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "EV and clean-energy clusters need techno-commercial managers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Massive public-works budgets require leaders who understand both engineering specs and P&L."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National Master Plan 2021-2030",
        "reason": "Electronics and infrastructure expansion create demand for techno-commercial leaders."
      }
    }
  },
  "18d0cab8-b641-42ad-ae78-cf2c62dcf4ea": {
    "career": "Professional Psychologist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Registered psychologists appear on CSOL and state occupation lists."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Falls under allied-health shortage; provincial nominee streams list psychologists."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Mental-health professionals accepted but lower urgency than nurses/MDs."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "HSE advertises posts, yet profession omitted from Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Hospitals may hire foreign specialists, but visa categories focus on nursing care."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Clinical psychologists on Green List with fast-track residency."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "Large hospital expansions require behavioural-health specialists."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "High service demand, yet role outside National AI/Manufacturing priority lists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "Private hospitals recruit licensed psychologists for expat population."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "NHS hires psychologists but role not on Shortage List post-2025."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Rising mental-health demand and insurance coverage, but no dedicated immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "1e76108e-e7fe-4091-be12-11c3307c8ccb": {
    "career": "Early Music Specialist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Strong classical scene and state-funded orchestras support niche performers."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Baroque festivals present, yet immigration quota low."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Appreciation for classical authenticity; visas under Artist category."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Well-funded arts festivals occasionally book historically informed performances."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry priority list values senior classical musicians and heritage arts."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Niche but viable through artist visas and early-music festivals."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "bcb79b6f-6c06-4226-abb7-9118fd389e6f": {
    "career": "Fashion Marketing Specialist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Fashion capitals Tokyo/Osaka hire foreign brand experts via Design visa."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Luxury retail expansion at NEOM and Riyadh drives niche demand."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Regional fashion HQs exist, yet role outside official priority clusters."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s luxury sector needs brand marketers for regional hubs."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry road-map highlights fashion and advertising leadership."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Large fashion industry offers jobs but no immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "ff806600-7132-4caf-8a4e-25a61faa331f": {
    "career": "Medical Anthropologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Some grants via ARC, yet not on occupation lists."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities recruit interdisciplinary health researchers under research talent streams."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Academic track available, though competition with EU candidates."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "SFI grants interdisciplinary projects, but not on Critical Skills list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Limited university positions; visas possible but not prioritised."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Health-services research institutes occasionally hire qualitative specialists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Health-policy think tanks may hire but no formal priority."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Global Talent visa covers medical social-science researchers."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "",
        "reason": "NIH-funded universities value cross-cultural health research; J-1/H-1B academics common."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "1514d257-2700-45d6-8483-0af5eca08b01": {
    "career": "Māori Art Creator",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "15",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Creative New Zealand and iwi trusts fund Māori artists, but preference for tangata whenua."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Museums and art fairs show interest in Pacific art, though not a policy priority."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "15",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      }
    }
  },
  "8cfe31b0-3620-4ab2-b287-56aa1090f91e": {
    "career": "Visual Arts Teacher",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Secondary teachers are listed; visual arts accepted if teaching certification obtained."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Several provinces recruit K-12 teachers; arts is acceptable but lower priority than STEM."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Shortage of school teachers; arts not critical but still qualifies for teacher pathway."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "27",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Secondary teachers on Green List; visual arts outside core shortage, still eligible."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Teacher shortages exist, but no immigration policy specifically targets arts teachers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "e21f5e85-04d4-4110-90f0-730fc76c01e6": {
    "career": "Classics Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Universities can nominate under Research Stream visas; limited quotas for humanities."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Academia remains eligible for research visas, though humanities not singled out."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Strong funding for ancient studies and welcoming research visas."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "27",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Smaller but active classics centres; possible under general research permits."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "MOE funds niche humanities, but visa facilitation modest."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "World-leading classics departments sponsor Skilled Worker visas."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Universities sponsor O-1/J-1/H-1B for humanities scholars despite no explicit policy priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "8ed46a79-efd6-4e66-abed-77a88cbb923b": {
    "career": "Global Commerce Manager",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Management roles score CRS points but aren’t priority occupations."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Management professionals can qualify on points but not a shortage list."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Critical Skills List focuses on tech and engineering rather than general management."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Mega-projects need trade and supply-chain leadership, though not formally prioritised."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Singapore Economy 2030",
        "reason": "Global trade hub needs managers with cross-border compliance expertise; faster EP processing for high-earners."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi free zones court global trade managers for logistics and re-export hubs."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Global commerce ties into City of London financial services but no shortage listing."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Role qualifies for H-1B but not singled out in industrial acts."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "355ef7a2-5444-4cd4-b554-e8dbac33a5e0": {
    "career": "Operations Technician",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Industrial technicians appear on state skill lists, especially mining hubs."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Trades and technicians earn extra points, but focus is more on electricians/plumbers."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Acute shortage of mechatronics and production technicians in Mittelstand factories."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Critical Skills List prefers engineers over technicians."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "67",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Industrial machinery and manufacturing technicians are explicit SSW categories."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industry 4.0 roll-out needs plant technicians with automation skills."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Migrant Category",
        "reason": "Manufacturing plants need technicians but numbers are small."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Some shortage visas for manufacturing techs but limited quotas."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "New manufacturing plants need skilled technicians to run and maintain lines."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Chip packaging and electronics assembly plants short of experienced line technicians."
      }
    }
  },
  "5498fa49-65f7-4670-a3f4-f8a8619a6607": {
    "career": "Sustainability Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Migration Strategy 2023",
        "reason": "CSOL lists environmental scientists; nation pushes renewables and critical-minerals sustainability."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Green-tech clusters in Ontario and BC actively recruit environmental scientists."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Energiewende and climate targets create shortages of environmental and life-cycle assessment experts."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "RPJPN 2025-2045",
        "reason": "Nickel and geothermal sectors need environmental scientists for permitting."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Emerging offshore wind sector needs sustainability talent but no dedicated immigration category."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Green-growth strategy funds carbon-neutral R&D; HSP points favour PhDs."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "MADANI Economy",
        "reason": "Government pushes renewable energy and ESG reporting; imported expertise accepted case-by-case."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Green List explicitly includes environmental scientists for fast-track residency."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Mega-projects need sustainability assessments but focus remains construction-led."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Green Plan 2030",
        "reason": "Carbon services hub seeks life-cycle analysts and sustainability researchers."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Operation 300bn",
        "reason": "Net-zero 2050 pledge drives recruitment of carbon management scientists."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Offshore wind, hydrogen and CCUS projects list environmental scientists on shortage visas."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Massive federal funding for carbon capture, renewables and climate R&D drives demand for sustainability scientists."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National Master Plan 2021-2030",
        "reason": "Offshore wind and LNG projects require environmental impact scientists."
      }
    }
  },
  "85131270-07c4-4030-834f-9b6b804e4bf8": {
    "career": "Biorobotics Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL lists software and biomedical engineers, but biorobotics still niche."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "IT/AI engineers fast-tracked; research hospitals want surgical robotics talent."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Strong medical-device sector and EU’s robotics hubs in Munich & Stuttgart."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Broad automation push, yet health-tech robotics demand emerging slowly."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Software & med-device clusters in Galway/Limerick hire robotics engineers cautiously."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Highly Skilled Professional visa",
        "reason": "World leader in humanoid & rehab robots; fast visa points for PhDs."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan funds automation and med-device assembly, but R&D still small."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Robotics appears only in general software category; few dedicated employers."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "NEOM hospitals and industrial automation projects recruiting niche robotics talent."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "National AI Strategy 2.0",
        "reason": "Strong med-tech startups, A*STAR grants, but small overall market size."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Operation 300bn",
        "reason": "Programme backs advanced manufacturing and med-tech but still early-stage demand."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 prioritises AI, med-tech and semiconductors—skills overlap with biorobotics."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Funds sensor chips, advanced manufacturing and AI—exact ingredients for medical and soft robots."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Focus on chips not bio-integration; limited prosthetics R&D."
      }
    }
  },
  "f458dac6-d495-4d58-9825-8b1746ece718": {
    "career": "Economics Data Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Lists data analysts broadly, but economics specialism niche."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Canada courts data scientists for government budgeting and fintech sectors."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Point system rewards data/IT skills; language barrier for policy roles."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "RPJPN 2025-2045",
        "reason": "Government wants statisticians but foreign hires rare."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Big-tech HQs and Dublin’s funds industry crave data economists."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP accepts data analysts, but Japanese language key for central-bank work."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Policy leans toward industrial engineers; analysts mostly local hires."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "General demand for data skills; few pure economics shops."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Economic diversification programmes need analysts, but roles often contractor-based."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Economy 2030",
        "reason": "MAS and sovereign funds employ data-savvy economists; global talent welcomed."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s DIFC hires econometricians for sovereign wealth, fintech and trade analytics."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London seeks data-driven economists for finance and policy think-tanks."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds AI and data infrastructure, boosting demand for quantitative analysts."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National Master Plan 2021-2030",
        "reason": "Focus on manufacturing and logistics; macro-data roles limited."
      }
    }
  },
  "7d8ec722-5e1c-471c-bca4-1a2491746aae": {
    "career": "Environmental E3 Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL lists civil, environmental and mining rehab engineers amid climate pressures."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Targets civil and renewable-energy engineers for green-infrastructure build-out."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Aggressive Energiewende needs environmental and hydrogen infrastructure engineers."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel/EV mining requires environmental remediation experts."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Wind and grid projects demand EHS and environmental impact specialists."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Renewables expansion slow; roles clustered in a few utilities."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan funds renewable and waste-to-energy plants, creating moderate demand."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Immediate shortages in water, waste and climate-resilience engineering."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Mega-projects require sustainability assessments but import talent sparingly."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Green Plan 2030",
        "reason": "City-state invests in coastal protection, waste-to-energy and carbon services."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Net-zero drive opens roles in desalination and carbon capture."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Offshore wind, CCUS and nuclear need environmental compliance engineers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA pours billions into clean energy, carbon capture and ecological restoration."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "National Master Plan 2021-2030",
        "reason": "Offshore wind and LNG projects need environmental assessments."
      }
    }
  },
  "9d35e397-e0df-479f-8c84-bb17eb1943a2": {
    "career": "Actor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Film incentives sporadic; few visas reserved exclusively for performers."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Toronto/Vancouver film hubs need performers but entry is competitive."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Theatre scene strong yet language barrier high; visas possible via freelancing."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Film tax breaks exist but actors not on critical list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Wellington’s film studios hire actors occasionally; category points low."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Government pouring billions into new entertainment sector, importing talent."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "Small but growing streaming productions; no special visa priority."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai Studios City offers freelance visas for media professionals."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries on priority list; London & Manchester major production hubs."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Hollywood still magnet for global talent despite no direct visa priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a0bf2c1a-bb33-4c53-8e55-b02779c788bd": {
    "career": "Conservation Biologist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL includes environmental scientists to protect unique ecosystems."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Parks Canada and resource ministries list biologists as priority."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "EU Green Deal funds rewilding projects; talent shortage outside academia."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Orangutan and reef conservation projects attract international NGOs."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Peatland restoration funds exist but hiring still small."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "National parks hire few foreign researchers; language barrier high."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "MADANI Economy",
        "reason": "Rainforest conservation grants growing but mainly NGO-based."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Aggressive predator-free goal needs biodiversity scientists immediately."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Protected-area tourism opens limited roles for wildlife experts."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Green Plan 2030",
        "reason": "Urban greening roles exist but small pool, competition high."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Mangrove and coral restoration projects hire conservation contractors."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Biodiversity-net-gain law drives demand for ecological consultants."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Act funds habitat restoration and climate resilience, boosting field projects."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National Master Plan 2021-2030",
        "reason": "Mekong biodiversity projects employ biologists on fixed contracts."
      }
    }
  },
  "61dd4f0a-7c38-47c3-af64-3fec3fd459af": {
    "career": "Creative Entrepreneur",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Entrepreneur visa exists but points favour STEM and construction over creative sectors."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Start-up visa welcomes founders, yet quotas focus on deep-tech and health rather than creative businesses."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Self-employment permit possible, but government incentives favour engineering and renewables, not media or design."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "No special pathway; Enterprise Ireland prefers export-led tech instead of creative lifestyle brands."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Massive funding for film, gaming and arts districts; foreign creatives offered fast-track residency."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Economy 2030",
        "reason": "Creative media hub incentives exist but are secondary to AI and advanced manufacturing."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Golden Visa and Dubai Creative Clusters give 100% ownership for media, fashion and design start-ups."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry scale-ups are a named ‘sector deal’; Innovator Founder visa supports non-STEM founders."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Start-ups in clean tech and EVs get grants and tax credits, but generic creative ventures are not a named priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "9c7914a7-b089-43c4-91f0-445b29f11bc5": {
    "career": "Language Professor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "University roles possible but not on core occupation list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Bilingual French-English teaching valued, but quotas favour STEM and healthcare."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Public universities seek English-speaking staff; Blue Card points good for PhD holders."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Third-level lecturers are eligible for Critical Skills permits, even in humanities."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "Strong demand for English and linguistics faculty; HSP points heavily reward PhDs and publications."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Limited slots; priority given to STEM lecturers."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Vision 2030",
        "reason": "Universities aggressively recruit English lecturers for tourism pivot, yet visa preference sits below engineering."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "UAE Centennial 2071",
        "reason": "Private universities in Dubai/Abu Dhabi hire language faculty, but immigration no special fast track."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Universities sponsor professors readily despite removal from shortage list; REF pressures keep hiring steady."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "CHIPS and Science Act",
        "reason": "Universities hire widely; J-1 and H-1B exemptions for academics remain generous though not a policy focus area."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "c7b20107-5bcf-494c-96a9-aae0ad930b10": {
    "career": "Professional Social Worker",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Regional visas sometimes list social work, yet national priority still lies with nurses."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Care-economy occupations get extra points and provinces list social workers as high demand."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Need for eldercare support allows entry, but licensing translation hurdles remain."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Listed only for medical social work; entry possible but numbers small."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 2)",
        "reason": "Social workers appear on Green List, offering direct residence pathways."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Green Plan 2030",
        "reason": "Ageing-population initiatives create some openings, but tight quota for foreign practitioners."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Social workers were removed from shortage list in 2025, yet sponsorship still possible."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Community programs funded indirectly create jobs, but no special immigration channel."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a72f2d3f-0ace-49b4-8777-acd7dabbfaff": {
    "career": "Tax Specialist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Finance professionals qualify, but draws focus on tech and healthcare."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Steuerberater profession regulated; foreign experts get Blue Card if senior."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Multinationals in Dublin hire tax planners to navigate EU-US rules; Critical Skills permit available."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "VAT and corporate tax expansion drive demand, yet Saudization limits foreign roles."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Green Plan 2030",
        "reason": "Sustainable-finance initiatives require carbon-tax and transfer-pricing experts; ONE Pass available to top earners."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Operation 300bn",
        "reason": "Corporate tax and transfer-pricing reforms create immediate need for skilled tax advisers in DIFC/ADGM."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City firms need international tax experts for post-Brexit restructuring; visas fast-tracked for financial services."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Complex clean-energy incentives increase demand for specialised tax advisers, though no immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "220284bc-de56-4b52-8597-d75093cfe8b9": {
    "career": "Counseling Manager",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Migration Strategy 2023",
        "reason": "Aged-care and rural mental-health services lack managers; Priority pathways available."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Mental-health professionals receive category-based invitations; leadership roles in hospitals are critical."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Klinik administrators with psychology credentials can attain Blue Card amid rising demand."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Health-service managers with psychology background qualify under medical and health-services category."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Registered counsellors and managers are on Green List with direct residency offer."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "New wellness resorts hire counsellors, but preference goes to nationals in public sector."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Green Plan 2030",
        "reason": "Wellbeing push opens some roles, but foreign quotas tight."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Private clinics recruit, yet visas prioritise doctors over counsellors."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "NHS hiring exists but counselling removed from shortage list; sponsorship still possible."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Funding for community mental-health clinics helps hiring but no immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "34a1393d-269e-4be2-a07a-e020738bb0e8": {
    "career": "Data Analytics Leader",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL lists software engineers and data analysts; leadership roles benefit via employer-sponsored visas, but not named shortage."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Strategy explicitly targets data scientists/AI managers for permanent residency pathways."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT Spezialist fast-track covers data professionals; leadership eligible once contract secured."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Analytics needed in EV and fintech plays, but immigration quotas favor engineers not managers."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List features data scientists and cloud architects; analytics managers quickly obtain Stamp 4 residence."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Highly Skilled Professional visa",
        "reason": "Big data specialists get bonus points, but language barrier keeps demand moderate for leadership roles."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "NIMP 2030 stresses Industry 4.0 analytics, yet hiring tilts toward technical implementers over strategic leads."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Skilled Migrant Category",
        "reason": "Points system rewards high earnings but data analytics not on Green List, so lower priority."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "Megaprojects need analytics for tourism, energy and smart cities but focus is on sector experts, not generic data leads."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "National AI Strategy 2.0",
        "reason": "Strategy calls for Chief Data/AI roles; EP/S Pass processing fast-tracked for proven analytics leaders."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "We the UAE 2031",
        "reason": "National AI and fintech pushes create demand for analytics heads in Dubai & Abu Dhabi free-zones."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital/AI on IS-8; senior data leaders qualify for Skilled Worker and Scale-up visas."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act pours billions into AI/data initiatives; senior analytics talent needed to turn data into competitive advantage."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "National Master Plan 2021-2030",
        "reason": "Digital-economy agenda values data skills, though foreign leader roles limited to large multinationals."
      }
    }
  },
  "b845b4b5-3862-4331-b748-e283d27d1684": {
    "career": "Genetic Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Not on core shortage list; biotech hiring exists but visa pathways standard rather than fast-track."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "ITAS earmarks life-science researchers for priority work permits, though clinical roles rank higher."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Qualified scientists accrue high points; pharma and bio-manufacturing clusters in Bavaria need talent."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "RPJPN 2025-2045",
        "reason": "Biopharma on agenda yet infrastructure still developing; foreign experts hired mostly for knowledge transfer."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Biopharma manufacturing corridor around Cork needs genetic engineers for cell-therapy lines."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP explicitly lists biotech researchers; Kansai and Tsukuba gene-editing labs recruit internationally."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan prioritises medical devices and pharma; gene-therapy start-ups offered tax breaks."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "No direct Green List match; some roles in agri-genomics and biosecurity."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Biotech is emerging focus, but current visas concentrate on clinicians and manufacturing quality."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Singapore Economy 2030",
        "reason": "Biomedical sciences a core pillar; A*STAR and Biopolis routinely sponsor passes for genetic engineers."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Operation 300bn",
        "reason": "Biotech designated as future pillar; Golden Visa available yet market size still small."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences are flagship; visas for R&D workers fast-tracked, plus generous research grants."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds next-gen biotech and genomics hubs, accelerating demand for CRISPR engineers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "National Master Plan 2021-2030",
        "reason": "Agri-biotech and vaccines growing, but limited R&D funding for advanced gene editing."
      }
    }
  },
  "2854b239-0f12-424c-87e7-6678ee535afb": {
    "career": "Instructional Designer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "Role sits outside CSOL; employers must prove labour-market testing."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Category does not list designers, but education technology firms can sponsor if CLB met."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Points possible for degree and language, yet no shortage designation so competition strong."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Asta Cita",
        "reason": "Digital literacy campaigns open limited consultant roles; work permit caps apply."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "47",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "No direct listing, yet multinational tech firms in Dublin hire IDs for global training."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Highly Skilled Professional visa",
        "reason": "Possible under humanities visa category, but language limits opportunities."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "MADANI Economy",
        "reason": "Corporate digitisation creates some demand but locals usually preferred for Bahasa-based content."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Skilled Migrant Category",
        "reason": "Education technologists not on Green List; jobs possible in universities."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Tourism and hospitality academies need e-learning modules; expat hiring allowed but not priority."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Economy 2030",
        "reason": "National push for lifelong learning allocates grants to SkillsFuture vendors employing instructional designers."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "UAE Centennial 2071",
        "reason": "Massive upskilling push; corporate L&D budgets support visas for specialist IDs."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Not on shortage list, but EdTech Scale-up route eases sponsorship for high-salary roles."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Large training contracts for reskilling workers create moderate demand for e-learning designers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "EdTech growing yet salaries low for foreign specialists; only niche English programmes hire."
      }
    }
  },
  "82c91a25-9f47-4026-8b7c-ec1cf360778f": {
    "career": "International Development Officer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Migration Strategy 2023",
        "reason": "Aid projects in Pacific create some jobs but position not on CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Role falls under social policy managers—eligible but no bonus points."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "GIZ and NGOs recruit globally; Opportunity Card gives points but small intake."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "RPJPN 2025-2045",
        "reason": "International NGOs need programme officers, yet work-permit process complex."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on list; Irish Aid and NGOs do sponsor for niche expertise."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Highly Skilled Professional visa",
        "reason": "JICA employs foreigners primarily in field offices; HQ roles rare without Japanese fluency."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "ASEAN development initiatives create some roles; foreign hiring subject to quota."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "MFAT projects exist yet hiring usually from local pool; points possible for high salary."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Huge social-impact programmes need policy officers and monitoring experts—foreign specialists welcomed."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Singapore Economy 2030",
        "reason": "Regional HQ for many multilaterals; Employment Pass straightforward for experienced officers."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "We the UAE 2031",
        "reason": "Dubai Foundation & multilateral hubs hire officers for South-South cooperation projects."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "59",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "FCDO contractors abundant but visa sponsorship depends on organisation size."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "USAID contractors ramp up climate-resilient infrastructure abroad; skills needed but not immigration priority."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Development agencies present but prefer local nationals for cost reasons."
      }
    }
  },
  "d3e506f7-077e-4ede-a438-0f24a0eb7fc7": {
    "career": "Marketing Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "Marketing specialists may qualify under standard skilled visa with high points, but not shortage."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "No special pathway; CRS depends on age and language only."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Possible via general occupation card; demand modest, German language essential."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV and tourism brands seek consultants, but expatriate quotas tight."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on list; few firms willing to sponsor except digital-first agencies."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Language and local market nuances limit openings for foreign consultants."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "MADANI Economy",
        "reason": "Government pushes halal and digital brands, but local talent supply adequate."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "41",
        "policy": "Skilled Migrant Category",
        "reason": "Points-based route only; few employers sponsor consultants from abroad."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "Mega-tourism projects aggressively hire branding consultants; expat talent welcomed."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Economy 2030",
        "reason": "Regional HQs base their Asia-Pacific marketing in Singapore, issuing EPs to consultants with niche expertise."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "63",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s creative industry free-zones facilitate visas for marketing professionals serving MENA clients."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry seniors on IS-8 list; mid-level consultants still need high salary for visa."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Clean-energy firms still need market strategy, but profession not targeted for visas."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Rapid consumer growth, yet companies prefer bilingual locals at lower cost."
      }
    }
  },
  "cb66a011-6cba-4a63-a9bd-9e336dafff1f": {
    "career": "Occupational Therapist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "OT appears on CSOL and state nomination lists due to aging population needs."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Allied-health roles, including occupational therapy, get priority points for permanent residency."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Act streamlines visas for licensed health professionals; growing rehab sector."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Some demand, but OT not on Critical Skills list—general work permit route only."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "OT sits on Tier-1 Green List with direct residency pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "Large hospital expansion and rehab centres in mega-projects need allied-health staff."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Targets world-class healthcare; hospitals sponsor OT visas."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Demand exists but OT not named in federal shortage or incentive lists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "eecc3804-a8dd-4aa0-b3ec-11250e60602f": {
    "career": "Advanced Graphic Designer",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "Entertainment cities and tourism projects need branding and experience designers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "No priority, but regional design agencies sponsor experienced talent."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai positioning as regional creative hub; Golden Visa for talented designers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry senior talent is explicitly listed in IS-8 priority sectors."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Creative visas exist but no federal priority; market is competitive gig-based."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "94b4eb0c-39b3-4fb3-9685-d626a9a84b8e": {
    "career": "Music Producer",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Gigantic investment in concerts, festivals and studios to build entertainment economy."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Niche but active regional recording scene; no formal priority."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai Music District and Abu Dhabi labels offer creative-talent golden visas."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative sector listed; global music hub in London and Manchester."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Robust industry and O-1 visa route, but no explicit federal priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "c2d69b05-ee73-4fe1-bffd-3bf11f14c377": {
    "career": "Research Astronomer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "SKA telescope drives demand; no dedicated visa priority yet."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Science talent welcomed but limited astronomy posts."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Max Planck institutes actively hire foreign postdocs, streamlined residence card."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Few astronomy centres; visas focus on tech."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP fast-track for PhD researchers; NAOJ recruits international astronomers."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Space programme nascent; few research posts open to foreigners."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "UAE Centennial 2071",
        "reason": "Emirates Mars Mission spurs limited research hiring."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Space science listed under advanced manufacturing & space cluster funding."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act boosts NSF & NASA grants for fundamental space science, easing J-1/H-1B funding."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "cbef3370-1b28-4b4a-bcd7-2b283c8b561d": {
    "career": "Digital Business Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Migration plan focuses on core tech roles; digital business roles secondary."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Open to tech-enabled managers but not category-based priority."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Card can be used, but quotas favour engineers."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV and fintech drive need for digital strategy leaders, but visas harder."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Critical Skills list is STEM/finance heavy; generic business roles filtered."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "Digitalisation push opens some roles, but local talent pool exists."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Digital transformation is core plank; consultants recruited for giga-projects."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "National AI Strategy 2.0",
        "reason": "Push for data-driven business models requires digital transformation specialists."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "UAE Centennial 2071",
        "reason": "Government targets digital economy doubling; specialist managers receive golden visas."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "No specific policy, yet tech-scaleups hire transformation talent."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Bill funds broadband and digitalisation projects needing transformation managers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "44c5a06e-1dff-4881-b648-5bbb9d057f5a": {
    "career": "Marine Research Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Environmental scientists—including marine ecology for the Great Barrier Reef—receive priority visas and state sponsorship."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Scientists qualify under STEM streams yet marine science is not an explicit priority list occupation."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "General pathway for researchers exists, but marine science demand is modest in an inland-focused economy."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Island nation is strengthening fisheries science, offering some openings for foreign marine researchers."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Atlantic research funding exists, but immigration priority is reserved for IT, engineering and health roles."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Oceanography institutes can sponsor under HSP, though the field is niche within the program."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industrial plan focuses on semiconductors and aerospace rather than marine research."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "List covers environmental scientists for coastal adaptation; universities and CRIs actively recruit offshore talent."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "Vision 2030",
        "reason": "NEOM and Red Sea giga-projects need marine ecologists to protect coral reefs and design sustainable tourism."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "We the UAE 2031",
        "reason": "Some marine conservation linked to coastal tourism, but not a headline occupation."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Research councils fund ocean science for offshore wind, yet the occupation is absent from the Shortage List."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA funds coastal resilience and ocean-mapping projects, increasing federal research hiring but the role is not named as a core shortage."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "bc967890-00ad-49f5-8d27-b16cb81fd739": {
    "career": "Sustainability Economist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Migration Strategy 2023",
        "reason": "Environmental economists get state nomination case-by-case but sit outside core CSOL roles."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "ESG specialists are sought for Ottawa’s clean-economy and carbon-pricing agenda, though not an explicit shortage occupation."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Germany’s Energiewende demands economists to model renewable subsidies and EU carbon trading."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "RPJPN 2025-2045",
        "reason": "Focus on EV minerals; sustainability economics staffing mostly local public-sector."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "IFSC banks seek ESG analysts; while not explicitly listed, STEM economists get facilitated permits."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Carbon-tax modelling is emerging but demand volume remains low."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Government evaluating carbon markets opens limited economist roles tied to palm-oil sustainability."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Carbon-pricing work exists yet numbers are small, placing this role in a generic skilled pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Vision 2030",
        "reason": "Vision 2030 centres on growth metrics and finance rather than academic sustainability economics roles."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Green Plan 2030",
        "reason": "Singapore’s carbon tax and green-finance leadership create steady demand for sustainability economists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai’s sustainable-finance hub recruits ESG economists for carbon-credit structuring."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "London’s green-finance push values economists who price climate risk and shape policy models."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA’s massive climate-spending needs economists to design carbon markets and evaluate subsidy impact."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "National Master Plan 2021-2030",
        "reason": "Green finance still nascent; recruitment focuses on engineers not economists."
      }
    }
  },
  "9c15c427-fa17-4f48-811c-8740db6afbb0": {
    "career": "Curriculum Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "STEM curriculum developers in demand for national education reform; states sponsor quickly."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Secondary teachers and education consultants are explicit priority, accelerated PR offered."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Shortage of STEM teachers drives demand for curriculum design, but German language is a barrier."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "RPJPN 2025-2045",
        "reason": "K-12 reforms need specialists, but preference is for nationals."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not listed; individual school boards may sponsor but numbers are small."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Secondary teachers on the Green List; MoE hires specialists for new literacy and numeracy standards."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Teachers removed from shortage list in 2025; limited sponsorship remains for niche subjects."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct policy, but districts import STEM educators under H-1B when local supply is thin."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "National Master Plan 2021-2030",
        "reason": "Ed-tech reform opens some roles, yet work permits remain school-by-school."
      }
    }
  },
  "fb490c35-1454-4b57-b90a-d413588cf781": {
    "career": "Interior Design Innovator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "State nomination possible for highly experienced designers yet outside CSOL core."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Interior designers can qualify under French-speaker or experience streams, but not priority."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Possible via points system but no explicit demand for foreign interior designers."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Bali and new capital Nusantara create boutique design demand."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Design not on critical list; permits issued only case-by-case."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "High-end hotel boom yields limited HSP visas for interior specialists."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "KL hospitality projects occasionally import senior interior designers."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Creative roles compete for limited points; construction trades prioritised instead."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Vision 2030",
        "reason": "Luxury hotels, museums and giga-projects drive strong demand for innovative interior concepts."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Economy 2030",
        "reason": "High-end retail interiors generate some EP sponsorship but role is not on priority lists."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi position themselves as design hubs; visas for senior creatives fast-tracked."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry seniors are on IS-8, covering high-level interior architecture roles."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct link; U.S. creative industries remain globally dominant, offering H-1B pathways based on portfolio."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Creative talent largely sourced locally; foreign hires rare."
      }
    }
  },
  "ecdf89e4-d61e-4a2c-be7f-7d693ec6f1bb": {
    "career": "Sustainable Supply Chain Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Migration Strategy 2023",
        "reason": "Net-zero transition plus distance logistics make supply-chain experts valuable under employer sponsorship."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Category for transport and logistics occupations eases PR, though sustainability focus is emerging."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "German Lieferkettengesetz (Supply-Chain Act) creates urgent need for ESG-compliant managers in industry."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "RPJPN 2025-2045",
        "reason": "Nickel-EV boom drives demand for ethical sourcing and logistics transparency."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma and med-tech exporters seek professionals versed in EU sustainability reporting."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Manufacturers pursue Scope-3 reductions but foreign recruitment remains selective."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Electronics exporters must meet global ESG audits, creating openings."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Sustainability roles exist but priority is health and construction."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Massive construction and renewable projects require green procurement and circular-economy logistics."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Green Plan 2030",
        "reason": "Port hub positions itself as Asia’s sustainable-logistics nerve centre with strong talent visas."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Operation 300bn",
        "reason": "Industrial strategy targets advanced, low-carbon manufacturing with resilient supply chains."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Offshore wind and EV sectors need traceable, low-carbon components."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA domestic-content rules force firms to re-wire green supply chains, spiking demand for specialists."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Foreign plants need clean supply chains to sell into US/EU markets."
      }
    }
  },
  "c81f419c-1ce9-41a2-a438-b742f51b1637": {
    "career": "Writing Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Demand exists in higher-education and media, but CSOL omits generic writing roles."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Content editors qualify under general Express Entry, yet writers are not on category lists."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Skilled Immigration Act welcomes language teachers, not stand-alone writing specialists."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Publishing and universities recruit writers, but Skilled Worker list excludes the role."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Universities and Ed-Techs hire writing tutors but no federal immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "26",
        "policy": "",
        "reason": ""
      }
    }
  },
  "986e9ee6-5590-4a52-9950-a8d3baf18509": {
    "career": "Health Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Medical scientists are explicitly listed for priority visas and long-term shortages."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Federal strategy singles out life-science researchers for fast-track permanent residency."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Universities and pharma clusters recruit health scientists; easier Blue Card process."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Biopharma listed, yet local talent supply growing and visas complex."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma and med-tech corridor around Cork and Dublin lacks PhD health scientists."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP gives bonus points to biotech researchers; aging society boosts funding."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan names pharma and medical devices as growth sectors needing R&D staff."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Migrant Category",
        "reason": "Government funds health innovation; PhD holders gain direct residency points."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "NEOM and King Faisal hubs invest in biotech and clinical trials."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Singapore Economy 2030",
        "reason": "Biomed is a key pillar; A*STAR hires global health scientists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Genomics and precision-medicine centres in Abu Dhabi hunt for research talent."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life sciences is an IS-8 pillar; Global Talent Visa fast-tracks researchers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Massive grants for biomedical and basic science labs drive demand for PhD health researchers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Biomedical R&D is emerging but funding still limited."
      }
    }
  },
  "967ad051-bc65-4e26-b040-b5d1eaa9b385": {
    "career": "International Commercial Lawyer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Demand exists in mining and infrastructure deals, but not on CSOL."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Lawyers can immigrate via Express Entry, yet foreign bar transfer is complex."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Foreign lawyers may advise on home law only; limited visa facilitation."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "",
        "reason": "Post-Brexit firms expand in Dublin, but Critical Skills List omits lawyers."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Vision 2030",
        "reason": "Mega-projects sign big international contracts, needing foreign commercial law expertise."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "National AI Strategy 2.0",
        "reason": "Regional arbitration hub with liberal licensing for foreign commercial lawyers."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "UAE Centennial 2071",
        "reason": "DIFC courts and free-zone deals rely heavily on English-law commercial practitioners."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Senior legal services for City finance are explicitly prioritised under IS-8."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "",
        "reason": "Large firms need cross-border counsel, but no federal talent policy for lawyers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "90cc2135-e619-4e9a-975b-298a28d6da67": {
    "career": "Legal Advisor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Businesses hire in-house counsel, but CSOL omits the role."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Express Entry possible, yet legal advisors not on targeted lists."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Non-EU advisors face licensing hurdles; limited demand."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Financial-services compliance demand, but no Critical Skills listing."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Megaprojects create governance needs, but nationals are preferred."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "",
        "reason": "In-house roles exist, but no targeted talent scheme for generic advisors."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "UAE Centennial 2071",
        "reason": "Free zones and MNCs hire English-law advisors; visa facilitation exists."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "City firms still need compliance counsel, though not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Corporate compliance roles exist, but no federal shortage policy."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4137d362-46bd-4e23-a08d-45e46fd41d4c": {
    "career": "Accelerated Security Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Cybersecurity engineer explicitly listed for priority visas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Cybersecurity occupations fast-tracked under new tech categories."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "IT specialists can immigrate without degree if experienced, cyber is shortage area."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "RPJPN 2025-2045",
        "reason": "Digital infrastructure goals note cyber importance, but hiring still local-first."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Cybersecurity analyst/engineer is on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP favours AI and cyber experts; ageing IT workforce."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "MADANI Economy",
        "reason": "Digital push needs cyber talent, but visa categories still forming."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Migrant Category",
        "reason": "Government highlights cyber talent shortage for digital resilience."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "Smart-city projects and financial sector demand advanced cyber defences."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "National AI Strategy 2.0",
        "reason": "CISO and security-engineer roles qualify for Tech.Pass and COMPASS bonuses."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Operation 300bn",
        "reason": "Fintech and space initiatives require elite cyber experts; Golden Visa for specialists."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital & cyber security is an IS-8 pillar; fast visa routes exist."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Critical-infrastructure cyber grants create urgent need for security engineers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Growing fintech sector yet limited specialised visa schemes."
      }
    }
  },
  "6098a4c9-0614-4296-958f-494c99743609": {
    "career": "Audio Engineer",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Small but stable demand for live events and film post-production; no immigration priority, but Express Entry still open under general skills."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Large music hardware sector (Berlin, Hamburg) offers some openings; role can qualify as ‘specialist worker’, but not in shortage."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Highly Skilled Professional visa",
        "reason": "Anime/gaming audio in Tokyo creates niche demand; engineers can qualify under ‘specialist in humanities/arts’ but competition is steep."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Gigantic entertainment projects (NEOM, Riyadh Season) actively import live-sound and post-production engineers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Growing events market and Esplanade studios hire foreign experts, yet audio isn’t in National AI Strategy or Manufacturing 2030 priorities."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai/Abu Dhabi studios, Expo City and tourism push list ‘creative & media production’ as priority, with fast visas for experienced audio engineers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "UK Creative Industries growth plan explicitly funds music production; technicians qualify for Skilled Worker visas under the creative route."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "",
        "reason": "Entertainment hubs (LA, NYC, Nashville) need recording and live-sound talent, but no federal talent policy targets the field."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      }
    }
  },
  "9719b1a8-23bf-4f7c-a955-cdea5d4b512f": {
    "career": "Biomedical Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Growing medtech clusters (Melbourne Bio21) but not on CSOL; sponsorship possible via Global Talent visa."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Government lures life-science PhDs to Toronto/Montreal hubs through dedicated research permits."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "BioNTech and CureVac drive demand for molecular biologists; Blue Card readily issued."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Government wants biopharma capability; foreign experts hired for pilot plants."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma corridor (Cork, Dublin) hires biomedical scientists and offers Critical Skills Permit."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Aging society funds regenerative medicine; English-speaking posts limited but high points for PhDs."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "NIMP 2030",
        "reason": "Medical-device and vaccine push needs researchers, yet funding is smaller scale."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "KAUST and NEOM invest in genomics but volumes still modest."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Singapore Economy 2030",
        "reason": "Biopolis and A*STAR provide well-funded labs; biomedical science is an explicit pillar."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Operation 300bn",
        "reason": "Abu Dhabi’s  biotech park offers Golden Visas to PhD scientists."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences ‘Sector Deal’ funds cell-gene therapy; Global Talent visa fast-tracks researchers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Massive funding for bio-manufacturing, mRNA, and pandemic preparedness; NIH and startups aggressively sponsor visas."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "National Master Plan 2021-2030",
        "reason": "Biotech listed as strategic, but R&D ecosystem still early."
      }
    }
  },
  "e04ebd6b-7cdc-4c54-8654-ff9e94cad520": {
    "career": "Mechatronics Designer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Electrical and mechanical engineers are on CSOL; mechatronics fits, especially in mining automation."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Listed as engineering skill; demand in automotive Ontario but not formal shortage list."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Auto and machinery giants urgently need mechatronics engineers; streamlined Blue Card path."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "RPJPN 2025-2045",
        "reason": "EV battery plants need automation, yet visa bureaucracy remains tough."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Automation in MedTech and pharma needs mechatronics, but competition small."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Highly Skilled Professional visa",
        "reason": "Global capital of robotics; generous points for mechatronics master’s holders."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "NIMP 2030",
        "reason": "Industry 4.0 and semiconductor equipment manufacturing rely on mechatronics experts."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Robotics demand small but growing in agritech; requires case-by-case accredited employer sponsorship."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Smart-city projects and automated logistics recruit robotics designers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "National AI Strategy 2.0",
        "reason": "Robotics and precision-engineering talent gets EP/S-Pass fast-track."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Operation 300bn",
        "reason": "Industrial automation central to manufacturing diversification; Golden Visa available for specialists."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Advanced manufacturing and EV battery plants list robotics engineers on Shortage list."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "CHIPS and Science Act",
        "reason": "Robotics and advanced manufacturing grants create thousands of mechatronics roles in fabs and logistics."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Factories racing to automate; foreign experts welcomed but salaries modest."
      }
    }
  },
  "31867ffe-d1f7-456f-bca8-0cc3932c9129": {
    "career": "Public Relations Manager",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Highly Skilled Professional visa",
        "reason": "Global firms in Tokyo need English PR leads; Japanese language still crucial."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Mega-projects hire English PR managers, but Arabic preferred."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Regional HQs recruit PR managers, but role not in Tier-1 tech list; EP quotas tightening."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Tourism and finance sectors sponsor seasoned comms professionals on one-year renewable visas."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Creative-Route Skilled Worker visa covers PR for film/gaming, yet salary thresholds high."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Large corporate demand, H-1B possible but cap-limited; not linked to industrial acts."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "31",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a00f8b08-c155-49c2-b2bf-1c7c9528ea7f": {
    "career": "Spanish Culture Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Universities teach Spanish but role not prioritized under Migration Strategy."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Bilingual preference is French; Spanish studies departments small but existent."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Humanities academics can gain points, yet STEM gets priority."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Small but growing need for Spanish in export firms; no critical-skills support."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Selective humanities hiring at NUS/NTU and tourism boards, but not on Tier-1 list."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "",
        "reason": "Universities value Iberian studies; research councils fund post-colonial humanities."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Universities and Hispanic-market firms hire academics and cultural consultants; no explicit policy but market size huge."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "31",
        "policy": "",
        "reason": ""
      }
    }
  },
  "2339954c-70ff-4612-96a3-f75cb11cebf6": {
    "career": "Trade Compliance Director",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Growing defence and critical-minerals exports create demand, but occupation not singled out."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Ottawa prioritises import-export, aerospace and defence firms that need certified officers to avoid penalties."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Export-heavy Mittelstand needs experts on EU dual-use rules and U.S. re-export controls."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel/EV exporters hire compliance managers, yet senior director posts mostly expatriate."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "High-tech pharma exporters require the role but no formal shortage listing."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Highly Skilled Professional visa",
        "reason": "Chip and robotics exporters need oversight on U.S. re-export laws; language barrier narrows pool."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Semiconductor packaging boom increases need, but local talent pipeline adequate."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Agrifood exporters value the role yet numbers are small."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Non-oil manufacturing push demands leaders who can navigate U.S./EU sanctions and GCC customs."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Manufacturing 2030",
        "reason": "Major re-export hub enforces tight strategic-goods licensing; seasoned directors in demand."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Operation 300bn",
        "reason": "Dubai’s free-zones and growing defence/aerospace clusters hire directors to stay WTO-compliant."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Post-Brexit companies need seasoned heads for EU/UK border regimes and sanctions screening."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Advanced-tech exporters must meet strict EAR/ITAR rules; companies scaling chip supply chains are hiring senior compliance leads."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Role emerging with foreign fabs, still niche today."
      }
    }
  },
  "5ca7929d-4ddd-4dbe-a638-0a4600bc7c98": {
    "career": "Development Economist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Aid agencies in Canberra hire, but occupation small."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Ottawa recruits economists for Indigenous, rural and international aid programmes."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "GIZ and KfW Development Bank run large overseas projects needing policy analysts."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Irish Aid and Dublin think-tanks hire but do not list as shortage."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "JICA recruits economists yet preference for Japanese speakers limits roles."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "Government uses economists for poverty eradication, but few foreign hires."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "MFAT funds Pacific development work; limited openings."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National AI Strategy 2.0",
        "reason": "ADB and World Bank hubs in Singapore need research economists, especially for AI and development."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Dubai hosts UN offices but posts are few and competitive."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "FCDO and ODI remain major global employers for development economists."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Think-tanks and federal agencies evaluate climate and poverty impacts of IRA funding."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "08a854e9-39e9-4456-a181-89e83135967b": {
    "career": "French Literature Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Limited French programmes; funding tight."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Bilingual mandate and Francophone immigration stream prioritise French literary scholars for universities."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "DFG funds comparative literature; universities value foreign academics."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Occasional hires within Trinity/UCD, but not shortage-listed."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Some posts in elite universities, Japanese language required."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Migrant Category",
        "reason": "Tiny market—one or two roles annually."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Russell Group universities maintain strong modern-language departments."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "CHIPS and Science Act",
        "reason": "NEH and major universities still fund humanities though not a listed shortage."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "faa4486e-bfea-4831-b7c0-f9bb9d62f9d2": {
    "career": "Language Arts Teacher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Secondary teachers in shortage; English counts for regional visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Category stream specifically lists K-12 teachers, especially French and English."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Needs teachers but prefers German-language instruction; bilingual schools hire foreigners."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Some demand in Gaelscoileanna English stream, but not shortage-listed."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 2)",
        "reason": "English teachers eligible for fast-track residency after two years."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Indirect federal funding for public schools but English teachers not officially short-listed."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "ac04d69e-021a-4149-b821-55e417bb6888": {
    "career": "Logistics Coordinator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Role present but focus is on engineers and construction PMs."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Transport occupations and French speakers get priority; e-commerce boom continues."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Export powerhouse faces acute logistics labour shortages, especially around Hamburg and Rhine-Ruhr hubs."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV battery exports need coordinators; Bahasa requirement high."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma exporters hire but not shortage-listed."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "SSW covers warehousing yet language barrier limits foreign coordinators."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Port Klang upgrades raise need, but local workforce ample."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Skilled Migrant Category",
        "reason": "Demand exists in agrilogistics yet not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Mega-projects and new free zones require coordinators for multimodal freight."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Singapore Economy 2030",
        "reason": "World’s second-busiest port invests in AI-enabled logistics talent."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Operation 300bn",
        "reason": "Jebel Ali Port and Dubai South need talent for 24/7 global trade flows."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Shortages after Brexit, yet visa priority leans toward drivers, not planners."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Port modernisation and reshoring drive need for supply-chain staff."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "53",
        "policy": "National Master Plan 2021-2030",
        "reason": "Manufacturing boom spurs demand, but salaries less attractive."
      }
    }
  },
  "a431d478-2d85-4023-8bca-293c790b07b5": {
    "career": "R&D Associate",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Manufacturing and mechanical engineers are on the list, but R&D budgets are smaller than North America."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Priority for engineers and product-development talent to grow domestic tech manufacturing."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Auto and machinery giants face engineer shortages and offer English-friendly R&D roles."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV battery R&D just ramping up; opportunities are growing but small."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Focus is more on software and pharma than mechanical R&D."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP fast-tracks semiconductor and robotics R&D talent."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Country banking on chip R&D; grants and tax perks for engineers."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Niche openings in agri-tech and med-tech; numbers limited."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Mega-projects need materials and process R&D, but hiring still project-based."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Manufacturing 2030",
        "reason": "Government funds precision manufacturing R&D; competition is intense but constant."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Operation 300bn",
        "reason": "Industrial diversification funds some R&D labs, yet scale is modest."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Advanced manufacturing is a named pillar; R&D tax credits spur hiring."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Federal funds push semiconductor and advanced-manufacturing R&D; labs are hiring junior researchers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Early-stage design centres opening; roles exist but still limited."
      }
    }
  },
  "97c07f39-c7d2-4871-aae5-185606018def": {
    "career": "Control Systems Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Electrical and industrial automation engineers listed for skilled visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Automation engineers fall under high-demand STEM category."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Industry 4.0 roll-out has outpaced local engineering supply."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "RPJPN 2025-2045",
        "reason": "Automation roles exist in EV battery plants but scattered."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "63",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Med-tech and pharma plants require automation engineers."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Highly Skilled Professional visa",
        "reason": "World’s largest robotics market still short of controls talent."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industry 4.0 upgrades in E&E factories create steady demand."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Listed under electrical/electronic engineers for residence pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Robotics roles in NEOM projects exist but fewer than construction jobs."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "National AI Strategy 2.0",
        "reason": "Precision-engineering hub integrates AI with robotics; locals insufficient."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Operation 300bn",
        "reason": "Government pushes industrial automation; free-zones recruit control engineers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Advanced manufacturing and defence need robotics and motion-control experts."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Smart-factory retrofits and automation credits fuel demand for controls talent."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National Master Plan 2021-2030",
        "reason": "Electronics manufacturers hiring PLC and motion-control specialists."
      }
    }
  },
  "6486de86-4666-4484-8bfc-eb2cc0a39746": {
    "career": "Facilities Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Role fits under construction project management but not a named shortage."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Construction trades shortages extend to building-operations managers."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Some demand in large industrial parks; German fluency often required."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "41",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nusantara project needs FM later, but current openings limited."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "FM not on the list; hiring favours EU citizens."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Building cleaners and maintenance staff are listed, not managerial FM roles."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "MADANI Economy",
        "reason": "Green-building push opening some FM jobs but mostly local hiring."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Skilled Migrant Category",
        "reason": "Openings exist, yet limited visa priority."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Thousands of new tourism and smart-city buildings need experienced FM leads."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Green Plan 2030",
        "reason": "Green retrofit targets create FM roles, but locals prioritised for managerial functions."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Massive real-estate stock and sustainability push keep FM talent in demand."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Role exists but not on shortage lists post-Brexit."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Modernisation funds for public buildings raise demand for facility professionals."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "National Master Plan 2021-2030",
        "reason": "Commercial real-estate boom offers roles yet without formal talent visas."
      }
    }
  },
  "ac72cd96-f97a-4414-8d66-0dbedc584ab3": {
    "career": "Marketing Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Migration Strategy 2023",
        "reason": "Marketing not on priority occupation list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Field not on category-based selection lists; only general Express Entry possible."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Possible under points system but no shortage designation."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "No special visa route; Bahasa requirement common."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Tech giants hire analysts but role absent from critical list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "MADANI Economy",
        "reason": "Hiring exists in e-commerce but locals prioritised."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Generic skilled visa only; limited employer sponsorship."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Tourism and entertainment sectors do hire analysts but prefer Arabic speakers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Economy 2030",
        "reason": "Digital marketing talent welcomed but pass quotas tightening."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s marketing hubs recruit expat analysts, but role not nationally prioritised."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries are a pillar, yet marketing analysts not on shortage list."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "No direct priority; tech firms still recruit analysts under normal H-1B routes."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Role not in talent-shortage lists."
      }
    }
  },
  "648139c6-dc0c-45de-9abb-a10220e39fef": {
    "career": "Medical Imaging Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "Radiographers and sonographers on core skills list with fast-track visas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Radiologic technologists are explicitly prioritised under healthcare shortage."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe shortage of radiology staff across hospitals and clinics."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Clinical roles restricted for citizen workforce development."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Radiographers remain on critical list for fast-track permits."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Healthcare category not yet opened under SSW."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "Private hospitals recruit but generally prefer local grads."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Medical imaging technologists on Tier 1 list—direct residence path."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Hospital expansion under Vision 2030 recruits foreign imaging staff."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Green Plan 2030",
        "reason": "Aging population drives demand; public hospitals hire foreign radiographers."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "UAE Centennial 2071",
        "reason": "Private hospitals and diagnostics centres heavily import radiographers."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Clinical radiographers removed from shortage list in 2025; still hire but harder."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Clinical roles face visa caps; hiring possible but not prioritised."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Role not prioritised for foreign talent."
      }
    }
  },
  "0f902474-7004-484b-a937-732daef5f061": {
    "career": "BA Coordinator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Business administrators appear on state lists only for specific sectors, giving moderate but not strong alignment."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Managers with French or tech skills get points, but generic admin is a supporting rather than priority occupation."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Can qualify under ‘other qualified professionals’, yet not explicitly favoured like engineers or nurses."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Eligible for General Employment Permit, yet not on Critical Skills list, so lower priority."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Skilled Migrant Category",
        "reason": "Management roles gain points for degree and experience, but lack direct Green-List support."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Mega-projects need back-office coordination; expatriate managers still recruited though role isn’t a headline priority."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Service-sector diversification creates demand for operations coordinators inside free-zone firms."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Can obtain sponsorship under general occupation codes, but role not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Generic business-operations roles still sponsored by large contractors and service firms supporting federally funded projects."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4bfbe0c8-9c6f-41ce-ad12-281379dbcc2e": {
    "career": "Dance Instructor",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Kingdom is rapidly building entertainment sector; recruits foreign choreographers for festivals and mega-projects."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi fund performing-arts academies and tourism shows, opening visas for experienced instructors."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative sector is a strategic pillar; arts educators can obtain ‘Creative Worker’ visas though cap is small."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Arts visas (O-1, P) exist but federal priority funding only indirectly benefits community arts programmes."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "de7f2304-6b32-437b-a9ec-1e91120a07c0": {
    "career": "Economic Principles Instructor",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "University lecturers remain on skilled-occupation list, facilitating visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Programme eases hiring of professors and researchers, especially bilingual candidates."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Points for PhD, publications and German language; universities actively recruit foreign faculty."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Higher-education lecturing appears on the list; fast-track work permits available."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Highly Skilled Professional visa",
        "reason": "PhD instructors earn high points under academic activities."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Lecturers can gain residence but not Green-List fast track."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Privately funded universities hire foreign economics faculty for rapid expansion."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National AI Strategy 2.0",
        "reason": "Universities expand economics of AI programmes; passes granted to high-citation researchers."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "UAE Centennial 2071",
        "reason": "Branch-campus universities in Dubai/Abu Dhabi actively recruit PhD instructors."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Universities receive funding for economic impact research; Global Talent visa open to academics."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "CHIPS and Science Act",
        "reason": "Act expands university research funding, raising demand for economics faculty in policy evaluation and labour studies."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4aaa8e62-1c74-49cb-a03b-bdbb1ade4240": {
    "career": "Management Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Industrial/production engineers on priority list; state sponsorship widely available."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Industrial engineers appear on high-demand list; fast permanent residence pathways."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Mittelstand and auto sector urgently need industrial engineers for efficiency upgrades."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "RPJPN 2025-2045",
        "reason": "Nickel & battery plants need efficiency experts, yet bureaucracy limits fast visas."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Industrial & production engineers on critical list—fast-track work permits."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Highly Skilled Professional visa",
        "reason": "Process-optimisation and smart-factory specialists gain high immigration points."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industry 4.0 targets require management engineers for semiconductor and EV plants."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Skilled Migrant Category",
        "reason": "Qualifies for points but not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Mega-projects and new industrial cities hire process-optimisation engineers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Manufacturing 2030",
        "reason": "Smart factories require industrial engineers though passes focus on top talent only."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Operation 300bn",
        "reason": "Plan pushes advanced manufacturing; industrial engineers needed for plant efficiency."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Advanced manufacturing and clean-energy supply chains list industrial engineers as key talent."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Industrial and systems engineers are central to scaling advanced semiconductor and manufacturing plants."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Industrial engineers recruited to raise fab productivity but visa pathways still emerging."
      }
    }
  },
  "77ec42e3-aa69-49f1-8cd0-d1c9501c7952": {
    "career": "School Counselor Educator",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Teacher-training lecturers including counselling specialisms remain on skilled lists."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Counselling educators support mental-health capacity in schools, aligning with federal wellbeing initiatives."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Education specialists can qualify but language requirements and limited university slots lower priority."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Educational psychologists are listed, giving moderate priority to trainer roles."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Migrant Category",
        "reason": "Government funds wellbeing programmes; universities seek counselor-educators."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "UAE Centennial 2071",
        "reason": "Private universities recruit counselling professors, but numbers are small."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Mental-health training valued, yet educator visas compete with STEM priority."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Not a direct priority, but universities still sponsor counselling faculty under general education codes."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "c62b6dd3-0173-4386-ab5d-f6d8c126c525": {
    "career": "Advanced Robotics Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Core Skills list covers software, data and automation engineers to modernise mining and manufacturing."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Digital-tech stream highlights AI and automation specialists; robotics engineers score high CRS points."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Germany’s world-class industrial automation sector (KUKA, Bosch) fast-tracks robotics talent."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV battery and mineral plants adding automation, but hiring volumes still early-stage."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Robotics fits inside software engineer code but is not on the critical shortage list."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics engineers explicitly prioritised to offset ageing workforce and maintain global robot leadership."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industry 4.0 push welcomes automation talent, though focus is wider semiconductor chain."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "General engineering recognised but robotics demand is niche and small in scale."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "NEOM and giga-projects deploy service robots and automated logistics, creating selective demand."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "National AI Strategy 2.0",
        "reason": "Strategy names service & logistics robotics as national growth vertical; Talent Pass available."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Operation 300bn",
        "reason": "Industrial strategy funds smart factories and warehouse robotics; visas issued under advanced tech quota."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital & manufacturing pillars support robotics R&D for EV and aerospace supply chains."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "CHIPS and Science Act",
        "reason": "Federal funds for advanced manufacturing, defense and semiconductor fabs are driving aggressive hiring of robotics engineers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Factory-automation robotics linked to new chip assembly plants; moderate opportunity."
      }
    }
  },
  "ed9d2138-fa72-4ec9-8c0e-3aaf222246d3": {
    "career": "Clinical Speech Therapist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Speech pathologist code on CSOL enables priority visas and regional sponsorship."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Speech-language pathologists fall under healthcare occupations given top CRS priority."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Rehabilitation clinics recruit foreign therapists; licensing process slower than nurses."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Speech and language therapists explicitly on Critical Skills Permit list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Licensing limited to native-language therapists; few visas issued."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Speech therapists listed (Tier 2) with direct residence pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Vision 2030",
        "reason": "Private neuro-rehab centres import foreign therapists; nationalisation keeps numbers limited."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Child-development clinics and hospitals hire expatriate SLPs under healthcare visa quotas."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Hospitals report shortages, but role not on any federal priority immigration list."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a400a58d-67b6-43d4-8c63-74d0cfdbe0bc": {
    "career": "Government Advisor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "Public-sector jobs favour citizens; consultants hired case-by-case."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Advisory roles possible in provincial ministries but not immigration-priority occupations."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Card allows high-skill migration, but civil-service advisory posts demand fluent German."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Role not shortage-listed; think-tanks sometimes sponsor visas."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Policy advisory roles limited by language; private consultancies may sponsor under HSP points."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "MADANI Economy",
        "reason": "Economic ministries occasionally engage foreign advisors for NIMP 2030, but numbers small."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "No dedicated policy stream; agencies hire rarely from overseas."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Vision 2030",
        "reason": "Ministries and royal courts import strategic advisors for mega-projects and economic diversification."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Economy 2030",
        "reason": "Public-sector think-tanks hire some foreign experts, but citizenship preference is strong."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Dubai & Abu Dhabi pay premium for international policy talent in economic and climate strategy units."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Cabinet Office and consulting firms recruit policy experts for IS-8 implementation work."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Federal and state bodies need policy advisors to manage trillion-dollar infrastructure rollout; cap-exempt hiring possible."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "bb9417f7-d64f-4148-a7ac-e7f71bceea8c": {
    "career": "Monetary Economist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Economists not on CSOL; sponsorship possible through universities and banks only."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Bank of Canada and fintech hubs sponsor quantitative economists under tech talent streams."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Bundesbank hires selectively; German language limits wider demand."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Bank Indonesia focuses on nationalisation; few foreign economist roles."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Quantitative finance and central-bank analyst codes on list; visa processing streamlined."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Bank of Japan sponsors PhD economists; language still barrier."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "MADANI Economy",
        "reason": "Bank Negara and Islamic finance hubs hire monetary economists for policy research."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Small market; Reserve Bank rarely sponsors overseas economists."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Saudi Central Bank and PIF seek macro-researchers for diversification strategy."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Singapore Economy 2030",
        "reason": "MAS positions and sovereign funds recruit top monetary economists to steer fintech and macro-prudential policy."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "UAE Centennial 2071",
        "reason": "Central Bank and sovereign funds recruit monetary economists to back fintech and dirham-stability goals."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London’s global financial hub and Bank of England offer Skilled Worker visas for macro-policy talent."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Federal Reserve and Treasury hire economists to track IRA macro effects; H-1B cap-exempt research roles."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "State Bank seldom sponsors foreigners; local degrees preferred."
      }
    }
  },
  "decf8ed4-bce8-4a18-a8ef-54331917d38f": {
    "career": "Archaeologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "Museums and mining-impact assessments hire a few foreign archaeologists; no fast-track."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Academic roles and heritage consulting fit points system but not a named priority."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Regional heritage offices recruit foreign specialists for Roman and Bronze-Age sites."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "RPJPN 2025-2045",
        "reason": "Borobudur and new capital excavations open consulting slots, but Bahasa requirement applies."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Heritage bodies hire, but role is not on critical list; standard work permit needed."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Archaeology tied to prefectural agencies requiring fluent Japanese."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Work available in iwi consultation and heritage impact, but small numbers."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "AlUla and Red Sea projects fund excavations needing experienced archaeologists."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "We the UAE 2031",
        "reason": "Tourism heritage push creates limited contracts for foreign archaeologists."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Post-Brexit shortage of field archaeologists for urban development projects."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Cultural-resource surveys mandated for new infrastructure create steady archaeological consulting demand."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "40cb7ec3-3669-4259-be5a-fbe498c661c9": {
    "career": "E-Business Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Migration Strategy 2023 focuses on STEM and construction; generic business management receives standard points only."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Express Entry gives points for management experience yet no specific category-based selection for e-commerce managers."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Skilled Immigration Act welcomes managers, but quotas favour engineering and trades over retail or digital marketing heads."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Huge push for digital marketplaces outside Java fuels demand for senior e-business leadership."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Critical Skills List excludes marketing/retail managers; job offers still possible in Dublin’s tech sector via General Work Permit."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Highly Skilled Professional visa favours engineers; e-commerce managers can enter but without preferential points."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "NIMP 2030 mentions digitalisation, yet priority points flow to semiconductor and advanced-manufacturing, not commercial managers."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Green List targets teachers, health, construction; e-business managers must use general Skilled Migrant pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Large investments in online tourism, fintech and retail platforms create explicit demand for experienced digital-business leaders."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Singapore Economy 2030",
        "reason": "Not Tier-1, but EP points boost for digital-marketplace managers supporting regional HQs."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Dubai & Abu Dhabi free-zones court e-commerce companies; management talent fast-tracked under digital-economy visas."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Modern Industrial Strategy prioritises advanced manufacturing, not commerce; managers qualify only under generic Skilled Worker visa."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Digital-commerce skills valued by private employers, but the role is not mentioned in CHIPS, IRA or IIJA priority lists."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "National Master Plan 2021-2030",
        "reason": "Government wants global e-commerce know-how to scale platforms like Tiki/Shopee; management talent gets relaxed work-permits."
      }
    }
  },
  "60d7f6f3-bacb-4391-a857-3958ee7d640c": {
    "career": "International Law Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Migration lists exclude legal occupations; overseas lawyers face strict re-qualification."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Express Entry awards points for legal experience, but no category-based stream for lawyers."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "International arbitration centres growing in Frankfurt, yet not on Skilled Immigration shortage list."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "",
        "reason": "Post-Brexit Dublin seeks EU law talent; Critical Skills list includes solicitors with specialised experience."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Foreign lawyers can register but only advise on home-jurisdiction law; limited visa points."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Islamic finance expansion creates some openings, yet not on priority immigration lists."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Legal jobs available but no immigration priority; re-admission takes time."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Mega-projects need contract experts, but Saudisation keeps quotas tight for foreign lawyers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "National AI Strategy 2.0",
        "reason": "Financial hub values cross-border dispute specialists; Foreign Practitioner Scheme streamlined."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "UAE Centennial 2071",
        "reason": "DIFC/ADGM courts drive demand for cross-border legal counsel; specialist visas available."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London depends on international law firms; senior solicitors included in high-value professional services."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "US bar admission possible, yet federal priority lists favour STEM over legal services."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "5782ecfc-13e8-419b-8360-e3eb60dd3c1e": {
    "career": "Theatre Educator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "CSOL lists STEM and secondary maths; drama teachers enter via general Skilled Migrant route."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Category-based selection lists early-childhood and K-12 teachers, yet performing-arts specialisms receive no preference."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Cultural educators can immigrate, but Opportunity Card focuses on STEM/mechatronics."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Drama teaching not on Critical Skills List; general work permit necessary."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Green List covers primary and STEM teachers only; drama outside shortage lists."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Skilled Worker visa allows drama teachers, but they are not on Shortage List."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Arts teachers viable but not prioritised under federal immigration acts."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "0ef4397c-46ae-4222-aa9b-e7b0a224bdee": {
    "career": "Behavioral Therapist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Migration Strategy 2023",
        "reason": "Severe shortages in psychologists and therapists across NDIS and aged-care."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Mental-health professionals explicitly targeted for fast-track PR."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Acute mental-health staffing gaps; foreign therapists eligible for accelerated Blue Card."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Growing need, yet localisation policies limit foreign clinical roles."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Psychologists and therapists included for critical-skills permits."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "HSP visa emphasises nursing care over specialised therapists; demand niche."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Private hospitals hire therapists, but no immigration priority."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Behavioural therapists on Tier-1 health list with direct residency pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Vision 2030",
        "reason": "New hospitals and autism centres recruiting expatriate therapists."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "MOH grants allied-health registrations; not a Tier-1 priority but demand steady."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Dubai Health Authority grants golden visas to scarce mental-health professionals."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "NHS shortages exist, but occupation removed from post-2025 Shortage List; sponsorship still possible."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "",
        "reason": "High domestic demand, yet no federal shortage list; states ease licensing reciprocity."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Mental-health field small; work permits available but not fast-tracked."
      }
    }
  },
  "544410e3-5032-4d3e-bb8e-4915d698d170": {
    "career": "Bioprocess Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL includes chemical/biotech engineers to support pharma manufacturing in Victoria and NSW."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Ottawa invests in domestic vaccine capacity; bio-manufacturing engineers on STEM priority list."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "79",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Biopharma clusters in Hessen and Bavaria recruit foreign process engineers under Blue Card."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Biopharma still nascent; foreign engineers hired project-by-project."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Dublin-Cork pharma corridor urgently needs bioprocess engineers for blockbuster biologics plants."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points bonus for biotech researchers and engineers supporting ageing-care pharma."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "NIMP lists pharma and medical devices; generous tax breaks for hiring biotech engineers."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Small biotech sector; some roles via general Skilled Migrant Category."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Vision 2030 emphasises pharma, but most plants still under construction; limited current slots."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Singapore Economy 2030",
        "reason": "Biopharma manufacturing is a national pillar; EP point system heavily rewards bioprocess expertise."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Biotech hub emerging, yet engineering priority lies in med-tech R&D, not large-scale bioprocess."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences manufacturing a strategic pillar; Skilled Worker visa shortage points for bioprocess engineers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds advanced biomanufacturing plants, biologics and mRNA vaccine scale-up; EB-2 NIW fast tracks biotech engineers."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "National Master Plan 2021-2030",
        "reason": "Government funding vaccine R&D centres; foreign experts get streamlined work permits."
      }
    }
  },
  "6be0b1cb-b10b-4b9c-aa12-61b216072169": {
    "career": "Communications Manager",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Large-scale tourism and entertainment projects need senior comms talent to shape global image."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Economy 2030",
        "reason": "Digital marketing roles exist but are not flagged as top-tier shortage occupations."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Government actively recruits experienced media/communications leaders to promote UAE as a business & tourism hub."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry seniors included, but immigration priority leans to film/game production rather than generic comms."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Corporate communications demand exists but not referenced in any US priority immigration or industrial policy."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "642c2e80-cf57-49de-96b7-58861d86eac0": {
    "career": "DevOps Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL lists software developers, DevOps and cloud engineers as priority shortage roles."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Software engineers are explicitly targeted for fast-track permanent residence."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT Spezialist path lets DevOps professionals obtain Blue Card without a degree if experience proven."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "E-commerce boom requires DevOps yet policy focuses on hardware and energy first."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "DevOps/software engineers receive Critical Skills permits with PR after two years."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Highly Skilled Professional visa",
        "reason": "Cloud and AI professionals qualify but language barrier keeps numbers modest."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "NIMP 2030",
        "reason": "Industry 4.0 rollout needs DevOps but policy spotlights semiconductors more than software ops."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Software engineer appears on Tier 1 list enabling straight-to-residence visas."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Digital transformation projects need cloud talent but Saudization limits foreign intake."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "National AI Strategy 2.0",
        "reason": "DevOps underpins AI product deployment; Tech.Pass and COMPASS favour experienced engineers."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Operation 300bn",
        "reason": "Fintech and manufacturing digitisation create solid demand for DevOps skills."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital/AI specialists qualify for Skilled Worker visas and Global Talent pathways."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "CHIPS and Science Act",
        "reason": "Cloud automation and AI infrastructure underpin semiconductor and advanced-tech R&D funding."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Rapid growth in AI and fintech boosts demand for cloud engineers."
      }
    }
  },
  "d4c3a703-6888-442e-a324-545a0200d16c": {
    "career": "Hospitality Educator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "VET sector hires hospitality trainers but not on priority lists."
      },
      "canada": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Tourism is a growth pillar; private colleges sometimes recruit foreign faculty."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Skilled Migrant Category",
        "reason": "Some demand for vocational tutors, but not listed on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Mega-projects (NEOM, Red Sea) bankroll hospitality academies seeking global faculty."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Economy 2030",
        "reason": "Integrated resorts and polytechnics offer limited but real demand for hospitality lecturers."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "We the UAE 2031",
        "reason": "Tourism strategy funds hotel-management institutes that import experienced educators."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a5066535-9345-4d0d-9076-bc7eaa4cecc5": {
    "career": "QA Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Software testers included in ANZSCO shortage categories."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Grouped under software engineers for immigration scoring."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialists route recognises QA experience regardless of degree."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "RPJPN 2025-2045",
        "reason": "Growing digital economy requires testers but no special incentives."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Test engineers fall within software developer category for Critical Skills permits."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Eligible under IT engineer points system but language hurdle remains."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "NIMP 2030",
        "reason": "Industry 4.0 adoption drives need for QA though focus is on hardware."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Demand exists but QA not singled out on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Digital projects hire QA, yet local workforce supply is growing."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National AI Strategy 2.0",
        "reason": "Software testing, especially for fintech and AI safety, is valued under Tech.Pass."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Operation 300bn",
        "reason": "Fintech/product companies need testers; visas accessible but not top shortage."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital shortage code SOC 2135 covers software testing roles."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "CHIPS and Science Act",
        "reason": "Software quality roles support expanded digital R&D, though not explicitly named."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Booming software outsourcing sector steadily hires QA."
      }
    }
  },
  "b29a3369-e223-477c-8693-6fe91c74881b": {
    "career": "Choreographer",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Cultural visa pathways exist but are city-specific and competitive."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Entertainment sector expansion (concerts, festivals) requires international choreographic talent."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai and Abu Dhabi invest in large-scale shows needing choreographers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry seniors—including dance—qualify for Global Talent visa."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Arts O-1 visas exist but not part of economic priority lists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "bc81d2fb-c923-4485-9614-decf04a0c5b5": {
    "career": "Game Designer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Creative roles are outside the Core Skills Occupation List; visas possible via Global Talent stream yet not priority."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Canada welcomes digital-media talent but game design is not on the targeted occupation lists, so immigration pathways exist but are competitive."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Points-based card allows non-EU creatives, but no shortage list support for game design."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Games not on list; however, Dublin’s indie scene offers limited opportunities via standard work permit routes."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "Gaming giants (Nintendo, Sony) can sponsor designers; HSP visa rewards high salary/education though not on priority list."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Vision 2030",
        "reason": "Huge investment in e-sports and entertainment megaprojects (NEOM Game Hub) creates demand for experienced game designers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Singapore Economy 2030",
        "reason": "Government funds e-sports and AAA studios (Ubisoft, Riot) under digital-media pillar, but still secondary to AI/fintech."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "We the UAE 2031",
        "reason": "Dubai Media City and AD Gaming incentivise international studios, making senior designers desirable though not formally shortage-listed."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 names the creative games sector as a strategic growth industry with tax relief and fast-track visas for senior talent."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Act funds broadband and cloud infrastructure that indirectly supports the booming US video-game industry but does not explicitly prioritise creative roles."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      }
    }
  },
  "d1f0d248-325c-4b72-8e4c-07198864a5e0": {
    "career": "Geophysicist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Geophysicists are explicitly on CSOL due to demand in mining and geothermal; fast-track visas available."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Mining, energy and carbon-capture sectors have acute shortages; geoscientists receive extra CRS points."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Germany needs subsurface experts for geothermal and CCS but role competes with EU talent pool."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel, copper and geothermal expansion drives steady demand for exploration geophysicists."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Earthquake-hazard modelling needs talent, but language and seniority hurdles keep numbers small."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "MADANI Economy",
        "reason": "Oil, gas and CCS hubs in Sarawak require geoscientists; employers sponsor EP1 visas."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 2)",
        "reason": "Listed under ‘other engineering professionals’ for geothermal exploration; offers straight-to-residence pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Massive investment in mining and hydrogen storage requires seismic survey specialists."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National AI Strategy 2.0",
        "reason": "City-state has little subsurface industry; only a few regional HQ analytics roles."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Operation 300bn",
        "reason": "CCUS and hydrogen projects create demand, though smaller than Saudi market."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "CCUS clusters and North Sea decommissioning need geophysicists but no shortage-list concessions post-Brexit."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Bill funds critical-minerals mapping, carbon-storage and geothermal projects that employ exploration geophysicists."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "National Master Plan 2021-2030",
        "reason": "Offshore wind and LNG import projects need some subsurface work but not a formal priority."
      }
    }
  },
  "110f7256-9f1a-477d-aab4-b9b6bb278ad4": {
    "career": "Modern Studies Teacher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Secondary teachers on CSOL, though humanities posts fill slower than maths/science."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "K-12 teachers are priority, but French or rural placements preferred; social studies less acute than STEM."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "States face shortages in social sciences, especially bilingual programs; language B2 German mandatory."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "ALT English programmes hire humanities graduates, but Modern Studies syllabi differ; cultural fit issues."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Secondary teachers on Tier 2 Green List, offering work-to-residence path after two years."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "Private international schools recruit social-studies teachers, but not covered by national priority schemes."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Humanities teachers were removed from shortage list in 2025; hiring possible but visa points harder."
      },
      "united_states": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      }
    }
  },
  "ec14a2fd-cbad-4cd7-b70d-67898f7e50f0": {
    "career": "Molecular Biology Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Medical researchers fit Global Talent visa but are outside core shortage list."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Biotech scientists gain points, especially with PhD and French, but not singled out like nurses or IT."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Germany’s BioNTech boom attracts molecular biologists, yet competition from EU graduates keeps it Tier 2."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Biopharma identified but talent localisation preferred; few foreign lab roles yet."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Biopharma and med-tech giants need molecular biologists; listed for Critical Skills Permit."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "Biotech researchers rewarded with HSP points; language barrier keeps numbers modest."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan promotes pharma and medical devices, opening roles for molecular biologists."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Limited biotech sector; visas available but few openings."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "Emerging biotech hubs in NEOM and KAUST recruit researchers but still nascent."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Singapore Economy 2030",
        "reason": "A*STAR and Biopolis anchor biomedical research; specialists welcomed under ONE Pass though sector not top-tier like AI."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "We the UAE 2031",
        "reason": "Abu Dhabi Biotech Hub offers Golden Visas for PhD scientists."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences named pillar; fast-track Global Talent visa for molecular biology specialists."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act earmarks billions for biotech manufacturing and R&D, prioritising molecular biologists for bio-foundries."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National Master Plan 2021-2030",
        "reason": "Biotech is upcoming but still early-stage; limited senior positions for foreigners."
      }
    }
  },
  "cb9bef8e-2eec-4742-9a2d-a18da1120a46": {
    "career": "Natural Science Teacher",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Migration Strategy 2023",
        "reason": "Secondary STEM teachers are on CSOL with direct PR pathways."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "STEM teachers prioritised but French language or rural postings boost chances; caps vary by province."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Acute shortage of STEM teachers; states run fast-track foreign qualification recognition programs."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "47",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "ALT science programmes exist but limited; language and syllabus differences hinder full licensure."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Secondary science teachers on Tier 1—immediate residence on job offer."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "Private international schools recruit STEM teachers but not under national talent initiatives."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Physics and chemistry teachers remain on shortage list, but visa points tightened in 2025."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No federal shortage visas for secondary science teachers; state licensure complex for newcomers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "e14060eb-2fe6-4514-aae9-b1101cf42dc4": {
    "career": "Pharmaceutical Chemist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Core Skills list highlights medical scientists and pharmaceutical manufacturing roles."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Healthcare scientists are prioritised; pharma chemists qualify under health-science NOC codes."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Germany’s strong chemical & life-science sector actively recruits foreign chemists."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Focus is on biopharma processing and vaccines, fewer openings for synthetic chemists."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Huge API/export pharma cluster around Cork & Dublin drives constant chemist demand."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP rewards advanced biotech researchers, including drug-discovery chemists."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan singles out pharma & medical devices; tax breaks lure formulation chemists."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Life-science jobs allowed but not on Green List, so ordinary points route only."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Biotech is emerging, but incentives focus on healthcare delivery rather than R&D."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Economy 2030",
        "reason": "Biomedical manufacturing is a core pillar, yet quota-controlled; fit is solid but not top."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Dubai Science Park courts pharma R&D, yet numbers remain modest—medium fit."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life sciences named as pillar; visa routes fast-track PhD medicinal chemists."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds domestic drug manufacturing and biomanufacturing R&D, directly requiring medicinal chemistry talent."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "National Master Plan 2021-2030",
        "reason": "Biopharma listed but emphasis still on generics and manufacturing, limited R&D roles."
      }
    }
  },
  "a1b69a5a-e52f-49fa-bb03-37582105855c": {
    "career": "Cybersecurity Architect",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Migration Strategy 2023",
        "reason": "Core Skills list specifically names cyber and data-security roles."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Cybersecurity specialists earmarked for streamlined work permits and PR pathways."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT Fachkräfte visas cover high-level security architects, but German language often required."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Multinationals’ SOCs around Dublin hunt for security architects."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP favours AI/ML and cybersecurity researchers; language less critical for experts."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "MADANI Economy",
        "reason": "Bank Negara and digital banks scaling up infosec, but salary ceiling lower."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Eligible but not on Green List; points system only."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Smart-city and fintech projects need cyber architects, but localisation quotas apply."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "National AI Strategy 2.0",
        "reason": "Financial sector and GovTech recruit senior security architects under COMPASS fast-pass."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Operation 300bn",
        "reason": "Financial hubs (DIFC, ADGM) push zero-trust architecture in banking and gov cloud."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital & cyber security are priority sectors with shortage-occupation visas."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Federal funds for semiconductor & critical-infrastructure security create senior cyber architecture demand."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Security talent helpful for chip fabs’ IP protection but visas limited."
      }
    }
  },
  "5d053acc-0a9a-4233-ab4d-0bdfc5456c26": {
    "career": "Environmental Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Environmental scientists appear on CSOL for mining impact assessments."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Green-economy occupations prioritised as Canada targets net-zero 2050 reporting."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Energiewende projects demand LCA and ESG analysts, but language is a gate."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "RPJPN 2025-2045",
        "reason": "Environmental monitoring for nickel & geothermal projects gives moderate demand."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Environmental scientists eligible but not explicitly critical; some green-finance demand."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "NIMP mentions ESG compliance but immigration priority is manufacturing engineers."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Migrant Category",
        "reason": "Climate-risk roles valued for forestry, dairy and coastal management."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Mega-projects require EIA, yet roles often go to large consultancies already on staff."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Green Plan 2030",
        "reason": "Carbon services hub needs analysts, but quota tight and competition high."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "We the UAE 2031",
        "reason": "COP28 legacy drives ESG reporting, but hiring numbers are modest."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean-energy pillar requires impact analysts for offshore wind, hydrogen and CCUS."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA’s climate spending needs analysts to model emissions, offsets and compliance."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "46f595de-8ff2-49d6-b034-902d2a0b4d3e": {
    "career": "Game Artist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Creative visas exist but numbers small, state-sponsorship needed."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Canada’s game studios hire, yet creative roles not specially prioritised—points only."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Game roles possible via standard work permits but not critical list."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Highly Skilled Professional visa",
        "reason": "Home of Nintendo/Sony; HSP covers digital creators if salary high enough."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Entertainment megaprojects include e-sports and gaming hubs requiring art talent."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Economy 2030",
        "reason": "Government funds AAA studios and metaverse labs; COMPASS offers points but not top tier."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai’s gaming & metaverse strategy offers golden visas for senior creatives."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry pillar lists game development; Global Talent visa fast-tracks lead artists."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "CHIPS and Science Act",
        "reason": "Indirect benefit via booming game engines for AR/VR, but not directly prioritised."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      }
    }
  },
  "fb6e8d10-12a8-4bd4-bb82-1a295e24b16f": {
    "career": "HR Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "HR not on Core Skills list; employer sponsorship only."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Generic business roles obtain work permits but no priority points."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Mega-projects import senior HR, but Saudization limits numbers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Economy 2030",
        "reason": "Regional HQs still value expat HR, though COMPASS points needed."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Free-zone multinationals often hire expat HR for regional hubs."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Large hiring waves in clean-tech firms need HR, but role not policy-driven."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "43a9daba-6ce1-4b08-abed-a86a4282bda4": {
    "career": "STEM Software Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "‘Software Engineer’ is a flagship occupation on CSOL with three-year visa pathways to PR."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "IT and software engineers have their own fast-track immigration draw and highest CRS bonuses."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT Spezialist visa waives degree if skills proven; acute shortage across automotive and Industrie 4.0."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Demand in fintech and EV supply-chain digitalisation, but bureaucracy and Bahasa requirement deter."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "FAANG EMEA HQs depend on continuous inflow of software engineers; job offer ⇒ immediate Critical Skills permit."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points heavily favor AI/robotics programmers; language barrier still high."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "IC-design centres and fintech clusters seek software talent but salaries lower than West."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Green List includes ‘Software Engineer’; straight to residence visas but small absolute headcount."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Hiring for smart-city and fintech projects, yet Saudization limits volume and expat tenure."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "National AI Strategy 2.0",
        "reason": "Tech.Pass and COMPASS salary exemption attract senior software engineers in AI, fintech and robotics."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Operation 300bn",
        "reason": "Dubai and Abu Dhabi free-zones offer ten-year Golden Visas for AI and software talent."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital, AI and semiconductor software on Shortage List; visas processed in <3 weeks."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Direct funding for AI, quantum and next-gen software R&D; H-1B demand for coders remains far above cap."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Chip design and e-commerce boom need software engineers; foreign hires capped by local upskilling goals."
      }
    }
  },
  "88412270-6631-4946-86b2-7165c02c1523": {
    "career": "Training Coordinator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "Listed under HR advisors—possible but lower points than technical skills."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Soft-skills occupations get CRS points only when French-speaking; demand exists but not priority."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Can enter on points, but HR not in shortage catalog; German language mandatory."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "RPJPN 2025-2045",
        "reason": "Work-permit quotas and Bahasa mandate make foreign HR rare."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on Critical Skills list; General Employment Permit still possible."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Language and cultural training expectation high; few slots for foreign HR staff."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "MADANI Economy",
        "reason": "Companies expanding manufacturing need trainers, but expat quota tight."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Skilled Migrant Category",
        "reason": "HR roles qualify only at high salary band; small market."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Vision 2030",
        "reason": "Mega-projects need internal L&D, yet Saudization pushes them to hire locals first."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Singapore Economy 2030",
        "reason": "MOM COMPASS framework still favors local HR; EP possible at high salary."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Free-zones aggressively hire L&D staff for multinational workforces; Golden Visa possible above salary threshold."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "HR not on shortage list; eligible visa category but sponsor willingness limited."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Massive infrastructure rollout requires workforce upskilling teams, yet role is non-specialty for visas."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "41",
        "policy": "National Master Plan 2021-2030",
        "reason": "Preference for local HR except for niche technical trainers."
      }
    }
  },
  "2cbb95d0-527b-4f7a-80c5-09916bb6d734": {
    "career": "Cinematographer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Migration Strategy 2023",
        "reason": "Screen Australia subsidies increase demand but no special visa preference."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Vancouver and Toronto film tax credits draw productions and crew."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Berlin indie scene welcomes creatives, yet German language and funding limits."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Tourism board funds co-productions; work-permit hurdles remain."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Irish Film Tax Credit lures productions but cinematography not on Critical list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Niche anime live-action hybrids; language barrier significant."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "MADANI Economy",
        "reason": "Iskandar Studio incentives attract regional shoots; roles project-based."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Skilled Migrant Category",
        "reason": "Weta and Amazon’s productions need camera crew, but few residency pathways."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Vision 2030",
        "reason": "Massive spend on film city and festivals; foreign DoPs hired on project visas."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Singapore Economy 2030",
        "reason": "Mediapolis grants but preference for local camera crews."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Dubai Studio City offers 0% tax for film crews; visas issued quickly but temporary."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry senior roles listed; Film London’s £300 m studio expansion."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Indirect boosts: new studio complexes eligible for tax incentives; O-1 visa available for acclaimed artists."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Growing local film, yet foreign cinematographers uncommon due to cost."
      }
    }
  },
  "814948fd-ff24-48bf-bf54-837fbecedc82": {
    "career": "Curriculum Advisor",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Migration Strategy 2023",
        "reason": "‘Educational Consultant’ on medium-term list; PR after 3 years in regional areas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Education administrators qualify and French bilingual advisors get extra CRS points."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "STEM curriculum specialists help tackle shortage of teachers; visas possible with MA and German B2."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "RPJPN 2025-2045",
        "reason": "Curriculum reform ongoing; expat advisors hired on short contracts."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Education consultants fall outside Critical Skills; General permit possible."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Highly Skilled Professional visa",
        "reason": "International schools use advisors but Japanese curriculum tightly regulated."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Growth in private international schools but salaries modest."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Education advisors listed; direct residence once salary threshold met."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Vision 2030",
        "reason": "Private international schools hire advisors for IB and STEM, but roles limited."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Singapore Economy 2030",
        "reason": "MOE contracts niche experts but citizenship preference high."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "We the UAE 2031",
        "reason": "KHDA pushes curriculum reform; advisors hired in Dubai campuses though visas employer-tied."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Curriculum designers not on shortage list; sponsorship doable for academies at high salary."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "CHIPS and Science Act",
        "reason": "Some STEM outreach funds flow to curriculum design, but immigration category scarce."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Ed-tech startups prefer local hires due to language alignment."
      }
    }
  },
  "cc85911a-1a64-4fe8-b6bd-78957fef5bae": {
    "career": "Grade School Teacher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Secondary STEM and primary teachers on priority list with fast PR route."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "K-12 teachers receive extra CRS; acute shortages in French and rural areas."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Länder recruit foreign teachers to ease shortage, especially STEM and English."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "RPJPN 2025-2045",
        "reason": "Nusantara campus schools hiring, but Bahasa proficiency required for licensing."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Primary teachers outside Critical list but work permits possible via Catholic schools."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "ALT programmes hire English grads, yet short-term and capped pay."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "MADANI Economy",
        "reason": "International schools booming, but visa quotas and pay modest."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Primary and secondary teachers on Tier 1—direct residence pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "International schools hire expats; public system restricted to Saudis."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Economy 2030",
        "reason": "MOE rarely sponsors foreign primary teachers; some openings in private IB schools."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi private schools actively recruit CBSE and IB teachers."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Only maths, physics, computer teachers are shortage; others need sponsorship and QTS."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No federal teacher shortage visa; some districts sponsor J-1 but temporary."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National Master Plan 2021-2030",
        "reason": "Growth in bilingual schools, but ESL focus over general subjects."
      }
    }
  },
  "2583f636-19d7-4e8d-b408-054ed52cdcc5": {
    "career": "Interactive Media Designer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Occasional demand in gaming hubs like Melbourne, but not on Core Skills list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Tech creatives eligible under general digital occupations, yet not on priority lists."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Visa points for design degrees, though focus remains on engineers and IT."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Tech firms hire UX talent, but role absent from critical-skills list."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "69",
        "policy": "Highly Skilled Professional visa",
        "reason": "Video-game giants recruit foreign UI/UX experts; points system rewards high salaries."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Creative roles can qualify under generic points system, yet not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Gigaprojects (NEOM, AlUla) need immersive media, AR/VR and digital experience designers now."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "National AI Strategy 2.0",
        "reason": "UX designers valued in fintech and govtech, yet not core Tier-1 occupation."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai Media City and Abu Dhabi gaming strategy place senior interactive designers on priority hiring."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries (film, TV, gaming) explicitly listed; fast-track visas for experienced designers."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Massive broadband and 5G rollout fuels demand for digital content and UX talent, but no dedicated immigration fast-track."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "6a5003a1-4ec1-4b7d-acb5-97053af1f33a": {
    "career": "Modern Language Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Universities sponsor researchers; role sits outside Core Skills but academia hiring steady."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Academics gain points for PhD and French, yet language research not a named priority."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Strong demand for linguists in integration and AI-translation projects; points awarded for PhD."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Some grants in minority Celtic languages, yet not on critical list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Highly Skilled Professional visa",
        "reason": "University labs studying NLP need bilingual scholars, but points favour STEM."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "PhD scholars qualify for extra points, but no shortage designation."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Economy 2030",
        "reason": "Universities fund corpus linguistics for AI translation; PhD researchers receive EP points."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "UAE Centennial 2071",
        "reason": "Federal universities recruit linguistics faculty to raise academic rankings."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Universities can sponsor researchers under lecturer/researcher codes despite overall visa tightening."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "CHIPS and Science Act",
        "reason": "Act boosts federal research funding, including humanities through NSF fellowships, but no special visa lane."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      }
    }
  },
  "219e1e6c-283f-4f61-804a-559499eb7e39": {
    "career": "Pharmaceutics Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "59",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Clinical pharmacists are listed, but pure R&D scientists receive no fast-track."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Canada courts pharma R&D talent but limits permanent slots to certain provinces."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Major biotech clusters in Berlin and Munich hire formulation scientists via new points system."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Nine of world’s top ten pharma firms manufacture in Ireland; R&D scientists on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "Aging society fuels drug research; HSP fast-track for PhD scientists."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan targets medical devices more than novel drug R&D."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "List covers clinical pharmacists, not drug-discovery researchers."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "Growing pharma manufacturing parks, yet preference for process engineers over R&D scientists."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Singapore Green Plan 2030",
        "reason": "Biopharma manufacturing and research hubs (Biopolis, Tuas) aggressively recruit formulation scientists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Operation 300bn",
        "reason": "Industrial strategy includes pharmaceutical manufacturing; R&D specialists receive Golden Visa eligibility."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences super-cluster around Oxford-Cambridge demands formulation and drug-delivery experts."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds biomanufacturing and reshoring of drug production, boosting demand for formulation experts."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "46ae9ec7-5f1b-43ca-82e6-21c1713c1e92": {
    "career": "Applied Software Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Software developer positions dominate priority list with streamlined visas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Software engineers top the tech category with fast PR turnaround."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Shortage of IT specialists; new Chancenkarte gives points boost."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech boom needs coders, yet immigration pathways unclear."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Software developers included, but quota caps reached quickly."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP programme gives bonus points to software specialists earning ¥20M+."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industry 4.0 push needs software, but salaries and visas less attractive."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Software engineers on Tier-1 Green List; smaller market than Canada/Aus."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "Digitisation of public services drives hiring but localisation rules apply."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "National AI Strategy 2.0",
        "reason": "Software engineers powering fintech and AI platforms qualify for COMPASS EP points."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Fintech and AI startups recruit engineers with Golden Visa options."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital and AI specialists listed for skilled-worker fast track post-Brexit."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "CHIPS and Science Act",
        "reason": "Demand for embedded and semiconductor-adjacent software; no special visa but H-1B volume high."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Firms seek embedded software engineers for chip sector, but still emerging."
      }
    }
  },
  "d8379b20-c46b-4f0d-85bf-7f150f9a30a3": {
    "career": "Bioinformatician",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Some state nomination lists cover bioinformatics under medical scientists."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "AI and health-tech streams include bioinformatics, but not top-tier priority."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Genome centres in Heidelberg and Berlin actively sponsor foreign bioinformaticians."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Biotech and med-tech firms require data scientists, including bioinformatics."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "Genome Japan and RIKEN recruit foreign PhDs under HSP fast-track."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "MADANI Economy",
        "reason": "Initiatives in precision medicine are growing but still small-scale."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "List includes ‘medical laboratory scientist’, but bioinformatics remains niche."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "National AI Strategy 2.0",
        "reason": "Biopolis clusters AI with genomics; EP points favour bioinformaticians."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "UAE Centennial 2071",
        "reason": "Genome UAE project hires analysts, but numbers limited."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Wellcome Sanger and Genomics England seek bioinformaticians; Skilled-Worker visa eligible."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds precision medicine and genomic manufacturing, driving bioinformatics hiring."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      }
    }
  },
  "2aa479b6-8d2d-4675-84db-96ff5f3ce1e1": {
    "career": "Business Education Teacher",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Commerce/economics secondary teachers are on CSOL; states sponsor visas for regional schools."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Secondary-school teachers, especially business/computer studies, receive category-based invitations due to nationwide shortages."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Berufsschulen need vocational business teachers; fast-track recognition for foreign qualifications."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Critical Skills List excludes secondary teachers; individual schools recruit directly."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Teaching priority is mainly English and STEM; commerce teachers outside SSW scope."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Secondary teachers incl. business studies appear on Tier-2 list, enabling work-to-residence pathway."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Business teachers can use Skilled-Worker visa but are absent from official shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Teacher shortages focus on STEM and special-ed; business studies has no dedicated federal shortage designation."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "e57da87c-0832-4fcf-bae0-57d1a0868d8b": {
    "career": "Chemical Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Demand exists in mining and water treatment, yet role not on core shortage list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Industrial chemists welcomed but not singled out; fits broader STEM stream."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Chemical industry pivoting to green feedstocks seeks external specialist consultants."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV battery and nickel processing push demand for process chemistry consultants."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Pharma clusters hire some chemists; consultant pathway niche."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points favour advanced materials experts but competition high."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Specialty chemicals identified as a pillar; consultants needed for plant upgrades and ESG audits."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Migrant Category",
        "reason": "Small chemicals sector offers limited slots; case-by-case visas."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "Mega-projects in petrochemicals and mining hire consultants for process optimisation and ESG compliance."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Singapore Green Plan 2030",
        "reason": "Jurong Island shifts to sustainable chemicals; consultant visas possible but not fast-track."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Operation 300bn",
        "reason": "Industrial expansion includes specialty chemicals, but priority leans toward manufacturing engineers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 funds clean-tech, opening advisory roles, yet chemical consultants not on shortage list."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Clean-energy and battery projects need chemical process advice to meet IRA tax-credit thresholds."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "National Master Plan 2021-2030",
        "reason": "Growing petrochem and battery supply chain need technical advice, but not formally prioritised."
      }
    }
  },
  "99abcf06-d0be-47cc-81f3-7be6d9ef2250": {
    "career": "Digital Entrepreneur",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Tech entrepreneur visas exist but caps small after 2021 overhaul."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Startup Visa stream offers PR for founders with angel funding."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Self-employment visas possible; not a strategic shortage role."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "RPJPN 2025-2045",
        "reason": "Digital economy goals exist but visas still bureaucratic."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Start-up Entrepreneur Programme niche and funding threshold high."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Tokyo startup visa limited to accredited wards; Japanese language a hurdle."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "DE Rantau nomad visa helps freelancing but not prioritised in NIMP."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "NZ scrapped dedicated entrepreneur visa in 2022; pathway uncertain."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Vision 2030",
        "reason": "Fintech sandbox and visas attract some founders, but local partnership often mandatory."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "National AI Strategy 2.0",
        "reason": "Tech.Pass and EntrePass give streamlined residency for innovative digital founders."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "We the UAE 2031",
        "reason": "Golden Visa available for founders; free-zone setup in 48 hours."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Innovator Founder visa supports high-growth digital ideas."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds tech hubs and venture grants that indirectly support startup founders."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "78cd2d32-c4ae-4104-97a0-99cbabb56ef2": {
    "career": "Human Biologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Role falls under general life scientist category—competitive but not core shortage."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Biotech researchers eligible under STEM streams but not singled out like doctors/nurses."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Bio-pharma clusters in Bavaria and NRW recruit overseas researchers for clinical pipelines."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Biopharma ambitions exist yet regulatory pathway nascent."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Biotechnologists and biomedical scientists are on list to support pharma manufacturing boom."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP category rewards PhD life-science points; aging society invests in regenerative medicine."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "MADANI Economy",
        "reason": "Biopharma included but semiconductor and aerospace dominate talent focus."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Small research market; positions judged individually."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "NEOM health and biotech projects hire scientists but numbers limited."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Singapore Economy 2030",
        "reason": "Biomed scientists top-tier; A*STAR and pharma MNCs recruit globally with five-year passes."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "UAE Centennial 2071",
        "reason": "Genomics hub in Abu Dhabi growing, yet biologist roles not in fast-track list."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences is named pillar; Global Talent visa streamlined for biomedical researchers."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "CHIPS and Science Act",
        "reason": "Act allocates billions to biotech and bio-manufacturing R&D, boosting researcher demand."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "National Master Plan 2021-2030",
        "reason": "Health biotech priority early-stage; still limited researcher visa allocation."
      }
    }
  },
  "c2a5f82d-8703-4940-96e9-194948bd2a5c": {
    "career": "International Law Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Demand exists in trade and arbitration but visas processed under general professional category."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Lawyers are regulated provincially; no special fast-track for international law."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Qualification recognition for foreign lawyers complex; limited quota roles."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "RPJPN 2025-2045",
        "reason": "Capital relocation drives infrastructure contracts; foreign legal advisors allowed under tight quotas."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Post-Brexit arbitration work growing but no occupation-shortage listing."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Foreign legal consultants licensed under separate system; language barrier high."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Mega-projects require contract and arbitration specialists familiar with global standards."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Economy 2030",
        "reason": "International arbitration hub; Foreign Practitioner Certificate streamlines entry."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "UAE Centennial 2071",
        "reason": "DIFC and ADGM courts use common law; expat consultants in high demand."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London champions cross-border finance; senior lawyers on Global Talent route."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Global firms in New York and D.C. need treaty, trade and sanctions advisors, though not on federal shortage list."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "d329df0b-6794-471b-bd1b-d711844d4ba1": {
    "career": "International Media Specialist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Possible under general IT/creative pathways, but not an explicit shortage."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Creative economy mentioned but not prioritised for foreign hiring; limited slots."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Entertainment and media mega-projects (NEOM, Red Sea) hiring global content experts."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Media roles possible, but not in Singapore’s Tier-1 tech lists; EP points system neutral."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai Media City & Abu Dhabi creative clusters aggressively recruit international media talent."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry is a named pillar; creative visas fast-track senior media specialists."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Large media labour market but no dedicated immigration priority for journalists or media strategists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "d5c05e40-fa15-46d8-8395-a9ed543ed8d3": {
    "career": "Social Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Academic researchers fall under Higher Education nominations though not on CSOL."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities and think-tanks can sponsor under research talent stream."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Highly-qualified researchers in demand; eased residence permits for academics."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "RPJPN 2025-2045",
        "reason": "Need for social policy evaluation as government scales welfare programs."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Universities can sponsor Critical Skills visas for PhD-level social scientists."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points system rewards PhDs even in social science."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Some university hiring, but no shortage listing."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Social research roles linked to tourism and social reform projects."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "National AI Strategy 2.0",
        "reason": "Behavioural scientists integrated into AI ethics and governance teams."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "UAE Centennial 2071",
        "reason": "Research universities in Abu Dhabi/Dubai hire social scientists for policy work."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Research councils fund behavioural science for policy and fintech ethics."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act boosts fundamental research funding, including behavioural and social sciences."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      }
    }
  },
  "6a6b10c0-475c-4b98-a586-e56e24c11bae": {
    "career": "Sociology of Law Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Universities can sponsor academic visas even if occupation not on CSOL."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Canadian universities recruit socio-legal scholars for Indigenous justice and AI governance."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Research institutes value socio-legal expertise for integration and digital privacy law."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "RPJPN 2025-2045",
        "reason": "Governance reforms create some demand for legal sociologists."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Niche demand in data-protection research centres."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "University law faculties can sponsor; not a national priority."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Reforms need comparative legal researchers, but hiring remains limited."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "National AI Strategy 2.0",
        "reason": "AI governance research requires scholars bridging law, tech and society."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "UAE Centennial 2071",
        "reason": "Free-zone universities study fintech regulation and Islamic finance law."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Socio-legal research supports tech-policy and human-rights components."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds interdisciplinary law & society research on tech regulation and ethics."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "60f45c59-a5e2-40f6-860b-e69fb33142aa": {
    "career": "Theatre Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Academic stream possible, yet not on occupation list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "SSHRC funds theatre studies, but not an immigration priority."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Germany’s rich theatre tradition funds research fellowships in dramaturgy."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Government funds cultural heritage projects needing theatre historians."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Some demand via Irish theatre heritage research, but not critical."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Kabuki and Noh research institutes can sponsor, yet numbers are small."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Growing entertainment sector may commission heritage theatre studies."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Arts House and Esplanade hire researchers, but role not in top talent lists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Cultural districts like Abu Dhabi’s Saadiyat need curators and researchers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry pillar supports theatre scholarship within top conservatoires."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "",
        "reason": "NEA and university grants support performing-arts scholarship; O-1 visas available."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "66eabcee-3cdf-4259-bb23-2681e9ffec9f": {
    "career": "Archivist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Library and Archives Canada occasionally uses Express Entry for specialised archivists."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Cultural heritage institutions can sponsor under shortage of information specialists."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "National digitisation push for colonial archives could open roles."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "",
        "reason": "National Archives of Ireland recruits niche digital archivists under Critical Skills permit."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Megamuseum projects need digitisation experts for heritage exhibits."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "National Archives seeks specialists, but role outside Tier-1 lists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Louvre Abu Dhabi and national archives hire international preservation talent."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "",
        "reason": "British Library and BFI sponsor specialist archivists; shortage of digital preservation skills."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "National Archives and digital preservation projects hire overseas specialists under H-1B cap-exempt institutions."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "f3a71a75-894f-4b08-92c5-99a340b3ec40": {
    "career": "ESL Support Educator",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Migration Strategy 2023",
        "reason": "Teacher shortages drive state visa sponsorships even though ESL is outside STEM focus."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Secondary teachers and French/English-language specialists are priority occupations for provincial nominations and category draws."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Federal states recruit foreign teachers to support migrant integration in secondary schools."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Critical Skills List covers STEM teachers only; ESL jobs possible via general work permit."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Conversational English instructors are common but hired on basic instructor visas, not high-skill programs."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Migrant Category",
        "reason": "Chronic teacher gaps; English-language support often bundled with literacy teaching roles eligible for visas."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "MOE prefers local teachers; role not in National AI Strategy or Manufacturing 2030 talent targets."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Private schools hire expatriate ESL teachers but role not on Operation 300bn or other priority lists."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Teacher visas focus on maths & science; EAL specialists must qualify through general teacher route with lower success rates."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Schools hire ESL aides for immigrant students, but K-12 roles are not on any federal talent list."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "",
        "reason": "Private language centres recruit foreigners but outside semiconductor/tech priority lists."
      }
    }
  },
  "a79f502f-38e4-4fe0-b5e5-ad2f72d4d9d2": {
    "career": "Legal Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Legal services absent from Core Skills Occupation List; employer-sponsored visas possible for niche expertise."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "No priority pathway; consultants compete under general NAICS professional category."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Points-based system may accept senior legal advisors, but not a headline shortage."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel/EV projects hire contract advisors, yet quotas low."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Financial-services legal experts qualify under consulting and compliance headings."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Cross-border deal lawyers needed for semiconductor investments but not on NIMP talent list."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Mega-projects drive need for contract specialists, yet Saudisation keeps numbers small."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "National AI Strategy 2.0",
        "reason": "AI-governance and fintech regulation drive demand for cross-border legal advisors."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "We the UAE 2031",
        "reason": "Dubai & Abu Dhabi free zones court international legal talent for fintech and arbitration hubs."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Senior legal and consulting professionals explicitly prioritised for Skilled Worker visas."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Complex clean-energy deals create advisory demand, but role not explicitly listed in visa priorities."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "82d2e83c-dc57-4a6b-b7dd-ce07910d9b89": {
    "career": "Apparel Designer",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Domestic brands expanding; visas issued ad-hoc, not in national priority."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "",
        "reason": "Tokyo fashion scene hires foreigners under general artist visa, outside talent lists."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Entertainment & lifestyle push niche demand for fashion creatives."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai Design District offers visas for fashion talent to boost creative economy."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries list prioritises film & gaming; fashion eligible but not highlighted."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Large fashion market, but role not included in federal talent policies."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Growing garment exports create limited openings for designers with tech-pack skills."
      }
    }
  },
  "a1c57c38-e38c-4a6d-9e31-05496c6f1f4b": {
    "career": "Fashion Merchandiser",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Growing middle class fuels fashion retail, but not on talent list."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "",
        "reason": "International retailers in Tokyo hire foreign merchandisers, outside priority programs."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Luxury retail expansion at NEOM and Riyadh malls creates limited demand for experienced merchandisers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Regional buying offices hire merchandisers, still outside Tier-1 tech focus."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai retail hub recruits global merchandisers to curate trend-driven assortments."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Creative industry list skews to digital & media; retail merchandisers apply via general route."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Large retail sector offers H-1B sponsor chances, but not a listed talent priority."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Fast-fashion sourcing offices need merchandisers fluent in English and supply-chain tech."
      }
    }
  },
  "e5ac67dd-0c5b-4b84-9286-c9c53da6e30e": {
    "career": "Professional Communicator",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "New capital city push needs communicators, but no priority visas."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Global firms need English-speaking PR staff; visas through general humanities category."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Mega-projects hire global PR experts to shape international image."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Communications roles available, yet outside National AI Strategy talent focus."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai’s media-city free zones court senior communicators for fintech, tourism and space programmes."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry priority includes media and content roles, easing visa paths for experienced communicators."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Role not on federal priority lists, but strong market demand in tech and entertainment."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Foreign PR advisors hired by tech start-ups raising global capital."
      }
    }
  },
  "18ce61eb-0eb7-4ee9-9b65-0ec2f75a2b72": {
    "career": "Sports Marketing Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Migration Strategy 2023",
        "reason": "Visa pathways exist, but marketing is excluded from Core Skills Occupation List."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Creative and marketing occupations can enter via general Express Entry, yet are not on any priority list."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Creative marketing roles qualify under general skilled visa, though not actively courted."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Vision 2030",
        "reason": "Massive investment in sports events (NEOM, LIV Golf) puts senior sports marketing on the priority hiring list."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi bid for global tournaments; agencies seek experienced marketers for sponsorship and fan engagement."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry leadership is listed, giving partial alignment for senior sports marketing specialists."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Large-scale venue upgrades create some demand for experienced sports marketers, but the role is not a federal talent priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "f88e79b4-447e-4303-bbdb-7305e469cee5": {
    "career": "Sustainable Energy Developer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL lists renewable-energy and electrical engineers to support large solar and green-hydrogen builds."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Clean-tech and battery supply-chain incentives create solid—but secondary—demand for renewable-energy developers."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Energiewende intensifies need for solar, wind and grid-integration specialists; fast-track visas offered."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Push for geothermal and solar as coal transitions stimulate recruitment of renewable engineers."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Onshore/offshore wind engineers listed on Critical Skills permit."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "Government promotes offshore wind and hydrogen; HSP points favor renewable engineers."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan emphasises renewable energy and EV supply chain, attracting foreign clean-energy talent."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Renewable-energy engineers are on the Green List with direct-to-residence pathways."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Gigawatt-scale solar and wind projects (NEOM, Red Sea) urgently recruit sustainable-energy developers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Green Plan 2030",
        "reason": "Imports most of its power but invests heavily in regional solar and carbon-management projects needing technical leads."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Operation 300bn",
        "reason": "Masdar and other entities aggressively hire for utility-scale PV and offshore wind."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Offshore wind, CCUS and hydrogen projects receive priority immigration support."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA pours $369 B into renewables, driving huge demand for engineers who can deliver solar, wind and storage projects."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "National Master Plan 2021-2030",
        "reason": "Country targets 18 GW offshore wind by 2030, needing project developers."
      }
    }
  },
  "ac78e2c3-ee15-4007-b966-77eeea092eac": {
    "career": "Child Advocate",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Community-and-disability services face shortages, giving moderate pathways for qualified advocates."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Social-worker shortages allow extra CRS points; legal child advocacy still possible via provincial nomination."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Youth-welfare social workers qualify, but language and licensing hurdles are high."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Social work absent from Critical Skills; general employment permit still possible."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Skilled Migrant Category",
        "reason": "Oranga Tamariki hires social workers; not on Green List so standard points apply."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Solicitors and social workers can obtain Skilled Worker visas, but not a shortage occupation post-2025."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "General visa routes exist; no child-advocacy priority but social-impact lawyers are employable."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "23717a4e-1fdd-4965-8cff-2ca840e8f777": {
    "career": "Emergency Cybersecurity Manager",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "Migration Strategy 2023",
        "reason": "Cybersecurity specialists named on Core Skills Occupation List with priority visas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Dedicated tech-talent stream fast-tracks cybersecurity managers."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT-Security shortage recognised; Blue Card simplified."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Digital-banking expansion raises demand, but visa processes less streamlined."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Cyber-security specialists on Critical Skills list with fast permit."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points favour cyber experts; language still a hurdle."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industry 4.0 roll-out highlights urgent cybersecurity needs."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Migrant Category",
        "reason": "Security architects qualify for high points, but not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Vision 2030",
        "reason": "Massive digital-government push demands rapid-response cyber teams."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "National AI Strategy 2.0",
        "reason": "Cybersecurity talent identified as core to AI and finance ecosystems."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "UAE Centennial 2071",
        "reason": "Fintech and smart-city initiatives require 24/7 incident-response leadership."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Cybersecurity is explicitly cited; shortage list eases Skilled Worker visas."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Federal cyber-resilience funding and semiconductor security provisions create top-tier demand for incident-response leaders."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Government drives semiconductor cyber-protection, requiring incident managers."
      }
    }
  },
  "380baae7-fb86-417a-a496-43ecf9034ecf": {
    "career": "Health Program Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Hospital managers and health-service leaders listed in state nominations."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Healthcare administration qualifies under French-speaking and health-occupation streams."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Health administrators can secure visas but face language and licensing demands."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Health-service managers not on Critical Skills list; general permit possible."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Private hospitals hire managers, but no special immigration facilitation."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "District Health Boards recruit managers, yet role not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Vision 2030",
        "reason": "Mega-hospital projects urgently hire foreign health program managers to modernise systems."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Singapore Green Plan 2030",
        "reason": "Smart-hospital and ageing-population programs create demand for skilled project managers."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "We the UAE 2031",
        "reason": "Dubai Health Strategy seeks experienced managers for AI-enabled hospital programs."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "NHS hires managers but role lacks shortage-list status after 2025."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Public-health managers needed for infrastructure projects, but not an explicit immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "8024575a-f7a6-4f4c-a944-c597266b3e61": {
    "career": "Sustainability Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Migration Strategy 2023",
        "reason": "Net-zero push in resources and construction needs ESG professionals, yet role not explicitly on Core Skills list."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Environment sector points and ESG hiring in mining, forestry and finance create steady but secondary demand."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Energiewende and mandatory CSRD reporting force companies to hire sustainability leads; visa pathways available for STEM/management talent."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel/EV supply-chain firms discuss ESG, but expatriate quota rules temper direct hiring."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "ESG pressure in tech/pharma clusters, but occupation not on critical list—mid-level opportunity only."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Decarbonisation road-maps create some demand, yet firms prefer internal engineers over external ESG managers."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan emphasises green manufacturing but hiring focuses on engineers; standalone sustainability manager roles limited."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Climate-adaptation projects create some need, but role not singled out on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Vision 2030",
        "reason": "Giga-projects (NEOM, Red Sea) require sustainability governance, giving strong but still emerging demand."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Singapore Green Plan 2030",
        "reason": "Sustainable-finance hub status grows ESG roles, yet foreign-talent framework keeps numbers modest."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "We the UAE 2031",
        "reason": "Mandatory ESG reporting on ADX/DIFC and COP28 legacy spur hiring, although many firms import consultants not full-time leads."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 backs offshore wind, hydrogen and mandatory TCFD reporting, making sustainability managers core hires across listed companies."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA’s billions for clean-energy plants and corporate decarbonisation budgets sharply boost demand for in-house sustainability managers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "National Master Plan 2021-2030",
        "reason": "Foreign-owned factories need ESG compliance, yet visa routes not tailored to management specialists."
      }
    }
  },
  "4a551293-c079-4ade-9afa-ffc497bdd5d9": {
    "career": "Area Studies Professor",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Migration Strategy 2023",
        "reason": "Asia-Pacific diplomacy focus funds Asia-studies chairs but overall quotas remain limited."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities granted streamlined hiring for specialised faculty to retain international students."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Funding for Indo-Pacific strategy spurs demand for scholars; Opportunity Card eases hiring of non-EU academics."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "RPJPN 2025-2045",
        "reason": "Humanities recruitment budget constrained; preference for citizens."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Humanities not on critical list; a handful of roles exist in Dublin."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "Some English-language universities seek non-Japanese Asianists for global programs."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "MADANI Economy",
        "reason": "Government focuses on STEM; humanities hiring minimal."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Small but stable need in universities teaching Asian languages and history."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Vision 2030",
        "reason": "New universities recruit some cultural studies faculty, yet localisation focus limits slots."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "National AI Strategy 2.0",
        "reason": "NUS and NTU world-class in Asian studies, yet hiring highly competitive and limited."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "UAE Centennial 2071",
        "reason": "Branch campuses hire humanities PhDs mainly on contract; policy does not prioritise field."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "China strategy funds more Asian-studies posts, but STEM still dominates visa allocations."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "CHIPS and Science Act",
        "reason": "US universities expand Asian-policy centres to address supply-chain and security questions linked to Act."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Few openings—local scholars preferred for Vietnamese studies, not broader Asian focus."
      }
    }
  },
  "bc3df75c-0a7d-43a5-adcd-fc9825eb0344": {
    "career": "Clinical Educator",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Dentists on CSOL; universities get streamlined visas for clinician educators."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Severe dentist shortage; teaching dentists receive priority healthcare points."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Aging population boosts oral-health demand; dental faculties recruit foreign educators."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Few accredited dental schools; preference for Indonesian faculty."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Dentists on list, yet only two dental schools limit openings."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Language barrier restricts foreign clinical educators."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Private colleges hire some expats; public sector prefers locals."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Dentists on Tier 1 list; academic posts benefit indirectly."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Private universities hire expatriate dental educators, but localisation policy limits numbers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Singapore Economy 2030",
        "reason": "NUS dental faculty world-class but openings rare; high competition."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "UAE Centennial 2071",
        "reason": "Medical universities in Dubai/Sharjah attract foreign dental faculty, though on short contracts."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Clinical dentistry vacancies allow visa sponsorship, but teaching funding tight."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "CHIPS and Science Act",
        "reason": "Not directly linked, but dental schools recruit international faculty under academic visas."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "National Master Plan 2021-2030",
        "reason": "Growing dental market but educator roles still limited."
      }
    }
  },
  "c7b64fb7-e0ee-4bc3-83d9-3a3423c38ed9": {
    "career": "Compliance Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Migration Strategy 2023",
        "reason": "Fintech regulation growth creates moderate need; not on CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Banks hire, but role not singled out for immigration priority."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "EU MiFID and ESG rules raise demand for English-speaking compliance professionals."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech boom needs compliance, but visa barriers remain."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Dublin’s fintech hub and EU HQs list regulatory compliance on critical-skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Foreign banks in Tokyo hire bilingually, but roles few."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "MADANI Economy",
        "reason": "Islamic finance growth adds some roles, yet locals preferred."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Migrant Category",
        "reason": "Limited finance sector size caps openings."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "Fintech and capital-market liberalisation create opportunities, though localisation policy applies."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Singapore Economy 2030",
        "reason": "MAS regulations keep demand high, but talent bar steep."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "DIFC/ADGM expansion and global AML rules make compliance officers critical hires with golden-visa eligibility."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City’s post-Brexit regulatory load drives acute need for compliance talent; firms sponsor visas aggressively."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA’s tax-credit rules fuel demand for compliance staff in energy and finance."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Strategy focuses on engineering; compliance roles peripheral."
      }
    }
  },
  "7ef719d1-4199-4c5c-b20d-43c2fd748044": {
    "career": "Criminal Justice Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Migration Strategy 2023",
        "reason": "States hire crime statisticians for justice reforms, yet not on core skills list."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Provinces seek data analysts in public safety but no dedicated stream."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Language requirements limit foreign analysts in police agencies."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "RPJPN 2025-2045",
        "reason": "Police modernisation underway, but analyst roles for foreigners rare."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Role not on list; occasional openings in CSO and Garda."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Language and security clearances hinder foreign analyst hiring."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "MADANI Economy",
        "reason": "Positions exist but largely restricted to citizens."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Some roles inside Ministry of Justice, but numbers small."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Vision 2030",
        "reason": "Public-security modernisation ongoing, yet nationals prioritised."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National AI Strategy 2.0",
        "reason": "GovTech crime-analytics teams hire some foreigners, though locals preferred."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Smart policing initiatives open limited analyst contracts for expats."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Data-driven policing and probation reforms drive modest demand in Home Office and consultancies."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA funds smart-city crime data projects, increasing analyst roles in agencies and consultancies."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Security roles prioritise nationals over expats."
      }
    }
  },
  "acfa61bf-a6f8-48ff-af9f-ad1ff96c7b88": {
    "career": "Field Archaeologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "State heritage laws drive need for archaeologists on rail, mining and renewable projects, but not a national priority occupation."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Large infrastructure and mining projects require heritage impact assessments; provinces add archaeologists to shortages intermittently."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Migrant Category",
        "reason": "Accident-prone infrastructure expansion requires pre-build archaeological surveys; limited but persistent openings."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Mega-tourism sites like AlUla hire archaeologists for heritage tourism, yet roles are niche and project-based."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Rail/road expansions trigger legally mandated archaeological work; chronic field-staff shortages."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Highway and energy projects must complete cultural-resource surveys, creating steady CRM archaeology demand."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "e4f7087e-7ad4-4dbd-8bf1-a1ac7f974120": {
    "career": "Māori Language Teacher",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "15",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "18",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "12",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Skilled Migrant Category",
        "reason": "National strategy to revitalise Te Reo Māori places certified teachers on shortage lists."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "12",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "22",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      }
    }
  },
  "76e51045-bff0-46f4-99a9-c987332a55cd": {
    "career": "Secondary & Religious Education Teacher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Secondary teachers appear on CSOL; regional visas sponsored especially for humanities."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Some provinces list secondary teachers, yet preference is for STEM and francophone educators."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "States face teacher shortages, though priority is STEM; visa still possible."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 2)",
        "reason": "Secondary teachers including religious studies are on Green List Tier 2 when registered."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Private international schools recruit expatriate teachers, but no formal shortage designation."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Shortage list now excludes non-STEM teachers; visas still possible with sponsorship."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Teacher shortages exist, but immigration policies do not fast-track humanities educators."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "32cb245f-5b86-4484-8ac8-b870c35ab531": {
    "career": "Systems Developer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Software developers listed as ‘priority’ with streamlined visas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Dedicated tech draws and fast PR for software engineers."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Accelerated Blue Card for IT specialists even without degree if skilled."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "59",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech and e-commerce growth creates demand though visas less streamlined."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Software developers get Critical Skills permit with path to PR in 2 years."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points favour software and AI engineers for five-year renewable visas."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "MADANI Economy",
        "reason": "NIMP 2030 promotes Industry 4.0 requiring embedded and systems devs."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Software engineer is explicitly Green List Tier 1 but small market limits volume."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "Digital government and mega-projects seek developers, yet experience requirements high."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "National AI Strategy 2.0",
        "reason": "COMPASS and Tech.Pass welcome experienced developers in AI and fintech."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai and Abu Dhabi free zones sponsor tech talent with Golden Visas."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital and AI specialists on fast-track visas, especially for fintech and gaming."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Massive incentives for advanced computing and software talent feeding semiconductor and AI sectors."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "National Master Plan 2021-2030",
        "reason": "Semiconductor and e-commerce strategies need backend developers."
      }
    }
  },
  "afa13d32-570a-4213-9719-44c3af7f9e8a": {
    "career": "Corporate Finance Analyst",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Finance analysts can qualify but tech and healthcare dominate draws."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech growth creates analyst demand though immigration formalities tougher."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Financial services quants and analysts appear on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "HSP visa focuses on tech and R&D; finance less prioritised."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Islamic finance a strategic pillar, but roles favour local grads."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Diversification push fuels hiring in corporate finance and investment banking."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Singapore Green Plan 2030",
        "reason": "Sustainable finance professionals included in talent drive; analysts with ESG focus welcomed."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai International Financial Centre actively sponsors corporate finance talent."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London financial services is a designated priority under IS-8."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Clean-energy firms need analysts for capital structuring but role is not immigration-priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a54f132f-5e94-46eb-b69e-e715c1618abd": {
    "career": "Microelectronics Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Electrical/electronics engineers on CSOL, yet no dedicated semiconductor initiative."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Falls under broader electrical/software engineering which earns extra CRS points but is not named as a headline shortage."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Electrical/electronic and semiconductor firms (Infineon, Bosch) lobby for easier visas; Opportunity Card awards bonus for this profile."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Plans to move up EV value-chain to chip packaging; skills still emerging."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Electronics hardware engineers qualify, but IDA focus leans software/cloud over silicon."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Highly Skilled Professional visa",
        "reason": "TSMC-Sony Kumamoto fab and Rapidus drive national race to revive semiconductor sector."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Penang’s ‘Silicon Island’ expansion makes IC design & packaging engineers top-priority hires."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Electronics engineers accepted, but no semiconductor cluster so demand moderate."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Advanced manufacturing parks (NEOM, KAEC) seek electronics talent, yet focus is more on renewable and construction."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Manufacturing 2030",
        "reason": "Micron, GlobalFoundries and STMicro fab expansions keep semiconductor engineers on EDB’s priority-pass list."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Operation 300bn",
        "reason": "Abu Dhabi’s semiconductor foundry GlobalFoundries drives mid-scale demand for chip engineers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 explicitly lists semiconductor specialists; Cambridge and South Wales fabs expanding."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Huge subsidies for domestic semiconductor design/fabrication; straight match for chip-process, design-verification and packaging engineers."
      },
      "vietnam": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Aims to train/attract 50,000 chip engineers by 2030 for Intel, Amkor, Synopsys hubs."
      }
    }
  },
  "cea3ef79-c42a-4fe5-96e2-d494ed40dac0": {
    "career": "Writer",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Express Entry Category-Based Selection",
        "reason": "French-speaking journalists/authors get points; otherwise generic."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Freelance artists can apply under ‘Künstler’ self-employment track, but limited quotas."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "N/A",
        "reason": "Tax exemptions for literary income attract authors, but visa still standard."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "National AI Strategy 2.0",
        "reason": "Creative Pass supports high-earning authors; still niche."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Dubai Creative Zone grants freelance permits to authors, but not priority."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry visas include established writers; London publishing hub."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "N/A",
        "reason": "No immigration priority, but O-1 visas exist for ‘extraordinary’ creatives."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b49e2bf3-9158-4b7c-ba15-c87d6757c4da": {
    "career": "Arts Entrepreneur",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Berlin supports creative startups, yet still general visa process."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Large cultural districts (AlUla, Diriyah) recruit curators and gallery operators."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Singapore Economy 2030",
        "reason": "New ‘EntrePass’ allows creative-industry founders with funding, but seats are few."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "Dubai Culture’s ‘Creatives in the City’ long-term visa aids art-business founders."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry visas cover gallery and digital-arts startups."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "N/A",
        "reason": "Possible under E-2 investor visa but no shortage priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "21ce0e57-6682-48f1-bf10-e35941d65601": {
    "career": "Early Ed Coach",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Early-childhood teacher trainers listed; regional visas fast-track."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Early-childhood educators specifically prioritized; coaching roles qualify under NOC 42202."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe Kita teacher shortages; pedagogical coaches welcomed, but German language mandatory."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "N/A",
        "reason": "Childcare staffing shortages exist, but role not on Critical Skills list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Early-childhood teachers on Tier 1 list; coaching accepted as senior pathway."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "N/A",
        "reason": "Early-ed coaches need local MOE approval; few foreign passes granted."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Private nursery chains hire curriculum coaches, though not nationally prioritized."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "N/A",
        "reason": "Early childhood roles exist but not a shortage occupation for visas."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "e4d449f2-0ea0-4558-ac48-57f8e31f170b": {
    "career": "Fashion Brand Manager",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Luxury retail growth in Riyadh seeks brand managers, but quotas remain limited."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "N/A",
        "reason": "Global luxury HQs in Singapore sponsor passes for senior brand managers, yet not strategic priority."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s fashion hub, tax-free salaries, and Creative Zone visas favor experienced brand managers."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "High-end creative industries (London Fashion Week) create some sponsorships, though not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "N/A",
        "reason": "Fashion marketing roles exist but not immigration-priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "55f1be1a-414e-475e-b8cf-9f179592c23f": {
    "career": "Financial Economist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "No shortage listing for economists; possible employer-sponsored visas in finance hubs like Sydney."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Express Entry prefers STEM and healthcare; economists invited only via general points route."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Economists qualify through points but are not on high-priority shortage lists."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Sovereign fund and nickel finance create some openings but not on shortage list."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List includes financial services quants; Central Bank and funds industry recruit economists."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Demand for macro-economists in sovereign wealth fund and PIF projects but not formal visa priority."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Economy 2030",
        "reason": "Singapore aims to be Asia’s sustainable-finance hub; MAS courts economists for policy and risk analytics."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi financial centres court economists for fintech and capital-market regulation."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London targets quantitative economists for financial-services competitiveness and post-Brexit policy design."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Finance skills valued in green-energy and infrastructure bond markets but not directly listed on priority visas."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "9bf6698f-1d2a-4983-9d88-f96a5724fdde": {
    "career": "Logistics Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Some roles under construction PM but logistics management not explicitly listed."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Transport occupations targeted; managers qualify if experience in trucking or warehousing."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Germany’s export economy faces acute warehouse & transport talent shortages."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "69",
        "policy": "RPJPN 2025-2045",
        "reason": "Nusantara capital build-out requires sophisticated supply-chain coordination."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Critical Skills list omits logistics managers; possible under general employment permit."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "SSW covers ground crew and drivers; managers must use general work visa."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "MADANI Economy",
        "reason": "Klang Port expansion and e-commerce growth fueling demand for supply-chain leadership."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Migrant Category",
        "reason": "Logistics skills earn points but are not on the fast-track Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Mega-projects like NEOM need end-to-end logistics leadership across desert supply chains."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Singapore Economy 2030",
        "reason": "Smart logistics important but MOM hasn’t placed managers on top shortage list."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai aims to stay global trade hub; free-zones actively recruit logistics managers."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Temporary list covers HGV drivers, not managerial logistics roles."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Massive port, rail and warehouse upgrades spur demand for supply-chain managers."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "National Master Plan 2021-2030",
        "reason": "Manufacturing boom and new deep-sea ports prioritise logistics optimisation talent."
      }
    }
  },
  "906edeb7-1d86-46b2-9a4a-68986ef6e8a6": {
    "career": "Media Production Musician",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Entertainment visas exist but not priority; case-by-case sponsorship."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "No shortage list; artists use Global Talent Stream only if very high profile."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Berlin’s media scene attracts freelancers but not on shortage lists."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Growing streaming market but no formal talent pathway."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Screen Ireland funds some scoring work but no special visa priority."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "Anime and gaming soundtracks create demand; applicants need points but role aligns with creative sectors."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Kingdom funds film and gaming music for entertainment mega-projects."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Singapore Economy 2030",
        "reason": "MediaCorp and gaming studios recruit composers; not top-tier but supported by creative-industry grants."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "UAE Centennial 2071",
        "reason": "Abu Dhabi and Dubai free-zones court media composers for streaming and gaming studios."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "UK’s creative-industry strand prizes film, TV and gaming composers; Global Talent visa fast-tracks them."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "CHIPS and Science Act",
        "reason": "No direct link; however O-1 visas available for exceptional creative talent in Hollywood."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "46c03003-f0b8-4316-9d05-a414cfcc4f57": {
    "career": "Process Optimizer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "List emphasises mining and construction engineers; process optimisation roles possible but indirect."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Manufacturing modernisation and clean-tech plants require process engineers."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Automotive and machinery giants seek Lean experts to stay competitive."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel and EV battery plants welcome lean experts but visas not streamlined."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List covers manufacturing engineers, which can include process optimisation."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-factory upgrades favor optimisation specialists, especially in robotics plants."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Semiconductor and EV plants urgently need yield-improvement engineers."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Some demand in food-processing plants but not green-list priority."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "New manufacturing clusters and giga-projects need productivity specialists."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Manufacturing 2030",
        "reason": "Precision-engineering sector prizes continuous-improvement leaders to hit high-mix low-volume targets."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Operation 300bn",
        "reason": "Industrial strategy wants advanced manufacturing experts to localise production."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "73",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean-energy and aerospace supply chains depend on continuous-improvement professionals."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Advanced fabs need industrial engineers to squeeze yields and uptime."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Wafer-packaging growth fuels demand for process improvement talent."
      }
    }
  },
  "f6ff117f-4fd0-4093-a256-d57a460df47a": {
    "career": "Public Accountant",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Accountants remain on medium-term skills list allowing four-year visas and PR pathway."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "French-speaking and provincial nominee streams often seek CPAs for SMEs."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Foreign auditors need German language and re-credentialing, lowering attractiveness."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List explicitly cites accountants and auditors for multinational financial HQs."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Migrant Category",
        "reason": "CA and auditors earn high points though not green-list fast track."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "IFRS transition creates demand but localisation policies limit expatriate share."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Singapore Economy 2030",
        "reason": "Regional HQs need IFRS and tax experts; Employment Pass obtainable for CPAs."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "We the UAE 2031",
        "reason": "DIFC firms need IFRS and tax-ready CPAs; Golden Visa available for certified professionals."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Senior accounting is on shortage list; Big-4 aggressively sponsor skilled auditors."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "CPA roles plentiful but not immigration-priority; H-1B lottery applies."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Need exists in FDI firms but no special immigration priority."
      }
    }
  },
  "e68c8cd0-674e-4566-8f39-29aca8ea5174": {
    "career": "Speech-Language Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Speech pathologists & related researchers sit on state CSOLs because of paediatric wait-lists."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Allied-health researchers including speech pathology receive priority points and fast PR."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Act welcomes academic health scientists but demand is moderate and German-language heavy."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Speech & language therapists are listed; PhD scientists fast-track to Stamp 4 residency."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points for PhD researchers but Japanese-language clinic requirement limits uptake."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Speech-language therapists on Tier-1 list; research PhDs route to Straight-to-Residence visa."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "NHS shortage in speech therapy underpins visas, though pure research funding is competitive."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "CHIPS and Science Act",
        "reason": "NIH-funded labs value speech-disorder research but no dedicated immigration incentives."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "5d7cf0a4-de20-43a2-9c34-842cdc3fe0ca": {
    "career": "Actuarial Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Demand exists in superannuation but actuaries are not on the core skills list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Financial analysts included broadly; actuaries can qualify via points but not singled out."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Open to STEM finance talent, yet German regulation and language narrow roles."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "RPJPN 2025-2045",
        "reason": "Pension reform will need actuaries but localisation rules limit expats."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Reinsurance hub in Dublin lists actuarial & quantitative risk as critical skills."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "National AI Strategy 2.0",
        "reason": "MAS pushes InsurTech and sustainable finance risk, keeping actuaries on high-demand lists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "UAE Centennial 2071",
        "reason": "DIFC insurers and reinsurers aggressively poach credentialed actuaries for Solvency II work."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City insurers view actuaries as strategic talent; fast-track Skilled Worker visas common."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Insurance carriers scaling climate-risk units; no formal visa priority but market huge."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "c44d8388-eba4-43cf-8372-0f6991439f52": {
    "career": "Biomechanical Design Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Emerging medical-device startups and ageing-care market need biomech engineers."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Med-tech clusters in Ontario and BC recruit engineers under STEM fast-track."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Orthopaedic implant manufacturers face engineer shortages; easier Blue Card rules apply."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Healthcare equipment localisation rising but engineering roles still limited."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Galway–Limerick med-device corridor lists biomedical design engineers as critical."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "Ageing society fuels robotics prosthetics; HSP points favour engineering PhDs."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan spotlights medical devices but focuses on manufacturing, not R&D."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Small but growing biomedical sector offers limited slots."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Vision 2030",
        "reason": "Rehab megaprojects and sports medicine drive demand, but localisation preference."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Economy 2030",
        "reason": "Biomedical manufacturing hub actively grants EPs to device design specialists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Operation 300bn",
        "reason": "Health-tech manufacturing incentives exist yet volumes remain modest."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences pillar funds prosthetics, exoskeleton R&D; visas available."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA & NIH pour billions into med-device R&D, especially mobility and prosthetics."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Innovation policies lean toward electronics rather than med-device design."
      }
    }
  },
  "1bd0f9b5-52c6-4a49-9ca7-4d1ac092bd8b": {
    "career": "Botanical Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Migration Strategy 2023",
        "reason": "Land-rehab mandates after mining spur demand for botanists in environmental impact teams."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Agri-scientists and environmental consultants receive extra CRS points."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Green hydrogen projects include ecological assessments; Blue Card possible for botanists."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "RPJPN 2025-2045",
        "reason": "Food-security and rainforest restoration make plant-science consultants desirable."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Agri-scientists and conservation biologists sit on Tier-1; direct path to residency."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Vision 2030",
        "reason": "Mega-projects like NEOM need landscape ecology, though desert greening is niche."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Urban greening and mangrove restoration hire consultants, but no formal priority."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Ecologists sometimes qualify under environmental scientist codes; competition is high."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Native-plant restoration in federal projects creates consulting gigs but no visa boost."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "National Master Plan 2021-2030",
        "reason": "Agri-tech push and reforestation budgets open roles for overseas botanists."
      }
    }
  },
  "b9344a7b-0393-4d16-bbe9-64869e2b9020": {
    "career": "Design Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Creative visas exist yet competitive points ranking keeps scores modest."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Creative workers welcomed but no dedicated stream."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Industrial Mittelstand values UX for machinery; English-language roles growing."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List focuses on ICT engineering rather than design research."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Consumer-electronics giants value English UX, but Japanese language often required."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "NIMP 2030",
        "reason": "Manufacturing 4.0 emphasises engineering more than user research."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Giga-projects need service-design experts but localisation target tempers demand."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Singapore Economy 2030",
        "reason": "Fintech and med-tech firms seek researchers for APAC markets, though role not on critical list."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai’s media and fintech hubs hire senior design researchers for regional products."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industries pillar highlights user-experience research for gaming and film tech."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "CHIPS and Science Act",
        "reason": "Hardware firms need UX insights for new consumer devices, but not an official shortage."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "0c61f2a0-2c56-47ac-b78e-26ac10f53573": {
    "career": "Educational Technologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Digital education supports regional schools, but Educational Technologists are outside the Core Skills Occupation List."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "EdTech falls under general digital skills welcomed by Express Entry, yet it is not a priority occupation."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Digital-learning specialists can qualify through generic IT channels; no direct shortage listing."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EdTech helps close skills gaps for 270 M people, yet visas favour engineers over educators."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Generic software roles are listed, but pure instructional-design technologists are not."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Applicants can enter under broad IT categories; EdTech is not a named priority."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Digitalisation of education supported, yet semiconductor and advanced-manufacturing talent outrank EdTech in visa queues."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Skilled Migrant Category",
        "reason": "Schools adopt hybrid teaching, but the Green List does not name EdTech roles."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Massive e-learning spend for upskilling citizens opens consulting opportunities, albeit alongside heavy localisation push."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "National AI Strategy 2.0",
        "reason": "EdTech startups receive AI grants, but the occupation itself is not on the Tier-1 shortage list."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "We the UAE 2031",
        "reason": "Smart-learning is core to national human-capital goals, so EdTech specialists obtain Golden Visas with relative ease."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital-creative sector values EdTech expertise, yet it is not on the official Shortage List."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Federal broadband roll-outs and digital equity funds drive demand for experts who turn connectivity into classroom learning outcomes, but role is not a named shortage."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Government pilots e-learning, but manpower focus is on semiconductor and infrastructure engineers."
      }
    }
  },
  "618a74b3-e4cd-42ff-915d-8ba831855512": {
    "career": "Fisheries Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL covers aquaculture managers but not advisory consultants; some regional visas available."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Atlantic provinces welcome marine scientists under agri-food and resource streams."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Government targets sustainable tuna and shrimp; foreign experts gain ‘blue economy’ visas."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Bord Iascaigh Mhara funds stock-assessment projects; visas possible via general scientist route."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Large coastal fleet needs sustainability advisories; SSW covers fishery domains."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "MADANI Economy",
        "reason": "Blue-economy agenda promotes foreign expertise in high-tech aquaculture."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Sustainable seafood is a national export; marine scientists receive fast-track residence."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Red Sea aquaculture projects need expertise, yet localisation rules limit routine hiring."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "UAE Centennial 2071",
        "reason": "Niche aquaculture pilots exist, but fintech and AI dominate visa allocations."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Post-Brexit fishing policy created short-term openings, not an ongoing shortage list role."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "NOAA funds sustainable harvest projects, but consultants are hired project-by-project, not immigration-priority roles."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "National Master Plan 2021-2030",
        "reason": "World’s fourth-largest seafood exporter seeks consultants on disease control and feed optimisation."
      }
    }
  },
  "218ec13e-32bd-44f8-8e1c-44c5335f92e7": {
    "career": "Health Policy Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Aged-care reforms require policy experts; role fits under health-economist stream."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Chronic provider shortages mean provinces hire analysts to optimise spending and immigrant pathways."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Statutory insurers fund research units, but German-language requirement is a barrier."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "National Health Insurance reform opens research contracts, yet bureaucracy slows hiring."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Role comes under health-economist skill code but is not in fast-track category."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Highly Skilled Professional visa",
        "reason": "Ageing-society think-tanks recruit foreign PhDs under HSP research stream."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Universal-health discussions ongoing; foreign analysts possible but quotas prefer locals."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Migrant Category",
        "reason": "Rural health-equity studies attract foreign analysts on general skilled visas."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Vision 2030",
        "reason": "Gigantic hospital PPPs need data-driven policy teams; expatriates hired aggressively."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Green Plan 2030",
        "reason": "Population ageing and value-based care pilots need policy modellers, especially with data-science skills."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "We the UAE 2031",
        "reason": "Mandatory insurance reform and health-tech hubs create steady analyst demand."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "NHS productivity taskforces seek analysts though not formally on shortage list."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Affordable-care debates fuel demand for analysts, but occupation lacks dedicated federal visa fast-track."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National Master Plan 2021-2030",
        "reason": "Health-insurance expansion generates consulting projects; no dedicated visa lane."
      }
    }
  },
  "ff38272d-4ec5-4de9-9ec9-f79bf00e6275": {
    "career": "STEM Accountant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Accountants dropped from most regional shortage lists after 2023 glut."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Express Entry rarely selects accountants unless bilingual or provincial nomination."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "STEM firms need IFRS experts, yet occupation competes with abundant EU talent."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Battery-supply projects hire some expatriate accountants, but localization pressure rising."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma multinationals in Cork and Galway sponsor CPAs with STEM-sector background."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Corporate accountants seldom get HSP points unless bilingual in Japanese."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "NIMP 2030",
        "reason": "Semiconductor fabs need project-cost accountants to track incentives."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Accountants listed only for senior tax specialists; STEM experience gives marginal edge."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Mega-projects need project-cost accountants, but Saudisation quotas apply."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Economy 2030",
        "reason": "Deep-tech firms backed by EDB favour accountants who understand grants and carbon reporting."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Operation 300bn",
        "reason": "Manufacturing push needs cost-accountants familiar with R&D grants."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-science clusters hire accountants versed in R&D tax credits; Skilled Worker visa available."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Tech giants require specialised revenue recognition experts, but accountants are not a visa-priority occupation."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Foreign STEM companies use regional hubs in Singapore, not Vietnam, for high-level accounting."
      }
    }
  },
  "60bcd842-5358-49bd-9f1b-1f319889ef64": {
    "career": "Study Abroad Coordinator",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Education export is Australia’s 3rd-largest industry; institutional sponsorship for coordinators is common in regional campuses."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "International-student boom fuels roles, but labour codes classify them as generic advisors."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Tuition-free universities attract global students; coordinators hired, though local language favoured."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Government scholarship schemes contract some coordinators, but visa caps remain low."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Higher-education internationalisation needs staff, but role not on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Inbound student targets create demand, yet Japanese language remains gate."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "MADANI Economy",
        "reason": "Education hub ambitions open jobs, though preference given to multilingual locals."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "After COVID rebound, universities rebuild international teams but visas focus on researchers."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Government scholarship programmes create some outbound-advisory jobs, largely filled by citizens."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Singapore Economy 2030",
        "reason": "Global campuses on the island need advisors, yet local talent pool is sufficient."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "Global branch campuses in Dubai Academic City hire coordinators, but not a priority visa category."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Universities rely on fee-paying internationals; coordinators sponsored under generic SOC codes."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Thousands of campus international offices hire, yet occupation is not recognised in immigration priority lists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "2fdc905a-70da-4b17-97ea-26a0af3a273d": {
    "career": "Systems Designer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Mechanical, aeronautical and production engineers appear on the medium-long term skills list."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Mechanical and aerospace engineers receive extra CRS points under the STEM draw."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Auto, renewable and machinery majors urgently recruit systems engineers."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV battery and mineral processing plants value mechanical systems but prefer regional experience."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Mechanical and electromechanical engineers qualify for fast-track visas."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics and space programmes recruit foreign systems engineers with point bonuses."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan emphasises aerospace and semiconductor packaging, creating some need for systems design."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Civil and structural dominate the list; mechanical gets limited but valid pathways."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Mega-projects (NEOM, defence, space) require complex systems integration talent."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Manufacturing 2030",
        "reason": "Precision-engineering demand exists, yet role competes with saturated regional talent pool."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Operation 300bn",
        "reason": "Push to grow advanced manufacturing opens niche demand for systems designers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "EV, aerospace and clean-energy pillars list systems engineering as a priority skill."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Funds advanced manufacturing, aerospace and defence R&D that need multi-disciplinary systems engineers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Primary focus is chip packaging; mechanical systems roles are supportive not core."
      }
    }
  },
  "dd6f9daf-26d9-4bc2-8b36-2314c4fe9049": {
    "career": "Talent Acquisition Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Migration Strategy 2023",
        "reason": "Recruiters can enter under generic business visas, not skill-shortage lists."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Programme markets Canada abroad, yet HR roles themselves lack dedicated points."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Points possible for HR managers, but language and localisation limit demand."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "HR not on critical list; standard work permits possible."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "HR fits general skill category but sits low on priority ladder."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Economy 2030",
        "reason": "Strategic sectors hire international recruiters, but MOM passes harder to obtain for HR."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "We the UAE 2031",
        "reason": "Multinationals in DIFC need global recruiters, but no special immigration incentives."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital and finance clusters hire recruiters, yet occupation is not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Mass infrastructure hiring indirectly raises demand for recruiters, but no dedicated visa priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "7ef7b30e-661e-4dca-b7b0-c8975347f8f3": {
    "career": "Wellness Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Dietitians listed under allied health shortages in regional areas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Allied health and dietetics receive category-based draws, especially in French provinces."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Preventive healthcare push fuels demand for nutrition experts."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on critical list but public-health contracts create demand."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Nutritionists included under allied health occupations with direct residency pathways."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "High-end wellness resorts hire consultants, but licensing hurdles exist."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Singapore Green Plan 2030",
        "reason": "Preventive health campaigns create limited openings, but competition is stiff."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Luxury clinics recruit dietitians; DHA licence required but visas available."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Nutritionists are not on shortage list; general visa possible with sponsorship."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Community health grants create some roles, but visa priority low."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "6b1b86ae-25c3-4429-9387-229ec29c9895": {
    "career": "Education Administrator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Regional education leadership listed, but caps are small."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Rural school leadership roles qualify under French-speaking and education streams."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Migrant Category",
        "reason": "STEM teachers prioritised over administrators; pathway exists but secondary."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Leadership roles need prior UK teaching experience; sponsorship possible but rare."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Indirect benefits via school modernisation grants; no visa priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "fd16ec99-a634-44b6-8d3e-c013e61a06f0": {
    "career": "Internet Technology Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "ICT business and systems analysts are priority occupations with visa length up to 4 years."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Dedicated STEM draws fast-track IT professionals to permanent residency."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialists can relocate without degree if experience proven."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Demand exists, but work-permit quotas and Bahasa requirements limit uptake."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "ICT specialists on critical list get two-year work permit leading to residency."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Highly Skilled Professional visa",
        "reason": "IT engineers gain top-tier points, easing permanent residency path."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Digital backbone for semiconductor and aerospace push relies on network experts."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Software and network professions on straight-to-residence path."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "National digitalisation plan requires thousands of IT specialists."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "National AI Strategy 2.0",
        "reason": "COMPs and cybersecurity on COMPASS salary-benchmarked visa fast track."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "UAE Centennial 2071",
        "reason": "Free-zone tech hubs grant five-year green visas to IT experts."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital and cyber specialists qualify for Skilled Worker visas with reduced salary thresholds."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "CHIPS and Science Act",
        "reason": "Broad tech funding increases demand for network and systems specialists, yet H-1B remains main route."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "National Master Plan 2021-2030",
        "reason": "Rapidly growing data-centre and fintech sectors chase foreign IT talent."
      }
    }
  },
  "2e6d988c-f0cd-44a4-9bd1-f4929ee1282c": {
    "career": "Rehab Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Physiotherapists are on the CSOL and receive extra points for state sponsorship."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Allied-health professionals are specifically grouped under the new Healthcare draws with fast-track PR."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Acute rehab staff shortages in hospitals; foreign physios can obtain recognition and Blue Card."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Public-hospital shortages exist; however physiotherapists were removed from Critical Skills List in 2024."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Rehab not yet an SSW category; hospitals still sponsor under regular work visa with proven experience."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Physiotherapists are on Green List Tier 1 with direct residence pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Large hospital expansions seek rehab staff, but visas focus on doctors/nurses first."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Singapore Green Plan 2030",
        "reason": "Silver Generation ageing drives demand, but physio is not on official Shortage List—hiring still possible via EP."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Private hospitals hire physiotherapists for medical tourism, yet no dedicated immigration incentive."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "NHS trusts recruit physios internationally, but role is not on 2025 shortage list after reforms."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Ageing Baby-Boomers drive demand for physiotherapy, but no federal immigration priority lists target this skill."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "16834332-f618-4d2e-ae13-b2df6e103f00": {
    "career": "VFX Artist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Vancouver and Montreal studios hire foreigners under Global Talent Stream, but role is not on Category-based immigration list."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Anime/VFX studios hire foreigners, but no HSP points bonus for creative roles."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Weta Digital periodically sponsors senior artists but no Green List support."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Massive spend on film & gaming under V2030 makes senior VFX talent a priority for NEOM Media City."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Singapore Economy 2030",
        "reason": "Media 21 grants exist, but VFX not in National AI Strategy priority."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s creative-media push gives Golden Visas to proven digital artists."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Film, TV, and gaming VFX are named creative-industry priorities with fast Global Talent visa."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Hollywood demand high, but no federal talent visa preference for creative artists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "ceb9098c-0cc1-4444-9f79-f1cf363bf197": {
    "career": "Aviation Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "CSOL lists airport operations roles only in regional areas; competition high."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Passenger growth demands managers, but immigration prioritises pilots and mechanics over management."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Air-traffic rebound needs managers, but Blue Card quotas focus on engineers."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nusantara airport and tourism push open roles for experienced aviation managers."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "Tokyo Haneda/Japan Airlines hire foreign experts, but HSP points modest for management only."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Aerospace cluster around KLIA needs managers for MRO and cargo hubs."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Small aviation market; immigration lists focus on pilots/engineers."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Vision 2030",
        "reason": "Gigaproject airports (NEOM, Red Sea) urgently recruit global aviation leadership."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Economy 2030",
        "reason": "Changi T5 expansion favours seasoned managers; COMPASS framework awards bonus points to aviation sector."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "We the UAE 2031",
        "reason": "Dubai & Abu Dhabi aim to triple passenger capacity; Golden Visas for senior aviation professionals."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Heathrow expansion stalled; no shortage-list support for managers."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "USD 25 bn earmarked for airport modernisation creates management openings, though no dedicated visa perks."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "New Long Thanh airport seeks some expatriate managers; no formal incentive."
      }
    }
  },
  "8462a034-4168-48eb-a36b-851f2d696403": {
    "career": "NGO Advocate",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "NGOs can sponsor Critical Skills permits for solicitors in asylum law, though not prioritised."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "National AI Strategy 2.0",
        "reason": "Select public-interest tech policy NGOs hire foreign counsel under EP, but numbers small."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "UAE Centennial 2071",
        "reason": "International arbitration hub needs some public-interest counsel, though visas favour corporate law."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Senior legal professionals are listed; NGOs use Skilled Worker visas for human-rights solicitors."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Public-interest law firms sponsor H-1B, but role not in any federal priority list."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "bf66383e-63e2-4d34-9e18-5eca8c4e1452": {
    "career": "School Social Worker",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Regional visas cover social workers, but role not on national CSOL."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Social workers are a named sub-category in the Healthcare/ Care Economy draws."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Youth-welfare offices hire foreign social pedagogues; Blue Card possible with degree level recognition."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Tusla shortages allow employment permits, but role not on Critical Skills List."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Skilled Migrant Category",
        "reason": "Child well-being strategy labelled social work ‘critical’; easy pathway after registration."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Singapore Green Plan 2030",
        "reason": "MOE hires Allied Educators; EP possible, but local grads prioritised."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Private schools can hire foreign counsellors, but no immigration bonus."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "School counsellor shortages in rural areas; J-1 visas sometimes used though not a federal priority list."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "0e679997-a73c-465b-9f31-47a26d86dc4c": {
    "career": "Zoologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Not on CSOL but universities and state parks hire zoologists for biodiversity monitoring."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Express Entry Category-Based Selection",
        "reason": "NOC 2121 (biologists) fast-tracked; Arctic and prairie provinces recruit conservation scientists."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Biologists qualify for Blue Card yet few dedicated vacancies outside research institutes."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Biodiversity-rich archipelago needs conservation scientists, but jobs sporadic and local."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Department of Conservation roles exist but the occupation is absent from Green List."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Biodiversity targets create some research grants but role not on shortage list."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "CHIPS and Science Act",
        "reason": "NSF funding for life-science research and National Park Service demand for wildlife biologists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "9818a29c-26a1-45ec-b27d-bad36c181900": {
    "career": "Communication Specialist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "Entertainment and mega-projects need English-language PR talent."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Singapore Economy 2030",
        "reason": "Regional headquarters demand English PR skills, yet role outside strategic shortage list."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi are regional media hubs seeking senior comms professionals."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries expansion keeps strategic communication in demand, though visa hurdles remain."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "CHIPS and Science Act",
        "reason": "Huge market for corporate comms, but no special immigration preference."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "31",
        "policy": "",
        "reason": ""
      }
    }
  },
  "d487a4f6-0cd2-414b-99c0-d07d166573a9": {
    "career": "Criminal Justice Administrator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "State police recruit internationally for specialist leadership roles, yet few openings."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Provinces occasionally nominate senior police managers, but no dedicated stream."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Skilled Migrant Category",
        "reason": "Small but periodic needs in corrections leadership; heavy local preference."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Some leadership posts in HM Prison & Probation Service are open to foreign experience—but visas tough."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Federal grants modernise policing technology, increasing demand for data-savvy administrators."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "035e6dba-1da6-49b0-ae9a-d7bfa21da3bf": {
    "career": "Financial Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Occupation classified as ‘generic management’—employer sponsorship only."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Strategy targets fintech and controllers but Express Entry points modest."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Eligible for points, but language-heavy role limits demand."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "49",
        "policy": "RPJPN 2025-2045",
        "reason": "Capital relocation to Nusantara driving some corporate finance hiring."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "IFSC Dublin actively recruits finance leaders, especially in funds and insurance."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Highly Skilled Professional visa",
        "reason": "Tokyo aims to be Asian finance centre, but Japanese language often required."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Skilled Migrant Category",
        "reason": "Accountants favoured over generic finance managers."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Vision 2030",
        "reason": "Huge PIF investments require corporate finance leadership."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Economy 2030",
        "reason": "Global hub for sustainable finance; COMPASS framework favors experienced managers."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "DIFC/ADGM attract global finance talent with 0% personal tax and quick visas."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London remains global finance hub; Senior Manager visas expedited."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Clean-tech firms need finance leads for tax-credit projects though no visa fast-track."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a46a8e45-bc5b-4207-91ea-35d5a08fc823": {
    "career": "Hospital Administrator",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Health and Welfare Services Managers are priority occupations with visa concessions."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Healthcare managers get additional CRS points; provinces actively recruit."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Aging population strains hospitals; administrators with German/English skills welcomed."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Managers absent from list; occasional HSE direct hires possible."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Private hospital growth allows expatriate managers, though preference local."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Not on Green List but district health boards sponsor experienced managers."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Vision 2030",
        "reason": "Large private hospital chains in NEOM and Riyadh need international administrators."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Singapore Green Plan 2030",
        "reason": "Public hospitals prefer citizens; private groups occasionally sponsor foreign COOs."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "We the UAE 2031",
        "reason": "Medical tourism focus drives demand for hospital management expertise."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "NHS trusts recruit managers, but immigration priority below clinical roles."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds rural hospital upgrades, increasing demand for operations leaders."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "742bc31f-f3d6-4ab5-b3c9-a0736fd849fc": {
    "career": "International Business Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "General business skills welcomed but not on Core Skills Occupation List."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Program accepts business and financial analysts yet they are not on priority lists."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Need for global-market advisors in nickel/EV firms; still secondary."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Tech MNC hub uses analysts, but visa priority reserved for engineers and scientists."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Foreign-investment push opens limited demand for market analysts."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Economic-diversification megaprojects need international market analysts for investment decisions."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Economy 2030",
        "reason": "Regional HQs in finance and tech constantly hire analysts; however role isn’t on Tier-1 critical list."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "We the UAE 2031",
        "reason": "Free-zone multinationals and sovereign funds actively recruit cross-border business analysts for growth strategy."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Financial-services and digital clusters rely on analysts though not shortage-listed."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Large MNC and consulting ecosystem needs analysts but role is not named in industrial policy."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Role exists in growing export firms but not part of semiconductor priority list."
      }
    }
  },
  "73792dfb-2ba0-4f86-8923-ac5336d39f86": {
    "career": "Project Leader",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Software developers and tech team leads are on the priority list."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Software engineers and managers headline immigration draws."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialists can obtain Blue-Card without degree; demand for project leads is acute."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "RPJPN 2025-2045",
        "reason": "Growing fintech market needs leadership yet not on skills list."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Software development managers qualify for Critical Skills Permit."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points favour senior software leaders, but language barrier limits uptake."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Digital-hub aspirations create demand, but immigration prioritises semiconductor hardware."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Software engineers on Tier 1; leadership roles welcomed but not separately listed."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Tech parks in NEOM hiring, yet visas focus on senior AI rather than general software PMs."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "National AI Strategy 2.0",
        "reason": "Tech managers qualify for COMPASS points if leading AI product teams."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Operation 300bn",
        "reason": "Digital projects and fintech scale-ups recruit experienced software leaders."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital/AI occupations shortage-listed; project leaders follow the same SOC code."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "CHIPS and Science Act",
        "reason": "Leadership in AI and semiconductor software teams valued, but no explicit visa priority."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Focus is on chip and AI engineers rather than project management roles."
      }
    }
  },
  "84cbb620-9b59-4f70-9c47-f6eb625304a0": {
    "career": "Building Technologist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Civil/structural engineers and construction PMs are priority; technologists closely related."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Construction technologists qualify, yet nurses and IT eclipse demand."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Housing-crunch pushes demand for skilled building professionals with BIM expertise."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital Nusantara fuels need for BIM and green-building specialists."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Construction demand moderate; visas favour engineers over technologists."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "Industrial master plan includes smart manufacturing; building tech demand is supportive, not core."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Construction PMs and engineers on Green List; technologists often accepted under same ANZSCO code."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Gigaprojects like NEOM aggressively hire BIM and building-science specialists."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Smart-city and megatower pipeline needs technologists skilled in sustainability and digital construction."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Shortage lists highlight engineers; technologists are adjacent but not explicitly named."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "US infrastructure boom needs BIM and building-science professionals, but immigration channels not prioritised."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National Master Plan 2021-2030",
        "reason": "Infrastructure expansion creates openings but no dedicated immigration priority."
      }
    }
  },
  "74dd26e3-451d-4e39-b2d2-b3a354c2d685": {
    "career": "Health Services Administrator",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Aged-care reforms heighten demand for qualified administrators."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Provincial nominee programs often target healthcare managers to ease system strain."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Hospital staffing shortages extend to non-clinical management roles."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Private hospitals expanding in Jakarta, but immigration pathways unclear."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Critical Skills List omits healthcare administrators."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Private hospital boom causes some demand yet no explicit policy support."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Green List focuses on clinicians; administrators sometimes sponsored by DHBs."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "New mega-hospitals require experienced international health administrators."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Green Plan 2030",
        "reason": "Health-tech and ageing-population strategies encourage skilled administrators, though not Tier-1."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai Health Strategy pushes for global expertise in hospital management."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "NHS recruits managers but visa priority mainly clinical."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Demand high, but no special immigration channel for non-clinical managers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "07fafb6b-fba2-4330-9259-559049e77a2c": {
    "career": "Instructional Coach",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Secondary STEM teachers shortage; instructional coaches provide professional learning."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "K-12 teachers and early-childhood educators on priority list; coaching accepted under same NOC."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "STEM teaching shortage opens doors for pedagogy specialists."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Primary and secondary teachers on Tier 1; mentoring expertise welcomed."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "MOE limits foreign teacher numbers; some international schools hire coaches."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Private schools hire expatriate coaches, but not a strategic immigration focus."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Skilled-worker visa excludes most school roles after 2025."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "K-12 roles largely state-funded and domestic sourcing preferred."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4c30a15c-735a-4bc4-9f9b-5034feed8d01": {
    "career": "Medical Physics Technician",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "State occupation lists cite medical physicists/radiation therapists as shortages; visas expedited."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Allied-health technologists are specifically targeted in healthcare draws, giving quick PR pathways."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Radiotherapy departments face staffing gaps; new act speeds up recognition of foreign credentials."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Hospitals recruit internationally, yet role is not on Critical Skills List, slowing visa options."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Healthcare pathways focus on nursing care; few slots for medical physics technicians."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Medical imaging and radiotherapy technologists are on Tier 1, offering immediate residence on arrival."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Cancer-care expansion needs staff, yet no dedicated visa preference for this niche skill."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Biomedical cluster hires some specialists, but technicians fall outside National AI/Manufacturing priorities."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Private oncology centres recruit overseas technologists, but policy spotlights doctors over technicians."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Clinical roles recently removed from shortage list; hiring possible but not prioritised."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Hospitals hire imaging and radiotherapy technologists on H-1B, but the role is absent from recent industrial spending acts."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "f071a34d-52db-4fcf-9674-da51eda0b117": {
    "career": "Nursery Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Regional visas favour farm managers, giving moderate pathways for commercial nurseries."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Agricultural and horticultural supervisors receive extra points and frequent provincial nominations."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Skilled Immigration Act helps recognised vocational trades, but horticulture is a secondary focus."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Government wants advanced agri-tech to boost food security, opening slots for skilled nursery leads."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "SSW agriculture covers greenhouse work, though management roles need Japanese language."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Agriculture modernisation is rising, yet no dedicated visa track for foreign nursery managers."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Migrant Category",
        "reason": "Nursery and greenhouse managers qualify for skilled residence points due to labour shortages."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Horticulture managers are employable but not covered by industrial or immigration priority lists."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "National Master Plan 2021-2030",
        "reason": "Plan pushes high-value horticulture exports; firms import skilled managers for tech transfer."
      }
    }
  },
  "d8973dbf-264e-484f-bb0e-596f46272d01": {
    "career": "Operations Director",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "General managers eligible for Skilled visas but points are lower than STEM shortages."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Strategy encourages senior managers, yet no dedicated fast track."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Points system rewards management experience, still secondary to technical roles."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital and EV projects require operations heads, though permits handled case-by-case."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Critical Skills List focuses on tech and pharma; senior managers get standard work permits."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "Industrial diversification calls for experienced plant directors but no special visa lane."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Skilled Migrant Category",
        "reason": "High points needed since role is not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Mega-projects need seasoned operations leaders across construction, logistics and tourism."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Employment Pass framework welcomes senior managers, but they are outside Tier-1 tech lists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing push values directors who can scale plants and supply chains."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Global Business Mobility routes exist but no shortage prioritisation."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Always in demand but not singled out in CHIPS/IRA/IIJA; standard H-1B route applies."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "55e2e947-15a2-48fc-aa68-f6e629a7731c": {
    "career": "PR Consultant",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Mega-projects and tourism push require English-speaking PR experts to shape the Kingdom’s image."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Regional HQs need PR, yet the role is outside Tier-1 lists, so passes are competitive."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi aim to be media hubs, attracting seasoned PR consultants."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Creative Worker visa allows entry, yet not on official shortage lists."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Creative visa options exist (O-1), but communications is not an economic-priority field."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "6ded44bd-30d4-4704-8f1c-823724737de8": {
    "career": "Storyboard Artist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Tax-rebate driven animation hubs (Vancouver, Montreal) hire foreign artists but no shortage list incentives."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Animation studios like Cartoon Saloon hire some overseas artists, but no national priority."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Highly Skilled Professional visa",
        "reason": "World’s largest animation market welcomes top artists who score high on HSP points."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "WetaFX and local studios occasionally import talent, yet role isn’t on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Massive investment in film and gaming creates demand for visual-story talent."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Animation industry exists but Employment Pass quotas are tight for junior creatives."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai Media City aims to be a regional animation hub, courting international artists."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries listed as strategic; Global Talent visa eases entry for storyboarders with awards/credits."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "",
        "reason": "Hollywood, streaming and gaming dominate global demand; O-1 visas commonly used for top storyboard talent."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4b2d83d5-4e08-4eda-a4d8-de684cab6077": {
    "career": "Unmanned Systems Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Robotics engineers appear on CSOL, yet unmanned-systems roles remain niche and largely defence-restricted."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Tech draws accept engineering backgrounds, but drones are not a listed shortage; jobs exist mainly in defence and mining inspection."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Aerospace and mechanical shortages let UAV engineers qualify, though Germany’s civilian drone market is still small."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Agri-drone pilots are growing, but priority remains on EV batteries and minerals."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Software engineers qualify, but dedicated UAV employers are few and small."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics and drone R&D receive priority points; firms like Yamaha and Rakuten hire foreign UAV talent."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Aerospace cluster offers some roles in drone subsystems, but few full-stack UAV manufacturers."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Green List lacks a drone category; limited demand for agricultural drone specialists."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Giga-projects use drones for security and mapping, driving overseas recruitment of UAV engineers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "National AI Strategy 2.0",
        "reason": "Strong autonomy R&D ecosystem and Defence Science bodies recruit unmanned-systems specialists, though quotas are tighter than Tier-1 fields."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Operation 300bn",
        "reason": "Dedicated government corridors for cargo drones and defence tech create strong hiring demand for unmanned-systems experts."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Aerospace and defence pillars highlight autonomous air systems, giving clear visa routes for drone engineers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Massive federal spending on autonomous and defense robotics creates the world’s largest demand for drone and unmanned-vehicle engineers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Electronics skills overlap, yet immigration focus is chip design rather than drones."
      }
    }
  },
  "925fa584-a586-4ecf-90a9-e4e6a6df155a": {
    "career": "Industrial Biotechnologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Biotechnologists sit on CSOL but visa quotas and local graduate supply keep demand modest."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Life-science PhDs score well in Express Entry, though industrial biotech isn’t a named shortage."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Chemical and pharma giants in Germany recruit foreign biotech scientists via EU Blue Card."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "RPJPN 2025-2045",
        "reason": "Food and bio-fertiliser R&D planned, yet visas focus on engineers, not scientists."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Ireland’s pharma–biotech cluster offers fast-track visas and plentiful biomanufacturing roles."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "Bioeconomy Strategy funds synthetic-biology pilot plants; points-based visa favours PhDs."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Biopharma and specialty-chemical targets make industrial biotechnology a headline growth area."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Priority is medical lab science; few openings in industrial biotech."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Vision 2030",
        "reason": "Biotech parks are emerging, yet demand skews to healthcare rather than industrial enzymes."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Singapore Green Plan 2030",
        "reason": "Synthetic-biology hubs like Biopolis recruit, but foreign-talent passes are competitive."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Biotech startups exist but still small-scale; visas favour clinicians and AI talent."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences pillar prioritises bioprocessing and advanced therapeutics, with streamlined visas for R&D scientists."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA pours billions into bio-based fuels and chemicals, boosting industrial biotech hiring."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "National Master Plan 2021-2030",
        "reason": "Government supports pharma R&D, but industrial biotech remains early-stage."
      }
    }
  },
  "df45dbf6-44ed-4ad7-bc39-ca0d1fd0246b": {
    "career": "MIS Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Migration Strategy 2023",
        "reason": "ICT Managers remain on Skilled Occupation List, enabling visa sponsorship."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Tech draws favour IT managers who meet point thresholds and language scores."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT roles qualify, but German-language demands and local talent narrow openings."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Digital-government projects hire MIS leads, though bureaucracy slows foreign permits."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "ICT managers appear on the list, fast-tracking visas for experienced candidates."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points possible, but employers prefer bilingual managers."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "MADANI Economy",
        "reason": "Digital-economy push needs MIS leads, yet local supply meets much demand."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Role isn’t on the Green List; general skilled category still possible with high points."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Digital transformation projects hire foreign IT managers, yet Saudization policies limit numbers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Singapore Economy 2030",
        "reason": "Financial services and logistics firms recruit MIS leaders; EP quotas are tightening."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "UAE Centennial 2071",
        "reason": "Banks and logistics firms in Dubai modernise ERP systems and recruit seasoned MIS leads."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Not on shortage list but still eligible under general Skilled Worker visa streams."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Large infrastructure projects upgrade legacy IT, increasing demand for experienced MIS managers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Tech managers needed, but visas prioritise hardware engineers."
      }
    }
  },
  "4203bba1-b5f7-481c-9b3c-bac0a66436cd": {
    "career": "NGO Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "Consultants may obtain visas under general categories, but role has no special listing."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Social-impact experience can earn points, yet immigration priority lies elsewhere."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Points system allows entry for skilled professionals, yet NGO consulting demand is limited."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Role not on Critical Skills list; possible only through General Employment Permit."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Non-profit advisers fall under generic management; modest demand and tight quotas."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Economy 2030",
        "reason": "Impact-investment scene hires some consultants, but foreign quota is limited."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "International-development consultancies cluster in London, but no special visa concessions."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Federal community-development grants create advisory work, but not a named shortage occupation."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a85dab3a-eae0-4462-a276-89895d933cdb": {
    "career": "Agricultural Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Agricultural and fisheries scientists are explicitly listed, with regional visa incentives."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Agri-researchers are welcomed, especially French speakers, though not top-tier shortages."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Corporates like Bayer hire agri-scientists, but profession isn’t a priority shortage."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "RPJPN 2025-2045",
        "reason": "Food security and aquaculture expansion make agri-scientists a headline talent need."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List focuses on pharma and ICT; agri-scientists use general permits."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "49",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-agriculture projects exist, but language and funding limit foreign hires."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "MADANI Economy",
        "reason": "Food-tech R&D is growing, yet visas favour manufacturing engineers."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Critical shortage of agri-scientists for dairy and climate adaptation earns automatic residence pathways."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Desert agriculture projects need expertise, yet hiring volumes remain modest."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Singapore Green Plan 2030",
        "reason": "Urban-farm R&D exists, yet limited openings and strict EP quotas keep demand niche."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "We the UAE 2031",
        "reason": "Vertical-farm and food-security projects create some roles, but not officially prioritised."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Agri-tech isn’t in IS-8; visas possible under general Skilled Worker route only."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds climate-smart agriculture, creating some research roles but no dedicated visa priority."
      },
      "vietnam": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "National Master Plan 2021-2030",
        "reason": "Government prioritises agritech and sustainable fisheries, actively courting foreign scientists."
      }
    }
  },
  "8e22d815-f74c-49b8-95f2-f5df9e0cdd55": {
    "career": "CM Project Lead",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Construction Project Managers sit explicitly on CSOL; visas are fast-tracked due to housing and infrastructure deficits."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Construction managers can qualify under the general skilled-worker stream, yet they are not on Canada’s priority list."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Act recognises civil engineers and construction supervisors; German builders lack experienced site leaders for energy-retrofit boom."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "New capital Nusantara and EV plants open opportunities; employers can sponsor experienced foreign project leads."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Ireland prioritises quantity-surveyors and site engineers, not project leads."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "SSW covers mid-skill construction trades; managers can enter only via corporate transfers, so demand is lower."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan funds factories and rail, but visas favour local engineers; foreign PMs hired case-by-case."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "81",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "‘Construction Project Manager’ is on the Green List Tier 1 with direct residency pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Gigaprojects such as NEOM and the Red Sea need thousands of foreign project leads with BIM and megaproject expertise."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi are adding airports, museums and data centres; senior construction managers are on priority work-permit lists."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "List covers only specialist civil engineers; generic construction management must pass normal points test."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA is fuelling highways, bridges and broadband builds, but demand is centred on licensed civil engineers rather than overseas project leads."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Large transport projects need managers yet no dedicated immigration lane exists."
      }
    }
  },
  "292e0ca5-c7c9-4ff1-9582-7cf067b3e526": {
    "career": "CPA Candidate",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "The new skills tiers favour tech and engineering; general accountants sit in lower priority bands."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Accountants qualify as skilled workers but fall outside Canada’s priority shortage categories."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "German firms need English-speaking auditors, yet the policy prioritises engineers and IT over finance."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "IFSC Dublin seeks chartered accountants for global funds and pharma multinationals."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "Vision 2030",
        "reason": "Financial-sector Saudisation reduces foreign junior accountant hiring."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Green Plan 2030",
        "reason": "Carbon-accounting rules lift demand for CPAs, though they are not on the absolute priority list."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai’s DIFC courts and tax-free status keep Big-4 auditors recruiting CPA aspirants."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London lists chartered accountants as shortage; post-Brexit mobility schemes speed visas."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Growth grants boost corporate compliance and tax advisory work, though CPAs are not explicitly fast-tracked for visas."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "25d7089b-c183-4ca5-bc9d-79922ff4d52d": {
    "career": "Financial Reporting Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Finance roles ranked lower than STEM and healthcare in new skills hierarchy."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Falls under generic ‘financial officers’; not priority category."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "German policy aims at engineers and IT; IFRS specialists can still qualify on points but without preference."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Multinational HQs in Dublin need statutory and US-GAAP reporting talent."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Financial-reporting demand exists in listed PIF companies, but Saudisation curbs foreign mid-level hiring."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Green Plan 2030",
        "reason": "Mandatory climate disclosures explode demand for financial-reporting experts, though not on official shortage list."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "UAE Centennial 2071",
        "reason": "IFRS and ESG disclosures for global investors keep Dubai hiring experienced reporting analysts."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "London’s listed companies must meet stringent reporting; shortage of IFRS experts post-Brexit."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Clean-tech firms need SEC and ESG reporting talent, yet occupation lacks dedicated visa priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "7a6a910c-5dbc-4199-ada9-2033a981880a": {
    "career": "Medical Lab Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "‘Medical Laboratory Scientist’ appears on CSOL; rural hospitals sponsor visas quickly."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Allied health professionals, including medical lab technologists, are now priority category with faster draws."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Clinical labs face shortages; new act simplifies credential recognition for health technologists."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Irish hospitals lack clinical biochemists and microbiologists; role qualifies for Critical Skills Permit."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Role on Green-List Tier 1 offers straight-to-residence visas."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Mega-hospitals at NEOM and Riyadh recruit foreign lab scientists despite Saudisation targets."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Green Plan 2030",
        "reason": "Hiring occurs, but role competes with local grads; no explicit priority."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "We the UAE 2031",
        "reason": "Dubai Health and Abu Dhabi’s SEHA list medical technologists as shortage positions."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "NHS shortage list covers biomedical scientists, easing visa route."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds biomedical manufacturing; hospitals still struggle with lab staffing but no special visa lane exists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "c6a76b19-35b0-448c-aeb6-32d8ff0f2082": {
    "career": "NGO Manager",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Programme invites social-impact leaders, but priority still skews to tech and health."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "Vision 2030",
        "reason": "Charitable foundations expanding, but localisation quotas limit visas."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Green Plan 2030",
        "reason": "Environmental NGOs need project leads, but Employment Pass criteria apply without priority."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Dubai supports social enterprises; foreign managers hired via standard employment visas."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Third-sector managers can get Skilled-Worker visas, yet no shortage points bonus."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Climate-and-equity grants fuel non-profits, yet immigration pathways remain general."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "73bddda4-61bc-4e17-8331-1a6ccf5b6116": {
    "career": "Operations Coordinator",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Mega-projects (NEOM, tourism resorts) recruit coordinators to handle complex multi-contractor logistics."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "Singapore Economy 2030",
        "reason": "Digital-trade and logistics hub keeps a steady but competitive demand for tech-literate operations planners."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "We the UAE 2031",
        "reason": "High event, logistics and e-commerce activity generates moderate demand for tech-savvy operations staff."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Advanced-manufacturing clusters need operations planners, but visa routes favour specialised engineers."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Large federally-funded construction and tech-manufacturing sites need coordinators for supply, vendor and labour scheduling."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "582ec91a-97ae-42c0-acf4-a2bc20231580": {
    "career": "PR Strategist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Vision 2030",
        "reason": "Tourism and entertainment push has created niche demand for English-Arabic PR specialists."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Regional HQs in Singapore contract PR strategists for APAC campaigns, but role not on priority lists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai and Abu Dhabi aim to be regional media hubs, importing senior PR talent."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative Industries are a named pillar; senior comms strategists qualify for Skilled Worker visas."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "No federal talent policy, but mature PR market keeps moderate H-1B demand."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "30761673-db04-43db-b77e-5beb95710351": {
    "career": "Product Development Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Mechanical/electrical engineers on list; product dev experience valued in defence and mining equipment."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Engineers receive high CRS points but role not singled out for critical need."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Germany’s auto and machinery sectors urgently hunt design engineers for EV and Industry 4.0 products."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV battery and appliance makers recruiting product development engineers."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Medical-device multinationals in Galway demand mechanical product engineers."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics and electronics giants sponsor HSP visas for product engineers with CAD/CAE expertise."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Chip-packaging and aerospace firms expanding R&D need design engineers."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Green List covers civil/structural engineers; product design engineers must pass general Skilled Migrant route."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "NEOM and defence manufacturing plants recruit product developers for smart-city hardware."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Manufacturing 2030",
        "reason": "Precision-engineering firms want engineers who can shorten prototype-to-production timelines."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Operation 300bn",
        "reason": "Push to grow local advanced manufacturing draws experienced product engineers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Advanced manufacturing and EV clusters around Midlands and North East need product development talent."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act pours billions into R&D and advanced manufacturing, needing engineers who turn concepts into manufacturable products."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "New fab and electronics parks hunt for product design skills."
      }
    }
  },
  "752c7d49-75f9-4812-8eb6-f6f0cba8eb71": {
    "career": "Criminal Justice Policy Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Policy analysts can obtain visas, yet occupation is not on CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Role eligible under general NOC research categories but not priority listed."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Opportunity Card allows points for social-science grads but competition is high."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Think tanks occasionally recruit, but DETE list excludes social sciences."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Skilled Migrant Category gives points for policy roles, but no shortage declaration."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Universities and international NGOs hire some foreign criminology researchers."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Home Office, charities and academia sponsor social-policy researchers under Skilled Worker route."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "",
        "reason": "Think tanks, state agencies and NGOs sponsor visas for policy researchers with quantitative skills."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "cf769f64-53c4-4493-b8b7-294505375301": {
    "career": "Doctor of Nursing Practice",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "Severe shortages in advanced nursing across aged-care and remote areas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Registered nurses and nurse practitioners top the targeted healthcare draw list."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Hospitals actively recruit foreign nurses with advanced qualifications and German B2 language."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Foreign clinical practice restricted; some roles in international hospitals."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Nurse practitioners are explicitly listed for Critical Skills permits."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Nursing-care SSW pathway open, but language bar is high for advanced clinicians."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Foreign advanced nurses limited to private hospital roles."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Nurse practitioners on Tier 1 but annual cap keeps score just below Tier 1 threshold."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "New private hospitals and medical cities import experienced nurse leaders."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Licensing possible but quotas and local-hire rules keep demand moderate."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Growing medical tourism drives demand for advanced practice nurses."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Post-2025 shortage list excludes overseas general nurses, but NHS still hires some advanced practitioners."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Advanced practice nurses increasingly used to fill primary-care gaps, though no dedicated immigration policy."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Healthcare focus on local training; foreign nurse licensing complex."
      }
    }
  },
  "6b9cfc55-4b59-4403-9d3d-b22f7f6da50b": {
    "career": "Ethics Instructor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Universities hire but role is outside Core Skills Occupation List priorities."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Canadian colleges actively recruit humanities faculty and offer academic work-permit streams under regular Express Entry."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Act covers university lecturers; philosophy/ethics teaching counts toward skilled academic visas."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Humanities lecturers can obtain General Employment Permits; demand moderate."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points favour PhD lecturers, but ethics is niche."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Tertiary lecturers can gain visas, yet not on Green List so competition high."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Universities value ethics amid AI debates, but role not in Tier-1 lists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Private universities hire ethics faculty but outside national priority tracks."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Universities sponsor Skilled-Worker visas for lecturers despite not being IS-8 shortage."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Universities and business schools keep steady demand for ethics lecturers, though not singled-out by federal talent acts."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "544eceec-7de2-438d-a71d-8f60c7749bfa": {
    "career": "Fine Arts Illustrator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Arts occupations possible under general skilled visas yet not on CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Artists enter under Self-Employed Persons Program, niche and competitive."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Points system allows creatives but with lower weighting than tech roles."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Manga/anime market values illustrators, yet visas fall under cultural activities, limited quotas."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Vision 2030",
        "reason": "Entertainment sector is expanding; illustrators find contract work on tourism projects."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Media industry hires illustrators but role not on Tier-1 skills."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "We the UAE 2031",
        "reason": "Dubai media and gaming firms hire illustrators though not priority."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries named in IS-8, but individual illustrator roles are freelance heavy."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Creative jobs cluster in NYC/LA but not covered by federal immigration incentives."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a639bcc1-e562-42e7-a016-c2ba8441ac9c": {
    "career": "ICT Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "ICT workers are on Core Skills List with priority visas and pathways to PR."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "IT occupations top Canada’s category-based invites and get rapid permanent residency."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Shortage of software and network experts; fast-track Blue Card rules apply."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Digital economy and e-commerce drive steady demand for ICT workers."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Software and network specialists get Critical Skills permits with two-year route to PR."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points favour IT; companies sponsor foreign specialists to plug shortages."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan calls for digitalisation and Industry 4.0, boosting ICT hiring."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Software engineers in Tier 1 enjoy streamlined residency, broader ICT roles still welcomed."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Digital transformation projects across government and NEOM need ICT expertise."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "National AI Strategy 2.0",
        "reason": "ICT (cloud, cyber, data) underpins AI hub ambitions; Employment Pass eased for experts."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Operation 300bn",
        "reason": "Smart city, fintech and AI initiatives aggressively hire ICT talent on Golden Visas."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital and cyber roles on shortage list enable fast Skilled-Worker visas."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds AI, semiconductor and cybersecurity projects that require broad ICT talent."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "National Master Plan 2021-2030",
        "reason": "Government grows fintech and semiconductor sectors, requiring experienced ICT staff."
      }
    }
  },
  "0dd54e3a-6e8a-439e-892b-bb4fa6cc9b6c": {
    "career": "Photography Instructor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Private RTOs hire instructors; occupation not on CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Self-employed teacher visas possible but outside category-based streams."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Cultural educators are eligible but receive modest points."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Cultural activity visa covers photography teachers but strict income proof."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Vision 2030",
        "reason": "Growing media academies under entertainment push hire photography trainers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Private art schools may sponsor passes, but not on skills lists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "We the UAE 2031",
        "reason": "Dubai creative hubs run short courses needing instructors."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Art schools sponsor Tier 2 visas even though role not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Community colleges and art schools hire, yet not federally prioritised."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "d6324b3f-57fb-4665-af04-fe2d829cf305": {
    "career": "Court Administrator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Courts digitise services, yet job absent from CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Provincial courts hire admins; occupation enters through general skilled visa, not priority list."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Public roles limited, but private arbitration centres hire admins."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Some openings in Ministry of Justice, but not on Green List."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Singapore International Commercial Court recruits some foreign admin talent."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Dubai and Abu Dhabi free-zone courts sometimes hire expat administrators."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "HM Courts use Skilled-Worker visas sparingly; role not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "IIJA invests in digital courts but role is managerial, not federally prioritised."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "c0828203-65fe-4a38-8445-4b40c5d8ee70": {
    "career": "Farm Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Agriculture appears in regional visas, but not on national high-priority list."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Category covers ‘agriculture and agri-food workers’; provinces list farm managers on shortage lists."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Law allows non-EU agricultural managers but demand is muted compared with nursing and engineering."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Food-security and agri-productivity goals create slots for experienced managers."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "SSW Category 8 covers agriculture with renewable five-year visas."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "MADANI Economy",
        "reason": "Plan nods to food security but incentives focus on high-tech industry."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "‘Dairy farm manager’ is Green-List Tier 1 with fast-track residence."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Vision 2030",
        "reason": "Food security is mentioned, yet recruitment focuses on megaproject tourism, mining and energy."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Rural-development funds for broadband, storage and irrigation create some openings but role is not explicitly prioritised."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "National Master Plan 2021-2030",
        "reason": "Modernising agri-tech and aquaculture is a named pillar, boosting demand for professional farm managers."
      }
    }
  },
  "7f0f1b9a-ae96-42e4-9ad0-60ac620a368c": {
    "career": "Program Director",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "List targets technical specialists; senior managers must clear higher salary thresholds."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Strategy spotlights tech rather than generic leadership; managers compete in general Express Entry pool."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Programme directors qualify via points but are not on shortage lists."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "RPJPN 2025-2045",
        "reason": "Nusantara new capital and battery hub projects rely on imported programme directors temporarily."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List centres on tech and pharma specialists, not generic management."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Points favour R&D and tech; managers without patents struggle to pass threshold."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan values project leaders but visa priority still granted to engineers."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "High-income managers can qualify, yet no dedicated shortage pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Megaprojects like NEOM aggressively hire experienced programme leaders."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "EP framework welcomes senior managers, but quotas tight and focus on specialists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "We the UAE 2031",
        "reason": "Economic diversification plans require directors to run multi-billion dirham programmes."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Only technical and creative leaders get shortage points; general programme roles rely on salary test."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Massive federal projects need senior programme oversight, but no dedicated visa priority."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National Master Plan 2021-2030",
        "reason": "Large infrastructure roll-outs need directors, yet local talent policy prefers domestic promotion."
      }
    }
  },
  "980b378b-d673-4df5-8d7b-bb7d305edd85": {
    "career": "Systems Integrator",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "ICT systems integrator is on list with fast-track employer nomination."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Strategy lists software and cyber roles; integrators qualify under broader tech stream."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Auto and industrial IoT sectors urgently seek integration engineers for Industry 4.0 retrofits."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV battery plants create some need, but localisation targets limit foreign hiring."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "ICT systems architects/integrators are listed with streamlined permits."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP awards extra points to semiconductor and robotics systems experts."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Electronics hub Penang looks abroad for integration engineers."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Demand exists but scale small; no dedicated Green-List slot."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Smart-city and defence megaprojects hire integrators for control systems."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Manufacturing 2030",
        "reason": "Precision-engineering roadmap values integrators for robotics and fabs, though visas competitive."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing push requires systems integration talent."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Shortage list names ‘systems engineer’ for aerospace, EV and semiconductor clusters."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Huge funding for semiconductor fabs and defence tech needs experts who knit hardware, firmware and software."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "FAB and OSAT facilities require integrators for automated lines."
      }
    }
  },
  "241dedd9-388c-4c19-8ca6-592b51b60cdd": {
    "career": "Athletic Director",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "National sporting culture strong, yet visas favour coaches over directors."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Sports administrators fall under general NOC management categories without priority."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Small but avid sports scene; roles exist but few sponsored visas."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Government pours billions into sports clubs and leagues, importing experienced directors."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi bid for global tournaments, needing administrators."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industries focus helps elite club hiring, but no visa shortcuts."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "College-stadium upgrades create roles, but no specialised immigration route."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a8bfd8e8-ffef-4ffc-b356-272782902bf5": {
    "career": "Medicinal Chemist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Migration Strategy 2023",
        "reason": "Chemical and pharmaceutical scientists get points but compete with healthcare roles for visas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Pharma scientists appear on category list; fast PR for STEM doctorates."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Big chemical industry recruits PhDs, yet not in absolute shortage like engineers."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Biopharma is identified growth pillar, but salary caps may limit senior foreign hiring."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Global pharma cluster in Cork and Dublin cannot meet headcount locally."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Highly Skilled Professional visa",
        "reason": "Points for doctoral life-science researchers enable quick PR."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan promotes pharma and medical devices; tax holidays for R&D centres."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Limited pharma presence; roles exist mainly in academia."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Biotech and vaccine plants planned under localisation drive, welcoming foreign R&D heads."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Singapore Economy 2030",
        "reason": "Biomedical manufacturing hub recruits medicinal chemists, yet quotas keep demand Tier 2."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "We the UAE 2031",
        "reason": "Dubai Science Park incentives attract drug-discovery start-ups needing chemists."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences ‘sector deal’ lists medicinal chemistry as key capability."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "CHIPS and Science Act",
        "reason": "Science Act allocates billions for biotech, boosting drug-discovery labs that hire chemists."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "National Master Plan 2021-2030",
        "reason": "Government courting vaccine and API manufacturers needs experienced chemists."
      }
    }
  },
  "f16edc84-e908-4a29-b8c7-3e5ec6560205": {
    "career": "Public Health Educator",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Allied-health promotion roles appear on state CSOLs to curb chronic-disease burden."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Health-care and community-service occupations receive extra CRS points, easing PR for qualified educators."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Public-health outreach valued but priority lies with clinical nurses; entry possible with German B2 language."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "RPJPN 2025-2045",
        "reason": "Government tackling stunting and smoking; may seek foreign advisors, but Bahasa barrier remains."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on list, but HSE community-health units sponsor when Irish talent scarce."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Ageing society needs health promotion but language barrier and limited quota lower score."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 2)",
        "reason": "Health-promotion specialists address obesity and Maori health gaps; role listed for streamlined residence."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Government funds preventive-health campaigns but Saudization keeps scores moderate."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Singapore Green Plan 2030",
        "reason": "Health Promotion Board runs campaigns; hires few foreigners under Employment Pass."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Lifestyle-disease reduction initiatives hire health educators, yet no dedicated visa lane."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "List covers clinicians, not educators; local councils still sponsor niche public-health educators."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Federal funds for preventive-care outreach create hiring, but role is not an explicit immigration shortage."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "3c4474cc-4b03-4c29-aca1-a103881c911a": {
    "career": "Vehicle Dynamics Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Limited domestic auto manufacturing keeps demand modest."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Ontario’s EV cluster recruits, but role competes with domestic grads."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "BMW, Mercedes and suppliers urgently need suspension, NVH and ADAS dynamics experts for EV lines."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Government pushes local EV assembly; imported dynamics expertise required."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Highly Skilled Professional visa",
        "reason": "Toyota, Honda and Subaru invest in next-gen chassis and GR performance models."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Proton and DRB-HICOM upgrade EV platforms and need dynamics know-how."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "NEOM and Ceer EV brand import foreign chassis talent."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Manufacturing 2030",
        "reason": "Focus is on semiconductor and precision-engineering rather than full vehicle platforms."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Operation 300bn",
        "reason": "Autonomous-mobility R&D hubs hire small numbers of dynamics specialists."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Formula-One corridor and EV gigafactories need ride/handling engineers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "EV tax incentives spur hiring for chassis and ride-handling engineers in Detroit and Silicon Valley."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "VinFast attracts foreign engineers for global EV chassis programmes."
      }
    }
  },
  "2db6482e-7426-47f6-bbb1-efe8a29f6f5a": {
    "career": "Community Music Educator",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Arts educators qualify under Federal Skilled Worker but receive no category boost."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not listed, but arts councils give limited work permits."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Entertainment sector growth funds after-school music programmes."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "Cultural foundations sponsor foreign musicians for music-education residencies."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Shortage list intermittently includes secondary music teachers; community roles can piggy-back."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Not a shortage occupation, but cultural-visa O-1 remains accessible for skilled educators."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "bf086356-81c9-4070-a571-4596cae2ebe4": {
    "career": "Dramatic Artist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Entertainment visas exist but capped and employer-sponsored."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Performers eligible yet compete for general FSW points."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Short-term artist visas available; longer residencies harder."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Screen Ireland funds projects, but no shortage listing."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Culture visas exist but limited; language barrier significant."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Cinemas reopened; government funds productions and imports acting talent."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "Esplanade theatres import foreign artists on temporary passes."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Dubai studios and free zones issue creative visas for performers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative Industry priority includes film and theatre, with Global Talent visa route."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Not linked to policy, but O-1 visa supports notable performers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "75c69eaa-9f68-4550-a1e1-d2af3057583e": {
    "career": "Financial Modeler",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Large banks sponsor, but role not on priority lists."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Finance roles earn points but no extra weighting."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV and infrastructure megaprojects require project-finance modelling experts."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "IFSC Dublin recruits financial analysts and modelers for global funds."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Tokyo’s fintech startups hire English-speaking modellers, but competition is high."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "MADANI Economy",
        "reason": "Islamic finance hubs in KL need advanced cash-flow modellers."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Vision 2030",
        "reason": "Sovereign funds and giga-projects need project-finance models."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "National AI Strategy 2.0",
        "reason": "Sustainable finance and fintech quants qualify for Tech.Pass and EP exemptions."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "UAE Centennial 2071",
        "reason": "DIFC and ADGM aggressively court fintech and valuation specialists with Golden Visas."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London demands quants; financial services highlighted as key pillar under IS-8."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "CHIPS and Science Act",
        "reason": "Visa pathways remain broad; Wall Street demands quantitative modellers for M&A and tech valuation."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National Master Plan 2021-2030",
        "reason": "Fintech growth creates some demand but without immigration incentives."
      }
    }
  },
  "bdadd452-7794-4b1b-9fcd-e19f0823ad94": {
    "career": "IT Security Manager",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Cyber security specialists are on the core list with state sponsorship and points boosts."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Cybersecurity is an explicit priority category with fast-track permanent residence for experienced professionals."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT-Sicherheitsfachkräfte receive simplified Blue Card rules and no German-language requirement for many roles."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech expansion needs security talent, though no dedicated fast-track yet exists."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Cybersecurity specialists qualify for Critical Skills permit leading to immediate family reunion."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Highly Skilled Professional visa",
        "reason": "Cyber roles fit the points-based HSP scheme but are not named priorities, so competition is higher."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "NIMP 2030",
        "reason": "Digital security supports semiconductor and Industry 4.0 goals, yet not listed as headline occupation."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Migrant Category",
        "reason": "Digital specialists earn high points though not on Green List; visas still attainable with job offer."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Mega-projects and digital banking push demand for cyber leaders to protect critical data."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "National AI Strategy 2.0",
        "reason": "Cybersecurity roles receive COMPASS salary exemptions and are grouped with AI talent for Tech.Pass."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "We the UAE 2031",
        "reason": "Nationwide digitalisation plan highlights cybersecurity as a pillar, offering Golden Visas for experts."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Cybersecurity appears in IS-8; Skilled Worker visa has salary discounts for shortage roles."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Critical infrastructure funds mandate stronger cyber-resilience for power, transport and telecom sectors, increasing demand for security leadership."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Cyber skills valued in chip ecosystem but secondary compared to design and manufacturing engineers."
      }
    }
  },
  "70e87b6e-f9a4-439e-b25f-959aa27e9b03": {
    "career": "Supply Chain Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Role supports manufacturing and mining exports but is not on core occupation list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "General demand for data-savvy professionals; no dedicated stream but points for STEM degrees."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Industrial exporters rely on data-driven logisticians; new points system favours STEM and German A2."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "RPJPN 2025-2045",
        "reason": "Nickel-to-battery supply chains create analyst roles in new industrial parks."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on list; employers may sponsor but without fast-track benefits."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Skills recognised under HSP points but language barrier limits SMEs sponsorship."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "NIMP 2030",
        "reason": "Plan emphasises supply-chain resilience for semiconductors and EVs, boosting analyst demand."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Skilled Migrant Category",
        "reason": "Analysts earn points but compete with Green-List engineers for visa caps."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Mega-projects and e-commerce growth drive need for advanced logistics analytics."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Singapore Economy 2030",
        "reason": "TradeTech initiatives seek analysts to optimise port, air-cargo and free-trade-zone flows."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Operation 300bn",
        "reason": "Manufacturing push plus DP World logistics hub demand optimisation expertise."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Advanced manufacturing clusters need analysts, yet role not on shortage list so visas costlier."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "CHIPS and Science Act",
        "reason": "Reshoring semiconductors requires analysts to redesign domestic logistics and inventory models."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "National Master Plan 2021-2030",
        "reason": "E-commerce and export manufacturing require data-driven logistics professionals."
      }
    }
  },
  "30049a3c-189f-4726-9857-5a79ea7be982": {
    "career": "Tourism Operations Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Migration Strategy 2023",
        "reason": "Regional tourism towns sponsor managers under state nomination despite absence from core list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Hospitality not a targeted stream; points possible under general pool only."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Hospitality skills valued but language requirement and saturation limit demand."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Bali and new capital Nusantara tourism zones recruiting experienced foreign professionals."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on list; small number of employer-sponsored permits possible."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Hotel staff covered at mid-skill SSW level, but management positions rare for foreigners."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "MADANI Economy",
        "reason": "Eco-tourism push creates some management roles, yet not a priority occupation."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Migrant Category",
        "reason": "Tourism key to GDP; experienced managers can secure visas with adequate points."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "NEOM, Red Sea and AlUla projects are hiring thousands of international tourism managers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Singapore Economy 2030",
        "reason": "Cruise and MICE sectors expand, creating limited but quality management openings."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi invest in high-end tourism and issue 10-year visas for sector leaders."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Hospitality roles removed from shortage list; sponsorship costly."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Indirect benefits through upgraded national parks, but no dedicated immigration priority."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "National Master Plan 2021-2030",
        "reason": "Tourism designated a growth pillar with new coastal resort zones needing skilled managers."
      }
    }
  },
  "3b6693c9-d714-4226-ae2b-6d3c4254f4ca": {
    "career": "International Business Lawyer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "Legal roles are employer-sponsored only and rarely make state priority lists."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Lawyers compete in general pool and must pass provincial bar exams after arrival."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Foreign lawyers face requalification and German language barriers to practice."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "RPJPN 2025-2045",
        "reason": "Can advise on international law but must partner with local advocates for court work."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Legal roles not on list; requalification through King's Inns required."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "MADANI Economy",
        "reason": "Cross-border Islamic finance creates niche demand, yet local partnership caps apply."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Skilled Migrant Category",
        "reason": "Limited demand; must retrain under NZ Council of Legal Education."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Vision 2030",
        "reason": "International firms expanding, yet new Saudization rules restrict foreign licence quota."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Economy 2030",
        "reason": "Foreign Legal Practitioner licence allows cross-border M&A and arbitration practice with minimal quotas."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "UAE Centennial 2071",
        "reason": "DIFC courts permit foreign lawyers to practise common law in English, easing entry."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Senior law services listed; Solicitors Qualifying Exam pathway open to foreign grads plus Skilled Worker visa."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Cross-border deal flow from clean-tech subsidies raises demand for trade and M&A counsel, but H-1B caps remain tight."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Foreign law firm licences available but market small and work visas limited."
      }
    }
  },
  "dadc435a-7269-4879-8915-01ae8eb95661": {
    "career": "Organizational Development Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "HR specialists require employer sponsorship and are rarely on state priority lists."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Business professionals welcome under general stream, but not priority occupation."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Possible Blue Card path, yet German-language HR regulations limit roles."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "RPJPN 2025-2045",
        "reason": "Localization rules cap foreign HR heads; advisory roles possible on projects."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "HR roles outside critical skills; must rely on general employment permits."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Highly Skilled Professional visa",
        "reason": "Cultural and language nuances make OD positions for foreigners niche."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "NIMP 2030",
        "reason": "Manufacturing upgrades need change-management talent but not on priority list."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Skilled Migrant Category",
        "reason": "HR roles qualify for points but compete with STEM for limited quotas."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Public-sector transformation programmes hire OD experts for Saudization and culture change."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Singapore Economy 2030",
        "reason": "Tech firms hire OD specialists but COMPASS points modest; quota tightened for generic HR."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Diversifying conglomerates invest in OD to retain multinational talent; Golden Visa possible for PhD holders."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Sponsorship possible but role not on shortage list, raising salary thresholds."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Clean-energy firms scaling fast need culture architects, yet no dedicated visa perks."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "National Master Plan 2021-2030",
        "reason": "FDI companies use locals for HR; visas issued case-by-case."
      }
    }
  },
  "3eb41996-f757-4c79-8ada-b20fb3602f78": {
    "career": "Systems Engineering Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Onshore defense and mining equipment programs list systems engineers as high demand."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Managers of complex engineering projects qualify under the expanding STEM priority stream."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Automotive, rail and defence OEMs urgently hire systems-engineering leads."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Future EV and infrastructure projects could absorb limited systems talent."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Med-tech and pharma manufacturing sites hire systems leaders though in smaller numbers."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics and semiconductor giants value systems expertise but language barriers remain."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Emerging semiconductor fabs need mid-level systems managers."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Niche fit; only a few defence and aerospace employers."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "NEOM and defence megaprojects require systems oversight but roles limited."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Manufacturing 2030",
        "reason": "Precision-engineering and defence primes hire experienced systems managers."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing push opens some demand for systems engineering managers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Aerospace, EV and defence clusters actively recruit senior systems engineers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Large federal spend on semiconductor, aerospace and defense projects needs experienced systems-engineering leadership."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Some opportunity in chip assembly plants, mostly at plant-engineering level."
      }
    }
  },
  "22235b4e-95b4-443d-99a2-0b7ecb2d5347": {
    "career": "Construction Technologist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Government pushes for digital twins and modular methods in large infrastructure builds."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "BIM-literate construction professionals can claim points under trades and tech streams."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "High demand for engineers using BIM in energy-efficient retrofits."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "RPJPN 2025-2045",
        "reason": "Nusantara new capital project opening doors for BIM specialists."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Shortage of tech-savvy construction managers for housing rebuild and earthquake resilience."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "NEOM, Red Sea and giga-projects aggressively hire digital construction experts."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Automation priority leans toward manufacturing rather than construction."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "We the UAE 2031",
        "reason": "Smart city and mega-tower plans favour BIM and drone-enabled site managers."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Demand exists but not on official shortage lists post-Brexit."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Digital-construction skills helpful but not explicitly prioritised."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National Master Plan 2021-2030",
        "reason": "Large infrastructure upgrades offer limited digital-construction roles."
      }
    }
  },
  "aaccbf48-0e70-422c-9f39-9aeeccd2e5f4": {
    "career": "Consulting Mathematician",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Migration Strategy 2023",
        "reason": "Demand exists in finance and mining analytics but limited numbers."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "AI and fintech clusters value mathematical consultants."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Industry 4.0 research institutes hire applied mathematicians."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Priority is industrial engineers not mathematicians."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Global quant funds and pharma modelling operations in Dublin need talent."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics and insurance sectors value high-end modelling."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Islamic finance analytics growing but still small."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Fintech and AI hubs at KAUST open niche consulting roles."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "National AI Strategy 2.0",
        "reason": "Quant finance and AI ethics teams depend on mathematical consultants."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "UAE Centennial 2071",
        "reason": "Financial services and space program require modelling specialists."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City finance, defence analytics and AI labs hire heavily."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Advanced modelling for AI, quantum and semiconductor R&D heavily funded."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Focus remains on engineering rather than pure modelling."
      }
    }
  },
  "fd13c0a8-93dd-4d52-b473-cebe4c633842": {
    "career": "Health Informatics Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "National Digital Health Strategy needs skilled informaticians."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Listed under healthcare tech; provinces actively recruit for EMR rollouts."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Hospitals racing to meet e-health records mandate."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Digital health in infancy; roles scarce."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "EHR roll-outs in HSE seek specialists."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Ageing population pushes for health IT but language limits entry."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "MADANI Economy",
        "reason": "Private hospitals digitising records present moderate demand."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Te Whatu Ora invests in unified digital health platform."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Mega-hospitals and telehealth startups recruit niche informatics roles."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Singapore Green Plan 2030",
        "reason": "Nationwide health data platform requires informatics specialists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Smart-hospital initiatives in Dubai and Abu Dhabi creating openings."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "NHS digital transformation urgently needs informatics talent."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Federal funding for hospital IT modernisation increases demand for informatics experts."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National Master Plan 2021-2030",
        "reason": "E-health pilots exist but budgets small."
      }
    }
  },
  "7020abf0-3299-4f2a-8838-cede17951da6": {
    "career": "Medication Safety Officer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Hospitals must appoint medication-safety pharmacists under national standards."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Pharmacist shortages; patient-safety leadership explicitly prioritised."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Aging population and strict EU pharmacovigilance require safety officers."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Hospital accreditation movement starting to create few roles."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharmacist shortage extends to safety leadership."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Pharma safety valued but language and licensure hurdles."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Private hospitals adopt medication-error reporting, limited specialised roles."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Small pool of qualified pharmacists for DHB safety teams."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "New tertiary hospitals seek Western-trained medication-safety leads."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Green Plan 2030",
        "reason": "Smart hospital programmes encourage dedicated safety pharmacists but in small numbers."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Accredited hospitals add safety posts to keep JCI status."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "NHS patient-safety strategy funds medication safety improvements."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Hospital improvement grants encourage dedicated medication-safety roles."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National Master Plan 2021-2030",
        "reason": "Medication safety mostly handled by general pharmacists."
      }
    }
  },
  "582fa1aa-dc61-4c09-9881-0333d3dfecec": {
    "career": "RF Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Electrical/telecom engineers appear on CSOL, covering RF roles for nationwide 5G build-out."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Electrical engineers recognised, but RF specialisation not explicitly prioritised."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Telecom equipment firms and automotive radar suppliers lobbied to add RF talent to shortage lists."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "RPJPN 2025-2045",
        "reason": "Spectrum planning for Nusantara smart-city opens some demand, but smaller market."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Growing semiconductor back-end cluster around Cork offers some RF roles."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Highly Skilled Professional visa",
        "reason": "5G/6G and automotive radar programmes qualify RF engineers for HSP fast-track."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Penang’s RFIC and antenna packaging ecosystem classifies RF engineering as a priority skill."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Generic electrical engineers in demand, but limited large-scale RF industry."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "NEOM smart-city and defence projects need RF, yet local talent pipeline growing."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Manufacturing 2030",
        "reason": "Sustained incentives for RF filter and IC fabs keep hiring brisk, though visas tightly managed."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Operation 300bn",
        "reason": "Dubai/Abu Dhabi satellite and telecom initiatives seek experienced RF designers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "National semiconductor task-force lists RF IC and antenna specialists as critical."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Massive federal funding for semiconductor and 5G/6G R&D makes RF design one of the core shortage areas."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Hanoi-Ho Chi Minh corridor courting RF front-end module suppliers."
      }
    }
  },
  "881b1508-0a65-438e-bc57-e53f260bf102": {
    "career": "Technical Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Electrical/software consultants can qualify, yet occupation lists prefer hands-on engineers."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Consultants ride in under generic STEM streams, not a stand-alone priority."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT consultants accepted, but sponsorship harder without concrete product skills."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "RPJPN 2025-2045",
        "reason": "Nusantara capital move opens specialised consulting gigs but sporadic."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Only senior cloud consultants flagged; generalists compete with EU talent."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Mega-projects outsource plenty of tech advisory work to foreign firms."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "National AI Strategy 2.0",
        "reason": "High-end digital consultants welcomed under Tech.Pass but quotas tight."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Operation 300bn",
        "reason": "Dubai’s free-zones court consultants for digital transformation contracts."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Consultants in AI, clean energy, and defence secure Skilled-Worker visas."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Large federal programmes need external tech advisors but no dedicated visa channel."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "cf432092-38c5-4e69-81ec-d4e28aef390f": {
    "career": "TESOL Educator",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Regional schools seek ESL specialists for migrant communities."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Early-childhood and K-12 teacher shortages include ESL streams, with extra points for French or rural."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Bilingual initiatives in Grundschule and vocational colleges add English teachers to opportunity card."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Asta Cita",
        "reason": "Tourism regions need ESL staff for 2045 vision; permits limited to degree-holders."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "JET and eikaiwa centres constantly hire foreign English instructors outside SSW quotas."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "International schools hire, but government prefers local teachers in public sector."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Primary and secondary teachers on Green List; ESL counted under English specialisations."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Private international schools recruit ESL teachers, but supply is robust."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Booming ESL private sector—centres sponsor teachers easily."
      }
    }
  },
  "43b6d9f4-b56d-4e9c-aebd-166bca9c0f2b": {
    "career": "Cultural Liaison",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Indigenous engagement and Asia-Pacific projects need liaisons, but roles are niche."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Multicultural policies create some demand in settlement agencies."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Tourism islands and new capital agency employ liaisons for foreign investors."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Firms expanding overseas need bilingual cultural experts for negotiations."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Tourism and entertainment megaprojects recruit liaisons for expatriate coordination."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "Regional HQs require cultural mediators, yet EP criteria favour domain specialists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Hyper-diverse workforce in Dubai needs cross-cultural facilitators for events and hospitality."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries export roles occasionally require culture brokers."
      },
      "united_states": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "d0859ff8-5f78-4181-aa93-a5418ac5d46f": {
    "career": "Eco-Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Migration Strategy 2023",
        "reason": "Solar, hydrogen, and mine-rehab projects list environmental engineers on occupation lists."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Renewable-energy and climate-adaptation engineers receive extra CRS points under environmental streams."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Energiewende demands engineers for wind, hydrogen, and circular-economy plants."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "RPJPN 2025-2045",
        "reason": "Nickel-EV boom conditioned on strict environmental management."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Some demand in wind farms and water treatment, but numbers small."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-city and renewable projects count toward HSP points."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "MADANI Economy",
        "reason": "Palm-oil waste valorisation and solar fabs seek eco-engineers."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Infrastructure resilience and offshore wind place eco-engineers on Tier 2 green list."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "NEOM and Red Sea projects mandate stringent environmental compliance."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Green Plan 2030",
        "reason": "Urban sustainability and carbon services hub hire eco-engineers for lifecycle analysis."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Masdar City and COP28 legacy investments chase sustainability talent."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Offshore wind, nuclear, and CCUS clusters treat environmental engineers as shortage roles."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Hundreds of billions for clean-energy and carbon projects drive urgent need for environmental engineers."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "National Master Plan 2021-2030",
        "reason": "Offshore wind and LNG-to-power plants require environmental assessment experts."
      }
    }
  },
  "f9f6efa6-2231-4003-8d1f-cfc7d767c0b2": {
    "career": "Fantasy Writer",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Canada funds arts through grants, yet writers are outside Express Entry priority lists."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Literary heritage strong yet not on Critical Skills list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "World-leading publishing sector but no dedicated visa route for writers."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Big publishing houses and streaming studios hire genre writers, but no immigration preference exists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b6259906-fcdd-42ac-adf5-96a0ad02551b": {
    "career": "Financial Mathematician",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Migration Strategy prioritises core tech; finance quants sit outside list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Financial quants welcome, yet not named in category-based Express Entry."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "General points system can admit quants but not a named shortage occupation."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List names quantitative analysts and risk modellers."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Can qualify via points, but financial maths not a government focus."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "MADANI Economy",
        "reason": "Islamic-finance hub needs quants but role not on priority list."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "National AI Strategy 2.0",
        "reason": "Quantitative finance aligned with AI-driven fintech growth, but not top-tier manufacturing focus."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "We the UAE 2031",
        "reason": "DIFC attracts algorithmic-trading and risk-model talent under fintech push."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Financial-services pillar explicitly seeks quants for City of London."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "High Wall Street demand but not covered by CHIPS/IRA/IIJA."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "ceeb6e3f-9ab7-4a59-8add-a2a6ee0da8f2": {
    "career": "ICT Project Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Software and cyber roles on CSOL; project managers accepted under ANZSCO 135112."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "IT managers receive extra CRS points under tech category."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialists, including PMs, get streamlined Blue Card and opportunity card routes."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Digital-nation goals create openings, but local talent pipeline growing."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "ICT managers appear on the list for pre-approved permits."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Points-based route available, but Japanese-language barrier remains."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "NIMP 2030",
        "reason": "Industry 4.0 roll-outs need PMs though focus is on engineers."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Migrant Category",
        "reason": "Points system welcomes experienced PMs but not listed on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Large digital-transformation projects need PMs, yet Saudization quotas apply."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Singapore Economy 2030",
        "reason": "Tech PMs hired, yet policy spotlight is on deep-tech engineers not managers."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Operation 300bn",
        "reason": "Digital infrastructure megaprojects require experienced IT leaders."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Digital project managers qualify under SOC 213."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Strong demand in private sector; no dedicated federal talent policy."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National Master Plan 2021-2030",
        "reason": "Foreign IT managers hired for rapid tech expansion."
      }
    }
  },
  "e395ed7e-c2ac-420b-90d8-a95111e083e1": {
    "career": "Policy Economist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Roles exist within Treasury but not on CSOL."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Federal and provincial governments run ongoing economist competitions; French fluency adds points."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Points system admits economists yet shortage list favours STEM."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Central Bank and ESRI hire economists, but not on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Visa possible, yet language barrier limits policy involvement."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Economy 2030",
        "reason": "Economic Development Board and MAS value analytical economists for industrial policy."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Strategic planning units hire economists, yet no dedicated visa lane."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Government Economic Service runs fast-stream; global talent visa open to researchers."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "",
        "reason": "Think-tanks and federal agencies constantly recruit economists, though no special visa preference."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "ebcb7491-3971-4c92-8bc6-a87c16585b8d": {
    "career": "Political Systems Instructor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Higher-education visas available yet Migration Strategy targets STEM."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Faculty hiring steady, but not on Express Entry priority list."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Universities can sponsor, but humanities not a shortage field."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Universities can sponsor but role not on Critical Skills list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Economy 2030",
        "reason": "Autonomous universities hire globally but prioritize tech research."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "International campuses hire faculty, but no immigration priority."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Global Talent visa covers academia; universities seek political science lecturers."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Universities sponsor H-1B for social-science faculty despite no federal priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "c43f28b1-25a0-43f5-8b49-86f19db71bee": {
    "career": "Public Service Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL allows state nomination for senior managers yet demand is modest and competitive."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Public-administration managers can qualify under general Express Entry but are not a flagged priority occupation."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Municipalities hire international managers for digitalisation projects, but language and local-law hurdles keep demand moderate."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Mega-projects (NEOM, Red Sea) recruit global public-sector leaders for governance and city administration."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Economy 2030",
        "reason": "Public Service Division occasionally hires global experts for digital-government initiatives, but numbers are small."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Federal and emirate governments import experienced managers to build world-class public services."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Civil-service fast-stream open to foreigners only in narrow cases; local experience preferred."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Federal and state agencies scaling infrastructure projects need experienced managers although role is not on shortage lists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "7376d741-e0ef-4c2e-9380-f9b8a8b0ea27": {
    "career": "Sports Media Producer",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Creative occupations can immigrate via general stream but lack priority points."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Kingdom invests heavily in sports events and entertainment, importing senior media producers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "SportsHub and regional broadcasters import specialised producers, but quotas are small."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi sports channels seek global producers for cricket, F1 and UFC coverage."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative Industries are a named pillar; Sky Sports and BBC recruit international production talent."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Digital-broadcast build-outs around new stadiums spur niche demand, but no formal shortage listing."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4c72bd82-d3e2-496f-9ad4-bb9648ea2b27": {
    "career": "Aircraft Systems Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Defence and civil-aviation projects recruit aerospace engineers through state nomination."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Aerospace clusters in Quebec and Ontario seek engineers but occupation not on fast-track list."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Airbus and Lufthansa Technik face shortages of systems engineers, eased by revised visa rules."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "State aircraft maker PTDI and drone initiatives look overseas for expertise."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "MRO operations exist but focus on technicians more than design engineers."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Highly Skilled Professional visa",
        "reason": "Mitsubishi Heavy and JAXA recruit foreign experts for next-gen spacecraft and UAVs."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan targets aerospace exports; foreign engineers welcomed for design and avionics."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Rocket Lab hires niche talent, but numbers are limited."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Vision 2030",
        "reason": "Military aviation and new airlines (RIA) source foreign aerospace engineers for rapid expansion."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Manufacturing 2030",
        "reason": "Aerospace MRO hub relies on imported engineers for avionics and predictive-maintenance systems."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Operation 300bn",
        "reason": "Al Ain aerospace cluster and Emirates Engineering import systems specialists to build local manufacturing capacity."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Tempest future fighter and civil-aviation decarbonisation put aerospace systems on the shortage list."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds aerospace R&D, hypersonics and space exploration, driving demand for flight-critical systems engineers."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Emerging aerospace parts suppliers need systems know-how alongside electronics."
      }
    }
  },
  "044eb057-8588-4d11-ae50-d92dcc7b22e9": {
    "career": "Comparative Literature Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Group-of-Eight universities recruit PhD holders, though positions are limited."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Universities use permanent residency stream to hire international humanities academics."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Excellence Initiative grants fund comparative literature departments that sponsor foreign researchers."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Humanities PhDs obtain Critical Skills visas via university sponsorship."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "International faculty roles exist in English-language programmes."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Smaller academic market offers occasional lectureships."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Economy 2030",
        "reason": "NUS and NTU fund multicultural literature studies aligning with soft-power goals."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "UAE Centennial 2071",
        "reason": "NYU Abu Dhabi and Sorbonne Abu Dhabi sponsor niche research faculty."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Russell Group universities hire but cuts in arts funding keep competition fierce."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act allocates broad research funding to universities, sustaining humanities tenure tracks for top scholars."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "faf709d9-8e6c-440d-b5f8-c572e7565e4a": {
    "career": "International Historian",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Sector hires global historians for Asia-Pacific research, but positions are limited."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Universities sponsor tenure-track historians through permanent residency pathways."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Leibniz Institutes and DAAD programmes actively recruit foreign history scholars."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "History departments leverage Critical Skills Visa for niche areas like Asian studies."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Foreign scholars fill English-language world-history courses at national universities."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Smaller universities occasionally advertise history lectureships for international applicants."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Economy 2030",
        "reason": "Asian Civilisations Museum & NUS hire global historians for heritage diplomacy."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "UAE Centennial 2071",
        "reason": "International branch campuses need cross-cultural history faculty."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Russell Group continues to value global historians despite Brexit hiring complexities."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "US universities continue to fund area-studies chairs, leveraging soft-power budgets."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "ebf5876b-7518-486d-b9c2-db2b40e1d967": {
    "career": "Physics-Math Teacher",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Physics and maths teachers on CSOL and state migration lists."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Secondary-school teachers explicitly prioritised; French bilingual teachers get bonus points."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe shortage of STEM Lehrkräfte; fast-track Blue Card if degree recognised."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "N/A",
        "reason": "STEM teacher gaps exist but not on Critical Skills list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Secondary maths/physics teachers on Tier-1 Green List with straight-to-residence pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "International schools in new giga-projects hiring expatriate STEM teachers."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Demand in premium CBSE/IB schools but no dedicated immigration priority."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Physics teachers were on shortage list; rules tightening yet visas still possible."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "N/A",
        "reason": "Chronic STEM-teacher shortages but no special federal visa channel."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a2423f0b-f7c5-4a20-bae7-b2f4039f0405": {
    "career": "Practice Nurse",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Registered nurses on almost every state occupation list with PR pathways."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "RNs top priority; provinces run fast-track ‘Nurse Connect’ streams."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Massive Pflegekraft shortage; offers accelerated visas and language training."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "N/A",
        "reason": "Preference for domestic nurses; wage levels low for expatriates."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "RNs on Critical Skills; 4-year work-to-stay path."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Nursing-care visas available, but language exam is tough."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "MADANI Economy",
        "reason": "Private hospitals import some foreign nurses; bureaucratic approvals slow."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Straight-to-residence for registered nurses across specialities."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Large hospital expansion hiring expatriate nurses with tax-free salaries."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Green Plan 2030",
        "reason": "MOH recruits foreign nurses but tight quota and rising localisation."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Private hospital clusters in Dubai/Abu Dhabi recruiting foreign RNs."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "NHS international recruitment programmes but pay restraint and visa fees."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "N/A",
        "reason": "High demand for RNs but caps on EB-3 visas and state licensure hurdles."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "N/A",
        "reason": "Local supply sufficient; foreign nurse licensing rare."
      }
    }
  },
  "acb70288-901b-4395-8fd1-0255ffec644b": {
    "career": "Social Care Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Universities can sponsor but not on core occupation lists."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "SSHRC funding and research visas for social policy analysts."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Blue Card possible for PhDs; limited quotas for social sciences."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "N/A",
        "reason": "Academic posts available but not on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Highly Skilled Professional visa",
        "reason": "Possible via university sponsorship but language is barrier."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Migrant Category",
        "reason": "Academic roles qualify under points test but not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "N/A",
        "reason": "Social research largely contracted to local universities, Arabic required."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National AI Strategy 2.0",
        "reason": "Social sector research clusters growing, but quota tight."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "N/A",
        "reason": "Think-tank roles exist but tiny market, no priority visa."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Research councils fund social-care innovation; Global Talent visa route open."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds behavioural & social-science grants; universities sponsor H-1B visas."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "5973ae31-1bad-4e78-90ef-31089e778ece": {
    "career": "Social Neuroscience Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Migration Strategy 2023",
        "reason": "Global Talent visa stream covers neuroscience researchers."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Tri-Council grants prioritise neuro-AI; universities offer tenure-track for PhDs."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Max Planck and Charité expand social brain labs; Blue Card fast-track."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Neuroscience within med-tech R&D priority; SFI grants attract post-docs."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Highly Skilled Professional visa",
        "reason": "RIKEN Brain Science Institute recruits foreign PhDs with point-based HSP visa."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "NIMP 2030",
        "reason": "Plan emphasises semiconductors and medical devices, not fundamental brain research."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Small but growing neuroimaging groups; points-based route only."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Some KAUST labs, but hiring focuses on AI engineering, not social neuro."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Economy 2030",
        "reason": "A*STAR and Duke-NUS fund social neuro-AI projects; competitive but well-funded."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Operation 300bn",
        "reason": "Research funding targets space and biotech manufacturing more than academic neuroscience."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences ‘Brain Health Mission’ funds & fast-track Global Talent visas."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Billions for brain, AI and behavioural research; NIH and NSF fund labs that sponsor visas."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "3881fc09-149e-442e-b9d2-8ea98d0a37ac": {
    "career": "Sport Sociologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Sports-science research valued but not on core lists."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "SSHRC funds sport & inclusion research; academic immigration possible."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Universities can sponsor, limited demand outside elite institutes."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "N/A",
        "reason": "Limited university chairs; immigration possible but competitive."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Highly Skilled Professional visa",
        "reason": "Niche research pockets; language barrier high."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Migrant Category",
        "reason": "Small academic market, some roles in high-performance sport units."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Vision 2030",
        "reason": "Sport expansion focuses on event management, not sociological research."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "N/A",
        "reason": "SportSG funds applied analytics, limited sociological research roles."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "We the UAE 2031",
        "reason": "Sport initiatives hire marketers and coaches, few research posts."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "UK Sport funds social-impact studies; Global Talent visa possible."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "CHIPS and Science Act",
        "reason": "Grants fund societal impacts of AI in sport; universities sponsor visas."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4ae6d0e8-7aba-4c75-9a74-ba5160aef6d6": {
    "career": "Academic Tutor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "",
        "reason": "Migration lists target school teachers and STEM trainers, tutors only indirectly useful."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Programme covers K-12 teachers, not private tutors; some overlap in demand for French/Math support."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Juku (cram-school) boom sustains demand, but workers enter on generic Instructor visas, not priority."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Green List includes primary and secondary teachers, not off-school tutors."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Huge tuition industry, but MOM treats tutors as S-Pass applicants, not strategic talent."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "41",
        "policy": "We the UAE 2031",
        "reason": "After-school tutoring popular with expatriates, but employers prefer locally based freelancers."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "47",
        "policy": "",
        "reason": "Shortage list removed teaching; tutoring is market-driven gig work."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Private tutoring supports workforce up-skilling but is outside federal talent programmes."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "78aada17-f446-4243-8ee8-eef3837611f5": {
    "career": "Artistic Director",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Creative workers can enter on entertainment visas, outside CSOL."
      },
      "canada": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Freelance Künstler visa in Berlin attractive but not priority."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "",
        "reason": "Cultural visas available, but demand moderate and language heavy."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Massive investment in entertainment districts needs high-profile creative leadership."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Esplanade, Mediacorp and gaming studios import some top creative leads, but not a strategic category."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Government pushes Dubai-Abu Dhabi as regional media hubs, actively recruiting artistic directors."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry senior roles explicitly listed as priority talent."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "O-1 visas possible for noted creatives, but no federal priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "1699e9d3-2588-4612-bcef-a5e1c843b6d6": {
    "career": "Biodiversity Conservationist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Migration Strategy 2023",
        "reason": "Nationwide threatened-species plan makes ecologists and conservationists priority under environmental scientist codes."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Federal parks and Indigenous stewardship projects need conservation scientists, especially French-speakers."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Renewables expansion requires biodiversity offset experts."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "RPJPN 2025-2045",
        "reason": "Forest conservation tied to climate finance, a few foreign expert consultancies."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "",
        "reason": "Peatland restoration and EU Natura sites need ecologists, yet outside Critical Skills list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "59",
        "policy": "MADANI Economy",
        "reason": "Rainforest protection grants some NGO jobs, but immigration paths general."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Kiwi recovery, predator-free programme list conservation scientists on Tier 1."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Nature reserves in NEOM recruit some ecologists, but small numbers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Singapore Green Plan 2030",
        "reason": "City-in-Nature goal opens NPark ecologist roles, but limited slots."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "We the UAE 2031",
        "reason": "Mangrove restoration and wildlife sanctuaries create limited specialist slots."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Post-Brexit farming payments reward biodiversity, raising demand but not formally prioritised."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds habitat restoration and climate resilience roles, boosting conservation hiring."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "53",
        "policy": "National Master Plan 2021-2030",
        "reason": "Plan names biodiversity, but hiring focuses on local graduates."
      }
    }
  },
  "9731e1a7-cc1a-4bc5-8e87-87ccd6e94592": {
    "career": "Building Surveyor",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Licensed building surveyors are explicitly on state occupation lists due to housing boom."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Construction trades priority indirectly covers building inspectors."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Bauüberwachung specialists needed for energy-efficient retrofits."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital Nusantara needs compliance staff, but localisation preferences."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "",
        "reason": "Housing-for-All plan lifts demand though role not on Critical list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "NIMP 2030",
        "reason": "Industrial park expansion needs QA inspectors, but foreign hiring limited."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Leaky-building crisis makes building surveyors Green-List Tier 1."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Mega-projects require code compliance experts, but civil engineers prioritised higher."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "BCA tightens building safety requiring registered inspectors; EP quotas still selective."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Operation 300bn",
        "reason": "Construction boom keeps demand, yet visas bundled under civil engineer codes."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "",
        "reason": "Persistent shortage of chartered building surveyors; attracts Skilled-Worker sponsorship."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Rebuild wave needs inspection professionals, yet no special visa category."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "National Master Plan 2021-2030",
        "reason": "Urban redevelopment seeks some international expertise, not priority."
      }
    }
  },
  "a9bdadaa-fb27-4076-8a17-98e392a141b2": {
    "career": "Construction Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Nationwide shortage of civil/construction engineers on priority list."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Civil and construction engineers receive extra CRS points."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Aging infrastructure and Energiewende boost demand for Bauingenieure."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "New capital city and EV infrastructure create acute shortage."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Civil engineers remain on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Construction engineers can get SSW2 status but language barrier high."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "NIMP 2030",
        "reason": "Industrial parks need engineers, yet locals preferred."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Civil engineers Tier 1, but competition for limited slots."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "NEOM, Red Sea and giga-projects aggressively recruit construction engineers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "EP quotas tight; strategic focus on advanced manufacturing, not generic construction."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Operation 300bn",
        "reason": "Massive real-estate and industrial build drives ongoing demand."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Construction engineers removed from shortage list in 2025, but demand persists via employers."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Trillion-dollar rebuild funds highway and bridge engineers."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "National Master Plan 2021-2030",
        "reason": "Transport megaprojects seek foreign civil engineers."
      }
    }
  },
  "acc9c8af-c3b6-4206-88cb-5ab85e0816d7": {
    "career": "Entrepreneurship Advisor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Strategy backs start-ups, but occupation lists focus on technical skills, not business mentors."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Canada welcomes entrepreneurs, yet advisory roles are not shortage-listed; immigration possible under self-employment or consulting."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Consultants can qualify if salaried, yet no dedicated shortage code for entrepreneurship advice."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Government accelerators for EV and fintech need mentors, yet work-permit rules still favour technical hires."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Enterprise Ireland supports founders, but advisers are not on the critical list; general consultant pathway possible."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points for business managers exist, yet demand skews toward deep-tech founders over external mentors."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan nurtures tech SMEs; international advisers welcome but not priority visa."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Possible points for management consultants, but not a named Green List shortage."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Vision 2030",
        "reason": "Massive investment in incubators for tourism, fintech and smart-city projects requires start-up coaches and accelerators."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Economy 2030",
        "reason": "Entrepreneur Pass (EntrePass) specifically targets founders & advisors guiding AI, fintech and deep-tech start-ups."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "UAE Centennial 2071",
        "reason": "Government-backed free zones and Operation 300bn aggressively recruit mentors for SME and tech-entrepreneur ecosystems."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Strategy funds scale-ups, yet immigration list covers tech specialists rather than business advisers."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "CHIPS and Science Act",
        "reason": "Start-up mentoring supports semiconductor and advanced-tech founders but is an indirect, advisory role not explicitly listed."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "National Master Plan 2021-2030",
        "reason": "Startup hubs in Ho Chi Minh City invite mentors informally; no dedicated immigration channel."
      }
    }
  },
  "2594a6ed-f402-4d08-bee7-6c86362e5278": {
    "career": "German Culture Specialist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Cultural mediators and translators can obtain visas; demand moderate for heritage promotion and tourism."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Tourism mega-projects recruit international culture advisors to curate European exhibits."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "We the UAE 2031",
        "reason": "Museums like Louvre Abu Dhabi occasionally hire European culture curators."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4e8df4f1-bcdf-4429-96a0-e0cb83ad251d": {
    "career": "German Literature Scholar",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "Academic visas exist; humanities not on core skills list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities can sponsor humanities professors, but no shortage points."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "German universities value international literary scholars and offer research visas."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Academic roles can sponsor, yet not on critical list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Economy 2030",
        "reason": "NUS and NTU occasionally open humanities chairs; still niche."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Private universities occasionally hire European literature faculty."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "University lecturing visas possible, but not shortage-listed."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "CHIPS and Science Act",
        "reason": "Academia is generally open, though not a target of tech-focused funding."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "6ec70d89-ddaa-4216-be5d-51b10e36f656": {
    "career": "Human Development Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Roles exist in NGOs and government, but not on Core Skills List."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Government needs policy analysts for Indigenous and immigrant development programs."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Bundesagentur hires labour-market researchers; demand moderate."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "RPJPN 2025-2045",
        "reason": "Plan stresses human capital; consultants needed but immigration path general."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Economic-development agencies hire analysts; not shortage coded."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "MADANI Economy",
        "reason": "Government think tanks hire policy researchers for inclusive-growth agenda."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Policy analysts qualify for points but no Green List priority."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Government is aggressively importing experts to design education, labour and social-welfare reforms."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Economy 2030",
        "reason": "SkillsFuture initiatives create limited openings for policy specialists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "We the UAE 2031",
        "reason": "Human-capital development is a flagship pillar; think tanks recruit international specialists."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Federal funds include workforce development, opening policy-analyst roles though not shortage-listed."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National Master Plan 2021-2030",
        "reason": "International NGOs recruit advisors for rural human-development programs."
      }
    }
  },
  "c712c18d-6453-4025-bea2-480c82821227": {
    "career": "Human Rights Advocate",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Express Entry Category-Based Selection",
        "reason": "NGOs can sponsor, and French-speaking advocates get bonus points."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Berlin hosts many NGOs; specialists qualify under general academic visa."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "RPJPN 2025-2045",
        "reason": "NGO advocacy possible, but permits require local partnerships."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "NGO visas possible, but not on critical list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Human-rights lawyers can enter via Skilled Worker visa, though not shortage."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Non-profits continue hiring for environmental-justice monitoring linked to IRA projects."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "793907dc-bcd0-45ab-986f-fded230c4deb": {
    "career": "International Development Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Government aid program is small; demand exists mainly through NGOs rather than migration lists."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Consulting skill-sets welcome, yet development is not a listed shortage occupation."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "German Development Bank (KfW) uses such experts, but they are outside the Skilled Immigration Act list."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Massive development spending creates steady consultancy contracts with multilaterals."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Government seeks expertise for inclusive growth programs, but prefers local talent."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Mega-projects need social-impact consultants to meet sustainability and global donor standards."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Regional HQs of NGOs hire, but the occupation is outside core national priority sectors."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Abu Dhabi and Dubai fund regional development initiatives and contract advisory firms."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "FCDO and big consultancies recruit, but the job is not on shortage lists."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "USAID and MCC regularly hire consultants, but the role is not named in federal priority legislation."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "National Master Plan 2021-2030",
        "reason": "Large infrastructure and poverty-reduction plans occasionally hire foreign advisors."
      }
    }
  },
  "6fb7af8a-e8eb-4271-976f-0eab85f9dad4": {
    "career": "Literary Critic",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Cultural grants exist yet critics are not on category-based selection lists."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "English-language publishing scene exists, but critics not in National AI Strategy priority."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "London’s publishing hub offers roles, yet critics are outside the official shortage lists."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Large publishing and media market supports critics, but no immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "22",
        "policy": "",
        "reason": ""
      }
    }
  },
  "145d2d01-5058-4469-bfc2-6acbaa28cd21": {
    "career": "Painter",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Berlin’s artist visa offers limited residency options, yet not tied to Skilled Immigration Act."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Vision 2030",
        "reason": "New museums and cultural districts need resident artists, but opportunities remain niche."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Residencies at Gillman Barracks exist but painters are outside core policy focus."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Dubai Culture funds residencies; still not a strategic occupation."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries are valued, yet painters aren't on shortage lists."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "O-1 artist visa exists, but painters are not policy priorities."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "26",
        "policy": "",
        "reason": ""
      }
    }
  },
  "ae96ee41-4b1d-4bb9-a572-dc03cbdc9972": {
    "career": "Payroll Officer",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Occupation codes eligible under accounting clerks, but not priority category."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Some shortage of payroll specialists in Mittelstand, yet not officially listed."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "HQ hub needs payroll talent, but EP quotas tight and role not in priority tech list."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "UAE Centennial 2071",
        "reason": "Large multinationals need payroll staffs, but no strategic focus."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "",
        "reason": "Payroll officers fall under general admin, not shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Demand exists, but automation and lack of federal priority keep visa chances slim."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "43d49c28-9de1-4559-910a-f88fe7edb605": {
    "career": "Public Health Advisor",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "Public health is part of critical healthcare skills on CSL and state nomination lists."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Public-health professionals fall under healthcare shortage categories with fast-track PR."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Health authorities face shortages in epidemiology and health policy."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nationwide health reforms create contract roles for technical advisors."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Health Service Executive recruits, yet not on Critical Skills list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "MADANI Economy",
        "reason": "Government targets better health outcomes; foreign expertise valued but quota limited."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Epidemiologists and health advisors are listed for direct residency pathways."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Saudi CDC and NEOM projects hire public-health experts to modernise the system."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "MOH Office for Healthcare Transformation engages experts, but not a top-tier shortage."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "We the UAE 2031",
        "reason": "Dubai Health Authority recruits for population health and pandemic preparedness roles."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "UKHSA hires epidemiologists, but recent visa tightening keeps it off shortage list."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "",
        "reason": "CDC and state agencies recruit, but role not named in federal priority acts."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "NGO and WHO projects hire advisors, yet immigration still cautious."
      }
    }
  },
  "2fc860fe-577b-49fb-abfe-bc460dd6b9e1": {
    "career": "Quantitative Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Math professionals are eligible, but Sydney’s smaller trading desks limit openings."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Express Entry now highlights AI/data scientists; Toronto/Montreal finance houses hire quants."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Blue Card for mathematicians; Frankfurt banks need risk quants but scale modest."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech growth needs data risk skills, but deep-quant roles limited."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Dublin hedge-fund and big-tech cluster prizes quantitative analysts."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP grants fast residence to AI/quant researchers for Tokyo banks and labs."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "Islamic finance pushes analytics, but high-frequency research teams are few."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Niche opportunities in a tiny capital-markets ecosystem."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Growing fintech plans require risk modelers, yet market is early-stage."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "National AI Strategy 2.0",
        "reason": "Fintech hub MAS supports quants, but tight EP quotas keep it Tier 2."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "UAE Centennial 2071",
        "reason": "Sovereign funds and DIFC fintechs aggressively recruit global quant talent."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London lists digital/AI finance; sponsored visas processed quickly."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Heavy federal AI funding and Wall Street demand make the U.S. the premier hub for PhD-level quants."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Government woos AI talent; sophisticated quant finance yet to mature."
      }
    }
  },
  "59ce23a8-14bf-4383-b6f5-ae4acef5e5ad": {
    "career": "Veterinary Educator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Veterinarians appear on CSOL; PhD educators qualify under academic stream."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Healthcare stream awards extra points to licensed veterinarians with teaching experience."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "STEM lecturers, including animal science, can obtain EU Blue Card."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Single vet school limits vacancies; not on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "PhD vets meet HSP points, but language a barrier."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Veterinarians are Tier 1; Massey University actively recruits overseas educators."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Agri-tech universities seek vet faculty, but positions handful."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Royal Veterinary College hires internationally yet role not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Vet schools face faculty shortages, but no dedicated federal immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "2cca1887-166b-476a-a596-25254ca37907": {
    "career": "Art Critic",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Berlin art scene attracts foreigners on artist visas, but limited quotas."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "State arts funding limited; immigration points favour tech."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Language barrier; some opportunities in bilingual publications."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "London’s media and galleries employ critics, yet role absent from shortage lists."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Large media and gallery scene; O-1 visa possible but no formal priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "387b7664-e518-4a7c-ad03-f15a2696c032": {
    "career": "Community Nutritionist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Nutritionists appear on CSOL for aged-care and public-health roles."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Dietitians flagged as healthcare shortage; provincial nominee streams fast-track."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Public-health dietitians get EU Blue Card; aging population boosts demand."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Community nutrition largely NGO-driven with low expatriate hiring."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "HSE hires but role not on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Language and licensure hurdles limit foreign dietitians."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Government wellness campaigns create some openings; immigration quotas tight."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Dietitians on Tier 2 list; work-to-residence after two years."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "National obesity programs need nutritionists, yet preference to nationals."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Green Plan 2030",
        "reason": "Health Promotion Board hires dietitians, but quota limits foreign intake."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Private hospitals and wellness resorts sponsor licensed dietitians."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "NHS recruits dietitians internationally, but occupation removed from shortage list in 2025."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "State health departments hire dietitians but role not federally prioritised."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Public-health roles mainly localised."
      }
    }
  },
  "fa74d5f9-8069-4f04-a7c6-6510090768ef": {
    "career": "Conservation Officer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Regional ranger roles eligible for skilled visas protecting unique biodiversity."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Provincial streams list park wardens and fishery officers for expedited residency."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "State conservation agencies sponsor environmental protection officers under STEM category."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "RPJPN 2025-2045",
        "reason": "Anti-poaching units in national parks recruit limited international experts."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "National Parks hire occasionally; immigration priority low."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Language and civil-service rules restrict foreign ranger hiring."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Forest-reserve protection aligns with green agenda; limited but present demand."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "DOC lists rangers on Tier 2 with fast path to residence."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Green Plan 2030",
        "reason": "NParks hires some foreign officers, but small land area restricts numbers."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Environment Agency and NGOs hire officers, but not on shortage list."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Climate funds expand National Park Service hiring, but no formal shortage list."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National Master Plan 2021-2030",
        "reason": "Government boosts biodiversity efforts; few foreign hires so far."
      }
    }
  },
  "3933381a-a3ec-4a74-8b0b-1ae786db218a": {
    "career": "Environmental Health Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "“Environmental Consultant/Scientist” on CSOL owing to mine-site remediation and climate adaptation projects."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "STEM stream covers environmental scientists but quota favours software and healthcare first."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Renewable build-out needs some health-risk assessors but role not named on priority list."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV battery projects require impact studies but expat visas limited outside engineering."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List focuses on pharma, ICT and civil engineers; environmental health only sometimes sponsored."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP prioritises semiconductors and AI; environmental health treated as regular, slower pathway."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "41",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Green compliance needed in fabs but no dedicated fast-track for environmental health roles."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "‘Environmental Scientist’ sits on Tier-2 Green List for water quality and biosecurity oversight."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Megaproject EIAs create pockets of demand yet local hiring preferred for cost."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Singapore Green Plan 2030",
        "reason": "Carbon management and urban-health monitoring create mid-level demand for environmental health scientists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Mandatory ESG reporting spurs hiring of environmental health experts in industrial free zones."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Offshore wind expansion needs environmental risk reviews but not on formal shortage list."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds Superfund clean-ups and community air monitoring, boosting demand for exposure-assessment scientists."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Focus on manufacturing; environmental health hiring small and largely local."
      }
    }
  },
  "08cfd5fb-f066-4268-bf68-1ac3e7aae464": {
    "career": "Interactive Media Developer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "“Software Engineer” shortage pathway covers interactive media developers."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Software developers fast-tracked; Montréal and Vancouver gaming clusters hungry for talent."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Berlin-Hamburg game studios use new fast Blue Card rules for IT specialists."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Digital-economy drive widens need for app and game developers."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Software developers get two-year critical-skills permits; gaming and fintech booming in Dublin."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Game majors recruit, yet HSP quota focuses on robotics and semiconductors."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Government promotes digital content but priority funding goes to semiconductor sector."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Software engineer category offers residence, though local studios are small."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "NEOM and entertainment zones invest in metaverse and interactive experiences."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "National AI Strategy 2.0",
        "reason": "Metaverse R&D grants support interactive media though AI engineers still priority."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Operation 300bn",
        "reason": "Dubai metaverse strategy boosts demand for immersive media coders."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-tech visas exist, but caps favour AI and advanced manufacturing."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Large private market but no dedicated visa priority for game or web developers."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "National Master Plan 2021-2030",
        "reason": "Mobile gaming and e-commerce expansion creates solid but mid-level demand."
      }
    }
  },
  "9ec6bb21-b24d-4944-a6ca-f52b661d908c": {
    "career": "Physiotherapy Practitioner",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Physiotherapists on CSOL; state sponsorships plentiful for rural clinics."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Allied health stream prioritises physiotherapists for permanent residency."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe rehab staff shortages; language-proficiency is main bottleneck."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Regulations favour local practitioners; limited expat roles."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Physiotherapists remain eligible; public hospitals offer relocation packages."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Growing private hospitals but no special visa pathway for physios."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Tier-1 listing grants fast residence for qualified physiotherapists."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Medical-tourism hospitals and sports academies import experienced physios."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "MOH hires foreign physios case-by-case; quotas tightening."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "We the UAE 2031",
        "reason": "Private hospitals and Dubai sports clubs actively recruit licensed physiotherapists."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "List narrowed in 2025; physio sponsorship possible but fewer trusts qualify."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Chronic pain and ageing boom creates hiring, but visa caps and licensing hurdles remain."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Local graduates meet most demand; foreign hiring rare."
      }
    }
  },
  "0347eb16-e2d0-40f7-9bfb-888b59c64058": {
    "career": "Rhetoric Specialist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Academic hiring possible under Global Talent Stream, yet role not on fast STEM list."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Some demand in universities; however, humanities seldom get Blue Cards."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "UAE Centennial 2071",
        "reason": "English-language media hubs hire speechwriters for leadership events, but few openings."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Creative-industry visas possible for senior speechwriters, yet competition intense."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Universities and think-tanks sponsor specialist communicators, but no immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "cc3c6467-d442-4e2a-9d8d-3ee9ba371b45": {
    "career": "Risk Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Banks hire, yet immigration list focuses on engineers and healthcare."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Strategy welcomes fintech and risk-analytics talent, albeit below AI priority."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Finance roles receive Blue Cards, but no specific shortage incentives."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "",
        "reason": "Need for risk experts in nickel/EV projects exists but not formally prioritised."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "FS quants and risk analysts feature on Critical Skills list for Dublin’s IFSC."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "MADANI Economy",
        "reason": "Islamic finance hub Kuala Lumpur actively imports risk professionals."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Market small; visas favour construction and healthcare."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Fintech and sovereign fund projects require enterprise-risk advisors."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Singapore Economy 2030",
        "reason": "Sustainable-finance push creates solid, though competitive, demand for risk consultants."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "We the UAE 2031",
        "reason": "Dubai DIFC courts financial-risk experts for regional banking and crypto hubs."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London prioritises advanced financial services, including risk consulting."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "High demand in finance hubs, but not targeted by recent federal industrial policies."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Banks expanding but prefer local hires; limited expat quotas."
      }
    }
  },
  "0a53c67f-bea0-4636-9221-d3c9a27887e9": {
    "career": "Site Supervisor",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "‘Construction Project Manager/Site Supervisor’ explicitly on CSOL; fast visas for major infrastructure and housing builds."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Construction supervisors fall under skilled trades pathway amid housing-supply push."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe shortage of Bauleiter for renewable-energy and rail upgrades; easier blue-card rules."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital Nusantara fuels demand, but Indonesian language and licensing lower accessibility."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Housing crisis drives hiring, yet supervisors sit outside critical-skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "SSW covers construction workers; supervisory visas possible after in-country experience."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industrial-park expansion needs site oversight, but talent pool largely domestic."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "‘Construction Project Manager/Site Supervisor’ on Tier 1 list—direct residence pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Vision 2030",
        "reason": "Mega-projects like NEOM and Red Sea need expatriate site leads but localisation targets keep score below Tier 1."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "We the UAE 2031",
        "reason": "$100 bn infrastructure pipeline values experienced site leaders, yet no formal shortage list."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Large infrastructure spend (HS2, offshore wind) creates demand, but role not on Shortage List post-Brexit."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "US$1.2 trn highway, bridge and transit projects need on-site coordination and safety management but role not formally listed as shortage."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "National Master Plan 2021-2030",
        "reason": "Transport and energy projects create openings, yet foreign-hire quota tight."
      }
    }
  },
  "65d245dc-066f-46ec-9692-437147c9b661": {
    "career": "Accredited Urban Planner",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Regional councils list ‘Urban & Regional Planner’ on skilled-occupation list, but capped quotas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Municipalities recruiting planners for rapid-growth suburbs; not in priority stream hence Tier 2."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Smart-city and brownfield regeneration need Stadtplaner; German language requirement lowers score."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nusantara capital shift opens opportunities, though Bahasa and local regs essential."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Housing Plan 2030 needs planners, yet role absent from critical list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-city trials (Society 5.0) hire a few foreign planners with bilingual skills."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "MADANI Economy",
        "reason": "Transit-oriented developments around Kuala Lumpur generate demand but licensing is local."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Migrant Category",
        "reason": "Housing shortage drives planner hiring, but role not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Gigacity projects (NEOM, Qiddiya) aggressively recruit accredited urban planners from abroad."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Green Plan 2030",
        "reason": "Planners valued for density solutions, but tiny market and local grads keep it Tier 3."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai & Abu Dhabi expand sustainable urbanism teams; chartered planners get fast-track ‘Golden Visa’."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Regeneration and HS2 corridor require RTPI planners; Brexit shortages rising but salary threshold high."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Massive funding for transit-oriented development and climate-resilient cities raises certified planner demand."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "National Master Plan 2021-2030",
        "reason": "Urbanisation rapid yet foreign planners mostly short-term consultants."
      }
    }
  },
  "79f5cf7d-9110-41de-8f63-48644466e94e": {
    "career": "GIS Manager",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Listed under ‘Spatial Scientist’; mining and disaster-response agencies sponsor visas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Open-data push and natural-resource monitoring place GIS on ‘digital occupations’ fast-track."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Renewable-energy siting needs GIS, yet English-only roles limited."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital mapping uses GIS, but local language and pay deter many."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Flood-risk and telecom projects create steady GIS demand within tech corridor."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Highly Skilled Professional visa",
        "reason": "Disaster mapping projects recruit limited foreign managers with Japanese fluency."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "MADANI Economy",
        "reason": "Palm-oil, forestry monitoring use GIS; managerial hiring mainly local."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Migrant Category",
        "reason": "Earthquake resilience work uses spatial data, but role not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "Smart-city and tourism giga-projects need GIS, though expat quotas apply."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Singapore Economy 2030",
        "reason": "Nation-wide digital twin initiatives need seasoned GIS managers though competition is stiff."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai Digital Twin initiative hires GIS talent, but manager roles competitive."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Net-zero infrastructure relies on spatial analytics; shortage seen in local councils."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "High-resolution mapping underpins broadband, climate and transport grants; GIS leadership in demand."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "National Master Plan 2021-2030",
        "reason": "Infrastructure mapping needs rising, yet salaries low for expatriates."
      }
    }
  },
  "d8dc94fc-80fa-429b-89d6-91ac3592f021": {
    "career": "Information Security Manager",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Cyber Security Manager listed; government funds 17,000 new roles by 2027."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "‘Cybersecurity specialists’ priority stream offers two-week work permits."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "200k cyber talent gap; English-only roles growing but not universal."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech boom increases demand, yet manager visas limited."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "European cyber headquarters of tech giants clustered in Dublin."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Highly Skilled Professional visa",
        "reason": "Rising cyber threat, but language and residency hurdles persist."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "NIMP 2030",
        "reason": "Digital-banking licences raise cyber spend yet salaries lag regional hubs."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Migrant Category",
        "reason": "GovCERT shortage exists, yet not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Fintech and defence sectors hire CISOs with tax-free packages."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "National AI Strategy 2.0",
        "reason": "Cybersecurity is declared core enabler; EP processing fast for senior talent."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Operation 300bn",
        "reason": "Abu Dhabi’s Hub71 and Dubai DIFC push cyber resilience across finance."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "NCSC names cyber a top shortage; Skilled Worker visas streamlined."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Semiconductor fabs and critical-infrastructure firms need security leadership; DHS designates cyber as national shortage."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Growing chip sector needs security experts, but domestic hiring preferred."
      }
    }
  },
  "90283d8b-cf69-41d6-b25d-e4d01086ec85": {
    "career": "Mental Health Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Migration Strategy 2023",
        "reason": "Government invests AU$2.3 bn in mental-health R&D; Global Talent visa possible but competitive."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "CIHR funds large mental-health initiatives; PhD researchers fit health-priority pathway."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Max Planck and university clinics expand psychology labs; German language needed for clinical datasets."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "SFI grants available but role outside critical-skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Ageing-society budgets include mental-health studies, yet Japanese language barriers."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "MADANI Economy",
        "reason": "Mental-health research nascent; funding uncertain."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Migrant Category",
        "reason": "Small research ecosystem but focused on indigenous mental health."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Vision 2030",
        "reason": "Funding targets clinical psychiatrists more than research roles; visas restricted."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Singapore Green Plan 2030",
        "reason": "National Mental Health Blueprint funds NUS and IMH research; small but well-resourced market."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "New wellbeing institutes emerging but research posts limited."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences priority; UKRI funds mental-health ‘Grand Challenge’, Global Talent visa fast."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds NIH behavioural-health studies; universities sponsor J-1 and H-1B researchers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "d9da6f72-d57f-42a8-8b43-98548a32a709": {
    "career": "Power Electronics Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Electrical engineers for renewable energy grids and mining electrification are on the list."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Targets electrical engineers for clean-tech and battery plants in Ontario and Quebec."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Urgent need in e-mobility, industrial drives and wind-turbine converters."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel-based EV battery ecosystem needs motor-drive engineers."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Electronics engineers for semiconductor fabs and med-device power modules."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics and EV giants hire power-electronics talent under HSP fast-track."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "IC-packaging hub expanding into power semiconductor devices."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Green List (Tier 2)",
        "reason": "General electrical engineers welcome; power-electronics niche but useful for grid upgrades."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "NEOM and renewable mega-projects require inverter and HVDC expertise."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Manufacturing 2030",
        "reason": "Precision-power modules for data-centres and chip fabs are a stated priority."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing push includes EV chargers and solar inverters."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean-energy, aerospace and EV battery clusters need power-converter designers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Massive subsidies for EVs, solar, storage and domestic power-conversion manufacturing demand specialists."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Government courting inverter and motor-drive manufacturers."
      }
    }
  },
  "9e67c6e7-11ec-4525-8238-ae7e413aedf0": {
    "career": "School Psychologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "",
        "reason": "States include educational psychologists on skilled-occupation lists."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "French-speaking and rural areas list psychologists as priority health workers."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Child psychologists valued as schools integrate migrants."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "National Educational Psychological Service recruits qualified outsiders."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Educational psychologists on long-term skills shortage list."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Local councils struggle to fill educational psychology posts."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Chronic shortage in K-12 mental-health services; districts sponsor H-1B."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "2f543fda-071d-41c3-92ed-60c603490ff3": {
    "career": "Strategic Planner",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Mega-projects hire strategic planners for tourism and smart-city units."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "MNC HQs employ planners, but not under priority programmes."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Free-zones court strategy talent for fintech, space, and logistics sectors."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Consultancies sponsor Skilled Worker visas for planners with niche expertise."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Management roles exist but not tied to federal talent programmes."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "e9bca180-adc2-4507-9c82-0ff2b7101f2c": {
    "career": "Dance Educator",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Community centres and arts schools hire foreign specialists selectively."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "We the UAE 2031",
        "reason": "Growing performing-arts scene in Dubai needs instructors for academies."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry seniors can obtain Global Talent visa."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Private studios and universities sponsor O-1 visas for exceptional talent."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "cfa822e7-6672-405f-abcd-30d8e9093067": {
    "career": "Finance Officer",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "IFSC Dublin needs finance officers and compliance analysts."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "MADANI Economy",
        "reason": "Islamic finance expansion in Kuala Lumpur creates openings."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Fintech and sovereign fund projects seek finance professionals."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Singapore Economy 2030",
        "reason": "Sustainable-finance hub needs officers versed in ESG reporting."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai International Financial Centre actively issues visas for finance talent."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London and fintech hubs list finance roles on Skilled Worker visa."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Large demand but not tied to industrial policies."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "d04fd2b8-b403-478f-8062-cf349fe7509a": {
    "career": "Front Office Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Regional resort operators struggle to fill senior hotel positions; state nominations often list hospitality managers."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Role sits outside Express Entry priority categories; vacancies exist mainly in tourist hubs like Banff and Niagara."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Skilled Immigration Act focuses on nurses and engineers; hospitality managers can still use Opportunity Card points but not prioritised."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Bali and Labuan Bajo upscale resorts need seasoned foreign managers until local talent pipeline matures."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "Kuala Lumpur premium hotels expanding; talent shortage mild but managers can obtain work passes with experience."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Green List excludes hotel managers; employers may still sponsor under general Skilled Migrant Category if experience is strong."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Mega-projects (NEOM, Red Sea, AlUla) need thousands of hotel leaders to meet luxury tourism targets."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai & Abu Dhabi aim to double visitor nights; five-star chains aggressively recruit experienced front-office talent."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Post-COVID staff shortages exist but hospitality dropped from shortage list; sponsorship still possible for big chains."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Hospitality managers not included in federal talent lists, but large private sector demand in Vegas, Orlando and NYC hotels keeps openings steady."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "af99b58c-2c41-4b0c-b5f9-79b48a469fa5": {
    "career": "Property Surveyor",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Building and land surveyors are on national shortage lists; fast-track visas and state sponsorship available."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Civil and construction professionals receive extra points; provinces like Ontario actively invite licensed surveyors."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Boom in housing retrofits and rail projects requires geodetic engineers and Vermessungstechniker."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Local licensing barriers and drive to localise construction roles limit foreign surveyor demand."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Quantity surveyors explicitly listed due to housing shortage and data-centre construction."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Construction SSW covers basic surveying tasks but full professionals fall under general work visa with no shortage priority."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "NIMP 2030",
        "reason": "Industrial park expansion needs cadastral surveys; still secondary to semiconductor priorities."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Land/quantity surveyors sit on Tier 1, giving direct residence pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Giga-projects need survey work but prefer larger EPC contractors; individual visas possible but limited."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Tight manpower quotas; survey work often subcontracted, though public-housing rebuilds give niche openings."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "Dubai real-estate boom creates demand, yet no federal shortage recognition; experience with RICS valued."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Chartered surveyors were retained on shortage list; RICS membership eases visa sponsorship."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Massive highway and broadband builds need land and right-of-way surveyors, though not listed as critical shortage."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Focus is on infrastructure engineers and semiconductor, not standalone surveying roles."
      }
    }
  },
  "d52e0f8c-5636-4555-8a52-cc49fc93556a": {
    "career": "Resource Manager",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "Water-scarcity projects and mine site rehabilitation place environmental resource managers on state skill lists."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Federal and provincial parks, mining reclamation and forestry boards list environmental managers as priority."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Energiewende and forest-health programmes need geoscience managers, but competition from EU talent keeps score lower."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "RPJPN 2025-2045",
        "reason": "Nickel and forest-carbon projects need compliance managers, but Bahasa requirement limits openings."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Growth in wind-farm planning offers roles; still outside Critical Skills list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "Palm-oil sustainability pushes need auditors, but quotas favour local graduates."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Climate adaptation and biodiversity roles exist; resource managers can obtain residence but not on fast-track list."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "NEOM conservation zones need environmental oversight, yet visas favour engineers over managers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "49",
        "policy": "Singapore Green Plan 2030",
        "reason": "Green Plan funds mangrove restoration and carbon services; small job pool, strict EP criteria."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "COP28 follow-up projects create limited demand for carbon and habitat managers."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Environmental management tied to offshore wind and biodiversity net-gain, though not formally prioritised."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Billions for climate resilience and land restoration drive demand for natural-resource managers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "National Master Plan 2021-2030",
        "reason": "Hydropower and coastal projects seek environmental approvals; foreign expertise used on a consultancy basis."
      }
    }
  },
  "98c77cd2-177d-464b-9c8d-0dcdfc681059": {
    "career": "Training Manager",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "",
        "reason": "Opportunity Card points possible, but HR not shortage; German-language barrier high."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "47",
        "policy": "",
        "reason": "Multinationals in Dublin hire L&D but HR excluded from Critical Skills list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Regional shared-service centres hire some expatriate L&D managers, but role not prioritised."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Mega-projects need corporate academies and Saudization training leaders, creating moderate demand."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "53",
        "policy": "",
        "reason": "EPs granted for niche skills; HR not on priority list but regional HQs still hire."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "We the UAE 2031",
        "reason": "Knowledge-economy push drives corporate universities; expatriate L&D managers remain common."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Skilled Worker visa allows sponsorship, but HR not on shortage list; roles exist in finance and tech."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Demand exists in tech and healthcare firms, but no federal talent incentives for L&D roles."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a6633f8a-68e6-424a-8bc9-1e9e950344d7": {
    "career": "Agricultural Manager",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Migration Strategy 2023",
        "reason": "Regional visas actively seek farm and station managers to combat rural skills shortages."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Farm managers listed; Prairie provinces issue targeted invitations for livestock and grain operations."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Modern dairies hire tech-savvy managers, but role not on shortage lists."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Asta Cita",
        "reason": "Food-security drive and vast plantations create openings for precision-agri managers."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "",
        "reason": "Large dairy co-ops hire skilled managers, though Critical Skills list focuses on engineers."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Hokkaido dairies recruit foreign managers through SSW agriculture pathway."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Dairy farm managers get direct residence pathway due to acute labour gaps."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Controlled-environment agriculture projects occasionally import managers but job numbers small."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Farm managers can get sponsorship, yet role absent from shortage list post-Brexit."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "No federal priority, but large agribusinesses in Midwest sponsor managers with precision-farming expertise."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "",
        "reason": "High-tech greenhouse projects hire some foreign expertise, but not prioritised nationally."
      }
    }
  },
  "cc6da6bc-dc41-4de6-93c6-263fc190f804": {
    "career": "Cell Biology Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL lists medical laboratory and biomedical scientists with fast-track visas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Biotech featured as priority science; peer-review experience earns extra Express Entry points."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Research institutes recruit life-science PhDs; Opportunity Card points favor STEM doctorates."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Focus on biopharma research is early-stage; few specialist roles today."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Biopharma cluster around Dublin/Cork needs cell biologists for manufacturing and QC."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP gives points for biotech PhDs, matching aging-research and regenerative-medicine programs."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan promotes medical devices and biopharma, drawing cell-culture talent to Penang hubs."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Migrant Category",
        "reason": "No direct Green List slot, but PhD adds strong migration points for university roles."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Limited yet growing biotech hubs around NEOM; still niche today."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Economy 2030",
        "reason": "Large biomedical parks (Biopolis) hire cell biologists, but quota management keeps Tier-2."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai Science Park hires cell-culture specialists but volumes are small."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences R&D named pillar; Global Talent visa streamlines entry for published researchers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act pours billions into life-science R&D, NIH grants, and EB-2 NIW eases visas for PhD biologists."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "National Master Plan 2021-2030",
        "reason": "Biotech listed but funding and labs still emerging—entry possible yet limited."
      }
    }
  },
  "6ab6bb9c-768e-48ab-8412-6071bd5c6293": {
    "career": "Gender Studies Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Academic stream visas possible, but discipline not on CSOL—hiring numbers modest."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Express Entry Category-Based Selection",
        "reason": "French-speaking social-science PhDs earn extra CRS points and universities face faculty shortages in humanities."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Humanities doctorates earn points, yet funding scarce outside big cities."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Critical Skills omits humanities, but academic Roles still exist with standard work permits."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Universities can sponsor lecturers; no shortage designation."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National AI Strategy 2.0",
        "reason": "A few gender-policy think tanks hire, yet role not in priority lists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Private universities hire DEI academics, but immigration not priority."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Universities recruit under Global Talent visa; research councils fund equality studies."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "CHIPS and Science Act",
        "reason": "Universities always hire humanities PhDs; no dedicated immigration push but H-1B cap-exempt academic slots exist."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "490643de-536a-4e6c-b795-f608091cd899": {
    "career": "Operations Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Operations managers sit outside CSOL; visas possible but competitive."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Management roles possible via CRS, though not singled out."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Blue Card available for degree-holders, but no shortage bonus."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "New capital development requires operations planners but local hiring preferred."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on critical list; Standard work permit possible with higher salary."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points favor STEM; generic ops less valued."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "Shared-service centers hire, but local talent sufficient—no priority."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Points route only; occupation not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Mega-projects need logistics and ops professionals to hit tight timelines."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Economy 2030",
        "reason": "MOM quotas tight; generic ops get S-Pass, not critical occupation."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Free-zone multinationals sponsor ops analysts for regional logistics hubs."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "General operations roles eligible for Skilled Worker visa but not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Large federal projects hire ops analysts, but generic management not immigration-priority."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National Master Plan 2021-2030",
        "reason": "Manufacturing boom needs ops talent, yet visas still favor engineers."
      }
    }
  },
  "9da794b9-298a-4fbf-804f-9ee433fa7e88": {
    "career": "Sports Therapy Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Physiotherapists and exercise physiologists are priority occupations with fast visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Physiotherapists on healthcare shortage list; sports focus valued by pro teams."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Rehab therapists in demand; must pass language and licensing exams."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Physiotherapists currently on General Employment permit, not Critical Skills."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Physiotherapists on Tier-1 Green List—straight-to-residence pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Sports cities need therapists for elite clubs, but roles few and male-dominated."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Green Plan 2030",
        "reason": "MOH licenses physiotherapists; quotas tight, sports rehab niche."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Sports academies hire therapists; not on critical list."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Physio shortage list removed 2025; sponsorship still possible for clubs."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Stadium renovations create some sports-medicine jobs but no immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b1f1321e-8ff2-47f9-ac8a-f83375de13c3": {
    "career": "Travel Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Migration Strategy 2023",
        "reason": "Travel agents removed from skilled lists in 2024."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Hospitality workers not on priority list; CRS route only."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital Nusantara and eco-tourism islands require consultant talent."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "MADANI Economy",
        "reason": "Kuala Lumpur aims to be regional travel hub; foreign expertise welcomed."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Points possible but not a shortage occupation."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Vision 2030",
        "reason": "Massive investment in inbound tourism (NEOM, Red Sea); bilingual consultants urgently needed."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s target of 40 M visitors drives demand for bespoke travel planners."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Role not on shortage list; sponsorship rare."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Tourism rebound helps, but no special visa priority."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "National Master Plan 2021-2030",
        "reason": "Halong Bay & coastal tourism expansion need package designers fluent in English/Chinese."
      }
    }
  },
  "83da4ea3-586d-49ea-abb2-5708136b35a4": {
    "career": "Biomedical Business Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "List focuses on clinicians and engineers; biotech commercial managers only moderately demanded."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Strategy highlights scaling Toronto–Montreal biotech clusters and welcomes senior business talent in life-sciences."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Germany’s BioNTech-led boom needs commercial leadership, though immigration law emphasises technical roles."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma and med-tech exporters need managers who combine science knowledge with global sales expertise."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "Biotech is a growth field; commercial managers qualify but tech researchers take priority."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan supports med-device and pharma scale-ups; managerial roles exist but policy spotlights engineers."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Life-science scale-ups are small; demand exists but not an official shortage."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "41",
        "policy": "Vision 2030",
        "reason": "Local pharma plants and NEOM health projects create some openings for experienced expatriate managers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "73",
        "policy": "Singapore Economy 2030",
        "reason": "Biomed manufacturing hub needs go-to-market managers, but tech specialists remain top priority."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Operation 300bn",
        "reason": "Biotech manufacturing is an emerging pillar; foreign commercial leaders sought but not headline priority."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life sciences is a flagship sector; strong incentives for market-oriented leadership talent."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds biomanufacturing and commercialization; firms need managers who can translate lab results into profitable product lines."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "95fa2e78-f81d-41eb-89b0-d15ae301e108": {
    "career": "Media Relations Manager",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Vision 2030",
        "reason": "Mega-projects need global PR teams to attract investment and tourists."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s push to be a media hub creates steady demand for senior PR talent."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry seniors are on the shortage list; media comms sits tangentially."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Large media ecosystem sustains demand though not tied to federal industrial policy."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "32b14760-8ca2-427c-9f56-45ea2d2a9920": {
    "career": "Speech-Language Therapist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "SLPs appear on health-professional shortage list across states."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Allied-health shortages place SLPs high on invitation list."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe therapist gaps in elder-care and paediatrics; fast-track visas offered."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "HSE recruits abroad, yet Critical Skills list focuses on doctors/nurses."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Care sector needs therapists, but licensing translation is complex."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "SLPs explicitly listed with direct residency pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Vision 2030",
        "reason": "New private hospitals import allied health talent, though doctors get priority."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Aged-care expansion drives demand, but roles usually filled locally."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "We the UAE 2031",
        "reason": "Growing rehab sector in Abu Dhabi creates moderate SLP demand."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "NHS hires overseas SLPs, but role not on official shortage list post-2025."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Ageing population drives demand even without new federal incentives."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "9206ac8a-5c88-4ac9-b3c5-d8dd482e24f0": {
    "career": "Wind/Percussion Player",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "Vision 2030",
        "reason": "New entertainment venues hire foreign orchestra players for events."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Dubai Opera and film scoring create steady but competitive demand."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry on shortage list; orchestras recruit globally."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Creative sector strong; visas possible via O-1 but not policy-driven."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "2a683d46-3b5e-4e4b-b183-01749833438a": {
    "career": "BI Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Data analysts included in new tech-skills list, but below software engineers in priority."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Express Entry Category-Based Selection",
        "reason": "IT professionals, especially data analysts, have priority invitations."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "German Mittelstand needs BI talent for Industry 4.0 rollouts."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Digitalisation push in banking and EV supply chain requires analytics talent."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Dublin’s tech multinationals urgently need BI to meet EU reporting rules."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-factory and robotics firms hire BI experts for real-time analytics."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "MADANI Economy",
        "reason": "Industry 4.0 adoption in semiconductor fabs fuels BI consulting demand."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Data analysts appear on Tier-2 list with fast-track residency."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Vision 2030",
        "reason": "Government megaprojects require BI dashboards for tourism, finance and logistics KPIs."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "National AI Strategy 2.0",
        "reason": "BI underpins data-governance mandates, but AI researchers enjoy top tier."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "UAE Centennial 2071",
        "reason": "Fintech and smart-city goals drive demand for data-visualisation consultants."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital and AI specialists are priority; BI seen as gateway skill."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds data-driven manufacturing; demand for BI experts in federal and private projects."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National Master Plan 2021-2030",
        "reason": "E-commerce and fintech boom need BI skills though not formally shortage-listed."
      }
    }
  },
  "8be5517f-0d08-43e6-9193-68e154167c04": {
    "career": "International Policy Advisor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Migration Strategy 2023",
        "reason": "Accepts senior managers on points system; policy focus lies elsewhere (health, STEM)."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Advisory/managerial occupations can qualify under general high-skill streams, yet no explicit category priority."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Accessible through EU Blue Card for degree holders, but not a named shortage occupation."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Major projects hire foreign policy specialists for global outreach, yet numbers limited."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National AI Strategy 2.0",
        "reason": "International organisations in Singapore hire advisors, but role not in strategic shortage lists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "We the UAE 2031",
        "reason": "Government entities and multilaterals in Abu Dhabi/Dubai actively recruit expat policy experts for diplomacy and soft-power goals."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Think-tanks and consultancy qualify under Skilled Worker visa, but not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "59",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Role is high-skilled and common in think-tanks and government contractors but not on any shortage or STEM list."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a82a593a-7cf6-4c26-936a-f565b26d3655": {
    "career": "Molecular Microbiologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Life-science R&D accepted but not explicitly prioritised; points route available."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Biomanufacturing targets under talent strategy; researchers score highly in Express Entry."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Strong pharma and biotech clusters seek PhDs; Opportunity Card eases entry."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "61",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Biopharma research listed as strategic; tax holidays for R&D firms seeking talent."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Biopharma giants in Dublin & Cork struggle for PhD talent; role on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP welcomes biotech PhDs, but language and ageing institutes limit numbers."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan prioritises pharma and medical devices, raising demand for microbial R&D."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Green List (Tier 2)",
        "reason": "Occasional demand in agricultural biotech; not a headline shortage."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "New vaccine plants in NEOM recruit scientists, but intake remains small."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Singapore Green Plan 2030",
        "reason": "Biomed hub offers Employment Pass salary exemptions and generous grant funding."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Operation 300bn",
        "reason": "Dubai Science Park and Abu Dhabi bioclusters court foreign microbiologists for R&D."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences pillar and fast-track visas cover microbiology researchers and biotech founders."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA and NIH funding boost biotech and vaccines; labs sponsor H-1B and O-1 talent aggressively."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "National Master Plan 2021-2030",
        "reason": "Government pushes biotech and vaccine self-sufficiency; foreign scientists gain incentives."
      }
    }
  },
  "3dba119d-691d-43ef-854a-4e0d326f92f9": {
    "career": "Performer",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Kingdom invests heavily in concerts and festivals, importing performers for new entertainment sector."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai’s media cities and Expo legacy venues host continual demand for international acts."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries flagged as strategic; Global Talent visa fast-tracks established performers."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct policy support, but large creative market and O-1 artist visa route."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "c7da3687-b130-4478-b964-6f46fa093176": {
    "career": "Sports Curriculum Developer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Strong sporting culture; schools hire foreign specialists via points route though not on shortage list."
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Kingdom invests in sports academies and events, importing coaching curriculum talent."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Private schools and new sports hubs recruit foreign experts to design PE and academy programs."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Elite clubs and private schools sponsor visas, yet role not on shortage list."
      },
      "united_states": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "369acf19-cef3-41e2-876c-bf806b1a7bcb": {
    "career": "Biosystems Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Environmental and agricultural engineers are on the skilled list, easing visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Express Entry Category-Based Selection",
        "reason": "AgTech and clean-tech startups actively sponsor under engineering categories."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Renewable energy and agritech firms seek engineers for biogas and precision farming."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Food security and biomass energy projects value biosystems expertise."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Agri-food tech a growing niche; role qualifies under engineering codes."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-city and robotics farms attract biosystems engineers under HSP."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan pushes bio-based chemicals and precision agriculture requiring systems engineers."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 2)",
        "reason": "Dairy and horticulture industries need sustainable systems engineers."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Vision 2030",
        "reason": "Interest in desert agriculture and biofuels, but hiring volume low."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Green Plan 2030",
        "reason": "Vertical farming and biofoundry sectors hire, but scale smaller than electronics/AI."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Controlled-environment farming initiatives recruit some biosystems talent."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean energy, hydrogen and ag-tech funding create roles in food-system engineering."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds bioenergy, sustainable agriculture and carbon capture—all require biosystems engineers."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "National Master Plan 2021-2030",
        "reason": "Agritech and bioenergy are strategic; foreign engineers incentivised."
      }
    }
  },
  "647c0a8c-9231-4e6f-b1f0-8c2a9055ae93": {
    "career": "Biotechnology Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Biotech listed under medical scientists; visas fast-tracked for vaccine and med-tech R&D."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Health-science professionals and researchers receive extra CRS points; biopharma hubs in Ontario/Quebec hiring."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Germany’s BioNTech success drives demand for molecular biologists and process engineers."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Huge biopharma manufacturing base (Pfizer, Takeda, Regeneron) classed as critical skill for visas."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP gives points for biotech researchers, yet language barrier slows direct entry."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan targets pharma and med-device export growth—tax holidays for firms hiring biotech talent."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Skilled Migrant Category",
        "reason": "Limited but growing agri-biotech and med-tech clusters—points awarded yet few openings."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "NEOM life-science projects need biotech know-how but localisation preference keeps numbers modest."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "81",
        "policy": "Singapore Economy 2030",
        "reason": "Biomed manufacturing and cell therapy are flagship sectors; Employment Pass relaxed for PhD holders."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "Dubai Science Park courting gene-therapy startups; Golden Visa route for PhD scientists."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences pillar funds cell & gene therapy, bioprocessing and vaccine R&D—shortage occupation."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds biomanufacturing, cell-based therapies and domestic biopharma supply chains—exact skills needed."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "548b0e2f-e820-4b66-9519-a5fec27e8f18": {
    "career": "Cellular Biologist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Migration Strategy 2023",
        "reason": "Medical scientists listed as priority; grants for stem-cell and regenerative medicine research."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities receive funding to recruit cell biology post-docs; streamlined work permits for researchers."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Max Planck and Helmholtz institutes actively head-hunt cellular biologists; fast visa via Punkte-system."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma and med-tech plants need cell culture experts for biologics manufacturing."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Highly Skilled Professional visa",
        "reason": "iPS cell research center in Kyoto recruits globally; Japanese language still hurdle."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Niche demand in agri-biotech; limited positions outside academia."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "National AI Strategy 2.0",
        "reason": "A*STAR’s Institute of Molecular & Cell Biology recruits globally; long-term pass easier for PhDs."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "UAE Centennial 2071",
        "reason": "Research hubs in Khalifa City hiring, but roles competitive and prefer previous GCC experience."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Cell & Gene Therapy Catapult and Wellcome funding create shortage of cell biologists."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act injects billions into basic life-science research via NSF and NIH funding opportunities."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "36d4674b-8d27-4880-b6e6-8559b9f5b94e": {
    "career": "Criminal Justice Officer",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "15",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "18",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "22",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Large security projects seek foreign expertise in forensic tech and cyber police training."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Dubai Police recruits foreign specialists in cyber-crime and forensics on contract basis."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Certain civilian investigative roles open to visa holders, but sworn officer posts need residency."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA allocates funds to state police for tech upgrades, opening limited roles for specialists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "15",
        "policy": "",
        "reason": ""
      }
    }
  },
  "9fcfb7b4-5700-4049-a7e5-3923c3dbf0f9": {
    "career": "Data Analytics Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Data analysts on CSOL; visas streamlined for consulting firms."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Tech occupations, including data analysts, receive additional category points."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialists may enter without degree; German language still hurdle for consulting roles."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "41",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech data roles growing yet localisation rules rising."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Big Four and tech multinationals in Dublin actively sponsor analytics consultants."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "HS visa awards points for data scientists; language barrier limits consulting engagements."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Government pushes data-driven public services; still emerging consulting market."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Skilled Migrant Category",
        "reason": "Some demand in banking and government but small absolute numbers."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "63",
        "policy": "Vision 2030",
        "reason": "Government mega-projects hire analytics consultants for tourism, logistics and smart-city KPIs."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "National AI Strategy 2.0",
        "reason": "Consultants in AI & analytics qualify for COMPASS bonus; strong demand in finance."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "63",
        "policy": "Operation 300bn",
        "reason": "Dubai consultancies need analytics talent for fintech and manufacturing transformation."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Financial services & AI pillars make data consultants a shortage occupation, especially in London."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funding drives demand for consultants analysing clean-energy and manufacturing data."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "National Master Plan 2021-2030",
        "reason": "E-commerce boom fuels some analytics roles; visa processes evolving."
      }
    }
  },
  "58e6af41-9b7a-4e3f-ad8d-8630cd67684b": {
    "career": "Data Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Migration Strategy 2023",
        "reason": "Software and data engineers on priority list with 7-day visa processing."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Data scientists/engineers highlighted; fast 2-week work permits under Global Talent Stream."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "63",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT workers no longer need degree if skills proven; data roles plentiful in Industry 4.0."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech and e-commerce growth, but localisation rules high."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "All major data-centre operators and FAANG hire data specialists; immediate Critical Skills Permit."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP covers AI/data; English-only roles limited outside multinationals."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Government digital push but salary levels lower; Data specialists on MDEC priority."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Skilled Migrant Category",
        "reason": "Limited but steady demand in banks and telcos; small market size."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Smart-city mega-projects need big-data engineers; contract roles common."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "National AI Strategy 2.0",
        "reason": "Data governance specialists in demand for AI regulatory sandbox; COMPASS bonus for tech talent."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "UAE Centennial 2071",
        "reason": "Fintech and government open-data initiatives fuel hiring; Golden Visa for coders."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital/AI pillar lists data engineers and architects as shortage occupation."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds AI and data infrastructure; strong pull for data engineers and stewards."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "E-commerce giants need data teams; visas improving but still tricky."
      }
    }
  },
  "9fe83ad7-c954-437f-af8c-d28a4fbbb7d2": {
    "career": "Global Marketing Manager",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Act allows any degree-holder, but marketing is not shortage; German language barrier keeps demand modest."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "31",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Foreign CMOs hired by electronics and halal-brand exporters, but not officially prioritised."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Mega-projects need senior brand leaders to promote tourism, sports and entertainment globally."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "Smart-nation brands value seasoned marketers, but role is not in Tier-1 tech list."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi push global marketing for tourism, fintech and free-zone brands."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry seniors appear under IS-8, but competition with resident talent keeps priority low."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Marketing roles not covered, but multinationals created by IRA clean-tech funding still need global brand leads."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a8d3d37b-b7e3-4987-9f6b-52072f56fb93": {
    "career": "Health Psychologist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Registered Psychologist (ANZSCO 2723) on Medium-Long-Term list; priority visas available."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Healthcare occupations list explicitly includes psychologists due to national mental-health gaps."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Act welcomes healthcare degrees; demand in clinics, but language and licensing lower urgency."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Clinical Psychologist included but capped numbers keep tier lower."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Clinical Psychologist is on Tier-1 Green List, fast-track residence."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Vision 2030",
        "reason": "New hospitals recruit behavioural-health experts, yet Saudization keeps intake moderate."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "49",
        "policy": "Singapore Green Plan 2030",
        "reason": "Ageing population drives mental-health hiring, but MOH prefers local practitioners."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "UAE Centennial 2071",
        "reason": "Private hospitals import licensed psychologists to tackle rising lifestyle illnesses."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Clinical Psychologists remain on NHS shortage list though overall policy has reduced health roles."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Not a named field, yet mental-health shortages give visa chances through H-1B cap-exempt clinics."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "dda7909d-fb02-4cc0-af41-a380c32b1c43": {
    "career": "Media Critic",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Academic and arts visas possible, but no shortage designation."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities recruit cultural-studies faculty to boost global rankings though not priority."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Points system values advanced degrees; arts critics accepted but not prioritised."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "24",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National AI Strategy 2.0",
        "reason": "English-language think-tanks analyse digital media, but roles are few."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "We the UAE 2031",
        "reason": "Dubai media free zones house English-language publications seeking reviewers, but limited visas."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries include cultural criticism; UK universities hire Asian-media scholars."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds humanities fellowships on AI ethics and media, sustaining academic critic roles."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "22",
        "policy": "",
        "reason": ""
      }
    }
  },
  "557a175d-e379-460a-8cee-771d19f12dd4": {
    "career": "Musculoskeletal Physio",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Physiotherapist (ANZSCO 2525) on Medium-Long-Term list, enabling permanent residency."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Physiotherapists sit on priority healthcare list with dedicated invitation rounds."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe rehab staff shortage; fast-track recognition program for foreign physiotherapists."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Physiotherapist (2121) included, granting fast-track work permits."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Physiotherapist is on Tier-1; straight-to-residence visa."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Vision 2030",
        "reason": "New sports and wellness facilities recruit physios, but localisation policies apply."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Economy 2030",
        "reason": "MOH issues conditional registration for foreign physios to meet ageing-population demand."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "UAE Centennial 2071",
        "reason": "Private hospitals and sports clubs hire foreign physios; DHA licence required."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Physiotherapists remain on NHS shortage list despite wider policy tightening."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "59",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct policy, but ageing workforce shortages create H-1B cap-exempt hospital openings."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      }
    }
  },
  "f22ad32e-2da5-4c91-9131-3c841fffcfb3": {
    "career": "Policy Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Migration Strategy 2023",
        "reason": "State health departments recruit policy advisors to manage Medicare and NDIS pressures."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Federal and provincial agencies need health-policy experts for aging population reforms."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Opportunities in health-insurance funds, but German fluency essential, limiting priority."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "49",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Health policy not on list; individual vacancies possible."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "MADANI Economy",
        "reason": "MOH reforms open some consultancy roles, but preference for returning Malaysians."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Skilled Migrant Category",
        "reason": "Te Whatu Ora hires analysts for health-system overhaul; role not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Vision 2030",
        "reason": "Ministry of Health imports policy talent to shift to insurance-based system."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Singapore Green Plan 2030",
        "reason": "MOH employs foreign analysts on contract for ageing-population projects, but limited slots."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Dubai Health Authority seeks strategists for medical tourism and preventive-health targets."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Roles exist in NHS England and think-tanks, but no shortage designation."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Public-health policy analysts hired to track IRA climate-health links, but no formal shortage."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "3642615c-7c89-407f-9a5f-64e5ee2ca997": {
    "career": "Primary School Teacher",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL flags Primary School Teachers as a high-priority shortage occupation with fast-track visa."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Elementary and early-childhood teachers explicitly listed under 2025 category-based draws."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe shortage of Grundschule teachers; Act relaxes recognition rules for foreign-trained educators."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "General demand, yet not on Critical Skills List, hence standard work permit route."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "Green List (Tier 2)",
        "reason": "Primary teachers on Green List with straight-to-residence pathway after two years."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Primary teachers recently removed from shortage list; still possible but no express priority."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Chronic teacher shortages in many districts, but no federal immigration priority programme."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "2dd1a657-113f-4ba2-b170-2e07be6e9b59": {
    "career": "Specialist Barrister",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Foreign-trained advocates must pass stringent local law exams; not on CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Provincial bar admission and domestic legal training preferred; limited immigration facilitation."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Financial-services legal specialists facilitated, though still need King’s Inns qualification."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Islamic finance law needs expertise, but must partner with local firms."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Vision 2030",
        "reason": "Growing arbitration market for giga-projects, but Saudisation restricts courtroom practice."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "National AI Strategy 2.0",
        "reason": "International arbitration hub; selective admission of foreign Senior Counsel for complex cases."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "DIFC/ADGM courts recruit common-law advocates for financial disputes."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Senior law professionals named in IS-8; Bar Council actively courts international talent for complex sectors."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Litigation lawyers in demand, but no federal skills list; state bar admission required."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "74c67334-f297-4887-b6dc-c8ee332ff02a": {
    "career": "Database Administrator",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Migration Strategy 2023",
        "reason": "ICT Database Administrators on Core Skills list with 7-day visa processing."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Software engineers and DBAs invited under 2025 tech draws with low CRS cut-offs."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialists can skip degree recognition if salary threshold met."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Digital-banking and e-commerce expansion driving DBA demand."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Database developers/administrators explicitly listed; fast-track work permit and residency."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points for cloud/DB engineers, easing permanent residence."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industry 4.0 push needs data infrastructure talent in semiconductor corridor."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Migrant Category",
        "reason": "DBAs score high STEM points even if not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Digital government and mega-projects need data infrastructure experts."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Economy 2030",
        "reason": "Financial services and data-centre boom sustain demand, but not a top-tier shortage."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Operation 300bn",
        "reason": "Industrial digitalisation and fintech hubs recruit cloud DBAs."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital and cybersecurity pillars cover data platform skills; standard Skilled Worker visa applies."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Expanded broadband and data-center builds raise demand for database talent, though not formally prioritised."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Data platform experts required to support chip design and e-commerce."
      }
    }
  },
  "a192ceb7-6177-4074-80b7-b039db84c204": {
    "career": "Earth System Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Migration Strategy 2023",
        "reason": "Bushfire and reef programmes recruit environmental scientists under STEM stream."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Strategy lists climate scientists for expedited pathways, especially for Arctic research."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Renewable-energy transition drives demand for climate and atmospheric scientists."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Geothermal and deforestation monitoring need earth scientists, yet visas are project-based."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Marine Climate Change Centre hires specialists, but not on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Highly Skilled Professional visa",
        "reason": "Renewable-energy and disaster-prediction labs offer HSP points bonuses."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Green growth targets open some roles, but no dedicated fast-track."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Migrant Category",
        "reason": "Climate-change adaptation research funded, though not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "NEOM and Red Sea projects employ climate and desertification experts."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Green Plan 2030",
        "reason": "Carbon services hub sponsors climate-modelling researchers."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "COP28 legacy funds climate data hubs, attracting earth-system researchers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean-growth pillar bankrolls Met Office and university climate super-computing."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Massive funding for climate modelling and carbon monitoring research creates new federal and private roles."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "National Master Plan 2021-2030",
        "reason": "Offshore wind & coastal resilience studies create limited research posts."
      }
    }
  },
  "253e2b4e-4292-4e8c-ab5d-b9bbda0ed19d": {
    "career": "Educational Administrator",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Migration Strategy 2023",
        "reason": "Regional schools sponsor experienced heads under education stream."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Educational managers may qualify under targeted draws for French-speaking educators."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Administrative roles require fluent German and state civil-service exams."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Leadership posts require Gaeilge and teaching council registration."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Migrant Category",
        "reason": "Leadership roles get high skill points though not on Green List."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "No current shortage-occupation status; sponsorship possible but competitive."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Principal shortages in rural districts, but immigration handled ad hoc at state level."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "764edd0a-cf5c-451f-baae-83ae4ce4cc54": {
    "career": "International Finance Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Migration Strategy favours STEM and trades, not generic finance occupations."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Finance not on targeted Express Entry lists; candidates compete in general pool only."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Skilled Immigration Act focuses on engineers and IT; banking falls outside shortage lists."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "41",
        "policy": "",
        "reason": "Golden Indonesia 2045 emphasises fintech tech roles; pure finance gets no priority."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List includes financial-services quants; Dublin’s IFSC hires global talent."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Highly Skilled visa gives points, but finance not singled out."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "MADANI Economy",
        "reason": "Islamic finance hub in Kuala Lumpur recruits cross-border finance experts."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Green List omits finance; visas possible but no fast-track."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Vision 2030 is scaling fintech and sovereign-wealth projects that need cross-border finance talent."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Singapore Economy 2030",
        "reason": "Global hub for sustainable and wealth management; Employment Pass has relaxed salary criteria for finance specialists."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi free-zones court global finance specialists with golden visas and 0% tax."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London financial services explicitly listed; fast-track Skilled Worker visas for senior finance roles."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Large financial sector and H-1B availability but no dedicated immigration priority for finance roles."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "National master plans focus on fintech engineers rather than finance strategists."
      }
    }
  },
  "44c70002-4682-4c66-ba53-99b4a1bd7b46": {
    "career": "Science Educator",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Secondary STEM teachers on priority list with direct PR pathways."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Early-childhood and K-12 teachers get extra CRS points and faster PR."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Acute shortage of STEM teachers; fast-track work-and-settle visas."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Occasional shortages but not on Critical Skills list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Secondary science teachers have streamlined residency pathways."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "No national shortage policy; visas possible but not prioritised."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4325a261-9976-4620-bce2-834f161d8787": {
    "career": "Social Policy Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Universities sponsor Global Talent visas for high-impact researchers."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Academic and non-profit research roles qualify under general Express Entry but lack priority points."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "",
        "reason": "Opportunity Card values advanced degrees; social science researchers welcomed in universities."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "",
        "reason": "Some openings in Jakarta think tanks, yet no immigration priority."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "",
        "reason": "Irish Research Council funds social policy PhDs with Critical Skills visa options later."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Highly Skilled visa points favour STEM; social research less prioritised."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Think-tank roles exist but not on NIMP 2030 priority list."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "No dedicated listing, but universities can sponsor work visas."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Government reforms create demand for policy analysts, though not formalised in visa lists."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Public Policy School and social research institutes sponsor EPs for PhD holders."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "Dubai policy labs recruit but without explicit immigration perks."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "",
        "reason": "Universities and civil-service fellowships on Skilled Worker route; doctoral route eases settlement."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "",
        "reason": "Universities and think-tanks use H-1B/O-1 for researchers, though not on strategic shortage lists."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Policy focus on tech; social research visas handled case-by-case."
      }
    }
  },
  "07046d6a-7691-4d51-af37-78b58e8c7134": {
    "career": "Tourism Developer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "",
        "reason": "CSOL focuses on trades and STEM rather than tourism strategy."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Express Entry does not prioritise tourism planners."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "No shortage designation for hospitality planners."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "RPJPN 2025-2045",
        "reason": "Labuan Bajo and new capital Nusantara need sustainable tourism developers."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Inbound tourism push, but visas aimed at hotel staff rather than planners."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "",
        "reason": "MADANI agenda promotes eco-tourism; incentives for project specialists."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Post-Covid rebuild has regional visa incentives for destination managers."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Mega-projects like NEOM, Red Sea and AlUla aggressively import tourism development talent."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Tourism Board hires few foreigners; EP approvals tightly capped."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi target 40 M visitors; golden visas for senior hospitality strategists."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Tourism roles exist but no immigration incentives."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Government targets high-value tourism clusters; work visas eased for project leads."
      }
    }
  },
  "ff9929a3-8a12-422f-838c-d92d08ebab71": {
    "career": "BI Systems Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Data analysts sit on priority list with direct PR routes."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Data analysts and software engineers receive category-based invites."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialists get fast-track visas and Blue Card options."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech and EV supply-chain projects need data talent."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Data scientists/analysts included, offering Stamp 4 residency."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Highly Skilled Professional visa",
        "reason": "Points award for AI/data backgrounds; path to permanent residency."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industry 4.0 push demands BI for smart factories."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Software and data roles have direct-to-residence pathways."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Smart-city and giga-projects hunger for data analytics talent."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "National AI Strategy 2.0",
        "reason": "COMPASS framework awards salary/qualifications points to analytics roles."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Operation 300bn",
        "reason": "Golden visa for AI and analytics professionals, but competition high."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital/AI specialists on shortage list; Skilled Worker visas expedited."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds big-data and AI projects that need BI talent."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "National Master Plan 2021-2030",
        "reason": "E-commerce and fintech growth fuels demand for analytics."
      }
    }
  },
  "70a96fae-211e-4f7d-bdde-ce8ac1b2ba80": {
    "career": "Broadcast Specialist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "31",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Huge investment in entertainment and sports requires multilingual broadcast crews for events like Formula-E and e-sports."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Economy 2030",
        "reason": "MediaCorp and regional streaming hubs hire some broadcast techs, but role is not on priority list."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Dubai Media City and Abu Dhabi twofour54 actively sponsor broadcast technicians for regional TV and streaming hubs."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry growth – film & TV production hubs in Manchester, Cardiff, Pinewood – imports experienced broadcast engineers."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "None",
        "reason": "Media jobs are not immigration-prioritised but the large broadcast industry still recruits niche technical talent."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "99672999-1bc3-4ab8-8631-68a0f1761c1e": {
    "career": "Business Technology Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Skill code 261111 (ICT business analyst) sits on CSOL, facilitating visas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "IT/business analysts squarely listed under ‘Data and Digital’ priority stream."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT-Fachkräfte pathway welcomes business IT specialists without German degree."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Role 2421 ‘ICT business and systems analysts’ is explicitly on critical skills, offering fast-track residency."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "Possible points via IT profession but language and client-facing nature add friction."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Digital transformation central to NIMP 2030 yet foreign analysts usually hired only for senior posts."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Migrant Category",
        "reason": "ICT analysts can gain points but not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Fintech and e-government projects buy analyst talent but preference is for localisation."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "National AI Strategy 2.0",
        "reason": "Tech Pass and COMPASS favour digital business analysts with AI/data skill sets."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "UAE Centennial 2071",
        "reason": "Banks, airlines and free-zone tech hubs fast-track digital strategy roles."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Shortage list includes business/ICT analysts under digital occupations."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "CHIPS and Science Act",
        "reason": "Digital transformation talent supports semiconductor and advanced-manufacturing initiatives."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "National Master Plan 2021-2030",
        "reason": "E-commerce and fintech growth spurs demand, but no dedicated immigration pathway."
      }
    }
  },
  "f03641bf-3f72-483d-b593-6ed30d923874": {
    "career": "Civil Project Manager",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Construction project managers and civil engineers on priority list with state sponsorship pathways."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Civil engineers on list; PM background earns extra points."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Highway, rail and renewable projects suffer PM shortages; English-speaking hires increasing."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital Nusantara construction needs seasoned PMs on two-year expert permits."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Civil engineers yes, but PMs treated as general managers so process slower."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Construction Project Manager is explicitly on Tier-1 Green List with straight-to-residence visa."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Giga-projects like NEOM, The Line and Diriyah urgently import civil PMs."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "None",
        "reason": "Tight quota; civil PM roles usually filled by existing EP holders rotated internally."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Operation 300bn",
        "reason": "Mega airports, ports and real-estate developments require experienced PMs on short visa processing."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "59",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Infrastructure push (HS2, offshore wind) values PMs but shortage list mainly covers engineers."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Massive federal spend opens opportunities but H-1B cap limits direct immigration."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National Master Plan 2021-2030",
        "reason": "Transport megaprojects allow foreign PMs via EPC contractors but no fast-track visa."
      }
    }
  },
  "4981b7e4-c7bd-4063-ad06-5dcdaf251051": {
    "career": "Design Educator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Higher-ed lecturers eligible, but design not prioritised."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Post-secondary institutions recruit studio instructors under academic stream."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Art & design Hochschulen hire English-speaking faculty; blue-card points for PhD holders."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "None",
        "reason": "University hiring possible, but Critical Skills list focuses on STEM."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Art universities accept foreign faculty; language barrier lowers demand."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "None",
        "reason": "Green List excludes tertiary design lecturers."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "New creative universities (KAU, Princess Noura) need design faculty but prefer PhDs."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Economy 2030",
        "reason": "LASALLE and SUTD hire select foreign design faculty, but quotas tight."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Dubai Institute of Design & Innovation and NYUAD actively sponsor design educators."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative higher-ed sector globally competitive; Tier-2 visa for lecturers straightforward."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "None",
        "reason": "Universities hire foreign MFA/PhD design faculty on H-1B cap-exempt visas."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "9b1d6420-03a4-4019-adeb-763f564676fc": {
    "career": "Film Director",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Berlin’s indie scene sponsors some auteur directors, but no formal priority."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "None",
        "reason": "Section 481 tax credit draws productions but director roles usually filled before visa stage."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "State-funded film studios and Red Sea Film Festival import seasoned directors for training local crews."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Singapore Economy 2030",
        "reason": "IMDA co-funds some international co-productions, offering temporary work passes."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "twofour54 and Dubai Studio City give free-zone visas to international filmmakers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry identified as a key growth pillar; Global Talent visa fast-tracks notable directors."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "None",
        "reason": "US immigration has no creative priority list, but O-1 visas exist for proven talent."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "d9a10a7b-195e-4aac-88c8-10d8ae36c1b0": {
    "career": "Food Biotechnologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Not explicitly listed, but CSOL welcomes agri-scientists and food safety experts for export industries."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Canada courts biotech and ag-tech talent through new startup visas and research grants."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Biotech know-how valued in Germany's large food & brewing sector; easier Blue Card route."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Vision 2045 backs cultured protein and fermentation to cut imports; limited local talent pool."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on list but Ireland's huge food exports support demand for fermented ingredients scientists."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP targets biotech researchers; food giants like Ajinomoto and Meiji recruit foreign PhDs."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "NIMP pushes halal biotech and functional foods; strong incentives for foreign specialists."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "47",
        "policy": "Vision 2030",
        "reason": "Vision 2030 funds food security and desert agriculture projects that need fermentation and cellular agriculture skills."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Singapore Green Plan 2030",
        "reason": "Singapore invests heavily in alternative proteins to boost food security; GoodMeat/Temasek tie-ups create jobs."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "UAE promotes food-tech hubs in Abu Dhabi (e.g., vertical farming); niche but growing demand."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 life-sciences pillar funds precision fermentation and cultivated meat R&D."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds alternative proteins and bio-based manufacturing; skilled food biotech researchers feed that pipeline."
      },
      "vietnam": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "National Master Plan 2021-2030",
        "reason": "Strategy flags agritech and biotech to move up value chain; foreign experts get fast-track work permits."
      }
    }
  },
  "2cef7fab-96b9-42fa-a214-5923896f5b0f": {
    "career": "Food Technologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL lists food technologists for regional visas; dairy/meat export industries rely on them."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Agrifood processing plants need QA technologists, yet role is not in priority category; standard points route."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Push to upgrade palm and cocoa value chain needs product development specialists."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Food technologist appears on Ireland’s Critical Skills list due to massive dairy and whiskey exports."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "MADANI Economy",
        "reason": "Halal food processing expansion elevates need for technologists with QA and sensory skills."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Skilled Migrant Category",
        "reason": "NZ’s large dairy sector actively recruits food technologists through standard skilled migrant route."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Vision 2030",
        "reason": "New food processing zones in NEOM need QA and product developers, but still niche."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Singapore Green Plan 2030",
        "reason": "Alternative-protein pilots require technologists for scale-up, yet competition is fierce."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "We the UAE 2031",
        "reason": "Growing food-tech cluster in Abu Dhabi creates limited roles for technologists."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 sustainability drive boosts demand for reformulation experts to cut salt and sugar."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds sustainable packaging and plant-based foods—opens R&D roles, but not a core shortage occupation."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "49",
        "policy": "National Master Plan 2021-2030",
        "reason": "Export-oriented seafood processors recruit QA staff, but local talent supply is improving."
      }
    }
  },
  "f713cb7d-965a-40ce-a707-b4a18600803b": {
    "career": "Legal Philosopher",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Global Talent visa covers 'digihumanities' scholars; philosophy departments are small yet open."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities can use expedited visas for research chairs, but few positions available."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Germany funds Rechtsphilosophie chairs and offers English-language post-docs with fast-track Blue Cards."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on list, but research funding for AI ethics intersects legal philosophy."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "National AI Strategy 2.0",
        "reason": "AI governance push opens fellowships in legal theory and ethics at NUS and SMU."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "UAE Centennial 2071",
        "reason": "Branch campuses hire ethics professors for law schools, but on contract basis."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "World-leading jurisprudence centres (Oxford, KCL) sponsor global scholars under Skilled Worker route."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "CHIPS and Science Act",
        "reason": "Funding boost for humanities research within NSF; top universities sponsor J-1/H-1B for tenure-track faculty."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4f705bc0-35d0-4fd0-b311-6797b81df4b7": {
    "career": "Mental Health Nurse",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL lists mental-health nurses as critical; offers Priority Processing Health visas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Category-based draws specifically target RNs, with mental-health specialists at top of shortage lists."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe nurse shortage; psychiatric wards actively recruit foreign nurses with fast-track recognition."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Psychiatric nurses remain on Critical Skills list with fast immigration processing."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Mental health nurses on Green List Tier 1, offering immediate residence pathways."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Expansion of psychiatric hospitals under Vision 2030 increases demand for foreign nurses."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Singapore Green Plan 2030",
        "reason": "Hospitals recruit psychiatric nurses, but quota caps keep demand moderate."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "UAE Centennial 2071",
        "reason": "Mental-health services growing post-COVID; DHA streamlines overseas nurse licensing."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Despite list changes, NHS still sponsors mental-health nurses under Health & Care visa."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA community grants fund behavioural-health clinics that hire psychiatric nurses."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "f095217d-b630-4716-b0b3-dbe647096841": {
    "career": "Meteorologist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Bushfire and cyclone risk create steady demand at Bureau of Meteorology; role eligible for skilled visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Extreme-weather events push Environment Canada to recruit foreign meteorologists with radar and modelling skills."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Renewable-energy planning needs wind resource analysts; Blue Card route available."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "RPJPN 2025-2045",
        "reason": "Mounting climate risks; BMKG considers foreign experts for capacity building."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Typhoon forecasting critical; English-speaking researchers hired for supercomputer modelling."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Skilled Migrant Category",
        "reason": "MetService hires few but specialised forecasters; standard points system applies."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "NEOM and Red Sea resorts need micro-climate studies for mega-projects."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Singapore Green Plan 2030",
        "reason": "High-resolution urban climate modelling needed for flood management; limited roles."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Operation 300bn",
        "reason": "Cloud-seeding and aviation safety programmes create niche meteorologist roles."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Met Office supercomputer upgrade fuels hiring; climate science aligns with clean-energy pillar."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA funds climate resilience; NOAA and private weather firms aggressively hire forecasters and climate data scientists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      }
    }
  },
  "3a0976a8-8b6a-473f-b9a2-36a09616343b": {
    "career": "Residential Designer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL lists architects and construction managers, with interior roles considered supportive rather than critical."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Construction trades are prioritised, yet interior design remains an adjacent, lower-priority skill."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Demand for building professionals exists; interior designers may qualify but are not on primary shortage lists."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP can cover design professionals but housing design is not a named priority."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Housing rebuild needs designers, yet official ‘Green List’ focuses on structural engineers, not interiors."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Luxury residential, NEOM and tourism giga-projects hire high numbers of interior and residential designers."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Ongoing premium real-estate boom keeps residential designers in demand, though not formally listed as shortage."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 emphasises advanced manufacturing and clean energy; interior design is peripheral."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA funds affordable-housing retrofits, creating some demand for interior specialists but not an explicit shortage occupation."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "fe90ac95-8e41-4a82-b390-466a783df7f8": {
    "career": "Technology Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Migration Strategy 2023",
        "reason": "Digital adoption is a core pillar; consultants with cyber/cloud skills are sought."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Strategy courts digital specialists who can guide Canadian SMEs’ transformation."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialists, including advisory roles, get fast-track residence."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Digital roadmap mentions advisory roles, yet focuses on engineering talent."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Digital transformation consultants can qualify under ICT specialisms."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP welcomes IT professionals who advise manufacturers on Industry 4.0."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Companies need consultants to embed automation, though not a formal shortage."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Tech skills valued but advisory capacity not on ‘Green List’."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "Public-sector digitalisation drives large consulting contracts."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "National AI Strategy 2.0",
        "reason": "Enterprises seek consultants to operationalise AI across sectors."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "UAE Centennial 2071",
        "reason": "Government megaprojects and banks hire tech consultants for AI and fintech roll-outs."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Strategy incentivises digital/AI adoption across industry, boosting consultancy demand."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "CHIPS and Science Act",
        "reason": "Firms need advisors to translate federal tech incentives into business strategy."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "National Master Plan 2021-2030",
        "reason": "Tech consultants required for e-commerce scaling but outside priority list."
      }
    }
  },
  "e9b7f220-bcea-41b0-9756-96957263bbe8": {
    "career": "Youth Drama Teacher",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Secondary STEM teachers are on CSOL; drama is outside core list but still employable in private schools."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "General K-12 teachers are prioritised; arts specialists can qualify under French-language or rural postings."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz",
        "reason": "Teacher shortages mainly in STEM; arts educators have limited priority."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Green List (Tier 2)",
        "reason": "Secondary teachers in any subject can access pathways, giving mild priority to drama."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "We the UAE 2031",
        "reason": "Private international schools hire arts staff but not under strategic initiatives."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct linkage, but arts programmes sometimes benefit from community-school funding."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "272c1d4c-ab8b-472f-a408-f6a46d7b1f0b": {
    "career": "Civil/Infra Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Major road, rail and mining projects list civil engineers as critical."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Infrastructure expansions and housing push civil engineers onto priority lists."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Aging bridges and energy transition need structural and transport engineers urgently."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital Nusantara needs engineers, but immigration favouring Indonesians first."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Housing and data-centre boom drives need for civil & structural engineers."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Construction worker shortages exist, but engineer roles are less explicitly prioritised."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "MADANI Economy",
        "reason": "Infrastructure spending rising, yet semiconductor and EV sectors dominate priority."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Green List (Tier 1)",
        "reason": "Earthquake-resilient rebuild keeps civil and structural engineers on the direct-residence Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Vision 2030",
        "reason": "NEOM, Red Sea and metro projects create massive demand for infra engineers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Green Plan 2030",
        "reason": "Limited land means fewer mega civil projects; demand exists but modest."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Operation 300bn",
        "reason": "Port expansions, Etihad Rail and smart-city builds need experienced civil engineers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "HS2 and offshore wind installations keep civil engineers on shortage lists."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "US$1.2 trillion injection into highways, bridges, rail and water drives acute engineer demand."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "National Master Plan 2021-2030",
        "reason": "Transport infrastructure projects open mid-level opportunities, not formal shortage status."
      }
    }
  },
  "de64b8e4-a88f-4de7-9595-56d0d63d2119": {
    "career": "Classicist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Migration Strategy 2023",
        "reason": "Academic research positions provide pathway under Global Talent Visa for arts scholars with high citation impact."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Express Entry Category-Based Selection",
        "reason": "French-language universities favour humanities PhDs for tenure-track, though not on formal shortage list."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Deutschlandstipendium and research foundations fund classical philology positions."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Academia in humanities remains eligible for research visas though not labelled critical."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Economy 2030",
        "reason": "NUS and Yale-NUS keep small classics faculties; no strategic priority but steady hiring."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "UAE Centennial 2071",
        "reason": "Private universities occasionally hire humanities faculty, but no policy priority."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Russell Group universities continue to fund classics via arts councils despite STEM shift."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "CHIPS and Science Act",
        "reason": "No direct link; however, US universities routinely sponsor humanities scholars through H-1B cap-exempt visas."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "ab39d6b1-dbb1-42da-aa93-f75ed64e317f": {
    "career": "French Translator",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Official bilingual country actively courts French-speaking talent across all occupations, making translators directly eligible for extra CRS points."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Act allows entry for any qualified worker, but translators are not on shortage list."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "We the UAE 2031",
        "reason": "Multilingual tourism/events market creates some demand, but role not in talent visa priority."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Translators may obtain visas under general route, yet not on shortage list."
      },
      "united_states": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "3a5ace97-daaf-420c-8925-2f92fe3926c3": {
    "career": "Interaction Designer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Software developers on Core Skills List typically hire in-house UX designers."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Canada courts tech workers for its fast-growing SaaS sector; UI/UX roles included."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Tech start-up scene in Berlin hungry for designers, though not an official shortage occupation."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "E-commerce giants hire UX talent; still peripheral to industrial goals."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List explicitly mentions UX/UI among software professionals for fast-track permits."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP welcomes IT professionals; product design valued but not named."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "General tech visas allow UI/UX, but no Green List priority."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Digital experiences for mega-projects (NEOM) need designers yet visas focus on senior expertise."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "National AI Strategy 2.0",
        "reason": "Digital product design supports AI-enabled citizen services and fintech apps."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "UAE Centennial 2071",
        "reason": "Fintech and e-commerce hubs in Dubai seek UX talent under Golden Visa tech category."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry priority covers gaming and digital media where interaction design is core."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "CHIPS and Science Act",
        "reason": "Digital product design talent supports AI and semiconductor ecosystems funded by CHIPS startups."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National Master Plan 2021-2030",
        "reason": "Booming fintech apps fuel demand, though not a formal priority occupation."
      }
    }
  },
  "89c578a7-f489-4023-a5fc-f40df4188f2d": {
    "career": "Manufacturing Technologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL lists production and mechanical engineers; technologist roles adjacent but accepted."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Push to reshore battery and EV manufacturing needs technologists, but category not singled out."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Germany’s Mittelstand and auto sector urgently recruit manufacturing technologists for Industry 4.0 retrofits."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "RPJPN 2025-2045",
        "reason": "EV battery and nickel processing projects demand manufacturing talent, though focus is on engineers."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List includes mechanical engineers; technologist roles accepted but not headlined."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Highly Skilled Professional visa",
        "reason": "Japan’s robotics and semiconductor sectors grant fast-track to manufacturing technologists."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Government invests heavily in wafer fabrication and requires technologists for yield improvement."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Small manufacturing base offers some roles but not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Gigaprojects and new industrial cities create demand for smart-factory talent."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Manufacturing 2030",
        "reason": "Plan to raise manufacturing GDP share relies on technologists for precision-engineering facilities."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Operation 300bn",
        "reason": "Plan to grow advanced manufacturing output explicitly targets technologists for robotics integration."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 highlights advanced manufacturing including EV and aerospace where technologists are key."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds new fabs and advanced manufacturing plants that rely on technologists for process optimisation and automation."
      },
      "vietnam": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Large-scale chip assembly plants need process technologists to meet export targets."
      }
    }
  },
  "44baf145-ab42-4c39-8d97-9e95be7c91cb": {
    "career": "Operations Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "No specific listing for operations analysts, but business visas exist."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Strategy focuses on software/data; generic operations falls outside priority categories."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "RPJPN 2025-2045",
        "reason": "Growing e-commerce logistics generates some demand, but visa pathways are generic."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Critical Skills list focuses on tech, pharma, engineering."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Vision 2030",
        "reason": "Mega-projects need data-driven logistics and supply-chain analysts; visas available for experienced talent."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Economy 2030",
        "reason": "Data-literate operations roles fit Services 4.0 push, but not in Tier 1 shortage."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Dubai logistics and fintech clusters seek operations optimisation specialists for rapid scaling."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Operations analysis allowed under general skilled visa but not shortage-listed."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Large projects create back-office data roles, but analysts not a named shortage."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "National Master Plan 2021-2030",
        "reason": "Multinationals in manufacturing zones hire analysts, though not a talent priority."
      }
    }
  },
  "e2b24307-c36e-4992-b2ae-dea92c65d4d7": {
    "career": "Regulatory Affairs Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "TGA workforce gaps for oncology trials place role on biotech employer-sponsored visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Health Canada fast-tracks cancer therapies, creating steady demand for regulatory professionals."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "73",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "EMA filings from German pharma require English-speaking regulatory staff."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma manufacturing hub around Cork urgently hires RA specialists for EMA submissions."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Local language requirements limit openings, but HSP covers life-science experts."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Government promotes medical devices; regulatory compliance talent moderately needed."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Small but growing biotech cluster around Auckland seeks niche specialists."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Life-sciences regulation still nascent; imports dominate oncology drugs."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Green Plan 2030",
        "reason": "Biomed manufacturing and clinical-trials hub needs RA professionals to liaise with HSA."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "We the UAE 2031",
        "reason": "Plan to build regional pharma hub needs regulatory expertise, though mainly generics."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life sciences pillar and MHRA reform place oncology regulatory staff on high-demand lists."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Biotech funds within the Act drive oncology drug pipelines, demanding experts to navigate FDA submissions."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Biotech sector early-stage; RA roles limited to generics import."
      }
    }
  },
  "dace5a51-1be9-4b34-b55e-ba6ab6ce3de9": {
    "career": "Sports Rehab Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Physiotherapists, incl. sports specialisms, on long-term skills list with fast visa pathways."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Physiotherapists are a named health shortage; easier PR with category-based draws."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe rehab staff shortage; simplified recognition of foreign physio degrees."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Physiotherapists on list; sports specialism valued by rugby and GAA clubs."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Licensing barriers high; few openings outside national athletic teams."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Physiotherapists on Green List providing straight-to-residence visas."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Growth of elite sports programmes (NEOM, Riyadh Season) creates niche roles but not formal shortage."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Singapore Green Plan 2030",
        "reason": "Elite sports science hub at Sports Hub creates some roles but outside core priority list."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Private sports academies hire foreign physios, yet occupation not in priority quotas."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "NHS shortage is in general physio, sports rehab roles compete for limited Skilled Worker visas."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Demand from pro-sports and ageing population, but sports physiotherapy not listed in federal talent programmes."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "bdeaa019-b542-4fcd-9207-feed893b851b": {
    "career": "Stage Manager",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Rich cultural scene yet no fast-track visa for stage crew."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Mega-events need experienced foreign stage managers but visas remain employer-driven."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s live-events boom opens slots, yet occupation not on priority residency lists."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries flagged in IS-8; seasoned stage managers can qualify under Skilled Worker visa with employer sponsorship."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Strong theatre industry (Broadway) but no special immigration concessions."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "f93cfd71-79b6-4547-b35f-a3c45ce53054": {
    "career": "Water Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "Chronic drought drives demand for groundwater and catchment scientists in skilled-migration lists."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Fresh-water management a national priority; hydrologists qualify for environmental STEM draws."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "River restoration and flood control projects recruit environmental scientists."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "RPJPN 2025-2045",
        "reason": "Capital relocation to Nusantara needs water planners; still employer-sponsored."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Limited dedicated visa priority, though EU projects hire occasionally."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Flood-management research after typhoons attracts HSP points for PhD holders."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Water quality issues after dairy boom put hydrologists on Green List Tier 2."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Desalination R&D and NEOM’s water innovations create selective openings."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Singapore Green Plan 2030",
        "reason": "PUB water-recycling R&D hires specialists but numbers small compared with AI talents."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "We the UAE 2031",
        "reason": "Water-security labs hire experts, but immigration prioritises AI and energy first."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean growth pillar includes water tech, yet not on shortage list so sponsorship needed."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA funds $55 billion for water; hydrologists in high demand for remediation and climate resilience."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "National Master Plan 2021-2030",
        "reason": "Mekong delta subsidence projects recruit hydrologists under infrastructure plan."
      }
    }
  },
  "4ddca49d-74fb-435f-a84c-70cd3573f07c": {
    "career": "Assessment Specialist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Education roles rarely reach CRS cut-offs unless French-speaking."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Education reform hires consultants, but visas employer-specific."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "MOE pilots adaptive testing; niche openings but outside core priorities."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Abu Dhabi education councils commission large-scale assessments."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Ofqual outsources psychometrics, yet role not on shortage list—sponsorship needed."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Testing firms still sponsor H-1B, but occupation outside federal priority lists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "9ccf5be3-b5aa-4290-9ffc-b3cdfa53459a": {
    "career": "Biological Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Migration Strategy 2023",
        "reason": "Some slots under medical device and pharma categories, but smaller industry."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Federal push on bio-manufacturing; quick visas for PhD-level bioengineers."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Bioeconomy roadmap funds industrial biotechnology startups."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Government investing in vaccine and biofertiliser plants, but immigration flows limited."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Med-tech and pharma multinationals cluster around Cork & Galway; bioengineers on critical list."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "Synthetic-biology and regenerative-medicine labs qualify for top HSP points."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Medical devices and specialty chemicals need bio-process engineers."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Ag-biotech roles exist but not Green-List priority."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "New pharma and vaccine plants under Vision 2030 seek niche bioengineers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Singapore Economy 2030",
        "reason": "Biomed cluster at Biopolis offers EP and ONE Pass for bioengineers."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Operation 300bn",
        "reason": "Biomanufacturing earmarked as advanced industry; Golden Visa for PhD holders."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences pillar funds bioprocessing, gene-therapy facilities; Skilled Worker visas available."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA’s biotech & biomanufacturing incentives spike demand for synthetic-biology engineers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "National Master Plan 2021-2030",
        "reason": "Emerging biopharma sector; still employer-sponsored."
      }
    }
  },
  "42d0242c-ecae-4c46-85f1-62de0da7e9f9": {
    "career": "CEO",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "General managers admissible through Employer-Sponsored stream, yet not listed on Core Skills Occupation List."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Program rewards senior management skills but CEOs compete with tech/health priority candidates for points."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Managers can use EU Blue Card, but no specific demand signal for top executives."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Executives fit General Employment Permit; tech and pharma roles receive priority instead."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Skilled Migrant Category",
        "reason": "Allowed under ANZSCO but Green List focuses on technical roles, not corporate leadership."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Mega-projects (NEOM, Red Sea) actively head-hunt foreign CEOs to build new industries."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Economy 2030",
        "reason": "EP and Overseas Network & Expertise Pass actively court global CXOs for regional HQs."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Golden Visa fast-tracks proven C-suite talent for free-zone headquarters and Operation 300bn industrial clusters."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Global Business Mobility & Innovator Founder visas suit CEOs, yet not a shortage-list occupation."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Not a shortage occupation, but US multinationals relocate C-suite via L-1/O-1 when leading federally funded megaprojects."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "30aed61b-4f01-4b1b-8ccb-b9f0e4f62016": {
    "career": "Computing Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "CSOL lists software developers and data scientists; research roles ride same demand."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Canada brands itself as the global AI hub and grants fast visas to research scientists."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "AI centres in Munich and Berlin aggressively recruit international computer science PhDs."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "SFI centres and US Big Tech campuses need PhD-level researchers."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points favour AI/robotics researchers; subsidies under Society 5.0."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Government funds semiconductor and AI research clusters in Penang and Cyberjaya."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Migrant Category",
        "reason": "Limited research funding; openings exist but few compared with engineering shortages."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "KAUST and NEOM hire AI researchers, yet volumes are smaller than engineering and hospitality."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "National AI Strategy 2.0",
        "reason": "A*STAR and NUS expand quantum, cybersecurity and AI labs; EP points favour PhDs."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "UAE Centennial 2071",
        "reason": "MBZUAI and DIFC AI labs attract talent but on niche scale."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Shortage list covers AI/cyber; Global Talent visa eases entry for computing researchers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Massive federal funding for AI, quantum and semiconductor research drives demand for PhD computer scientists."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Emerging R&D parks need computing researchers for chip design toolchains."
      }
    }
  },
  "7d67a791-5c63-4d0d-9838-d307c8ea49de": {
    "career": "Dance Therapist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "Art therapists listed under community and personal service workers; regional hospitals sponsor."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Allied health occupations get bonus points even if dance therapy is niche."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Rehab clinics hire creative arts therapists amid aging population."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Mental-health workforce shortage includes creative therapists, but not on Green List."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Creative arts therapists licensed by HCPC can obtain health-worker visas."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct policy, but US healthcare labour shortages allow visas for allied therapists in some states."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "86978268-d2dc-4e54-bc16-cff6e922f615": {
    "career": "Feminist International Relations Scholar",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Migration Strategy 2023",
        "reason": "Higher-education sector recruits internationally; academic stream separate from CSOL."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Universities sponsor tenure-track faculty; social-science academics receive points for PhD and French ability."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "DAAD and Humboldt funds social-science postdocs; gender studies growing in Berlin universities."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Social-science lecturers qualify for General Employment Permits though not on critical list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Limited IR departments, but universities can sponsor specialist lecturers."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Economy 2030",
        "reason": "NUS and NTU hire international faculty; subject not a national priority but tolerated."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Global Talent visa supports academia; LSE and SOAS are feminist IR hubs."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "CHIPS and Science Act",
        "reason": "Academic visas (J-1, H-1B cap-exempt) available; US universities dominate IR research funding though not policy-driven."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "d7476ee1-296e-4ccd-a645-4837228067c0": {
    "career": "Geological Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Mining and civil mega-projects desperately need geological and geotechnical engineers, fast-tracked for visas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Critical minerals push and northern mining expansion place geological engineers on priority lists."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "59",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Renewable-energy foundations require geotechnical skills, but shortage focus lies elsewhere."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel and EV battery supply chain relies on geological engineers for resource evaluation."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Civil engineers listed; geological specialism acceptable but few mining projects."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "Seismic design demands geotechnical expertise for infrastructure resilience."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Critical-minerals exploration for semiconductors increases demand, but still emerging."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Listed under civil/structural; earthquakes drive demand for ground-engineering expertise."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Vision 2030",
        "reason": "Massive mining and giga-infrastructure projects recruit foreign geological engineers for resource mapping."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Operation 300bn",
        "reason": "Underground metro and renewable projects require subsurface studies, though scale smaller than Saudi."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Offshore wind and HS2 create pockets of need, but field not on shortage list."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Highway, tunnel and critical-minerals projects need geotechnical experts but not formally listed as shortage."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Bauxite and rare-earth mining growth calls for geological expertise."
      }
    }
  },
  "251beab9-4a5a-4ca3-87cc-8b6d459975d9": {
    "career": "HPC Developer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Software engineers are eligible but HPC is a niche within the broader category."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "AI and data-center growth puts HPC skills on the preferred tech talent list for Express Entry."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "National supercomputing centres and automotive simulation clusters actively sponsor HPC developers."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Only a handful of government labs run HPC, so jobs are scarce."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma and fintech giants run HPC workloads and can fast-track visas for experts."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Highly Skilled Professional visa",
        "reason": "Fugaku successor projects and robotics R&D give steady demand for parallel-programming engineers."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Semiconductor fabs need some HPC for chip design but hiring volume is modest."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Limited but growing demand via university climate-modelling labs and genomics projects."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "NEOM and Aramco use supercomputing for energy modelling, creating specialised but small openings."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "National AI Strategy 2.0",
        "reason": "National Supercomputing Centre doubles capacity in 2025, actively importing CUDA/OpenMP talent."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Operation 300bn",
        "reason": "Abu Dhabi’s G42 and national AI cloud recruit HPC programmers for Arabic LLMs."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "£1B exascale programme and Cambridge’s AI clusters put HPC on the shortage radar."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Exascale and semiconductor investments are driving massive hiring in GPU, MPI, and quantum-ready high-performance computing teams."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Early-stage HPC clusters for EDA; roles exist but still experimental."
      }
    }
  },
  "ff9fd65b-fe5f-4dd6-8f87-f8d3b6b7a2af": {
    "career": "HR Business Partner",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "HR managers rarely appear on Core Skills List, but employer-sponsored visas remain possible."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Only Francophone or tech-specific HR roles earn extra points; otherwise standard CRS competition."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "General management roles can qualify via points but face German-language barrier."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "HR is not critical; general work permit possible but slower."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Corporate HR roles seldom qualify for HSP points unless bilingual in Japanese."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "MADANI Economy",
        "reason": "TalentCorp brings some senior HR leaders, but local preference dominates."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Skilled Migrant Category",
        "reason": "HR managers included but ranking lower than health and engineering on points."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Saudization pushes firms to localise HR, shrinking expat quotas."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Singapore Economy 2030",
        "reason": "EP eligibility exists but HR not in Shortage Occupation List; COMPASS points needed."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "We the UAE 2031",
        "reason": "Multinationals rely on expat HRBPs to manage diverse workforces in free zones."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Role not on shortage list; sponsorship only for senior pay bands."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Large federal contractors still sponsor HR managers, but immigration priority is low."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b041bad9-2d48-4cf5-9536-25dbdbb4f142": {
    "career": "Sculptor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Distinguished Talent visa possible for award-winning sculptors."
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Opportunity Card (Chancenkarte",
        "reason": "Freelance artist visa exists but requires proof of income and health insurance."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital city art installations recruit international sculptors on project visas."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Highly Skilled Professional visa",
        "reason": "Cultural visas available but small market, requires gallery sponsorship."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Gigaprojects (AlUla, NEOM) commission large-scale public art from foreign sculptors."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Economy 2030",
        "reason": "ArtsHouse residencies exist but no strategic policy priority."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai Culture free zone offers visas to international artists and artisans."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry priority; Global Talent visa open to acclaimed sculptors."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Not policy-linked, but O-1 visa supports exceptional artists and public-art commissions abound."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "fa5b9a57-2944-473c-9a2a-842256ea26ea": {
    "career": "Sports Performance Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Sport scientist roles fit under 'Other Natural and Physical Science Professionals' on shortage lists."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Few dedicated NOC codes; points depend on general Kinesiology qualifications."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Bundesliga clubs sponsor specialists but numbers are limited."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "RPJPN 2025-2045",
        "reason": "New football league investments create niche openings."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Outside Gaelic games institutes, demand is small."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "J-League clubs occasionally hire but language barrier high."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "MADANI Economy",
        "reason": "National Sports Institute employs few expats."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Migrant Category",
        "reason": "High Performance Sport NZ hires data-driven managers for Olympic preparation."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Vision 2030",
        "reason": "Massive spending on elite academies and football clubs drives strong foreign recruitment."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Singapore Economy 2030",
        "reason": "SportsHub hires some performance staff, but quota limited."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "We the UAE 2031",
        "reason": "Dubai Sports Council funds pro teams needing performance departments."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Premier League clubs sponsor visas, but role not on official shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "NFL and NBA hire sports scientists, but no formal immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4245b59f-3733-452c-9efd-32c6ee3c0578": {
    "career": "Startup Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Start-up Visa targets founders, not consultants; employer sponsorship still feasible."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Regional incubators hire consultants, but immigration preference is for technical founders."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Berlin’s VC scene uses advisors, but role not prioritised."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nusantara innovation hub imports some foreign advisors."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Enterprise Ireland funds external mentors for SaaS and med-tech startups."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "Startup visa focuses on entrepreneurs; consultants need employer sponsorship."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "MADANI Economy",
        "reason": "Cradle Fund incubators bring in a handful of foreign mentors."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Migrant Category",
        "reason": "Callaghan Innovation contracts some consultants yet visas focus on deep-tech founders."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Government-backed accelerators pay foreign experts to mentor new SMEs."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Singapore Economy 2030",
        "reason": "EDB and SGInnovate rely on seasoned consultants to groom deep-tech ventures; EP attainable."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai Future District Fund and Operation 300bn recruit advisors to scale startups."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "London’s tech city hires consultants under the Scale-Up visa route."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "CHIPS and Science Act",
        "reason": "Venture ecosystems exploding around semiconductors and climate tech create advisory roles."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "National Master Plan 2021-2030",
        "reason": "Tech parks hire consultants but priority remains engineers."
      }
    }
  },
  "78d1a17b-e24f-4d1e-9abe-5b69759ff7de": {
    "career": "TESOL Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Teacher shortages exist, yet English specialists are only moderately favoured outside remote areas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "English-language specialists support newcomer integration and are accepted under the teachers/early-childhood categories."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Schools need English teachers, but immigration incentives focus on STEM and nursing first."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Vision stresses human-capital English skills, yet no special migration lane exists."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Eikaiwa and JET demand remains, yet program visas sit outside priority engineering tracks."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 2)",
        "reason": "Secondary and language teachers qualify for fast-track residence pathways."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Private schools hire ESL experts, but no dedicated immigration priority exists."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "ESL demand is growing but K-12 teaching is not on any federal priority list."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "High demand for English teachers, but no strategic visa stream beyond standard work permits."
      }
    }
  },
  "c7c4b145-675c-4158-af45-b5396844a841": {
    "career": "Water Resource Manager",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Severe drought cycles place water engineers on the core skills list with fast-track visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Climate-resilient infrastructure is a national priority; civil/environmental engineers receive extra points."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Utilities modernisation and EU water-quality directives need specialists, though below top shortage occupations."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital Nusantara requires end-to-end water-resource planning."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Civil/environmental engineers qualify; ageing water networks face EU infringement fines."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-city and flood mitigation projects recruit, yet preference is for domestic engineers."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Water projects exist but are overshadowed by semiconductor and EV priorities."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1)",
        "reason": "Civil and environmental engineers on Green List gain automatic residence pathways."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Mega-projects (NEOM, Red Sea) demand large-scale desalination and water-reuse planning expertise."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Singapore Green Plan 2030",
        "reason": "PUB’s NEWater and Deep Tunnel projects keep demand steady for water professionals."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Operation 300bn",
        "reason": "Nation targets advanced water-treatment and reuse technologies to hit sustainability goals."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "OFWAT reforms create jobs, but the role is not on shortage list; visas are competitive."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "US$55 billion earmarked for drinking-water and wastewater projects drives immediate hiring of water managers."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National Master Plan 2021-2030",
        "reason": "Mekong delta flood control and urban water upgrades need expatriate expertise."
      }
    }
  },
  "e85794f9-7e34-4f18-97a5-0625565caa74": {
    "career": "Behavioural Economist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Behavioural insights teams are small and do not appear on CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Roles exist in nudge units and banks but outside priority immigration streams."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Some federal ministries run nudging projects, yet visa preference is for STEM."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Behavioural analysts plug into fintech and pharma marketing, qualifying under economist category."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Immigration focus is on engineering; social scientists rarely sponsored."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Islamic finance sector experiments with nudges, but vacancies remain few."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Very limited openings; applicants compete under generic analyst category."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "National AI Strategy 2.0",
        "reason": "GovTech’s behavioural design teams and fintech hubs recruit regularly."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "UAE Centennial 2071",
        "reason": "Banks and fintechs value behavioural insights, but hiring remains niche."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Financial services and the Behavioural Insights Team keep steady demand for economists."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Government labs and tech firms hire, yet not tied to federal industrial funding."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "2fe9c84d-c839-44a4-a05d-b9bbbfe43d53": {
    "career": "Dance Program Coordinator",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Cultural and entertainment push funds large dance academies and festivals."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai’s creative clusters actively import performing-arts managers for tourism events."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry boom, yet no visa shortage; arts council sponsorship needed."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Arts visas exist (O-1), but no immigration priority or funding alignment."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "792a6be0-494d-4432-8c86-55791f8d0028": {
    "career": "Digital Journalist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "State-backed English outlets and sports media expand, yet roles are politically sensitive."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai Media City recruits digital reporters for regional and global news portals."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry growth supports roles, but not on shortage list; exceptional-talent visa possible."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "No immigration priority; media layoffs common despite pockets of demand."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "9024a0f2-b4f7-432f-924b-47f23d155e61": {
    "career": "Diplomatic Liaison",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Policy highlights French-speaking and international relations skill sets, but no dedicated fast-track for diplomacy."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "We the UAE 2031",
        "reason": "The UAE actively hires international liaison officers for global conferences but no formal immigration priority."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Skilled Worker visa accepts ‘policy analysts’ as shortage adjacent, but not a core priority."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Foreign-service style roles are government–controlled, but leadership/negotiation experience is valued in U.S. multinational and multilateral organisations."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "8ff1bdb4-4216-47ac-a2e2-4fa77d9ea7e2": {
    "career": "Mathematical Modeler",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL lists data analysts and actuarial mathematicians—overlaps with modelling."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Category for data scientists and AI specialists explicitly includes modelling experts."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Fast-track for IT and engineering, including simulation engineers."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Critical Skills lists data scientists/statisticians—direct overlap."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points favour AI/robotics researchers using mathematical models."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industry 4.0 analytics needs but no special visa lane."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Migrant Category",
        "reason": "Points for data analysts but no green-list slot."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Mega-projects use demand forecasting models, but no formal visa priority."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "National AI Strategy 2.0",
        "reason": "Nation funds quantitative research teams in finance, disease modelling, climate risk."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "UAE Centennial 2071",
        "reason": "Golden Visa track for AI and data scientists encompasses mathematical modelling."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital/AI and clean-energy workstreams demand fluid-dynamics and optimisation modelers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds advanced computing, climate and health modelling—directly hiring mathematical modelers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Chip design sims need modelers; still early-stage."
      }
    }
  },
  "8ca973ea-3073-409a-b3c8-af366fba2ebc": {
    "career": "Microbiology Lab Tech",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL names medical laboratory scientists and technicians as shortage roles."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Health-care lab technologists listed under targeted health occupations."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Act prioritises healthcare workers, including laboratory technologists."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Demand exists in pharma manufacturing, but not critical-skills tier."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Green List (Tier 2)",
        "reason": "Green List contains ‘medical laboratory scientist’ pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Expanding healthcare cities creates moderate demand for lab staff."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "",
        "reason": "Biomedical hub hires lab staff, but Employment Pass requirements unchanged."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "We the UAE 2031",
        "reason": "Private hospitals recruit foreign lab techs but no formal fast-track."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "List includes biomedical scientists; microbiology labs qualify."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "",
        "reason": "Biotech boom (IRA clean-energy biotech credits) keeps demand for lab technicians."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "f17c9549-2820-4317-a7b1-9e9b29223712": {
    "career": "Veterinary Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL lists veterinarians and animal scientists as shortages."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Stream for researchers and agri-food specialists covers veterinary science."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Animal-health research exists but STEM priority sits with engineering and IT."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Agri-food economy needs animal scientists but not on critical list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Veterinarians are on Tier-1; research roles overlap."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "USDA and NIH fund animal-health studies but not immigration-priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "c528dc31-6aec-4ba8-ae05-e4a6f3b200dc": {
    "career": "Architectural Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL names civil/structural and construction PM roles; immediate visa pathways."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Civil and structural engineers are targeted occupations."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Shortage of Bauingenieure (structural engineers) in energy-efficient retrofits."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital city construction seeks foreign expertise but still protectionist."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Construction rebound has openings but not on critical list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-city architects qualify for HSP points but language a barrier."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industrial park expansion needs engineers yet no explicit fast-track."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Structural and civil engineers on Tier-1 with direct residency path."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Vision 2030",
        "reason": "Giga-projects like NEOM recruit thousands of architectural engineers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Built-environment roles exist, yet not in Manufacturing 2030 priority."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Operation 300bn",
        "reason": "Mega-developments and sustainability retrofits create high demand and Golden Visa eligibility."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean-energy infrastructure (offshore wind, nuclear) needs building-envelope specialists."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA funds bridges, rail and energy-efficient buildings—demanding architectural engineers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Local licensing rules and preference for domestic engineers."
      }
    }
  },
  "421bf474-7555-4290-9d8e-36e3504b8501": {
    "career": "Budget Officer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "State treasuries recruit budget analysts yet the occupation is absent from CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Public-sector finance roles exist but are not on Express Entry priority lists."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Federal/Länder ministries need fiscal planners, though not flagged as shortage in Skilled Immigration Act."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Mega-projects (NEOM, Red Sea) require rigorous budgeting but Saudization limits foreign mid-level posts."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Large sovereign entities seek budget control talent, yet no dedicated immigration fast-track."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "",
        "reason": "HM Treasury and councils hire but role not on Shortage List after 2025 changes."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Multi-billion federal outlays under IIJA and IRA need specialists to plan, track and audit agency budgets."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "64a87ead-9bf0-4ee8-b849-8c0bb82c0a2c": {
    "career": "Computational Biologist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "CSIRO and medical research institutes sponsor genomics specialists under STEM visa categories."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Biotech clusters in Toronto and Montréal recruit via STEM-focused streams."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Bioinformatics roles at Max-Planck and pharma firms qualify for Opportunity Card fast-track."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Biopharma corridor (Cork-Limerick) lists bioinformaticians as critical skill."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "AMED projects in genomics qualify for points-based HSP visa."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "NIMP 2030 promotes biotech and medical-device R&D; labs seek computational talent."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Some university labs recruit, but role not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "NEOM biotech hub is emerging, still limited openings."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Singapore Economy 2030",
        "reason": "Genome Institute and A*STAR aggressively hire computational biologists under National AI Strategy 2.0."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Operation 300bn",
        "reason": "Genome programme boosts demand yet numbers remain small."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 names life sciences as pillar; Cambridge–Oxford–London ‘Golden Triangle’ hungry for computational genomics talent."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Massive federal grants for biotech and precision medicine drive demand for bioinformatics PhDs."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "",
        "reason": "Emerging biotech parks but immigration priority sits with semiconductor and energy engineers."
      }
    }
  },
  "71501a01-e601-4abf-b120-40d5773b7f7b": {
    "career": "Health Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Migration Strategy 2023",
        "reason": "NHMRC-funded institutes sponsor health researchers on updated skilled-visa pathways."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Public-health and epidemiology researchers invited under STEM and healthcare streams."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "University medical centres offer Chancenkarte to health research PhDs."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Public-health and biopharma research roles qualify for critical-skills permit."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "AMED and RIKEN research projects sponsor PhDs in epidemiology and health data science."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "MADANI Economy",
        "reason": "Government trials to grow med-tech research, but numbers small."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Some demand in public-health units, but role absent from Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Biotech and clinical research zones emerging, yet foreign hiring limited to senior levels."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Green Plan 2030",
        "reason": "Preventive-health clusters and A*STAR fund population-health studies needing scientists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Dubai Science Park recruits researchers, though no official fast-track."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences ‘Grand Challenge’ funds health science innovation across NHS trusts and universities."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Federal boost for biomedical and public-health R&D finances NIH, CDC and private labs."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "d0a51971-06b7-4366-ba76-9c814608101d": {
    "career": "Hospitality Brand Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Tourism-heavy states recruit brand managers, though not on CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Express Entry prioritises trades and health, not marketing professionals."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "RPJPN 2025-2045",
        "reason": "Bali and Labuan Bajo projects need branding but hiring skewed to local talent."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "NIMP aims at manufacturing; tourism branding roles rare for visas."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Tourism is key sector but immigration priority goes to chefs and managers, not brand roles."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Gigaprojects like NEOM and Red Sea luxury resorts need global branding talent immediately."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "",
        "reason": "Premium hotel chains base APAC branding teams in Singapore despite no official shortage list."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi push for world-class tourism branding under Centennial 2071 vision."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Creative visas favour senior film/gaming talent, not hospitality marketing."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Tourism rebound fuels branding roles, but no federal immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b3cb7d06-67e7-4057-a628-a43f894aa806": {
    "career": "Music Tutor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Role outside Core Skills list but niche demand in cities."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Private music schools hire, yet occupation not on Express Entry priority."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "",
        "reason": "Rich classical heritage fuels steady demand; Blue Card available but not shortage."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Private music schools hire foreigners for Western instruments, but language barrier."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Demand in enrichment centres, but MOM tightens passes for arts tutors."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "International schools hire music tutors, but no special immigration advantage."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "ABRSM culture sustains demand; however, Skilled Worker visa sponsorship limited."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Strong extracurricular music market, but no federal visa preference."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "429a0bb8-5c11-4e49-afee-6882426f079c": {
    "career": "Robotics Expert",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Engineers welcome, but robotics not singled-out."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Target list explicitly names AI, automation and robotics engineers."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Need industrial mechatronics and automation talent for Mittelstand factories."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Automation needed in nickel/EV plants yet not formal shortage."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Software & AI priority—robotics accepted but not headline."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics engineers explicitly prioritised for ageing-society automation."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industry 4.0 and automation goals create moderate pull."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Generic engineering shortage, robotics niche."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "NEOM and giga-projects advertise demand for autonomous systems."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "National AI Strategy 2.0",
        "reason": "Robotics engineers align with precision-engineering and AI robotics testbeds."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing push includes industrial robots."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Robotics aligns with clean/advanced manufacturing and defence tech goals."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Federal funding for autonomous manufacturing and advanced robotics labs."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "National Master Plan 2021-2030",
        "reason": "Electronics manufacturing shifting toward robotics, but skills list focuses on semiconductors."
      }
    }
  },
  "39b60545-153f-4794-8d83-dc71ae02f711": {
    "career": "Technical Director",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Senior ICT managers accepted but secondary to hands-on coders."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Tech managers qualify under software and data categories."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Points for experience; management roles welcomed but not prioritised."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "RPJPN 2025-2045",
        "reason": "Digital transformation goals open doors for experienced tech heads."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Tech multinationals in Dublin routinely sponsor senior directors."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "Points for management experience; language hurdles remain."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "MADANI Economy",
        "reason": "Tech parks hiring foreign CTOs to scale start-ups."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "ICT managers on skill lists, but numbers limited."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Megaprojects recruit foreign tech leaders for smart-city rollouts."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Singapore Economy 2030",
        "reason": "Global-HQ hub hungry for seasoned technical directors overseeing regional teams."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai and Abu Dhabi free-zones attract senior technology executives."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital sector growth needs experienced technical leadership."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Large federal tech projects value senior tech leadership, though not a named shortage."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "National Master Plan 2021-2030",
        "reason": "Growing ICT sector values foreign leadership, but few slots."
      }
    }
  },
  "1a3784e9-ee8e-4934-9a59-b40d379f940d": {
    "career": "Child Psychologist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Clinical psychologists including child focus listed in health shortages."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Allied health occupations, especially mental-health, receive extra points."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Mental-health roles recognised but language barrier strict."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "RPJPN 2025-2045",
        "reason": "Few foreign licences recognised; demand exists in Jakarta."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Clinical psychologists eligible for fast-track permits."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Highly Skilled Professional visa",
        "reason": "Psychology not priority; ageing rather than paediatric focus."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Private urban clinics importing child specialists."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Clinical psychologists on Tier 1 shortage list."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Child mental health clinics expanding within new healthcare cities."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Singapore Green Plan 2030",
        "reason": "Child mental health flagged as growing public-health concern."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "We the UAE 2031",
        "reason": "Private hospitals hunting for licensed paediatric psychologists."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "NHS *Child & Adolescent Mental Health Services* posts difficult to fill."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Funds community mental health programmes; paediatric specialists in demand."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Mental-health awareness rising but immigration pathways unclear."
      }
    }
  },
  "e9fbfd7c-513b-4894-a6b9-d6e7912ded52": {
    "career": "Diversity and Inclusion Officer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Corporate sustainability reporting drives moderate need for inclusion experts."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Multicultural policy environment values D&I expertise though not formal list."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Large multinationals embrace D&I, but no shortage status."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Tech multinationals self-fund D&I roles, but not visa priority."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Skilled Migrant Category",
        "reason": "Government agencies emphasise equity in public service."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Economy 2030",
        "reason": "Fair Consideration Framework promotes workforce diversity reporting."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Multinational HQs adopt global inclusion standards."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Large City firms and media require D&I reporting."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Federal contractors must meet workforce diversity targets, spurring demand."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "2db8e6d0-52ad-40f3-94a0-898d6334c7d5": {
    "career": "Educational Leader",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Secondary STEM and regional schools need experienced principals."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Express Entry Category-Based Selection",
        "reason": "French-speaking and rural school leaders in demand."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "International schools recruit foreign heads; strict language rules for public sector."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "International curriculum schools hire expatriate heads in Jakarta/Bali."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Leadership roles possible but not on critical list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "MADANI Economy",
        "reason": "International schools in KL recruit foreign principals."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Principals and education managers listed as hard-to-fill roles."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Vision 2030",
        "reason": "Private international schools in new economic zones hire foreign leaders."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "We the UAE 2031",
        "reason": "Dubai/Abu Dhabi private schools aggressively recruit experienced principals."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Academy chains use Global Talent visas sparingly for head-teachers."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "School modernisation funds create some principal vacancies, but not a visa priority."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "National Master Plan 2021-2030",
        "reason": "Growth of bilingual schools drives niche demand."
      }
    }
  },
  "b4576c43-1827-4fdf-ba33-8cf16510cfe5": {
    "career": "Environmental Policy Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Renewable-energy build-out and water-security debates require environmental policy expertise."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Climate-adaptation projects and carbon-pricing reforms create good but not priority-list demand for policy talent."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Aggressive Energiewende and EU Green Deal compliance drive hiring of environmental policy specialists."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel-mining and geothermal expansion need environmental governance advisers."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Green-finance hub raises some demand, but the occupation is not on the critical list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Highly Skilled Professional visa",
        "reason": "GX (Green Transformation) plan sparks niche policy work, yet immigration targets engineers first."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "NIMP’s renewable-energy thrust needs policy research, though openings are limited."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Green List (Tier 2)",
        "reason": "Emphasis on climate resilience and biodiversity offsets supports steady recruitment."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Mega-projects must clear environmental approvals, but localisation focus tempers openings."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Singapore Green Plan 2030",
        "reason": "Carbon-tax and sustainable-finance push open some roles, but not on Tier-1 shortage lists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "Net-zero 2050 pledge generates consulting roles, yet immigration priority sits with engineers not analysts."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Offshore wind, hydrogen and CCUS clusters need policy analysts to shape subsidies and regulation."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA pours hundreds of billions into climate and clean-energy programmes, fuelling demand for analysts to design and track policy impacts."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "National Master Plan 2021-2030",
        "reason": "Offshore-wind and LNG build-outs require environmental review capacity but not formally prioritised."
      }
    }
  },
  "bfb40848-2508-4318-87ba-b79c67a15f15": {
    "career": "Experimental Photographer",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Artist visas exist, though outside Express Entry priority categories."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Berlin’s art scene attracts photographers, though not on shortage list."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Vision 2030",
        "reason": "Massive investment in entertainment and cultural districts seeks avant-garde visual artists."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Arts houses and photography festivals offer limited but notable opportunities."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s media-free zones and art fairs actively recruit creative talent."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry route covers senior photographers with strong portfolios."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "No immigration priority, but the US market funds art grants and residencies."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "13c0b252-2a0c-4fbb-81fd-819135e14b0e": {
    "career": "Export Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "Opportunities in agriexport and mining houses but outside core shortage list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Trade-compliance expertise valued yet not on category-based draws."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Export-driven Mittelstand needs trade specialists though engineers still priority."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel and EV battery export growth needs logistics specialists."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Med-tech exporters value the role but IT skills dominate the list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Export manufacturing firms hire specialists but language barrier high."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Semiconductor and EV sectors scaling exports require trade professionals."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Niche roles in dairy and wine export firms."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Non-oil export expansion needs customs and trade-finance experts."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Singapore Economy 2030",
        "reason": "World-class port and trade-tech ecosystem recruit export operations experts."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Operation 300bn",
        "reason": "Dubai-Jebel Ali logistics hub aggressively recruits export and trade-compliance professionals."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Post-Brexit firms need customs expertise, though not officially prioritised."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Supply-chain resilience programmes create some openings, but not a shortage occupation."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "National Master Plan 2021-2030",
        "reason": "Booming electronics exports create demand for compliance and documentation talent."
      }
    }
  },
  "dde09874-a5c9-4778-9b83-cdbb8f73d1c2": {
    "career": "Food & Beverage Director",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Lists chefs but not F&B directors on shortage rolls."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Express Entry focuses on cooks and servers rather than senior directors."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Hospitality hires exist but not in critical-skills lists."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Tourism growth drives some openings, but no special visa track."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "47",
        "policy": "",
        "reason": "Seasonal labour priority over senior management."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Luxury resorts in NEOM, Red Sea and AlUla urgently seek seasoned F&B leadership."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Marina Bay and Changi-linked resorts seek experienced directors despite tighter quotas."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi hotels compete for global-standard F&B directors."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Large hospitality market, yet not an immigration priority occupation."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "28523ae3-2e5b-408a-b3be-b6a88ec3fcd5": {
    "career": "German Teacher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Secondary language teachers in shortage, though STEM takes priority."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "French-speaking teachers prioritised; language teachers still benefit from acute K-12 shortages."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Foreign-language teachers are actively recruited for schools."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "International schools hire language teachers despite Emiratisation drive."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "8de210a6-df2a-412d-ad54-1b3eb1143f96": {
    "career": "International Finance Lawyer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Strategy focuses on STEM and health; legal services not on Core Skills list, but global-capital work exists in Sydney."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Law is not in any targeted Express-Entry category, yet Big-Law firms still hire qualified foreign attorneys."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Act permits qualified professionals, yet German/ EU law requirements and language make entry tough for foreign finance lawyers."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Financial-services lawyers not on list, but Dublin’s post-Brexit funds hub hires common-law finance specialists under General Employment Permit."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Vision 2030",
        "reason": "Mega-projects and sovereign-wealth activity need finance counsel, but localisation rules limit foreign legal practice licences."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Economy 2030",
        "reason": "Global hub for sustainable and structured finance; Foreign Practitioner licences readily granted for cross-border deals."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "We the UAE 2031",
        "reason": "DIFC/ADGM position Dubai-Abu Dhabi as global finance hubs, aggressively issuing legal-practise permits to cross-border finance specialists."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London depends on international capital markets; Skilled-Worker visa explicitly lists solicitors/ barristers in shortage for financial services."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Wall Street demand for cross-border deal lawyers is high, but U.S. immigration policy does not list lawyers as a shortage occupation."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "94b5e364-78b8-417f-a0c6-d372f496eed0": {
    "career": "International Political Economy Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Limited targeted demand, though Canberra and mining majors hire Asia-policy economists."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "High-skill visas open, but no explicit shortage; opportunities mainly in government research and banks."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Berlin think-tanks and EU institutions in Brussels seek analysts; English-language roles expanding with geopolitical tension."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Some roles in EU-policy consultancies, but not on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Think-tanks value security economists, yet Japanese language remains gatekeeper."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Government entities contract analysts for economic diversification but prefer bilingual Arabic speakers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "National AI Strategy 2.0",
        "reason": "Regional HQs and think-tanks in Singapore hire IPE analysts to track ASEAN trade and fintech regulation."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai think-tanks and sovereign wealth funds need geopolitical risk analysis for investment strategy."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London and Whitehall rely on IPE skills for trade, sanctions, and financial-services regulation."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "",
        "reason": "DC think-tanks and Wall Street rely on IPE analysts to interpret sanctions, trade policy and geopolitical risk; H-1B specialty occupation fits."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a8be57f9-19e7-4a5d-9ffc-a231795ad673": {
    "career": "Materials Chemist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Chemical and materials engineers are on list; chemists can enter via related STEM codes."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "STEM roles qualify under general STEM stream, but not singled out."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Germany’s push for green hydrogen, battery cells and advanced materials makes chemists highly sought."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "RPJPN 2025-2045",
        "reason": "Nickel battery supply chain expansion creates roles for cathode-materials chemists."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma-biotech cluster in Cork and Galway hires analytical and materials chemists under Critical Skills code ‘Chemical scientist.’"
      },
      "japan": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Highly Skilled Professional visa",
        "reason": "Japan’s strength in battery, semiconductor and robotics materials drives demand for PhD chemists."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan names specialty chemicals and semiconductor materials as core growth pillars—direct fit."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Chemists not explicitly listed but can qualify under ‘Other Engineering Professionals’ in energy sector."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Materials R&D for EVs, renewables and petro-chem diversification attract foreign PhD chemists to NEOM labs."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Manufacturing 2030",
        "reason": "Pharma, semiconductor and sustainability R&D parks actively recruit materials scientists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing plan funds composite-materials and semicon R&D; chemists welcome though scale smaller than KSA."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean-energy and aerospace materials sit in IS-8 priority; Global Talent visa suits PhD chemists."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act pours billions into semiconductor materials, quantum and battery R&D—core work for materials chemists."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Setting up fab plants needs dielectric and photoresist chemists; Talent visa available."
      }
    }
  },
  "5c3b2a98-8350-4199-88c3-7275df656a23": {
    "career": "Mental Health Advocate",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Community health professionals fit under social-worker occupation codes on CSOL."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Care-economy stream values community and mental-health workers, including advocacy coordinators."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Some demand in NGOs, but German-language requirement high."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Advocacy NGOs hire, yet not on Critical Skills list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Community workers category covers mental-health roles; advocacy adjacent."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Mental-health awareness campaigns growing, but roles scarce and prefer citizens."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Government pushes wellbeing, but advocacy positions small and often volunteer based."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "",
        "reason": "NHS and charities recruit mental-health community workers despite removal from shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Advocacy roles exist in nonprofits but not linked to federal skill shortages."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "8b6ab05c-3425-487c-812e-49ec2aec44ba": {
    "career": "Orthopedic Physiotherapist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Physio on Medium-Long-Term list; grants 4-year visas leading to PR."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Physiotherapists are priority occupation; streamlined PR pathway."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe shortage in rehab clinics; foreign PTs can get recognition with B2 German."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Physiotherapists on list, offering Critical Skills Permit."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Physiotherapists appear on Tier 1; fast-track to residency."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Private hospitals hire foreign PTs, but localisation increasing."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "MOH lists PTs as allied-health, but quota limits and high competition place it in Tier 3."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "We the UAE 2031",
        "reason": "Sports-medicine clinics in Dubai hire but no formal skill-shortage priority."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Physiotherapists were removed from shortage list in 2025; still recruit via general health code."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "PT demand is high but no special immigration concessions; foreign licensure process lengthy (NPTE, state boards)."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b1c62399-8d08-4017-a972-b00c858e6990": {
    "career": "Stagecraft Instructor",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Migration Strategy 2023",
        "reason": "Higher-education lecturers fall under skilled-worker visas though performing-arts not priority."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Public colleges recruit technical-arts instructors; teaching positions earn education points."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Arts-university lecturers qualify as academic specialists on EU Blue Card."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "New Nusantara arts hubs may recruit foreign stagecraft teachers."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Third-level lecturers are recognised on work-permit list despite arts not being priority."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Specialist humanities instructor category covers theatre faculty."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "MADANI Economy",
        "reason": "Film & performing-arts schools emerging but not in priority list."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Migrant Category",
        "reason": "Limited but possible demand at drama schools; points for master’s+ lecturers."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Vision 2030",
        "reason": "Growing entertainment academies for NEOM/Red Sea projects need backstage training staff."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Singapore Economy 2030",
        "reason": "LaSalle & SOTA regularly hire international theatre-tech lecturers under Education Passes."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "We the UAE 2031",
        "reason": "Dubai creative-media academies hire stagecraft educators for expanding events sector."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "67",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Universities & conservatoires sponsor Global Talent visas in creative disciplines."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "CHIPS and Science Act",
        "reason": "Universities enjoy stable H-1B demand for arts faculty even if not named in industrial policy."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Cultural-tourism push creates some demand for technical theatre educators."
      }
    }
  },
  "6d5c492e-6d33-4113-9337-91b2b96b7cd7": {
    "career": "Theatre Performer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Entertainment visas available though not priority."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Cultural Exchange work permits support touring artists."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "State theatres hire foreign performers under artist visas."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Bali & Jakarta entertainment demand foreign circus-style talent."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on list, but Artist visa exists for cultural contributions."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Highly Skilled Professional visa",
        "reason": "Entertainer visa category, limited quotas."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "NIMP 2030",
        "reason": "Growing events market but not policy target."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Limited but film-driven arts scene offers some roles."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "Massive investment in live entertainment requires skilled performers for NEOM and Riyadh Season."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Economy 2030",
        "reason": "Esplanade and Marina Bay Sands import headline acts under Entertainment Work Pass."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s creative-media hubs contract international stage talent."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Global Talent visa covers performing-arts leaders in West End and touring companies."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "CHIPS and Science Act",
        "reason": "Not policy-linked but O-1 visas allow exceptional performers on Broadway."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Tourism shows hire but no policy support."
      }
    }
  },
  "643966c4-f227-4180-a0aa-99e300df3173": {
    "career": "Theology Professor",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Higher-education lecturers eligible for Temporary Skill Shortage visa."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Doctorate-level lecturers meet education points despite subject."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Historic demand at church-funded universities; Blue Card straightforward for professors."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Islamic higher-ed sometimes imports foreign PhDs for accreditation."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Third-level lecturers on Critical Skills even in humanities."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Highly Skilled Professional visa",
        "reason": "Private Christian universities invite foreign faculty."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Islamic universities employ PhDs, but not priority."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Migrant Category",
        "reason": "Limited but theological colleges can sponsor."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Islamic studies departments recruit foreign scholars for universities."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Singapore Economy 2030",
        "reason": "Autonomous universities recruit diverse religion scholars through Education Pass."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Branch campuses hire humanities faculty across faith traditions."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "71",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Universities can use Skilled Worker visa for theology lecturers."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "CHIPS and Science Act",
        "reason": "Universities sponsor H-1B for humanities faculty irrespective of act focus."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Religious education is restricted; only limited academic roles."
      }
    }
  },
  "2f148c6e-620b-4bad-9510-6427e002164a": {
    "career": "Area Studies Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Strategic policy institutes hire Asia analysts under skilled visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Government think-tanks seek regional experts; PhDs score high points."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Berlin research foundations regularly sponsor humanities researchers."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Foreign academics possible under research visas but not priority."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "University lecturer category on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Asia-Pacific security institutes value foreign area specialists."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "MADANI Economy",
        "reason": "Limited roles in regional think tanks."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Skilled Migrant Category",
        "reason": "Small but some demand in foreign-policy ministry and universities."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Think tanks studying Asia trade ties recruit foreign experts."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Singapore Economy 2030",
        "reason": "ISEAS-Yusof Ishak Institute hires South-Asia scholars under Research Pass."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Abu Dhabi’s policy centers look for South-Asia expertise."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "71",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "SOAS and policy institutes sponsor Global Talent visas."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "CHIPS and Science Act",
        "reason": "Universities and think-tanks sponsor researchers despite tech-focused act."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "State institutes rarely hire foreign social scientists."
      }
    }
  },
  "c622512f-cbb5-46ab-bac6-b467b94deb69": {
    "career": "Cell & Molecular Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Medical researchers on CSOL, especially for cancer and genomics."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Biotech and life-sciences flagged for streamlined work permits."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Max Planck and BioNTech rely on international molecular scientists."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Biopharma research pushed for health resilience; foreign experts welcomed."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma and med-tech clusters in Cork and Dublin actively recruit researchers."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Highly Skilled Professional visa",
        "reason": "RIKEN and AIST labs designate molecular biology as priority."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "NIMP 2030",
        "reason": "Pharma and medical device R&D labelled key growth area."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Some demand in bio-tech startups but small scale."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "KAUST and NEOM’s genomics programs recruit global researchers."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Singapore Economy 2030",
        "reason": "Biomedicine is flagship sector; A*STAR grants fast EP for molecular scientists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Operation 300bn",
        "reason": "Dubai Science Park and Abu Dhabi’s med-tech hubs need cell biologists."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life sciences listed as core growth sector with fast Global Talent visas."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act pours billions into biotech and lab infrastructure, fast-tracking NIH and startup hiring."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Biotech sub-programs seek foreign talent for vaccine and agri-bio research."
      }
    }
  },
  "db6f603c-1deb-41b9-8167-c492c29e9cda": {
    "career": "Digital Business Strategist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Migration Strategy 2023",
        "reason": "Digital adoption grants create consulting work but role not explicitly listed."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Priority on tech workers spills over into demand for planners who shape digital go-to-market plans."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Mittelstand modernisation drives need, yet visas focus on technical specialists not strategists."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "47",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Digital-economy growth creates demand, but foreign hiring restricted outside technical roles."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Tech multinationals use strategists, yet role absent from critical list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Highly Skilled Professional visa",
        "reason": "Corporates digitising after COVID need planners; however visa points higher for engineers."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "NIMP2030 digitalisation goals open space, but hiring favours technical programme managers."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Digital-skills shortages recognised, but strategist is considered secondary to engineers."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "National digital-economy pillar funds consultancies to guide e-commerce, gov-tech and tourism projects."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Economy 2030",
        "reason": "Digital economy hub needs strategists, but visa incentives mainly target deep-tech specialists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "We the UAE 2031",
        "reason": "Ambition to double digital economy by 2031 creates strong pull for strategy talent."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital & AI clusters seek business translators, but visa list prioritises technologists not managers."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Broadband rollout and digital-services funding push firms to hire strategists who can monetise new online channels."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "National Master Plan 2021-2030",
        "reason": "E-commerce boom needs strategy talent, yet immigration focus stays on engineers."
      }
    }
  },
  "7f79c442-c445-4d38-937d-a8c540b46daa": {
    "career": "Interdisciplinary Educator",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Migration Strategy 2023",
        "reason": "Schools and unis push Asia-capability; humanities teachers on shortage lists."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Teacher shortages, especially for multicultural curricula and Asian language programmes."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "International schools and rising university English-medium programmes seek global-history instructors."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Some demand in Trinity/UCD Asia institutes; immigration routes exist but not prioritised."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "49",
        "policy": "Highly Skilled Professional visa",
        "reason": "International universities add global-studies faculty; competition high."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "",
        "reason": "Branch campuses need lecturers, but hiring leans toward sciences."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Secondary-STEM dominates list, but humanities educators still qualify under general skilled migrant route."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Vision 2030",
        "reason": "Private universities expanding liberal-arts departments, yet visas prioritise STEM faculty."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "NUS, NTU seek Asia scholars, yet passes prioritise tech and finance roles."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Growth of branch campuses creates posts, but preference for Western PhDs and English native speakers."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Humanities no longer on shortage list, but Russell Group still recruits Asian-studies lecturers."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Universities hire area-studies lecturers; community colleges add Asia-centric global-studies courses."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "cacc8d1e-022c-49b8-80d9-ffac79ed5705": {
    "career": "Leadership Coach",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Migration Strategy 2023",
        "reason": "Executives seek coaches during post-pandemic reorganisation, but visa focus is technical."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "",
        "reason": "Growing but smaller corporate market; role not on immigration priority lists."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Family-owned firms use coaching selectively; language barrier limits foreign entrants."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Rapid managerial upskilling needed, yet expat quotas tight."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Multinationals purchase coaching, but scale modest."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Highly Skilled Professional visa",
        "reason": "Companies shifting from seniority culture hire bilingual coaches, yet Japanese language essential."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "47",
        "policy": "MADANI Economy",
        "reason": "Leadership training part of Industry4.0 plan, but budgets limited."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Skilled Migrant Category",
        "reason": "Niche demand, not officially prioritised."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Vision 2030",
        "reason": "Local managers in megaprojects receive leadership upskilling; global coaches contracted frequently."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Financial hub buys coaching services, but passes now favour deep-tech talent."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "UAE Centennial 2071",
        "reason": "Regional HQs, fintechs and family conglomerates invest heavily in executive coaching."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City firms fund coaching as part of talent-retention; no formal visa priority though."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "",
        "reason": "Huge executive-education market; firms spend billions on coaching as part of digital change efforts."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "2bfc59b8-514d-42a8-97bc-c1172e204059": {
    "career": "Narrative Developer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "53",
        "policy": "Migration Strategy 2023",
        "reason": "Government grants for indie games boost demand, but few visas reserved for writers."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Montreal/Vancouver studios hire storytellers alongside programmers."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Growing games sector yet German-language skills expected."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Asta Cita",
        "reason": "Nascent gaming sector; foreign narrative hires rare."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "49",
        "policy": "",
        "reason": "Some AAA support studios in Dublin/Galway; not on critical list."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Highly Skilled Professional visa",
        "reason": "Anime/game giants need bilingual storytellers to globalise IP."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "NIMP 2030",
        "reason": "Government wants local IP; funding focuses on animation but writer visas limited."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Migrant Category",
        "reason": "Weta and indies offer roles, but small volume."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Massive spending on gaming & entertainment cities demands IP writers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "National AI Strategy 2.0",
        "reason": "Regional game publishers in one-north, but visas aimed at tech, not writers."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "We the UAE 2031",
        "reason": "Dubai Media City attracts transmedia storytellers for region-wide projects."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 lists creative industries; tax relief keeps games studios hiring writers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "",
        "reason": "World’s largest game & streaming industry; visas like O-1 support creative talent."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Mobile-game boom but companies mostly hire local talent."
      }
    }
  },
  "814868d6-1190-47d4-b9f5-7732bee4f39a": {
    "career": "Pediatric OT",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "OTs on CSOL; fast-track visas and state sponsorships available."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Allied-health shortages; OTs now invited in healthcare-targeted draws."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe paediatric therapist shortage, especially in rural clinics."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Paediatric rehab demand exists but salary and licensing deter expats."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Paediatric OTs on critical list with streamlined permits."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "59",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Ageing society needs therapists; licensing process long for foreigners."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Private hospitals hire some expats; local graduates filling most roles."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Green List Tier-1 role with immediate residency path."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "New paediatric hospitals in NEOM and Riyadh recruit foreign OTs."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Children’s hospitals hire OTs, yet quota space limited."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Dubai & Abu Dhabi children’s centres import licensed therapists."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "NHS faces OT shortages but immigration list trimmed; trusts still sponsor."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Child-therapy waitlists long; OTs qualify for H-1B Specialty Occupation in hospitals."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Nascent OT profession; few regulated positions for foreigners."
      }
    }
  },
  "e72ce0b5-0d20-406b-a576-75ae4346ee6c": {
    "career": "Professional Dancer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Entertainment visas exist, but Migration Strategy focuses on STEM and health, not performing arts."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Arts work permits possible yet creative roles are outside Express Entry priority lists."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Cultural visa options, though Skilled Immigration Act targets technical jobs, not dancers."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Special-purpose visas for performers; not on Green List, so limited pathways."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "New entertainment districts need live shows; international performers recruited for events."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Tourism mega-projects hire dancers for hotels, theme parks, and festivals."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry seniors highlighted; West End theatres regularly sponsor skilled dancers."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Huge commercial dance market (Broadway, film, TV) drives demand, but no federal immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "543fe6e5-3923-473f-9bca-e9836c6d160f": {
    "career": "Sports Journalist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Vision 2030",
        "reason": "PIF-backed sports leagues create demand for English sports coverage."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Regional sports hubs like ESPN Asia hire, but journalism unlisted in AI strategy."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi host major events and regional sports networks."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry seniors include media; Premier League fuels sports news hiring."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Massive sports media market, but no federal talent-shortage incentives."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "d1c8b771-9116-473f-9211-05ca35ddb767": {
    "career": "Wildlife Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Biodiversity conservation flagged under environmental scientists category."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Conservation officers exist but Express Entry targets other sectors first."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Some demand in forestry, yet Skilled Immigration Act prioritises engineers."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "RPJPN 2025-2045",
        "reason": "Eco-tourism and rainforest protection receive some funding, but not formal shortage occupation."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Department of Conservation regularly recruits biodiversity managers."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "National Parks Service hires, yet role not on federal shortage lists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "f99185fd-883d-47f8-a94d-ad9c9a160cb1": {
    "career": "Community Health Worker",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Welfare and community health support listed due to rural shortages."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Health-care support occupations fast-tracked under new categories."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Ageing population drives demand for preventive health outreach staff."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Health Service Executive recruits CHWs, though not on Critical Skills list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Māori and Pacific outreach programmes rely on skilled CHWs."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Preventive care initiatives create moderate demand, but Saudization applies."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "HealthySG initiative values outreach, but role filled mainly by locals."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "Public health campaigns need multicultural outreach staff."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "CHWs recognised in public health grants, but not on federal skill shortage lists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4195d444-4230-4115-8a35-93ca9dfcdd84": {
    "career": "Creative Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Creative roles not on Core Skills list; sponsorship possible but rare."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Canada’s talent strategy targets tech more than creative consulting."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Asta Cita",
        "reason": "Government promotes digital creative economy, but no formal shortage list."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points possible for senior creatives, though not a named priority."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Giga-projects seek brand and experience consultants for tourism and entertainment."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Creative roles exist in agencies, yet outside National AI Strategy 2.0 priorities."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s creative economy strategy hires international creative leads."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry seniors explicitly encouraged; London agencies sponsor visas."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Strong market demand, but outside federal priority programs."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "c540d04a-5b06-4667-b775-b0250ed1c59f": {
    "career": "Critical Social Worker",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Regional visas list community welfare workers, but not on Core Skills Occupation List."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Healthcare and care-economy categories explicitly invite licensed social and community service workers."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Shortages in elder-care create demand for social workers, yet role is not named priority."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on Critical Skills list but public health services recruit internationally due to shortages."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Social workers formerly on Green List; now assessable through overall points, still regional shortages."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Green Plan 2030",
        "reason": "Non-profit sector recruits foreign MSWs, but no policy priority."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "No federal immigration priority, but continual nationwide shortages in child-protection and mental-health social work keep openings available."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "22",
        "policy": "",
        "reason": ""
      }
    }
  },
  "534b0554-6481-48ae-8c41-46f65a57d248": {
    "career": "Film Producer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Migration Strategy 2023",
        "reason": "Screen sector incentives exist, but producers apply through general skilled visas."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Tax credits make Vancouver/Toronto busy, yet no immigration fast-track for producers."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Screen Ireland relies mostly on EU citizens; producers not on critical list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Massive investment in entertainment cities and local content needs international producers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Singapore Economy 2030",
        "reason": "Media Development Authority incentives exist, but role not top-tier priority."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "Dubai Studio City offers incentives but no dedicated visa path."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry leaders explicitly prioritised; Global Talent visa fast-tracks senior producers."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "79",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct film clause, but O-1 visas for extraordinary creatives keep Hollywood open."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "3982221e-dceb-4f14-85b5-af45e73a3ad8": {
    "career": "Food Innovation Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Ag-tech roles earn points but absent from Core Skills list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Agri-food technologists score well on points, though not priority category."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Food scientists welcome under general STEM shortage but not named."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Food security specialists are explicit priority in nickel-rich, climate-vulnerable archipelago."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Food scientists listed historically but downgraded; points route still viable."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "MADANI Economy",
        "reason": "Halal food innovation a niche, but immigration favours manufacturing engineers."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Food technologists and agri-scientists explicitly on Green List; fast-track residency."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Food security projects need consultants, but hiring skews toward large multinationals."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Green Plan 2030",
        "reason": "30×30 initiative seeks consultants for urban farming and novel foods."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Vertical-farming push creates openings, yet role not top priority."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Sustainable agri-tech grants create niche demand, but no explicit visa track."
      },
      "vietnam": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "National Master Plan 2021-2030",
        "reason": "Government backs agri-tech and alt-protein to boost exports; foreign experts welcomed."
      }
    }
  },
  "9d923a68-331a-483a-91cf-0859f0162d5b": {
    "career": "Gender and International Relations Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Migration Strategy 2023",
        "reason": "Global Talent visa covers academics, yet field not on Core Skills list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities use regular work permits; not in category-based selection."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Think tanks can sponsor visas, but role lacks shortage designation."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "RPJPN 2025-2045",
        "reason": "International NGOs run gender programmes and sponsor visas selectively."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Role outside critical skills; universities can still sponsor individually."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Small policy market; general points route only."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National AI Strategy 2.0",
        "reason": "Policy institutes value regional gender expertise, but not priority sector."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai think tanks hire experts, but immigration preference for STEM."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Global Talent visa covers social scientists with strong publications."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "CHIPS and Science Act",
        "reason": "No direct fit, but academia and think tanks hire under H-1B cap exempt visas."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "378ac3f4-b584-4d78-8869-0225d5fb9036": {
    "career": "Graphics Designer",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Entertainment and tourism projects hire designers, but Saudization caps visas."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "DesignSingapore Council supports talent, but EP quotas tightened."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Marketing agencies constantly hire, yet not strategic priority."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Only senior creative directors prioritised; junior designers need general skilled visa."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Still demand in marketing, but no immigration preference; market saturated."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "bd5c59d3-b817-4cc5-bec0-723387d5a46d": {
    "career": "Math Coach",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Secondary mathematics teachers are on CSOL; fast-track visas and state sponsorship available."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Provinces list secondary-STEM teachers as shortage; direct PR pathways for qualified educators with French or rural commitment."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Acute shortage of maths teachers in Gymnasium; Blue Card eligibility with accredited degree."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Green List (Tier 2)",
        "reason": "Secondary STEM teachers eligible for Work to Residence after two years, but cap numbers are small."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Maths teachers hired, but role removed from official shortage list in 2025; visa sponsorship possible but competitive."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Demand for STEM teachers exists, but no federal immigration priority; H-1B options limited for K-12 roles."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "1bfdfdfb-ca7b-4d8d-9a20-696dc2555d65": {
    "career": "Neurobiology Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Life-science researchers eligible under general research scientist ANZSCO, but caps are small."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Federal labs and Quebec pharma recruit neuroscientists; no dedicated priority but Global Talent Stream available."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Max Planck and university hospitals hire neuroscientists; EU Blue Card accessible with PhD."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Biopharma research zones in Bandung and Jakarta need specialists, yet red tape remains."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Neuro-pharma and med-tech cluster around Dublin/Galway; Critical Skills permit for biomedical scientists."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "RIKEN and universities offer funded posts; HSP points favour PhDs and high salaries."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan lists pharma R&D; BioNexus incentives attract brain-disease researchers."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Limited funding; few dedicated neuroscience positions, mostly academic tenure-track."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "New biotech parks under Vision 2030 seek researchers, but opportunities still emerging."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Singapore Economy 2030",
        "reason": "Agency for Science, Technology and Research (A*STAR) funds neuro-degenerative research; COMPASS points favour PhD talent."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Dubai Science Park and Khalifa University sponsor brain-research talent for precision-medicine programs."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences a strategic pillar; Global Talent Visa expedites top neuroscientists to Oxford, UCL and pharma hubs."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Major NIH and BRAIN Initiative funding; O-1/H-1B for researchers fast-tracked at universities and biotech startups."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National Master Plan 2021-2030",
        "reason": "Government funds neuro-pharma trials, but infrastructure still maturing."
      }
    }
  },
  "e9e4fafb-3065-4e56-9afc-46f87a1e719c": {
    "career": "Renewables Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Solar-farm and grid-battery boom; state nominations fast for renewables engineers."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Green-tech hiring growing but not singled out; points awarded for STEM experience."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Energiewende drives demand for wind and PV specialists; easy Blue Card route."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "RPJPN 2025-2045",
        "reason": "Geothermal and solar expansion; need specialists for Nusantara smart-city grid."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Offshore wind planners on the list; demand rising but grid constraints slow hiring."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "Offshore wind and hydrogen hubs push for foreign expertise under HSP."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "MADANI Economy",
        "reason": "Solar manufacturing and floating PV get incentives; talent welcomed but salaries lower."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Onshore/offshore wind and geothermal projects qualify for Work to Residence."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "NEOM and Red Sea giga-projects need solar-hydrogen experts; lucrative contracts."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Singapore Green Plan 2030",
        "reason": "Regional renewable trading hub; roles skew to project finance and carbon, not pure engineering."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Operation 300bn",
        "reason": "Masdar expansion into global renewables; Golden Visa for specialised engineers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Offshore wind, CCUS and hydrogen form core pillars; shortage-list visas fast."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Massive tax credits for solar, wind, hydrogen; firms scramble for engineers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "National Master Plan 2021-2030",
        "reason": "Gigawatt-scale offshore wind planned; foreign engineers permitted via work permits."
      }
    }
  },
  "27c5aa14-4847-4a2b-a63f-ad522d44b0dd": {
    "career": "Software Engineering Leader",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Migration Strategy 2023",
        "reason": "Software devs on CSOL; leadership roles need employer nomination but plentiful."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Category for STEM/tech draws senior devs; Toronto-Waterloo corridor booming."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Berlin and Munich tech scenes leverage EU Blue Card for engineering managers."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "E-commerce unicorns hire tech leads, yet work-permit bureaucracy discourages foreigners."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "European HQs of FAANG in Dublin constantly hire engineering managers; Critical Skills permit."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "Points system rewards seniority; startups in Tokyo need bilingual leads."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "MADANI Economy",
        "reason": "Digital-hub ambitions but leadership roles often filled internally; pay lower."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Migrant Category",
        "reason": "Software managers eligible, but small ecosystem limits openings."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Fintech and giga-projects hire tech leads, yet relocation hurdles and local quotas exist."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "National AI Strategy 2.0",
        "reason": "Tech leads in AI and fintech qualify for COMPASS bonus points and Tech.Pass."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "UAE Centennial 2071",
        "reason": "Fintech and AI startups in DIFC crave seasoned tech leads; Golden Visa available."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital sector priority; Scale-Up visa offers fast track for high-growth firms."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Funding for advanced computing and AI widens demand for senior software leadership."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Focus on embedded/software for chips, not general leadership; opportunities exist but fewer visas."
      }
    }
  },
  "313189e4-2eee-4f8e-8272-95e34ec54120": {
    "career": "Stage Director",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Temporary Entertainment visa available case-by-case; not on CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Culture funding exists yet performing-arts roles not in Express Entry priority categories."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Entertainment sector exploding with new theatres; foreign creative leaders courted with tax-free packages."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Arts House and Esplanade attract international directors, but no immigration priority."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi push live entertainment; Golden Visa for notable directors."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry seniors prioritised; Global Talent visa fast-tracks theatre directors with portfolio."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Strong market (Broadway) but no immigration priority; O-1 visa possible for award-winning directors only."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "13217574-018b-44ab-8e90-11d39852d20c": {
    "career": "Sustainable Design Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL names construction PMs and engineers for low-carbon housing; sustainability consultants qualify under engineering–environmental streams."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Climate targets and provincial building codes drive demand for LEED-literate architects; candidates score extra CRS points for STEM/green skills."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Energiewende retrofit program needs specialists who can slash building emissions and manage EU taxonomy compliance."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital Nusantara aims for net-zero, creating pockets of opportunity for foreign green-building consultants."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Civil/environmental engineers are listed; sustainability consultants can leverage overlapping skill codes."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-city and zero-carbon projects need architects with green know-how, but language and licensing create barriers."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Green factory upgrades and EV supply-chain parks open niche demand for eco-design advisers."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Post-quake rebuild and rising flood risk push demand for climate-resilient, passive-house expertise."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Vision 2030",
        "reason": "Megaprojects like NEOM and the Red Sea mandate net-zero buildings and regenerative tourism, importing global green-design talent."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Singapore Green Plan 2030",
        "reason": "Mandatory Green Mark standards mean constant retrofit cycles needing energy-modelling and embodied-carbon specialists."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi require sustainable consultants for massive mixed-use developments pursuing Estidama/Pearl ratings."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean-energy pillar values decarbonised construction, but no specific visa concessions; roles compete with local talent."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Generous IRA tax credits for energy-efficient retrofits and new net-zero buildings make green-design experts a top shortage occupation."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "National Master Plan 2021-2030",
        "reason": "Rapid urbanisation seeks sustainable construction guidance, yet immigration channels are still generic."
      }
    }
  },
  "1c043234-c202-41c4-a1a4-c037bb2f70ea": {
    "career": "Technical Artist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Digital-games roles qualify under ‘multimedia specialists’, yet quotas are modest."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Canada courts digital-media workers; Montreal and Vancouver offer fast visas and tax credits for game studios."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Berlin and Hamburg indie scenes hire, but no specific shortage listing."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Dublin’s growing game sector hires under ‘software developers’, but numbers are small."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Highly Skilled Professional visa",
        "reason": "Tokyo’s AAA publishers crave bilingual tech artists for Unreal and proprietary engines."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Skilled Migrant Category",
        "reason": "Weta Digital and small studios recruit, though points threshold is high."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Economy 2030",
        "reason": "Ubisoft and Riot base regional teams here; EP visas possible, but role not in Tier-1 list."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industries pillar names gaming; Skilled Worker visas have a reduced salary floor for senior technical artists."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Policy irrelevant but the world’s largest game studios cluster in US tech hubs; visas via H-1B or O-1."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a6843aa4-e5ca-45c1-9158-9d593d1bfc1b": {
    "career": "Urban Planning Advisor",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "State nomination lists include urban and regional planners to support fast-growing suburbs."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Rapid immigration and housing shortage push cities to import planners with GIS and zoning experience."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Smart-city pilots need talent, but language requirements slow foreign uptake."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital Nusantara requires global expertise in sustainable city-building, transport and land-readjustment."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Ireland’s housing crisis creates consultant demand, yet not formally critical."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-city zones need advisors, but Japanese language and local law knowledge are essential."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Kuala Lumpur greater metro expansion opens pockets for transit-oriented development advisors."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Only specific civil roles listed; planners must compete through general skilled-migrant category."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "NEOM, Qiddiya and AlUla seek global planners to craft entirely new cities and tourism corridors."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Green Plan 2030",
        "reason": "Urban Redevelopment Authority hires foreign experts for carbon-neutral master planning."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "We the UAE 2031",
        "reason": "Dubai 2040 plan and Abu Dhabi smart-city projects recruit foreign strategic planners."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Demand exists for levelling-up projects, but planning roles are not on shortage list post-2025."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Record federal spend on transit and climate-resilient housing boosts municipal demand for planners."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "National Master Plan 2021-2030",
        "reason": "Fast urbanisation and new industrial parks drive modest demand for foreign planning consultants."
      }
    }
  },
  "28a6bafa-1bef-4d2e-b523-ff51ff6aa54f": {
    "career": "Archaeological Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Aboriginal heritage surveys need archaeologists for mining projects; roles exist under ‘life scientists’."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Parks Canada and universities hire niche heritage researchers, though not prioritised."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Well-funded universities and museums pursue bioarchaeology and radiocarbon dating experts; English-speakers accepted."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Hominid sites on Java attract occasional foreign collaborative digs."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Commercial archaeology tied to road projects exists, but immigration priority is low."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "AlUla archaeological park invests heavily in scientific digs, welcoming foreign specialists."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "We the UAE 2031",
        "reason": "Heritage focus small compared with tourism, limited lab-based archaeology."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "UKRI funds cutting-edge archaeogenetics; visas for research scientists streamlined through Global Talent."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "CHIPS and Science Act",
        "reason": "Act increases NSF funding for heritage science, isotopic dating and ancient DNA labs."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b8007649-4915-43fd-b0db-c0a773c3c292": {
    "career": "Certified Elementary Teacher",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Primary educators listed; states offer direct nomination and expedited visas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Primary teachers and French/English bilinguals get targeted invitations to address severe classroom shortages."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Länder lack Grundschule teachers, especially STEM and English; foreign licences recognised with bridging courses."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Irish-language primary teachers in Gaeltacht areas remain in demand."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "ELT assistants hired, but certified elementary teachers not on visa priority lists."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Primary teachers on Tier-1; pathway to residence after two years."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Economy 2030",
        "reason": "MOE rarely sponsors foreign primary teachers; international schools hire under EP quota."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Private international schools recruit certified teachers, but not part of national shortage list."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct visa, but regional shortages allow J-1 or H-1B for specialty bilingual teachers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      }
    }
  },
  "7a549fa2-06ab-4d78-afb9-594c7396d776": {
    "career": "Chemistry Lab Technician",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Role appears on state lists for pharmaceutical and mining laboratories, but not national priority."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Pharma and food-processing sectors seek lab techs classed under skilled trades."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Chemical and pharmaceutical clusters along the Rhine require qualified lab technicians."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel processing and battery plants will add limited lab roles."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "67",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Large biopharma exports create steady demand for lab support staff."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Highly Skilled Professional visa",
        "reason": "Materials and pharma R&D parks need foreign lab talent but prefer senior chemists."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Specialty-chemical and semiconductor fabs hire QC technicians."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Food-safety and dairy labs recruit technicians, yet numbers are modest."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Petrochemical diversification creates some need for analytical labs."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Manufacturing 2030",
        "reason": "Biomed manufacturing hub needs lab QC but prefers degree-level analysts."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Operation 300bn",
        "reason": "Growing pharma manufacturing parks list QC labs as supporting roles."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences pillar funds R&D labs that hire technicians."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Battery, clean-energy and biotech plants need QC technicians for chemical analysis."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Electronics packaging/testing labs require basic chemical analysis support."
      }
    }
  },
  "5c0a4d3d-d1c9-4196-a68d-33a1d93450f7": {
    "career": "Computational Finance Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Growing fintech scene needs specialists yet not on core skills list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Fintech hubs in Toronto and Montreal welcome quants but program targets broader IT first."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Frankfurt banks hire quants but favour EU talent; limited official priority."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Jakarta’s digital banks experiment with quants, yet still niche."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "IFSC Dublin lists financial maths and risk modelling as shortage skills."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Highly Skilled Professional visa",
        "reason": "Tokyo banks recruit a few HSP quants but language barrier limits numbers."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "MADANI Economy",
        "reason": "Islamic finance innovation needs stochastic-model developers but numbers are small."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Emerging Riyadh fintech hub seeks risk-model experts but in low volumes."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "National AI Strategy 2.0",
        "reason": "Global fintech capital offers tailored passes for AI-driven quantitative finance."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "UAE Centennial 2071",
        "reason": "DIFC and ADGM place quants on fast-track fintech visas."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London remains global centre for quantitative finance and algorithmic trading."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "CHIPS and Science Act",
        "reason": "Quant talent fuels high-frequency trading and risk models for tech-heavy markets."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "7a0757c7-d138-46f6-844b-ac35a01221cd": {
    "career": "COO",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Migration Strategy 2023",
        "reason": "COOs sponsored only when industry experience is niche."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Management talent welcomed but not a named shortage."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Medium-sized Mittelstand firms recruit bilingual ops leaders sparingly."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Select EV and mining giants hire expat operations heads."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "C-suite visas possible but evaluated case-by-case."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Language/culture barriers keep demand limited to global firms."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "MADANI Economy",
        "reason": "Manufacturing scale-ups may import operational leaders for Industry 4.0 transitions."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "41",
        "policy": "Skilled Migrant Category",
        "reason": "Small economy limits slots for foreign C-suite roles."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Vision 2030",
        "reason": "Mega-projects hire expat COOs but government pushes localisation."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Economy 2030",
        "reason": "Global HQs often base COOs here, but no specific shortage list."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "53",
        "policy": "We the UAE 2031",
        "reason": "Free-zones allow multinationals to import senior management."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Scale-ups and PE-backed firms sponsor COOs when sector knowledge is scarce."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Complex infrastructure programmes need seasoned operations leadership."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "46c974eb-1a87-4f99-8e12-fd6319d03034": {
    "career": "Data Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Tech visas prioritise software and data engineering skillsets."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Category-based IT invitations heavily feature big-data roles."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Industry 4.0 roll-outs need data pipeline architects."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "RPJPN 2025-2045",
        "reason": "Digital-bank and EV supply-chain data projects emerging."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "EU big-data hubs in Dublin list data engineers explicitly."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Highly Skilled Professional visa",
        "reason": "AI and robotics firms sponsor data pipeline experts."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industry 4.0 focuses on manufacturing data platforms."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Growing but small tech market; role listed under generic software engineer."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Vision 2030",
        "reason": "Smart-city mega-projects produce demand but prefer contract consultancies."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "National AI Strategy 2.0",
        "reason": "Government targets 20,000 AI & data roles; salary thresholds eased for tech visas."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "UAE Centennial 2071",
        "reason": "Fintech and gov AI programmes aggressively hire data engineers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Priority shortage for digital & AI specialists; fast visa route."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Frontier AI and semiconductor R&D rely on massive data pipelines."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "National Master Plan 2021-2030",
        "reason": "E-commerce and fintech scale-ups demand but at smaller scale."
      }
    }
  },
  "bb6b02c1-a4e2-4277-bf05-03ab206e828c": {
    "career": "Digital Media Designer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Graphic/digital designers only on some state lists."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Creative roles eligible but ranked below core tech."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Designers can qualify but are not shortage-listed."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "RPJPN 2025-2045",
        "reason": "E-commerce growth creates some UI/UX demand but no formal prioritisation."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on list; only exceptional designers sponsored."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Gaming giants recruit UI/UX talent but expect Japanese proficiency."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "MADANI Economy",
        "reason": "Animation and game outsourcing firms hire designers but policy focus is elsewhere."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Entertainment and esports investments fuel demand for digital creatives."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Economy 2030",
        "reason": "Tech firms hire designers yet quotas favour deep-tech roles first."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s media-city free zones fast-track senior digital designers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industries pillar backs gaming, film and design; Global Talent visa covers UI/UX."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "CHIPS and Science Act",
        "reason": "Silicon Valley product teams always need UI/UX talent, though not policy-driven priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a796f82d-baa4-4361-946a-e4fbd28f253c": {
    "career": "Financial Planner",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "The Core Skills list stresses engineers and nurses, not finance, so visas are possible but competitive."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Financial planners are not on Express Entry shortage lists, but French-speaking CFPs can gain extra points."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "While not on the list, Dublin’s funds industry sponsors experienced planners for EU-wide advisory roles."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "NIMP 2030 focuses on industrial tech; wealth-management roles obtain permits but lack priority points."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Riyadh is positioning itself as a regional wealth-management hub, creating demand for credentialed planners."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Green Plan 2030",
        "reason": "MAS grants Employment Passes for sustainable-finance planners serving regional clients."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "DIFC/ADGM aggressively license expatriate advisers for a fast-growing HNW client base."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London includes wealth & sustainable finance under IS-8; Skilled-Worker visa sponsors actively recruit CFP/CFA talent."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "",
        "reason": "Personal-finance roles are not singled out in recent U.S. industrial legislation, though the mature wealth-management market still attracts H-1B hires."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "c0ac5de2-061e-4daf-ab68-5a9ca556e15b": {
    "career": "Forensic Biologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "State police labs sponsor some roles but they are not on the national Core Skills list."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Category-based immigration values biotech researchers; RCMP labs hire foreign specialists."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Biotech and lab scientists qualify under STEM shortage provisions."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Biomedical scientists, including forensic biologists, are on the Critical Skills list for fast-track permits."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points favour PhD-level biotech researchers; police labs seldom recruit foreigners."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "NIMP 2030 favours pharma manufacturing over forensic science."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Green List omits forensic science, yet ESR occasionally recruits offshore talent."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Growing forensic capability for mega-projects security, but localisation policies limit visas."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National AI Strategy 2.0",
        "reason": "Home Team Science & Tech Agency hires forensic genomics experts under STEM visa channels."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai Police crime labs bring in expatriate DNA analysts for capacity building."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Life-sciences R&D and privatised forensics firms actively sponsor scientists."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Federal funding boosts bio-forensics R&D and crime-lab modernisation, raising demand for DNA experts."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "7010e9a4-597a-437a-952a-cf3d20128b0c": {
    "career": "Guest Experience Strategist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Major resorts sponsor managers, though role is absent from CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Hospitality managers can qualify via Provincial Nominee Programs, but not on national shortage lists."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Bali and Nusantara resorts look overseas for boutique-hotel experience leads."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "SSW allows hotel staff, but strategist roles demand high Japanese fluency."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "",
        "reason": "Tourism Recovery Plan funds luxury projects that import limited senior talent."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Hospitality managers receive points under Skilled Migrant Category but rank behind nurses and engineers."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Mega-projects (NEOM, Red Sea) need experts who design world-class guest journeys."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Tourism is important but not in Tier-1 shortage; EP approvals hinge on seniority."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi aim to lead global luxury tourism, aggressively hiring CX strategists."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Tourism is mature but not immigration-priority; H-2Bs exist yet limited."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "2d4ed92f-af1d-404e-b289-37fe9750fb9d": {
    "career": "International Program Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "",
        "reason": "Employer-sponsored visas possible; category lacks CSOL priority."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Management roles earn CRS points but compete with tech and healthcare applicants."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "General managers can qualify via points but face language hurdles."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Multinationals in Dublin hire PMs, yet Critical Skills list prefers tech experts."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Language and cultural fit limit uptake, but HSP points favour advanced degrees."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "49",
        "policy": "",
        "reason": "Skilled Migrant Category awards points for PM roles but quotas are tight."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Megaprojects need bilingual program managers to coordinate international vendors."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "59",
        "policy": "",
        "reason": "Employment Pass obtainable, but COMPASS points higher for tech roles."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Operation 300bn",
        "reason": "Abu Dhabi free zones hire global PMs to run cross-border initiatives."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "",
        "reason": "Role is eligible under Skilled-Worker but off current shortage list."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Large NGOs and tech multinationals sponsor H-1Bs for global PM roles, though not a policy priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "8fd4d903-d157-4db7-9409-27edeba94b48": {
    "career": "Opera Educator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Performing-arts teachers can obtain 408 visas, yet competition is stiff."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Arts visas exist but no specific shortage; funding depends on grants."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Germany’s rich opera scene and Musikhochschulen recruit international vocal coaches."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Highly Skilled Professional visa",
        "reason": "Conservatories sponsor accomplished teachers, but language and audience size constrain numbers."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Arts House and Esplanade host residencies, but role is not on Tier-1 lists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Dubai Opera offers occasional teaching residencies but no structured visa priority."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry talent, including classical music educators, sits within the UK’s global talent route."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "",
        "reason": "Elite conservatories and outreach programs sponsor O-1 visas for distinguished vocal educators."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "2cee25cb-bd04-4552-a82d-62b4e6f14ee2": {
    "career": "Startup Founder",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Global Talent visa stream includes ‘digitech’ founders but seats are limited."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Canada’s Start-up Visa and targeted strategy court tech entrepreneurs with fast PR and seed funds."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Opportunity Card awards extra points for founders but programme is new and competitive."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Focus on EV and agri-tech start-ups; legal uncertainty keeps it a tertiary choice."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Start-Up Entrepreneur Programme offers residency for high-potential tech founders feeding the EU market."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Tokyo & Fukuoka ‘Startup Visa’ zones ease entry but language/barriers remain."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "NIMP grants and ‘DE Rantau’ visas encourage Industry 4.0 founders, yet ecosystem still maturing."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Entrepreneur Work Visa exists yet quota small; fit is secondary."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "NEOM and national funds aggressively seed early-stage tech and tourism ventures."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "National AI Strategy 2.0",
        "reason": "EntrePass and generous R&D grants make Singapore Asia’s favourite AI/fintech launchpad."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "UAE Centennial 2071",
        "reason": "Golden Visa for entrepreneurs and 0% personal tax attract startup founders across AI, fintech and climate tech."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Innovator Founder visa supports digital, clean-tech and creative start-ups aligned with IS-8 clusters."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "CHIPS and Science Act",
        "reason": "Deep-tech start-ups in semiconductors and AI can access CHIPS grants and relaxed founder visas (International Entrepreneur Parole)."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Government funds chip/AI start-ups but foreign founder visas are restrictive."
      }
    }
  },
  "69bf8750-5134-44ab-a5df-bb96bfdaca41": {
    "career": "Toxicologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Clinical scientists fit CSOL but toxicology roles are niche, so secondary fit."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Health-science occupations earn extra CRS points although toxicology isn’t on the priority list."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Pharma and chemical firms welcome lab scientists; Blue Card available."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Biopharma and food-safety labs expanding alongside halal certification drive."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma cluster around Cork/Galway urgently needs toxicologists for drug-safety testing."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Highly Skilled Professional visa",
        "reason": "Biotech researchers, including toxicology, receive top-tier points and 1-year PR track."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "NIMP pushes pharma and medical devices, creating steady demand for toxicology testing."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Few dedicated toxicology listings; possible under ‘medical laboratory scientist’."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Growing pharma and food-safety labs but Saudization creates competition."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Singapore Green Plan 2030",
        "reason": "Biomedical Hub needs toxicologists for drug trials and environmental health assessments."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Dubai Science Park labs hire toxicologists yet numbers are modest."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences R&D is a flagship pillar; toxicologists eligible for Skilled Worker fast-track and significant grants."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds biopharma and environmental safety labs needing toxicology expertise."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National Master Plan 2021-2030",
        "reason": "Biotech parks in Ho Chi Minh City recruit safety scientists for export-grade products."
      }
    }
  },
  "013107e1-e95d-47cf-8c4a-34155187e962": {
    "career": "Water Treatment Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Civil/environmental engineers for desalination and drought resilience are on the list."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Construction and utility engineers get high CRS points; clean-water projects prioritised in northern provinces."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Waste-water and renewable energy plants need specialists; Blue Card pathway straightforward."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "RPJPN 2025-2045",
        "reason": "Government pushing sanitation but localisation rules apply."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Only some senior environmental engineers qualify; fit is supportive."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Infrastructure engineers possible under HSP, but competition and language hurdles lower attractiveness."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Upgrades in sewage treatment exist yet foreign recruitment modest."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Listed under civil engineers; ageing water infrastructure creates vacancies."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "World’s largest desalination capacity under expansion across NEOM and Red Sea projects."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Green Plan 2030",
        "reason": "NEWater tech leaders hire but local talent pool already strong; foreign entry limited."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Operation 300bn",
        "reason": "Water-recycling and solar desal initiatives create steady engineering demand."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Private water utilities recruit but not on official shortage list."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "US is investing $55 billion in drinking-water upgrades, driving urgent demand for treatment engineers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "National Master Plan 2021-2030",
        "reason": "ODA-funded water projects hire specialists, mostly short-term consultancies."
      }
    }
  },
  "89fd345c-4b5b-4e1a-be8f-653b43a608f8": {
    "career": "Acting Coach",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Film tax credits create work in Vancouver/Toronto, yet no immigration priority."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Tax-incentivised film sets occasionally import specialist coaches, but not on CSOL."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Vision 2030",
        "reason": "Entertainment sector growth under GEA brings demand for acting coaches for new film studios."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s media-city and film academies import senior acting teachers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry is a priority; drama schools and streaming productions create steady demand."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Not policy-driven; demand stems from Hollywood, making the US a market but not a formal priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b1e82e70-ba52-4e1c-bbaf-8038f9a1f482": {
    "career": "Cultural Tourism Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Regional tourism campaigns open roles, yet not on CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Indigenous and heritage tourism growing but immigration focus remains elsewhere."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "RPJPN 2025-2045",
        "reason": "Labuan Bajo and Borobudur super-priority destinations hiring cultural managers for premium tourism."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Inbound tourism surge; cultural site managers possible under hospitality SSW."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "MADANI Economy",
        "reason": "State-funded heritage city (Melaka, Georgetown) upgrade programmes recruit cultural managers."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Skilled Migrant Category",
        "reason": "Maori cultural tourism niche but limited visas."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Mega-projects (AlUla, Diriyah) need managers to curate heritage experiences for 100 M tourists target."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Abu Dhabi’s Louvre, Qasr Al Hosn and Dubai Creek rely on global cultural-tourism experts."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Heritage sites employ managers, but role doesn’t meet shortage criteria."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "National parks and heritage sites hire managers, but no special visa priority."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "National Master Plan 2021-2030",
        "reason": "UNESCO sites like Hoi An need sustainable tourism managers; govt courting foreign expertise."
      }
    }
  },
  "2b760252-2d47-4298-89ad-7780844ddaf8": {
    "career": "Development Project Manager",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Construction Project Managers explicitly on CSOL to meet housing and mining-infrastructure boom."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Construction trades prioritised; managers benefit indirectly yet are not in core list."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Civil/renewable projects short on planners; PMs accepted but under engineering umbrella, hence Tier-3."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Construction PMs not on list; demand moderate."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "SSW targets mid-skill site labour; managers may qualify only via company transfer."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Construction Project Managers on Green List for fast-track residence amid quake rebuild and housing push."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Mega-projects (NEOM, Red Sea) urgently recruit international project managers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Economy 2030",
        "reason": "Project managers valued but not in priority tech lists; employment pass quota tightening."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "We the UAE 2031",
        "reason": "Continued real-estate and infrastructure pipeline seeks experienced PMs but local preference keeps it Tier-2."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 focuses on engineers; PMs useful yet outside shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Large federal spend on roads, bridges and broadband needs experienced project managers but not classed as critical skill."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "0f12f4fd-4051-4194-948f-63684ce43179": {
    "career": "Entrepreneurship Club Leader",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Policy supports founders; club leadership adjacent, hence Tier-3."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on list; soft ecosystems support only limited roles."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National AI Strategy 2.0",
        "reason": "Startup ecosystem active; however, visas target founders/investors over club leaders."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "UAE Centennial 2071",
        "reason": "Free-zone incubators welcome mentors, yet priority remains tech founders."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Universities host enterprise societies; leaders may get visas via graduate route, still peripheral."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "CHIPS and Science Act",
        "reason": "US campus startup ecosystems value mentors but role not occupationally classified for visas."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "214b3cc8-f49f-4eaf-a334-7a83b95a62b7": {
    "career": "Financial Advisor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Financial planners off priority list after 2024 reforms."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Financial roles not in latest targeted categories, but openings exist."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Growing middle class boosts demand, but local language/laws key."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Financial services quants and planners essential to Dublin’s funds sector."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP focuses on quants and fintech engineers over retail advisors."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "MADANI Economy",
        "reason": "Islamic finance expansion opens niche for sharia-compliant advisors."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Growing retail investment market seeks certified advisors, yet Saudization tempers demand."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Green Plan 2030",
        "reason": "Hub for sustainable and private banking needs MAS-licensed advisors."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "We the UAE 2031",
        "reason": "Dubai/Abu Dhabi aim to be global wealth hubs, aggressively importing certified advisors."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London financial services remain strategic; skilled-worker visas list advisers."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "No direct priority; wealth advisors still in demand by private market."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "9cb9b367-ac8c-4f00-8635-781e3c8f8d18": {
    "career": "Hospitality Sales Lead",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Bali & new capital’s tourism drive calls for seasoned hospitality marketers."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Hotel staff under SSW, but sales leaders rarely sponsored."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "MADANI Economy",
        "reason": "High-end tourism push in Langkawi needs sales talent though not officially prioritised."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Mega-tourism destinations require global hotel sales heads to attract guests."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Economy 2030",
        "reason": "MICE hub needs skilled hotel sales, but policy focus stays on tech so Tier-2."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai’s MICE and luxury sectors aggressively court experienced sales leaders."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Tourism rebound creates demand but no visa priority."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Rapid resort growth values foreign expertise in sales strategy."
      }
    }
  },
  "f639351b-d646-4339-b339-7e75004b60dc": {
    "career": "Intelligence Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Migration Strategy 2023",
        "reason": "Cybersecurity and defence priority list includes threat-intelligence roles."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "CSIS recruits analysts but small intake keeps it Tier-3."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz",
        "reason": "BfV seeks analysts but citizenship/security clearance hurdles lower openness."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "RPJPN 2025-2045",
        "reason": "Growing fintech sector needs threat intelligence but not formal priority."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Cyber-threat intelligence roles exist in multinationals but not on critical list."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP welcomes AI and security analysts for smart-city and defence projects."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "NIMP 2030",
        "reason": "Cyber-intel demand rising with Industry 4.0; still emerging priority."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Migrant Category",
        "reason": "Small intelligence community; hires mainly citizens."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Regional security and defence tech expansion boosts demand for private-sector analysts."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National AI Strategy 2.0",
        "reason": "Data-fusion analysts useful for counter-terrorism and finance, yet local citizen preference applies."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Operation 300bn",
        "reason": "Abu Dhabi invests in defence tech and data analytics, importing talent for fusion centres."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "MI5/MI6 and defence contractors need cyber/intel analysts; listed shortage."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Defense, AI and cybersecurity roles heavily funded; analysts critical for national security."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "c116bef6-0e37-4295-81e8-ca5a81319ddc": {
    "career": "Journalism Researcher",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Open work-permit routes exist, yet Express Entry does not list journalism as priority."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Vision 2030",
        "reason": "Vision 2030 promotes entertainment/media sectors, but journalism faces licensing barriers."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "We the UAE 2031",
        "reason": "Dubai Media City recruits senior research talent for global outlets and fact-checking hubs."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Vibrant press ecosystem; immigration routes exist but journalism not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Large media market and investigative journalism tradition, but no federal talent policy targeting journalism."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b44211fa-6d5f-497f-ba3d-c1b3f7b558aa": {
    "career": "Latin Teacher",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Gymnasium curricula include Latin, yet immigration list focuses on STEM teachers."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Latin Excellence Programme funds some roles, but not on official shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Niche demand in college-prep schools; not covered by federal shortage lists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "f3b36327-da52-42fa-9c14-1200dbce7d32": {
    "career": "Maritime Logistics Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Major exporters need port talent, but role not on CSOL."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Transport and logistics occupations receive extra points."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Hamburg and Bremen ports require managers, yet not shortage-listed."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "RPJPN 2025-2045",
        "reason": "Island nation emphasises maritime corridor development."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Container hubs like Yokohama need managers, but no dedicated visa track."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Port Klang expansion creates roles, though not policy priority."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Some demand via coastal shipping reforms, but visa preference elsewhere."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Massive investment in Red Sea and NEOM logistics zones seeks senior managers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Singapore Economy 2030",
        "reason": "PSA Tuas Megaport fuels steady need for logistics leadership."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi aiming to be top global logistics hubs."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Freeport programme expands roles, but not on shortage list."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Port modernisation funds drive demand for supply-chain managers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "National Master Plan 2021-2030",
        "reason": "Export-led economy upgrading ports, but preference for local hires."
      }
    }
  },
  "3633ce73-df8f-46e3-89e2-a67fbdd1df3c": {
    "career": "Materials Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Critical minerals and battery materials R&D highlighted."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Incentives for cleantech and semiconductor materials scientists."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Automotive and renewable industries hungry for new alloys and composites."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "67",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel-based battery materials R&D encouraged."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Med-tech and pharma sectors need biomaterials experts."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Highly Skilled Professional visa",
        "reason": "Semiconductor and battery giants seek cutting-edge materials R&D."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Targets advanced materials and semiconductors supply chain."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Small research base; niche openings in universities only."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "Neom R&D hub investing in advanced materials for construction and energy."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Manufacturing 2030",
        "reason": "A*STAR funds quantum and nanomaterials research though not official Tier-1 list."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing initiatives require materials scientists."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean energy and aerospace clusters prioritise materials innovation."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Billions allocated for advanced materials and semiconductor R&D."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Materials labs support chip packaging and testing ambitions."
      }
    }
  },
  "2c95cfd9-38cb-4536-87a6-47733e643879": {
    "career": "Natural Resource Manager",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Water and land management critical amid climate stress."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Forestry and conservation professionals on priority list, vast boreal resources."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Renewables push creates some demand; not shortage-listed."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "RPJPN 2025-2045",
        "reason": "Massive reforestation and peatland restoration under carbon markets."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Peatland restoration funding exists but not on critical skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Forestry managed largely domestically; visa focus elsewhere."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "MADANI Economy",
        "reason": "Push for sustainable palm-oil certification creates moderate demand."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Conservation and biodiversity skills highlighted."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Singapore Green Plan 2030",
        "reason": "Regional carbon-services hub needs resource auditors."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "UAE Centennial 2071",
        "reason": "Desert ecosystem work limited but carbon-offset projects emerging."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Some roles in rewilding projects, yet no visa priority."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds landscape restoration and carbon-credit monitoring."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "National Master Plan 2021-2030",
        "reason": "Forestry and coastal resource management prioritised for climate resilience."
      }
    }
  },
  "a193e354-999b-4312-a29e-7f8ca869628c": {
    "career": "Safety Manager",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Large pipeline projects require site HSE officers; CSOL lists Construction Project Managers with explicit ‘workplace safety’ skills."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Construction boom and trades-oriented immigration stream list safety/HSE supervisors under ‘transport & construction occupations’."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Renewables and rail upgrades face labour shortages; Bau-BG insurers demand certified Sicherheitsingenieure."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "RPJPN 2025-2045",
        "reason": "Nickel/EV and Nusantara capital projects list K3 (occupational safety) experts as supporting talent."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "General civil engineers are listed; safety managers may piggy-back but not explicitly prioritised."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Safety roles fall under construction management, eligible for points under Highly Skilled Professional but not headline demand."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Electronics plants and new EV lines need OSHA-aligned HSE, yet immigration pathways favour engineers first."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Migrant Category",
        "reason": "Tight labour market in civil works after cyclone rebuild—H&S coordinators earn extra points though not Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Vision 2030",
        "reason": "NEOM, Red Sea, Diriyah giga-projects insist on expat HSE managers with international certifications."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Green Plan 2030",
        "reason": "Manufacturing 2030 needs HSE, yet MOM quotas are tight and role is not on the top shortage list."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "79",
        "policy": "We the UAE 2031",
        "reason": "Operation 300bn factories and Expo-legacy sites require ISO-45001 safety leads; role sits on priority engineering list."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Some regional shortages in construction safety, but not a national shortage occupation."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA is pumping billions into roads, bridges and factories; OSHA-compliant safety leadership is explicitly budgeted on every federal site."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "National Master Plan 2021-2030",
        "reason": "Large infrastructure buildout raises demand for site safety but government focuses visas on engineers."
      }
    }
  },
  "26870084-1cd9-4042-8c34-f14b2a79e226": {
    "career": "Social Science Education Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Secondary teachers on CSOL; social science specialisms accepted though STEM weighted higher."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Express Entry Category-Based Selection",
        "reason": "K-12 and curriculum consultants are included under early-childhood/teacher shortage streams, especially for French and Indigenous studies."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "School and vocational educators receive points; Bundesländer lack humanities teachers in bilingual programmes."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "Asta Cita",
        "reason": "Education reforms focus on digital and STEM; humanities specialists hired mainly by international schools."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Humanities educators not on list; schools may sponsor only when local supply exhausted."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "International schools and universities recruit social science curriculum faculty via points system."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "MADANI Economy",
        "reason": "Private universities expand liberal-arts, but national plans focus more on STEM."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Migrant Category",
        "reason": "Secondary social-science teachers can gain bonus points though not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Vision 2030",
        "reason": "Private international schools hire foreign curriculum experts, but Saudization limits public roles."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Economy 2030",
        "reason": "MOE hires mostly locals; social science curriculum consultants find niche roles in EdTech firms."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "UAE Centennial 2071",
        "reason": "International schools in Abu Dhabi & Dubai import curriculum designers for IB/AP humanities."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Current shortage list removed humanities teachers; immigration routes still exist but with higher salary thresholds."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds STEM, leaving social studies outside priority; education roles rely on local hiring."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "National Master Plan 2021-2030",
        "reason": "Bilingual schools grow, requiring social studies content creators, though not a formal shortage."
      }
    }
  },
  "9452f90a-aa18-45e1-a688-dce1f3499632": {
    "career": "Supply Chain Coordinator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Focus on construction and cyber means logistics coordinators receive points but no priority queue."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Manufacturing and agri streams indirectly value supply chain skills; not on explicit shortage list."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Automotive supply chains hiring, yet immigration preference given to engineers."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel/EV supply chains need planners; still not an official shortage occupation."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma plants need planners; still outside critical list so general work permit needed."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "SSW covers warehouse operatives but white-collar coordinators must use regular points system."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "NIMP 2030",
        "reason": "Semiconductor export push requires planners, yet foreign hiring caps apply."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Skilled Migrant Category",
        "reason": "Ports and dairies need planners, but Green List omits the occupation."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Mega-projects and new free zones seek logistics planners to integrate ports, rail and warehouses."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Singapore Economy 2030",
        "reason": "PSA, Changi and advanced manufacturing require logistics strategists; COMPASS points favour skills in data-driven supply chains."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai aims to be world’s logistics hub; free-zone employers fast-track visas for supply chain professionals."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Midsized manufacturers hire coordinators, but visa shortage list removed this role."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA’s EV and battery subsidies create new value chains requiring logistics talent, but visas not specifically prioritised."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Electronics clusters need coordinators, but engineers receive priority in work permits."
      }
    }
  },
  "cc554b88-850f-40a4-b066-b5284ca477dc": {
    "career": "Trade Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Demand exists in DFAT and mining exporters; no dedicated immigration lane."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Government seeks policy economists, but formal priority is tech rather than trade."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Export-oriented Mittelstand wants analysts, yet points favour engineers."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel and EV trade negotiations create niche roles; still not priority."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "IDA-backed MNCs hire for EU customs compliance, though role not on official list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "Trade ministries hire limited foreign advisers via points pathway."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Policy think tanks growing but preference for local economists."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Small economy; analyst roles limited and not on shortage lists."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Diversification pushes require trade policy researchers for new FTZs."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "National AI Strategy 2.0",
        "reason": "As Asia’s trade hub, MAS and MTI need analysts versed in data-driven trade modelling; EP points reward finance analytics."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Dubai International Financial Centre recruits analysts for FTA advisory services."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Post-Brexit trade deals spur demand in consultancies and HM Treasury."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA reshapes global supply chains; firms hire analysts to model tariff and subsidy impacts."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "National Master Plan 2021-2030",
        "reason": "Export strategy units emerging; visas favour tech."
      }
    }
  },
  "c7a65414-a1f2-4ca3-b772-6fe896ce4ad3": {
    "career": "Veterinary Surgeon",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Veterinarians sit on CSOL; sponsorship fast-tracked due to severe regional shortages."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Rural and food-animal vets are on priority list with dedicated pathways and LMIA exemptions."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Tierheim and agribusiness demand vets; licensing hurdles but role recognised as Mangelberuf."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Aquaculture and poultry expansion drive demand, though foreign licensing is complex."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Veterinarians explicitly listed; permits fast-tracked."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Licensing strict and Japanese language mandatory; some demand in livestock sector."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "Halal meat certification drives some demand, but preference for local grads."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Veterinarians are Green List Tier 1—residence straight after two years."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Growing equine and dairy sectors need vets but Saudization applies."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Green Plan 2030",
        "reason": "Pet health market growing, but AVS caps foreign vet numbers."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "We the UAE 2031",
        "reason": "Falconry, equine hospitals and pet clinics hire expat vets; not a strategic priority."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Vets remain on shortage list; sponsorship targets rural clinics."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "No direct link, but rural vet shortages exist; H-1B options limited."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "National Master Plan 2021-2030",
        "reason": "Livestock modernisation needs vets, yet work permits remain tight."
      }
    }
  },
  "42746541-4094-4ef3-aa01-d405d1be3f75": {
    "career": "Waste Management Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Environmental/civil engineers on CSOL; states hiring consultants for circular-economy targets."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Environmental engineers qualify but waste is not singled-out; points depend on French or provincial needs."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Abfallwirtschaft engineers eligible but shortage less acute than energy or IT."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "RPJPN 2025-2045",
        "reason": "Focus on mining waste and nickel tailings; consultants welcome yet not prioritised."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Environmental roles possible under civil engineering, yet not priority."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Highly Skilled Professional visa",
        "reason": "Can enter as environmental engineer, but ageing society priorities dominate."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Circular-economy pilots inside electronics parks create niche demand."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "No Green-List role, yet councils seek landfill-to-resource expertise."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Vision 2030",
        "reason": "Giga-projects must hit sustainability KPIs including zero-waste construction."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Singapore Green Plan 2030",
        "reason": "Nation targets 30 % landfill reduction by 2030; consulting opportunities in industrial estates."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s waste-to-energy plants and Expo City require specialist advice."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Waste consulting supports clean-energy clusters but not on shortage list."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA funds recycling modernisation and landfill-gas capture, creating advisory demand in municipalities."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "National Master Plan 2021-2030",
        "reason": "Rapid urbanisation pushes solid-waste upgrades but talent still secondary to semiconductors."
      }
    }
  },
  "98491e82-114b-44c0-bf65-f009833f1408": {
    "career": "Academic Writer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Migration Strategy 2023",
        "reason": "Universities recruit Asia-Pacific cultural scholars to strengthen regional research."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Points available for PhDs, but social-science writers not targeted."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "DAAD funds Asian-studies fellows; English-language publications valued."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Funding channels favour applied sciences over academic writing."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List excludes humanities, but universities can sponsor niche talent."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP welcomes PhD writers; demand in English-language journals on Asia."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "MADANI Economy",
        "reason": "Asian-studies writing largely fulfilled locally; imports rare."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Limited slots outside STEM, though some Pacific-Asia research centres hire."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Vision 2030",
        "reason": "Humanities hiring focused on Saudi heritage, not Asian studies."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Economy 2030",
        "reason": "Think-tanks publish on Southeast Asia, but visas selective."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "UAE Centennial 2071",
        "reason": "Branch campuses occasionally need area-studies content writers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Russell Group pushes Global Britain scholarship; humanities still receive visa points."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds humanities outreach alongside STEM; universities still sponsor area-studies publishing."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Priority on tech and infrastructure, not humanities."
      }
    }
  },
  "95f4cd0e-b82a-4fc7-8b27-b245d433f7b2": {
    "career": "Childhood Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Migration Strategy 2023",
        "reason": "Universities seek developmental psychologists to address indigenous and rural education gaps."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Canada funds child-development labs to improve early-learning policy."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "DFG grants for developmental neuroscience attract foreign PhDs."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "RPJPN 2025-2045",
        "reason": "Child research underfunded compared with nutrition and mining."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List omits psychology researchers; universities may still sponsor."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "Some openings in developmental neuroscience under HSP points."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "MADANI Economy",
        "reason": "Social science hiring modest; not prioritised."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Some demand via university research centres, not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Vision 2030",
        "reason": "Child psychology research still embryonic; emphasis on clinical medicine."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Economy 2030",
        "reason": "A-STAR’s SICS funds child cognition, but slots are few."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "UAE Centennial 2071",
        "reason": "Family policy think-tanks hire selectively; no broad shortage."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Research funding squeezed but elite universities sponsor visas."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "CHIPS and Science Act",
        "reason": "NSF budgets include behavioural science grants on learning and cognition."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Funding focused on STEM and infrastructure."
      }
    }
  },
  "64a1ed42-3e61-44fb-bbb7-58c17ad9d214": {
    "career": "Classroom Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "STEM secondary teachers on CSOL; general classroom management adjacent."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Secondary teachers are an explicit priority; provinces fast-track visas."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe teacher shortages, especially in STEM and integration classes."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "RPJPN 2025-2045",
        "reason": "Local teacher-training expansion preferred."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Only maths and language teachers prioritised; classroom management generic."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Public school roles limited to nationals; eikaiwa (English conversation) possible but not listed."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "MADANI Economy",
        "reason": "Education reform focuses on STEM skills domestically produced."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Secondary teachers on Green List; easier residence pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Vision 2030",
        "reason": "Public teaching reserved for nationals; private schools hire but not priority."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Singapore Green Plan 2030",
        "reason": "MOE rarely hires foreign classroom teachers unless niche subjects."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "UAE Centennial 2071",
        "reason": "International schools recruit, yet classroom-manager visas tied to employer sponsorship."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Teachers removed from shortage list in 2025."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct teacher shortage support at federal level."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Private schools hire expats, but policy priority is semiconductors, not teaching."
      }
    }
  },
  "44cbddeb-89c4-4e7f-b433-dac0e2f82483": {
    "career": "Clinical Research Associate",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Pharmacovigilance and clinical-trials monitors on skill lists."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Healthcare and pharma research receive points; oncology trials expanding."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz",
        "reason": "Big pharma clusters in NRW and Bavaria sponsor oncology CRAs."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Oncology trials minimal; focus on infectious disease."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma and med-tech giants run global trials from Dublin and Cork."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "CROs hire bilingual CRAs, but foreign language barrier lowers demand."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Growing medical-device R&D but oncology trials still small."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Smaller trial volume, yet visas possible through district health boards."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Vision 2030",
        "reason": "King Faisal and NEOM hospitals launching research units needing monitors."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Green Plan 2030",
        "reason": "Biopolis anchors regional oncology trials; CRAs on EP fast-track."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "We the UAE 2031",
        "reason": "Dubai Science Park seeks oncology study monitors, but numbers limited."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences super-cluster around Oxford-Cambridge-London drives shortage of CRAs."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA and NIH pour billions into cancer trials, driving CRA demand."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "National Master Plan 2021-2030",
        "reason": "Early clinical-trial infrastructure developing; limited roles today."
      }
    }
  },
  "5f2d10a0-9ba8-48e2-93ea-46deebfaba5c": {
    "career": "Hotel Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Not on CSOL, yet regional tourism areas sponsor hotel GMs through employer-sponsored visas."
      },
      "canada": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "New capital Nusantara plans thousands of hotel rooms, opening senior expatriate roles."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Hotels can hire under SSW Category ‘Accommodation Industry’, path to management after language proficiency."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "NEOM, Red Sea and AlUla giga-projects need thousands of international hotel leaders immediately."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "",
        "reason": "Tourism is important, but manpower quotas and local-hire rules keep hotel management off priority lists."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai & Abu Dhabi target 40 M visitors; luxury chains fast-track global GMs under Golden Visa."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Hospitality removed from Shortage List but sponsor licences still possible for senior managers."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Hospitality roles are employer-sponsored, not on federal skill lists, but large chains file H-2B or L visas for experienced managers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "5ab46ec6-bae8-46a4-8dc3-3078fe7249e6": {
    "career": "Industrial-Organization Psychologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Practitioner psychologists are regulated, yet organisational specialists fall outside CSOL priorities."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Express Entry awards points for advanced degrees; IO psychologists qualify but are not priority."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Fachkräfteeinwanderung targets engineers and nurses; IO psychologists can still secure Blue Card via employer."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Critical Skills List omits psychology, but tech giants hire culture scientists on general permits."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP gives points for PhD and salary; corporate Japan values productivity experts."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Not on Green List; still possible through Skilled Migrant Category with PhD points."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Firms value talent analytics, but MOM passes focus on salary, not occupation priority."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Multinationals in DIFC sponsor performance and culture specialists to support diversification drive."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Role meets Skilled Worker visa salary floor, yet not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Corporate demand is high, but not covered by federal talent programs."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a6d17c96-83ed-46e6-8e2e-a2647c3dfd6c": {
    "career": "International Financial Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Finance is not on CSOL; employer sponsorship still possible at senior pay levels."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Financial managers qualify for Express Entry but not category-based priority."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Blue Card available for high-salary finance professionals; not a national shortage occupation."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech expansion and sovereign wealth funding need cross-border finance managers."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Financial services quants and managers supported for Dublin’s IFSC growth."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Tokyo’s international finance hub offers HSP fast-track for senior managers."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "MADANI Economy",
        "reason": "Islamic finance hub in Kuala Lumpur welcomes experienced international finance talent."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Financial managers sit outside Green List; points-based pathway only."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Diversification plan requires global finance leaders for PIF megaprojects."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Singapore Economy 2030",
        "reason": "Sustainable and fintech finance leaders qualify for EP Complementarity Assessment (COMPASS) bonus."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "UAE Centennial 2071",
        "reason": "DIFC & ADGM lure international finance executives via 10-year Golden Visas."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London financial services explicitly protected and globally recruited post-Brexit."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "",
        "reason": "Wall Street sponsors high-salary finance leaders under H-1B/O-1 despite no federal talent list."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Role not on priority lists, though fintech growth generates some demand."
      }
    }
  },
  "c51544ee-9c4f-40c1-812e-1b0f0dd11dcc": {
    "career": "Japanese Literature Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "",
        "reason": "Group of Eight universities recruit humanities lecturers; visas via academic stream."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "",
        "reason": "Express Entry rewards PhD; several universities run Japanese Studies centres."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "DAAD funds East-Asian research; Blue Card path for postdocs."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Small but growing East-Asian studies departments occasionally recruit overseas scholars."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Highly Skilled Professional visa",
        "reason": "Universities and National Institutes encourage foreign researchers to internationalise Japanese humanities."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Academic visas available, but few funded positions."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "NUS and NTU fund Asian-studies research chairs; academic EP straightforward."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "SOAS and Oxbridge regularly hire Japan specialists under Skilled Worker visa."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "US universities fund Asian Studies chairs and sponsor J-1/H-1B scholars."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "42c5acec-e3d1-4d5a-92ee-60d97f5beaa5": {
    "career": "Marketing Data Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Data analysts and scientists are explicitly listed for fast visas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Data scientists receive extra CRS points under new tech category."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialists can obtain Blue Card without degree if skilled."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "RPJPN 2025-2045",
        "reason": "Digital economy goals include data-driven marketing expertise."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Big-tech European HQs in Dublin hire marketing analysts at scale."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP fast-tracks AI and analytics specialists for consumer brands."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industry 4.0 push needs analytics talent across sectors."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Tech roles possible via Skilled Migrant Category but not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "AI and digital marketing central to mega-projects’ global outreach."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "National AI Strategy 2.0",
        "reason": "AI/ML and fintech marketing analytics qualify for Tech.Pass and COMPASS bonus."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "National AI strategy and regional ad hubs recruit data scientists."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital and AI specialists remain on shortage list."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "AI/ML talent is a named national priority; tech firms lead ad-tech innovation."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National Master Plan 2021-2030",
        "reason": "E-commerce giants and fintechs hire growth-focused data scientists."
      }
    }
  },
  "3b8b90a8-ef25-433b-b11a-f4725c5ad7e6": {
    "career": "Media Consultant",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "Massive investment in entertainment and sports events needs experienced media strategists."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi aim to be regional media hubs and recruit senior consultants."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries are a named growth pillar, but visa routes remain competitive."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Creative-industry work is available but not singled out in federal talent legislation or visa fast-tracks."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "12bff6d6-bef7-4ce8-8a7c-564e6034d119": {
    "career": "Quality Control Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Some states list food technologists, offering nomination pathways."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Agri-food processing occupations receive extra CRS points and targeted draws."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Industrial quality professionals qualify, but demand is moderate."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Food security initiatives need QC expertise for new facilities."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Large dairy and beverage exporters recruit QC managers, but no critical-skills fast track exists."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Food-processing SSW track allows progression; managerial roles require language fluency."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Halal export push creates QC demand, but visas favour engineers over managers."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Food technologists and dairy QC managers appear on Tier 2 shortage list."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "Expansion of food security projects needs QA/QC but not formally prioritised."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Green Plan 2030",
        "reason": "Role exists in urban-farm startups but outside official talent lists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Growing food-tech sector hires QC talent yet faces no official shortage classification."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Role not on the Shortage Occupation List; sponsorship possible but harder."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Food manufacturing needs QC leaders, but they are not on specialised visa fast-tracks."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National Master Plan 2021-2030",
        "reason": "Modernising agri-food chains value quality managers, yet no dedicated visa priority."
      }
    }
  },
  "84607a4a-6add-4f56-928a-2b6bcc4b455c": {
    "career": "Sports Therapy Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "",
        "reason": "Australia invests in sports science for Olympic preparation; universities sponsor researchers."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Academic roles exist but not on targeted shortages."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Sports institutes hire, yet occupation lacks dedicated fast track."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "National training centres for 2032 Olympics bid may open niche roles."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "No national shortage designation; few specialised labs."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Research funding focuses on robotics and ageing rather than sports therapy."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Small market; limited but steady research positions at universities."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "Kingdom’s new sports academies need evidence-based rehab programs."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "We the UAE 2031",
        "reason": "Dubai Sports City funds applied research contracts."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "UK Sport funds biomechanics and recovery research; universities can sponsor Global Talent visas."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "",
        "reason": "Collegiate and pro-sports labs fund injury-prevention research; O-1 visas suit PhD holders."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "7201c539-396e-4102-8c72-9cd5635cf105": {
    "career": "Advanced Practice Pharmacist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Migration Strategy 2023",
        "reason": "Allied health shortages place pharmacists high on state nomination lists."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Health professionals, including pharmacists, receive extra CRS points and quicker PR pathways."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Aging population drives demand; foreign-trained pharmacists can qualify after language exams."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "More hospitals need pharmacists, but licensing localisation slows foreign entry."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharmacists remain on the Critical Skills list, enabling fast work permits."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Licensing hurdles and language make entry difficult; no visa priority."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "MADANI Economy",
        "reason": "Growing biopharma sector values clinical pharmacists but prioritises R&D chemists."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Pharmacists are explicitly on Tier-1 Green List with straight-to-residence visas."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Hospital expansion and localisation of pharma manufacturing create strong demand."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Green Plan 2030",
        "reason": "Biomedical hub values regulatory pharmacists, yet clinical roles face local-talent preference."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Health-care city projects recruit specialist pharmacists for clinical and regulatory roles."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Pharmacists recently removed from Shortage List; sponsorship possible but competitive."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Pharmacists are in steady demand but not part of federal priority acts."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "National Master Plan 2021-2030",
        "reason": "Pharma industry expansion and WTO harmonisation drive demand for advanced pharmacists."
      }
    }
  },
  "c3373183-2ab1-4bd6-8084-2a3bbbfe31da": {
    "career": "Space Planner",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Interior designers appear on some state lists granting nomination."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "No shortage designation; architects receive preference over planners."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Immigration focus is on engineers rather than design planners."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital Nusantara requires extensive workplace planning expertise."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Small market and no priority visa scheme for interior design."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Building design roles require Japanese licensure and language skills."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "NIMP 2030",
        "reason": "Commercial expansion creates some demand, but not officially prioritised."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Interior architecture roles exist but not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Giga-projects such as NEOM need thousands of workplace and hospitality space planners immediately."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Economy 2030",
        "reason": "High-density redevelopment sustains jobs but not on critical-talent lists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "79",
        "policy": "Operation 300bn",
        "reason": "Mega-developments in Dubai and Abu Dhabi continually hire experienced planners."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Role sits outside Shortage List; sponsorship possible but limited."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Demand exists in commercial real estate but not covered by federal priority acts."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National Master Plan 2021-2030",
        "reason": "Office and industrial parks growth needs planners though no formal shortage."
      }
    }
  },
  "7e12bcc4-1235-455a-92de-d9225042c064": {
    "career": "Advertising Manager",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "24",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "22",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Entertainment and tourism growth needs senior marketing talent, but preference for Arabic speakers limits demand for foreigners."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Creative media roles get some support, but advertising management is not on priority lists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi push to be MENA media hubs; senior ad managers qualify for creative-industry visas."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries are endorsed, but advertising managers compete with plentiful local talent."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Creative-sector jobs exist but are outside federal industrial-policy priorities."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "24",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a8715342-299f-46f3-85ab-b19ae35e2c41": {
    "career": "Bio-Integrated Designer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "CSOL lists medtech engineers, not bio-design creatives."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Biotech is encouraged, but niche design roles compete with local grads."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Green materials and industrial design hubs like Berlin seek sustainable product innovators."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Strong med-device sector provides some openings for bio-materials designers."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP covers biotech and smart-city architects which overlaps with living design."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan supports medical devices and advanced materials; niche design roles possible."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Green Plan 2030",
        "reason": "Bio-medtech research exists, but immigration priority stays with scientists not designers."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing zones court biomaterials R&D, but hiring still small."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "UK funds bio-fabrication and synthetic biology clusters in London and Cambridge."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Federal R&D money flows into biotech, advanced materials and lab-grown manufacturing—prime ground for living-material design."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "9a6cf965-d5bb-4ac2-a87c-25b7404d3a54": {
    "career": "Climate Change Economist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Net-zero roadmap fuels demand for climate policy economists."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Government hires economists for carbon tax modelling and clean-tech incentives."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Energiewende and EU Green Deal generate roles in think-tanks and ministries."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "RPJPN 2025-2045",
        "reason": "Need for carbon-pricing analysis around forestry and mining, but hiring is still small."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Some demand in climate-finance teams, but not on Critical Skills list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Emissions Trading Scheme needs analysts, but total openings are small."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Economists guide diversification into renewables and carbon markets."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Green Plan 2030",
        "reason": "Carbon services hub needs economists for regional offset markets."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "UAE Centennial 2071",
        "reason": "ADGM Green Finance agendas create limited economist posts."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Treasury and consultancies model net-zero pathways and carbon budgets."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Massive climate-finance spending needs economic modelling of carbon pricing and cost-benefit analysis."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "12c3ca41-9179-4a0b-a598-1503910167ce": {
    "career": "Clinical Director",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Health-system reform demands experienced clinical leaders."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Severe shortages of senior healthcare managers; provinces fast-track them."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Hospitals hire foreign medical managers due to ageing workforce."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Some demand, but Critical Skills list focuses on frontline staff."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "NZ explicitly lists health-service managers on fast-track residency list."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Mega-hospitals in Riyadh and NEOM recruit international clinical leaders."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Public hospitals rarely sponsor managers, but private groups sometimes do."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Dubai Health Authority issues golden visas for senior medical administrators."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "",
        "reason": "Hospitals need leadership but role not singled out in federal industrial policy."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b9118d4d-b189-4b8f-8db5-064cea897d83": {
    "career": "Clinical Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL lists biomedical engineers and healthcare technologists."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Biomedical engineers are on priority lists for hospitals and device firms."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Germany’s med-tech cluster around Munich and Tuttlingen urgently needs engineers."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Large med-device manufacturing sector (Medtronic, Stryker) recruits biomedical engineers."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "Aging population fuels demand; HSP covers med-device engineers."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan targets medical devices as a growth pillar."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Biomedical engineers appear on Tier 2 list with clear residency pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "New smart hospitals hire clinical engineers but prefer GCC experience."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Economy 2030",
        "reason": "Biomed manufacturing hub at Tuas hires clinical engineers."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "Private hospital expansion drives moderate demand for device specialists."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences priority includes med-tech R&D and hospital engineering roles."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds domestic med-tech manufacturing and hospital modernisation, spiking demand for biomedical engineers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Growing med-device assembly market seeks some biomedical engineers."
      }
    }
  },
  "039f62b8-e660-4e84-8f01-a0048e4a9368": {
    "career": "Data Analytics Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Migration Strategy 2023",
        "reason": "ICT professionals incl. data analysts on Core Skills list but below healthcare/engineering in urgency."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Data scientists/analysts are an explicit priority occupation with fast-track permanent residency."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialists can bypass degree requirements; data analytics roles qualify for the Opportunity Card."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech boom needs data talent, but Bahasa requirements and local hiring quotas lower attractiveness."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Data, AI and cloud roles give automatic Critical-Skills permits and family reunification."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Highly Skilled Professional visa",
        "reason": "Points-based system rewards data/AI STEM degrees but language and culture barriers remain high."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "MADANI Economy",
        "reason": "Data analytics supports Industry 4.0 goals, yet local supply keeps pay moderate and visas cautious."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "ICT is recognised but not on the Green List; standard points pathway applies."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Government digitalisation and smart-city projects need analysts, yet local hiring is preferred over expatriates."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "National AI Strategy 2.0",
        "reason": "Government wants 15,000 more data professionals; COMPASS points favour this occupation but competition is fierce."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "UAE Centennial 2071",
        "reason": "Fintech and AI hubs (DIFC/ADGM) pull in analytics talent with 10-year Golden Visas."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital, AI and cyber on priority lists; Skilled-Worker visa salary floor remains a hurdle for juniors."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act pours billions into big-data, AI and semiconductor research—analytics talent sits at the core of funded projects."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Analytics aids chip design/manufacturing, but foreign talent visas limited to senior experts."
      }
    }
  },
  "62e3f6bb-b250-4c1e-950f-235c8598c6ca": {
    "career": "Materials Technologist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Mining-to-manufacturing value chain looks for metallurgists and materials scientists."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Battery and clean-tech manufacturing needs composite and polymer specialists."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Automotive and renewable sectors seek lightweight alloys; fast-track visas for STEM degrees."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel-to-battery ecosystem needs metallurgy know-how but language and expat caps apply."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Med-tech materials skills valued but not explicitly critical, points system still helps STEM grads."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics and EV battery firms recruit materials scientists; HSP gives five-year residence."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan highlights specialty chemicals and advanced materials for semiconductor supply chain."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Small demand in composites for aerospace and marine, but no dedicated Green-List slot."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Vision 2030",
        "reason": "NEOM construction and hydrogen projects need corrosion-resistant materials expertise."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Manufacturing 2030",
        "reason": "Precision engineering cluster invests in nano-materials and additive manufacturing."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing push covers polymers and composites, yet expat visas favour senior experts."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Lightweight materials for EV and aerospace are named focus areas; Global Talent visa available."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Advanced materials are critical for semiconductors, batteries and quantum devices funded by the Act."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Chip packaging targets under-fill, epoxy and substrate expertise but mainly localisation efforts."
      }
    }
  },
  "5e758897-cc7f-4b40-8103-e793953cd3ca": {
    "career": "Online Program Director",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Education managers absent from Core Skills list; private providers may sponsor senior hires."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Education managers can immigrate under standard manager code but not in category-based focus."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Points possible for higher-education managers but demand modest."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "49",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Role not on list; companies still sponsor under General Permit with longer processing."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Limited demand; language barrier high for education management."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "MADANI Economy",
        "reason": "Growing private universities but localisation policies constrain director-level visas."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Skilled Migrant Category",
        "reason": "E-learning growth but not on Green List; points route only."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Vision 2030",
        "reason": "Privatised universities and NEOM Academy hire online program leaders but prefer Western experience."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Singapore Economy 2030",
        "reason": "Ed-tech cluster hires directors, but occupation not on COMPASS bonus list."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s e-learning hubs recruit directors and offer Golden Visas for education entrepreneurs."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "EdTech seen as growth sector but directors must clear salary floor and sponsorship hurdles."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Broadband expansion indirectly boosts ed-tech, yet role not a federal priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "bb63b79d-415a-4257-b92c-03d5c7be4ea6": {
    "career": "Petroleum Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Oil-and-gas engineers only regionally in WA/NT; not national priority."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Alberta employers still sponsor petroleum engineers under skilled trades stream."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "RPJPN 2025-2045",
        "reason": "Deep-water and gas megaprojects need engineers; incentives for downstream investments."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "NIMP 2030",
        "reason": "Petronas and deep-water projects recruit engineers; government still monetises hydrocarbons."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Aramco and NEOM need CO2 capture & enhanced recovery experts—high salaries and streamlined visas."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Operation 300bn",
        "reason": "ADNOC expands offshore capacity; Golden Visa path for energy specialists."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "North Sea still hires, yet immigration list focuses on clean energy."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA tilts to clean energy; petroleum demand stable but not favoured for visas."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "National Master Plan 2021-2030",
        "reason": "Vietsovpetro fields need talent but localisation grows."
      }
    }
  },
  "3ffbc247-937d-4b6e-ab25-bd4d6ef6bf42": {
    "career": "Power Systems Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Renewables penetration stresses grids; power-systems engineers on priority list."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Hydro-Québec and provincial utilities need analysts for clean-power targets; engineers obtain extra points."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Energiewende requires experts in grid stability and storage modelling; accelerated Blue-Card route."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "RPJPN 2025-2045",
        "reason": "Geothermal and coal transition projects create pockets of demand; bureaucracy heavy."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Grid interconnectors and data-centre demand create vacancies for power engineers."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-grid R&D ongoing, but language requirements limit junior roles."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "MADANI Economy",
        "reason": "Grid upgrading for EV rollout needs talent; expat visas issued sparingly."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Electrical engineers incl. power-systems given fast-track residence to hit 100% renewables goal."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "NEOM’s renewable grid needs analysts, but local hire share rising."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Singapore Green Plan 2030",
        "reason": "Import-dependent grid moving to regional renewable imports; analysts needed for interconnect studies."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Masdar and DEWA recruit grid specialists for solar farms; Golden Visa possible at senior level."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Offshore wind and nuclear expansion rely on power-systems modelling; occupation on shortage list."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Massive grid modernisation and renewables integration demand load-forecast and stability experts."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "National Master Plan 2021-2030",
        "reason": "Solar and wind boom strains grid; foreign consultants hired on project basis."
      }
    }
  },
  "3f8a30ce-be81-454c-a949-7d4c13dae529": {
    "career": "Renewable Energy Manager",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL lists electrical/civil engineers for large-scale renewables and grid connections, roles that quickly transition into project management."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Clean-tech engineers get extra CRS points; utilities and provincial green-hydrogen pilots recruit experienced managers."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Energiewende accelerates wind/solar build-outs; utilities sponsor foreign managers with engineering degrees."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "63",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Geothermal and solar mega-projects around Nusantara need foreign project managers."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Offshore wind consent process spurs hiring of energy-project managers with grid know-how."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Feed-in tariff cuts slow demand, but offshore wind demo sites still recruit foreign managers."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Targets 70 % renewables by 2050; utility-scale solar EPCs look offshore for experienced leadership."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Wind-farm and geothermal expansions seek project managers with power-systems background."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Vision 2030",
        "reason": "NEOM and Red Sea giga-projects mandate renewable micro-grids overseen by international managers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Green Plan 2030",
        "reason": "Grid imports and floating PV create some roles, but policy focus is more on finance than construction management."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Operation 300bn",
        "reason": "Masdar’s solar parks and green-hydrogen pilots import talent to hit 50 % clean-energy target."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "79",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Offshore wind and hydrogen clusters (Teesside, Humber) need programme managers but visa priority sits just below STEM R&D."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA pours billions into solar, wind and battery projects that need engineers-turned-managers to deliver on strict tax-credit timelines."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "National Master Plan 2021-2030",
        "reason": "Offshore wind and LNG-to-power projects lack local management expertise."
      }
    }
  },
  "4dc78181-17d0-4603-b086-04c3baab604a": {
    "career": "Screen Composer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Screen sector incentives draw productions, but composers not on priority lists."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Tax credits make Vancouver/Toronto shoot more content, creating some composer slots."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Film subsidies in Berlin/Munich allow artists points-based entry, but not shortage occupation."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Vision 2030",
        "reason": "Massive investment in film, gaming and live entertainment demands international composers to train local talent."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National AI Strategy 2.0",
        "reason": "Government funds media labs but composer roles small and competitive."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "We the UAE 2031",
        "reason": "Dubai Studio City and Abu Dhabi rebate attract productions needing senior screen composers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry ‘IS-8’ gives top priority to film/TV/game music leaders—straight path to Global Talent visa."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct policy, but Hollywood and streaming demand keeps O-1 visas viable for exceptional composers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "2ab17952-9748-4759-a90d-ea3d20002aba": {
    "career": "Sociolinguistics Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Universities seek linguists for Aboriginal language documentation; GTI visa covers researchers."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Bilingualism research and Indigenous language revitalisation projects recruit foreign PhDs."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "DFG funds corpus-linguistics projects tied to migration integration; easier Blue Card for researchers."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "SFI grants for speech-tech and minority languages attract postdocs."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics firms partner with universities on human-robot dialogue studies."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Limited university seats, but Māori language initiatives open occasional posts."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "National AI Strategy 2.0",
        "reason": "Language-tech research units (AI Singapore) hire sociolinguists but slots are few."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry pillar funds social-AI interaction research; Global Talent fast-tracks academics."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "NSF funding for language-AI ethics and multilingual corpora boosts tenure-track openings."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "ab7252af-6ebe-486c-af16-8538eccb2a1e": {
    "career": "Sustainable Entrepreneur",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Business Innovation visa invites founders, yet quotas shrinking."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Start-Up Visa exists but targets tech scale-ups, not all eco ventures."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Impact hubs and KfW green funds welcome foreign founders meeting job-creation criteria."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "67",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Carbon-trading pilots and geothermal focus open slots for foreign co-founders."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "59",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Enterprise Ireland funds climate tech, yet immigration prefers employees over founders."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Tokyo/Sapporo run start-up visas, but renewable focus still small."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "MADANI Economy",
        "reason": "Green startup grants under NIMP 2030 plus 100% foreign ownership in many sectors."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Investor visas re-opened, but higher capital thresholds hinder boot-strapped founders."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "$1 bn greentech fund under PIF co-invests with foreign founders building locally."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Singapore Green Plan 2030",
        "reason": "EntrePass + ESG grants make city a launch pad for sustainable-finance startups."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "We the UAE 2031",
        "reason": "Golden Visa for entrepreneurs, free-zone incubators and COP28 legacy funds prioritise climate solutions."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Innovator Founder visa plus clean-tech grants support sustainability startups."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA tax credits plus DOE loans fuel green start-ups; founders can leverage E-2 or O-1 pathways."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "National Master Plan 2021-2030",
        "reason": "Government offers tax holidays for clean-tech founders in industrial parks."
      }
    }
  },
  "96064b5f-4bd7-4d32-aaff-f6f529520e6c": {
    "career": "Audiologist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Code 252711 Audiologist is on CSOL and receives priority processing."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Audiologists are on the Health Occupations list; fast PR and provincial nominations."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Ageing society creates shortage; clinics assist with Anerkennung licensing."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on critical list but hospital waiting times lead to employer-sponsored permits."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Tier 1 Green List occupation; straight route to residence."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Hospital expansion under privatisation drives demand for allied health."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Green Plan 2030",
        "reason": "Not a priority occupation; private clinics hire sparingly."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "We the UAE 2031",
        "reason": "Private hearing-care chains recruit foreign audiologists, especially with Arabic language basics."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Audiology recently removed from shortage list; still possible but slower."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct priority; rural clinics sometimes sponsor but numbers small."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "ed15fe4d-5233-49cb-b098-ba7ff29ede63": {
    "career": "Behavior Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "NDIS rolls and school-based behaviour support appear on state shortage lists."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Allied mental-health professionals receive extra CRS points under health-care shortage streams."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Demand exists in autism centres but role not explicitly named; recognition route via ‘other health professions’."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Autism service NGOs recruit abroad, but occupation absent from Critical Skills list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Skilled Migrant Category",
        "reason": "Accredited employers seek ABA therapists for disability services, earning bonus points."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Vision 2030",
        "reason": "Private autism clinics import expatriate ABA staff, yet no formal shortage designation."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Green Plan 2030",
        "reason": "Special-needs schools hire BCBAs, yet health roles outside core talent lists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "We the UAE 2031",
        "reason": "Dubai Health Authority licences behaviour analysts for growing special-needs schools, but quota is limited."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Some NHS mental-health shortages allow visa sponsorship, yet ABA not on core list."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Medicaid-funded autism therapy demand is surging; several states reimburse ABA under the IRA’s behavioural-health allocations."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "98638621-8688-4a92-bdd1-4c0be7aab603": {
    "career": "Biotech Associate",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Life-sciences hiring exists, yet not on priority lists outside senior roles."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Biomanufacturing is encouraged but falls below current healthcare/IT focus."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Biopharma clusters around Munich and Berlin actively sponsor molecular lab staff."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Biopharma listed but currently secondary to EV-battery hiring."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma and med-tech giants in Cork and Galway constantly need GMP lab associates."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "Regenerative-medicine boom offers HSP points for cell-culture specialists."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Biopharma and medical-device clusters in Penang seek wet-lab talent locally and abroad."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Only senior clinical scientists appear on Green List; junior bench roles rare."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "New research hubs hire foreign biotech graduates for genome and vaccine projects."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Singapore Economy 2030",
        "reason": "Biomed manufacturing is a national pillar; EDB grants keep inflow of associate-level scientists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Operation 300bn",
        "reason": "Dubai-Abu Dhabi biopharma push recruits associates, albeit in smaller numbers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences R&D named core growth pillar; visa fast-track for lab scientists."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Massive bio-manufacturing and synthetic biology grants prioritise lab talent."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Government funds vaccine plants, yet immigration preference leans to electronics."
      }
    }
  },
  "35926b13-26bf-4c08-8713-92d44feadc60": {
    "career": "Case Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Aged-care reforms list ‘welfare worker’ occupations on state shortage rolls."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Care-economy roles receive priority points; provinces sponsor social-service case managers."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Social workers have eased recognition; German language requirement remains high."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "49",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Role not on Critical list; some NGOs still recruit internationally."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Community and disability support workers on Green List Tier-2."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National AI Strategy 2.0",
        "reason": "Ageing-society grants sponsor foreign medical social workers; still capped numbers."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Hospitals sponsor clinical case managers, but numbers are modest."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Adult social-care shortages allow sponsorship, yet salaries often below visa minimum."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Federal community mental-health grants open slots but not a named shortage."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "27cccee9-a3ef-4670-9ea4-03b1272ab3b5": {
    "career": "Compensation and Benefits Manager",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Some global firms in Germany sponsor reward specialists, yet no shortage points."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on Critical Skills list; some tech MNCs still hire via General Work Permit."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Mega-projects hire foreign C&B experts to design expat packages before localisation phases."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "Reward specialists get EPs in finance sector but role outside talent lists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Financial-services and free-zone multinationals regularly import reward managers for complex expat pay structures."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Large City firms sponsor senior reward roles, yet immigration prefers STEM."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Large clean-energy firms scaling under IRA hire HR reward leaders, but role is not nationally prioritised."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "c86890ce-6042-4b51-b60d-8edfab312803": {
    "career": "R&D Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Electronics engineers and technology consultants appear on various state shortage lists."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Tech streams invite electronics R&D talent, though consulting roles count as management services."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz",
        "reason": "Auto and industrial giants hire R&D consultants for EV power electronics and Industry 4.0."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV-battery and electronics zones contract expatriate R&D consultants to localise production."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Electronics design engineers are critical; consultancies supply expertise to MedTech cluster."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Highly Skilled Professional visa",
        "reason": "Chip and robotics firms import R&D advisors under top-score HSP category."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Penang’s semiconductor ecosystem demands specialised R&D consultants for packaging and test."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Limited semiconductor footprint; some work in defence electronics only."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Mega-projects and defence tech rely on imported electronics R&D advisors."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Manufacturing 2030",
        "reason": "Semiconductor precision-engineering initiatives place R&D consultants on preferred EP list."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Operation 300bn",
        "reason": "Dubai and Abu Dhabi push advanced manufacturing and space electronics consulting."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 names semiconductor and clean-energy electronics as critical, with R&D tax incentives."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Semiconductor and advanced-manufacturing firms need external experts to convert grants into prototypes quickly."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Government grants reward firms hiring foreign R&D advisers for design centres."
      }
    }
  },
  "56675c8a-bd5e-4ea0-b210-5044ec8ace9c": {
    "career": "Registered Dietitian",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "Dietitians appear on state occupation lists due to hospital and aged-care shortages."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Allied-health professionals, including dietitians, receive additional CRS points and easier provincial nomination."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Hospitals face nutrition-therapy gaps; act eases visa for recognised allied-health degrees."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on list, yet public hospitals advertise overseas roles due to ageing population."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Medical tourism growth sparks some demand, but no dedicated visa incentives."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Dietitians are explicitly on Tier-2 Green List with fast-track residency after two years."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "New mega-hospitals and wellness resorts hire clinical dietitians as part of lifestyle-disease strategy."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "We the UAE 2031",
        "reason": "Private hospitals and sports academies recruit licensed dietitians for obesity-reduction goals."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Dietitians recently removed from shortage list; jobs exist but sponsorship harder."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Demand for preventative health is growing, but dietitians are not on any federal shortage list."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "cc6d7748-3224-4ea5-82e8-352a0d292b1a": {
    "career": "School Administrator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "STEM teachers are on lists; leadership posts rarely sponsored unless remote-area schools."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Teacher shortages exist; administrators can qualify under provincial education streams but competition is local."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "State-run schools require German language C1 and local credentials, limiting foreign admin roles."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Leadership not on list; Catholic-school regulations further restrict outsiders."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Skilled Migrant Category",
        "reason": "Rural schools sometimes recruit overseas deputy principals, but visa points lower than for teachers."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "UAE Centennial 2071",
        "reason": "Private international schools hire foreign principals, yet roles are limited and often filled internally."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct visa priority, but campus modernisation funds indirectly raise demand for principals able to manage upgrades."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "874cc893-35f3-4044-bef9-6096a94e76ea": {
    "career": "Social Psychologist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Australian Research Council funds social-behaviour projects linked to health and online safety."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities recruit PhDs under research streams; French-speaking scholars gain extra points."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "DFG grants and English-language labs seek global talent in behavioural economics and social cognition."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on list, yet Irish Research Council offers grants for behavioural studies."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "English-medium labs on consumer behaviour recruit HSP-score holders."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Migrant Category",
        "reason": "Universities in Wellington and Auckland list social-psych posts on long-term skill shortage list."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National AI Strategy 2.0",
        "reason": "A*STAR funds social-acceptance of AI projects; slots competitive."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Operation 300bn",
        "reason": "Private universities hire selectively; no visa incentives."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "UKRI funds behavioural insights for online safety and public health messaging."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "CHIPS and Science Act",
        "reason": "Federal research grants fund behavioural science for human-AI interaction and misinformation studies."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "d2efad24-0b42-452b-a7f9-bfd76d7b960c": {
    "career": "Biodiversity Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "Threatened-species recovery projects list ecology PhDs for global talent visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Parks Canada and provinces recruit conservation scientists; French-speakers gain extra CRS points."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Renewables focus dominates, yet Helmholtz Centres hire biodiversity modellers."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "RPJPN 2025-2045",
        "reason": "Kalimantan reforestation for new capital opens project-based research roles."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Marine Institute hires some foreign PhDs; no dedicated visa priority."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Universities recruit for satoyama and smart-city ecology projects."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Rainforest research stations hire foreign scientists on contract, but visa caps are tight."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Predator-Free 2050 and DOC shortages put conservation biologists on fast-track residency list."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Green Plan 2030",
        "reason": "City-state funds some mangrove studies, but limited field sites."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Funding exists via UKRI, but ecologists not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds climate projects that include habitat restoration, but immigration pathways are general."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "National Master Plan 2021-2030",
        "reason": "Mekong biodiversity projects attract NGOs, yet immigration paperwork complex."
      }
    }
  },
  "4582694d-2c0b-4dbb-a71f-b7f6f4a07c44": {
    "career": "Comparative Politics Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Universities use Global Talent visas for governance and Indo-Pacific policy specialists."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "SSHRC grants attract foreign PhDs; points boosted for French proficiency."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Berlin think-tanks and universities seek English-speaking comparative politics scholars."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Universities sponsor specific EU-governance projects; not on critical list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Select universities study Asian governance; HSP score helps, but Japanese preferred."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Small departments hire occasionally; no dedicated visa pathway."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "National AI Strategy 2.0",
        "reason": "Think-tanks like RSIS hire comparative politics PhDs for regional stability studies."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "ESRC funding and Global Talent visa support social-science researchers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "CHIPS and Science Act",
        "reason": "NSF social-science funding still robust; J-1 and H-1B cap exemptions for universities."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "0048c7ed-250c-47df-ac9c-5672b5764fc3": {
    "career": "Cultural Preservation Officer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "State museums recruit niche conservators; role outside Core Skills list, so demand is moderate."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "French-speaking heritage officers can obtain additional CRS points, but occupation not on priority lists."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Federal cultural institutions fill provenance-research and repatriation posts via skilled-worker visas."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Tourism plans for Borobudur and Bali include limited conservation posts."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on Critical Skills list; limited roles in National Museum and OPW."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Some demand in preservation of cultural properties, but vacancies small."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Heritage New Zealand hires few specialists; general skills route necessary."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Mega-projects at AlUla & Diriyah require experts to conserve archaeological sites and artifacts for tourism."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "Government funds heritage galleries, but immigration priority lies elsewhere; roles exist on a niche basis."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Cultural districts (Louvre, Guggenheim Abu Dhabi) actively sponsor conservation talent."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Heritage is part of the wider creative sector; museums face skill gaps post-Brexit."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA allocates funds for restoring historic bridges and federal buildings; agencies need preservation specialists to oversee compliance."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "84699a1d-ffd3-4aa6-ad07-2b7043b36cef": {
    "career": "Curatorial Associate",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Migration Strategy 2023",
        "reason": "Role sits outside Core Skills list but state museums use employer-sponsored visas."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Large museums in Ottawa and Toronto sponsor specialised art-history talent occasionally."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Provenance and repatriation research needs English-speaking curators."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Tourism push funds some new galleries but roles limited."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on Critical Skills list; few positions beyond National Gallery."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Large national museums occasionally recruit foreign curators for global exhibitions."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Skilled Migrant Category",
        "reason": "Te Papa recruits few specialists; points route possible."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "New museums at Qiddiya and Riyadh Art demand curatorial staff for rapidly expanding collections."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Singapore Economy 2030",
        "reason": "National Gallery and Asian Civilisations Museum recruit niche experts; not priority occupation."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Louvre, Zayed National Museum hire international curators to build credibility."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries strategy covers museums; Brexit shortages raise demand slightly."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Federal grants for museum modernisation open visas through arts organisations."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "c300f03e-787d-4714-bfee-f9570e76ec29": {
    "career": "Curriculum Designer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Migration Strategy 2023",
        "reason": "STEM-curriculum experts support under-staffed secondary schools; employer sponsorship common."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Teacher shortages give education designers an edge, especially French-speakers."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Bilingual curriculum writers needed for international schools."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "RPJPN 2025-2045",
        "reason": "STEM education upgrade needs consultants, but visa path unclear."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Some demand in e-learning companies; not on critical list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "International schools and ed-tech startups need English curriculum designers."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Green List (Tier 2)",
        "reason": "Education sector shortage extends to learning-design professionals."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "K-12 reforms import edu-tech talent but localisation rules apply."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Economy 2030",
        "reason": "MOE and private providers hire learning-designers; not a priority occupation."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Private schools seek IB and STEM curriculum experts."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Federal grants for broadband and ed-tech create demand for digital curriculum specialists."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National Master Plan 2021-2030",
        "reason": "Ed-tech growth opens some curriculum roles, but domestic hires preferred."
      }
    }
  },
  "efd38ac4-0eca-40a6-9960-1408ea045471": {
    "career": "Design Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "69",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Product design managers fall under engineering design shortages in renewables and med-tech."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Expanding hardware startups recruit senior industrial designers through Global Talent Stream."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Automotive and machinery clusters desperately need design managers to integrate UX with engineering."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV battery and appliance sectors recruit some design managers."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Med-tech corridor hires some industrial design leads, but not on critical list."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics and consumer-electronics giants value bilingual design managers."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan targets product innovation in semiconductors and EVs, boosting demand for design leadership."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Green List (Tier 2)",
        "reason": "Some demand in med-tech and agri-equipment firms; not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "NEOM product teams hire a few design leads, but focus is on construction."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Manufacturing 2030",
        "reason": "Precision-engineering firms and med-tech startups hire design managers to scale globally."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing push needs consumer product and med-device design leadership."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Strategy lists advanced manufacturing and creative design as priority; EV and aerospace firms need design managers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act pours billions into advanced manufacturing; firms need industrial design leaders for new fabs and devices."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Fast-growing hardware ODMs need industrial design talent for export markets."
      }
    }
  },
  "ec3127a1-0e64-41e5-a273-2d3fb83e4266": {
    "career": "Event Production Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Large festivals sponsor experienced managers, but not on Core Skills list."
      },
      "canada": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "MICE industry hires foreign specialists through general skilled route."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Tourism drive around Bali and Jakarta motorsport events increases need for production managers."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on list; some hires for tech conferences in Dublin."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Highly Skilled Professional visa",
        "reason": "Osaka 2025 Expo drives short-term demand for foreign event experts."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Government promotes MICE tourism; employers may sponsor niche talent."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Migrant Category",
        "reason": "Events sector growing post-pandemic, but limited quota."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Government pours billions into concerts, sports, and expos; high demand for experienced production managers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Economy 2030",
        "reason": "F1 Grand Prix and MICE hub require seasoned freelancers; not a priority visa."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai Expo legacy and year-round mega-events create continuous demand for event leaders."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry priority covers film, TV, live events; London venues need production talent after EU worker loss."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Funding for convention centres spurs event demand, but no visa priority."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "National Master Plan 2021-2030",
        "reason": "Growing conference sector in Ho Chi Minh City; roles exist but visas limited."
      }
    }
  },
  "cca97756-c5a1-47ca-87a1-d0f00bce9ec4": {
    "career": "Financial Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Banking sector recruits quants but occupation absent from Core Skills list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Fin-tech welcomed under broader tech-talent drive, yet role not on priority selection list."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Frankfurt finance hub values quants; still secondary to engineering shortages."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "IFSC funds and trading houses classified quantitative finance as critical skill."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "Tokyo’s push for international finance centre accepts quants under HSP points scheme."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Fintech and capital-market expansion under Vision 2030 need pricing and risk-model talent."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "National AI Strategy 2.0",
        "reason": "Fintech-quant talent prized to build AI-driven pricing and risk platforms for regional banks."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai DIFC targets quants for derivatives, structured-product desks and Islamic-finance risk models."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London lists advanced financial-services and quantitative risk among strategic skills."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "",
        "reason": "Wall Street and hedge-fund demand for quants remains strong, but financial services not named in current industrial policy."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "bbacd5e1-2dc1-458b-b6e5-dec8afb6d5a1": {
    "career": "General Accountant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Occupation sits on supplementary list allowing state nomination, not national high-priority."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Express Entry Category-Based Selection",
        "reason": "French-speaking and finance professionals receive extra CRS points though not explicit shortage."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Chartered accountants authorised for audit sign-off listed as critical skill."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Domestic CPA pipeline sufficient; immigration slots go to engineers."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Points awarded for degree roles, yet accountants absent from Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Large projects need finance staff, but Saudization limits foreign junior accountant visas."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Singapore Economy 2030",
        "reason": "Accountants receive COMPASS bonus only when adding niche tax or sustainability reporting skills."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "IFRS-skilled accountants required in free-zone corporates amid Operation 300bn expansion."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Senior accounting and auditing on IS-8 priority list due to post-Brexit talent gap."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Demand steady, but accountants excluded from recent industrial-policy priority lists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      }
    }
  },
  "bf78b67d-fb9e-400e-9f7e-766e14faaa9b": {
    "career": "Inclusion Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Secondary teachers, especially special-ed, on national shortage list."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "K-12 teachers and special-needs educators given priority points, widespread provincial shortages."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "States facing teacher deficits include inclusive education in recruitment drives."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Demand exists, yet role absent from critical skills list, employer sponsorship needed."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Special-needs and secondary educators appear on Tier 2 Green List."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "International schools recruit, but inclusion not in national priority list."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Private international schools hire inclusion staff, but not strategic priority."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Schools hire special-education experts, but visa pathways limited outside STEM."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "dc97058d-0937-4d5e-ae80-22f7936f977d": {
    "career": "Investment Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Wealth-management demand exists but not on Core Skills list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Program highlights fintech; traditional investment advisers lower priority."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Frankfurt finance centre hires analysts, yet immigration focus elsewhere."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Funds industry needs chartered investment professionals."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "Tokyo’s push to revive asset-management hub includes incentives for CFAs."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "PIF and new stock-market products require portfolio and asset-allocation experts."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "National AI Strategy 2.0",
        "reason": "WealthTech and sovereign funds recruit AI-savvy investment pros."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi global hubs courting portfolio managers under finance strategy."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Financial-services specialists have priority status to sustain City competitiveness."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "67",
        "policy": "",
        "reason": "Wall Street appetite strong, but role outside industrial-policy focus."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      }
    }
  },
  "00b167b0-b9b4-4316-ab05-a02712558379": {
    "career": "Medical Device Designer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Medical-device engineers eligible for points under general engineering shortages."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Biomed engineers fall under targeted STEM talent stream."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Bavarian med-tech cluster lacks enough biomedical engineers."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Galway and Limerick med-device hubs list biomedical engineers as critical."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "Aging society drives demand for implant and diagnostic device engineering."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Med-device engineering one of five strategic sectors for export growth."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "STEM points available though role not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Large hospital expansions import diagnostic-device R&D talent."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Green Plan 2030",
        "reason": "Biomedical manufacturing core pillar; Biopolis aggressively hires device designers."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Operation 300bn",
        "reason": "Plan encourages local med-tech manufacturing; designers sought."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences and med-tech R&D explicitly prioritised."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds med-tech R&D, including bio-instrumentation and implantable electronics."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Nascent med-tech industry; talent welcome but not prioritised."
      }
    }
  },
  "3bde0fa5-7546-42c0-8515-962fa34344d9": {
    "career": "Organisational Psychologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL names general psychologists; I-O backgrounds qualify indirectly but rank below clinical and counselling needs."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Mental-health occupations receive extra CRS points, yet industrial-organisational specialism is not on the national shortage list."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Law allows any STEM/academic professional in principle, yet demand centres on engineers and nurses, not OD experts."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Skilled Migrant Category",
        "reason": "Points system rewards advanced degrees; organisational psychology accepted but not prioritised."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Singapore Economy 2030",
        "reason": "Firms invest in people analytics, but MOM shortage lists prioritise tech, not psychology."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "UAE Centennial 2071",
        "reason": "Multinationals in DIFC occasionally hire OD consultants, yet visa incentives focus on tech and finance."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Consultancies and the Civil Service hire OD experts, but the Shortage List excludes the role."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Corporate wellness budgets are rising, but no dedicated visa or funding scheme targets organisational psychology."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "46493240-4016-4783-a5ed-ed9606fc8db1": {
    "career": "Regulatory Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "TGA reform and growing clinical-trial sector create openings, but engineers rank higher."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Health Canada speeds cancer-drug reviews, lifting demand for regulatory affairs specialists."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "German pharma clusters need EMA dossier talent, yet visas prioritise engineers first."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Dublin-Cork pharma corridor seeks regulatory affairs experts for EU centralized filings."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP grants top points to biotech researchers; PMDA accelerating oncology pathways."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan highlights pharma; local firms need guidance on ICH and FDA standards."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Small but expanding clinical-trial market; role earns points but no fast track."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Vision 2030 funds biotech manufacturing, yet most regulatory work is outsourced abroad."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Singapore Economy 2030",
        "reason": "Biomedical hub requires specialists to navigate HSA and FDA dual submissions."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Nascent biotech hub at Khalifa City needs compliance staff but on a limited scale."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences pillar offers fast-track visas; MHRA is rushing oncology approvals post-Brexit."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds domestic biomanufacturing; oncology drug approvals still need seasoned FDA liaison experts."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Growing generic-drug exports, but limited high-end oncology trials."
      }
    }
  },
  "5eac85e2-ac37-43a5-988f-5e190e91aeed": {
    "career": "Tax Accountant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Role is eligible under general accountant ANZSCO codes but well below priority trades."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Express Entry Category-Based Selection",
        "reason": "French-speaking accounting professionals score bonus points; tax specialism valued by SMEs."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Possible via Blue Card, yet German language barrier keeps demand moderate."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "IFSC needs international tax planners, though not on Critical Skills list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Islamic finance growth needs tax compliance, but locals fill most roles."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Accountants eligible for points, but shortages are mild compared with engineers."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Vision 2030 financial hubs need tax talent, yet Saudization quotas apply."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Economy 2030",
        "reason": "As a regional tax hub, Singapore welcomes accredited professionals, though no shortage bonus."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "We the UAE 2031",
        "reason": "New corporate tax regime spikes demand for chartered tax specialists."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Senior accounting and tax advisers underpin City of London competitiveness; visas fast-track ACCA/CPA talent."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Large demand for CPAs in multinationals, but no specific immigration incentive."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "bb3786c7-3a71-49e7-af64-8484d8b75ef4": {
    "career": "Environmental Systems Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL highlights civil/environmental engineers; managers with EMS skills ride same demand wave."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Net-zero push elevates demand for environmental management professionals."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Energiewende accelerates hiring of sustainability managers in manufacturing and renewables."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel and EV plants must meet environmental standards; managers hired selectively."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Data-centre boom sparks EMS hiring, yet not on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Highly Skilled Professional visa",
        "reason": "Carbon-neutral roadmap values EMS expertise, but language barrier reduces sponsorships."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "MADANI Economy",
        "reason": "New ESG reporting rules open roles, but priority remains semiconductor engineers."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Resource-intensive industries must certify environmental management systems for permits."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Giga-projects require LEED and ISO compliance staff, but expat quotas fluctuate."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Green Plan 2030",
        "reason": "Mandatory climate reporting drives need for ISO-certified environmental system leads."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Operation 300bn",
        "reason": "Manufacturing expansion ties funding to ESG, lifting but not prioritising EMS roles."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean-energy pillar needs environmental managers to meet strict UK disclosure laws."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA pours billions into clean-energy projects that need ISO-14001 and ESG compliance managers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "National Master Plan 2021-2030",
        "reason": "Offshore wind projects need EMS, yet talent pipeline is mostly local."
      }
    }
  },
  "f5576564-8707-4379-9714-957fd217f6bd": {
    "career": "Exercise Phys Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Accredited Exercise Physiologists are formally listed to combat chronic-disease burden."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Healthcare stream awards extra points; exercise science counts as allied health."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Some rehab clinics hire foreign exercise therapists, but language and licensing limit demand."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Demand exists in private rehab clinics, but Critical Skills list excludes the role."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Green List (Tier 2)",
        "reason": "Role assessed case-by-case under allied health; demand rising with ageing population."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Vision 2030",
        "reason": "Fitness centres in mega-projects hire wellness consultants, yet visas focus on hospitality."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s medical tourism market looks for sports rehab staff, but not visa-priority."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "",
        "reason": "NHS Long-Term Plan backs preventive medicine; visas processed under physiotherapy codes."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Preventive-health market is huge, but role enters via general H-1B cap, not a shortage list."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "ccc54eff-3033-4a22-8ce0-9fcad3f90a99": {
    "career": "Fashion Supply Chain Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL lists logistics managers generally; fashion sector presence limited."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Programme accepts supply-chain professionals but focuses on healthcare and tech; apparel niche keeps score modest."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Law welcomes logistics specialists, yet Germany’s fashion import hub is secondary to automotive and machinery."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Large textile sector seeks specialists to meet export and e-commerce growth targets."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "SSW covers hotel & food logistics; apparel skills transferable but not directly targeted."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan modernises manufacturing logistics; textile industry sizeable though lower-margin."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Small apparel market; demand exists only in large retail chains."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Mega-projects need retail & lifestyle supply chains; fashion import flows rising with tourism push."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Singapore Economy 2030",
        "reason": "Fashion not priority, yet Singapore’s role as regional logistics hub sustains moderate demand."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Operation 300bn",
        "reason": "Dubai is MENA fashion hub; strategy funds logistics and re-export services, raising head-count."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries include fashion, but immigration priority is for designers, not supply chain; still some openings."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Port, rail and road upgrades mildly boost demand for apparel-logistics talent but fashion not a named priority."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "National Master Plan 2021-2030",
        "reason": "Vietnam is global apparel exporter; government upgrades ports and digital customs—strong need for fashion supply-chain talent."
      }
    }
  },
  "e4d404fb-221e-4737-b1a2-7dd40efe5a27": {
    "career": "Field Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL cites environmental scientists; mining remediation and biodiversity work are high-priority."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Programme lists environmental scientists as desirable, especially climate-impact roles in Arctic and forestry."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Renewables expansion needs site assessments, but hiring favours engineers over pure researchers."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "RPJPN 2025-2045",
        "reason": "Geothermal expansion needs some field surveys; foreign researchers face permit hurdles."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List favours engineers; pure field science positions fewer but present in marine research."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP welcomes researchers but grants stricter point thresholds; language a barrier."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "MADANI Economy",
        "reason": "Rainforest conservation grants rising, yet total headcount small."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Climate and biodiversity science critical to agriculture and conservation; direct residence pathways exist."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Green Plan 2030",
        "reason": "Urban biodiversity studies funded, yet island lacks vast field sites, limiting roles."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean-energy and environmental R&D receive tax credits; universities recruit overseas researchers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act injects billions into NSF and geoscience grants; visas for STEM researchers simplified."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Environmental impact assessments required for energy projects, but local hires preferred."
      }
    }
  },
  "5e604e09-f79c-4509-bcec-f6a4a58f4db2": {
    "career": "Film Critic",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Small critic community centred on public broadcasters and festivals."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Cultural funding supports film festivals but roles limited; no fast-track visa."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Berlin hosts major festivals, yet German-language fluency essential; immigration channels generic."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Vision 2030",
        "reason": "Growing cinema sector seeks bilingual reviewers for new publications, though numbers remain small."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "English-language press exists, but critic roles few and competitive."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Dubai film festivals and English-language press create some critic gigs, but freelance basis."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "53",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries high profile but visa list favours production, not journalism; still London media hubs hire."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Large media market supplies most critic jobs; not an immigration priority but O-1 visa possible for renowned writers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "aaf9ee2a-50b0-49f4-845e-fdfb1318c7b2": {
    "career": "ICT Integrator",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Software and cyber roles cover enterprise integration; easy visa sponsorship in big cities."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Express Entry Category-Based Selection",
        "reason": "ICT occupations receive extra CRS points; chronic shortages of systems integrators in public sector modernisation."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT-spezialisten can gain EU Blue Card without degree if experienced; Industry 4.0 drives demand."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "National digital ID, health stack and EV supply chains require ICT integration."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Multinationals demand cloud and on-prem hybrid expertise; Critical Skills permit fast-tracks talent."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "Aging COBOL systems in banks need integration with AI front-ends; HSP points favour STEM."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan’s Industry 4.0 upgrades depend on systems integration across factories."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Migrant Category",
        "reason": "Government cloud migration creates steady openings though market size is small."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Smart-city and fintech projects hire integrators to stitch legacy and cloud systems."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "National AI Strategy 2.0",
        "reason": "MAS, GovTech and data-centre growth keep a healthy market though entry bar is high."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "We the UAE 2031",
        "reason": "Federal push for digital services and Operation 300bn’s manufacturing tech stack needs integration pros."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital and cyber clusters recruit integrators for NHS and defence projects, yet salary thresholds high."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds domestic semiconductor and cloud build-outs that need systems integration talent."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "National Master Plan 2021-2030",
        "reason": "E-government and fintech expansions seek integrators to connect legacy databases."
      }
    }
  },
  "af00e7d1-8462-4216-9260-bb93712fe980": {
    "career": "Investigative Psychologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Registered psychologists invited, yet crime-analysis niche small."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Clinical psychologists are priority; investigative specialism accepted within broader licence category."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Forensic psychology roles exist but language fluency and licensing hurdles lower attractiveness."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Garda bureau employs few profilers; licensing pathway available but limited openings."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Forensic units small; foreign licensing difficult."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Police occasionally hire profilers; roles tiny but recognised under psychologist licence."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Vision 2030",
        "reason": "Security sector modernising, yet prefers ex-military analysts over psychologists."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Home Team Behavioural Sciences Centre occasionally hires specialists but numbers are tiny."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Dubai Police runs behavioural analysis unit; foreign experts hired case-by-case."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Registered psychologists on shortage list; National Crime Agency employs behavioural investigators."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "FBI and police departments consult profiling experts, but no dedicated immigration pathway."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "6e67d595-3aa4-4a31-b1cf-3123254435a9": {
    "career": "Landscape Planner",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL explicitly lists Landscape Architect; major city-greening and bushfire-resilience projects need planners."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Landscape architects are on several provincial shortage lists, giving extra CRS points for architecture-related skills."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Municipalities hiring Landschaftsplaner for climate-adapted public spaces qualify for fast-track visa."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital Nusantara needs landscape input, yet immigration preference is for civil/environmental engineers."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "‘Landscape Architect’ is on Green List; direct residence pathway for park and coastal-resilience projects."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Mega-developments (NEOM, Red Sea) hire landscape teams, but civil and structural roles are prioritised above planners."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Tourism-driven city-park schemes value landscape skills, yet they sit behind architecture and infrastructure on visa lists."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Landscape architects remain on shortage list outside London, easing sponsorship."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Green infrastructure and urban-park revitalisation funds create steady but not critical demand for landscape planners."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "e9d01b06-eea4-4b86-8468-d847012199b0": {
    "career": "Maori Health Practitioner",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Aboriginal and Torres Strait Islander health programmes recognise similar skills, giving some pathway overlap."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Indigenous cultural healers valued, but no dedicated immigration stream."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "15",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "18",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Te Whatu Ora directly recruits Māori health professionals for culturally safe care and grants residence visas."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "18",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "10",
        "policy": "",
        "reason": ""
      }
    }
  },
  "475ec432-120a-45fb-aafd-466b9be9f5d4": {
    "career": "Occupational Psychologist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "‘Organisational Psychologist’ appears on medium-term skills list enabling sponsorship."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Mental-health occupations receive provincial nominations despite not being federal Tier1."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Can gain EU Blue Card under general psychologist code, yet shortage is stronger for nurses."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Registered psychologists qualify for points, but Green List excludes this sub-specialty."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Mega-project HR teams hire wellbeing experts, though visa priority sits with engineers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Companies value organisational psychologists but MOM passes remain standard, not priority."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "UAE Centennial 2071",
        "reason": "Corporate wellness trending in DIFC firms, but no dedicated shortage list entry."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "‘Occupational Psychologist’ is explicitly on shortage list; fast visa and lower salary threshold."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Demand for workplace mental-health experts growing, but not an immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "96ffda76-d5d4-4a77-a546-494cd512d1c8": {
    "career": "Photography Historian",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "Universities can sponsor, yet STEM subjects have priority."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Academia counts under PhD pathway but not shortage field."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Kunsthistorisches institutes and photo archives hire researchers and grants easy EU Blue Card."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "University sponsorship possible, yet not on Critical Skills list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "National Gallery sponsors curators but humanities not in Tier1."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Louvre Abu Dhabi and universities recruit art historians, but role not on priority list."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry R&D funds support photo-history research; Global Talent visa applies."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "",
        "reason": "US universities and museums lead photographic research, offering J-1/H-1B for scholars."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "01f1c50b-525d-46e5-96c7-8b663027a342": {
    "career": "Physiology Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "National Health and Medical Research Council funds physiology labs; visas under researcher code easy."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Biotech clusters in Toronto and Montréal nominate PhD scientists through new STEM stream."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Max Planck and university hospitals secure Blue Cards for biomedical PhDs."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Biopharma research listed but infrastructure still developing."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma and med-tech giants need physiological researchers for drug discovery."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Universities sponsor but focus leans toward biotech engineering."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan supports pharma R&D, yet engineering profiles rank higher."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Research funding limited; still eligible for points as university lecturer/researcher."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "KAUST and NEOM biotech hubs recruit, but engineers rank above basic science on priority."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Green Plan 2030",
        "reason": "A*STAR and Duke-NUS aggressively hire biomedical scientists under Tech.Pass and Global Talent routes."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Operation 300bn",
        "reason": "Dubai Science Park hires researchers; golden visa option for PhD holders."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life Sciences is core pillar; Global Talent visa fast for physiology PhDs."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA and NIH pour billions into life-science R&D, fast-tracking O-1/H-1B biomedical researchers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National Master Plan 2021-2030",
        "reason": "Government wants pharma scientists for generics sector; sponsorship possible."
      }
    }
  },
  "f691937e-1ab2-4b85-8250-d5d367de838d": {
    "career": "Public Policy Social Worker",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "State skill shortages list ‘Welfare Centre Manager’ and ‘Social Worker’; regional visas fast-track candidates."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Social workers are on the targeted occupation list; provinces actively recruit for child-protection and settlement roles."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Municipalities need qualified Sozialarbeiter for refugees and ageing population; new points system eases entry."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Social workers are NOT on the critical list; some HSE demand exists."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Skilled Migrant Category",
        "reason": "Qualified social workers can gain registration and are treated as skilled but not on Green List Tier-1."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "National AI Strategy 2.0",
        "reason": "Limited quota non-profit sector; some opportunities in social-service offices but not priority."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Social workers briefly on shortage list, but political climate tightening public-sector recruitment."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Federal funds expand community development and homelessness programmes, creating some openings but no dedicated immigration channel."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "bba5b803-05af-4076-ba4b-8e20a6fd3466": {
    "career": "Quality Control Officer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Pharma QC not on CSOL; niche demand in Melbourne biotech hub."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Some biomanufacturing clusters in Ontario/Quebec but not priority occupation."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Germany’s strong pharma sector hunts for GMP specialists; Blue Card accessible."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "World’s largest per-capita pharma exporter lists ‘Quality Control Analyst’ on Critical Skills visa."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Highly Skilled Professional visa",
        "reason": "Pharma QC valued but Japanese documentation standards and language barrier lower accessibility."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan targets pharma; investors in Penang and Johor need GMP-trained QC staff."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Growing local pharma plants in Jazan/NEOM create some QC posts, but localisation preference."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Singapore Economy 2030",
        "reason": "Biomedical manufacturing hub makes QC analysts eligible for EP fast-track and wage support."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Operation 300bn",
        "reason": "Dubai Science Park pushes biomanufacturing; QC roles exist though not on priority list."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences pillar funds manufacturing innovation catapults and demands rigorous QC talent."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds domestic pharma and biotech manufacturing; FDA cGMP demand boosts QC hiring."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "f73d9fc3-faa1-4721-a316-8f3dafc0182a": {
    "career": "Religious Education Teacher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Secondary teachers on priority lists; faith-based colleges in regional areas struggle to staff."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Express Entry Category-Based Selection",
        "reason": "K-12 teachers favoured; Catholic and Islamic school boards actively sponsor where French or rural shortages exist."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Religious instruction is run by state-church partnerships; language and doctrinal requirements limit openings."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "General secondary teachers on list; majority schools Catholic so RE ability valued."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Migrant Category",
        "reason": "Teacher shortage continues; integrated schools may sponsor but role not Green List Tier-1."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Green Plan 2030",
        "reason": "Independent schools hire expatriate RE teachers but are few; no policy alignment."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "International schools hire expatriate faith teachers, but not a strategic priority."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Teacher shortage list excludes RE after 2025; immigration still possible via academy trusts."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct link; private faith schools hire but immigration slots scarce."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "2fd5315a-028e-41ec-8038-80aa06e3906d": {
    "career": "TESOL Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Migration Strategy 2023",
        "reason": "International-education export sector funds TESOL R&D; academics get Global Talent visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Bilingualism push funds ESL research centres but not on priority list."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Universities seek English-medium instruction specialists; points system helps, but funding lags Anglo peers."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "International language colleges create some PhD posts but not a shortage occupation."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Highly Skilled Professional visa",
        "reason": "Government invests in English education ahead of Osaka Expo; universities hire TESOL PhDs."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "EdTech start-ups exist yet small scale; visas possible but competitive."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Universities internationalising English programmes; grants for applied linguistics."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "National AI Strategy 2.0",
        "reason": "NIE and EdTech firms research AI-assisted language learning; EP processed swiftly for PhDs."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "UAE Centennial 2071",
        "reason": "Federation pushes English proficiency; research roles modest in federal universities."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-education pillar funds EdTech and corpus linguistics; universities sponsor Global Talent visas."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act expands NSF funding for applied linguistics and AI language learning; universities sponsor H-1B/O-1."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "3f3819d2-04ab-4424-a589-67db5eeb9a0d": {
    "career": "Arts Administrator",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Berlin cultural sector welcomes internationals but no official shortage status."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Kansai and Kanto cultural districts accept foreign curators, albeit Japanese language needed."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Massive investment in entertainment cities needs experienced venue and festival managers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Economy 2030",
        "reason": "Esplanade and ArtSG recruit international administrators but role not on priority list."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Dubai Opera, Louvre Abu Dhabi and media free-zones hire cultural managers for global festivals."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industries pillar singles out cultural leadership; Global Talent visa fast-tracks proven arts managers."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "No direct link; cultural grants exist but immigration priority low."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4fd31a44-5712-426e-bfaa-7e06d5f21e1c": {
    "career": "Astronautical Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Migration Strategy 2023",
        "reason": "Australian Space Agency growth in launch sites and earth-observation needs aerospace skill."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Space Agency (CSA) buys foreign talent for small-sat and robotics projects."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "DLR and Airbus Defence & Space recruit non-EU propulsion and systems engineers."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Some small-sat startups supported by ESA but not large enough for Tier 1."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Highly Skilled Professional visa",
        "reason": "JAXA and private launchers under H3 rocket push actively court foreign aerospace PhDs."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan includes aerospace MRO; limited spacecraft work."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Skilled Migrant Category",
        "reason": "Rocket Lab’s presence creates niche demand but numbers small."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Kingdom funds satellite manufacture and KACST spaceport under aerospace pillar."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Economy 2030",
        "reason": "Small satellite component R&D exists but not core manufacturing priority."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Mohammed Bin Rashid Space Centre and Mars Mission require spacecraft systems talent."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 lists aerospace and satellite manufacturing as priority export sectors."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Massive NASA, DoD and commercial-space funding for launch vehicles, satellites and deep-space missions."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "21c44a2e-707d-4858-a858-e2cb7b3ba189": {
    "career": "Climate Change Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL lists environmental scientists for net-zero transition mining and energy projects."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Category now invites environmental and climate professionals directly."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Energiewende intensifies need for carbon accountants and adaptation planners."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Forestry carbon markets emerging; demand still early-stage."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Renewables build-out drives moderate demand for environmental scientists."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-city and hydrogen projects opening but language barrier remains."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "NIMP 2030 mentions carbon intensity targets, yet few dedicated immigration slots."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Climate-resilience roles on list—sea-level adaptation crucial for island nation."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "NEOM and renewables mega-projects require sustainability strategists but hiring numbers modest."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Singapore Green Plan 2030",
        "reason": "Carbon-services hub seeks analysts for mandatory disclosure rules."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "UAE Centennial 2071",
        "reason": "COP28 host invests in carbon markets and green hydrogen expertise."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Offshore wind and CCUS clusters need climate-risk analysts to unlock funding."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA injects US$370 B into decarbonisation, creating huge demand for mitigation analysts."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "National Master Plan 2021-2030",
        "reason": "Offshore wind expansion spurs some climate talent needs."
      }
    }
  },
  "7c5d3605-f2e6-4585-819c-f941638e3e37": {
    "career": "Language Specialist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Bilingual French-English translation essential for government services, giving extra CRS points."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Interpreters needed for migrant integration but quotas small."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "Foreign investment drives demand for Japanese-English technical localisation."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Vision 2030",
        "reason": "Tourism and events expansion needs Arabic-English specialists, but preference for regionals."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "National AI Strategy 2.0",
        "reason": "Regional HQs need localisation managers despite AI translation."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Dubai courts and media import high-end localisation talent for global business hub."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Shortage list intermittently includes interpreters, mostly public-sector roles."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct immigration priority; niche demand in defence and courts."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "8e7530c5-02cd-44e8-be6e-cecbc08a38ac": {
    "career": "Music Program Director",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Cultural visas exist but competitive quotas."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Berlin’s club scene attracts foreign curators under freelance artist visas."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Role outside critical list; occasional festival hiring."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Highly Skilled Professional visa",
        "reason": "J-pop industry imports niche global music curators."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Mega-projects like Riyadh Season need international music programming expertise."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Economy 2030",
        "reason": "Government funds Esplanade and music education; occasional director roles for festivals."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "We the UAE 2031",
        "reason": "Dubai Expo legacy venues and media free-zones hire directors for festivals and radio."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries listed; BBC, labels and festivals actively sponsor senior music talent."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct policy; demand driven by private radio, streaming and live venues."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "22e310ae-248c-4514-8715-3ea2ecf901db": {
    "career": "Research Nurse",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "CSOL lists mental-health and clinical-trial nurses with priority processing."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Registered nurses top immigration category; research experience rewarded in academic hospitals."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe nurse shortage; university hospitals hire for oncology and vaccine trials."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Clinical trial hubs in Cork and Dublin need RNs with pharma links."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Nursing care priority but research roles limited and language intensive."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "Growing clinical-trial sector but quotas modest."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Clinical-research nurses on Tier 1 with fast-track residency."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Medical cities aiming for global trials hire foreign RN researchers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Singapore Green Plan 2030",
        "reason": "Biomed city needs trial nurses; work-pass quotas tight."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai Science Park hospitals require GCP-certified research nurses."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "NHS trusts still sponsor nurses despite broader removal from shortage list."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds biomedical R&D; clinical trials need licensed research nurses."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "8288e554-cce6-4215-a7e3-b6decc1dff38": {
    "career": "Surgeon",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "Specialist medical practitioners on priority lists with visa concessions and regional incentives."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Physicians explicitly targeted; provinces run dedicated streams to fill specialist shortages, fast PR."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe hospital shortages; streamlined licensing and German-language upskilling support for foreign surgeons."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Consultant surgeons on Critical Skills list with fast-track employment permits."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Private hospitals hire expatriate surgeons selectively; no special immigration priority."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Specialist surgeons on Green List, offering straight-to-residence visas but limited openings."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Mega-hospital expansion in NEOM and Riyadh; attractive tax-free packages for board-certified surgeons."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "High standards and limited openings; EMP and conditional licensing possible but competitive."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Rapid private-hospital growth and medical tourism push create steady demand for specialist surgeons."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "NHS needs surgeons but new salary thresholds and immigration caps reduce attractiveness."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "High demand but no dedicated immigration fast-track; USMLE and long residency make entry tougher for IMGs."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "e04b9b63-3f8d-4bfa-82cd-9f854ebfd4cc": {
    "career": "Tourism Marketing Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Hospitality managers listed but marketing functions not prioritised, employer-sponsored only."
      },
      "canada": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "41",
        "policy": "",
        "reason": "Bali tourism boards hire foreign experts occasionally; work permits hard to secure."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Tourism push exists but immigration caps for marketing professionals remain tight."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Vision 2030",
        "reason": "Massive investment in destination branding for NEOM, Red Sea and AlUla; seeks global marketing talent."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "We the UAE 2031",
        "reason": "Dubai & Abu Dhabi tourism boards aggressively recruit experienced marketing managers for global campaigns."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Creative sector focus is more on film/gaming; tourism marketing visas possible but not priority."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Role exists but not on any immigration priority list; H-1B lottery only option."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "924e1c27-4ebe-41a6-9a22-f37b746f1581": {
    "career": "AI Data Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Migration Strategy 2023",
        "reason": "AI/ML added to Core Skills list, but quotas smaller than North America."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Dedicated AI tech visas and generous startup grants around Toronto, Montreal and Edmonton."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Blue Card fast-track for data scientists to support Industry 4.0 and automotive AI."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech and e-commerce need data science skills; visas possible but bureaucratic."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Data scientists qualify for Critical Skills permit; Dublin tech multinationals hiring."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "AI/ML engineers rated highly; point-based visa fast-tracks residency."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "NIMP 2030",
        "reason": "AI talent welcome to support semiconductor and Industry 4.0 drive."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Tech sector small; AI roles exist but not on Green List priority."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "NEOM and SDAIA aggressively recruit data scientists for smart city analytics."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "National AI Strategy 2.0",
        "reason": "Tech.Pass and COMPASS framework favour AI talent; strong R&D funding."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Operation 300bn",
        "reason": "Golden Visa available for AI specialists, strong demand in finance & gov tech."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "AI specialists on shortage list with Scale-up visa; London, Cambridge hubs."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Massive federal funding for AI talent in semiconductors and research hubs; strong H-1B STEM pathways."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Growing AI sectors in fintech and e-commerce, but salary scales lower."
      }
    }
  },
  "d69579df-991d-4cc5-a638-8738c0dc65d6": {
    "career": "AI Research Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Priority visas for AI researchers in defence and mining analytics."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "CIFAR and Vector Institute attract global PhDs with fast PR, but scale smaller than US."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Federal AI Initiative funds Max Planck & Fraunhofer, Blue Card easy for PhDs."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Research centres exist but limited senior AI research grants compared to peers."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics-oriented AI labs and generous points system for PhD holders."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "NIMP 2030",
        "reason": "Government funding for niche AI in manufacturing, but fewer deep-research roles."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "King Abdullah University and SDAIA pour money into AI basic research."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "National AI Strategy 2.0",
        "reason": "A*STAR and NTU fund frontier AI, Tech.Pass streamlines entry for PhD researchers."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Operation 300bn",
        "reason": "MBZUAI and G42 headhunt global AI scientists with tax-free packages and Golden Visas."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "AI Foundation Model Taskforce and Scale-up visa make UK a leader in academic-industry AI."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Billions into frontier AI research, generous O-1, EB-2 NIW pathways for PhDs."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4dc032a4-072e-479b-a21e-c7ab4a6c0749": {
    "career": "Consumer Insights Analyst",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "47",
        "policy": "Asta Cita",
        "reason": "E-commerce giants need insights; work permits attainable for senior experts."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Consumer analytics supports digital economy goals; some openings in KL."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Retail and entertainment giants need data-driven consumer analysts to localise offerings."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Data-driven marketing valued but role not in Tier 1; COMPASS pass possible with high salary."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "We the UAE 2031",
        "reason": "E-commerce and fintech boom creates demand for analytics talent; Golden Visa for data specialists."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Analyst roles exist but outside shortage list; employer sponsor required."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Role common but not on priority immigration lists; H-1B possible."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "fd4148ab-502f-49a9-b148-cf46a6e12282": {
    "career": "Dental Hygienist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Oral-health therapists/hygienists are on state skills lists, easing visas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Allied health occupations receive priority points and fast-track residency."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Act covers non-physician health staff; severe shortages in dental care."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Dental hygienists placed on Tier 2 Green List for direct residence pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Hospital expansion includes dental services but no dedicated immigration channel."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Green Plan 2030",
        "reason": "Foreign hygienists can be hired but not a priority occupation."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Private clinics recruit foreigners but no federal shortage listing."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Dental care professionals eligible for Skilled Worker visa, but not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "General healthcare demand exists but role not singled-out in federal talent policy."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "42d731cf-d681-4d13-9c8d-70ee3a1b949e": {
    "career": "Financial Controller",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Finance roles can qualify only through general skilled streams."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Finance professionals gain points but not a priority field."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Sovereign funds need controllers yet no formal shortage list."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "International financial services centre offers Critical Skills permits for accounting managers."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Islamic finance sector hiring but no special visa priority."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Mega-projects and sovereign funds aggressively hire senior finance controllers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Singapore Economy 2030",
        "reason": "Sustainable finance push raises demand for senior controllers; COMPASS points system favors high pay."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "UAE Centennial 2071",
        "reason": "DIFC and ADGM list finance leadership as priority; Golden Visa available."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London seeks senior finance talent despite tighter lists."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Manufacturing resurgence increases demand for plant controllers but no immigration incentives."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "bb78d66a-716d-4396-8c75-5eebdd6a8744": {
    "career": "Immunologist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Medical researchers on Skills list; government funds immunology hubs."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Biotech and health-science researchers receive dedicated work permits."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Max Planck and university hospitals face acute shortage of immunology PhDs."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Biopharma research earmarked but import of senior foreign scientists selective."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma giants in Cork and Dublin urgently hire immunology PhDs."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP targets biotech researchers with fast-track permanent residency."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "NIMP 2030",
        "reason": "Biopharma is focus, yet immigration pathways under refinement."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "List covers medical scientists broadly, but limited lab capacity."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "New biotech parks recruit immunologists, but residency pathways evolving."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Singapore Green Plan 2030",
        "reason": "A*STAR funds immunology institutes; EP processing fast for PhDs."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Operation 300bn",
        "reason": "Biotech manufacturing push seeks immunology talent for vaccine plants."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life sciences is explicit pillar; Global Talent visa streamlined."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Bill pours billions into biomedical and pandemic-preparedness R&D, fast-tracking O-1 and J-1 researchers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National Master Plan 2021-2030",
        "reason": "Biotech identified but labs still limited; visas ad-hoc."
      }
    }
  },
  "822d5397-bf97-486e-b058-03a176d2321f": {
    "career": "International Law Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Universities can sponsor but field not on core list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Academic researchers qualify via dedicated streams but not priority."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Research institutes welcome scholars; no specific short-age tag."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Universities may sponsor, yet not on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP grants points for academic papers regardless of field."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National AI Strategy 2.0",
        "reason": "NUS Centre for International Law recruits foreign PhDs; COMPASS points help."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Think-tanks in Abu Dhabi hire but no formal visa priority."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Global Talent visa supports humanities researchers at Russell Group universities."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "CHIPS and Science Act",
        "reason": "Universities funded for geopolitical research, easing J-1 visas."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "bbac8cf6-5dc2-4d52-aa13-21d254772a49": {
    "career": "IT Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Migration Strategy 2023",
        "reason": "Global Talent visa targets digital researchers but caps are lower."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Special immigration streams for AI and software researchers with fast PR."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "IT specialists receive priority cards; Fraunhofer institutes hiring."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "IT research demand growing but bureaucracy heavier."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "AI/ML researchers explicitly listed; generous R&D tax credits."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP prioritises AI, robotics, and semiconductor researchers."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "NIMP 2030",
        "reason": "Plan emphasises Industry 4.0 R&D and semiconductor design."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Software engineers on list; pure R&D roles fewer."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "NEOM and SDAIA invest billions into AI research centres."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "National AI Strategy 2.0",
        "reason": "Nation positions itself as global AI lab, offers EP exemption for top researchers."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Operation 300bn",
        "reason": "Dubai and Abu Dhabi sponsor AI research labs; Golden Visa available."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital/AI is core pillar; Global Talent visa cheap and fast."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Massive funding for AI, quantum, and semiconductor R&D fuels demand for IT researchers."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Government funds AI and chip design research centres; foreign experts welcomed."
      }
    }
  },
  "322f82d6-2523-4688-bc53-29a66c0841b9": {
    "career": "Marketing Communications Manager",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Massive tourism and entertainment push needs senior marketing talent, but locals preferred."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "We the UAE 2031",
        "reason": "Government promotes creative-media hubs; experienced MarCom managers qualify for Golden Visa."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry leadership cited, but competition high and no visa shortage code."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Private-sector demand is huge, but no federal immigration priority lists include generic marketing roles."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "6e186618-9438-4f8c-b15c-348e92945bb8": {
    "career": "Middle School Teacher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Secondary STEM and language teachers appear on CSOL with fast-track visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Teachers are on provincial shortage lists and receive extra CRS points."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe shortage of STEM teachers; new Blue-Card-light rules ease entry."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Some rural shortages, but not on Critical Skills list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Both primary and secondary teachers receive straight-to-residence visas."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Local shortages exist, but federal immigration policy does not prioritise K-12 teachers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "c5db9f45-074e-4751-bc79-d462d6bebcb2": {
    "career": "Network Security Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "Cyber professionals placed on Core Skills list with four-year visas leading to PR."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Cybersecurity explicitly fast-tracked with new work-permit stream and 2-week visa processing."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialists can migrate without degree if experience proven; cyber shortages acute."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Digital-economy roadmap highlights cybersecurity; expatriate hires still face quota paperwork."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Cybersecurity professionals qualify for Critical Skills Permit and immediate family visas."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Highly Skilled Professional visa",
        "reason": "Points-based HSP fast-tracks cyber and AI engineers."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan emphasises Industry 4.0 security; MSC companies eagerly sponsor visas."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Allows points for cybersecurity, but not on Green List yet."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Banks and NEOM rely on imported cyber talent while locals upskill."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "National AI Strategy 2.0",
        "reason": "Cybersecurity specialists earn extra COMPASS points and are on Tech@SG pass list."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "We the UAE 2031",
        "reason": "Golden Visa available for experienced cyber experts securing finance and energy infrastructure."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Cybersecurity listed in IS-8; Shortage Occupation Code eases salary thresholds."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Huge market demand and DHS funding, but not named in recent industrial acts."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Push for secure chip design expands cyber-talent demand, though visas less streamlined."
      }
    }
  },
  "24f6f8c4-1795-455e-a5c7-a73004d594c7": {
    "career": "Political Research Associate",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Academic roles possible, but occupation not on Core Skills list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Open to researchers via regular Express Entry, yet no targeted stream."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Opportunity Card awards points for social-science PhDs seeking research posts."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Universities can sponsor via General Employment Permit; no fast-track list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Universities sponsor humanities researchers under Professor/Researcher visa."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Only university sponsorship routes; no immigration priority."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Policy analysis jobs largely nationalised and sensitive."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Some international research centres, but EP points favour STEM."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Regional think tanks hire expats but visas processed as generic researchers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Global Talent visa covers social-science researchers attached to universities."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Think tanks and campaigns hire, but not covered by federal skills programs."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "7a3ab33a-5f61-4251-9c7b-474f701a69b8": {
    "career": "Radiation Physicist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Scientific researchers sponsored by universities under standard skilled visas."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Research scientists can gain PR via high CRS scores but no specific stream."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Blue-Card exemption for PhD holders in STEM research; DESY and ESA projects."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Few large-scale physics facilities; funding limited."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "JAXA and KEK recruit foreign radiation physicists; HSP visa fast-tracks."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Nuclear science mostly regulatory, not active research scale."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Small research ecosystem; limited dedicated roles."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "King Abdulaziz City for Science hires foreign physicists for space radiation studies."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "A*STAR funds some radiation oncology research but not immigration priority."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "UAE Centennial 2071",
        "reason": "Mohammed Bin Rashid Space Centre recruits radiation experts for Mars mission."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Nuclear and space sectors on IS-8; Global Talent visa supports physicists."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act boosts funding for space and high-energy physics research, easing visas for PhD researchers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "869f6e18-b062-4cc6-ab86-3307397a532b": {
    "career": "Sound Designer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Growing post-production hubs in Sydney; not on Core Skills list so sponsorship harder but possible for experienced talent."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Toronto-Vancouver film/TV tax credits create steady demand; federal immigration fast-tracks French or STEM-adjacent creatives."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Berlin advertising and gaming scenes hire international audio specialists; Blue Card possible but no priority status."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Niche animation and game studios in Dublin; outside Critical Skills list so visa options limited."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Huge investment in entertainment districts (NEOM, Qiddiya) needs live-event and theme-park sound design."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Some AAA game audio roles, but outside National AI/Manufacturing focus; EP possible for seniors only."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "We the UAE 2031",
        "reason": "Dubai Media City attracts regional TV, advertising and esports that hire audio leads under creative-industry visa."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "London film, West-End theatre and gaming audio are part of ‘creative industries’ pillar within IS-8; Global Talent visa available."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "",
        "reason": "Hollywood, AAA gaming and streaming audio jobs cluster in LA, NYC and Seattle; O-1B visa routinely used for exceptional audio talent."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "8e0e8b3d-0dbc-4d04-90ff-10e9c3e71907": {
    "career": "Sustainability Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL lists civil/electrical engineers for renewable mega-projects (offshore wind, green hydrogen) seeking skilled migrants."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Net-zero pledge plus clean-tech tax credits; category-based Express Entry prioritises STEM energy roles."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Energiewende accelerates recruitment of renewable-energy and carbon-reduction engineers; Blue Card streamlined."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Push for geothermal and EV battery plants needs sustainability talent, but Bahasa and local licensing hurdles."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Onshore & offshore wind expansion puts environmental engineers on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Government funds green ammonia and hydrogen pilots; HSP points for environmental engineering PhDs."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "NIMP 2030",
        "reason": "Plan includes renewable energy and decarbonisation; still early-stage so demand moderate."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Offshore wind and geothermal engineers are on Green List for direct residency."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "NEOM targets 100 % renewables and green hydrogen; foreign sustainability experts in high demand."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Green Plan 2030",
        "reason": "Carbon-management and green-building engineers qualify for COMPASS bonus criteria."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Operation 300bn",
        "reason": "Masdar and ADNOC aim for net-zero; engineers in solar, CCS and energy efficiency receive Golden Visa."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 prioritises offshore wind, nuclear, CCUS and hydrogen, creating shortage-list opportunities for sustainability engineers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA pours USD 369 B into renewables, hydrogen and carbon capture, driving acute demand for engineers who can decarbonise plants and grids."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "National Master Plan 2021-2030",
        "reason": "Offshore wind and LNG transition create openings but wages lower."
      }
    }
  },
  "c53e0108-6a3e-47a6-9adf-083d887e4138": {
    "career": "Archaeological Consultant",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Many infrastructure digs in Bavaria/NRW; Blue Card possible but German fluency critical."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "AlUla and Diriyah giga-projects pour billions into heritage excavations, hiring international archaeologists."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Museum of the Future and heritage sites commission consultants though volumes limited."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "HS2 rail and large housing projects require archaeological mitigation; Skilled Worker visa possible but not shortage-listed."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Federal law (Section 106) requires cultural-resource assessments on infrastructure projects, but role not immigration-prioritised."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "5280bd66-1090-4e76-abf8-2532bf76a1c4": {
    "career": "Athletic Administrator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Strong sports culture yet roles usually fill locally; employer sponsorship possible for experts."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "University and minor-league sports create modest openings but no immigration priority."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Massive investment in football, F1, e-sports and sports cities needs experienced administrators for leagues, venues and academies."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Singapore Sports Hub and F1 host events; foreign admins hired case-by-case, no priority."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai Sports Council and Abu Dhabi entertainment hubs recruit global sports-management professionals; long-term cultural-visa available."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Premier League clubs hire few foreigners for admin; Skilled Worker visa possible only with high salary."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "",
        "reason": "NCAA Division I athletics are a multi-billion dollar industry hiring foreign sports-biz talent via H-1B in limited numbers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4a5622bf-6e05-4ffb-a683-c53fbee9f944": {
    "career": "Biomedical Instrumentation Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Med-tech engineers qualify under ‘engineering professionals’ priority with pathways to PR."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Ontario and Quebec med-tech clusters woo biomedical engineers through STEM Express Entry draws."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Baden-Württemberg medical-device corridor hires international instrumentation engineers; Blue Card streamlined."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Galway-Cork med-device hub (Medtronic, Stryker) hires instrumentation engineers with Critical Skills permit."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "Aging population drives demand for medical devices; English-led R&D units obtain HSP visas."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "NIMP 2030",
        "reason": "Plan lists medical devices and advanced materials as growth sectors with investment incentives."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Some med-device R&D in Auckland; not yet on Green List but engineering skill shortages offer visa points."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "Smart-hospital build-outs need device commissioning engineers though localisation policy increases competition."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Economy 2030",
        "reason": "Tu-as and One-North house global med-tech giants; biomedical engineers qualify for Tech.Pass and COMPASS boosts."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Dubai Healthcare City hosts device makers and hospitals adopting robotics; Golden Visa for specialised engineers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences pillar funds med-tech innovation; device engineers on shortage list."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA expands domestic medical-device manufacturing tax credits; FDA fast-track devices need engineers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Emerging med-device assembly but limited high-end R&D."
      }
    }
  },
  "3fba233f-b266-44a0-8fa7-7ce550295a25": {
    "career": "Corporate Counsel",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Corporate solicitors are eligible for general skilled visas yet absent from Core Skills Occupation List, making them a lower priority."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Legal occupations are admissible under Express Entry but not prioritised; demand exists mainly in multinational HQs."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Non-EU lawyers face language and re-qualification barriers; only global corporations seek English-speaking in-house counsel."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Tech multinationals in Dublin have modest need, but profession not on critical list; must pass Law Society exams."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Mega-projects need compliance and contract specialists, but Saudisation means limited foreign lawyer slots."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "Regional HQs need counsel, but Singapore is tightening passes for generic corporate roles."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Dubai International Financial Centre courts follow common law, driving steady demand for experienced corporate counsel."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Global HQs in London value in-house counsel, yet role is not on Shortage List and requires Solicitors Regulation Authority admission."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Large tech and manufacturing firms growing under CHIPS/IRA still need in-house lawyers, but no official shortage list and state bar admission is mandatory."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "c6c93430-b2ba-4005-b6b0-08721d908976": {
    "career": "Data Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "IT roles including data governance receive points, though not on the core shortage list."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "AI and data occupations are explicitly targeted under updated talent streams."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Industry 4.0 pushes companies to hire data specialists; Blue Card pathway available."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "E-commerce and fintech growth require skilled data managers, but visa pathways remain generic."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "While list names data scientists, most multinationals in Dublin staff data management teams locally."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "Digital-transformation push offers fast-track visas for data governance experts."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "MADANI Economy",
        "reason": "NIMP 2030’s Industry 4.0 goals include enterprise data architecture, boosting demand."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Migrant Category",
        "reason": "Digital roles get points, but only software engineers are on the Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Vision 2030",
        "reason": "Smart-city and fintech projects require centralised data governance to meet regulatory goals."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "National AI Strategy 2.0",
        "reason": "Financial-grade data governance is core to Singapore’s push for trusted AI."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "UAE Centennial 2071",
        "reason": "Financial services and government open data initiatives drive steady hiring of data managers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 highlights digital and AI roles; data stewardship is implicitly covered."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "CHIPS and Science Act",
        "reason": "Massive federal funding for semiconductor and AI research elevates demand for robust data governance in labs and factories."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Chip manufacturing expansion needs strict data controls for IP and yield analytics."
      }
    }
  },
  "6fd5705f-4c79-423e-ae2e-bb0b96dc2034": {
    "career": "Industrial Systems Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Industrial and production engineers listed on CSOL with fast-track visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Manufacturing roles get CRS points but are not singled out as shortage."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Automotive and machinery giants face ageing workforce, pushing urgent demand for industrial systems engineers."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "RPJPN 2025-2045",
        "reason": "EV battery and mineral processing plants require lean and safety expertise."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Med-tech and pharma plants in Cork/Limerick continually hire industrial engineers."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Highly Skilled Professional visa",
        "reason": "Factory modernisation and robotics champions seek systems-level engineers."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan names industrial automation and semiconductor back-end as key, creating direct demand."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Manufacturing sector small; points available but no Green List priority."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Gigaprojects and new industrial cities need experts in plant layout and lean operations."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Manufacturing 2030",
        "reason": "Precision-engineering sector demands engineers who can integrate IoT and robotics on shop floors."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Operation 300bn",
        "reason": "Ambition to grow advanced manufacturing GDP share calls for industrial engineering talent."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 highlights advanced manufacturing, especially aerospace and EV batteries."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Reshoring fabs and advanced manufacturing plants require industrial engineers to optimise throughput and automation."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "National Master Plan 2021-2030",
        "reason": "Electronics manufacturing boom needs process-optimisation specialists."
      }
    }
  },
  "670cb1d6-9755-4a54-8831-fb8f25baf802": {
    "career": "Procurement Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Supply-chain managers are eligible for general visas but absent from core list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Role gains CRS points yet is not singled out for category-based invitations."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Manufacturers hire foreign procurement talent; however, it is not a priority occupation."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "RPJPN 2025-2045",
        "reason": "EV supply-chain build-out needs procurement skills, but protectionist rules curb foreign hiring."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Pharma and tech plants recruit procurement staff, yet no critical-skills incentive."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Growth in aerospace and electronics increases sourcing needs, but locals usually fill roles."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Mega-projects depend on strategic sourcing and contract negotiators familiar with global supply markets."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Economy 2030",
        "reason": "Regional HQs require strategic sourcing, though the role competes with resident talent under tightened work-pass quotas."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "UAE Centennial 2071",
        "reason": "Logistics and free-zone expansions create steady demand for procurement experts with ERP skills."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Role eligible under general Skilled Worker visa but not shortage listed."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Hundreds of federally funded projects create contract-administration roles, but no official shortage designation."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Export-oriented factories hire buyers, yet preference for Vietnamese speakers keeps demand secondary."
      }
    }
  },
  "de362441-b94f-43e9-8656-5c1e044ed87a": {
    "career": "Public Health Physician",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Medical Officers (Public Health) are on CSOL with immediate visa sponsorship and rural incentives."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Physicians are priority; provinces run dedicated public-health recruitment streams with fast permanent residency."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Ageing population and pandemic lessons drive urgent recruitment of preventive-medicine doctors."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Asta Cita",
        "reason": "Health-security goals create few foreign consultant slots; licensing remains difficult."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Medical practitioners on list; Public Health reform post-COVID increasing headcount."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Foreign physicians face licensing and language hurdles, though academia offers limited research roles."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Ministry recruits some expatriate physicians for dengue and NCD projects, but supply is mostly local."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Public-health medicine specialists get fast-track residency and relocation grants."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Vision 2030",
        "reason": "Health-sector expansion needs epidemiologists to manage chronic-disease and Hajj-related risks."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Green Plan 2030",
        "reason": "Preventive-health push exists but physician roles mostly filled by regionally trained doctors already holding local license."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Government invests in preventive health analytics, attracting foreign physicians."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "NHS hires public-health consultants but post-Brexit visas require standard points; role not on new shortage list."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Chronic shortage in rural health departments, yet no federal shortage list for immigration."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "International NGOs hire, yet public system prioritises local graduates."
      }
    }
  },
  "8d089365-9be0-4258-b023-602b97aed9df": {
    "career": "Sports Coach",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Strong sports culture; some state visas accept certified coaches, but not on Core list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Occasional provincial picks for high-performance coaching, yet not a named national shortage."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Demand within rugby/cricket academies but absent from Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Hefty investment in pro leagues and community sport to diversify economy."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "We the UAE 2031",
        "reason": "Sports academies and mega-events need coaching talent, yet no dedicated visa lane."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Club hiring possible; not on Skilled Worker shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Big professional & college sports market, but coaching not on any federal skills list."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "1c727897-d161-4c94-937f-e8683d05b08d": {
    "career": "Animation Instructor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "TAFEs and private colleges seek instructors, but not on CSOL."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Vancouver and Toronto animation hubs recruit faculty for skills transfer."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Anime academies accept foreign instructors under humanities visa, but not priority."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Weta-linked schools occasionally sponsor, yet not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Growing entertainment sector funds digital-arts academies needing trainers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Singapore Economy 2030",
        "reason": "Media industry respected; education roles possible but not top-tier demand."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Dubai media zones license creative schools that import faculty."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry skills gap; colleges can sponsor Tier-2 visas for niche tutors."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Art schools hire overseas experts; O-1 visas possible for distinguished creatives."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "34937ef1-972c-4861-a0b5-c510cf45034d": {
    "career": "Business Research Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Skilled visas possible under ‘Management Consultant’, yet not on Core list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Not a named occupation, but fits ‘Business & Finance’ NOC paths."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Points for degree and experience; no shortage listing."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Large tech HQs need insight analysts but role not critical-skills rated."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Highly Skilled Professional visa",
        "reason": "Eligible under business/finance category; language often barrier."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "KL fintech cluster hires analysts for Islamic finance projects."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Vision 2030",
        "reason": "Economic-diversification projects need analysts but prefer bilingual Arabic talent."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "National AI Strategy 2.0",
        "reason": "Financial and tech HQs recruit analytics talent; COMPASS pass points apply."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "UAE Centennial 2071",
        "reason": "Financial services and sovereign funds aggressively hire analysts."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London firms sponsor analysts in finance, consulting and tech."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Consulting firms and PE funds sponsor STEM-designated analytics roles."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "eb99bb45-1d33-4b5a-aa67-fdba532aeed9": {
    "career": "Clinical Occupational Therapist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "Occupational Therapists appear on Core Skills Occupation List."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Named shortage occupation; fast-track licences in multiple provinces."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe rehab staff shortage; recognition pathway streamlined."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Listed as critical skill allowing fast work permit."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Licensure possible but strict language exam limits uptake."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Private hospitals import some OTs; no national shortage scheme."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "OTs on Green List with direct residence path."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "New hospitals hire allied health, but language & licensing hurdles."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Hospitals hire OTs on Employment Pass but not priority list."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "Growth in rehab centres; DHA/HAAD licence required."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "",
        "reason": "NHS actively recruits, although role dropped from official shortage list in 2025."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Aging population drives OT demand; H-1B Health Care CAP exemptions possible."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "9a3348a6-c89b-4db7-ada7-efec001574da": {
    "career": "Clinical Trials Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Cancer Cooperative Trials Groups actively sponsor trial managers."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Emerging bio-clusters in Toronto & Montreal need trial leadership."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Pharma corridor in NRW sponsors experienced trial staff under blue card."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Biopharma listed as growth area; trial governance early stage."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Multinational pharma plants and CROs get fast permits for trial leads."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points favour advanced biotech researchers; English-language oncology trials growing."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan calls for boosted pharma R&D with foreign talent."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Limited number of Phase-III trials; few visas issued."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "New research hospitals opening, yet regulatory ecosystem still maturing."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Economy 2030",
        "reason": "Biomedicine is a pillar; A*STAR & hospitals need trial managers."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "We the UAE 2031",
        "reason": "Dubai Science Park and ADGM biotech zones recruit trial operations talent."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences super-cluster around Oxford-Cambridge demands senior trial managers."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds biomanufacturing hubs that run large oncology trials."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National Master Plan 2021-2030",
        "reason": "Government courting CROs, but scale still small."
      }
    }
  },
  "bbdf6061-61b9-4a02-9a7d-01007463be77": {
    "career": "Installation Specialist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Cultural-worker streams exist, yet Installation Specialists are absent from Express Entry priority lists."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Entertainment mega-projects (NEOM, Qiddiya) need experienced live-show rigging and installation talent."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "UAE Centennial 2071",
        "reason": "Rapid growth of concerts/theme parks in Dubai & Abu Dhabi demands stage installation experts."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry support covers theatre technicians, but no specific shortage concessions."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Culture visas (O-1, P-3) cover stage technicians but no federal talent policy prioritises performing-arts installation specialists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "f31f33e3-000a-4170-8729-2c7bedca6e1a": {
    "career": "Interdisciplinary Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Universities sponsor visas, but field not on CSOL priority list."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Strategy funds global researchers; humanities scholars can access dedicated academic work permits."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Act facilitates academic hires broadly; Asian-Studies roles depend on university demand."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Academic Critical-Skills path is STEM-heavy; humanities posts require direct sponsorship."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "Universities may sponsor Asian-Studies researchers; fast-track points for PhDs."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "University-sponsored visas available although subject not on Green List."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Universities/think-tanks (e.g., RSIS) value regional scholarship, yet not a national shortage."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "We the UAE 2031",
        "reason": "Branch campuses hire humanities faculty, yet field is niche."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Universities retain global talent routes even though humanities off shortage list."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Universities value Indo-Pacific expertise; H-1B research exemptions ease hiring even though not in major Acts."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "9e3e6810-6a9e-49a2-b04e-3c50d18e1565": {
    "career": "Mechanical Systems Designer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Mechanical engineers explicitly listed for priority visas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Mechanical engineers enjoy fast-track PR and dedicated draws."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Automotive and machinery sectors face severe mechanical-engineering shortages."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV battery and infrastructure projects recruit mechanical engineers."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Mechanical engineers qualify for Critical-Skills Employment Permits."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Highly Skilled Professional visa",
        "reason": "Mechanical and robotics engineers earn maximum points for fast residency."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Aerospace and EV sectors need mechanical system designers."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Engineering shortages include mechanical specialisations under general engineering category."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Giga-projects and new manufacturing clusters require system-design engineers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Manufacturing 2030",
        "reason": "Precision-engineering and robotics clusters value mechanical system designers."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing push generates some demand, though not formally prioritised."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "EV, aerospace and defence programmes list mechanical design as critical skill."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Huge investment in advanced manufacturing, EVs and infrastructure causes acute need for mechanical design talent."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National Master Plan 2021-2030",
        "reason": "Electronics and transport infrastructure expansion drives mechanical design demand."
      }
    }
  },
  "ce8377ed-bd72-4019-9801-62d895196687": {
    "career": "Outreach Specialist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "General skilled-worker routes possible, but category-based draws exclude outreach work."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Permits available via general employment routes, but no Critical-Skills support."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Think-tanks (e.g., RSIS) hire outreach staff, but role not in national shortage lists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Government agencies hire outreach pros, but Emiratisation limits foreign intake."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Think-tanks and NGOs employ outreach staff; role not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Public-affairs roles thrive, yet no immigration priority exists for communications specialists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "cc2c8cd5-7ce7-4525-81a8-09965d023638": {
    "career": "Performance Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Strong national focus on elite sports drives steady demand despite lack of formal listing."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "General skilled-worker pathway available; role not on priority lists."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Bundesliga clubs hire analysts, but immigration policy focuses elsewhere."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Critical Skills List focuses on STEM, not sports science."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "J-League clubs use analysts; immigration routes nonspecialised."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "High-Performance Sport NZ seeks exercise physiologists, though not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Big investment in hosting top sports events fuels need for performance staff."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Singapore Sport Institute employs analysts but occupation not on priority list."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "We the UAE 2031",
        "reason": "Pro clubs and academies in Dubai Sports City recruit sports scientists."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Premier League values analysts, but role not classed as shortage occupation."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Elite sports franchises employ analysts, yet no federal talent policy covers the role."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b2fbec63-7a57-4304-9cbc-bf025ee2e31f": {
    "career": "Physician",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Migration Strategy 2023",
        "reason": "GPs and specialists top the Core Skills Occupation List; visas processed ahead of general queue."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Physicians are explicitly targeted for priority permanent residency and provincial nomination streams."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe hospital shortages; simplified license recognition and Opportunity Card points for doctors."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Doctors qualify for Critical Skills permit with fast permanent residence route."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Regional hospitals court foreign doctors but licensing translation hurdles keep demand moderate."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Private hospitals recruit expatriate specialists yet no dedicated immigration priority."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Doctors on Green List receive immediate residence pathway and employers are actively recruiting abroad."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Massive hospital expansion requires foreign physicians; premium salaries and fast work visas."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Selective listing of certain specialties; quotas and strict exams keep numbers limited."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "We the UAE 2031",
        "reason": "Healthcare specialists enjoy Golden Visa eligibility but competition from regional talent keeps it secondary."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "NHS still hires internationally, yet doctors removed from official shortage list after 2025."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Persistent doctor shortages in rural/primary care, but no federal fast-track visa category."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "36a5a5bd-1553-4045-8733-c1a306b5bd15": {
    "career": "Property Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Stable need in cities; not on Core Skills list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Growth in multi-family housing yet occupation not on priority lists."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "New capital Nusantara will require large-scale property management expertise."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "41",
        "policy": "",
        "reason": "Commercial park developments need managers but immigration pathways generic."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Tourism rentals create roles but no Green-List recognition."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Mega-projects like NEOM and Red Sea require experienced property managers at scale."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "We the UAE 2031",
        "reason": "Rapid real-estate expansion and foreign investor focus create robust demand."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Build-to-rent boom in London but no official skills priority."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Large rental market sustains demand but no specific immigration channel."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Rapid urbanisation raises demand, yet employer-sponsored visas only."
      }
    }
  },
  "d7a18980-17cc-420f-b839-6d3f8cb9717f": {
    "career": "Publicist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Tourism push for Bali and new capital creates limited PR demand."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Tech multinationals in Dublin hire PR staff, but no skills-list priority."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "KL’s growing media scene needs English-speaking publicists yet visas handled case-by-case."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Tourism and giga-projects require global PR talent for reputation building."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s media free zones host many agencies needing international publicists."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industries growth includes senior communications roles; visa routes via Creative Worker scheme."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Hollywood, tech and political sectors fuel demand though not an immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "ab6c9ad8-d356-4524-93e0-50808993c1e1": {
    "career": "Real Estate Developer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Urban expansion continues, but migrants usually enter through construction engineering roles."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Housing demand high, yet occupation absent from skills lists."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Strict local regulations and language lower foreign developer demand."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "New capital city and infrastructure spree need seasoned developers."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Housing crisis, yet visas focus on construction engineers not developers."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Iskandar and Bandar Malaysia projects open opportunities; immigration handled case-by-case."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Housing crunch exists yet immigration targets construction trades more than developers."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Vision 2030",
        "reason": "Giga-projects need international talent in land acquisition, finance and mega-build execution."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Land-scarce but REIT hub hires development analysts; foreign quota tight."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi push large-scale mixed-use developments; Golden Visa supports senior professionals."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Demand exists, but no immigration priority; stringent planning laws."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Infrastructure spending boosts projects but no developer-specific visa priority."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Rapid urbanisation but local partnerships mandatory."
      }
    }
  },
  "65a84796-92f0-4ac4-84fe-42b5a7fc87f3": {
    "career": "Sculpture Instructor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Some demand in art colleges but outside Core Skills list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Cultural funding supports roles yet immigration priority low."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Strong art scene, yet positions scarce and German fluency expected."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Small number of art-college posts; no skills-list inclusion."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Creative-industry visas possible for notable artists; few stable jobs."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Art schools and community colleges hire, but visas via O-1 talent not shortage lists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "cf9a901f-c6e6-40ba-b9f5-0463972658fa": {
    "career": "Social Enterprise Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Regional-startup visas welcome impact founders, yet role is not on Core Skills list, so only moderate alignment."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Programme highlights purpose-driven entrepreneurship to retain global talent in smaller provinces; no dedicated visa stream but favourable ecosystem."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Ease of entry for startup founders, but social enterprise not explicitly prioritised over tech or engineering."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Push for inclusive growth in villages funds B-corps; experienced managers valued but not on priority engineer lists."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Government impact funds (MySDGs) seek social-enterprise leadership but immigration preference still lies with engineers."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Government funds CSR and non-profit spin-offs in tourism and culture, opening niche demand for experienced impact managers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Singapore Economy 2030",
        "reason": "raiSE grant schemes, Impact Hub and attractive EntrePass make Singapore Southeast Asia’s main social-enterprise hub despite no formal shortage list."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s ‘CSR Mandatory’ law and Abu Dhabi’s social-investment funds create some openings, though visas still favour tech specialists."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "‘Inclusive Economy’ pillar funds social-impact incubators, but no shortage-list advantage; standard Skilled Worker visa applies."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Community-scale clean-energy and climate-justice grants create space for mission-driven businesses needing managers with both commercial and social-impact skills."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "National Master Plan 2021-2030",
        "reason": "Legal recognition of social enterprises encourages hiring, yet foreign managers obtain only general work permits."
      }
    }
  },
  "2886e10d-399c-4f9f-988c-a803aeaae01a": {
    "career": "Sport Operations Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Major event pipeline (Brisbane 2032 Olympics) increases demand, but managers must compete under general visas."
      },
      "canada": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Bid for future Olympics and FIFA events spurs demand for experienced venue managers."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "Post-Tokyo 2020 venues pivot to entertainment events, importing some bilingual operations managers."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Massive investment in football, golf and mega-events (NEOM Games) has created acute need for international operations talent."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Singapore Economy 2030",
        "reason": "Sports Hub and Formula 1 race keep steady but small stream of Employment Passes for event-ops specialists."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi host F1, IPL, UFC; Golden Visa targets sports professionals and managers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Sport sector part of creative-economy priority; yet Skilled Worker visa salary thresholds still apply."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Stadium modernisations open operations roles, yet no immigration priority compared with STEM."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "e907b40a-d638-4e62-8c86-fdfd811eacf9": {
    "career": "Advanced Materials Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Lists materials engineers for clean-energy and defence projects."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Fast-track visas for semiconductor and battery R&D, strong university-industry labs."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Fraunhofer and auto giants chase materials PhDs for lightweight and battery tech."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "59",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel-based battery materials R&D gaining traction around EV boom."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Med-tech polymers and semiconductor packaging research create some demand for materials scientists."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics and EV battery giants recruit foreign PhDs in ceramics and carbon composites."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Aims to become advanced-materials hub for semiconductors and aerospace."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "NEOM and KAUST pump funds into nanomaterials and desalination membranes, offering tax-free labs."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Manufacturing 2030",
        "reason": "A*STAR funds nanomaterials for med-tech and chips; five-year pass for top scientists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Operation 300bn",
        "reason": "Looking to localise aerospace and additive-manufacturing materials; niche openings."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Catapult centres and defence supply chain list advanced materials as strategic technology."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Massive federal funding for semiconductor, quantum and next-gen materials places researchers on top of hiring lists."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Needs packaging and substrate materials experts but funding still early-stage."
      }
    }
  },
  "942e9731-8cce-462a-aaf3-cfd883a33852": {
    "career": "Aquaculture Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Tasmania’s salmon industry faces skill shortages; listed under agricultural scientists."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Atlantic provinces need fish-farm managers, but competition with domestic graduates."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Largest global producer of seaweed and shrimp upgrading to sustainable systems; skilled specialists fast-tracked."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Shellfish and seaweed sector seeks marine scientists though not headline skill."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Fisheries listed in SSW; automation pilots need specialists to boost yields."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "King-salmon and mussel expansion places aquaculture managers on Tier 1; straight-to-residence visa available."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Red Sea fish-farming projects need expertise but climate challenges persist."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Singapore Green Plan 2030",
        "reason": "30x30 food-security goal allocates funds for offshore fish farms, but market size small."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Scottish salmon farms face labour shortages, offering sponsored visas."
      },
      "united_states": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "vietnam": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "National Master Plan 2021-2030",
        "reason": "Vietnam aims to double high-tech shrimp and pangasius output; urgent demand for biosecurity and feed experts."
      }
    }
  },
  "78ffefbd-32c3-406f-9970-7c9e8a489875": {
    "career": "Content Creator",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Bali digital-nomad visa allows content producers; tourism boards pay for campaigns."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "Malaysia Digital Nomad Pass opens door but small brand budgets."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Entertainment push funds influencer campaigns for tourism megaprojects."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Singapore Economy 2030",
        "reason": "Tech-media hub with gig licences available but high living costs keep scale limited."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Free-zone content-creator licence and 10-year Cultural Golden Visa make Dubai regional hub."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industries visa supports digital content; London is Europe’s influencer HQ."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "No federal talent visa, yet huge creator economy platforms and brand budgets attract freelancers on O-1 visas."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "e2fefba4-fbdb-40d9-bd8f-eac1e8af108b": {
    "career": "Environmental Economist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Migration Strategy 2023",
        "reason": "Green-energy transition needs cost-benefit studies, but economists are not on core skills list."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Federal climate plan and carbon pricing create steady demand for specialists who can quantify environmental externalities."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Energiewende and EU taxonomy drive hiring of environmental cost analysts within industry and government."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Sustainability roles exist in large tech/pharma but not explicitly listed."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Environmental finance grows slowly; roles available but not prioritised."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Small but growing need for carbon-pricing and biodiversity valuation in forestry and fisheries."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Mega-projects seek sustainability economists to balance tourism revenue with environmental impact."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Green Plan 2030",
        "reason": "Nationwide carbon tax and sustainable-finance hub require specialists in environmental cost-benefit analysis."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "Net-zero pledge spurs demand for carbon-market and green-finance modelling."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean-energy clusters and mandatory climate disclosures need economists who can price externalities and guide policy."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Climate-related tax incentives and carbon-pricing analysis require economists to model environmental costs and advise agencies."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "11a22329-bdce-4a47-848d-63f2f9bbcee2": {
    "career": "FinTech Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Growing open-banking market yet outside core skills list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "FinTech hubs in Toronto and Vancouver hire, but not an explicit immigration priority."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Frankfurt’s fintech scene recruits specialists, but visa lists favour engineers."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Massive e-wallet adoption, yet visas prioritise engineers over consultants."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Dublin hosts European HQs of many fintechs; consultants fall under ICT vacancy categories."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Highly Skilled Professional visa",
        "reason": "Cashless push exists but language barrier narrows entry for consultants."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Islamic fintech growth; still secondary to semiconductor drive."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Rapid expansion of cashless economy and digital banking needs advisory talent."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "National AI Strategy 2.0",
        "reason": "Regional fintech capital offers FinTech fast-track Employment Pass for experienced consultants."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai and Abu Dhabi free zones push to be global fintech hubs; consultants qualify for Golden Visa."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London’s open-banking and digital-asset rulemaking drive strong demand for fintech advisory roles."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds digital finance R&D; consultants guide banks integrating real-time payments and AI risk tools."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "dce0d91c-cd68-4fa5-9149-b54f6ee0c688": {
    "career": "Freelance Illustrator",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Cultural industries stream supports experienced illustrators, but small quota."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on critical list; limited animation studios hire overseas."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Manga/anime demand exists but language barrier and corporate hiring over freelance."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Entertainment clusters hire concept artists for gaming and theme parks, but few freelance visas."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Economy 2030",
        "reason": "Limited demand—only niche advertising and gaming studios sponsor."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s Media City issues freelancer permits for illustrators serving ad agencies."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry high value; Global Talent visa open to recognised illustrators."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Creative visas (O-1) exist but not prioritised; demand in entertainment sector rather than policy."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "080a1c3a-d6ba-4112-8552-504fa2936f57": {
    "career": "Hospitality Marketing Director",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "Hospitality managers not on core skills list but resorts recruit."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Tourism boards hire marketers, yet immigration prioritises health and tech."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Bali and Nusantara projects hire experienced marketers, though not an official skill shortage."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Inbound tourism boom creates limited senior marketing opportunities, but Japanese fluency expected."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "Government promotes high-end tourism; resort chains recruit foreign marketing leaders."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Skilled Migrant Category",
        "reason": "Tourism rebound creates some roles, yet not listed as shortage occupation."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Gigaprojects (NEOM, Red Sea) aggressively hire senior marketers to brand new luxury destinations."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "Tourism Board campaigns exist, yet visas prioritise tech and finance."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s tourism push needs directors for global campaigns; role eligible for Creative Talent visa."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "e5951dae-816b-4bef-9dfa-eab7f0bef833": {
    "career": "Marine Geologist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Strong mining, LNG and offshore carbon-capture sectors list geologists as priority."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Atlantic offshore wind and Arctic research create steady demand for marine geoscientists."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Offshore wind boom needs geotechnical input, but engineers receive higher priority."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "RPJPN 2025-2045",
        "reason": "Nickel seabed mining and geothermal exploration list geoscientists as critical experts."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Emerging offshore wind projects create niche openings."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Highly Skilled Professional visa",
        "reason": "Seismic research funding exists, but language barrier and limited openings."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "NIMP 2030",
        "reason": "Offshore oil & gas still significant; need for sedimentologists in exploration."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Green List (Tier 2)",
        "reason": "Seafloor mapping for earthquake and tsunami research is an identified skill gap."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Red Sea mega-projects and offshore hydrocarbon exploration require marine sediment and stratigraphy experts."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Operation 300bn",
        "reason": "CCUS and coastal infrastructure push demand, but civil engineers are prioritised first."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "North Sea decommissioning and offshore wind need marine geotechnical studies."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Coastal resilience and offshore wind projects need seabed surveys and sediment studies."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "National Master Plan 2021-2030",
        "reason": "Coastal LNG and wind farms drive moderate demand for marine geologists."
      }
    }
  },
  "b122a981-1d55-4269-91a6-f7ba7bc97ab1": {
    "career": "Mental Health Practitioner",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "Psychologists/counsellors appear on Core Skills Occupation List; regional visas actively recruit them."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Mental-health and allied-health occupations get extra CRS points and faster PR processing."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe psychiatric-care gap; new law eases recognition of foreign mental-health qualifications."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Clinical psychologists only recently added; pathway exists but quotas limited."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Growing demand for mental-health care, yet profession not covered by HSP or SSW priority lists."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Health sector growing, but immigration priority is high-tech manufacturing, not clinical therapists."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Clinical psychologists are on Green List allowing straight-to-residence visas."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Mega-city projects require hospital staff; overseas mental-health specialists offered premium packages."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Demand exists, but therapy is not in National AI/Manufacturing priority sectors; visas competitive."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Country courts licensed therapists for rapidly expanding private clinics and tele-health platforms."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "NHS has shortages, but mental-health roles are not on post-2025 shortage list for skilled-worker visas."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Shortage of therapists nationwide, but federal talent acts focus on tech, not healthcare manpower."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "3580db10-cc2f-4293-a1ef-c1a3337d528f": {
    "career": "Risk Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Needed across mining and construction but not on Core Skills list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Role valued in banks and insurance, yet absent from category-based selection priorities."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Manufacturers hire risk pros, however immigration incentives target engineers not analysts."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "IFSC Dublin seeks risk professionals, especially in funds and cybersecurity."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Some demand in megabanks, but visas focus on engineers and scientists."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Islamic-finance growth generates risk jobs, yet not on NIMP priority list."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Gigantic construction, tourism and mining projects need enterprise-risk and supply-chain specialists."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Singapore Economy 2030",
        "reason": "Sustainable-finance push elevates demand for risk specialists in banks and MAS-regulated firms."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Operation 300bn",
        "reason": "Financial-services hub recruits risk analysts for banks, fintech and sovereign funds."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London firms sponsor visas for risk and compliance talent."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Demand in finance and infrastructure, but not singled out in federal talent programmes."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "c7e4a027-891e-41fe-8b45-64c33d788772": {
    "career": "Secondary Teacher",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "Secondary STEM teachers on Core Skills Occupation List with visa priority."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Secondary and STEM teachers receive bonus points and PNP fast-tracks across provinces."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "States face acute teacher gaps; new pathways recognise foreign qualifications."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "STEM teachers remain eligible under Critical Skills permits."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "ALT English programmes exist, but secondary subject teachers not on priority visas."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Secondary teachers on Green List allowing straight-to-residence visas."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Post-2025 shortage list removes most teaching roles; visas harder to obtain."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Teacher shortages exist, yet no dedicated federal immigration channel."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "6360446a-723b-4aa4-bf23-84a783d461bb": {
    "career": "SEO Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Demand exists, but marketing excluded from Core Skills list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Tech firms hire SEOs, yet role not in immigration priority lists."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Start-ups need SEOs but Skilled Immigration Act focuses on engineers."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Digital-economy expansion hires SEOs, yet visa pathways limited."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Tech multinationals hire SEOs but immigration list favours engineers."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "E-commerce growth needs SEOs but not on NIMP priority list."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Tourism and entertainment projects need digital marketing to reach global audiences."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Agencies recruit SEOs but profession not in National AI Strategy Tier-1 list."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "We the UAE 2031",
        "reason": "E-commerce boom keeps SEOs employed though not a strategic visa category."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries targeted; agencies sponsor experienced SEO talent."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Digital-marketing talent in high demand although not guided by federal visa incentives."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "89b2dc80-b6e2-4f38-a36b-14c09a734ce0": {
    "career": "Wind Ensemble Performer",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Classical-music heritage creates jobs in state orchestras, but no special visa incentives."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Professional bands exist but hiring favors local graduates."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Entertainment push funds orchestras and festival circuits seeking international performers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Esplanade and orchestras recruit expats, but role outside Tier-1 priorities."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Cultural-district projects hire musicians for resident ensembles."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Tier-1 Exceptional Talent visa available for leading performers."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "O-1 visas possible for extraordinary musicians, but not a strategic talent policy."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "8e5ce1fe-01e1-4870-8f57-bc0d6fb1e6c9": {
    "career": "Agronomist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Migration Strategy 2023",
        "reason": "Regional farming zones list agricultural scientists on state shortage lists."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Prairie provinces actively invite crop and soil scientists to raise productivity."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Seeks specialists for sustainable farming but priority lower than engineers and nurses."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Food-security and plantation yield targets create strong demand for crop scientists."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-agri R&D exists, but quota favours robotics and semiconductors."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "MADANI Economy",
        "reason": "Current industrial focus is semiconductors and aerospace rather than crop science."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Agricultural and dairy science are on Green List with direct residency pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Food-security mega-farms need advisors but intake limited compared with energy roles."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "We the UAE 2031",
        "reason": "Hydroponic and desert-farming projects hire agronomists, yet numbers are small."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds climate-smart agriculture R&D but agronomists compete with domestic graduates."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "National Master Plan 2021-2030",
        "reason": "Plan funds agritech and climate-resilient rice, needing agronomists."
      }
    }
  },
  "7a18552c-e8ce-4ec3-aac4-ce419f37af4b": {
    "career": "Algorithm Developer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Software developers are on Core Skills Occupation List."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "New Tech Talent Stream fast-tracks AI and software specialists."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Simplified Blue Card for IT pros without German language."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "RPJPN 2025-2045",
        "reason": "Push for fintech and e-commerce engines requires algorithm developers."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Big-tech hubs in Dublin need low-latency algorithm talent."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points favour AI/ML and robotics engineers."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan funds semiconductor design and advanced software R&D."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Software engineer pathway offers straight-to-residency visas."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Vision 2030",
        "reason": "NEOM and fintech projects recruit algorithm and AI teams."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "National AI Strategy 2.0",
        "reason": "Tech.Pass and ONE Pass welcome senior algorithm scientists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "UAE Centennial 2071",
        "reason": "Golden Visa targets AI and data scientists."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital/AI specialists sit at the heart of IS-8 high-growth sectors."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Billions for AI, semiconductor and HPC research; top visa routes for advanced coders."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Government incentivises AI and chip-design algorithm experts."
      }
    }
  },
  "110c188b-529f-41c1-b40e-f82f234e719c": {
    "career": "Brass Teacher",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Migration Strategy 2023",
        "reason": "Schools hire music teachers yet occupation not on CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Music educators can immigrate but not priority category."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Publicly funded music schools recruit but preference EU citizens."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries valued, yet brass teaching is niche."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct policy; arts visas (O-1) exist but limited."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "731b6c64-761d-42c9-8c0d-e97de45b1268": {
    "career": "Clinical Therapist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Psychologists and therapists flagged as critical in regional Australia."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Mental-health professionals receive extra CRS points and provincial nominations."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Ageing population drives demand for mental-health clinicians."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Clinical psychologists remain on critical skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Mental-health roles not in SSW; language barrier high."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Clinical psychologists on Green List with residency pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Vision 2030",
        "reason": "Large hospital groups seek expatriate therapists for new wellness centres."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Green Plan 2030",
        "reason": "Mental-health awareness rising but work passes capped; local training preferred."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "We the UAE 2031",
        "reason": "Fast-growing tele-health and private clinics hire licensed counsellors."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Some NHS shortages, but policy emphasis has shifted away from clinical roles."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct federal policy; state shortages create employment but limited visa priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "df7c590d-73c9-43ed-bead-be2e8aec8d57": {
    "career": "Consumer Marketing Manager",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Consumer market is huge but visa preference goes to tech, not marketing."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Mega-projects need senior marketers for tourism and lifestyle brands."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "Advertising sector healthy yet not in Tier-1 manpower list."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "We the UAE 2031",
        "reason": "Dubai & Abu Dhabi position themselves as global marketing hubs, offering Golden Visas to senior creatives."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "No direct policy; large consumer firms still hire for domestic market."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "e1309b47-ee4c-48e4-af4e-6f9ad21931fb": {
    "career": "Diagnostics Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "Medical specialists sit on the Core Skills Occupation List with streamlined skills assessment and state sponsorship."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Physicians are a headline shortage occupation and receive priority points plus fast-track provincial nominations."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe hospital vacancies; doctors gain Blue Card with reduced salary threshold and accelerated residence permits."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "New hospital projects in Nusantara city open posts, but licensing recognition lengthy."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Consultant and registrar posts qualify for critical-skills permits with fast family reunion and no labour-market test."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Aging population drives need for doctors; language and licensing hurdles keep scores moderate."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Private hospitals hire expatriate doctors but quotas and localisation cap numbers."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Specialist doctors receive immediate residence pathway and subsidised licensing support."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Mega-hospital and medical-city projects import foreign specialists on lucrative contracts, but localisation is ramping slowly."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "We the UAE 2031",
        "reason": "Private healthcare expansion recruits foreign board-certified diagnosticians; Golden Visa available but not formally priority."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "NHS still hires, yet post-2025 immigration rules down-weight most clinical roles in favour of R&D life sciences."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "",
        "reason": "Clinical doctors are in demand but not explicitly named in current industrial-policy bills; hospital shortages still drive H-1B and J-1 visas."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Healthcare reforms seek foreign expertise, yet visa pathways are ad-hoc and salaries low."
      }
    }
  },
  "ef999066-1785-4b86-9307-08d1a217cf6b": {
    "career": "Director",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Screen Australia funds foreign directors occasionally; no priority in migration lists."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Film tax credits attract productions, yet immigration prefers technical roles over creative leadership."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Government is pouring billions into entertainment and invites foreign directors to build industry skill."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "We the UAE 2031",
        "reason": "Dubai Studio City offers 10-year creative visas for senior film professionals."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Film & TV production leadership is listed under creative-industries growth sectors."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "O-1 visas recognise extraordinary film talent, but no targeted immigration incentive exists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b0459ae9-add1-4e32-b4be-efd14da5eff5": {
    "career": "Engineering Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Migration Strategy 2023",
        "reason": "Mechanical engineers listed on CSOL with points boosts and employer sponsorship demand across mining and defence."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Consulting engineers qualify for Express Entry but compete with software roles for slots."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Mechanical and automotive engineering are core export sectors; Blue Card fast-track available."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV battery and mineral processing facilities require foreign mechanical expertise."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Mechanical engineers appear in shortages, but consulting niche smaller than software."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics and automotive suppliers value foreign design consultants; ageing engineers retiring."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industrial 4.0 upgrades create demand for mechanical systems optimisation."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Most demand is for civil rather than mechanical consultants; fewer openings."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Mega projects (NEOM, Red Sea) outsource HVAC, energy and transport systems consulting to foreign experts."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Manufacturing 2030",
        "reason": "Precision-engineering cluster hires consultants for advanced factory retrofits, though visas are selective."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Operation 300bn",
        "reason": "Push into advanced manufacturing and smart cities raises need for mechanical systems consultants."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Advanced manufacturing and clean-energy projects seek experienced consultants for design optimisation."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Mechanical systems expertise is needed for large-scale transport, energy and manufacturing projects funded by IIJA."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "National Master Plan 2021-2030",
        "reason": "Manufacturing boom in electronics needs plant-layout and HVAC consultants."
      }
    }
  },
  "862b4533-3150-4f96-9bf6-58816874195e": {
    "career": "Family Program Developer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "State nomination sometimes lists community-services managers, yet national CSOL omits them."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Social-service managers can qualify under community-and-social occupations, but healthcare categories rank higher."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Federal demand is moderate; visa points favour care workers over program designers."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Social-service planners not on Green List but can apply under general skilled migrant route."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Community-services visas exist but role is not on any priority list."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "3256db42-52d7-4133-bb06-1d961e83911d": {
    "career": "Interactive Media Researcher",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Games-tech clusters in Montreal and Vancouver welcome UX researchers under the Global Talent Stream."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Dublin gaming studios hire, but not on critical-skills list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "e-sports and gaming hubs in Riyadh seek R&D talent, though still embryonic."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "National AI Strategy 2.0",
        "reason": "Government grants fund AR/VR research; Employment Pass facilitation for R&D talent."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "We the UAE 2031",
        "reason": "Dubai Metaverse Strategy funds immersive-tech labs that recruit researchers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-tech R&D is an identified growth segment with Skilled Worker sponsorship."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Gaming, XR and tech giants sponsor H-1B/O-1 for human-computer interaction researchers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a765dbd9-0ee5-42b0-ac43-7d24ed0d6df9": {
    "career": "LGBTQ+ Studies Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Strategy prioritises STEM teachers and trades; humanities researchers are welcome but not prioritised."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Academics may qualify under ‘high-skilled’ rules, yet diversity studies is not a targeted shortage."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Act enables university hiring of non-EU academics, though focus is engineering and IT."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "22",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List omits humanities, but universities can still issue employment permits."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "41",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points can be met by PhD researchers, though topic is not a national priority."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "List mainly covers STEM and health; social-science academics gain entry via general skilled visa."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "UAE Centennial 2071",
        "reason": "Universities hire liberal-arts faculty, but policy channels emphasise tech and finance."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Global Talent visa supports researchers, yet IS-8 funds are directed to science, not queer studies."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "CHIPS and Science Act",
        "reason": "Universities can sponsor H-1B cap-exempt scholars, but the Act funds mainly STEM, not humanities."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "5fc13e51-f1e3-432f-8f83-522c030da72b": {
    "career": "Poet",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List excludes poets; artist-residence permits possible but niche."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "Vision 2030",
        "reason": "Vision funds cultural festivals and poetry slams to boost tourism, but roles are gig-based."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai’s creative-media zones host spoken-word events, yet visas favour influencers over poets."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Strategy supports wider creative industries; poets may secure Global Talent visas via arts councils."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "CHIPS and Science Act",
        "reason": "Act irrelevant to arts; poets find visas via O-1 ‘extraordinary ability’ not government priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "19ff1b2a-ce9c-439a-a86b-aa77b320558a": {
    "career": "Science Education Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "Secondary STEM teachers are on Core Skills List; easy path to permanent residency."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Teachers and French-speaking STEM educators score top points; provinces list science education as critical."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe shortage of STEM teachers; Act streamlines recognition for foreign educators."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "STEM teachers listed as critical; fast-track work permit available."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points can be met by PhD educators, yet demand moderate."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Secondary science teachers appear on Tier 2; job-offer route leads to residence."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National AI Strategy 2.0",
        "reason": "MOE hires some STEM curriculum experts, but policy emphasis is AI R&D."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "We the UAE 2031",
        "reason": "Private schools recruit STEM coaches, but visas are employer-driven, not policy-driven."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Teachers removed from shortage list in 2025; hiring possible but sponsorship caps tighter."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "CHIPS and Science Act",
        "reason": "Act indirectly funds STEM outreach, but teachers are not a shortage occupation."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "3596f818-2a53-4460-9d7f-2e8c18b4d941": {
    "career": "Spanish Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Migration Strategy 2023",
        "reason": "Language researchers not on Core Skills list; universities can sponsor individually."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Express Entry Category-Based Selection",
        "reason": "French, not Spanish, is a priority; humanities still possible under general skilled stream."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Act eases academic hiring, though demand is higher for engineering."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "22",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List omits linguistics; university sponsorship remains possible."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Global Talent visa covers arts/humanities researchers even if not industry-funded."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "CHIPS and Science Act",
        "reason": "Universities may sponsor humanities scholars; Act funding is STEM-centric."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "07311f16-fcb9-4119-a072-62b45b95c553": {
    "career": "Animal Husbandry Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL lists agricultural consultants and farm managers; regional visas plentiful."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Agri-food stream highlights livestock managers; provinces like Alberta offer direct PR."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Demand for dairy and pig specialists in Bavaria and Lower Saxony."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "RPJPN 2025-2045",
        "reason": "Food-security pillar funds cattle and dairy expansion, opening roles for specialists."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Dairy sector needs genetics and feed specialists to hit export targets."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "SSW category covers livestock; bilingual experts can upgrade to professional visas."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "MADANI Economy",
        "reason": "Plan promotes high-tech halal livestock production; talent shortage in feed optimisation."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Dairy farm managers and agri-scientists are on Tier 1 with fast residency."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Food-security projects in desert agriculture recruit livestock experts."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Green Plan 2030",
        "reason": "Limited land; small but growing demand in urban vertical farming of eggs and fish."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "Government backs sustainable desert farming; roles exist but limited."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Strategy funds agritech R&D, yet migration quotas for farm roles are modest."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds climate-smart agriculture, creating some demand for livestock efficiency experts."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "National Master Plan 2021-2030",
        "reason": "Focus on modernising pork and poultry farms; foreign expertise valued."
      }
    }
  },
  "0b7491e8-611d-415a-85e1-ff74b68de9dd": {
    "career": "Arts Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Migration Strategy focuses on STEM and trades; arts management hires are local unless world-leading."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Not on category-based Express Entry lists; cultural-sector demand exists mainly at provincial level."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Skilled Immigration Act does not list arts managers, though large publicly funded theatres can sponsor."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Massive government spend on museums, festivals and giga-projects needs experienced arts managers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Economic plans are deep-tech; Esplanade and private galleries hire foreigners case-by-case."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Dubai Culture and Abu Dhabi’s Louvre projects create demand for senior cultural managers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry leadership explicitly listed; Global Talent visa fast-tracks arts managers with proven track record."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Strong creative-industry cluster but no federal immigration priority; roles filled through H-1B cap or O-1 arts visas."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "da06ce9b-3e76-4bd4-9c7e-f8fd1be1e06a": {
    "career": "Bioseparations Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Listed as ‘Chemical Engineer’ but not core shortage; visas possible with employer sponsorship."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Bioprocess engineers fit ‘science professionals’ priority and get extra CRS points."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Biotech clusters in Bavaria and NRW recruit foreign process engineers; blue-card friendly."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Government building vaccine and insulin plants, seeks expatriate bio-process talent."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Huge biopharma base (Pfizer, Amgen) actively sponsors engineers for purification lines."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points for doctoral scientists; government funding for cell-therapy manufacturing."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan names pharmaceuticals and medical devices as growth sectors needing process engineers."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Green List excludes bioprocess; some niche pharma plants sponsor under generic engineer code."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Investments in local biopharma manufacturing for health security require purification specialists."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Economy 2030",
        "reason": "A*STAR and Jurong pharma hub prioritise biologics purification engineers."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Operation 300bn",
        "reason": "National push for biotech manufacturing and vaccine plants creates demand for bioseparation expertise."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences pillar highlights biologics manufacturing; role on Skilled Worker shortage list."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds advanced biomanufacturing; biotech R&D roles qualify for STEM OPT and NIW green cards."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "National Master Plan 2021-2030",
        "reason": "Biotech manufacturing zones outside Hanoi/Ho Chi Minh recruiting foreign specialists."
      }
    }
  },
  "1d433151-e09b-4df3-bfd2-6b480a7cca19": {
    "career": "Choreographic Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Academic dance research exists but not on priority lists; employer sponsorship needed."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Limited tenure lines; some funding via SSHRC but not an immigration priority."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Well-funded dance-theatre tradition (Pina Bausch Centre); visas available under artist category."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Esplanade and LASALLE fund limited research fellowships; not a national priority."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Cultural foundations commission choreography but favour production over academic research."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry pillar includes senior arts academics; Global Talent route applies."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Universities and avant-garde companies fund dance research through Fulbright and NEA grants."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "3cd5c1a4-ff0d-44d2-9df3-266e99d57b2d": {
    "career": "Clinical Nutritionist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "‘Dietitian’ on Medium-Long-Term list; pathway to PR."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Allied health professionals enjoy additional CRS points and faster provincial nomination."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Hospitals short of nutrition specialists, especially geriatric care."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Critical Skills list omits nutrition; some HSE sponsorship occurs."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Migrant Category",
        "reason": "Clinical nutrition roles classed under health professionals in shortage areas."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Obesity and diabetes drives demand for hospital dietitians; foreign licences recognised."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "MOH registers dietitians but quotas small; strategic but not top-tier."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Private hospitals and wellness clinics actively recruit DHA-licensed dietitians."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Dietitians not on shortage list post-2025; NHS hires mostly local grads."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Dietitians can get H-1B but occupation not federally prioritised."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "e7de7797-c292-4bfd-874d-5b46731ffef8": {
    "career": "Coach Educator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "AIS occasionally sponsors but role absent from CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Sports occupations not on Express Entry lists; provincial hires possible."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Vision 2030",
        "reason": "Government building sports academies and pro leagues, recruiting foreign coach developers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "SportSG runs CoachSG but foreign hires rare; some consultancy contracts."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Emirates Sports Federation imports experts to upskill local coaches."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Elite clubs hire, but not on shortage list; visa sponsor needed."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "College athletics value expertise but immigration programmes not prioritised."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "38fba32b-3f5f-4f4a-9d2f-03827efa77e1": {
    "career": "Crime Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Skilled visa covers ‘intelligence officer’, yet crime analysis not on Core Skills list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Fits under generic data-analyst NOC; police services recruit immigrants but not on priority list."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Public-sector security analysts allowed under new act, but no explicit shortage."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Home Office lists ‘Intelligence analyst’—closest match—making sponsorship easier."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "City and federal agencies hire analysts for predictive policing and gun-violence dashboards, but role not singled out in immigration policy."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "5366946c-bb1d-4ccf-bfbf-41e79c87f43a": {
    "career": "Education Philosopher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Migration Strategy 2023",
        "reason": "Higher-education researchers classed as skill level 1; streamlined Global Talent visa possible."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Strategy funds social-science researchers and eases permanent residence for academics."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "New points system values doctorates and academic job offers, even in humanities."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Third-level lecturer is on the list, covering humanities researchers."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Doctorate holders score enough points for HSP, though humanities posts rare."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Universities may sponsor, yet not on Green List so standard skilled route."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Economy 2030",
        "reason": "Autonomous universities value interdisciplinary humanities; MOE funds education research."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "UAE Centennial 2071",
        "reason": "Private universities in Dubai hire liberal-arts faculty but supply exceeds demand."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Universities sponsor Skilled-Worker visas; philosophy of education supports creative-industry skills agenda."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Universities fund philosophy-of-education chairs; H-1B and J-1 research visas common."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "1925d765-f533-4d2f-9086-b78a5ef06a79": {
    "career": "FinTech Developer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Software developer on CSOL, but fintech not singled out."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Strategy specifically courts software and fintech coders with fast PR."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Act eases visas for IT professionals; Frankfurt’s fintech hub growing."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Massive unbanked population drives fintech; talent welcomed via Tech Visa."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Fintech software engineers explicitly listed; Dublin’s payments cluster expanding."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points for blockchain and cashless-payment coders; Tokyo Finolab supports."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "MADANI Economy",
        "reason": "Malaysia Digital licences focus on Islamic fintech; demand but not top-tier."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Developers welcome, yet fintech not on priority Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Vision 2030",
        "reason": "Riyadh Fintech Hub and digital banks make this a focus area."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "National AI Strategy 2.0",
        "reason": "MAS grants FinTech passes; SG is Asia’s premier hub, clearest policy fit."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai DIFC and Abu Dhabi ADGM aggressively recruit fintech engineers with Golden Visas."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "London’s global fintech dominance; Innovator Founder visa fast-tracks top coders."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Fintech firms tap STEM OPT and H-1B; digital-payment systems aid clean-energy credits under IRA."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "National Master Plan 2021-2030",
        "reason": "Fintech aiding e-commerce push; no dedicated visa preference."
      }
    }
  },
  "addd30b4-f9f0-40c9-8bfd-1c6af3d0bfe8": {
    "career": "Hospitality Entrepreneur",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Business Innovation visa possible, yet policy focus is STEM and trades."
      },
      "canada": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Massive tourism push in Bali and Labuan Bajo; foreign co-founders welcomed."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Start-up Entrepreneur Programme prefers tech or export-oriented ventures."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Regional revitalisation funds hotels, yet language and regulation hurdles.”"
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "MADANI Economy",
        "reason": "Eco-tourism and halal hospitality backed by government grants."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Tourism important but entrepreneur visas competitive and not prioritised."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Gigaprojects like NEOM and The Red Sea recruit foreign founders to build luxury eco-resorts."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "Tourism is stable but not high-growth priority; space constraints limit new hotel licences."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Golden Visa and free zones lure hospitality innovators for Expo City and beyond."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Innovator Founder visa possible, but sector not on strategic priority lists."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Startup pathway exists, but hospitality not on federal priority lists."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National Master Plan 2021-2030",
        "reason": "Tourism zone expansions invite foreign boutique-hotel investors."
      }
    }
  },
  "98ad31c6-e130-46a2-87f4-05022ff30db4": {
    "career": "Inclusive Education Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Special-needs teachers on CSOL, giving direct pathway to permanent residency."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Special-education teachers explicitly targeted in 2025 category draw; severe shortages in rural Canada."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Inclusive schooling reforms create demand; visa rules relaxed for qualified teachers."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Special-needs teachers retained on list despite broader teacher oversupply."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Special-education teachers on Tier 1, offering Straight-to-Residency."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "We the UAE 2031",
        "reason": "Private schools hire specialists but no dedicated visa priority."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Since 2025 teachers removed from shortage list; sponsorship still possible but costly."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "IDEA mandates special-education staffing; districts sponsor visas but role not federally prioritised."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "6e57bba4-3ea6-43ab-aecf-fd99ae6b8e96": {
    "career": "Insurance Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Financial-services candidates can still qualify under points test, yet not on Core Skills list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Finance skills occasionally invited, but not a named shortage occupation."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Dublin’s IFSC targets insurance & risk professionals; fast-track Critical Skills visa."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Financial-services and InsurTech are growth pillars; expatriate specialists welcomed."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Singapore Economy 2030",
        "reason": "Hub for re-insurance and sustainable finance; EP processing fast but not priority tier."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "UAE Centennial 2071",
        "reason": "DIFC insurers recruit actuarial and risk talent to build regional hubs."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "London insurance market (Lloyd’s) is globally dominant and on shortage lists for actuarial expertise."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Huge private insurance market but no federal talent visa priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      }
    }
  },
  "33c91177-66a0-4448-b1c3-4fe926bb0d3a": {
    "career": "Marine Tech Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Defence shipbuilding in Adelaide recruits, yet occupation not on primary shortage list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Shipbuilding in Halifax and BC search for niche talent but small numbers."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Hamburg shipyards hire, but engineering shortages centred on automotive."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "RPJPN 2025-2045",
        "reason": "Maritime nation targets naval construction and fisheries vessels; talent shortages acute."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Shipbuilding is a priority industry under SSW and needs engineers for automation and green fuels."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Focus on aerospace and semiconductors over maritime."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "NEOM and Red Sea shipyard projects need marine-systems engineers for tourism and logistics."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Singapore Economy 2030",
        "reason": "World’s busiest port pilots autonomous tugs; engineers welcomed yet not top-tier visa."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Operation 300bn",
        "reason": "Dubai and Abu Dhabi ports invest in autonomous vessels and require marine tech talent."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "73",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Decarbonised shipping and naval contracts make marine engineering a supported niche."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Naval modernization, offshore wind and ports revamp need marine engineers, but not top visa priority."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "59",
        "policy": "National Master Plan 2021-2030",
        "reason": "Ship-repair yards along coast seek experienced expats, but no formal priority."
      }
    }
  },
  "67b53bc5-c7e1-42d7-b6f4-27f051f90e09": {
    "career": "ML Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Migration Strategy 2023",
        "reason": "New specialist visa class for data scientists and AI engineers."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Dedicated AI talent stream with 14-day work permits."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz",
        "reason": "Blue Card lowered salary thresholds for AI roles."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech AI demand but localisation rules high."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "AI/ML is on Critical Skills; big tech campuses in Dublin."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Highly Skilled Professional visa",
        "reason": "Fast-track points for AI researchers with high salaries."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "59",
        "policy": "MADANI Economy",
        "reason": "AI listed under NIMP 2030 but hiring volumes modest."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Migrant Category",
        "reason": "AI on long-term skills list but small market size."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Vision 2030",
        "reason": "National Center for AI lures consultants for smart-city projects."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "National AI Strategy 2.0",
        "reason": "EP-fast lane for AI professionals; major incentives and compute grants."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "We the UAE 2031",
        "reason": "Golden Visa for AI experts; strong demand across fintech and govtech."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Tech Nation successor endorses Global Talent visas for ML experts."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Frontier AI talent heavily courted with O-1 and H-1B fast paths."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Start-ups in AI/ML growing but visa processes still young."
      }
    }
  },
  "ec254ac1-18fd-4711-ad44-0f43e0270d24": {
    "career": "Nanotechnology Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Migration Strategy 2023",
        "reason": "Advanced manufacturing skills recognised but not core list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Applied nanotech fits under STEM streams but not explicit priority."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Semiconductor fabs and Fraunhofer institutes sponsor nanotech researchers."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "RPJPN 2025-2045",
        "reason": "Focus on battery materials, some nano-coatings but not yet scaled."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Bio-pharma uses nanotech drug delivery but niche."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics and semiconductor giants hire nano-fabrication experts."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Nation doubling down on nano-enabled chip packaging; tax holidays for experts."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "KAUST invests in nano-materials for energy and desalination."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Manufacturing 2030",
        "reason": "A*STAR and IME lead world-class nano-fabrication; personalised EP fast-track."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing ambitions but early stage."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences and advanced materials clusters sponsor Global Talent visas."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Billions earmarked for nanoscale materials and semiconductors; EB-2 NIW route available."
      },
      "vietnam": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Government funds nano-electronics R&D to build local fabs."
      }
    }
  },
  "dcb09b3d-c10e-40bd-bec3-c9b5196e06f6": {
    "career": "Patient Care Coordinator",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Aged-care and nursing coordinators on priority list with fast visas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Nursing and care occupations top new healthcare invites."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe nurse shortage; hospitals sponsor care coordinators with German B2."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Nursing and healthcare management remain on list with simplified permits."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Role sits under registered nurse category with direct residence pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "New hospitals in Riyadh and NEOM recruiting international nursing leadership."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Singapore Green Plan 2030",
        "reason": "Aging population fuels demand but local workforce supply adequate; EP still possible."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Private hospital expansion needs bilingual coordinators, but nurses take precedence."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Healthcare roles exist but immigration priority on physicians not coordinators."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "86a85ad7-9f04-48d0-afc8-b6f02a9a5bd9": {
    "career": "Photonics Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Photonics useful for defence sensing yet absent from Core Skills list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Optics skills valued for quantum telecom hubs in Ontario but not an explicit shortage occupation."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Industrial lasers and automotive optical sensors face well-documented talent gaps."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Limited demand outside niche mining-sensor projects."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Med-tech optics research exists but photonics not on critical list."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Highly Skilled Professional visa",
        "reason": "Integrated photonics is critical for Japan’s semiconductor and robotics revival."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Wafer-fab and packaging parks in Penang need optics engineers for process control."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Small academic clusters; no large-scale commercial demand."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Smart-city projects need LIDAR and fibre links, but talent can be sourced regionally."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Manufacturing 2030",
        "reason": "Integrated photonics and quantum communications feature in National AI & semiconductor roadmaps."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing push includes optics, yet hiring is opportunistic rather than strategic."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Semiconductor and quantum photonics are named focus areas within IS-8."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Integrated photonics underpins on-shore semiconductor, quantum and LIDAR R&D strongly funded by CHIPS."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Photonics design/testing supports planned optical transceiver plants."
      }
    }
  },
  "c1a25c68-e2c7-4b04-9913-9222f12f4d38": {
    "career": "Quantitative Risk Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Occupation not listed on Core Skills list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Finance isn’t a priority category; entry relies on general CRS points."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Fin-risk expertise valued but not shortage-listed compared with IT and engineering."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Jakarta fintech/crypto hubs hiring risk quants, though pathways are general work permits."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "IFSC Dublin lists financial risk & quantitative analysts as critical skills."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Qualifies for points but finance not a named focus area."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "MADANI Economy",
        "reason": "Islamic finance growth needs market-risk quant talent in Kuala Lumpur."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "No accelerated pathway; standard points only."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Growing Riyadh fintech hub needs risk talent for sovereign-wealth and giga-projects."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Economy 2030",
        "reason": "MAS drives demand for quantitative risk talent across banks and hedge funds."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "UAE Centennial 2071",
        "reason": "DIFC/ADGM position Dubai-Abu Dhabi as regional finance centres actively importing quant risk skill."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London explicitly targets financial-services and quantitative talent on shortage list."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Large banks seek quants for green-finance risk, yet no immigration fast-track exists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b80a4b5c-4a4e-491a-ab20-4654b270434a": {
    "career": "Supply Chain Strategist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Migration Strategy 2023",
        "reason": "Construction and mining mega-projects need supply-chain experts though not on CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "No dedicated pathway; demand exists but competes under general CRS."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Re-shoring of manufacturing and EU battery plants drive urgent logistics talent shortages."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "RPJPN 2025-2045",
        "reason": "Nickel-battery ecosystem requires integrated supply design."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Demand exists in pharma export hubs but not on critical list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Re-shoring policies value supply-chain expertise but other tech roles outrank it."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "NIMP 2030",
        "reason": "Electronics and aerospace clusters targeting world-class supply chain capability."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Migrant Category",
        "reason": "Food exports rely on smart supply networks yet no fast-track list exists."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Mega-projects like NEOM require end-to-end supply-chain orchestration from global sources."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Economy 2030",
        "reason": "Global distribution headquarters base requires high-level supply-chain strategists."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai aims to be world logistics hub; strategists welcomed under Operation 300bn."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Advanced manufacturing clusters need supply resilience but no shortage visa route."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Post-pandemic reviews and IIJA funds prioritise resilient domestic supply chains."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "National Master Plan 2021-2030",
        "reason": "Booming export manufacturing needs planners as it climbs value chain."
      }
    }
  },
  "88fb57cd-4547-47be-8f9c-e8bedb3ee67f": {
    "career": "Agricultural Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Water-management and precision-farming engineers appear on regional occupation lists."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Prairie provinces list agri-engineering under farm and food-processing shortages."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Agritech for biogas and smart machinery moderately sought."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Food security and rice mechanisation prioritise agricultural engineering talent."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Grassland dairy sector needs some agri machinery expertise but not on list."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Smart agriculture pilots recruit engineers under HSP and SSW agri categories."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "MADANI Economy",
        "reason": "Palm-oil sustainability push needs mechanisation experts."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Dairy-heavy economy actively recruits Ag engineers for sustainability goals."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Desert agriculture initiatives exist but hire small numbers."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Ag-engineering not on shortage list since 2025."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA funds modern irrigation and rural broadband projects needing agri-tech design."
      },
      "vietnam": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "National Master Plan 2021-2030",
        "reason": "Government targets high-tech farming and agri-machinery localisation."
      }
    }
  },
  "44861c3a-3db9-49cd-be13-dd59a13f33e9": {
    "career": "Chief Information Officer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Migration Strategy 2023",
        "reason": "Digital-skills visas cover senior IT managers under general ICT manager codes."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Tech-scaleups recruit CIOs but no separate fast-track exists."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "German Mittelstand seeks CIOs for Industry 4.0 rolls-out; pathway via Blue Card."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "RPJPN 2025-2045",
        "reason": "E-commerce giants hunt seasoned CIOs for rapid scaling."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "ICT managerial roles eligible but not expressly critical."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "Corporate Japan courts foreign CIOs for DX yet still faces language barriers."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "MADANI Economy",
        "reason": "Digital-by-default government services recruit CIO-level leadership."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Senior ICT managers score high points but no priority list."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Giga-projects and state firms poach global CIOs to meet ambitious digital KPIs."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Economy 2030",
        "reason": "Regional HQs base CIO roles in Singapore to drive ASEAN digital agendas."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Operation 300bn drives demand for tech leaders across government and industry."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital, AI and fintech clusters list senior tech leadership as priority hires."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Large tech and manufacturing firms need CIOs to steer digital transformation and AI adoption."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National Master Plan 2021-2030",
        "reason": "Fast-growing banks and telcos need strategic IT heads."
      }
    }
  },
  "47afdef6-e24b-41cf-89d0-25fc74af82d1": {
    "career": "Digital Innovation Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Innovation managers are outside CSOL’s tech and engineering codes, but digital-transformation skills still valued by employers."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Category list favours software and data, so digital‐product managers get points only via work experience, not priority."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Law welcomes IT professionals; management positions gain visas if degree + offer, yet not a shortage occupation."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Vision mentions digital economy, yet immigration preference stays for engineers, not managers."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List covers software engineers, not managers; employer sponsorship common but not priority."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "Points available for senior salary/degree, yet role not on semiconductor/AI priority track."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan promotes Industry 4.0; firms need managers to drive digital overhaul in factories."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "Gigaprojects need leaders to digitise tourism, construction and finance workflows."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "National AI Strategy 2.0",
        "reason": "Companies get tax perks for digitalisation; experienced innovation managers qualify under Tech@SG pass."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Operation 300bn",
        "reason": "Plan pushes industrial digitalisation, creating demand for cross-functional innovation managers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Strategy lists digital and advanced manufacturing; visas possible under 'digital technology leader' SOC."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds advanced manufacturing and AI; firms then hire managers to steer digital initiatives, but role itself not on priority list."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National Master Plan 2021-2030",
        "reason": "Tech leadership useful to expanding e-commerce sector but not on semiconductor priority sheet."
      }
    }
  },
  "5b830add-cedc-44bc-8d5c-b04ecff872ec": {
    "career": "Education Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "STEM and secondary teachers shortlisted; education consultants gain visas via related ANZSCO codes."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Early-childhood and K-12 teachers on priority list; specialists in curriculum qualify closely."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Shortage of educators, especially in STEM and integration; specialists find regional demand."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List omits educators; work permit possible but not fast-track."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Primary and secondary teachers are Tier-1; curriculum specialists accepted under same codes."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Teachers removed from shortage list in 2025; education specialists still possible under SOC 2312 with sponsorship."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct provision, but EdTech grants create limited roles within school districts."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "49a2dc48-2244-4ee0-bd86-b4b580bea957": {
    "career": "Encryption Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Cybersecurity engineers on shortage list; priority processing for visas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Cybersecurity listed as top tech priority; extra CRS points for work experience."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT Spezialist track eases residence; BSI pushes for post-quantum crypto experts."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech boom drives niche demand; visas available but slower."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List names cybersecurity specialists; fast two-year path to residency."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "Quantum-safe encryption research incentivised under HSP points."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Digital banking and semiconductor sectors need secure IP protection."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Not on Green List but points route viable for senior cyber talent."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Fintech and defence digitalisation drive demand for encryption gurus."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "National AI Strategy 2.0",
        "reason": "GovTech and MAS push for talent in cryptography, payments, and digital identity."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "UAE Centennial 2071",
        "reason": "Banks and govt clouds pursue zero-trust architectures, importing crypto experts."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "79",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "National Cyber Security Centre shortage; Global Talent visa covers cryptography roles."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Critical infrastructure and defense programmes require advanced cryptography talent; clearance fast-tracks for STEM graduates."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Growing chip design outsourcing requires IP and data-in-transit security."
      }
    }
  },
  "a636bbab-c93b-4bd6-b6f9-1dc9db08fdfc": {
    "career": "Environmental Resource Manager",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Environmental scientists and managers listed for mining reclamation and water stewardship."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Net-zero targets fuel demand for sustainability professionals, but not formally on priority list."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Energy transition drives hiring in renewable and circular-economy projects; easy residence for STEM grads."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "RPJPN 2025-2045",
        "reason": "Nickel and geothermal expansions need environmental oversight; work-permit bureaucracy remains."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on list; roles filled through general work permits."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Eco-engineering valued but immigration preference remains for renewables engineers, not managers."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "MADANI Economy",
        "reason": "Green finance and palm-oil sustainability audits create moderate demand."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Environmental scientists on Tier-2; resource managers accepted with verified qualifications."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Mega-projects need environmental compliance, but localisation preference applies."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Green Plan 2030",
        "reason": "Carbon services hub hires resource managers though focus is on finance analysts."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "We the UAE 2031",
        "reason": "COP28 commitments push companies to hire sustainability managers, though not on formal shortage list."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Offshore wind, hydrogen and CCUS clusters require environmental governance staff."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds massive clean-energy projects requiring managers to track water, land and biodiversity impacts."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "National Master Plan 2021-2030",
        "reason": "Offshore wind and LNG projects require E&S managers, but no fast-track."
      }
    }
  },
  "6b86147a-af7a-4cc9-bd33-a3f6d0682978": {
    "career": "Ethnic Studies Professor",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Migration Strategy 2023",
        "reason": "Universities sponsor professors; no national shortage list preference."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Express Entry Category-Based Selection",
        "reason": "University teachers get CRS points; multicultural policy funds ethnic-studies departments."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Academic roles open via Blue Card, though humanities funding tight."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on critical list; universities still sponsor via General Employment Permit."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Universities in Auckland and Wellington recruit but not on Green List."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Universities sponsor lecturers; humanities research councils fund diversity scholarship."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "CHIPS and Science Act",
        "reason": "No direct link, but U.S. universities frequently sponsor humanities faculty under H-1B cap-exempt rules."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "aba42aa2-3091-4ce0-bef6-6e02fbf87c46": {
    "career": "Finance Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Migration Strategy 2023",
        "reason": "Skill lists focus on STEM and trades rather than corporate finance."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Finance not a listed shortage category; points possible but no prioritisation."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Possible Blue Card, yet not on shortage lists."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech and digital banking highlighted for economic leap-frogging."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Financial services quantitative analysts and risk specialists on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points may suit finance MBAs, but not a named priority."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "MADANI Economy",
        "reason": "Islamic finance growth targets demand risk and product specialists."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Massive push for fintech and capital-markets expertise in Riyadh."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Singapore Economy 2030",
        "reason": "Sustainable-finance and wealth-management growth; easier EP pass for experienced analysts."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "We the UAE 2031",
        "reason": "Dubai/Abu Dhabi positioning as global finance hubs; Golden Visa fast-tracks experienced specialists."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London financial services explicitly prioritised under IS-8 high-skill route."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Financial services not named in recent industrial-policy acts; standard H-1B route only."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "aa95b1f0-8b17-40ea-b7b9-64edb1a8bf13": {
    "career": "Game Audio Designer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Creative media not on CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Montreal & Vancouver studios hire, but not on category-based Express Entry lists."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Possible points via Opportunity Card, yet gaming audio not priority."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Creative roles not on Critical Skills list; standard work permit only."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Highly Skilled Professional visa",
        "reason": "Game giants seek foreign audio talent; HSP points route fits experienced designers."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Green List excludes creative roles."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Massive investment in e-sports and entertainment requires game-audio talent."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Games industry present but outside National AI Strategy priority list."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai Media City courting global game studios; creative visas available."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries (film, TV, gaming) named as high-growth sector with visa concessions."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "No special visa priority; O-1 possible for award-winning creatives."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a26e52c2-5760-4ec9-9233-57b39645c637": {
    "career": "Hospital Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Migration Strategy 2023",
        "reason": "Hospital administrators in demand within expanded health workforce list."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Healthcare leadership accepted under health occupations stream."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Hospitals recruit international managers to tackle nursing shortages."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Focus on clinical and biotech roles."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Critical Skills list focuses on clinicians, not administrators."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Language and licensure barriers; foreign admin hiring limited."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Healthcare management not priority in NIMP-2030."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Migrant Category",
        "reason": "Public-health reforms create vacancies for experienced administrators."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Gigantic investment in private hospitals; foreign managers fast-tracked with tax-free packages."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Hospitals do hire expat managers but outside priority occupations."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai Health Strategy needs seasoned managers; Golden Visa available."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "NHS manager roles rarely qualify for Skilled Worker shortage concessions."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "No immigration fast-track; H-1B cap applies."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "No special visa lane for managers."
      }
    }
  },
  "21031d5a-e4fa-4ea0-82ca-6224f961f450": {
    "career": "Interdisciplinary Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Migration Strategy 2023",
        "reason": "Academic jobs qualify for Employer-Sponsored visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities may sponsor Global Talent visas for researchers."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "DFG-funded institutes actively recruit humanities PhDs."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Limited research visas; language barrier."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Funding limited; standard hosting agreement route."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Universities value area-studies scholars; HSP points help."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Some grants for Southeast-Asia studies, but no special visa."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Universities small; limited targeted pathways."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "National AI Strategy 2.0",
        "reason": "Universities fund humanities-tech intersections; attractive S-Pass for researchers."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Global Talent Visa readily granted for recognised academics."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "CHIPS and Science Act",
        "reason": "Act boosted NSF budgets, funding area-studies centres and post-docs."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Foreign research hiring still bureaucratic."
      }
    }
  },
  "c94a902a-e6e0-4f0b-aca1-292a8bbbb088": {
    "career": "Landscape Designer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Landscape architects included under construction professions."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Not on Express Entry priority list; general demand in urban centres."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Green-city and climate-adaptation projects need designers; Blue Card possible."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital Nusantara needs sustainable landscape planning."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Critical Skills focuses on engineers, not landscape design."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-city initiatives sometimes recruit foreign designers."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Industrial plan targets manufacturing, not landscape."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Migrant Category",
        "reason": "Infrastructure rebuild and tourism resorts require landscape skills."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "NEOM, Red Sea, AlUla megaprojects have huge demand for landscape and public-realm designers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Garden City reputation, yet role not on priority lists."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Operation 300bn",
        "reason": "Massive urban development in Dubai/Abu Dhabi prioritises sustainable landscape expertise."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "No shortage designation; regular Skilled Worker visa only."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Green infrastructure funds open roles, but not a named shortage."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Government focuses on heavy infrastructure, not aesthetic design."
      }
    }
  },
  "04ce740d-f91c-4378-868d-eb132494ca7e": {
    "career": "Media Coordinator",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Express Entry gives no extra points; only general labour-market demand in major cities."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "23",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "22",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "26",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "24",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Vision 2030",
        "reason": "Large investments in entertainment and sports projects need media staff, including coordinators."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Media is a supported sector but not in National AI Strategy 2.0 priority occupations."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi position themselves as regional media hubs; demand for content and event coordination."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries are named growth sector, but visa routes are competitive and not shortage-listed."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "",
        "reason": "Creative/media roles exist but are not part of federal labour-shortage or industrial strategies."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "11430d54-ea9e-4072-9ddd-c96b5dbc65fd": {
    "career": "Pen Tester",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Information security analysts are on the CSOL with priority visas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Cybersecurity occupations receive extra CRS points and fast-track processing."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT Spezialist track lets pen testers bypass degree if experienced; demand high among Mittelstand and auto sector."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Banks and e-commerce expand cyber teams, yet immigration pathways remain complex."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pen testers fall under cybersecurity specialist code with immediate work-permit eligibility."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Highly Skilled Professional visa",
        "reason": "Government fast-tracks high-salary cyber experts to secure critical infrastructure for Osaka Expo and Society 5.0 goals."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "MADANI Economy",
        "reason": "Digital forensics and cyber roles are encouraged, but visa processes less streamlined."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Migrant Category",
        "reason": "Government lists cyber specialists as future-growth area though not on Green List Tier 1 yet."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Smart-city and fintech projects in NEOM drive demand for offensive security talent."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "National AI Strategy 2.0",
        "reason": "Cybersecurity specialists receive COMPASS bonus points; large demand from finance and data-center clusters."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Operation 300bn",
        "reason": "Fintech and federal cyber programmes offer Golden Visas to experienced pen testers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital and cyber are priority sectors; CREST-certified testers qualify for Skilled Worker visa with reduced salary floor."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Cybersecurity for critical infrastructure is a top federal funding area; DHS and private sector heavily recruit pen testers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Growing fintech and chip sectors want security skills, but limited English-speaking roles."
      }
    }
  },
  "ace38f80-8ea8-477c-9fa2-4605e212df6d": {
    "career": "Recruitment Specialist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "HR roles exist across industries but receive no Express Entry preference."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "29",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Vision 2030",
        "reason": "Mega-projects import foreign HR professionals to scale workforces quickly."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Recruiters help global firms meet COMPASS diversity points, but role not priority."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Fast-growing free-zones rely on international recruiters with multilingual networks."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "No shortage status, but tech and finance clusters create steady demand."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Talent acquisition is always needed but not covered by federal priority programmes."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "27",
        "policy": "",
        "reason": ""
      }
    }
  },
  "0c8e28e5-67e6-462f-8cde-a5f1554dc5d2": {
    "career": "Research Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Medical research roles exist; consultant category lacks visa priority."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Health researchers welcome, but consultant advisory roles not on priority list."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Health-economics consultants possible via EU Blue Card but not shortage-listed."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma and med-tech research services exported from Ireland’s cluster."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Biotech consulting limited to Japanese speakers; not on HSP fast-track."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "Government courting med-tech and pharma R&D; consultant roles exist but few visas."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Vision 2030",
        "reason": "Huge investments in biotech research cities drive demand for external experts."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Singapore Green Plan 2030",
        "reason": "Biomedical research hub hires consultants for clinical-trial strategy and health-economics."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "UAE Centennial 2071",
        "reason": "Abu Dhabi’s life-science clusters hire consultants to benchmark global health systems."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences R&D is a named priority; consultants support NHS innovation projects."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Health and life-science research funding surges; consultants help allocate grants and evaluate outcomes."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b6f39e60-5482-4630-a481-e87f0cc66fed": {
    "career": "UX Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Software developers priority indirectly benefits UX roles."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Digital designers included under tech category for streamlined visas."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Digital design counts toward points; Berlin startups hire English-speaking UX talent."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Super-app and fintech race raises demand for UX, albeit with localisation hurdles."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "",
        "reason": "Product-led SaaS companies cluster in Dublin; UX included in tech visa category though not shortage-listed."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Language-heavy user research limits foreign UX roles."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "NIMP 2030",
        "reason": "Digital-service exports growing; UX valued for semiconductor customer portals."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Vision 2030",
        "reason": "E-government and tourism apps seek world-class user-experience experts."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Singapore Economy 2030",
        "reason": "DesignSingapore and tech multinationals hire UX talent; COMPASS framework favours digital creatives."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "We the UAE 2031",
        "reason": "Fintech and super-app initiatives create steady demand for UX designers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative digital subsector prioritised; Global Talent visa recognises design portfolios."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Tech companies value UX, though not explicitly in federal priority acts."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "National Master Plan 2021-2030",
        "reason": "Booming e-commerce seeks UX skills, but few structured visas."
      }
    }
  },
  "fc418f81-6216-409e-98b1-575c919bf671": {
    "career": "Athletic Coach",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Sports-loving nation; visas exist for elite coaches yet occupation absent from Core Skills list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Sports coaching occasionally appears under recreation roles, but not a named immigration priority."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Demand exists in football academies, but policy focuses on trades and engineers."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Some demand via Gaelic sports programs but not a critical-skills role."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Sports coaching visas exist for Olympics legacy, yet not covered by SSW or HSP priority lists."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Rugby and cricket create pockets of demand; still not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Massive investment in professional sports and community fitness boosts recruitment of foreign coaches."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "UAE Centennial 2071",
        "reason": "Government pushes for sports tourism and wellness, increasing need for qualified coaching talent."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Premier League academies hire global coaches, yet occupation not listed under formal shortage areas."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Not on formal shortage list but huge collegiate/pro sports ecosystem drives steady demand for qualified coaches."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "22584d9f-d3e5-4000-8663-ed3b9ba5dcb6": {
    "career": "Classical Language Teacher",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Migration Strategy 2023",
        "reason": "Secondary STEM teachers listed, not classical languages."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Express Entry Category-Based Selection",
        "reason": "French bilingual teachers preferred; classical languages sit outside shortage categories."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Gymnasium system maintains Latin/Greek demand but at niche scale."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Private schools keep classics alive, though not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "CHIPS and Science Act",
        "reason": "Not a policy priority but universities continue to hire Latin, Greek, and Sanskrit lecturers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "74caaa38-b6b8-4610-a751-3bea19beaf50": {
    "career": "Clinical Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Medical laboratory scientists flagged as shortage occupation."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "New stream lists health-science researchers as priority talent."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Diagnostics and biotech firms compete for foreign lab scientists."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Biopharma research listed but still nascent; foreign talent welcomed selectively."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Biopharma cluster around Cork and Dublin needs clinical scientists."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP category explicitly includes biotech researchers."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan highlights medical devices and pharma, driving moderate demand for lab scientists."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Medical laboratory scientist is explicitly on Tier 1 Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "Mega-hospital projects and biotech zones recruit overseas clinical scientists."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Green Plan 2030",
        "reason": "Biomedical hub continues to import clinical research scientists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Growing genomics and personalised medicine initiatives seek lab researchers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences pillar names clinical trials and diagnostics as high-growth sectors."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act pours billions into biotech and advanced life-sciences R&D, fuelling demand for clinical researchers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National Master Plan 2021-2030",
        "reason": "Emerging pharma hubs require some clinical lab expertise."
      }
    }
  },
  "2aaf2648-b2f1-4254-92c0-f71c84b9dd60": {
    "career": "Diversity Consultant",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Government promotes inclusion yet DEI consulting not on priority list."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "UAE Centennial 2071",
        "reason": "Multinational HQs hire DEI advisors, but not a named priority occupation."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Large City firms employ DEI consultants yet visa rules treat it as generic management."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Corporate grants often require DEI reporting, but role not in federal talent strategy."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b9cd92a4-23f7-4544-9a20-7c1a3813a52d": {
    "career": "Event Marketing Manager",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Tourism incentives exist, yet event marketing absent from priority categories."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Massive MICE and sports events (NEOM, Riyadh Season) need seasoned event marketers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "MICE industry strong, but role not in official shortage lists, so only moderate priority."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai and Abu Dhabi position themselves as global event hubs, placing event marketing in top demand."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry growth supports events, but it’s not on Shortage List."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Conventions and sports arenas are expanding, but occupation not in federal shortage lists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "59cbcf0b-82dc-4930-8f45-6528cabbfbc5": {
    "career": "Level Designer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Growing indie scene and Screen Australia grants, but Migration Strategy 2023 does not list creative digital roles."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Game studios in Montréal/Vancouver hire foreign creatives, yet the Express Entry priority lists exclude entertainment jobs."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Large domestic gaming market welcomes foreign talent, but no dedicated visa prioritisation."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Vision 2030 funds esports and entertainment zones, creating some demand for senior level designers."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s gaming initiative sits under the creative-media pillar of the national vision, but numbers remain small."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 names the creative-gaming industry as a strategic export; Global Talent visa explicitly lists game design."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Huge commercial game sector and O-1/H-1B digital media talent demand, but no specific federal immigration priority for creative roles."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "61f3b6d3-2066-4c9b-9b0f-51cc50d4d3b0": {
    "career": "Medical Imaging Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Migration Strategy 2023",
        "reason": "Priority for medical scientists under health-care stream; easier PR pathways for PhD holders."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "79",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Healthcare and French-speaking researchers receive extra CRS points, though role is not explicitly listed."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "University hospitals seek MRI physicists; Blue Card eased for researchers in shortage occupations."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Medical physicists & imaging scientists eligible for Critical Skills permit."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP visa offers fast PR for PhDs working in AI-enabled imaging device firms."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Migrant Category",
        "reason": "Medical physicists can earn over salary threshold for straight-to-residence visas."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "New giga-hospital projects import imaging R&D talent but research culture still maturing."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Singapore Economy 2030",
        "reason": "A-STAR funds AI medical imaging; PhD scientists qualify for Employment Pass and ONE Pass."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai Academic Health City recruits imaging PhDs for AI-diagnostics initiatives."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences R&D including imaging falls under ‘health & life sciences’ priority with Global Talent visa sponsorship."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act boosts NIH/DOE funding for advanced MRI, PET and AI-imaging research; EB-2 NIW fast-tracks biomedical PhDs."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "884448e8-63ad-43a1-91e4-33d31331dd9a": {
    "career": "Movement Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "",
        "reason": "Nation invests heavily in sports science for Olympic performance; universities sponsor Global Talent visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Sports analytics firms can use Express Entry; not on priority list but high CRS scores possible."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Some demand at Bundesliga clubs yet not recognised as shortage occupation."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Some academia demand, but visas prioritise robotics over sports science."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "High-performance sport NZ recruits biomechanics experts on fixed-term visas."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Sports academies in NEOM hire human-movement PhDs to build talent pipelines."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "SportSG hires a handful of biomechanics experts; not a formal priority skill."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Dubai Sports Council funds limited research roles in biomechanics."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "UK Sport’s Elite Training Centres sponsor Global Talent in sport & exercise science."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "",
        "reason": "Elite sports labs and NSF biomechanics grants attract foreign PhDs via O-1 and J-1 research visas."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "0d86a248-2e01-4a07-8528-26406ca44d8e": {
    "career": "Performance Physiologist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "",
        "reason": "Australian Institute of Sport drives demand; Sport Scientist roles qualify for Global Talent visa."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Own the Podium funding supports exercise physiology labs; Express Entry possible but not priority."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Bundeswehr and Bundesliga use physiologists, but immigration lists focus elsewhere."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Limited professional sport science immigration pathways."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "High Performance Sport NZ recruits limited exercise physiology experts."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Neom sports academies seek exercise physiologists to raise local athlete standards."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Singapore Sports Institute hires a handful of performance physiologists but not a priority field."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Abu Dhabi cycling team and football leagues import sports science coaches."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "UK Sport’s talent visas include high-performance exercise scientists."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "",
        "reason": "NFL, NBA and Olympic training centres hire sports physiologists under O-1 visas."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "c1d82510-422e-45ed-ae43-379cb41c0fda": {
    "career": "Plant Science Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Migration Strategy 2023",
        "reason": "CSIRO and Grains Research organisations list agronomy/horticulture PhDs on Core Skills list."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Agri-scientists score high CRS and are in demand across prairie research stations."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Need for sustainable farming R&D exists but not a top shortage."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Food security pillar funds crop-breeding research for climate resilience."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Some demand in ag-biotech startups, yet not explicitly on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-agriculture R&D labs recruit PhDs under HSP fast-track."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "MADANI Economy",
        "reason": "Policy focuses on downstream agro-processing, not fundamental plant science."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Plant scientists on Green List get straight-to-residence visas to support food export sector."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Agri-tech is part of UK’s clean growth grand challenge; Global Talent visas available."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds climate-smart agriculture research, boosting demand for crop scientists."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "National Master Plan 2021-2030",
        "reason": "Country invests in agritech and high-yield crops; foreign researchers welcomed."
      }
    }
  },
  "11e4c94f-9b20-499f-87fc-6e8ae4cdd32c": {
    "career": "Regional Planner",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL includes Urban & Regional Planner (ANZSCO 232611) due to housing and infrastructure shortages."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Urban planners fit the 'construction and transport occupations' grouping used for targeted invitations, but demand is lower than for trades."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Stadtplaner qualify under architecture/engineering shortage lists supporting renewable-energy and housing projects."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital Nusantara drives some foreign planner demand, though government favours domestic hires."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Urban planners not on CSL; demand exists in local authorities but visas use general permit route."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-city and resilience projects allow planners to score highly on HSP points but job volume modest."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industrial park and EV cluster expansion needs spatial planners, yet occupation is not priority-coded."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Green List (Tier 2)",
        "reason": "Urban Planner appears on Tier-2 Green List because of Christchurch rebuild and housing demand."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Vision 2030",
        "reason": "Megaprojects like NEOM, Red Sea and Diriyah need regional planners for land-use, smart-city zoning and transit systems."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Green Plan 2030",
        "reason": "Compact-city expertise valued for carbon-neutral districts, yet local manpower supply keeps quotas tight."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "We the UAE 2031",
        "reason": "Massive mixed-use developments (Expo City, Masdar) require expatriate urban planners for sustainable master plans."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Planning is supportive to clean-energy and housing initiatives but not on core shortage list."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA allocates billions for transit-oriented development, climate-resilient city planning and affordable housing—skills directly supplied by qualified regional planners."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National Master Plan 2021-2030",
        "reason": "National plan stresses urbanization, but immigration preference still leans to manufacturing engineers."
      }
    }
  },
  "c3b7b3d4-ea39-4a4c-8777-c826df83294e": {
    "career": "Social Justice Advocate",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Migration Strategy 2023",
        "reason": "Human-services visas possible but quotas favour healthcare and engineering."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Non-profit workers can get open work permits, yet advocacy is not a priority occupation."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Points-based system values degrees and German skills; advocacy roles exist but no shortage designation."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "41",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Environmental and indigenous-rights NGOs operate but rely on short-term cultural visas."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "NGO roles possible via General Employment Permit; not a critical skill."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Skilled Migrant Category",
        "reason": "Social advocacy roles qualify generally if paid, yet not on Green List."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "National AI Strategy 2.0",
        "reason": "Policy research institutes hire social-policy analysts; activism itself stays tightly regulated."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Large charity sector and global think-tanks sponsor Skilled Worker visas in policy and rights fields."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Community-benefit clauses in IRA projects fund NGOs fighting environmental injustice, but role lacks dedicated visa priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4b68daf3-e320-486e-bbf0-cf9af7d815e0": {
    "career": "Sustainable Fashion Entrepreneur",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Berlin’s circular-fashion hub attracts foreign founders via EU Blue Card for business grads."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "47",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Circular textile pilots in Bandung; founder visas exist under creative-economy category."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Fashion not critical, but Startup Entrepreneur Programme offers residence for high-potential green ventures."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points awarded for founders; Tokyo invests in eco-textiles yet language a barrier."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "NIMP 2030 promotes sustainable textiles; foreign founders receive pioneer-status tax breaks."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Cultural & lifestyle sectors funded under Vision 2030; eco-friendly brands for tourism zones receive grants and work visas."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Green Plan 2030",
        "reason": "EnterpriseSG grants and EntrePass favour ESG-linked fashion tech."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai Design District and ADGM offer Golden Visas to sustainable fashion founders targeting global markets."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry is a named pillar; Innovator Founder visa welcomes circular-fashion startups."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA’s clean-manufacturing tax credits extend to low-carbon apparel plants, aiding eco-fashion startups though not an immigration priority."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Garment export giant interested in green retooling but immigration policy still manufacturing-centric."
      }
    }
  },
  "b0e915b7-84fc-41ee-b0e1-800d33821be0": {
    "career": "Theatre Director",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "Performing Arts Manager on Medium-Term list; sponsorship possible but limited."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Performing-arts workers access short work permits for festivals; not a targeted category."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "State-subsidised theatres constantly scout international directors; Blue Card obtainable with arts degree."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Jakarta arts festivals invite foreign directors on cultural exchange visas."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Arts Council supports foreign co-productions but immigration pathway is general permit."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Highly Skilled Professional visa",
        "reason": "International directors invited for avant-garde festivals, but language barrier and limited positions."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Entertainment Authority hires foreign directors for new performing-arts venues in Riyadh Boulevard and AlUla."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Economy 2030",
        "reason": "Esplanade theatres and NAC grants support foreign directors; Employment Pass straightforward for notable resumes."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "We the UAE 2031",
        "reason": "Dubai Opera and Abu Dhabi Cultural District recruit global directors on long-term Creative Talent visas."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry named pillar; Global Talent visa fast-tracks acclaimed theatre professionals."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "NEA funding rises indirectly via cultural infrastructure, but O-1 visas require extraordinary ability proofs."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "537342d2-e27c-47fc-8b8d-bf5e3b42d47d": {
    "career": "Theoretical Physicist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Global Talent visa list covers quantum science and astrophysics; funding via ARC Centres of Excellence."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Perimeter Institute and TRIUMF recruit global PhDs under academic stream of Express Entry."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Max Planck and DESY fill professorships through Blue Card fast-track for STEM PhDs."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "SFI Centres for Quantum Materials recruit PhDs; Critical Skills permit applies."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "KEK and RIKEN run HSP-eligible high-energy physics labs."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Limited research institutes; visas possible but few openings."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "KAUST funds basic science chairs though focus skews to applied energy."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "National AI Strategy 2.0",
        "reason": "Centre for Quantum Technologies and Nanyang Gravity Group recruit under One-Pass."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "UAE Centennial 2071",
        "reason": "NYU-AD and Sharjah Observatory sponsor quantum/gravity research roles with Golden Visa eligibility."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 names quantum and space science; Global Talent visa supports theoretical physicists."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act injects $200B into fundamental science including quantum and cosmology, with streamlined O-1 visas for top researchers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "cc91bcfc-b643-4155-95f0-b38881197fde": {
    "career": "Accounting Data Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Occupation not on Core Skills List, yet businesses need analysts for GST and ESG reporting."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Tech/data workers welcome but finance analytics not singled out for category-based Express Entry preference."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Can qualify as IT specialist, but not named shortage; German language barrier for finance roles."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "IFSC Dublin seeks data analysts for banking and insurance risk functions—qualifies as ‘ICT professional’."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Qualifies under business analytics but language and local accounting standards limit uptake."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Islamic finance analytics demand growing yet not on priority engineer/scientist lists."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Current Green List focuses on engineers, health, construction—finance analytics absent."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Big push for fintech and transparent public-sector accounting requires analytics talent."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Economy 2030",
        "reason": "Fintech & sustainable-finance hub offers ONE-Pass visas for senior data analysts in banking."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "We the UAE 2031",
        "reason": "Dubai/Abu Dhabi financial hubs actively issue fast visas for data-savvy finance professionals."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London’s financial services and new Sustainability Disclosure rules place analysts on shortage lists."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Demand for data-driven reporting in federally-funded infrastructure projects and wider SEC push for analytics-based disclosure."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "0f1d77b2-4298-4f87-a5cf-df17b65e182c": {
    "career": "Adult Nurse",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "General medical and ICU nurses sit on priority list with expedited visas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "RNs are a headline category; provincial streams fast-track NCLEX-ready nurses."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe nurse shortage; hospitals sponsor language and recognition programmes."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Irish hospitals offer Critical-Skills permits and free adaptation courses for RNs."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "SSW nursing-care pathway open; language test required."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Local supply adequate; foreign RNs restricted outside specialist units."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Registered nurses on straight-to-residence Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "New hospitals and medical cities recruit thousands of expatriate RNs."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Green Plan 2030",
        "reason": "Healthcare expansion exists but foreign nurse slots capped to protect local wages."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Private hospital expansion plus mandatory insurance drive demand for licensed nurses."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Recent policy tightening but NHS still issues visas for adult nurses in critical wards."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No dedicated nurse visa category, yet chronic shortages keep hospitals recruiting internationally."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "0a52a6a8-ab18-4445-8f9b-a4a04767c518": {
    "career": "Analytics Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Migration Strategy 2023",
        "reason": "Data analysts on Core Skills list; managerial tier less explicit but welcomed."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "AI, data scientists and managers prioritised for dedicated work permits."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "IT specialists with no degree path opened; data leadership valued in Industry 4.0 firms."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Digital roles growing but not on 2045 core shortage list yet."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Data scientists/managers on Critical Skills list feeding tech multinationals."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Highly Skilled Professional visa",
        "reason": "Point-based HSP category rewards data and AI leadership, but language hurdle."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industry 4.0 roadmap values data analytics to optimise factories."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Green List focuses on hands-on software roles, not management analytics."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Mega-projects need data leadership for smart-city dashboards and citizen services."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "National AI Strategy 2.0",
        "reason": "Analytics leadership qualifies for ONE-Pass; nation targets 15,000 AI professionals."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai’s ambition to be regional data hub drives demand for analytics managers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital/AI specialists explicitly prioritised; London corporates pay premium for analytics leadership."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds AI/ML research and data infrastructure needing leadership talent."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Priority on semiconductor and energy engineers; analytics managers secondary."
      }
    }
  },
  "cbe9291a-5dfc-42fe-94bd-d3bdb26099cc": {
    "career": "Biotech Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Medical-device and pharma engineers welcomed under generic engineering code."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Biomanufacturing earmarked for expansion, though not yet on formal shortage list."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Bio-pharma clusters in Bavaria and NRW recruit engineers; STEM Blue Card easy."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Biopharma in vision documents but scale-up still nascent."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma giants in Cork and Galway constantly hire bioprocess engineers."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Highly Skilled Professional visa",
        "reason": "Biotech R&D earns maximum HSP points, but language limits clinical projects."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Medical-device and vaccine manufacturing flagged as priority sectors."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Green List omits biotech engineers, focusing on civil and software."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Genomics and vaccine manufacturing flagged as strategic industries needing talent."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Singapore Economy 2030",
        "reason": "Biomed manufacturing is one of four ‘verticals’; generous RIE2025 R&D grants."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Operation 300bn",
        "reason": "Nation building biopharma parks; Golden Visa available for R&D engineers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences pillar targets biologics, cell-gene therapies; fast-track Global Talent visas."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds bio-manufacturing and advanced therapeutics facilities needing process engineers."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National Master Plan 2021-2030",
        "reason": "Government courting biopharma FDI; early-stage talent demand growing."
      }
    }
  },
  "1ba2f201-a859-4c78-91d6-19fcb9485ba9": {
    "career": "Communication Disorders Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Speech pathologists on priority list; visas processed in weeks."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Allied-health professionals, including SLPs and audiologists, receive extra points."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Logopedists in shortage, but B2 German required."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Still developing professional regulation; limited foreign recruitment."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "‘Therapists, speech and language’ explicitly named for Critical Skills permits."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Rehabilitation workers accepted, but language and licensing stringent."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Some demand in private autism centres, not national priority."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Speech-language therapists on straight-to-residence list."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "Rehabilitation centres in mega-projects need speech therapists for stroke and autism care."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Green Plan 2030",
        "reason": "Ageing population drives need, yet foreign therapist quota capped."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "We the UAE 2031",
        "reason": "Private hospitals and special-needs schools sponsor allied-health visas."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "NHS trusts still list speech therapists despite tighter overall healthcare rules."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct policy, but ageing population and school shortages sustain strong demand."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Very small speech-therapy sector; roles filled locally."
      }
    }
  },
  "368f8646-a8b0-43d9-966d-d06e759b5fed": {
    "career": "Composition Consultant",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Strong video-game/anime music sector but no dedicated visa preference."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Entertainment push funds concerts and festivals requiring composition experts."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "UAE Centennial 2071",
        "reason": "Diversifying into media production creates some demand for music consultants."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry growth and tax incentives keep music advisory roles in demand."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Large entertainment sector needs music advisors, but no federal talent policy prioritises the role."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4cd218de-cd48-4330-8dbb-949b656189aa": {
    "career": "Construction Admin Manager",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Chronic shortage of construction project managers on the CSOL."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Construction supervisors are prioritised for housing and transit projects."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Permits and site-documentation staff needed for large energy and rail builds."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "New capital Nusantara fuels demand for construction coordination staff."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Construction boom exists yet visa priority targets engineers more than admin leads."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "SSW covers construction support, though language requirement is steep."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Infrastructure push needs talent but quota caps keep scores moderate."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Fast-track residency for construction project managers and QS roles."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Giga-projects like NEOM require bilingual admin managers to control costs and permits."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Operation 300bn",
        "reason": "Ongoing megaprojects drive need for document control and contracts management."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Role isn’t on Shortage List, but private contractors recruit internationally."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Massive federal infrastructure spend boosts demand for project support roles."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Transport mega-projects open limited mid-level admin slots."
      }
    }
  },
  "ef0a95bb-9da9-4bdd-baf5-b0896befec00": {
    "career": "Cultural Heritage Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Some demand via state-sponsored visas for museum curators, but limited slots."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Express Entry favours STEM; heritage roles can enter only under general streams."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Historic preservation grants open niches for qualified foreigners."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "RPJPN 2025-2045",
        "reason": "Borobudur and new capital museum plans create some roles."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Heritage tourism is important but not on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "World-heritage sites employ foreigners through regular cultural visas, not fast-track."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Cultural tourism growth but no special visa category."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Heritage positions exist yet not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "AlUla, Diriyah and Red Sea projects urgently seek global heritage experts."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "UAE Centennial 2071",
        "reason": "New museums and cultural districts require experienced heritage managers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Lottery-funded restorations and tourism sustain steady need, but visa route is general skilled worker."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "National Park Service and private museums hire, yet no visa priority."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Hue and Hoi An projects hire specialists on ad-hoc contracts."
      }
    }
  },
  "f678f5d7-5a19-45f1-9991-9ed752fd8e9b": {
    "career": "Digital Finance Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Demand exists but Migration Strategy lists focus on core tech, not finance niche."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Fintech professionals can get dedicated work permits in Toronto and Vancouver hubs."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Fintech clusters in Berlin/Frankfurt recruit under general IT quotas."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Cashless-payments drive new roles, but local talent preferred."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Fintech engineers and analysts on critical list for Dublin’s payments ecosystem."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Tokyo’s fintech sandbox opens opportunities, but language remains a hurdle."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "MADANI Economy",
        "reason": "Islamic digital banking is a declared national priority for 2030."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Roles possible in small fintech startups but no visa priority."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Fintech growth targets cashless society; specialists welcome under fast visas."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Singapore Economy 2030",
        "reason": "Fintech and digital payments are explicit pillars with fast pass programmes."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "DIFC and ADGM position UAE as regional fintech hub with golden visas."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "London remains Europe's fintech capital with startup and big-bank demand."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Wall Street embraces fintech talent, though not directly incentivised by recent federal acts."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "National Master Plan 2021-2030",
        "reason": "Fintech startups growing yet immigration channels are generic tech visas."
      }
    }
  },
  "c13be6cd-70f9-4d93-ba58-cebfaeba2561": {
    "career": "Film Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Screen Australia growth creates some roles, but not on CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Streaming analytics jobs exist, yet arts are outside priority categories."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Small but growing film tax-credit scene needs limited analytics talent."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Anime and film studios use analysts, but language barrier limits foreign visas."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Vision 2030",
        "reason": "New cinemas and production houses create demand for market analysts."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai Media City offers roles analysing regional box-office trends."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry priority list covers film data and audience analysts."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "",
        "reason": "Hollywood studios hire analysts for box-office forecasting, but no immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "eafae84a-4acb-4863-91aa-f8a29b509aff": {
    "career": "Forensic Technologist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL lists forensic scientists under medical laboratory science shortages."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Classified with medical laboratory technologists on priority list for policing and justice."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Open recognition system for STEM lab specialists, including forensics."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Lab scientists welcome, though forensic sub-discipline not separately flagged."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Highly Skilled Professional visa",
        "reason": "Falls under life-science researchers eligible for fast-track HSP points."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Related to ‘laboratory scientist’ occupation, but not explicitly on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Vision 2030",
        "reason": "Security sector hires forensic labs, but no dedicated migration priority."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "We the UAE 2031",
        "reason": "Forensic labs serve policing; specialists obtain Golden Visa under ‘scientists’ category."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences R&D pillar covers advanced forensic analytics, but shortage not acute."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "CHIPS and Science Act",
        "reason": "Federal funding boosts forensic-lab instrumentation and STEM immigration pathways."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "860a5a13-c508-4c06-9028-aa5384eff57e": {
    "career": "Gender and Media Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Creative-industry academics can qualify under university sponsorship, not on shortage list."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Government funds diversity content auditing; open to social-science talent."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Points for social-science degrees; no explicit media-gender priority."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Universities hire gender-media lecturers via standard academic visas."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "Skilled Migrant Category",
        "reason": "Academic social scientists meet points threshold but not ‘Green List’."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "15",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Economy 2030",
        "reason": "Media diversity consultancies exist but are niche; no shortage status."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry pillar funds diversity consultants for film, TV and gaming."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "CHIPS and Science Act",
        "reason": "Universities receiving STEM equity grants seek gender-media researchers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "66e6434c-0233-4afa-9289-7806ae7ad1a0": {
    "career": "Global Development Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Dev-sector hiring possible via employer sponsorship, not on core shortage list."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Management professionals with French gain extra CRS points for international NGOs based in Ottawa."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "GIZ and KfW recruit globally for development programmes."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital build creates some multilateral project roles."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Irish Aid HQ welcomes specialists under general management code."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "JICA recruits HSP-qualified project leads."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "MADANI Economy",
        "reason": "Focus on domestic industrialisation; global-dev managers hired case-by-case."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Skilled Migrant Category",
        "reason": "Pacific-focused aid agencies based in Wellington hire but numbers small."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Saudi Fund for Development finances overseas projects and needs managers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Green Plan 2030",
        "reason": "Regional NGOs coordinate climate projects from Singapore hub."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai hosts many humanitarian NGOs and multilateral offices."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "FCDO and private consultancies manage global climate and infrastructure funds."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "USAID and MCC scale infrastructure aid, seeking seasoned project managers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "25985bc7-549d-4786-b15f-341c0d9f46da": {
    "career": "HR Developer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Migration Strategy 2023",
        "reason": "Corporate trainers can obtain employer-sponsored visas; not on CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Management professionals welcome but no dedicated stream."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Large manufacturers hire talent-development leads; standard Blue Card route."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "HR roles generally processed under standard permits, not critical list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Highly Skilled Professional visa",
        "reason": "Large firms seek bilingual HRD for global workforce integration."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Skilled Migrant Category",
        "reason": "HR professionals gain points but face tight caps."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Mega-projects need expatriate experts to upskill national workforce."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Economy 2030",
        "reason": "SkillsFuture and national upskilling push increase demand for corporate L&D experts."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Knowledge-economy push offers Golden Visas to talent-development leaders."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Skills pillar funds corporate L&D, but shortage list excludes HR roles."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Massive reskilling funds for green jobs boost demand for workplace learning designers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "bf94af61-1bd2-401c-8742-4a3a06534d41": {
    "career": "International Real Estate Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Employer-sponsored visas for property development but not on CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Provincial nominee programmes target property-development experience in growth cities."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Commercial property funds need asset managers; Blue Card possible."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "New capital Nusantara drives need for global property expertise."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Commercial property funds hire, but visas processed under generic manager codes."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industrial park expansion opens some roles to foreign asset managers."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Mega-projects (NEOM, Red Sea) aggressively recruit international real-estate leadership."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Singapore Green Plan 2030",
        "reason": "Carbon-neutral building push demands internationally experienced asset managers."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s global property hub offers Golden Visas to senior real-estate professionals."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "London capital markets and regeneration projects need cross-border asset managers."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Large-scale housing and commercial redevelopment seeks global capital managers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "National Master Plan 2021-2030",
        "reason": "FDI in industrial realty creates selective demand, local language a hurdle."
      }
    }
  },
  "cc6b24eb-d7f2-4b4e-acfd-378de82aeefb": {
    "career": "Middle Childhood Educator",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Primary and early-childhood teachers are listed as critical; state sponsorship available."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Primary teachers are explicitly targeted; fast-track PR for French and English educators."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe shortage of Grundschule (primary) teachers; streamlined visa and recognition pathway."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Primary educators absent from list; general work permit route only."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Primary teachers appear on Green List; permanent residency after two years of work."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Teachers removed from shortage list 2025; sponsorship still possible but no fast track."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Federal funds modernise schools but teachers are not on any national shortage or visa-priority list."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "90cc845f-f9fc-4515-b675-e054684a5f32": {
    "career": "Network Defense Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "‘ICT Security Specialist’ on CSOL, giving 482/189 visa priority."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Cybersecurity professionals are explicit priority; quick PR if CRS met."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT-Security experts get Blue Card with lower salary threshold."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "RPJPN 2025-2045",
        "reason": "EV and fintech growth implies cyber need but immigration bureaucracy heavy."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Cybersecurity specialist listed; direct Critical Skills Permit."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP covers AI/ML; cyber accepted but not explicit priority."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "MADANI Economy",
        "reason": "Digital security needed for semiconductor supply chain but visa routes generic."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "No specific cyber shortage listing; points route only."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Cybersecure smart cities and fintech push create demand but localisation rules apply."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "National AI Strategy 2.0",
        "reason": "Cybersecurity and AI listed among key manpower shortages; COMPASS framework rewards these skills."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Operation 300bn",
        "reason": "Banks and energy firms seek cyber talent; Golden Visa available but not automatic."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Digital/cyber specialists are on Shortage List, easing visa salary floor."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA funds cybersecurity for critical infrastructure but no dedicated visa stream."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Government focuses on semi fabs; cyber demand growing yet policy silent."
      }
    }
  },
  "282b3be1-ae42-441e-b944-b73c33cb26ad": {
    "career": "Pharmacy Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Pharmacists often added to state occupation lists even if not on core CSOL."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Chronic pharmacist shortages in rural Canada; provinces sponsor through provincial nominee streams."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Aging population drives demand; licence recognition pathway exists but complex."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharmacists not on list; general work permit still possible."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Pharmacists need NZ registration; not on Green List but points route available."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Hospital expansion and pharma localisation create pharmacist leadership demand."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Singapore Green Plan 2030",
        "reason": "Foreign pharmacists can register but MOH quota keeps numbers small."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Healthcare hubs in Dubai and Abu Dhabi seek experienced pharmacy managers."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Pharmacist roles appear intermittently; sponsorship possible but no dedicated fast track."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA touches drug pricing but pharmacists not on immigration priority lists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "795c1378-aa5d-4720-a007-5ed2c8748f58": {
    "career": "Seismologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "Mineral exploration hires geophysicists, yet seismology not on core list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Research roles exist but not immigration priority; points route only."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Research funding available, but not a defined shortage occupation."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "RPJPN 2025-2045",
        "reason": "Ring of Fire risk drives need for quake monitoring in new capital."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Highly Skilled Professional visa",
        "reason": "Earthquake research is national priority; HSP gives fast-track residency."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Migrant Category",
        "reason": "Quake-prone nation sponsors earth-science researchers within Crown institutes."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Limited to academic posts; not on Shortage List."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA funds earthquake-resilient infrastructure, boosting federal research hiring."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "7278a653-2cb5-44b0-baa6-89e644b3321e": {
    "career": "Agricultural Economist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Farm-gate profitability and drought economics drive state-nominated visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Agri-policy analysts valued, especially bilingual French/English."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Agricultural economists hired, but not shortage listed."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Food security and agri-productivity are top pillars; economists sought for policy design."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Agri-food is major export, but economists not on critical list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP favours biotech researchers over agricultural economists."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Palm-oil sector uses economists; however, not an immigration focus."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Dairy industry employs economists; points route only."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Vision 2030",
        "reason": "Focus on food import logistics rather than agri economics talent."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Green Plan 2030",
        "reason": "High-tech urban farming hires scientists, not macro-level agri economists."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Some roles in DEFRA and consultancies; no shortage designation."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds climate-smart agriculture; USDA hires economists but no visa priority."
      },
      "vietnam": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "National Master Plan 2021-2030",
        "reason": "Plan calls for agri-value chain optimisation and export market modelling."
      }
    }
  },
  "d772e45a-4db2-475f-9792-8cea0654dedb": {
    "career": "Atmospheric Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Environmental scientists eligible for skilled visas; bushfire and flood forecasting needs are acute."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Express Entry Category-Based Selection",
        "reason": "STEM stream lists environmental scientists; federal climate-adaptation budget boosts hiring in Environment & Climate Change Canada."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Renewable-energy expansion and flood-risk projects require atmospheric data specialists."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Occasional openings in Met Éireann; not a named critical skill."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Typhoon forecasting and satellite meteorology attract highly-skilled visas though not on SSW lists."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 2)",
        "reason": "NIWA and MetService struggle to fill climate-science roles; immigration list covers environmental scientists."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Mega-projects in desert regions need dust-storm and rainfall modelling but role is peripheral to core priorities."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Green Plan 2030",
        "reason": "Sea-level rise studies require climate modellers, but role sits outside top-tier manpower targets."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Cloud-seeding and coastal-flood studies create some demand yet not on official priority lists."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Met Office and offshore-wind planning depend on mesoscale modelling; STEM shortage visas available."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Extreme-weather resilience and climate-data modernization funds create sustained demand for meteorologists and climate modellers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "e1f0c3fe-aea8-46eb-9c83-7e744fcd061c": {
    "career": "Biomaterials Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Med-tech startups in Melbourne/Sydney use skilled visas for biomaterials R&D staff."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Biotech clusters in Toronto and Vancouver recruit under the STEM and French-speaker streams."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "MedTech Valley and Fraunhofer institutes offer visa-fast-track for biomedical engineers."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "RPJPN 2025-2045",
        "reason": "Healthcare R&D still nascent; few specialised visas available."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Galway–Limerick med-device corridor urgently needs biomaterials scientists for stents and orthopedic implants."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "67",
        "policy": "Highly Skilled Professional visa",
        "reason": "Aging population drives demand for regenerative medicine; HSP points favour PhDs."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan lists medical devices and advanced materials as priority industrial clusters."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Limited but growing demand in orthopedic-device firms; points system applies."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Biotech is emerging yet still peripheral compared with energy and construction."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Economy 2030",
        "reason": "Biomed manufacturing and A*STAR grants place biomedical scientists in top-tier manpower demand."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Operation 300bn",
        "reason": "Some incentives for med-tech manufacturing in Dubai Science Park, but not a headline shortage."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences pillar funds biomaterials and regenerative medicine, with Skilled Worker visas fast-tracked."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA allocates billions to biomanufacturing and advanced materials, fuelling demand for tissue-engineering researchers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Biomaterials outside current tech-policy focus."
      }
    }
  },
  "25c21bc1-2875-42dc-adcf-3d9f1f2acaa6": {
    "career": "Clinical Counselor",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Migration Strategy 2023",
        "reason": "Chronic rural mental-health shortages place counsellors on state nomination lists."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Care-economy stream explicitly lists counsellors and therapists as priority occupations."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Mental-health roles exist but language and licensing barriers keep them off federal shortage lists."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Counsellors are not on the list though individual HSE hospitals recruit internationally."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Mental-health counselling not covered by SSW and language licensing is tough."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "MADANI Economy",
        "reason": "Growing private sector, but foreign counsellors need local psychology board recognition—slow visas."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Counsellors qualify directly for work-to-residence visas due to acute shortages."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Rapid expansion of private hospitals includes mental-health wings needing bilingual therapists."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Green Plan 2030",
        "reason": "Healthcare manpower includes counsellors but tight local licensing keeps it tertiary priority."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "UAE Centennial 2071",
        "reason": "Wellness and tele-health boom drives demand for licensed counsellors, especially in Dubai Healthcare City."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "IAPT program hires counsellors but updated shortage list now favours psychologists over counsellors."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Post-pandemic mental-health grants are funneled through community clinics hiring licensed counselors."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "0f00a44c-2526-4392-9dd9-b7a830c4f553": {
    "career": "Development Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "DFAT outsources Pacific-aid projects but role not on core skills list."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Ottawa funds Indigenous and global-south development programs needing policy consultants."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "GIZ hires foreign experts for Africa/Asia programmes; points system recognises experience."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "RPJPN 2025-2045",
        "reason": "Some need for expatriate advisors on climate finance, but bureaucratic hurdles."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Irish Aid HQ is small; development consulting rarely on critical list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "JICA prefers bilingual staff; visa still possible under HSP generic category."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "MFAT has limited openings; not visa-prioritised."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Social-development initiatives contract advisors yet localisation plan limits foreign intake."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Economy 2030",
        "reason": "Regional HQs of NGOs hire policy consultants although not on manpower priority list."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai’s philanthropy and sustainability offices engage consultants, but not a formal shortage."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "FCDO and big consultancies deliver global-development work; Skilled Worker visas common."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "USAID and MCC contract consultants for climate-smart and governance projects aligned with IIJA’s global outreach funds."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "542be249-7cdd-458a-9b1e-74137b31eb63": {
    "career": "ESL Instructor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Migration Strategy 2023",
        "reason": "EAL teachers needed in schools but role is state-nominated not national priority."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "French-immersion teachers prioritized; generic ESL instructors rarely score enough CRS points."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "RPJPN 2025-2045",
        "reason": "Tourism and digital-economy goals fuel steady hiring of foreign ESL teachers."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Seasonal summer-school demand but no critical skills recognition."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Japan’s Instructor visa stream hires thousands for JET and private eikaiwa schools."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "International schools recruit ESL teachers, yet expat quotas tightening."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "International student market drives limited ESL demand; not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "Universities and new tourism hubs aggressively recruit native-level English instructors for workforce upskilling."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Economy 2030",
        "reason": "Some adult-education roles, but Employment Pass salary floor limits entry-level teachers."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Private K-12 and adult institutes in Dubai/Abu Dhabi frequently sponsor ESL work visas."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "National Master Plan 2021-2030",
        "reason": "Government pushes English proficiency; private centres sponsor work permits for TEFL holders."
      }
    }
  },
  "ff6064ec-a3d6-4c15-8caf-9a51c544ad75": {
    "career": "Fundraising Officer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Can enter through points system, but role absent from Core Skills Occupation List."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Charities hire fundraisers, yet not on health/tech priority lists so only general skilled-worker route."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Cultural NGOs may sponsor, but fundraising not an official shortage occupation."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Role not on list; only standard work permit route."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Possible via general points, yet not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Mega-projects (NEOM, AlUla) hire arts/culture fundraisers to secure global sponsorships."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "We the UAE 2031",
        "reason": "Philanthropy hubs in Dubai and Abu Dhabi seek experienced fundraising talent for culture and development causes."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries valued, but fundraising officers not on shortage list; sponsorship still possible."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Large nonprofit sector and O-1 visa for artists, but no federal priority scheme for fundraising roles."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "1efd01ef-b4a3-477b-bc9f-c2fcf4b04a4c": {
    "career": "Health Program Administrator",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Migration Strategy 2023",
        "reason": "State health systems list Health Services Manager as medium-long term skill shortage."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Healthcare management accepted under NOC 30010; provinces nominate for hospital backlog reduction."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Hospitals may sponsor, yet administrators not explicitly prioritised like nurses."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Healthcare PPPs welcome foreign expertise yet quotas apply."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Healthcare managers outside CSL; relies on general employment permit."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Hospitals prefer Japanese-speaking managers; limited foreign intake."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Private hospitals expanding, but no dedicated visa priority."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Migrant Category",
        "reason": "Te Whatu Ora recruits managers to streamline regional health reforms."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "New private hospitals and giga-projects need programme managers to meet JCI accreditation."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "MOH hires some foreigners, but EP quotas and local alignment needed."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Dubai Health Strategy calls for experienced admins to scale medical tourism."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "NHS hires, but role not on shortage list; sponsorship possible yet competitive."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Demand in hospitals, but federal immigration priorities target clinicians not managers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Growing health sector but local language/legal knowledge essential."
      }
    }
  },
  "3bfaebe0-c622-4e70-abff-419641a42b00": {
    "career": "Jazz Performer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Entertainment visas available yet project-based and temporary."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Artist residencies exist, but immigration prioritises tech and health."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Berlin offers freelance artist visas; strong jazz club circuit."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Seasonal festival gigs; long-term visas rare."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Highly Skilled Professional visa",
        "reason": "Tokyo and Osaka jazz scenes hire international acts; cultural visa possible."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Small scene, limited visas for musicians."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Entertainment push creates steady gigs in tourist mega-projects."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Club circuit exists but short-term employment passes only."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s luxury hotels and Expo City book foreign jazz acts."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry priority lists senior musicians; Tier 5 Creative visa route."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "",
        "reason": "O-1/B-1 visas and vibrant jazz economy in NYC, New Orleans, Chicago."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "aae1176f-675e-4c49-b097-97773b8b247e": {
    "career": "Medical Technologist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Medical Laboratory Scientist on Medium-Long Term Skill Shortage List with state sponsorship."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Medical laboratory technologists on priority healthcare list; fast-track PR pathways."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe lab workforce gap; Berufsanerkennung process recognises foreign degrees quickly."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "New hospitals in Nusantara plan to recruit some foreign lab talent."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Clinical measurement scientists and med-lab scientists on CSL enabling Critical Skills Permit."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Highly Skilled Professional visa",
        "reason": "Ageing population pushes demand; English-speaking labs in pharma R&D recruit foreigners."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "MADANI Economy",
        "reason": "Medical device clusters need lab staff, but licensing still required."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Medical Laboratory Scientist on Tier 1 Green List—straight-to-residence visa."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "New specialist hospitals require certified lab professionals and will sponsor visas."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Biomedical hub needs specialist technologists; MOH issues conditional registration."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "We the UAE 2031",
        "reason": "Health tourism growth drives demand; DHA and HAAD licence pathways available."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "NHS lists biomedical scientists on shortage list despite broader healthcare cuts."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "",
        "reason": "Hospitals face lab staff shortages, but federal tech bills exclude clinical roles."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Demand rising but local licensing and language barriers slow foreign recruitment."
      }
    }
  },
  "13f1bfde-3b9d-4212-99fa-46e6249c9437": {
    "career": "MIS Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Migration Strategy 2023",
        "reason": "ICT Business Analyst on Medium-Long Term Skill Shortage List."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "IT business analysts listed under tech category draws dedicated invitations."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT Spezialist pathway waives degree requirement if proven skills."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "RPJPN 2025-2045",
        "reason": "ERP rollout in state-owned enterprises fuels demand for MIS skills."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "ICT Business Analyst on CSL with Critical Skills Permit fast-track."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "Enterprises adopting ERP/SAP need bilingual MIS experts."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industry 4.0 push values MIS for factory data integration."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Role exists but not on Green List; standard points route."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Digital transformation of ministries creates openings, but Saudization quotas apply."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "National AI Strategy 2.0",
        "reason": "Financial and logistics sectors hire MIS pros for data governance; EP quotas favourable for tech."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Operation 300bn",
        "reason": "Smart manufacturing projects need MIS integration for ERP and supply chains."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital/cyber cluster around London and Manchester actively sponsors IT specialists."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Digitisation of public infrastructure and supply chains drives demand for MIS talent."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "National Master Plan 2021-2030",
        "reason": "E-commerce giants and fintechs sponsor systems analysts."
      }
    }
  },
  "88616cd7-9ad6-448c-8e69-e93e25c4c282": {
    "career": "Nutrition Advocate",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Some states list dietitians on CSOL, but competition is moderate."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Dietitians are classified as allied health and receive additional CRS points."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Act allows allied health workers; recognition process for dietitians exists but shortages are not acute."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Critical Skills List excludes nutrition; general work permit route only."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Dietitians appear on Tier 2 Green List, easing work-to-residence pathway."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "National AI & Healthier SG encourage preventive care, but the role is not on priority list."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "UAE promotes lifestyle medicine, but visas favour physicians over nutrition advocates."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Dietitians not on Shortage List and Modern Industrial Strategy does not mention them."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Public-health nutrition is valued but not directly incentivised by CHIPS, IRA or IIJA."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b28bd002-cea4-465f-a41f-5eb4f17b5670": {
    "career": "Science Outreach Specialist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Not on priority lists; niche hiring by museums only."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Science communication valued, but immigration priority lies elsewhere."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Singapore Science Centre hires few foreign outreach staff; visa facilitated only if unique."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "UAE Centennial 2071",
        "reason": "Space-sector PR needs communicators, yet quotas are small."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry cluster supports public science events, but no visa concessions."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds STEM public-engagement programs for NSF and NASA."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "9147c573-2b0a-43c8-9e77-57dfe6932721": {
    "career": "Academic",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Migration Strategy 2023",
        "reason": "Universities obtain streamlined visas for research academics."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Canadian universities actively recruit humanities PhDs under global talent streams."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Card awards points for PhDs; DAAD funds Asian Studies chairs."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Third-level lecturers qualify for Critical Skills work permits."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "PhDs receive high HSP points, though positions are few."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Universities hire selectively; no priority list advantage."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "New cultural institutes hire foreign scholars to boost soft power."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Economy 2030",
        "reason": "Asia-focused research centres at NUS/NTU secure passes for renowned scholars."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Branch-campus universities recruit niche humanities staff."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Global Talent visa streamlines hiring of academics with PhD and publications."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Universities receive large grants for area studies and international collaboration, easing J-1/H-1B hires."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "cbba00f7-0598-42f7-b20b-99c7ee1cd4f9": {
    "career": "CPA Accountant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Accountants removed from Priority Migration list in 2024."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Accountants fall under general Skilled Worker, no category-based boost."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Chartered accountants explicitly listed, easing permit process."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "",
        "reason": "Accountants on non-priority skills list with standard points requirement."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Large projects need IFRS specialists, but Saudization quotas apply."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Singapore Green Plan 2030",
        "reason": "Growth in sustainable finance needs auditors, but not core Tier 1."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Operation 300bn",
        "reason": "Financial-services expansion in DIFC requires qualified CPAs for audit oversight."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Senior accounting and audit professionals qualify for Skilled Worker visas with fast-track."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Finance roles not covered by CHIPS, IRA, or IIJA but labour demand persists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "d19c1731-1e03-401f-b275-1fccb4c6a552": {
    "career": "Global Health Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "Healthcare shortages include dentists and public-health specialists."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Dentists and public-health professionals receive priority points and faster PR."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Act streamlines licensing for foreign dentists, especially in rural areas."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Dentists listed; HSE struggles to fill community-oral-health roles."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Dentists on Tier 1 with direct residence pathway; public-health focus after COVID-19."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Vision 2030",
        "reason": "Massive hospital expansion and preventive-care programs recruit international dental experts."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Specialists may obtain conditional registration but quotas are low."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Dubai Health Strategy seeks global oral-health advisors."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Public-health dentists qualify for Health and Care visa though not on IS-8 list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Dental public-health experts welcomed by NGOs, but no federal talent program."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "236aa99a-9985-42e7-a706-5ee5fe84971f": {
    "career": "Health Systems Manager",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Hospital and aged-care managers appear on CSOL; employers sponsor visas quickly for experienced administrators."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Healthcare management falls under severe-shortage health occupations explicitly prioritized for fast-track permanent residence."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Hospitals facing nurse/doctor shortages also recruit non-clinical managers; new Act eases residence for degree-holders in health fields."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List covers doctors and nurses but not managers; work permits possible yet not fast-tracked."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "List covers health service managers allowing streamlined Work to Residence, though quotas smaller than Canada/Australia."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Vision 2030",
        "reason": "Gigantic hospital projects (NEOM Health, King Salman Medical City) aggressively import experienced health administrators."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Green Plan 2030",
        "reason": "World-class hospitals recruit some foreign managers, but quota tight and policy focus elsewhere."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "We the UAE 2031",
        "reason": "Plan targets world-class healthcare hubs; golden visas for medical leaders include hospital management professionals."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Clinical roles prioritized; non-clinical managers must show higher salaries and compete with domestic NHS leadership track."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Act funds hospital modernization but does not include dedicated visa routes; roles available yet immigration path indirect."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "167b3db4-6be6-4992-8944-abb14309c071": {
    "career": "International Finance Analyst",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Strategy focuses on tech rather than generic finance; openings exist but not prioritised."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech and sovereign wealth fund open roles but bureaucratic work-permit process."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List names financial services quants and analysts; fast two-year Critical Skills permit to PR."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Tokyo Global Finance Hub offers incentives, yet language and CFA-level skill expected."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Islamic finance expansion creates analyst demand, though salaries lower and visas employer-tied."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Emerging Riyadh financial hub creates roles, but preference for experienced Western expats."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Singapore Economy 2030",
        "reason": "Sustainable finance and fintech strongly backed; EP fast-pass for high-earners but quotas getting tighter."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai and Abu Dhabi push to be global finance centres, offering golden visas for analysts in DIFC/ADGM."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London financial services explicitly listed; Skilled Worker visas abundant for qualified analysts."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Act spurs clean-energy investments needing analysts, but no visa fast-track—H-1B lottery still bottleneck."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "c56862b4-2f26-4fe8-acfa-36b1afe9f01b": {
    "career": "Logistics Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Freight and warehousing planners on CSOL; employer sponsorship common in ports and mining supply chains."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Transport occupations and supply-chain analysts directly listed for priority PR draws."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "New points card covers supply-chain professionals but demand moderate and German language valued."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital Nusantara needs supply-chain planners; bureaucracy poses delays."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List prefers engineers; logistics analysts can obtain General Work Permit but slower."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "SSW covers warehousing; analyst roles exist but language is hurdle."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan emphasises smart logistics for semiconductor exports; MNCs sponsor talent."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Ports and dairy exporters need analysts but numbers small."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Vision 2030",
        "reason": "Mega-projects and new free-zones require data-driven logistics planners; tax-free packages, fast visas."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Economy 2030",
        "reason": "Sea-air multimodal hub invests heavily in supply-chain analytics; COMPASS visa system favours qualified analysts."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "We the UAE 2031",
        "reason": "Dubai aims to remain top logistics hub; golden visas for supply-chain professionals."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Shortage of HGV planners and warehouse managers post-Brexit opens analyst roles with sponsorship."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Freight network upgrades spark analytics roles, yet no immigration focus."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "National Master Plan 2021-2030",
        "reason": "Manufacturing boom drives logistics analytics demand; visas possible but through employers."
      }
    }
  },
  "dd18160a-b2ef-49bb-9203-1857a0072e40": {
    "career": "Marketing Illustrator",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Entertainment & tourism push needs visual branding; visas granted for experienced creatives."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Economy 2030",
        "reason": "Advertising hub uses EP for senior illustrators but quota limits entry."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "We the UAE 2031",
        "reason": "Dubai Media City actively imports illustrators for global campaigns; freelance visas available."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry seniors prioritised; Global Talent visa covers accomplished illustrators."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "No policy link; freelance visas scarce but creative gig market large."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "ccb4c563-7df6-4fe5-83ee-9b32822ae8e7": {
    "career": "Mechanical R&D Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Mechanical engineers listed, particularly in mining equipment and renewables."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Strategy pulls in engineers for cleantech and robotics; Global Talent Stream fast-tracks visas."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Auto and machinery giants urgently recruit R&D engineers; Blue Card process streamlined."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel/EV battery plants require mechanical design talent, but permitting slower."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List highlights other engineering disciplines; mechanical R&D possible but not prioritised."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics and precision machinery giants like Fanuc and Toyota heavily hire foreign R&D engineers."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan prioritises aerospace and EV mechanical R&D, offering 5-year Residence Pass for experts."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "List focuses on civil and structural; mechanical R&D roles exist but limited."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "NEOM and giga-projects demand novel HVAC and mobility systems developed by mechanical R&D talent."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Manufacturing 2030",
        "reason": "Precision-engineering hiring ongoing yet software/electronics dominate Tier 1 slots."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Operation 300bn",
        "reason": "Industrial strategy needs engineers for manufacturing R&D, yet numbers smaller than Germany/US."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean-energy and aerospace clusters seek mechanical R&D engineers; visas available via Skilled Worker."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Act funds advanced manufacturing and EV R&D, with National Lab openings and NIW green cards for researchers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Manufacturing growth opens some mechanical R&D slots but focus is electronics."
      }
    }
  },
  "6bfe758b-b73f-49ab-933e-69784e9c2cc3": {
    "career": "Mechanical Systems Integrator",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "List names mechanical engineers for defence, mining equipment and infrastructure builds."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Mechanical engineers are on the skilled-trades stream supporting automotive and clean-tech manufacturing expansion."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Acute shortage in automotive and industrial machinery sectors looking for system-level integration talent."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "RPJPN 2025-2045",
        "reason": "EV-battery and mining refineries add some mechanical demand, yet electrical/chemical dominate hiring lists."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Civil and electrical get priority; mechanical only sometimes sponsored."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robot and auto majors hunt for system-integration experts to link mechanics with AI."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Semiconductor equipment and aerospace clusters seek mechanical talent, albeit in smaller numbers."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Civil focus dominates, but mechanical roles still earn points for residency."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Gigaprojects (NEOM, Red Sea) demand HVAC and plant-room integration, though locals preferred first."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Manufacturing 2030",
        "reason": "Precision-engineering hub creates some need, but priority goes to semiconductor and robotics specialists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Operation 300bn",
        "reason": "Advanced-manufacturing push needs multidisciplinary mechanical talent, but visa slots limited."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Aerospace and EV supply-chain investment values mechanical systems integrators."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Massive funding for transport, energy and advanced-manufacturing plants needs engineers who can stitch mechanical, electrical and control systems together."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "47",
        "policy": "National Master Plan 2021-2030",
        "reason": "Electronics assembly lines need integrators but policy focus is more on electrical/software."
      }
    }
  },
  "868f7b4c-f707-47d0-ae51-94c8bc35ecc2": {
    "career": "Pharmacology Project Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Niche demand in growing med-tech sector but not on top shortage lists."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Biopharma clusters in Toronto and Montréal actively sponsor clinical-trial managers."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Biotech hot-spots (BioNTech, Bayer) recruit global drug-development PMs."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Biopharma ambitions early-stage; preference for local pharmacists."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Nine of the top ten pharma multinationals run plants and trials, urgently needing project managers."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "Ageing population drives drug innovation; PMs with English/Japanese are prized."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "MADANI Economy",
        "reason": "Generics and halal-pharma investments open project roles."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Small pharma market; occasional roles in university spin-offs."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Local manufacturing push exists, yet regulatory environment still maturing for complex trials."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Singapore Economy 2030",
        "reason": "Biomed hub needs global talent to run multicountry trials."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Biotech free-zones expanding but demand still modest."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "‘Life Sciences Superpower’ plan funds R&D campuses, creating many programme-management posts."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Life-sciences tax credits and reshoring funds fuel drug-development pipelines needing experienced PMs."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Pharma focus is manufacturing generics, not clinical pipeline management."
      }
    }
  },
  "f03f497a-0ad7-4e15-87f2-ef5e6161844e": {
    "career": "Physiotherapy Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Migration Strategy 2023",
        "reason": "Physio teaching–research roles on health occupation lists."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Aging population drives demand for rehab research; universities sponsor visas."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Rehabilitation science institutes need international post-docs."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Limited funding for academic health research; priority elsewhere."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Clinical physios on list; dedicated researchers fewer but still sponsored."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Sports-science labs hire foreign PhDs, though language barrier high."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Emerging health-tech research parks include some rehab efforts."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "69",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "ACC-funded injury research spurs university hiring."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Singapore Economy 2030",
        "reason": "Agency for Science, Technology & Research funds mobility and ageing studies."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "We the UAE 2031",
        "reason": "New academic hospitals recruit selectively for rehab research."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "NHS/UKRI fund musculoskeletal research, yet not a listed shortage."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "CHIPS and Science Act",
        "reason": "Bill boosts general scientific research funding, including NIH rehab science grants."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "National Master Plan 2021-2030",
        "reason": "Healthcare focus is clinical service, not research."
      }
    }
  },
  "ae5beeff-52e4-4680-b123-c45d7d5ad89f": {
    "career": "Security Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Nation lists cyber specialists as critical for defence and banking."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Cybersecurity occupations receive fast-track invitations under tech streams."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Industrial digitalisation fuels demand for infosec talent."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech boom wants security skills, yet work visas tightly capped."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Dublin’s data-centre cluster recruits security analysts aggressively."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "Tokyo exchanges and robotics firms seek English-speaking cyber staff."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industry 4.0 adoption needs security, but salaries lower."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "CERT NZ shortages create steady visa sponsorships."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Fintech and defence digital programmes hire global cyber experts."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "National AI Strategy 2.0",
        "reason": "Smart Nation goals elevate cybersecurity alongside AI."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Operation 300bn",
        "reason": "Smart-city and banking initiatives treat cybersecurity as top talent gap."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital and AI pillars emphasise cyber resilience, especially in finance."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds national cybersecurity R&D and chip-level security, driving hiring."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Growing but still emerging cyber market."
      }
    }
  },
  "0f51365b-816b-46a0-b550-65020fd4ddbe": {
    "career": "Software Architect",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Digital skills shortage list explicitly names software and cloud architects."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Software engineers are the largest tech immigration stream; architects receive highest salary offers."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Industry 4.0 programmes seek system-level software planners."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "E-commerce giants need architects but preference for local hires."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Multinational cloud and fintech hubs around Dublin urgently need software architects."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "Legacy systems modernization spurs hiring of bilingual architects."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "MADANI Economy",
        "reason": "Growing SaaS scene values architects yet still small scale."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "SaaS start-ups in Wellington/Auckland sponsor senior software roles quickly."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Smart-city and fintech projects need architects but visas favour regional talent first."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "National AI Strategy 2.0",
        "reason": "Financial services and AI product firms seek experienced system designers."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "We the UAE 2031",
        "reason": "Government cloud migrations create demand for experienced system designers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Fintech and AI scale-ups in London rely on senior architects."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds AI and cloud R&D requiring senior architects to design scalable platforms."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Software roles growing but policy emphasises hardware."
      }
    }
  },
  "3a74026f-6324-4947-bb1c-3be99954496e": {
    "career": "Textile Engineer",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Germany needs mechanical and materials engineers for its strong technical-textile and automotive interiors sector."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Vision 2045 adds value-added manufacturing beyond raw fibre exports, creating demand for textile process engineers."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Japan’s robotics and smart-city sectors value advanced materials; niche openings exist for functional textiles."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "NIMP pushes advanced materials and Industry 4.0 upgrades for Malaysia’s large textile export industry—clear skills gap."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 mentions advanced materials for EV/aerospace, offering limited but real demand for high-tech textile engineers."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA funds domestic advanced-manufacturing hubs where technical textiles (e.g., composites for EVs/aerospace) are small but growing niches."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "National Master Plan 2021-2030",
        "reason": "Vietnam is modernising its huge apparel sector with tech fabrics and automation; skilled engineers welcomed."
      }
    }
  },
  "9ed3c309-3d47-459c-8ea0-0b91a538b671": {
    "career": "Academic Dean",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Universities are a major export sector; senior academic leadership qualifies under Global Talent stream."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Strategy eases visas for senior higher-ed administrators to grow research capacity."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Card awards points for PhD and management experience, but demand modest."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Higher-ed leadership outside Critical Skills list, but universities can apply for discretionary permits."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Migrant Category",
        "reason": "Universities recruit international deans to strengthen research and global rankings."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "49",
        "policy": "",
        "reason": "Global Talent scheme may sponsor exceptional higher-ed leaders but role not in Tier-1 lists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "Country imports senior faculty for new branch campuses but not explicit policy priority."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "No shortage-list status, yet universities occasionally sponsor visas for experienced deans."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "No federal immigration priority, but elite universities hire globally for leadership roles."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      }
    }
  },
  "307b4fe6-8271-488b-8598-ee909a078019": {
    "career": "Agricultural Policy Advisor",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Migration Strategy 2023",
        "reason": "Strategy notes agri-tech and climate resilience roles; policy experts qualify under Global Talent."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Canada’s food-security push values professionals who can craft evidence-based agri policies and manage climate risk."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Act permits STEM policy specialists, but demand is smaller than for engineers."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Vision 2045 prioritises food security and agri transformation, creating clear demand for international policy specialists."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Ireland’s agri-food sector is strategic; policy analysts with STEM background can obtain permits through critical skills or research visas."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Most policy roles require native language proficiency and local exams."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "MADANI emphasises food security; external policy expertise contracted on project basis."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Migrant Category",
        "reason": "NZ’s economy relies on dairy and horticulture; government regularly recruits international agri-policy experts."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "UAE is investing in agri-tech and vertical farming; limited openings for policy advisors."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "US hires specialised advisors but agriculture isn’t on priority visa routes."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "National Master Plan 2021-2030",
        "reason": "Plan includes agritech; foreign advisors occasionally engaged via NGOs."
      }
    }
  },
  "9a8e4534-39e2-45a3-9023-630740214bbf": {
    "career": "Aviation Safety Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Air-traffic growth and remote-area flying create need for certified safety managers under Global Talent stream."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Strategy covers transport but aviation safety is niche."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "German carriers recruit English-speaking SMS experts amid fleet expansion."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "RPJPN 2025-2045",
        "reason": "Indonesia upgrading safety ratings; some roles open for expats on short contracts."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Large aircraft-leasing industry yields some safety roles, but no special visa track."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Highly Skilled Professional visa",
        "reason": "Airlines modernising fleets before Osaka Expo 2025 seek global SMS expertise."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "MADANI Economy",
        "reason": "Government revamps aviation safety post-MH370; foreign talent allowed but not policy focus."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Tourism-heavy aviation sector values foreign safety expertise, though not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Vision 2030",
        "reason": "Mega-projects (NEOM airline, Riyadh Air) are hiring global talent to build world-class safety systems."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Economy 2030",
        "reason": "Changi’s leadership and aerospace MRO strategy demand seasoned safety managers."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai and Abu Dhabi aim for top aviation hubs; Operation 300bn prioritises aerospace safety talent."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Aerospace cluster needs SMS managers but role not on shortage list."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA funds airport modernisation, increasing demand for safety leadership roles."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      }
    }
  },
  "cd90c78c-427d-4f98-aa97-c0c88d450d39": {
    "career": "Clinical Trials Coordinator",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Migration Strategy 2023",
        "reason": "Clinical research is a priority subsector within health and biotech streams."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Strategy targets life-sciences; coordinators qualify as allied health professionals."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Growing med-tech and pharma R&D need GCP-certified staff; English trials common."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma hub needs trial staff to support expanding biologics plants."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Highly Skilled Professional visa",
        "reason": "Global pharma runs English-language trials, but local regulation demands some Japanese fluency."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "NIMP 2030",
        "reason": "Aims to grow medical devices and pharma testing; coordinators needed for CROs."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Small but active biotech cluster recruits trial staff through general skilled visas."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Emerging biotech parks seek experienced coordinators to run first-in-human studies."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Singapore Green Plan 2030",
        "reason": "Biomedical sciences cluster hires coordinators for regional trials."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "We the UAE 2031",
        "reason": "Dubai Science Park attracts CROs; visas available but not top national priority."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life sciences is a named pillar; shortage of GCP-trained coordinators for NHS and private trials."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA boosts domestic pharma manufacturing; trials talent in high demand at biotech hubs."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Most trials outsourced; limited visa pathways for foreign coordinators."
      }
    }
  },
  "c95974de-2a8d-46d9-baff-e7ffd4ead74a": {
    "career": "Dental Educator",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Migration Strategy 2023",
        "reason": "Expansion of rural dental schools puts lecturers/clinical tutors on state skills lists."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Dentists are health-care priority; teaching experience boosts CRS points for academic streams."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Universities can fast-track non-EU professors in medical faculties, including dentistry."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "University lecturer (medical) recognised, but dental sub-specialism niche."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Universities may sponsor dental researchers, yet occupation not on specified shortage lists."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "MADANI Economy",
        "reason": "Private dental schools growing but profession outside national industrial priorities."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Otago School of Dentistry hires foreign academics but role not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "New private medical colleges need faculty, yet dentistry educators are a supporting rather than headline occupation."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Economy 2030",
        "reason": "NUS Dentistry occasionally hires foreign faculty but role lies outside priority clusters."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "Dubai/Sharjah medical universities recruit dental lecturers to back health-tourism growth."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Clinical academic dentists fall under shortage occupation code 2312 (higher-education teaching professionals)."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Universities sponsor dental faculty via H-1B; steady demand for healthcare educators despite no dedicated federal priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a08f0679-17f3-4f9e-b60a-68ab42945d67": {
    "career": "Dietetics Advisor",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Dietitian (252111) appears on CSOL enabling skilled-visa sponsorship."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Registered dietitians are health-care priority and earn extra points."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Allied health practitioners eligible though dietitians not top shortage."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Clinical dietitians not on list yet hospitals issue general work permits."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "MADANI Economy",
        "reason": "Health-food manufacturing uses nutrition advisors but migration priority is low."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Green List (Tier 2)",
        "reason": "Dietitians included; residency possible after two years in role."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Vision 2030",
        "reason": "Population-health targets create jobs in hospitals and sports cities."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Singapore Green Plan 2030",
        "reason": "Preventive-health push raises demand, yet role is outside priority clusters."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "UAE Centennial 2071",
        "reason": "Private hospitals and wellness resorts hire dietitians, but not priority occupation."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "NHS dietitians no longer on shortage list; sponsorship possible but capped."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Wellness market growing but role outside federal industrial priorities."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "34b5dfb5-d77c-4be5-8a8f-4d3f760028d0": {
    "career": "Estuarine Ecologist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Migration Strategy 2023",
        "reason": "Marine scientist on state priority lists for Great Barrier Reef protection; fast visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Blue-economy initiatives along Atlantic and Arctic coasts require coastal scientists."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Offshore wind EIA teams need ecology input but in small numbers."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Large-scale mangrove and coastal restoration attracts foreign ecological advisers."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Marine Institute offers contracts; role outside Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Coastal resilience research funded but Japanese language limits positions."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "NIMP 2030",
        "reason": "Mangrove conservation within ESG targets supports a handful of hires."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Marine scientist is Tier 1; offers straight-to-residence pathway."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Singapore Green Plan 2030",
        "reason": "Sea-level rise studies create some research grants, yet manpower need moderate."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Mangrove restoration projects in Abu Dhabi create limited ecology roles."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Estuarine impact assessments needed for offshore wind and flood-defence builds."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Coastal restoration grants fund estuary monitoring and habitat modelling."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National Master Plan 2021-2030",
        "reason": "Mekong Delta climate projects require estuary expertise, though budgets limited."
      }
    }
  },
  "4de9e61f-3f21-4e18-84c5-7b2801c32fec": {
    "career": "Human Development Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Lecturer/Researcher roles qualify for skilled visas but not priority list."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Points for PhD-level researchers; social-policy institutes seek talent."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Blue Card fast-track for academic researchers; demographic studies valued."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Quantitative economics researchers prioritised; human development adjacent but admissible."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points for publications, but language barrier limits roles."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Limited university posts, but qualifies for Highly-Skilled visa points."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "National AI Strategy 2.0",
        "reason": "Tech-society impact studies fund limited social-science fellowships."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Government research centres occasionally recruit social scientists for youth and happiness policies."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "University lecturers remain on shortage list until 2027, covering social sciences."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Universities and think tanks sponsor social-science PhDs; no specific industrial act but strong research funding."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "188c7329-10eb-4914-9b19-f3fc0d15d86b": {
    "career": "Infection Control Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "Occupation codes for public-health physicians and infection-control nurses on skills list."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Public-health and infection-control specialists fall under health-care priority stream."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Acute hospital shortage of hygiene specialists; fast-track visas available."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Private hospital chains hire advisors to meet new accreditation standards."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Clinical nurse specialist—Infection Control sits on Critical Skills List."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Hospitals value expertise, but Japanese language required for bedside work."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "Post-COVID regulations strengthen hospital infection units; moderate foreign hiring."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Infection-control nurse listed in Tier 2 with residence pathway after two years."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Mega-hospitals and accreditation goals fuel demand for CIC-certified staff."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Green Plan 2030",
        "reason": "Healthcare resilience efforts open Employment Passes for infection-control experts."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "UAE Centennial 2071",
        "reason": "JCI-accredited hospitals hire foreign infection-control leaders to maintain rankings."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "NHS recruits, but role not on Shortage List; general health worker visas apply."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Hospitals hire infection preventionists but no dedicated visa priority."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "",
        "reason": "Urban hospitals recruit selectively; no national shortage policy."
      }
    }
  },
  "fcc41b29-6f13-46f2-a52f-f60d95b860ac": {
    "career": "International Business Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Business consultants fall under ‘general professionals’, outside the Core Skills Occupation List."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Generic management roles receive only occasional invitations; no dedicated stream."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Advisory managers are admissible but not shortage-listed."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "State-owned giants engage consultants for EV supply chains, yet visas favour engineers."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List focuses on tech, engineering and finance—not general consulting."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Points-based HSP route admits business managers but competition is stiff and quotas small."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Government seeks foreign expertise for export strategy but no dedicated talent lane."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Government megaprojects hire international consultants for diversification and privatisation strategies."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Economy 2030",
        "reason": "Management consultants welcome under EP, but not in Tier-1 tech focus."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi free-zones recruit consultants to scale fintech, tourism and manufacturing clusters."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Strategy names management consulting as enabling, yet not on priority visa list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Consultants help U.S. firms navigate post-IIJA supply-chain realignment, but the occupation is not explicitly prioritised."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Advisory roles hired on project basis, not a listed shortage."
      }
    }
  },
  "0f79c467-d2b4-4b12-b8ea-fb93ed5b44b9": {
    "career": "International Legal Advisor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Legal services allowed but outside Core Skills list; state sponsorship limited."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Legal occupations rarely invited; provincial bars tightly regulate foreign entry."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Foreign lawyers face re-qualification; demand moderate for EU trade law."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Financial-services law in demand but not formally listed."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points favour corporate lawyers, yet language barrier high."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Mega-projects hire counsel, but Saudisation caps visas."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "National AI Strategy 2.0",
        "reason": "International arbitration hub welcomes foreign counsel, but licences limited."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "UAE Centennial 2071",
        "reason": "DIFC and ADGM court systems recruit common-law specialists for cross-border disputes."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City firms need senior international lawyers; law specifically cited under IS-8 priority."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "CHIPS and Science Act",
        "reason": "Cross-border counsel needed for tech deals, yet lawyers not on federal talent lists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      }
    }
  },
  "0a495f74-6b2d-41cc-947d-1367c0eecd2b": {
    "career": "Moral Philosopher",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Academic visas open, yet funding favours health and engineering."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities recruit humanities faculty, but quotas focus on STEM."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Universities seek ethicists for tech-society programmes and offer tenure-track visas."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on critical list but universities can sponsor researchers."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National AI Strategy 2.0",
        "reason": "Ethics boards value philosophers, but openings are niche."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "UAE Centennial 2071",
        "reason": "Private universities hire ethicists for liberal-arts cores, but small numbers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "UKRI funds ethics of AI and biotech; universities actively sponsor Global Talent visas."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "CHIPS and Science Act",
        "reason": "Ethics scholars contribute to AI-safety grants and university research, though indirectly tied to policy."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "eb0ef28c-748b-422b-8e6a-2c0deb331a84": {
    "career": "Music Software Developer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Software devs are tier-1, but niche music focus narrows openings."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Software engineers are a priority occupation; Montreal and Toronto house major audio-AI labs."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Berlin’s electronic-music tech scene eagerly sponsors IT visas."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Creative-economy push, but few specialised roles yet."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Software engineering is critical; gaming and audio firms in Dublin hiring."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Highly Skilled Professional visa",
        "reason": "Tokyo game-music tech needs C++ DSP talent; HSP points favour them."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "NIMP 2030",
        "reason": "Digital-content push exists, but semiconductor focus outweighs audio software."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Software skills valued but small market for audio products."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Growing entertainment sector but limited local development studios."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "National AI Strategy 2.0",
        "reason": "AI-music research at universities, yet overall demand modest."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Operation 300bn",
        "reason": "Media tech startups welcome under free-zone visas, yet still early-stage."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-tech engineers qualify for Scale-Up and Global Talent visas."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds next-gen audio DSP and AI-music startups clustered around Silicon Valley."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Tech visas favour hardware; audio startups still nascent."
      }
    }
  },
  "de863e4f-a547-4359-9747-3d67e51b276e": {
    "career": "Musician",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Berlin’s freelance visa supports musicians, but not a shortage occupation."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Gigantic investment in concerts and festivals drives demand for international acts."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Economy 2030",
        "reason": "Touring slots abundant, but permanent passes scarce; not a strategic priority."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "We the UAE 2031",
        "reason": "Dubai Expo City and Yas Island hire resident musicians; visas issued via creative-free-zones."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Music is a named creative priority; Global Talent visa fast-tracks established artists."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "No direct policy, but cultural visas (O-1) allow entry; large market for performers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "527704ef-6801-4573-80d3-2286d9fa62c3": {
    "career": "Product Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Mechanical/product engineers are on the priority list for migration and fast-tracked visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Mechanical and industrial engineers receive extra CRS points under the new STEM-focused streams."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Acute shortage of mechanical, electrical and product engineers in automotive and machinery sectors."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV battery manufacturing needs component design skills, but migration channels still forming."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Mechanical and manufacturing engineers included but intake volume limited."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "Product/semiconductor equipment engineers wanted, but strict language & culture fit hurdles."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Push for product engineers in semiconductor and aerospace supply chains."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 2)",
        "reason": "Mechanical and civil engineers enjoy streamlined residency pathways."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Need engineers for mega-projects, but preference for civil/structural over generic product roles."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Manufacturing 2030",
        "reason": "Precision-engineering product roles exist yet quota prioritises semiconductor and biomedical specialists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Operation 300bn",
        "reason": "Manufacturing diversification needs product design talent, yet numbers modest relative to software/AI."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Demand for advanced manufacturing, EV and aerospace product engineers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Massive investment in advanced manufacturing and product design for EVs, batteries and infrastructure equipment."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Focus on chip packaging/productisation offers some roles for product engineers."
      }
    }
  },
  "adf3799a-2dfe-46eb-9229-8c8e35c7cbc0": {
    "career": "Sustainable Development Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Migration Strategy 2023",
        "reason": "Nationwide transition to renewables places environmental consultants on priority lists."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Federal funding for net-zero pushes firms to hire ESG and sustainability consultants."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "EU-driven climate targets fuel demand for sustainable development experts across infrastructure projects."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "RPJPN 2025-2045",
        "reason": "Nickel/EV development requires sustainability advisors; competition with domestic talent."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Growth in green finance and data-center sustainability."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Highly Skilled Professional visa",
        "reason": "Carbon-neutral 2050 plan needs consultants, but language barrier persists."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "MADANI Economy",
        "reason": "Push toward renewable energy and ESG reporting opens niche roles."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Migrant Category",
        "reason": "Strong focus on climate resilience and indigenous land stewardship."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Vision 2030",
        "reason": "Giga-projects (NEOM, Red Sea) employ sustainability teams to meet global green standards."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Singapore Green Plan 2030",
        "reason": "Sustainable finance hub recruits consultants for carbon reporting and green supply chains."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "We the UAE 2031",
        "reason": "COP28 commitments create new ESG and carbon-management roles."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean energy mega-projects and mandatory climate disclosures drive heavy consulting demand."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Thousands of clean-energy projects require sustainability advisory talent."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "National Master Plan 2021-2030",
        "reason": "Infrastructure boom seeks environmental impact assessors, but limited visa clarity."
      }
    }
  },
  "326fa352-c56a-4b96-8242-e4dd95214bd2": {
    "career": "Advanced Data Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Migration Strategy 2023",
        "reason": "Data analysts and scientists on priority list for cyber and digital economy."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Dedicated IT/AI draws; fast PR for data analysts."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Easier job-seeker visas for IT specialists including data analysts."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech and e-commerce scale-ups seek analysts, yet immigration bureaucratic."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Big-tech European HQs need analytics experts; quick Critical Skills permit."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points favour data/AI professionals; language barrier moderate."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "MADANI Economy",
        "reason": "Digital economy push demands analysts but salaries lower."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 1)",
        "reason": "Pathway to residence for software and data professionals."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Smart-city and fintech initiatives hire analytics talent aggressively."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "National AI Strategy 2.0",
        "reason": "Wants 15,000 more data and AI professionals by 2030; COMPASS points boost."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "UAE Centennial 2071",
        "reason": "Financial, healthcare and logistics sectors compete for top data talent with golden visas."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "AI and data among key pillars; shortage list covers experienced analysts."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "STEM visa pathways and federal AI funding spike demand for data analysts across sectors."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "National Master Plan 2021-2030",
        "reason": "E-commerce and fintech growth fuels niche data roles."
      }
    }
  },
  "b535f166-323a-436e-a17a-01729e065330": {
    "career": "Architectural Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Migration Strategy 2023",
        "reason": "Universities and CSIRO recruit building-science PhDs for bushfire-resilient design research."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities get grants for climate-adaptive architecture; easier work permits for researchers."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Timber construction and energy-positive buildings are national R&D priorities."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "RPJPN 2025-2045",
        "reason": "Some smart-city research opportunities around new capital Nusantara."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Small but growing green-building research cluster."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Highly Skilled Professional visa",
        "reason": "Attention to smart-city R&D, though Japanese fluency often required."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "NIMP 2030",
        "reason": "Limited but emerging interest in tropical sustainable building research."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Skilled Migrant Category",
        "reason": "Seismic-safe building research draws foreign academics."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Neom and other projects sponsor advanced design think-tanks, but roles limited."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Singapore Economy 2030",
        "reason": "Sustainable tropical architecture labs attract PhDs, yet slots are few and competitive."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "We the UAE 2031",
        "reason": "Research hubs on desert architecture exist, yet funding episodic."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Net-zero building standards create grants for building-physics research."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Federal funds for resilient buildings spur research in materials and design methods."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "National Master Plan 2021-2030",
        "reason": "University-led research exists but foreign hiring low."
      }
    }
  },
  "d5a27ab5-dc0d-4df6-84b4-e53bf454e03c": {
    "career": "Arts Enterprise Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "Arts management not on priority lists."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Cultural-sector visas exist yet quotas small."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Berlin’s creative scene attracts managers, but not government-priority."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Asta Cita",
        "reason": "Jakarta arts scene growing but local hires preferred."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on list, but some opportunities in Dublin’s creative hubs."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Highly Skilled Professional visa",
        "reason": "Cultural-sector hiring limited, language a major barrier."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "NIMP 2030",
        "reason": "Industrial, not cultural, focus."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Skilled Migrant Category",
        "reason": "Limited slots; preference for tech and health workers."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Vision 2030",
        "reason": "Massive investment in entertainment and cultural festivals creates strong demand for experienced arts managers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Economy 2030",
        "reason": "Government funds digital media and arts festivals, offering some management roles though not top-tier priority."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi seek global talent to run museums, art fairs and film initiatives."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries explicitly prioritised; London arts organisations recruit international managers."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct policy, but creative-economy grants create some arts-management roles."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "9af8abfc-7571-4f14-8586-bf176c75a1d8": {
    "career": "Behavioral Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Migration Strategy 2023",
        "reason": "Academics fall under university stream; no dedicated shortage list slot for behavioural scientists."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "STEM researchers welcomed, yet behavioural science is not an Express-Entry priority category."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Opportunity Card awards points for advanced degrees; social-science researchers accepted but not shortage tagged."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "National AI Strategy 2.0",
        "reason": "UX and behavioural insights valuable to AI deployment, but not a designated shortage occupation."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Behavioural insights teams support public policy but occupation absent from Shortage List."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "CHIPS and Science Act",
        "reason": "Research funding covers social-behavioural science for human-AI interaction and public-health studies, but it is not a named labour-shortage occupation."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4a16a3ac-4d94-43e6-8ecc-2bb63562dafc": {
    "career": "Bioinformatics Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Medical scientists—including bioinformatics—appear on CSOL, enabling fast-track visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Express Entry Category-Based Selection",
        "reason": "STEM PhDs score high; Canadian genomics centres recruit but occupation not expressly named."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Bioinformatics fits under life-science researchers, a recognised shortage in pharma and med-tech clusters."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Biopharma corridor around Cork and Dublin lists bioinformatics under medical scientist shortages."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP targets biotech researchers; RIKEN and AIST offer points-based fast entry."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan highlights pharma and medical devices; bioinformatics useful but not headline."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "List contains medical laboratory scientists; bioinformatics accepted but not priority."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Vision 2030",
        "reason": "Genomics centres in NEOM and King Abdullah University recruit specialists, but numbers limited."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Singapore Economy 2030",
        "reason": "Biomed manufacturing and genomics initiatives place computational biology in high demand, yet below semiconductor/AI core."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai Genomics Project needs bioinformaticians; still secondary to fintech/AI priorities."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences R&D is a named pillar; visa routes fast-track biotech computational roles."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Massive funding for genomic medicine, cancer moonshot and AI-driven drug discovery creates acute demand for computational biologists."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National Master Plan 2021-2030",
        "reason": "Biotech is emerging but semiconductor/energy overshadow hiring."
      }
    }
  },
  "f8860a7c-dec2-4d23-af0c-0d41b9c5623b": {
    "career": "Character Designer",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Animation houses exist, but the role is outside Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Not on SSW; however anime/game studios sponsor highly skilled creatives under general work visa."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Mega-projects (NEOM, Qiddiya) hire animators for themed entertainment and gaming."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Singapore Economy 2030",
        "reason": "Animation is part of media cluster, but below Tier-1 tech priorities."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "We the UAE 2031",
        "reason": "Dubai Media City and Abu Dhabi Gaming initiative actively attract senior character designers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry (film, TV, gaming) is a named pillar, with special Global Talent visa route for experienced designers."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "CHIPS and Science Act",
        "reason": "Entertainment not covered, but animation studios still sponsor O-1 artists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "e5c533ce-b57c-427b-985e-347febd4c0e0": {
    "career": "Communications Instructor",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Migration Strategy 2023",
        "reason": "Vocational Education and Training (VET) lecturers are medium-term skill shortage."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Colleges need instructors; French-speaking educators receive extra points."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Universities seek English-speaking lecturers; points route facilitates humanities academics."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "67",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Higher-education lecturers are on Critical Skills, easing permits."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "63",
        "policy": "Highly Skilled Professional visa",
        "reason": "Universities value English-speaking communication faculty, offering HSP points."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Instructor roles possible, but not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Private universities and NEOM Academy hunt for English communication faculty."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Singapore Economy 2030",
        "reason": "Polytechnics recruit soft-skills lecturers but role is not Tier-1."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "We the UAE 2031",
        "reason": "Growing international campuses in Dubai recruit communication lecturers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "69",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Universities have lecturer shortages post-Brexit; Skilled Worker visa applies."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Community-college hiring expands for workforce upskilling, including communication courses."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      }
    }
  },
  "38a5b2a9-eb1d-4808-b0ac-9a311e20a928": {
    "career": "Curriculum Deliverer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Secondary STEM teachers appear on CSOL with visa concessions."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Early-childhood and K-12 teachers are named priority occupations for immigration."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe teacher shortages, especially STEM and bilingual, grant fast-track recognition."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List covers some STEM teachers, but general curriculum deliverer role borderline."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Public schools rarely sponsor; private eikaiwa hire but no priority status."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Secondary teachers feature on Tier-2 Green List enabling residence pathway."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "International schools recruit expatriate teachers but not a strategic shortage."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Funding for K-12 STEM outreach boosts demand for qualified teachers, but no special visa."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "790d0726-3f02-4d34-a98d-c10267d09666": {
    "career": "Development Sociologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Migration Strategy 2023",
        "reason": "Regional development grants create limited but real roles for applied social scientists."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Ottawa invites social-policy researchers, especially Francophones, to support indigenous and rural development programs."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Municipalities tackling integration and energy-transition need evidence-based social research capacity."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Roles exist in development NGOs headquartered in Dublin but numbers are modest."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Government funds Māori and Pacific development studies; small annual intake."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Singapore Green Plan 2030",
        "reason": "Limited openings in think-tanks studying social impacts of climate transition."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "We the UAE 2031",
        "reason": "Dubai Foundation for Women & Children and NGOs hire few applied sociologists."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Levelling-Up agenda funds think-tank and consultancies for social-impact assessments."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Federal spending on community infrastructure creates demand for social-impact evaluations and inclusive-growth researchers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "9247a9ce-e266-4be7-968f-9609de435037": {
    "career": "Events Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Events support booming sport and festival tourism; visas available under hospitality streams."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Tourism boards hire some event specialists, but occupation not on priority list."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Trade-fair city culture yields moderate demand yet no dedicated shortage listing."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "New capital Nusantara will need event talent, but policies still forming."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "2025 Osaka Expo ups temporary demand; still language-heavy."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "47",
        "policy": "",
        "reason": "Kuala Lumpur convention circuit expanding but nationals preferred."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Migrant Category",
        "reason": "International conferences and film festivals need managers in a small talent pool."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Mega-projects (NEOM, Red Sea, Riyadh Season) aggressively import senior event talent."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Economy 2030",
        "reason": "Marina Bay Sands MICE industry imports senior planners for large tech summits."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai Expo legacy and year-round MICE sector create constant openings for planners."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative sector values events, but post-Brexit visa costs keep demand moderate."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Large federal projects spark conferences and trade shows needing professional planners."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "e303db7a-cebc-436c-b372-438f6a8214e3": {
    "career": "Family Therapist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Counsellors and therapists listed due to rural shortages and ageing population."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Mental-health professionals receive priority points and provincial nominations."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Psychotherapists granted fast-track recognition amid youth-mental-health crisis."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Health Service Executive lists counselling psychologists in shortage categories."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "HSP visa accepts clinical psychologists, but language barriers are high."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Allied-health therapists get streamlined residence pathways."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Private hospitals import therapists for expatriate communities, still culturally sensitive work."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "MOH registers counsellors, but quotas favour citizens; some private-clinic roles exist."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai Health Authority licences foreign counsellors to meet rising mental-health awareness."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "NHS hires family therapists under psychological professions workforce plan."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "High domestic demand, but clinical licensure varies by state and no federal shortage policy."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "c1f454c4-33b1-4538-b63b-a81696cfae96": {
    "career": "Financial Markets Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Financial analysts qualify under General Skilled Migration but compete with locals."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Bay Street hires quants, but occupation not singled out for priority."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Frankfurt banks welcome EU talent; non-EU analysts need points but pathway exists."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Jakarta’s capital-market reform and sovereign wealth fund seek analysts."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "IFSC Dublin recruits financial-services quants on the Critical Skills visa."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "Tokyo’s push to rival Hong Kong opens fast-track visas for market analysts."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "MADANI Economy",
        "reason": "Islamic finance growth fuels analyst hiring in Kuala Lumpur."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Small financial sector offers limited visas."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "PIF and Tadawul seek analysts for diversifying economy and mega-projects."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "79",
        "policy": "Singapore Economy 2030",
        "reason": "Sustainable-finance push prioritises analysts with ESG expertise."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "UAE Centennial 2071",
        "reason": "DIFC and ADGM position Dubai/Abu Dhabi as global finance hubs needing talent."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London maintains priority visa routes for senior finance and fintech talent."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Massive bond issuance and green-energy financing boost demand for analysts."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "National Master Plan 2021-2030",
        "reason": "Nascent stock market needs talent, but foreign quotas small."
      }
    }
  },
  "b3388e6d-a29d-4a52-a3a1-aa05c2cbc3a9": {
    "career": "Game Animator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Government grants for indie studios, yet immigration pathways general not targeted."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Quebec and BC tax credits fuel modest foreign hiring in AAA studios."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "53",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Berlin/Hamburg studios use new points card to import niche creative talent."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Government e-sports focus; limited high-end animation studios."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "",
        "reason": "Animation Ireland lobbying raises demand but not on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Highly Skilled Professional visa",
        "reason": "Osaka and Tokyo giants like Nintendo and Capcom hire global animators under HSP."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "MSC status studios import mid-level talent for outsource animation work."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Skilled Migrant Category",
        "reason": "Weta and PikPok sponsor animators, but slots are few."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Singapore Economy 2030",
        "reason": "Ubisoft and Lucasfilm Animation recruit under creative-media tax incentives."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Abu Dhabi creative clusters recruit some animators for VR/AR projects."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry track lists gaming and VFX as priority occupations with visa perks."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "77",
        "policy": "",
        "reason": "World’s largest game studios cluster in California, Texas and Washington; no federal priority but strong industry demand."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Fast-growing mobile-game outsourcing needs foreign leads, but wages lower."
      }
    }
  },
  "45da5704-7765-407f-b39c-a2f9b844b716": {
    "career": "HCI Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "List covers software developers; HCI is welcomed but not shortage-tagged."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Category-based Express Entry prioritises software/A.I. roles, which include UX specialists."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialist fast-track covers usability engineers yet UX is secondary to core coding."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Digital public-service roadmap mentions UX only tangentially."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Tech multinationals’ EU HQs recruit usability and UX specialists aggressively."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP covers AI/robotics, UX demand exists but language barrier."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industry 4.0 consumer electronics adds some UX roles."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "General IT points pathway; HCI not on Green List."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "National AI Strategy 2.0",
        "reason": "Smart Nation projects place strong focus on human-centred design."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "We the UAE 2031",
        "reason": "Smart-government apps need bilingual UX designers for expat majority."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-digital sector prioritised; Global Talent visa eases entry for HCI experts."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds human-centric AI and Big Tech leads global demand for UX/HCI talent."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Growing e-commerce creates UX need but not policy priority."
      }
    }
  },
  "b5ebab1c-5283-4a8b-860a-1bd917ad0290": {
    "career": "Humanities Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Migration Strategy 2023",
        "reason": "University-sponsored visas welcome PhD lecturers despite no shortage tag."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Express Entry Category-Based Selection",
        "reason": "French/academic applicants gain extra points though not on priority list."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Strong research grants and fast-track for qualified academics."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Humanities absent from list; universities still sponsor star scholars."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "Some English-medium posts; language limits broader demand."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "PhD holders get residency points, but few university posts exist."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Economy 2030",
        "reason": "NUS/NTU hire humanities faculty, but quota limited and competitive."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Branch campuses hire PhDs yet no migration incentives."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Global Talent visa eases entry for researchers in creative economy."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "CHIPS and Science Act",
        "reason": "Act expands NSF fellowships, including social-science & humanities funding."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "ea844af2-603c-43b2-a0a7-bbbf9abe7ff2": {
    "career": "International HR Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Corporate visas available; no occupation shortage listing."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Management experience valued yet HR not in priority streams."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Companies hire foreign HR for global teams but policies spotlight engineers."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Expanding MNCs recruit some foreign HR for nickel/EV plants."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "HR absent from list; tech multinationals still recruit."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "MADANI Economy",
        "reason": "Shared-service centres hire but localisation policies growing."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "General points pathway; limited corporate HQ presence."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Mega-projects need expat HR leaders to navigate Saudization quotas."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Singapore Economy 2030",
        "reason": "Regional HQ hub values HR leaders versed in multi-jurisdiction compliance."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "95% private workforce is expatriate, driving strong demand for cross-border HR management."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Global firms based in London hire but not policy focus."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Large federal projects add multi-site HR demand but role not priority."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "FIEs need HR, yet authorities emphasise local talent development."
      }
    }
  },
  "786a15ed-8a5e-4131-b163-f6ecc71c0061": {
    "career": "Manufacturing Designer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Mechanical and production engineers listed to support on-shore industry."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Advanced manufacturing earmarked; designers qualify under engineer streams."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Auto and machinery sectors face acute shortage of production engineers."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV battery and nickel refining plants seek manufacturing designers."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Med-device and pharma plants need designers for GMP-compliant lines."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics and precision-engineering sectors value process-design experts."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan targets Industry 4.0 and semiconductor back-end requiring design engineers."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Small manufacturing base, some roles in food processing plants."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "NEOM and defence projects need advanced production design expertise."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Manufacturing 2030",
        "reason": "High-mix, low-volume factories demand experts in agile line design."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Operation 300bn",
        "reason": "Plan to grow manufacturing GDP demands line-design talent."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "EV and aerospace clusters recruit manufacturing designers for re-shoring aims."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Act drives new factories and requires engineers to design modern production lines."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "New chip fabs need production-line layout specialists."
      }
    }
  },
  "f462a961-fada-4f60-8ad7-a5a8f78f5c11": {
    "career": "Marine Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Defence shipbuilding programs hire but in limited numbers."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Shipping on Great Lakes creates some demand but not priority."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Hamburg shipyards and green hydrogen vessels need engineers."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Archipelago vision prioritises shipbuilding and maritime logistics capacity."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Shipbuilders and marine systems dominate SSW categories; acute talent need."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "MADANI Economy",
        "reason": "Straits shipping and offshore rigs employ marine engineers."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Small navy and ferry fleet; roles exist but few."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "NEOM port and Red Sea cruise projects require marine systems."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Singapore Green Plan 2030",
        "reason": "World’s busiest bunkering hub pushes for green-fuel ship design."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai and Abu Dhabi ports plus offshore energy drive demand."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Green shipping R&D funded but no formal shortage listing."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Offshore wind and Navy fleet upgrades need propulsion experts."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "National Master Plan 2021-2030",
        "reason": "LNG-to-power and logistics expansion require vessel design skills."
      }
    }
  },
  "afe25224-8f8a-4fe8-b05d-dc96917f1c48": {
    "career": "Medical Sociologist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Migration Strategy 2023",
        "reason": "Australian Research Council backs Indigenous and rural health studies, creating academic demand."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities expand population-health centres; Express Entry favours French-speaking academics."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Public health institutes need sociologists for ageing-population studies; English-language research roles eligible through Blue Card."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Health-services research centres at Trinity/UCD hire but numbers modest."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "Highly Skilled Professional visa",
        "reason": "Ageing-society research funding creates selective openings for English-speaking social scientists."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "MADANI Economy",
        "reason": "Public-health reforms generate limited social-science evaluation contracts."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Small but growing health-services research community values social determinants expertise."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Health-system modernisation includes limited social-science research roles in mega-hospital projects."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National AI Strategy 2.0",
        "reason": "Duke-NUS and NUS public-health programmes occasionally hire social-medicine scholars."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "We the UAE 2031",
        "reason": "Academic free zones (NYUAD, KU) recruit social-science PhDs; small niche."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "UKRI funds major social-medicine grants; Russell Group universities regularly recruit lecturers and postdocs."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Funds NIH-connected social-science research on health equity; U.S. universities hire medical sociologists for grant-driven projects."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "ebde9f29-7048-408c-8d08-2b155ed32a93": {
    "career": "Positive Psychology Practitioner",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "Shortage of registered psychologists, but coaching practice is unregulated and lower priority."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Mental-health demand high; unregulated coaching roles exist, but not on priority list."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Skilled Migrant Category",
        "reason": "Wellbeing initiatives in schools and government create some demand."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Corporate happiness programmes and mega-projects hire English-speaking wellbeing experts."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "49",
        "policy": "Singapore Green Plan 2030",
        "reason": "Large corporate HR functions buy wellbeing workshops, but not priority occupation."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "UAE Centennial 2071",
        "reason": "Government pushes 'National Wellbeing Strategy', opening consultant contracts."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "47",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "NHS trials social prescribing; private sector hires coaches but immigration priority low."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "CHIPS and Science Act",
        "reason": "Wellness industry booming but outside formal federal priority; private sector hires coaches."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "65f8713b-8459-4596-8a4b-207d4f4bb795": {
    "career": "Professional Urban Planner",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Urban sprawl and climate adaptation put planners on priority list."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Provincial growth plans and housing shortages create demand for planners."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Smart-city and renewable-district projects require international planning talent."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "New capital Nusantara is a greenfield mega-planning opportunity."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Dublin’s housing plan adds limited but notable planner roles."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-city pilots around Osaka and Fukuoka look for English-speaking talent."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "NIMP 2030",
        "reason": "Industrial corridor and transit-oriented developments require zoning experts."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Green List (Tier 2)",
        "reason": "Housing crisis and hazard-resilience work make planners sought after."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Vision 2030",
        "reason": "Gigaprojects like NEOM and The Line recruit hundreds of foreign urban planners."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Singapore Green Plan 2030",
        "reason": "Limited slots but high standards in URA; foreign planners hired for specialised roles."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Operation 300bn",
        "reason": "Smart-city expansions in Dubai and Abu Dhabi seek experienced planners."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Regeneration and housing targets keep demand steady though visa caps tightening."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Massive federal spend on transport, housing and climate-resilient cities drives hiring."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "National Master Plan 2021-2030",
        "reason": "Rapid urbanisation needs planners familiar with sustainable design."
      }
    }
  },
  "2bc124ca-b5d8-42a9-b4fa-25eaa580a35f": {
    "career": "Psychiatric Mental Health Nurse Practitioner",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "Mental-health nurses explicitly listed; regional visas available."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Severe shortages of psychiatric NPs on priority list; fast-track permanent residency."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Psychiatric nursing in acute shortage; hospitals sponsor German-language training."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Mental-health nurses on Critical Skills list with two-year work-to-residency path."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Nursing care pathway exists but requires N1 Japanese; limited NP concept."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Private hospitals recruit foreign psychiatric nurses but licensing hurdles exist."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Psychiatric nurse practitioners on Tier 1, offering direct residency."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "New mental-health hospitals recruit foreign advanced practice nurses."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Green Plan 2030",
        "reason": "MOH shortages in mental-health nursing; foreign NPs eligible under Conditional Registration."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "We the UAE 2031",
        "reason": "Private psychiatric clinics in Dubai Healthcare City hire international NPs."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Federal rural tele-mental health funding expands NP roles with prescriptive authority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "9761b90e-5ac2-44d8-81ae-08cdf7a2e8a0": {
    "career": "Recreation Program Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Migration Strategy 2023",
        "reason": "Tourism recovery drives some hiring; not on CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Municipal parks hiring, but not on priority list."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Eco-tourism in Bali and new capital creates niche managerial roles."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Adventure tourism sector needs programme managers, though not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Mega tourism projects (AlUla, Red Sea) recruit recreation managers to design visitor experiences."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "UAE Centennial 2071",
        "reason": "Theme parks and resorts hire experienced programme managers for guest engagement."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Local councils hire but budgets tight; visa priority low."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Federal park and community grants create moderate demand for recreation managers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "00e01596-7b5b-487d-b9c4-46b8025dfe22": {
    "career": "Soil Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Not on CSOL, yet drought resilience and regenerative farming create state-nominated demand."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Agri-food and climate-adaptation priorities mean soil scientists qualify under agriculture and French-speaker streams."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Environmental consultancies recruit soil scientists for contaminated-land remediation, but role is niche compared with engineering shortages."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Food-security pillar highlights agri-scientists to rehabilitate degraded soils for staple crops."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Agricultural-scientist category explicitly lists soil science; straight-to-residence pathway available."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds climate-smart agriculture and carbon-sequestration projects that need soil-health experts, but demand is regional rather than nationwide critical."
      },
      "vietnam": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "National Master Plan 2021-2030",
        "reason": "Agritech R&D and sustainable farming are strategic; foreign soil experts welcomed for rice-belt productivity."
      }
    }
  },
  "df9dc409-6799-4188-b886-9ec0dd5d63ce": {
    "career": "Visual Journalist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Dubai Media City hires senior visual storytellers for global outlets, but slots are few."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative visa route exists, yet competition is fierce and sponsorship limited."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct policy support, but largest media market offers freelance visas (O-1) for award-winning creatives."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "2898991c-badb-4c04-9d1e-30e157f35215": {
    "career": "Waste Management Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Environmental engineers appear on CSOL under construction and sustainability categories."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Provinces like Ontario list environmental engineers for expedited immigration."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Germany’s circular-economy push needs engineers for recycling plants and WtE facilities."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Big-city landfill crises create demand, but visa routes not tailored to engineers."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Environmental engineers on list; permits processed faster."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industrial clusters require hazardous-waste compliance specialists, but numbers modest."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Migrant Category",
        "reason": "Role recognised, but projects fewer than infrastructure staples like civil engineering."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Mega-projects include waste-to-energy in NEOM yet still secondary to construction PMs."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Green Plan 2030",
        "reason": "Tuas Nexus integrated waste facility spurs specialised hiring, though numbers small and local talent prioritised."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Operation 300bn",
        "reason": "Dubai’s zero-waste strategy drives selective hiring for landfill-gas and recycling plants."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 clean-growth pillar funds recycling tech; shortage visa category for environmental engineers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA funds landfill modernisation, methane capture and circular-economy infrastructure—creating strong demand for waste engineers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National Master Plan 2021-2030",
        "reason": "Urban waste challenges open slots, yet focus is more on semiconductor and energy engineers."
      }
    }
  },
  "3554c640-0a48-4b63-999c-342b675025b4": {
    "career": "Advertising Director",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "Regional HQs hire ad leaders, yet role not in official priority lists; quotas tight."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "We the UAE 2031",
        "reason": "Dubai positions itself as MENA creative hub; senior media leaders given Golden Visas."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry senior roles qualify for Global Talent visa though quotas limited."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "No immigration priority, but world’s largest ad market; O-1 visas for award-winning creatives."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "1a8e3099-3f45-4794-825e-f5ebfb3b8915": {
    "career": "Airline Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Aviation operations managers can secure employer-sponsored visas, but not on CSOL shortage list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Airport expansion creates roles, yet airline management not on priority lists."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Lufthansa group hires managers, yet policy spotlight is elsewhere."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "New Riyadh Air and NEOM airport projects need experienced airline leaders."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Singapore Economy 2030",
        "reason": "Changi expansion and SIA Group digitalisation projects open to foreign execs under targeted EP quotas."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "We the UAE 2031",
        "reason": "Global aviation hub offers Golden Visas for senior airline executives in Emirates, Etihad and flydubai."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Heathrow and Luton expansions fuel demand, but no special visa concessions."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Massive aviation market but no immigration priority; H-1B possible for specialised management."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "de949c1a-d421-4d2e-9c79-f827901025e2": {
    "career": "Conservationist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Migration Strategy 2023",
        "reason": "Biodiversity management jobs exist within state agencies, but the CSOL highlights engineers and nurses ahead of conservation scientists."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Parks Canada and provinces recruit conservation biologists, yet occupation is outside the core Express Entry shortage groups."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Environmental scientists qualify under general STEM rules, though not singled-out like renewable-energy engineers."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Ecologists may obtain general work permits; however, they are not on the critical list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "DOC faces persistent ranger shortages; ecological scientists gain streamlined visas even if not on top Green List tier."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Environmental scientists can use Skilled Worker visas, but they are outside the priority IS-8 tech clusters."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds habitat restoration and carbon-sink projects, creating demand for conservation field staff but role is not expressly listed as shortage."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "55cfc1ed-4c9b-4f33-94ae-26ef16c0a860": {
    "career": "Designer",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Entertainment and media hubs hire senior international designers for mega-events."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Operation 300bn",
        "reason": "Dubai’s media free zones actively grant visas to creative directors, especially with digital skills."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries are a named priority, yet only senior talent gets visa edge."
      },
      "united_states": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "459f8ff8-1f45-4794-bf6c-523f55156187": {
    "career": "Educational Systems Leader",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Secondary STEM leadership roles appear on state occupation lists."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Principals in rural/Francophone schools qualify under teacher shortage streams."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Federal states court foreign heads for bilingual and STEM schools."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Some international schools recruit principals, yet outside Critical Skills list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Principals and deputy principals enjoy prioritized pathways alongside teachers."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "K-12 administration hires foreigners rarely; no dedicated immigration channel but H-1B possible."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "29aad776-7172-46c6-b71e-1bd8fcfa22ea": {
    "career": "Environmental Health Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "State occupation lists highlight environmental health officers for hospitals and councils."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Classified under allied health; provinces explicitly list environmental health officers due to inspection shortages."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Public-health and water-safety experts qualify under healthcare STEM shortage pathways."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Air- and water-quality oversight growing but not in official shortage list."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Listed under ‘health and social services professionals’ with fast-track residency."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "Qualifies under health sciences but not a named priority."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Industrial growth raises demand for EH&S, yet immigration focus remains on engineers."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "MOH lists environmental health officers on Tier 2 with streamlined residence route."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Vision 2030",
        "reason": "Mega-cities need sanitation and air-quality specialists; hospitals import foreign experts."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Green Plan 2030",
        "reason": "Push for resilient public health; NEA brings in foreign specialists for vector control and food safety."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "UAE Centennial 2071",
        "reason": "Public-health and sustainability drives fuel demand for environmental health inspectors."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Role sits outside IS-8 but can use general Skilled Worker visa; councils report moderate shortages."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA funds water-quality and Superfund projects, indirectly boosting demand, but no dedicated visa preference."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National Master Plan 2021-2030",
        "reason": "Industrial parks hire environmental health consultants via standard work permits."
      }
    }
  },
  "a191fc7c-638e-4b80-bb03-f1e763f9595d": {
    "career": "Fitness Coordinator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Sports coaches sometimes sponsored, yet Fitness Coordinator absent from CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Role exists under NOC 5254 but not in Express Entry shortage lists."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Government invests in community sports and gyms; expat coordinators hired for new complexes."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "High demand for fitness but Employment Pass salary floor screens most coordinator roles."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Wellness tourism drives demand for qualified fitness managers in luxury resorts and gyms."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Health clubs hire overseas staff only when niche skills (e.g., Pilates master) are shown."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Large fitness market but no immigration priority; H-1Bs rarely granted for trainers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "90884784-56b8-436f-b662-a4795f698738": {
    "career": "Integrated Design Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "UI/UX demand exists in fintech and gov-tech, yet designers are absent from the Core Skills Occupation List."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Creative digital roles qualify only under generic French-speaker or provincial tech streams, not on the national priority list."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Tech companies sponsor designers through EU Blue Card, but design is not a highlighted bottleneck occupation."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Software roles prioritised; design roles fall under standard employment permit with longer processing."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Skilled Migrant Category",
        "reason": "Points-based route possible; creative occupations receive no bonus points or Green List fast-track."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Mega-projects (NEOM, Red Sea) recruit digital experience designers for tourism and smart-city platforms."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "National AI Strategy 2.0",
        "reason": "Digital product design valued by tech firms, but not among named shortage categories; EP points still achievable."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "We the UAE 2031",
        "reason": "Government pushes world-class media production and digital experiences; golden visa available for creative talent."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative Industry high-skill visas explicitly name senior digital designers for film, gaming, and immersive media."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Digital product design supports federally funded infrastructure-tech projects, but designers are not a named shortage occupation."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "8e1f6038-2326-4701-ae61-a0328e807eb8": {
    "career": "Safety Officer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Mining and construction firms sponsor OHS officers, listed under ‘Safety Inspector’ occupations."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Construction and transport categories value certified safety professionals for large infrastructure builds."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Chemical and automotive plants face compliance pressure, making Fachkräfte in Arbeitssicherheit attractive hires."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "RPJPN 2025-2045",
        "reason": "Nickel and EV battery plants seek HSE officers to pass global supply-chain audits."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Safety engineering appears only under specific construction management codes, limiting fast-track routes."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Chemical safety expertise scores points under ‘engineering’, yet language and regulation familiarity are barriers."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "MADANI Economy",
        "reason": "Petrochemical corridors need HSE staff to meet ESG targets for global investors."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Points granted for engineering technologists; OHS is supportive but not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Vision 2030",
        "reason": "Massive giga-projects and refineries urgently require HSE staff to meet global safety standards."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Singapore Green Plan 2030",
        "reason": "Strict MOM safety rules drive demand, but local upskilling reduces foreign hiring quotas."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Operation 300bn",
        "reason": "Expanding manufacturing and energy sectors recruit certified HSE officers for ISO compliance."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Role not on shortage list but companies may sponsor niche chemical-plant safety talent."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "New industrial projects require OSHA-compliant safety staff, but role is not classified as critical shortage."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "New fabs must hire certified safety professionals to align with international EHS norms."
      }
    }
  },
  "a0fc7908-3470-4aab-987b-23af0c413fe1": {
    "career": "Theatre Designer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Migration Strategy 2023",
        "reason": "Entertainment visas exist but are temporary and project-based, not shortage list."
      },
      "canada": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Cultural visa route supports creatives, yet designers must secure a theatre contract first."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Vision 2030",
        "reason": "New festivals and live-event venues recruit set and costume designers for growing entertainment sector."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi host expanding theatre and theme-park shows needing creative designers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative sector recognised as strategic; Global Talent visa fast-tracks experienced theatre designers."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct policy support; visas possible under O-1 for extraordinary artistic ability."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "537eb1f9-033f-44d8-876a-0c256c277f63": {
    "career": "Trainee Lawyer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Points available for solicitors, but trainees must still complete Australian Practical Legal Training."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Canadian provinces occasionally recruit foreign legal talent, yet local bar admission remains essential."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Solicitors appear on supporting list; trainees still need FE-1 and PPC exams."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Limited slots; candidates must retrain for NZLS admission."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "Foreign trainees can join international firms but must pass Singapore Bar exams to progress."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City firms sponsor Skilled Worker visas, but priority list names only senior law professionals."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Large compliance workload drives hiring, but no immigration preference for entry-level lawyers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "70b49bae-e3a8-4e3f-abf6-a21b65ffac6b": {
    "career": "Web Developer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "‘Software Engineer’ code on CSOL covers web developers for priority visas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Software engineers and web developers headline tech-occupation draws with fast 2-week work permits."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe IT talent gap; Blue Card fast-track for web developers with €41k salary floor."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "E-commerce giants and government super-app recruit full-stack talent to scale services."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Web and software developers qualify for Critical Skills Permit with two-year to residency pathway."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Highly Skilled Professional visa",
        "reason": "Developers meet HSP point system; language skills remain main barrier."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Digitalisation pillar funds local SaaS and e-commerce, attracting foreign developers."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Software engineers appear on Green List, but quota numbers are modest."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "E-commerce and gov digitalisation fuel steady demand for web developers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "National AI Strategy 2.0",
        "reason": "Web dev roles qualify under Tech.Pass, yet AI/ML gets the top incentives."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Fintech sandboxes and digital-by-default services create openings, but AI specialists outrank general developers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Scale-ups can sponsor Skilled Worker visas; Digital Tech still strategic though not on formal shortage list."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds digital ecosystems around semiconductors, creating demand for full-stack developers though not a named shortage."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "79",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Booming fintech and online platforms need web developers, but semiconductor engineers remain higher priority."
      }
    }
  },
  "32c3e9cb-9f97-4cd1-8596-caa497bb452c": {
    "career": "AI Project Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Software developers and data specialists qualify for fast-track visas; project leads accepted under the same ANZSCO codes."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "AI/ML roles get priority work permits and Express Entry points."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialists including AI PMs can immigrate without German-language proof if salary threshold met."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech and e-commerce firms want AI leadership but immigration still complex."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "AI project managers meet ‘ICT professional’ codes for Critical Skills permits."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Highly Skilled Professional visa",
        "reason": "AI/ML project leaders accumulate high points for fast residence and family benefits."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "AI oversight roles valued in semiconductor and Industry 4.0 plants but not yet on formal shortage list."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Tech managers receive points but sit behind healthcare and construction in priority."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "AI programme offices across government megaprojects hire project managers for data & analytics delivery."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "National AI Strategy 2.0",
        "reason": "EP Complementarity Assessment Framework (COMPASS) awards bonus points to AI project management roles."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "UAE Centennial 2071",
        "reason": "AI project leadership qualifies for 10-year Golden Visas under ‘specialised talent’."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Shortage list covers digital & AI managers; visa sponsorship streamlined."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Federal funds push AI R&D; managers who can ship commercial AI products are on the critical-talent list."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "AI specialists aid chip sector automation; visas possible yet less streamlined."
      }
    }
  },
  "7e54f7f7-b9eb-4a6b-aa86-c5b28d57ad1c": {
    "career": "Animation Producer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Creative roles can get visas, but compete against tech and health priorities."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Film & TV cluster in Vancouver offers jobs, yet not a named priority."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Points for creative professionals exist though not on shortage lists."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "RPJPN 2025-2045",
        "reason": "Government backs local studios, but foreign producers face protectionist rules."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Animation firms in Kilkenny hire foreigners but role not on critical list."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Anime industry demand; cultural visas available though not prioritised nationally."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "MADANI Economy",
        "reason": "Animation export promoted, but immigration prioritises manufacturing talent."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Weta Digital drives niche demand, but role not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Gigaprojects (NEOM, Red Sea) investing heavily in entertainment and animation."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Economy 2030",
        "reason": "Media sector grants attract producers, still secondary to deep-tech hiring."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai Media City incentives make senior creative producers a top talent target."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry senior roles listed as key growth sector with dedicated visas."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct policy, but Hollywood’s demand and O-1 visas make entry possible."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Creative sector growing yet not covered by tech-centric talent policy."
      }
    }
  },
  "21178c81-71cb-4ce6-a7bd-a64a404acb84": {
    "career": "Career Counselor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Secondary STEM teachers top list; guidance counselors eligible but less urgent."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "K-12 teachers are priority; counselors gain secondary benefit under education NOC."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "School social workers face shortages, opening door for qualified counselors."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Green List (Tier 2)",
        "reason": "Education advisors can apply though not on the headline Green List."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct priority, but schools hire under education funding streams."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "3226cbb8-32be-455b-9c8c-425faf60bcf6": {
    "career": "Climate Policy Advisor",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Clean-energy transition drives demand for policy analysts in Canberra and state governments."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Net-zero roadmap funds think-tank and government advisory hires."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Energiewende requires advisors on EU taxonomy, carbon pricing and renewables regulation."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Climate law experts needed for nickel/EV sector ESG reporting; immigration remains bureaucratic."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Demand exists but STEM roles still get priority points."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Decarbonisation taskforces recruit, yet foreign policy advisors need high Japanese fluency."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "MADANI Economy",
        "reason": "Policy talent wanted for renewable roll-out though manufacturing still leads priority."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Migrant Category",
        "reason": "Climate Change Commission needs talent, but visas favor engineers first."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Green hydrogen and carbon offset projects recruit sustainability policy talent."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Singapore Green Plan 2030",
        "reason": "Carbon-services hub seeks policy specialists on offset markets and regional diplomacy."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "We the UAE 2031",
        "reason": "COP-28 legacy and green-finance hubs prioritise sustainability specialists with policy depth."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Net-zero strategy funds advisory posts across Whitehall and private consultancies."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Record federal spending needs specialists to craft and audit climate rules."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National Master Plan 2021-2030",
        "reason": "Foreign advisors engaged on offshore wind regulation but no fast-track visas."
      }
    }
  },
  "1abc5b0d-1c63-4764-b3d6-1483b3f43bf6": {
    "career": "Cognitive Neuropsychologist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Neuropsychologists on Medium- and Long-Term Skilled List; fast-track PR."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Clinical psychologists qualify under healthcare shortages, especially for mental health."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Hospitals lack specialised neuropsychologists; degrees recognised via IQWiG pathway."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Psychologists listed but quotas limited versus IT and pharma roles."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Brain-science labs recruit, yet language and licensure hurdles remain."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Healthcare investment focuses on doctors and nurses, not psychologists."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Clinical psychologists on Tier-1 Green List receive immediate residency offers."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Private neurorehabilitation centres hire expats though priority lies in other specialities."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Green Plan 2030",
        "reason": "Aging-society initiatives open neurocognitive research grants but no special visa route."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "UAE Centennial 2071",
        "reason": "Mental-health specialists can obtain Golden Visas but not a headline shortage."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences R&D covers cognitive research positions; clinical posts need HCPC registration."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "CHIPS and Science Act",
        "reason": "Large NIH and NSF brain-research grants but not immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "08b79332-ca31-4150-bddd-89513069f069": {
    "career": "Community Pharmacist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Pharmacists appear on Medium/Long-Term list, offering fast visas and state nomination."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Several provinces list pharmacists as priority healthcare shortages, easing selection points."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Rural and elderly regions lack pharmacists; Act recognises non-EU licences with bridging."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on Critical Skills list, yet private chains still recruit overseas pharmacists."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Only pharma-R&D roles prioritised; community practice possible but regulatory Japanese fluency barrier."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Domestic oversupply of pharmacy graduates; foreign hiring exists mainly for niche clinical roles."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Community pharmacists are explicitly on Green List Tier 1 for direct residence pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Huge hospital and retail-pharmacy expansion under Vision 2030 needs licensed pharmacists."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Singapore Green Plan 2030",
        "reason": "Licensure strictly capped; foreign pharmacists admitted only for hospital specialties, not retail."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "UAE Centennial 2071",
        "reason": "Healthcare city projects recruit foreign pharmacists; easier licensure exams than GCC peers."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Shortage list includes pharmacists but sponsorship numbers limited after 2025 reforms."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA’s drug-price provisions push demand for community pharmacists to manage medication therapy, but no dedicated immigration channel."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "1ee62729-aeab-42b4-8302-1a2d90bebb1e": {
    "career": "Counseling Advocate",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Clinical psychologists listed; advocacy counselling assessed case-by-case."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Care-economy occupations get additional CRS points, especially French-speaking counsellors."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Mental-health staff shortages exist, but language proficiency and licensing slow migration."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Only clinical psychologists prioritised; advocacy roles need general work permit."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Counsellors appear on Tier 2 list leading to residence after two years."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Vision 2030",
        "reason": "Hospitals add mental-health units, yet cultural fit and gender segregation complicate hiring."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Green Plan 2030",
        "reason": "Well-being initiatives create counselling jobs, but foreign hiring is tightly regulated."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Mental-health awareness campaigns require counsellors, but limited visa prioritisation."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Community grants include mental-health funding, but no special visa category."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b25671ad-79f2-4749-ac77-6ce9f5b3fefd": {
    "career": "Curriculum Director",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Secondary STEM teachers in shortage; curriculum specialists sponsored by school systems."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Early-childhood and K-12 educators secured priority; leadership roles piggy-back on same NOC code."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Länder recruit foreign educators to modernise STEM syllabi, especially for bilingual schools."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Curriculum design falls outside Critical Skills; some openings in EdTech hubs."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "International schools in Kuala Lumpur recruit expatriate curriculum heads."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Primary and secondary educators on Green List; senior curriculum roles qualify after experience."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "International schools expanding, needing directors for IB/AP programmes."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Singapore Economy 2030",
        "reason": "MOE hires almost exclusively citizens; private international schools offer limited passes."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "Dubai/Abu Dhabi demand curriculum leaders in private British & IB schools."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Limited to broadband & STEM grants; some districts use funds for curriculum overhaul but no visa edge."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "79f8936f-4d79-43ff-bcfa-368b4ca7ec17": {
    "career": "Digital Business Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Migration Strategy 2023",
        "reason": "Digital transformation occupations enjoy priority processing and four-year visas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Strategy fast-tracks data and digital analysts under new Tech Talent visa."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "IT/business analysts gain points for occupation and English; shortages in Industrie 4.0 firms."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "RPJPN 2025-2045",
        "reason": "Tech scale-ups prefer local bilingual talent for business analysis."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Digital business analysts explicitly on list; two-year critical skills permit leads to residency."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Points system favours AI/ML engineers; analysts still qualify with high salary."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "NIMP 2030",
        "reason": "Industry 4.0 push requires analysts, but MNCs mainly tap regional talent from Singapore."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Migrant Category",
        "reason": "Tech roles accepted but quota small compared to developers."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Vision 2030",
        "reason": "Mega-projects and digital banks rely on analysts for agile delivery."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "National AI Strategy 2.0",
        "reason": "COMPASS framework gives bonus points for data & digital analysts."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Operation 300bn",
        "reason": "Smart-industry and fintech clusters sponsor digital analysts on Golden Visa tracks."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 pillar on digital/AI lists business analysts as shortage with scale-up visa."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "All federal tech programmes need analysts to bridge business and AI/semiconductor projects."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National Master Plan 2021-2030",
        "reason": "Foreign hiring focused on core engineering, not analysis roles."
      }
    }
  },
  "460e8341-238c-4c9f-9852-151d9198c960": {
    "career": "Digital Strategist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "Generic marketing excluded, though creative-industry visas possible with portfolio."
      },
      "canada": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Quota prefers engineers; digital marketing seldom meets points threshold."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Digital economy targets create room for foreign senior strategists in Jakarta startups."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on list, but tech MNCs in Dublin still sponsor niche digital roles."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Tourism board and e-commerce firms seek strategists, but immigration quotas limited."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Vision 2030",
        "reason": "Mega tourism, sports and entertainment projects aggressively hire digital storytellers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Economy 2030",
        "reason": "EP points possible for senior creatives, but not a core priority field."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "We the UAE 2031",
        "reason": "Dubai aims to be global media hub; creative professionals fast-tracked under freelance and Golden visas."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry seniors listed; strategists with strong portfolios can get Scale-up visas."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Clean-tech firms need digital outreach, but role not in federal priority immigration."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "E-commerce marketing talent sourced locally to cut costs."
      }
    }
  },
  "c87e4f15-eb33-43c6-bc4a-e73ba2fee1b2": {
    "career": "Diplomatic Advisor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Role not on Core Skills list; only general skilled visas apply."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Can enter under NOC 4169 policy analysts, yet not one of the targeted priority draws."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Points possible for advanced degree, but foreign-policy advisory not a shortage occupation."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "41",
        "policy": "National AI Strategy 2.0",
        "reason": "Several policy units hire foreign analysts, but discipline is not a national manpower gap."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "We the UAE 2031",
        "reason": "Think-tanks and multilateral bodies hire expats, but not listed as priority talent."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "International relations experts valued in London think-tanks, yet not on Skilled Worker shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Professional category accepted for H-1B, but diplomacy is not on any federal skills-shortage list."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "19b6b051-22ec-499c-947f-cda0c4b0203e": {
    "career": "Embedded Systems Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Electronics and software developers appear on shortage list, overlapping with embedded work."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "67",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Tech-specific draws actively invite software and embedded engineers."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Automotive and Industrie 4.0 firms urgently need embedded developers."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "RPJPN 2025-2045",
        "reason": "EV and IoT manufacturing zones will need some embedded skill, but programs still nascent."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Electronics and firmware engineers on Critical Skills permit."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics and chip giants court embedded engineers with fast-track visas and permanent residency."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "81",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Nation expanding design centres and needs thousands of embedded experts."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Migrant Category",
        "reason": "Eligible as electronics engineer but not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Smart-city, defense and robotics projects seek some embedded expertise."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "National AI Strategy 2.0",
        "reason": "Precision electronics and AI hardware R&D are headline priorities."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing push includes control-system talent but at moderate scale."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Shortage of semiconductor and automotive control engineers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Massive federal subsidies for semiconductor R&D drive demand for firmware and hardware engineers."
      },
      "vietnam": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Government aims for 50k chip engineers; embedded firmware core to target."
      }
    }
  },
  "38fee812-2ab9-4072-8e78-28c87ed88801": {
    "career": "Exhibition Manager",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "22",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Mega-projects (NEOM, AlUla) need world-class exhibition and events talent immediately."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "MICE industry large but MOM has tightened passes for generic events roles."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai Expo legacy and year-round conference industry create constant demand."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries promoted in London, though not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Creative industry large but no immigration priority; regular H-1B or O-1 only."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "22",
        "policy": "",
        "reason": ""
      }
    }
  },
  "62776344-8e66-43e9-99f7-d21af980d78d": {
    "career": "Extension Educator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "STEM teachers are on CSOL; marine outreach overlaps yet remains peripheral."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "47",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "STEM outreach eligible under general science streams but not priority."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "63",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Maritime education key for archipelago; foreign specialists can obtain R-D visa."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 2",
        "score": "63",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Fisheries sector needs trainers and outreach educators."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Government marine agencies hire few foreigners; no priority status."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Green List (Tier 2)",
        "reason": "Coastal resilience projects seek marine science communicators."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Some NGO and university programmes, but visas favour STEM R&D, not outreach."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "University Sea Grant programs hire some internationals, but not on shortage list."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Coastal climate-adaptation projects welcome experts but no formal fast-track."
      }
    }
  },
  "2f21d5fc-2fb5-498f-ab5f-7ddf635cad80": {
    "career": "Genetics Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Medical scientists listed on CSL but below nurses/engineers."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Health-science researchers prioritised in future talent stream."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Pharma and med-tech clusters in Bavaria and NRW seek molecular biologists."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "RPJPN 2025-2045",
        "reason": "Biopharma flagged but talent programmes still early stage."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma scientists and biotechnologists qualify for fast-track permits."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Highly Skilled Professional visa",
        "reason": "Biotech labs offer HSP, but language still a hurdle."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan names pharma and medical devices as key growth pillars."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Limited biotech sector; visas possible but not prioritised."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Genomics centres at KAUST growing, yet not headline shortage."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "79",
        "policy": "Singapore Economy 2030",
        "reason": "Nation invests heavily in biomedical sciences and offers 5-year Employment Passes for researchers."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "UAE Centennial 2071",
        "reason": "Genomics initiatives in Abu Dhabi need talent, but quota small."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences super-cluster around Oxford-Cambridge-London actively recruits global geneticists."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act allocates billions for biotech R&D, expanding lab jobs and startup visas."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "",
        "reason": "Growing biotech parks, yet immigration focus on semiconductors and energy."
      }
    }
  },
  "b731e4a3-61e1-40d9-ad14-41b6e9e08034": {
    "career": "German Translator",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Export-heavy Germany needs English/German localisation; Act recognises qualified language professionals for residence permits."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Creative sector needs translators for EU trade, but role is outside IS-8 priority list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Large German-owned firms and heritage communities create steady localisation demand, but translation is not a federal skills priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "39dcb5f8-34ad-4f7c-9a17-e0e24d3c0bcc": {
    "career": "International Security Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Migration Strategy 2023",
        "reason": "AUKUS partnership drives need for analysts covering Indo-Pacific security."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Ottawa courts defence, cyber-security and intelligence talent under the strategy."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Germany boosts defence spending post-2022; scheme eases entry for experienced analysts."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Focus on internal security; foreign analyst visas uncommon."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Think-tank and EU security roles exist but no targeted visa support."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "Tokyo expands intelligence capability amid regional threats; HSP eases hiring."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Security roles secondary to industrial policy, but regional risk units hire in KL."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Small intelligence community; limited but existing roles in Wellington."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Vision 2030",
        "reason": "Regional tensions and mega-projects create demand for risk and security analysis."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National AI Strategy 2.0",
        "reason": "City-state invests in AI-powered OSINT platforms and geopolitical analytics."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Ambition to be regional security & diplomacy hub fuels analyst hiring."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Defence and cyber are flagship IS-8 sectors, making security analysts highly sought."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "",
        "reason": "Huge defence and intelligence budgets create constant demand for geopolitical analysts despite not being tied to named industrial acts."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Growing defence spending but analyst roles largely domestic-language only."
      }
    }
  },
  "09c888b8-e350-4ac1-b82f-d82724b3accd": {
    "career": "Lab Medicine Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Medical specialists are explicitly listed for fast-track visas and permanent residency."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Physicians (all specialities) get priority invitations due to nationwide shortage."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Hospitals urgently recruit foreign doctors; streamlined recognition of medical licences."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Foreign doctors face strict localisation rules; limited specialist visas."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pathology consultants are explicitly on the Critical Skills list with fast PR."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Demand exists in aging society, but language and licensing barriers keep scores modest."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Healthcare expansion underway yet no dedicated physician fast-track."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Clinical pathologists are eligible for direct residency but competition is lower than nursing."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Rapid hospital expansion under giga-projects drives demand for laboratory specialists."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Healthcare demand high, but Ministry's approved-school list makes licensing competitive."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Healthcare is a national pillar; DHA/HAAD issue expedited licences for pathologists."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Histopathology consultants remain on the shortage list despite overall NHS visa tightening."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Pathologists are in shortage lists of several states, but no federal fast-track programme exists."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Growing private hospitals, but licensing and salary not attractive for foreigners."
      }
    }
  },
  "a8f84b50-97be-499f-910e-34bdc44a6f9a": {
    "career": "Maritime Finance Specialist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Small but growing Atlantic shipping cluster; no special immigration incentives."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Hamburg shipping banks hire specialists, but industry downsizing keeps demand moderate."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Nickel/EV focus overshadows shipping finance in current policy."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Dublin’s leasing know-how is aircraft-focused; limited shipping finance roles."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Tokyo banks finance domestic yards; language barrier limits foreign hires."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Port Klang growth yet high-end finance still handled in Singapore."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "New Red Sea and NEOM ports create need for structured vessel finance."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Economy 2030",
        "reason": "World’s top maritime hub offers strong demand for shipping finance professionals."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Dubai International Financial Centre pushes ship-finance products alongside logistics growth."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London remains the largest global centre for shipping loans and P&I clubs."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "",
        "reason": "New York remains a major hub for shipping bonds and maritime private equity, though not federally prioritised."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Financing handled by international lenders, not local talent programmes."
      }
    }
  },
  "1cfb9fa2-18b3-453b-ae85-ec0247490f04": {
    "career": "Medical Lab Tech",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Diagnostics technicians are on the Medium and Long-Term Strategic Skills List for permanent visas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Medical laboratory technologists receive priority invitations due to acute shortages."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Hospitals recruit foreign MLTs with simplified recognition of qualifications."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Lab tech roles exist but localisation policies keep demand modest for foreigners."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Medical scientists qualify for Critical Skills permits with PR after two years."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Aging society needs lab staff but language and licensing hurdles remain high."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Private labs expanding, yet no special visa category."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "MLTs fall under laboratory scientists, giving fast-track residency."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Hospital mega-projects require a steady pipeline of diagnostic techs."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Biomedical hub needs techs yet tight quota on mid-skill EPs."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Private healthcare boom drives demand; DHA licences issued quickly."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "NHS includes biomedical scientists and MLTs on shortage list."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "",
        "reason": "Federal shortages acknowledged, but technicians not on any special visa list."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Growing diagnostics sector but preference for local hires."
      }
    }
  },
  "11e970e0-1147-4af7-a72a-cdb22678e181": {
    "career": "Network Security Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Listed as ‘ICT Security Specialist’ with fast-track visas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Cybersecurity occupations get priority invitations under the new tech draw."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT security professions exempted from degree requirement if skills proven; blue-card eased."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Cyber on agenda but below minerals, EV and energy priorities."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "ICT security architect/specialist explicitly listed for fast permit."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Points awarded for cyber expertise but not singled out."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Government rolling out national SOCs; talent welcomed though not top-tier."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Migrant Category",
        "reason": "Not on Green List but still gains points as ICT highly-paid role."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Critical for fintech, defence and mega-project cyber-safety."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "National AI Strategy 2.0",
        "reason": "GovTech and MAS recruit aggressively for cyber-defence, though not spelled out as separate pillar."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Operation 300bn",
        "reason": "Cybersecurity named pillar to protect digital economy; Golden Visa offered."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Cyber and AI specialists on Shortage list with salary concessions."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Billions earmarked for critical-infrastructure cyber-resilience and federal workforce hiring of security talent."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National Master Plan 2021-2030",
        "reason": "Growing fintech sector needs security, but policy focus remains semiconductors."
      }
    }
  },
  "3cff09fa-2ee9-4e51-8d2e-6ef1be7172ec": {
    "career": "Photonics Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Migration Strategy 2023",
        "reason": "Advanced manufacturing engineers welcomed though not on core shortage list."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Targets semiconductor and quantum hardware specialists."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Optics and laser engineering are key for its industrial base; blue card eased."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "RPJPN 2025-2045",
        "reason": "Focuses on battery/EV rather than photonics."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "IC design focus spills into integrated photonics hubs in Cork and Limerick."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "81",
        "policy": "Highly Skilled Professional visa",
        "reason": "Global leader in optoelectronics; fast-track points for semiconductor researchers."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Photonics packaging and testing central to its semiconductor climb-up strategy."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "No specific demand for photonics; general engineering points only."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Limited photonics industry outside defence and research."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Manufacturing 2030",
        "reason": "Integrated photonics and quantum optics earmarked for high-value manufacturing growth."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "UAE Centennial 2071",
        "reason": "Some quantum and space optics labs, but small hiring volumes."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Photonics and quantum hardware funded under advanced manufacturing pillar."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Large grants for photonic and semiconductor R&D and fabs."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Investing in optical interconnect R&D, but ecosystem still young."
      }
    }
  },
  "b7cdf279-b6b6-4617-b5a1-8717e7a59269": {
    "career": "Physiology Instructor",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Migration Strategy 2023",
        "reason": "Regional universities sponsor medical-science academics to fill shortages."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities allowed faster visas for health-science lecturers."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Simplified rules for research and higher-education staff in STEM."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "RPJPN 2025-2045",
        "reason": "Local universities emphasise Indonesian hires except for niche chairs."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Higher Education Lecturers listed under Critical Skills."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Tenure-track openings limited; language a barrier."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Some private medical schools hire expats, but not priority."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Migrant Category",
        "reason": "Lecturers score high skill points though not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "New medical colleges recruiting, but local hiring preferred."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Economy 2030",
        "reason": "Top universities recruit globally, but teaching staff not explicit policy target."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Branch campuses hire overseas faculty, but volumes small."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "63",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-science R&D push expands lecturer posts despite visa salary hurdles."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "CHIPS and Science Act",
        "reason": "Act allocates funding to increase STEM and life-science faculty pipeline."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Focus on R&D, not teaching faculty immigration."
      }
    }
  },
  "1229044f-292e-4027-abdc-eec7bbd7fefe": {
    "career": "Powertrain Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Focus on mining and battery raw materials; some vehicle R&D firms hiring."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Ontario/St Lawrence EV corridor needs powertrain talent; draws favour engineers."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Automotive heartland shifting to e-powertrains; visa fast-track for engineers."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel-based battery and EV assembly hub needs powertrain know-how."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "No major vehicle manufacturing."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Highly Skilled Professional visa",
        "reason": "Hybrid/EV giants seek e-axle and battery integration experts."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "NIMP 2030",
        "reason": "Proton and EV suppliers scaling, but volumes moderate."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Small auto industry limits specialised roles."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Auto assembly plans early-stage; focus more on mobility services."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "No volume car production; only small R&D cells."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing push exists but auto segment minor."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "EV, hydrogen and motorsport clusters around Midlands and Silverstone."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Massive subsidies for EV and battery supply chain create demand for drivetrain engineers."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "67",
        "policy": "National Master Plan 2021-2030",
        "reason": "VinFast EV expansion requires drivetrain talent."
      }
    }
  },
  "db1d334a-dbec-45a4-ae4f-532032cd1446": {
    "career": "Public Administration Social Worker",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "63",
        "policy": "Migration Strategy 2023",
        "reason": "Aged-care reforms drive demand for qualified social workers."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Social and community service workers on targeted healthcare-support list."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Shortage of social workers for migrant integration and elder support."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Role not on critical list; general work permit only."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Care workers allowed but social work administration not covered."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "MADANI Economy",
        "reason": "Focus on economic empowerment rather than importing social workers."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Green List (Tier 2)",
        "reason": "Social workers gain fast residence after two years."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Vision 2030",
        "reason": "Sector not prioritised and subject to Saudization."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Green Plan 2030",
        "reason": "Limited slots; social sector prefers citizens/PRs."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Some roles in community welfare yet small numbers and Arabic preference."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Social workers recently removed from list but local shortages persist."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Community development grants create some municipal social-work posts but not immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "0fcbc43b-a208-4431-b776-d2e53e99a69b": {
    "career": "Public Health Administrator",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "State skill lists include ‘Health & Welfare Service Managers’ because public hospitals lack senior administrators."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Healthcare managers fall under the health-occupation draws that now get extra CRS points and faster PR processing."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Hospital systems facing ageing-population pressure actively sponsor foreign public-health managers."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on critical list, yet the HSE offers work permits when local hiring fails."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "Rapidly ageing society increases demand, but Japanese-language and public-sector constraints lower attractiveness."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Skilled Migrant Category",
        "reason": "District Health Boards have shortage points for health-service managers, giving the role a strong but secondary priority."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "Large medical-city projects and privatisation plans need international administrators to modernise public-health delivery."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Green Plan 2030",
        "reason": "Some demand in pandemic preparedness units, but role not in Tier-1 sectors, and tight quota for non-locals."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Expansion of private hospitals (e.g., SEHA, Mediclinic) drives demand, though Emiratisation quotas keep it below Tier-1."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "NHS trusts recruit managers abroad but the job is not on the official Shortage List, giving only moderate visa leverage."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds community-health resilience projects but the occupation is not an explicit visa priority; hospitals still hire internationally for experience."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      }
    }
  },
  "860821e3-c3c1-4ea6-8732-b789a3122989": {
    "career": "R&D Aerospace Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Defence and Australian Space Agency projects seek aero engineers, but numbers are modest."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Aerospace hiring steady (Bombardier, MDA) but not in special immigration draws."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Airbus and ESA facilities face engineer shortages; streamlined EU Blue Card route available."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Focus is on EV and maritime; LAPAN aerospace R&D limited."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Aerospace not on critical list; opportunities limited to avionics sub-sector."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Highly Skilled Professional visa",
        "reason": "JAXA and Mitsubishi Heavy Industries need aero R&D staff, and HSP visa offers fast track."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Aerospace manufacturing & MRO designated as high-value sector with tax incentives for foreign engineers."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Rocket Lab drives niche demand, but overall market is small."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Vision 2030",
        "reason": "NEOM aerospace testing range and KACST investments create growing need, tempered by Saudisation targets."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Economy 2030",
        "reason": "Aerospace MRO and defence R&D are growth pillars; engineers eligible for Tech.Pass."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Operation 300bn",
        "reason": "Mohammed bin Rashid Space Centre, Strata and EDGE recruit global aerospace R&D talent under golden-visa schemes."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 lists aerospace as flagship advanced-manufacturing; visas simplified under Skilled Worker route."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Billions flow to NASA, DARPA and commercial-space R&D; visas fast-tracked for advanced manufacturing and space talent."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National Master Plan 2021-2030",
        "reason": "Policy prioritises semiconductors, not aerospace; only small R&D cells exist."
      }
    }
  },
  "fa9bf240-3b3f-4756-aed6-c303eeb44afb": {
    "career": "R&D Technician",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Mechanical engineering trades appear on CSOL; visas available under sponsored stream."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Manufacturing modernisation needs technicians, but role competes with domestic college grads."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe shortage of mechatronics and lab technicians in Mittelstand R&D centres."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV battery and mineral processing plants recruit mechanical lab technicians."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "47",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Technician roles rarely win Critical Skills permits; some possibilities in med-device R&D."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "SSW covers industrial machinery; pathway exists but Japanese language mandatory."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan emphasises high-value manufacturing; tax breaks for firms hiring skilled R&D technicians."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Some demand in agritech R&D, but small overall market."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Mega-projects need lab technicians but prefer higher-degree engineers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Manufacturing 2030",
        "reason": "Precision-engineering road-map lists technical specialists; S Pass quota tight but obtainable."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Operation 300bn",
        "reason": "Manufacturing push creates openings, yet visas favour engineers over technicians."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Advanced manufacturing hubs need technicians, but not on Shortage List, so sponsorship chances moderate."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "CHIPS and Science Act",
        "reason": "Hundreds of new advanced-manufacturing labs mean immediate demand for hands-on technicians."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "National Master Plan 2021-2030",
        "reason": "Foreign-invested factories need process-development technicians for electronics clusters."
      }
    }
  },
  "10653f7f-4588-4d58-8416-799b7803373f": {
    "career": "Sport Psychologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "General psychologist roles are on skill lists; sport focus is niche but possible."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Clinical psychologists have a pathway, but sport specialisation not prioritised."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Bundesliga clubs hire sport psychologists, yet visas treat them as general health professionals."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Skilled Migrant Category",
        "reason": "NZ Rugby drives some demand, but limited slots overall."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Massive investment in elite sports and esports calls for top-tier performance psychologists."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Singapore Green Plan 2030",
        "reason": "SportSG hires a handful of performance psychologists; quotas are tight."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai Sports Council funds athlete-wellbeing programmes, offering golden visas for specialists."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Premier League clubs hire, but role not on shortage list so sponsorship limited."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct policy support, but pro leagues and NCAA programmes employ psychologists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      }
    }
  },
  "3c2e8060-ffac-4bab-a2ed-5d4c87e994ab": {
    "career": "Sports Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "A-League and cricket bodies use consultants, but small numbers keep it tertiary."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "NHL/MLS franchises hire, yet role not prioritised for visas."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Bundesliga hires strategy firms, but local language barrier high."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Government splurges on sports entertainment; consultants shape league strategy, sponsorship, and mega-events."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "SportsHub and F1 events use consultants, but market size is small and competitive."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai and Abu Dhabi host global tournaments and hire consultants for fan engagement and venue ROI."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Premier League commercial arms use consultants, but immigration priority is low."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No policy driver, but vast pro-sports market hires consultants for stadium projects and fan analytics."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "91550ff3-9f5d-4146-9085-a1d9ce5045a9": {
    "career": "Adult Math Teacher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Secondary STEM teachers are on CSOL; adult education centres recruit similar talent."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Express Entry Category-Based Selection",
        "reason": "STEM educators (including adult upgrading) earn extra CRS points; provinces list numeracy instructors."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Shortage of maths educators in vocational schools; recognition pathway exists for foreign teachers."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Further-education maths tutors eligible for work permits case-by-case; not on Critical Skills list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "List names secondary maths, giving indirect pathway for adult numeracy lecturers."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Workforce Singapore funds numeracy reskilling, yielding some demand for experienced instructors."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "We the UAE 2031",
        "reason": "Lifelong-learning push in free-zones drives some demand, but not an immigration priority."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Chronic FE college maths shortages but teachers removed from official shortage list in 2025."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Community colleges and workforce-upskilling programs suffer chronic maths-teacher gaps, but role is outside federal priority lists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "5a4fb35e-4a7e-4086-a741-42d0c5427818": {
    "career": "Climate Policy Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Net-zero roadmap drives hiring in climate-policy units and CSIRO."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Carbon-pricing leadership fuels demand for researchers; extra visa points for sustainability specialists."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Energiewende and EU Green Deal require analysts to craft regulation and model impacts."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "RPJPN 2025-2045",
        "reason": "Nickel and deforestation debates create limited policy-research contracts."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "",
        "reason": "Rapid wind-energy expansion creates policy research openings, though not on Critical Skills list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Skilled Migrant Category",
        "reason": "Zero Carbon Act implementation needs policy modellers, especially in agriculture emissions."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Emerging carbon-circular projects but limited independent research freedom."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Green Plan 2030",
        "reason": "City-state funds carbon-tax research; international PhDs welcomed via A*STAR."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "We the UAE 2031",
        "reason": "COP28 legacy spurs think-tank hiring, yet numbers remain small."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "UK hosts leading climate think-tanks and mandates carbon-budget reviews needing researchers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA pours billions into clean-energy analysis, funding think-tanks and federal labs hungry for policy talent."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "National Master Plan 2021-2030",
        "reason": "Foreign experts consulted on energy transition studies, but visa pathways ad-hoc."
      }
    }
  },
  "d5130140-cf75-47cb-9b0b-548619469e64": {
    "career": "Concert Performer",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Vision 2030",
        "reason": "Kingdom pours billions into concerts and festivals, actively importing talent for NEOM and Riyadh Season."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Performing-arts passes possible; state funds Esplanade and festivals, but limited slots."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi grow live-music circuits, offering multi-year creative visas."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry route available but competitive and London-centric."
      },
      "united_states": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "28cb4355-ecb4-4819-8238-dd239627f175": {
    "career": "Consulting Specialist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Visa pathways exist but consulting not on shortage lists."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Big Tech HQs require advisors; Critical Skills List excludes consultants, but permits issued on salary."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "Mega-projects contract hordes of strategy consultants, but Saudization raises barriers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Professional-services hub; high EP salary threshold but plenty of consulting roles."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai/Abu Dhabi free-zones court consultants in finance, AI and tourism."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Senior consulting sits under ‘professional services’; sponsor licences plentiful but not priority."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "No federal priority, but H-1B still admits thousands of management consultants."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b3baf2a6-777b-4e3d-9bb8-8fee3153478d": {
    "career": "Diagnostics Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Migration Strategy 2023",
        "reason": "Genomics services expanding; hospitals outsource diagnostic optimisation to consultants."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Healthcare focus plus med-tech cluster in Ontario need consultants for lab accreditation."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "In-vitro diagnostic firms along Rhine recruit foreign scientists for EU IVDR compliance."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Med-tech manufacturing cluster in Galway/Limerick hires diagnostics specialists for EU market."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Highly Skilled Professional visa",
        "reason": "Aging population drives lab modernisation, but Japanese language needed for client work."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Pathology shortages create some consultancy gigs but scale is small."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "New mega-hospitals and research cities import lab-diagnostics expertise."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Economy 2030",
        "reason": "Biomedical hub courts specialists for regulatory science and lab automation projects."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "We the UAE 2031",
        "reason": "Dubai Healthcare City hosts diagnostics start-ups needing regulatory consultants."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences pillar funds diagnostics innovation, especially in NHS genomics programmes."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Massive funding for biotech and precision medicine accelerates demand for diagnostic experts in labs and device firms."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "73a5ded3-7fee-4bd2-ae9f-252d1de24f6a": {
    "career": "Environmental Chemist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Environmental scientists appear on state lists, but chemist sub-specialty has only regional demand."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Environment-related STEM degrees receive extra CRS points; provinces actively recruit water-quality and air-monitoring chemists."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Strict EU pollution rules and green-hydrogen projects need chemists for testing and compliance."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel & EV supply chain drives pollution oversight, but chemist roles limited."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List focuses on biopharma; environment labs recruit, but numbers are small."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-city and waste-to-energy pilots need chemists yet immigration emphasis remains on engineers."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan highlights specialty chemicals and green manufacturing, both reliant on environmental chemists."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Green-list favours environmental engineers; chemists can qualify but with fewer points."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Vision 2030",
        "reason": "Megaprojects promise environmental monitoring, yet roles are niche and often outsourced."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Singapore Green Plan 2030",
        "reason": "Carbon-services hub seeks chemists for lifecycle analysis and emissions testing."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Industrial decarbonisation goals create some demand for lab specialists, but priority is on engineers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean-energy clusters (Teesside, Humber) hire chemists for battery and hydrogen analysis."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Massive funding for clean-energy, carbon capture and hazardous-waste site remediation drives demand for analytical chemists."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "National Master Plan 2021-2030",
        "reason": "Offshore-wind and heavy-industry expansion requires some environmental monitoring expertise."
      }
    }
  },
  "eab2748a-da22-44bc-86f4-43b9554ce9a9": {
    "career": "Global Logistics Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "Transport managers needed but not priority compared with construction trades."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Focused on trucking and warehousing labour, not strategic logisticians."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Export powerhouse relies on specialists for just-in-time manufacturing flows."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "New capital Nusantara and EV supply chains need modern logistics systems."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List prioritises tech and pharma over logistics managers."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "SSW covers dock work and trucking; high-level planners need HSP points but slots limited."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "MADANI Economy",
        "reason": "Aims to boost high-value manufacturing exports—needs better supply-chain coordination."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Small market; demand exists but few visas earmarked for planners."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Vision 2030",
        "reason": "NEOM and Red Sea projects aim to build world-class logistics hubs needing global experts."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Economy 2030",
        "reason": "World shipping hub but role sits just outside official Tier-1 tech focus."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi push to remain top trade and trans-shipment centres, aggressively hiring logistics talent."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Freeports initiative opens some roles, but not on shortage list."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Massive port, rail and highway upgrades spur demand for supply-chain planners."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National Master Plan 2021-2030",
        "reason": "E-commerce boom requires talent in cross-border logistics."
      }
    }
  },
  "a8d88886-8f30-435b-8198-866013c051c1": {
    "career": "Home Adaptation Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "NDIS funding for disability modifications boosts consultant roles."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Ageing population and grants for accessible housing create steady demand."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Rapidly ageing society subsidises barrier-free renovations needing specialist advisors."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List covers OT and physio broadly; adaptation consulting niche."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Severe ageing drives need for barrier-free homes, yet language barrier high."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 2)",
        "reason": "Healthy Homes and ACC programs finance accessibility upgrades."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Vision 2030",
        "reason": "Healthcare expansion exists, yet most elderly care still family-based—small market."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "We the UAE 2031",
        "reason": "Retrofitting demand limited to luxury segment; few visas issued."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "OTs in shortage, but independent consultants must self-sponsor."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Federal ADA retrofits generate work, but role not specifically incentivised."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "0fb195e4-51ed-4e9a-8bb9-93f69a4e526e": {
    "career": "IT Support Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "States list ICT support engineers as shortage occupations."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "IT and cyber are priority; support roles qualify under NOC 22221."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialist track allows residence even without degree if skills proven."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "RPJPN 2025-2045",
        "reason": "Need exists but local supply adequate; visas hard."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "ICT specialists broadly covered; multinationals need 24/7 support teams."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Highly Skilled Professional visa",
        "reason": "Qualified under IT engineer stream, but Japanese language often required."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "NIMP 2030",
        "reason": "Digital services pillar mentions support roles, yet degree of priority modest."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Migrant Category",
        "reason": "IT support included but application points moderate."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Digitalisation push hires support staff yet Saudization limits expat entry-level roles."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "National AI Strategy 2.0",
        "reason": "Data-center boom still needs human support despite automation."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Growing data-center and fintech sectors keep steady demand for help-desk talent."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "List favors cyber and dev-ops; support roles can still get visas with sponsorship."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "CHIPS and Science Act",
        "reason": "New fabs and data centers create in-house help-desk needs though role not high-tech."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Focus on engineering, not routine support."
      }
    }
  },
  "4dd6b9c9-b325-4e0b-b4d8-54f626ccac79": {
    "career": "Molecular Medicine Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "CSIRO and medical-research institutes actively recruit molecular biologists."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Express Entry favours biomedical PhDs; federal funds flow to genomics hubs."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "BioNTech effect: federal grants for mRNA and cell-therapy R&D."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Biopharma goal stated, yet infrastructure still developing."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Biopharma corridor (Cork-Limerick-Galway) urgently needs molecular scientists."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "National projects in regenerative medicine and iPS cells."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "NIMP pushes pharma and medical devices; foreign molecular experts welcomed."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Green List (Tier 2)",
        "reason": "Small but growing biomedical sector; few openings compared to agri-science."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Vision 2030",
        "reason": "King Abdullah City for Science & Tech funds genomics and biotech labs."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Singapore Economy 2030",
        "reason": "Tuition grants and visas for biomedical scientists in Biopolis and Tuas hubs."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Operation 300bn",
        "reason": "Dubai Science Park and Abu Dhabi Biotech Hub recruit molecular specialists."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences superpower ambitions; Oxford-Cambridge clusters hiring aggressively."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act allots billions to cutting-edge biotech and precision-medicine research."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "National Master Plan 2021-2030",
        "reason": "Early-stage biotech ecosystem; some demand but salaries modest."
      }
    }
  },
  "2f824f73-9ce0-451e-b166-74c10bf36038": {
    "career": "Music Policy Advisor",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Immigration lists focus on health, tech and trades—not cultural policy."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Critical Skills List excludes cultural policy, but English-language sector offers limited pathways."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Entertainment megaprojects need music‐rights advisers to shape local content rules."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Creative talent welcomed but not on Tier-1 lists; limited quota slots."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "We the UAE 2031",
        "reason": "Creative-media sector on priority list; senior music policy talent scarce locally."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry senior roles (inc. music) explicitly prioritised for visas."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Creative‐industry experts useful but not named in federal priority lists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "74f4c988-c77c-43a2-8c2b-466bdacc6d19": {
    "career": "Operations Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Large pipeline projects hire consultants to optimise supply chains."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Strategy targets tech-savvy managers who can lift productivity."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Mittelstand firms demand lean/Industry 4.0 operations expertise."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Localisation rules mean foreign consultants compete with SOEs."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Consultants welcomed but not on Critical Skills list; corporate demand exists."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Consultants can enter on business visas but not priority."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan mentions lean transformation but favours engineers over consultants."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Role acknowledged but points competition high versus engineers."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Government megaprojects rely heavily on foreign operations consultants for execution."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "National AI Strategy 2.0",
        "reason": "Firms need ops consultants to embed AI while keeping capacity lean."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Operation 300bn",
        "reason": "Manufacturing push seeks consultants to redesign plants and processes."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Need advisors to scale advanced manufacturing and clean-energy clusters."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Digital-transformation advisers needed for federally funded infrastructure modernisation."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National Master Plan 2021-2030",
        "reason": "E-commerce and semiconductor sectors hire some consultants, yet visas restrictive."
      }
    }
  },
  "274d4444-3549-44be-bcd1-429769898814": {
    "career": "Policy Developer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Migration lists prioritise engineers and health workers over social-policy staff."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Express Entry Category-Based Selection",
        "reason": "French-speaking policy professionals gain extra points; public sector hiring steady."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Fachkräfte law doesn’t feature public-policy roles; German language a hurdle."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "RPJPN 2025-2045",
        "reason": "Government consults external experts yet prioritises Indonesians."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Role possible in NGOs and government but not Critical Skills."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "MADANI Economy stresses industrial policy; limited slots for foreigners."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Points system gives modest weight; no shortage listing."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Reform agenda hires foreign experts to draft labour, tourism and environmental policies."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Policy think-tanks hire, but EP quotas tight."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "We the UAE 2031",
        "reason": "Government accelerators bring in policy talent to design future-ready regulation."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Need analysts to craft sector-specific rules, though visas competitive."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "General policy work valued but not on federal skill lists."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Foreign advisers occasional, but local language and legal limits apply."
      }
    }
  },
  "0ad2a05a-34de-4d94-a624-d9ca74cf8c3c": {
    "career": "Public Policy Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Occupation not on CSOL, yet NGOs sponsor occasionally."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Express Entry Category-Based Selection",
        "reason": "French-speaking managers earn extra CRS points; government hiring consistent."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Language barriers keep public-policy management low priority."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "RPJPN 2025-2045",
        "reason": "Some scope in international NGOs influencing new capital project laws."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Demand exists in tech lobbying, but visas limited."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Policy leadership largely reserved for Japanese nationals."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Foreign policy managers possible in regional HQs, not priority."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Green List omits management policy roles."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Reform offices need senior foreign managers to steer policy programmes."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Policy talent valued but EP quotas tighten; not Tier-1."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Government accelerators hire public-policy leaders to craft forward-looking regulation."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean-energy and creative clusters recruit policy managers for stakeholder alignment."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "",
        "reason": "Advocacy and corporate-affairs roles exist, but not a visa shortage list."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Government contracts restrict foreign leadership; corporate affairs smaller scale."
      }
    }
  },
  "bdabfae7-bd4e-4ed9-b181-6be3878d7b9e": {
    "career": "Research Coordinator",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Medical-research institutes sponsor coordinators for clinical trials."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Healthcare and life-science roles earn high CRS points."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "University hospitals face coordinator shortages, easing visa routes."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Clinical-trial ecosystem nascent; fewer foreign hires."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma corridor around Cork seeks research-trial talent."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP covers clinical-research support in pharma and med-device firms."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "MADANI Economy",
        "reason": "Growing medical-device sector, but coordinator positions fewer than scientists."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Migrant Category",
        "reason": "NZ Health Research Council projects need certified coordinators."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "New medical cities conduct trials for pharma inward investment."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Singapore Green Plan 2030",
        "reason": "Biomed hub funds translational research needing strict coordination."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Biotech free-zones recruit coordinators to comply with global GCP."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-science clusters in Oxford-Cambridge need study-management staff."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds biomedical trials; coordinators oversee study compliance."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Limited large-scale trials; role exists mostly via NGOs."
      }
    }
  },
  "56d68ece-603b-4f7f-9677-43cf9728914c": {
    "career": "School Athletics Coordinator",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Secondary physical-education teachers are on state CSOL lists; athletics coordination is treated as a teaching speciality."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "School teachers and youth-sport educators receive extra points under the early-childhood/K-12 educator priority stream."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "STEM/early-years teachers prioritised; sports teachers can qualify but receive fewer points."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 2)",
        "reason": "PE teachers appear on the Green List, making athletic-coordination experience advantageous for residence pathways."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "18706f28-8898-48af-9f45-066fcb42c851": {
    "career": "Simulation Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "High demand for civil, mining, and defence modelling specialists in CSOL engineering groups."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Classified under software/AI engineering; targeted for advanced-manufacturing clusters."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Automotive and mechanical sectors urgently need CAE and CFD experts."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV battery plants require some modelling, but supply-chain engineers prioritised."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Listed under mechanical/electrical engineers for med-tech and pharma manufacturing."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics and semiconductor sectors actively seek CAE specialists for smart-factory roll-outs."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Digital-twin skills needed in EV and semiconductor process optimisation."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Green List limits to civil and software; simulation engineering not explicitly prioritised."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Vision 2030",
        "reason": "Mega-projects (NEOM, aerospace) recruit digital-twin engineers for construction and mobility."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Manufacturing 2030",
        "reason": "Precision-engineering firms hire simulation experts for advanced process control."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Operation 300bn",
        "reason": "Advanced-manufacturing push values CAE talent for aerospace and additive manufacturing."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Critical for EV, aerospace, and clean-energy advanced-manufacturing pillars."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Digital-twin and multiphysics simulation underpin semiconductor, aerospace, and clean-energy R&D funded by CHIPS/IIJA."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "CAE valued but secondary to physical process engineers."
      }
    }
  },
  "12be8f31-0647-4a76-85c6-b316388a379e": {
    "career": "Social Care Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Aged-care sector shortages include facility and programme managers."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Care-economy roles, especially eldercare leadership, attract extra points in provincial nominee streams."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe nurse shortage creates demand for experienced social-care and elder-home managers."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Critical Skills List excludes social-care, yet employer-sponsored permits possible for managers."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 2)",
        "reason": "Managers of residential care facilities are on the list, enabling fast-track residence."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Post-2025 rules tightened; care-worker visas limited, but senior managers still sponsor-eligible without shortage priority."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Healthcare visas exist, yet policy emphasis is clinical nursing rather than social-care administration."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "76c255e1-f3e4-47e3-a5f8-6d46e849167d": {
    "career": "Theatre Vocalist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Entertainment visas exist but outside CSOL priorities."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Performing artists can obtain self-employment visas, yet not prioritised."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Artist visas exist but no special incentives."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Vision 2030",
        "reason": "Large spending on live entertainment and musical theatre districts under Vision 2030."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Performer Work Passes exist but creative sector not in Tier-1 lists."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi heavily recruit performers for growing theatre and cruise-tourism circuits."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "West End creative-industry pillar values experienced vocalists; Creative Worker visa streamlined."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "O-1 visa available for performers, but no formal labour-shortage incentive."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "2ffb0b44-0847-4115-a52d-673827441540": {
    "career": "University Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Education managers have standard visa pathways but are absent from CSOL priority list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Provincial programmes may accept education managers, yet no federal priority."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "New universities in NEOM and Riyadh seek experienced international campus managers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Autonomous universities can sponsor EPs, but role outside priority clusters."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "UAE Centennial 2071",
        "reason": "Free-zone universities in Dubai/Abu Dhabi recruit global admin leaders."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Universities can sponsor Skilled Worker visas, but role not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Universities can sponsor H-1B, but higher-ed administration not on national skill-shortage lists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "86c82afa-c6e6-43d7-9c10-9781011c5040": {
    "career": "Adult Gerontology NP",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Nurse Practitioners are explicitly listed; priority visas and regional incentives apply."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Advanced-practice nurses qualify under the health-care occupational draws offering fast PR."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe nursing shortage; advanced qualifications earn extra points and fast-track recognition."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Specialist nursing roles remain on Critical Skills permit route."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "SSW covers nursing care; NP scope recognition limited but points help under HSP visa."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Nurse practitioners on Tier-1 list with straight-to-residence pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Large hospital expansion requires specialist nurses, but immigration channels less formalised."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Ageing society needs geriatric care; NPs possible under Employment Pass but not priority list."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Medical tourism push values advanced nurses though not singled out for Golden Visa."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Advanced clinical nurses can still obtain health-and-care visa despite recent tightening."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Ageing population and primary-care gaps create demand, but no dedicated federal immigration priority for nurses."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a8f53c2d-e6be-469f-817f-26deb3cee7ae": {
    "career": "Ag Education Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Migration Strategy 2023",
        "reason": "Regional visas target agri-skills transfer to boost farm productivity."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Agriculture workers and French-speaking educators receive additional points."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Agri knowledge beneficial, but not on priority shortage lists."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "RPJPN 2025-2045",
        "reason": "Vision 2045 calls for farmer upskilling; international expertise sometimes sought."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "SSW aims to modernise farms; educators possible through private consultancies."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Plan stresses upskilling smallholders; extension trainers welcomed selectively."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Migrant Category",
        "reason": "Dairy sector depends on extension advisors for sustainability goals."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "US land-grant universities hire extension educators, but no dedicated immigration channel."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "National Master Plan 2021-2030",
        "reason": "Government pushing smart-farming adoption; needs trainers."
      }
    }
  },
  "88410b41-0f8a-4098-9b91-26110ca95827": {
    "career": "Applied Econometrician",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Data analyst roles allowed, but not on priority list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Strategy targets data scientists; econometricians qualify with quantitative proof."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "STEM points help, yet not on shortage list."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Emerging markets require data economists for EV policy evaluation."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Financial-services quants explicitly listed; fast Critical Skills Permit."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Points system favours PhD econometricians but no shortage list."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "47",
        "policy": "MADANI Economy",
        "reason": "Growing Islamic finance sector needs risk modellers, though not priority."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Macroeconomic modelling skills needed for diversification projects."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "National AI Strategy 2.0",
        "reason": "Financial regulators and banks hire econometricians for stress-testing and AI governance."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "UAE Centennial 2071",
        "reason": "Financial hubs recruit quants and econometric modellers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London demands econometric quants for fintech and risk analytics."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Demand in finance and policy think-tanks, but no immigration priority."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National Master Plan 2021-2030",
        "reason": "Fintech growth may create demand but currently nascent."
      }
    }
  },
  "98bf625b-1068-42fa-878e-4bdb4376b6b2": {
    "career": "Civ-Env Entrepreneur",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Migration Strategy 2023",
        "reason": "Priority for civil/environmental engineers and entrepreneur visas in regional areas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Civil engineers and cleantech founders qualify for Startup Visa and skilled draws."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Climate-tech startups welcomed; engineers obtain EU Blue Card then found firms."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nusantara capital move + EV supply-chain opens doors for civil-env entrepreneurs."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Supportive startup scene but civil-env focus niche."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-city projects need expertise but language/regulation barriers for founders."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Incentives for renewable and infrastructure tech startups in economic corridors."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Civil engineers in demand, but startup visas limited."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "NEOM and giga-projects actively court infra and sustainability entrepreneurs with 0% tax zones."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Startup SG supports greentech but civil construction market is saturated and heavily regulated."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Golden Visa and Operation 300bn support green infra founders."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean energy and construction innovation backed by grants; Innovator Founder visa exists."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Massive federal infrastructure spend creates market space but no special visa for founders."
      },
      "vietnam": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "National Master Plan 2021-2030",
        "reason": "Huge spending on wind, LNG, and transport welcomes foreign green-infra founders."
      }
    }
  },
  "87b694d1-957e-4060-b864-1175317867e9": {
    "career": "Clinical Supervisor",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "Speech pathologists listed on CSOL with priority processing."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Allied health professionals, including SLPs, invited under healthcare draws."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Therapy professions face shortages; credentials need recognition."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Speech and language therapists eligible for critical skills permits."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Licensing barriers; ageing society may open demand later."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Speech-language therapists on Tier-1 with straight-to-residence."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "New rehab centres recruit supervisors though pathways ad-hoc."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Growing rehab sector; foreign SLPs can get Employment Pass but not on priority list."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Private hospitals hire senior SLPs; Golden Visa possible for specialists."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "SLPs remain on shortage list even after other care roles cut."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "SLP demand high but no specific federal immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "ccb2d38b-4ee8-462a-9cb3-f3f7e5dcb5cc": {
    "career": "Community Engagement Officer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Role aligns with local-government and NGO work but is absent from Core Skills Occupation List."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Social-impact professionals can qualify under general skilled-worker streams, yet not on priority lists."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Municipal integration projects need engagement staff, still outside Skilled Immigration Act shortage list."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Community officers hired by councils/tribal authorities, yet not on Green List."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Government agencies run citizen-engagement teams, but role is outside Singapore’s Tier-1 tech focus."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Nation-branding drives community events, but immigration priority remains tech/finance."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Local councils recruit engagement staff, yet role is not on Shortage List."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Community-development roles exist in city and state programs but are not singled out by federal industrial policies."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "15cfd1be-8de4-439d-9775-10623d055f2c": {
    "career": "Curatorial Advisor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Museums Australia sponsors some curators, but Migration Strategy targets STEM trades."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Cultural institutions recruit abroad case-by-case; not on Express Entry priority lists."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Cultural visa routes exist yet outside national shortage classifications."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Mega-museum projects at NEOM need digital curation, but preference leans to experienced Western hires."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "National Gallery recruits global advisors, but role lies outside Tier-1 tech list."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Dubai/Abu Dhabi art districts import curators, albeit not immigration-priority."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Museums may sponsor visas, but role absent from Shortage List."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Major museums hire curators, but federal industrial acts don’t prioritise arts roles."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "dd3fc446-a606-4265-995e-53eeb43f98d4": {
    "career": "Cyber Investigator",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Migration Strategy 2023",
        "reason": "Cybercrime surge places DFIR roles on priority pathways, though behind nurses/software."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Cybersecurity specialists targeted, but forensics niche competes with domestic grads."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT-security experts fast-track visas after ransomware attacks on industry."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Digital-forensics demand rising after e-commerce data leaks, but immigration focus is EV supply chain."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Multinationals’ SOCs in Dublin seek incident-response leads."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "Government ramps up CERT after Tokyo stock-exchange outage."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "MADANI Economy",
        "reason": "Cybersec talent needed for digital banking licenses but not top-tier."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Some demand in CERT NZ, but not on Green List yet."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Fintech and defence pushes drive digital-forensics hiring, though expats face security clearance limits."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "National AI Strategy 2.0",
        "reason": "GovTech and MAS lead region in hiring DFIR and threat-hunt experts."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai Cyber Security Strategy welcomes DFIR talent for banking and energy sectors."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "National Cyber Force expansion makes digital-forensics a shortage occupation."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Bill earmarks billions for critical-infrastructure cybersecurity, boosting digital forensics hiring."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "National Master Plan 2021-2030",
        "reason": "Fintech boom requires cyber investigators, still secondary to semiconductor engineers."
      }
    }
  },
  "3da0f6d7-b91e-4862-9706-ea40b8c0742f": {
    "career": "Cyber Technologist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Migration Strategy 2023",
        "reason": "Listed on Core Skills Occupation List; acute talent shortage post-Optus breach."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Cybersecurity walk-in category expedites PR for SOC analysts and engineers."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Fast-track for IT experts, though bureaucracy slows English-only applicants."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech apps hiring cyber staff, yet immigration focus on EV supply chain."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Demand in Dublin tech HQs, but data/cloud roles rank slightly higher."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "Government campaigns for cyber engineers ahead of Osaka Expo 2025."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "MADANI Economy",
        "reason": "Growing digital-banking sector, but hardware engineers get priority."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Cyber roles needed but not yet on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Smart-city and fintech projects require SOC architects."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "National AI Strategy 2.0",
        "reason": "Cybersecurity & Trust is pillar; roles get Tech.Pass and COMPASS bonus."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "UAE Centennial 2071",
        "reason": "Financial-centre regulators push banks to hire cyber technologists."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital & cyber security listed as key pillar; shortage-occupation benefits apply."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Federal funding for critical-infrastructure cyber defences fuels nationwide hiring."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "National Master Plan 2021-2030",
        "reason": "E-commerce boom sparks SOC demand, albeit secondary to semiconductor talent."
      }
    }
  },
  "8285114a-2d71-42de-8d5d-7c7ebb59760a": {
    "career": "Data Strategist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Data analysts on Core Skills list but behind cyber and engineers."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Dedicated stream for data scientists and analytics professionals."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialists category covers data roles with streamlined EU Blue Card."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Fintech startups seek data leads but immigration focus elsewhere."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Dublin’s cloud HQs list data architects as shortage occupation."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "Corporate digital-transformation drives demand, but language barrier slows hiring."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "MADANI Economy",
        "reason": "Data analytics in Islamic finance growing yet not top priority."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Demand growing in banking and government; not yet on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Smart-city megaprojects need data governance leads."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Singapore Economy 2030",
        "reason": "Nation positions itself as regional data hub; strategists receive COMPASS bonus."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Fintech and carbon markets require data strategy talent."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "AI & data economy pillar makes strategists eligible for Skilled Worker fast-track."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds AI and data-centric R&D, driving demand for data strategy leads."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "National Master Plan 2021-2030",
        "reason": "E-commerce data roles emerging, still secondary to semiconductor push."
      }
    }
  },
  "eca42704-2440-49a0-ac20-86e667d83cad": {
    "career": "Environmental Entrepreneur",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Migration Strategy 2023",
        "reason": "Clean-energy founders welcomed through Global Talent visa, yet entrepreneur quota remains small versus engineer demand."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Climate tech is eligible for start-up visas and green-tech funds, but not singled out in category-based selection."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Germany’s Energiewende needs renewable-energy ventures; streamlined Opportunity Card favours greentech founders with capital."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Clean-energy ventures wanted for geothermal and batteries, but regulatory opacity deters early-stage entrepreneurs."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "No direct list match, yet Enterprise Ireland gives seed grants for green start-ups."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP rewards patents and capital, but green-tech venture ecosystem still small."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "NIMP 2030",
        "reason": "Plan emphasises renewable manufacturing; start-up incentives exist but fewer exits attract founders cautiously."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "List covers renewable-energy engineers, not founders; Start-up visa exists but capped."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Vision 2030",
        "reason": "NEOM and Red Sea giga-projects fund sustainability start-ups, yet foreign ownership rules add hurdles."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Singapore Green Plan 2030",
        "reason": "Climate Impact X, Temasek funds, and EntrePass favour green founders, though competition and high costs are steep."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "We the UAE 2031",
        "reason": "Golden Visa for sustainability founders and Masdar City incubators, but priority still on scale-ups, not early ideation."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean-energy and climate-tech on IS-8; Innovator Founder visa and £1 B Net Zero fund make UK a prime hub."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA pours >US$380 B into clean-energy start-ups, offering tax credits, grants and loan guarantees that directly benefit climate-tech founders."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "National Master Plan 2021-2030",
        "reason": "Government backs offshore wind and agri-tech, yet foreign founder visa path unclear."
      }
    }
  },
  "bd6f4030-03fe-4087-b5a4-b3ea4173a992": {
    "career": "FinTech Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Financial analysts appear on CSOL but below STEM shortage jobs."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Express Entry Category-Based Selection",
        "reason": "FinTech falls under generic NOC 1112, not in targeted draws."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "FinTech hubs in Berlin/Frankfurt hire, yet not a listed shortage occupation."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "FinTech mentioned but behind EV and energy priorities."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "FinTech analysts not on list, yet Dublin’s e-payments cluster offers plentiful general work visas."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "FinTech candidates qualify on points, but language and conservative banking slow growth."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "MADANI Economy",
        "reason": "Kuala Lumpur pushes Islamic digital finance; regulators offer sandbox visas for FinTech experts."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Skilled Migrant Category",
        "reason": "Points possible as business analyst, but no specific FinTech shortage."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Massive investment in Riyadh FinTech hub and digital payments makes analysts high-priority hires."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Singapore Economy 2030",
        "reason": "MAS grants and FinTech Festival cement city as global hub; Tech.Pass eases entry."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "UAE Centennial 2071",
        "reason": "DIFC and ADGM aggressively court FinTech talent with Golden Visa and zero tax."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "London is Europe’s FinTech capital; IS-8 lists financial services, plus Scale-up visa streamlines hiring."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "FinTech not a federal priority; roles exist but immigration pathways are generic."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Policy focus on hardware; FinTech growth is market-led, not policy-driven."
      }
    }
  },
  "0d002f1a-3208-4040-a58a-9a55a8066920": {
    "career": "Food Service Director",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Chefs are listed, but higher-level food service managers are not priority."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Hospitality managers rarely receive targeted invitations."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Shortages exist in kitchen staff, not director roles."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Hospitality mentioned but below energy and infrastructure priorities."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on list; pubs and hotels hire locally first."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "SSW covers hotel staff, not director-level foreigners."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "41",
        "policy": "MADANI Economy",
        "reason": "Policy focuses on manufacturing; hospitality visas are routine, not priority."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Skilled Migrant Category",
        "reason": "Restaurant managers appear on some regional lists but low points weight."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Giga-projects need large-scale hospitality leadership, boosting demand for institutional food directors."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Singapore Green Plan 2030",
        "reason": "Nutrition sustainability programs need managers, but role not in talent lists; quota constraints apply."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "We the UAE 2031",
        "reason": "Tourism expansion drives demand for food ops managers, but visas are standard, not special."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Hospitality removed from shortage list post-2025."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct priority; institutional dining grows with new public facilities."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "de631f22-9000-4153-916f-525207bd1aee": {
    "career": "Information Security Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Cyber Security Specialist is priority; Global Talent pathway fast-tracks visas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Cybersecurity Analysts are one of five tech occupations with dedicated invitation rounds starting 2024."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT security experts receive Blue Card with lower salary threshold and no degree requirement if skilled."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "RPJPN 2025-2045",
        "reason": "Digital-economy plans cite cyber, yet hiring bias is for local talent to meet data-residency laws."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Information security specialist on list; strong demand but slightly lower global pull than UK."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Highly Skilled Professional visa",
        "reason": "Points awarded, but language and lifelong employment norms slow hiring."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "NIMP 2030",
        "reason": "Cybersecurity skills support Industry 4.0 roll-out, though not headline priority."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Software engineers listed, cyber roles accepted case-by-case."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Digital government push hires cyber talent, but oil/defence nationals get preference."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "National AI Strategy 2.0",
        "reason": "CSA SkillsFuture subsidies and Tech.Pass target cybersecurity; Smart Nation cannot run without infosec."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Operation 300bn",
        "reason": "Banking and energy sectors poach cyber experts; Golden Visa available yet not quota-protected."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital/cyber listed; Scale-up and Skilled Worker visas eased for SOC-class 2135."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds semiconductor and AI labs that all require cybersecurity staff, but cyber not explicitly named."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Cybersecurity needed but overshadowed by hardware engineering focus."
      }
    }
  },
  "1a93a90d-4df8-418f-813c-2c6b22250cfe": {
    "career": "Math Teacher",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Secondary STEM teachers are explicit priority with fast-track visas to regional schools."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "K-12 teachers included; French-speaking math teachers get extra points under category draws."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Acute shortage of STEM teachers; credential recognition streamlined under Opportunity Card."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Teachers excluded; EU preference applies."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "JET Programme hires language, not math teachers; private international schools limited."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "MADANI Economy",
        "reason": "Education sector not on priority lists."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Secondary math teachers on Tier 1—direct to residence pathway, no labour test."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Vision 2030",
        "reason": "International schools hire, but Saudization limits public-school visas."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Singapore Green Plan 2030",
        "reason": "MOE prefers citizens; private tuition centres hire but role not in talent list."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "We the UAE 2031",
        "reason": "Private schools recruit expat math teachers, yet not part of national talent strategy."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Math teachers were removed from shortage list in 2025; still possible but no fast track."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Teachers not covered; H-1B cap still possible but limited."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "STEM education push exists but local hiring preferred."
      }
    }
  },
  "4daee4d3-8a32-4448-b97a-31a38011732f": {
    "career": "Outpatient Nutrition Counselor",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Dietitians appear on the CSOL and several state occupation lists, speeding visa processing."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Allied-health professionals (including dietitians) receive extra CRS points and provincial nominations."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Act fast-tracks recognition for allied-health roles to combat hospital shortages."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Can obtain General Work Permit but not on Critical Skills list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Dietitians are on Tier 2, allowing straight-to-residence pathways after two years."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Wellness tourism and private hospitals need nutritionists, but not nationally prioritised."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Green Plan 2030",
        "reason": "Chronic-disease prevention drives hiring, but role is not on key manpower lists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "Preventive-health programmes in Dubai Health City hire dietitians; no dedicated visa track."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Dietitians were recently removed from the shortage list; sponsorship still possible but harder."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Hospitals hire dietitians but there is no dedicated federal immigration or funding priority for the role."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "5a952b45-fe64-433b-b99e-74b62dccfbb4": {
    "career": "Performance Coach",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Sport-mad culture hires coaches, though not on CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Sports roles qualify under general work permits but not targeted."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Olympic legacy funds some foreign coaching roles, but limited visa quotas."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "",
        "reason": "High-performance sport programmes hire foreign experts case-by-case."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Government is investing billions in elite sports academies and leagues."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "We the UAE 2031",
        "reason": "Dubai Sports City and Abu Dhabi clubs recruit international performance staff."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Premier League clubs hire coaches but sponsorship caps apply."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Large pro-sports market creates demand, yet no federal talent policy for coaches."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b69ac1bf-32bd-40a1-977e-f284474389f1": {
    "career": "Process Chemist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Chemical and materials engineers are on CSOL for mining, battery and defence sectors."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Strategy targets cleantech and pharma manufacturing where process chemists are scarce."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Germany’s chemicals and green-hydrogen clusters recruit foreign process chemists aggressively."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel refining and EV battery chemicals are priority sectors."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Biopharma and medtech plants place process chemists on the critical list."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Highly Skilled Professional visa",
        "reason": "Materials science and battery R&D need foreign chemists; HSP gives fast track."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "NIMP spotlights specialty chemicals and semiconductor wet-process chemicals."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Niche demand in dairy and pharma plants; can use Skilled Migrant Category."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Downstream petrochemical mega-projects like SABIC rely on process chemists."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Manufacturing 2030",
        "reason": "Jurong Island chemical hub and pharma API plants hire process chemists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Operation 300bn",
        "reason": "Push for advanced manufacturing and specialty chemicals creates openings."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences and clean-energy pillars list chemical-process experts as priority hires."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds battery, hydrogen and advanced-materials plants that need chemical-process experts."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "63",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Chip packaging plants need chemists for photoresists and cleaning chemistries."
      }
    }
  },
  "a9267f4a-acb1-45e4-8c7c-4f94e7c6b023": {
    "career": "Tax Advisor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Tax agents can obtain visas, yet not on CSOL priority lists."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Role qualifies under general Express Entry but not category-based selections."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Strict local-exam requirement and German language makes foreign entry hard."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "RPJPN 2025-2045",
        "reason": "Tax reforms accompany foreign investment push; role supported but not prioritised."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Multinationals in Dublin need international tax planners despite not being on list—critical under employer permits."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Tax advising tightly regulated; language and exam barriers."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "MADANI Economy",
        "reason": "Islamic-finance hubs require cross-border tax talent though not officially prioritised."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "New VAT/corporate-tax rules drive demand for global tax expertise."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Singapore Economy 2030",
        "reason": "ASEAN HQs need transfer-pricing and carbon-tax advice, easing EP approvals."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "We the UAE 2031",
        "reason": "Introduction of corporate tax and global-minimum-tax rules make advisors critical."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London seeks senior tax and structuring specialists for financial services."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Financial services demand exists, but no immigration priority for tax professionals."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "FDI growth creates some demand, but no formal priority pathway."
      }
    }
  },
  "56a8157a-8a8f-464d-9a1b-1627826ce00d": {
    "career": "Visual Arts Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Limited demand; Distinguished Talent visa only for top artists."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Creative roles seldom receive points under category-based selection."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Berlin’s freelance visa supports art professionals, but no national shortage."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Bali galleries use freelancers; no immigration incentive."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Galleries in Tokyo hire foreign curators under Specialist in Humanities visa."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Mega-projects like AlUla and NEOM hire art consultants for museums and public art."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "National Gallery projects create some openings via Employment Pass but not priority."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s cultural districts and auction houses recruit international consultants."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry pillar values senior curators and consultants, though visas are competitive."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Large art market allows O-1 visas for recognised consultants, but no policy priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "d9d22c51-0eae-4d49-8b82-52df517769e2": {
    "career": "Analytical Chemist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "List covers environmental and industrial chemists but demand is moderate; regional pharma plants offer some roles."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "STEM researchers, especially in life-sciences and mining, receive extra CRS points under the science category."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "World-leading chemical industry (BASF, Bayer) faces ageing workforce; visa fast-track for STEM degrees."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV battery-materials refining needs lab chemists, but recruitment still early-stage."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Massive biopharma manufacturing base (Pfizer, MSD, Lilly) lists analytical chemists as a shortage occupation with fast-track residency."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points for advanced science degrees; roles in pharma QC and battery-materials labs."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan prioritises specialty chemicals; Penang and Johor fabs need analytical chemists for quality labs."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Skilled Migrant Category",
        "reason": "Small but growing food-testing and pharma QC labs keep chemists on the general skills list."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Downstream specialty-chemical and pharma clusters emerging in NEOM; demand still niche today."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Singapore Economy 2030",
        "reason": "Biomedical manufacturing cluster (Pfizer, GSK, Lonza) puts analytical chemists on preferred hiring lists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Operation 300bn",
        "reason": "Dubai Science Park courting biotech firms; chemists needed for QC and method development."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences pillar funds analytical R&D; eased Skilled-Worker visa for chemists in pharma hubs."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds core science labs and materials R&D; pharma and chemical companies hiring analytical chemists for advanced characterization."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "National Master Plan 2021-2030",
        "reason": "Growing pharma and semi-packaging sectors create modest demand for chemical analysis expertise."
      }
    }
  },
  "ab199421-cbe8-4ce9-9b5d-e3a7f75d454b": {
    "career": "Child Development Advisor",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Severe shortage of early-childhood professionals; advisory roles accepted as ANZSCO 272199 (counsellors nec)."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Early-childhood educators and allied specialists receive extra points; provinces offer PNP streams for child-care experts."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Government funds Kita expansion; child psychologists and advisors welcomed with streamlined recognition."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Childcare staff shortages persist, yet advisory positions compete with EU talent; some NGO roles."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Green List (Tier 2)",
        "reason": "Early-childhood teachers on Green List; developmental advisors hired by MoE and NGOs."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct priority; limited openings in Head-Start and private clinics via general labour shortages."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "643b05d5-ffbd-4375-be2e-3f89aab80823": {
    "career": "Energy Systems Integration Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Migration Strategy 2023",
        "reason": "State grids adding rooftop solar at world-record levels; shortage of engineers who can manage two-way power flows."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Hydro-Quebec, BC Hydro, and private clean-tech firms sponsor specialists integrating solar, wind, and storage."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Energiewende accelerates; TSO/DSO recruit integration experts for offshore wind and hydrogen projects."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Geothermal expansion and new capital city Nusantara require smart-grid design, but bureaucracy slows hiring."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "EirGrid recruits integration engineers for high wind penetrations; demand is steady but smaller market."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Utilities trial floating offshore wind; Japanese language barrier tempers recruitment."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "59",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan backs solar-plus-storage parks; need for engineers exists but few visas issued."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "100 % renewable target pushes Transpower to hire grid integration specialists."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "NEOM and Red Sea megaprojects promise world-largest green-hydrogen plants and microgrids."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Green Plan 2030",
        "reason": "Nation imports renewables via undersea cables and builds microgrids for data centres; integration engineers prized."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Masdar’s giga-solar farms and Dubai DEWA’s smart grid need integration talent."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Offshore wind and battery clusters on Humber and Teesside list power-system engineers on shortage list."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Billions for grid modernisation, EV charging, and renewables create huge demand for engineers who can stitch systems together."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "National Master Plan 2021-2030",
        "reason": "Rapid solar build-out strains the grid; foreign experts hired on project basis."
      }
    }
  },
  "c4ab571f-901b-4c27-a6fb-d4770107ae5d": {
    "career": "Formulation Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Limited but growing biotech manufacturing; some roles in Melbourne pharma precinct."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Life-science professionals receive STEM points; Quebec and Ontario pharma clusters recruit formulation experts."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Big vaccine and generics plants (BioNTech, STADA) need dosage-form scientists."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "State push for vaccine self-sufficiency still early stage."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "12/25 top pharma firms run plants; formulation scientists flagged as critical skills with immediate work-permit eligibility."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Highly Skilled Professional visa",
        "reason": "Global pharma R&D units in Osaka hire, but language and patents barriers exist."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan boosts pharma manufacturing; Penang factories need dosage-formulation know-how."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Small nutraceutical sector; few positions."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Vision 2030",
        "reason": "New API and vaccine facilities planned, demand still emerging."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Singapore Economy 2030",
        "reason": "Biopharma cluster (Pfizer, AbbVie, Lonza) prioritises formulation and process-development scientists; fast-track EPs."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Operation 300bn",
        "reason": "Dubai Science Park’s pharma hub recruits selectively for formulation R&D."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences pillar funds advanced drug-delivery research; Easy Skilled-Worker visa for formulation scientists."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds broader biotech R&D; pharma plants in Boston and Raleigh hire formulation scientists."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "National Master Plan 2021-2030",
        "reason": "Domestic pharma focuses on generics; limited R&D budget."
      }
    }
  },
  "969b041f-3cab-4a87-9996-bf744e110a3d": {
    "career": "HR Researcher",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Business researchers may qualify under general STEM/analytics, but HR not a named priority."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "May qualify via points for masters and experience, but HR research not shortage field."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Tech MNCs value people-analytics, yet HR not on critical list, so general permit route only."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National AI Strategy 2.0",
        "reason": "People-analytics intersects with AI adoption; EPs possible for top performers."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "UAE Centennial 2071",
        "reason": "Large multinationals in DIFC employ workforce-analytics teams; visas possible but competitive."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Data-driven management consulting sometimes sponsors HR analysts under 'business specialist' visas."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct priority; large corporates still value workforce analytics but not immigration-priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "faad95d9-0e50-4d89-a470-3d50b3f487db": {
    "career": "Jazz Ensemble Director",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Cultural workers can qualify under French-speaker or Provincial Nominee streams, but music is not on priority lists."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Massive state investment in live entertainment and music academies needs experienced directors to train local talent."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "We the UAE 2031",
        "reason": "Dubai-Abu Dhabi cultural districts hire foreign conductors and music educators for orchestras and jazz festivals."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry growth supports music roles, but they are outside formal shortage lists."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Not directly targeted, but U.S. grants and O-1 artist visas make large jazz programs recruit foreign directors for festivals and universities."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "e256e205-60a4-4f55-9c1c-4858c30280cc": {
    "career": "Journalism Consultant",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Program encourages media digitization, but journalism not on core shortage list."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "State-owned channels and mega-projects need global media advisors to build English-language credibility."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "National AI Strategy 2.0",
        "reason": "Major publishers explore AI newsrooms and engage external consultants, but role is ancillary to tech focus."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "We the UAE 2031",
        "reason": "Dubai Media City aggressively hires senior journalism strategists to position UAE as a global content hub."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative sector growth funds newsroom innovation, but not on official shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Digital infrastructure spending boosts local media transformation projects that hire consultants."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "d50acd0d-0a4f-4608-b586-9b1f15f02298": {
    "career": "Military Historian",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Migration Strategy 2023",
        "reason": "Some defence think-tanks sponsor historians for strategic studies, but no official shortage."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities recruit PhD historians, but role is not on priority list."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Research institutions can hire foreign PhDs through points system even if field isn’t prioritised."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Economy 2030",
        "reason": "National war museums occasionally recruit curators with deep military history expertise."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "UAE Centennial 2071",
        "reason": "War museums and defence colleges invite historians for exhibitions and curriculum."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "UK universities hold large MOD grants for war studies but humanities not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds humanities digitization projects at universities hosting defense archives."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "70133e79-1d78-4e0b-958b-925aca745839": {
    "career": "Musical Theater Performer",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Cultural Stream permits performers, but not on shortage lists."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Massive entertainment districts and state-backed musicals actively recruit international performers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Singapore Economy 2030",
        "reason": "Marina Bay Sands theatres cast foreign leads, but role not within core priority industries."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Dubai Opera and Expo City host year-round musicals needing global casts."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries recognised; West End producers sponsor exceptional talent visas."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Arts grants tied to downtown revitalisation indirectly fund regional theatres hiring foreign talent."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "7aab8637-8e27-4598-83a4-104c590578f7": {
    "career": "Occupational Therapy Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Allied-health researchers sit on priority list for ageing-care innovation."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Healthcare and French-speaker streams give fast-track PR to allied-health researchers."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe rehab workforce gaps; research hospitals sponsor OT PhDs."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Rehab services expanding slowly; research roles exist but few sponsorships."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Allied-health researchers get Critical Skills permits, though not explicitly named."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Hospitals sponsor PhD researchers; points based, but OT not on top shortage list."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Healthcare R&D growing, but most slots target medtech engineers rather than OT."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Rehabilitation researchers listed; direct residence pathway offered."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Mega-hospitals and rehab centres expand and recruit allied-health researchers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Green Plan 2030",
        "reason": "Ageing-population initiatives fund rehab research, but role not on top priority list."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "UAE Centennial 2071",
        "reason": "Academic medical centres in Abu Dhabi fund rehab innovation labs."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences R&D priority includes rehabilitation tech; Global Talent visa route possible."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Health-related grants for ageing and disability fund OT research posts, but not an immigration priority."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Healthcare investment rising, but foreign research hires remain limited."
      }
    }
  },
  "be3aca8f-8648-4d0c-b16d-c0655cbed67e": {
    "career": "Private Practice Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Physiotherapists appear on CSOL; states actively sponsor for permanent visas due to chronic shortages."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Allied health professionals, including physiotherapists, receive targeted draws and extra CRS points."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Act allows allied-health recruitment, but physiotherapy is not a named top-shortage occupation and requires B2 German."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Physiotherapists remain on Critical Skills list, giving two-year permit and fast-track to PR."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Physiotherapists on Tier-1 Green List with direct residence pathway after job offer."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Sports-medicine clinics and rehab centres expanding, yet no dedicated visa fast-track for the role."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Singapore Green Plan 2030",
        "reason": "Ageing population creates rehab demand, but role sits outside top-tier talent lists; standard Employment Pass route only."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Medical-tourism growth fuels demand; licensing through DHA/HAAD needed, but not a Golden-Visa priority."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Physiotherapy was removed from shortage list in 2025; still recruit overseas on standard visas."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Ageing population drives demand for rehab, but federal priority lists focus on doctors and nurses, not physiotherapists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "831c5e7c-9b9c-46c0-ab43-2c7a261bdb2c": {
    "career": "Safety Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Construction and mining projects require safety engineers, giving state nomination opportunities."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Engineers generally welcomed, but safety engineering is not a targeted Express-Entry category."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Industrial safety experts qualify under engineering titles amid renewed manufacturing push."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV battery and mining facilities must meet global safety standards, opening specialist roles."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Construction boom creates demand; no dedicated fast-track but standard Critical Skills permit possible under civil/mechanical engineer codes."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "Manufacturing safety expertise valued, though language and regulatory knowledge barriers remain."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industrial 4.0 upgrades and semiconductor fabs require process-safety talent."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Safety roles exist in construction but not on Green List, so standard points route applies."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Vision 2030",
        "reason": "Mega-projects like NEOM and Red Sea demand rigorous safety management; employers actively sponsor visas."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Singapore Green Plan 2030",
        "reason": "Tight workplace safety regulations sustain demand, yet role is not in Tier-1 talent lists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Operation 300bn",
        "reason": "Expansion of advanced manufacturing and logistics hubs increases need for certified safety professionals."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "High-risk sectors (nuclear, defence, offshore wind) hire safety engineers, but not formally short-listed."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "79",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Massive infrastructure rebuilds demand process and occupational safety specialists across construction and manufacturing."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National Master Plan 2021-2030",
        "reason": "Rapid electronics and infrastructure build-out needs safety systems, attracting foreign engineers."
      }
    }
  },
  "2568641b-2e32-436f-b531-bb5a68fd1265": {
    "career": "Spanish Language Specialist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Tourism outreach to Latin America fuels need for Spanish copywriters, but jobs limited."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "We the UAE 2031",
        "reason": "Airlines and free-zone media firms want Spanish localisation, yet niche hiring."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Spanish dominates U.S. LEP market, but no immigration priority exists for linguists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "582a217a-4249-4d03-8ee4-5aefaf339a47": {
    "career": "Biomechanics Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Migration Strategy 2023",
        "reason": "Sports-tech and medical-device R&D funded ahead of Brisbane 2032 Olympics."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities seek sports-science PhDs; Global Skills Stream eases hiring."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Research institutes like Fraunhofer hire movement-science PhDs via Blue Card pathway."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Biomechanics can qualify under biomedical engineer codes, but not explicitly prioritised."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics giants fund human-movement labs; HSP visa rewards PhD holders."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Emerging sport-science centres, yet limited immigration incentives."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Otago and AUT sports labs recruit, but role not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Vision 2030",
        "reason": "Sports cities need performance labs, yet research ecosystem is nascent."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Singapore Green Plan 2030",
        "reason": "Public HealthTech grants occasionally cover movement disorders, but role is outside Tier-1 list."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "We the UAE 2031",
        "reason": "Dubai Sports Tech Hub funds biomechanics startups, but limited academic posts."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences pillar supports med-tech and prosthetics where biomechanics expertise is central."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "CHIPS and Science Act",
        "reason": "Act boosts fundamental research funding, including human-movement science for robotics and exoskeletons."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "2aa231da-745d-47c4-8eac-58654e40905f": {
    "career": "Child Mental Health Counselor",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Migration Strategy 2023",
        "reason": "Nationwide shortage of child psychologists and counselors; role often state-sponsored."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Care-economy occupations, including mental-health counselors, receive targeted invitations and quick PR."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Mental-health demand growing, but language barrier and licensing hurdles keep quotas low."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Clinical psychologists listed; child mental-health counselors slide under that code."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Clinical psychologists on Tier-1; child counselors can enter via closely-related codes."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "New school and hospital projects hire foreign therapists, yet licensing opaque."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Singapore Green Plan 2030",
        "reason": "Mental-wellness acknowledged as social goal, but Employment Pass only, no shortage list."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "We the UAE 2031",
        "reason": "Dubai's mental-wellness push needs counselors, but no Golden-Visa priority."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "NHS hires child therapists under skilled-worker visa, albeit standard points only."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "",
        "reason": "Post-pandemic youth mental-health emergency funds accelerate visa sponsorship for licensed counselors, but no specific federal act."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a4cf6c28-fc2f-46c7-b5f2-3e6c3f0ded70": {
    "career": "Clinical Dietitian",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Migration Strategy 2023",
        "reason": "Allied-health shortages; state nomination lists regularly include dietitians."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Dietitians fall under the healthcare occupations given top immigration priority."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Hospitals recruit foreign dietitians to address chronic staffing gaps."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "HSE recruits internationally, yet dietetics is outside the Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Ageing population increases need, but no dedicated fast-track visa category."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Dietitians are on the Green List, offering straight-to-residence pathways."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "New specialty hospitals and diabetes centres need licensed dietitians."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Lifestyle-disease initiatives spur moderate demand for clinical nutritionists."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "NHS vacancies exist but dietitians not on the official shortage list post-2025."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Growing hospital demand for nutrition therapy but not covered by major federal talent policies."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "5b7f6bcf-42c1-4148-a5a6-34cbb7a45863": {
    "career": "Composition Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Limited but stable research funding through ARC and conservatories."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Academic demand exists but not immigration-priority; jobs tied to few universities."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "",
        "reason": "Publicly funded universities and conservatoires value music research heritage."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "World-class conservatoires and AHRC funding make the UK a strong base."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Large university system and NEA grants sustain musicology posts."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "07b68d95-dacf-4507-abdb-75c209015c78": {
    "career": "Computational Social Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Migration Strategy 2023",
        "reason": "Data and cyber roles are on the core skills list."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Data scientists get priority work permits and permanent residency pathways."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialists fast-tracked; social-data analytics fits."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Government targets data-driven policy for Nusantara smart city."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Data scientists appear on the Critical Skills list."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "AI and data analytics qualify for fast-track points."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "MADANI Economy",
        "reason": "Data analytics is encouraged but incentives focus on manufacturing."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Migrant Category",
        "reason": "General demand for data roles but no specific fast lane."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Smart-city and fintech projects need social data insights."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "National AI Strategy 2.0",
        "reason": "Active funding for social-behavioural AI research labs."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "UAE Centennial 2071",
        "reason": "Government AI labs recruit behavioural data scientists."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 prioritises digital, AI and data science expertise."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act pumps billions into AI & data-driven research across social domains."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "National Master Plan 2021-2030",
        "reason": "Tech strategy values AI/ML talent for e-commerce and fintech."
      }
    }
  },
  "f8c57910-e0a7-46f2-8286-52be529a1884": {
    "career": "Creative Technologist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Some demand in media hubs; not on core skills list."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Digital creativity valued, yet visa priorities focus on pure tech."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Growing interactive media scene but policy spotlights engineering, not creative tech."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Film and game studios present some demand but no visa priority."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Interactive art scene exists, yet immigration quotas focus on robotics."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Mega-projects like NEOM need AR/VR experiences and interactive installations."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Singapore Economy 2030",
        "reason": "Nation promotes digital creative exports and immersive media."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai’s media city courts tech-driven creatives for immersive attractions."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry and gaming leaders are explicitly prioritised."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "",
        "reason": "Robust demand in advertising, gaming and AR/VR labs but not a federal priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "51714523-9e64-46df-9de0-eb0750b3d589": {
    "career": "Dramaturg",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Major companies like Sydney Theatre employ dramaturgs, but roles are few."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Stratford and other festivals hire dramaturgs, yet no immigration priority."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Rich subsidised theatre culture maintains steady demand for dramaturgie."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "National portfolio theatres still value dramaturgs despite funding cuts."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Large regional theatre network offers limited but real opportunities."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "0494d49d-3df3-4f1d-9136-36e3021b0c69": {
    "career": "Education Economist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Migration Strategy 2023",
        "reason": "Demand for cost-effectiveness analysis of school funding yet role sits outside named shortage list."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Ottawa prioritises research talent for policy evaluation of its public-school reforms and French-language education."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Universities hire economists for PISA-driven research but immigration officers view it as general academic job."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "41",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Government calls for schooling quality metrics, but expat hiring rare."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Universities hire but occupation not on critical list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Highly Skilled Professional visa",
        "reason": "Some think-tank roles; language barrier keeps inflow low."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "MADANI Economy",
        "reason": "Education finance reform underway, yet talent drawn locally."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Some posts in Ministry of Education policy units, yet numbers small."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Hiring foreign economists for education reform consultancies but localisation preference limits visas."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Economy 2030",
        "reason": "MOE funds rigorous policy trials; economists valued though numbers modest."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Private K-12 groups commission ROI studies, though not officially listed shortage."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Institute for Fiscal Studies and government departments sponsor quantitative economists to model school funding and productivity."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "NSF and Institute of Education Sciences grants fund large-scale education-outcome studies; universities actively sponsor economist visas."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Limited specialised demand; focus is on STEM capacity building."
      }
    }
  },
  "5fe940bb-c8bb-480f-b2c4-590bc9c095e5": {
    "career": "Env Parametric Designer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Energy-positive building push raises need for advanced modelling skills."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Architects welcome but not priority; sustainable design a nice-to-have."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Timber-hybrid high-rise boom uses parametric optimisation for insulation and daylight standards."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nusantara new capital hires sustainable designers, but hiring favours regional firms."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on list; few large architectural practices."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-city pilots (Tsukuba, Fukuoka) integrate parametric climate façades."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Some demand in Penang tech parks but small scale."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Some listings for architectural technologists; niche."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "NEOM, Red Sea and Qiddiya megaprojects actively recruit parametric designers for net-zero desert cities."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Singapore Green Plan 2030",
        "reason": "BCA’s Super Low Energy Building programme funds parametric optimisation pilots."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Operation 300bn",
        "reason": "Dubai and Abu Dhabi mandate sustainability ratings; firms use parametric software to meet Pearl & LEED."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Offshore wind and HS2 spinoffs need low-carbon infrastructure designers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Green public-works spending drives demand for energy-efficient parametric façades."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "National Master Plan 2021-2030",
        "reason": "Green city pledges emerging; market immature."
      }
    }
  },
  "bfb1f324-4a34-4c0e-baa7-f7de743dc412": {
    "career": "Evolutionary Biologist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Migration Strategy 2023",
        "reason": "ARC Discovery grants and biodiversity priorities require evolutionary expertise."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Genome Canada grants create post-doc openings, but not on category-based shortage list."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Max Planck and Leibniz institutes actively recruit foreign evolutionary biologists."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Wallacea biodiversity creates research projects yet funding uncertain."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Science Foundation Ireland funds some evolution genomics, yet not on critical list."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Highly Skilled Professional visa",
        "reason": "RIKEN and Okinawa OIST hire global evolutionary biologists."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Biodiversity hotspots need expertise but grants limited."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Migrant Category",
        "reason": "Limited university seats; some conservation genomics projects."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "KAUST funds marine evolution labs but numbers small."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Economy 2030",
        "reason": "A*STAR and NUS study pathogen evolution, offering competitive fellowships."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "UAE Centennial 2071",
        "reason": "NYUAD has evolutionary labs; niche hiring."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Wellcome Sanger and Natural History Museum lead global evolution research; post-Brexit visas easier for scientists."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "National Science Foundation boosts life-sciences funding; universities sponsor J-1 and H-1B researchers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Hiring focused on applied biotech rather than pure evolution."
      }
    }
  },
  "a0e5076a-0c7a-47c2-aa3b-011562fdcf4c": {
    "career": "Junior Barrister",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "Circuit courts face lawyer shortages; streamlined foreign lawyer admission pathways."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Common-law system allows skilled barristers to requalify; litigation shortages in small provinces."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Civil-law system; requalification onerous."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Courts Service highlights backlog; non-EU barristers can qualify via King’s Inns."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Migrant Category",
        "reason": "Small bar welcomes foreign talent once NZCLE completed."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "49",
        "policy": "Singapore Economy 2030",
        "reason": "Foreign law practice licence possible, but courtroom rights heavily restricted."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "ADGM/DIFC accept common-law counsel but courtroom rights limited."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Bar Council forecasts 15% advocate shortfall; Graduate Route eases visa for pupil barristers."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Foreign-trained lawyers rarely get bar admission; some compliance roles in climate finance."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "fcc75bb6-42c4-459a-bdd9-18fc8cb4fd57": {
    "career": "Marine Robotics Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSIRO and Defence Science need autonomous submersibles for reef and naval projects."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Atlantic coastal mapping and offshore wind create demand for AUV engineers."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "ROVs used in North-Sea wind farms but talent sourced within EU."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Deep-sea mining exploration opens some opportunities; localisation barriers remain."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Marine Institute runs AUVs; still niche."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Highly Skilled Professional visa",
        "reason": "Blue-economy push and robotics leadership create strong visa incentives for underwater autonomy."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "49",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Offshore oil uses ROVs, but preference for regional subcontractors."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "NIWA uses AUVs, yet hiring numbers tiny."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Vision 2030",
        "reason": "Red Sea giga-projects require autonomous inspection of coral restoration and underwater infrastructure."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "National AI Strategy 2.0",
        "reason": "Smart-port initiative funds autonomous underwater inspection drones for shipyards."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Operation 300bn",
        "reason": "Port automation in Jebel Ali and oil-field inspections boost ROV demand."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "UK leads in offshore wind, defence subsea drones; shortage of robotics engineers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "DARPA and NOAA fund autonomous underwater vehicle R&D; defense visa pathways favourable."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Not listed; maritime robotics still emerging."
      }
    }
  },
  "b0ef0857-b8df-4f29-b510-9ec02e86f16a": {
    "career": "Media Researcher",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Creative-industry openings exist yet role is absent from Express Entry priority lists."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Government is pouring funds into film, TV and sports sectors; researchers guide content strategy."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Some demand from streaming services, but role not on National AI Strategy or creative priority lists."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi free zones recruit media analysts for streaming and esports growth."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative Industries is one of eight pillars; research roles feed film, TV and gaming clusters."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Large film/TV market and think-tanks hire media analysts, but no dedicated immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b117a7b2-1352-412b-a67c-753ca87c0b57": {
    "career": "Neuroscience Technician",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Medical laboratory scientists are priority and neuroscience labs fit under this stream."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Healthcare and lab technologists earn extra points under the health-occupation draws."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Research technicians in life sciences can secure Blue Card with streamlined degree recognition."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma-biomed clusters around Dublin/Cork urgently require neuroscience and lab technologists."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "Brain/robotics labs seek technicians; HSP gives points for STEM degrees and publications."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "MADANI Economy",
        "reason": "Medical-device and biotech sectors growing, but technician roles not formally prioritised."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Migrant Category",
        "reason": "Lab techs receive points; neuroscience labs clustered around Auckland and Otago universities."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "New research hospitals need technicians, but recruitment still nascent."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Economy 2030",
        "reason": "Biomedical hub; A*STAR and private labs regularly sponsor technicians with neuroscience skills."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai Science Park and Khalifa University hire lab staff for brain-health initiatives."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences R&D is a core pillar; shortage roles fast-tracked on Skilled Worker visa."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "",
        "reason": "NIH-funded labs constantly hire techs, but not singled out in federal immigration policy."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b1509b56-5211-48b8-a691-dcbc10454ce3": {
    "career": "Online Startup Founder",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Global Talent Visa covers digital founders, but bar is high and not core priority."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Start-Up Visa grants PR for funded founders, yet quotas limited."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Berlin welcomes entrepreneurs, though policy focus lies elsewhere."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Start-Up Entrepreneur Programme targets high-potential export businesses but limited slots."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "NEOM, fintech and e-commerce accelerators exist but ecosystem still nascent for foreigners."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "National AI Strategy 2.0",
        "reason": "EntrePass and Startup SG encourage AI-driven online ventures with grants and visas."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "We the UAE 2031",
        "reason": "Golden Visa for entrepreneurs and abundant free-zone subsidies make it attractive."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Innovator Founder visa supports tech startups though criteria strict."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Largest VC ecosystem and International Entrepreneur Parole, but not a listed labor shortage."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "d72c6970-9263-4d15-a9ee-d7e93c14672f": {
    "career": "Performance Practice Specialist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Opportunities through arts councils exist but not on priority lists."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Opera houses contract foreign coaches occasionally, but visas require case-by-case artist visas."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Massive investment in live entertainment needs foreign specialists to train local performers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Some demand for theatre specialists, but not on official priority lists."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "We the UAE 2031",
        "reason": "Expo City and Dubai Opera import experts for shows, festivals and creative-economy goals."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry senior roles, including performance coaches, supported under shortage scheme."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "",
        "reason": "Broadway, touring companies and universities employ movement and vocal coaches, though no formal visa priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "14c47ec4-a15c-446c-ab5d-74580de3616b": {
    "career": "School Psych Examiner",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Migration Strategy 2023",
        "reason": "Counsellor/psychologist roles appear on state occupation lists, especially rural schools."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Mental-health and education professionals receive additional points under health and French-speaking draws."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "School psychologists hired by Länder with German-language requirement; limited foreign recruitment."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Some shortages in rural areas, but not on Critical Skills list."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Migrant Category",
        "reason": "Educational psychologists earn points and are often recruited by Ministry of Education."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "International schools may sponsor, but role not on priority lists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "International schools hire examiners, yet no national priority."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Educational psychologists face shortages but visa caps and local qualification hurdles persist."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Rising demand for special-education assessments, but not on federal shortage lists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "e6b77ec4-9fe7-4ec1-986a-9bc5480fe7ad": {
    "career": "Agroecology Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Agronomy appears on regional lists, but priority lies with nurses and engineers, so points cut-offs remain high."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Federal draws now target agri-food scientists and French-speakers; research institutes compete for soil-health experts."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Green tech labs hire ecological agronomists, yet the Act focuses on nurses and engineers, not research scientists."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Food-security and agri-innovation are core pillars; foreign soil-health scientists qualify for new R-D visas."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Teagasc recruits specialists but the field is not on the Critical Skills list, so general work permit rules apply."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-farm R&D fits the visa, but quotas focus on robotics and semiconductors first."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "MADANI Economy",
        "reason": "Government promotes agro-tech start-ups, yet formal migration pathways remain ad-hoc."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Agri-scientists are explicitly on the Green List; a straight pathway to residence after two years."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Desert farming, food-security mega-projects (NEOM’s The Line) need soil and water-efficiency researchers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Green Plan 2030",
        "reason": "Vertical-farm ecosystem hires a handful of agri-ecologists, but quotas go to biomedical and AI specialists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "We the UAE 2031",
        "reason": "Some demand in controlled-environment agriculture, but not an immigration priority compared with AI and finance."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Funding exists for climate R&D, yet agro-ecology is outside headline shortage lists after 2025."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA pours billions into climate-smart agriculture R&D, opening post-doc and lab roles but not an official shortage occupation."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "National Master Plan 2021-2030",
        "reason": "Plan emphasises agritech and food security; foreign researchers get fast-tracked work permits via R&D hubs."
      }
    }
  },
  "cd54d7fc-f1d3-40d4-92fb-d78c49973c10": {
    "career": "Anthropological GIS Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Humanities academics gain visas, yet preference is for STEM and healthcare, so points cut-offs are stiff."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Academic researchers get fast-track study permits; not an explicit shortage but campuses welcome GIS talent."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "The card values advanced degrees; cultural-heritage GIS roles exist but aren’t a priority occupation."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on the list, but universities can sponsor researchers under Hosting Agreement."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Singapore Economy 2030",
        "reason": "Nation’s heritage board uses GIS, but quotas favour science and finance."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "UAE Centennial 2071",
        "reason": "Smart-city initiatives generate some GIS demand, yet anthropology focus is niche."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Heritage and creative sectors need GIS mapping of cultural assets; Global Talent visa suits PhDs."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "CHIPS and Science Act",
        "reason": "Act boosts NSF social-science grants, and universities sponsor J-1/H-1B roles for spatial anthropologists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "89da2660-fb95-404e-aa50-1f96008376d5": {
    "career": "Automation Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Industrial automation engineers appear on CSOL, especially in mining and food processing."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Category-based Express Entry targets tech; factories in Ontario and Quebec adopt Industry 4.0 rapidly."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Germany’s Industrie 4.0 push needs PLC programmers and robotics integrators urgently."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "RPJPN 2025-2045",
        "reason": "EV battery and nickel plants automate lines; new Golden Visa targets tech experts."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Automation and robotics engineers are on the list due to pharma and med-device plants."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Highly Skilled Professional visa",
        "reason": "Aging workforce and robotics leadership make automation engineers a top hiring segment."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan prioritises Industry 4.0 and automation; special tax incentives for robotics experts."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Some demand in dairy processing plants, but not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Gigafactories in NEOM and renewable projects need automation talent."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "Manufacturing 2030",
        "reason": "Singapore pushes hyper-automated fabs and offers Tech.Pass for senior automation specialists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing initiative targets 4IR automation engineers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Auto/EV and aerospace clusters in Midlands recruit control‐systems engineers under Skilled Worker visa."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Huge subsidies for advanced manufacturing and fabs drive demand for automation engineers."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Electronics plants want control-systems engineers to climb the value chain."
      }
    }
  },
  "5e7ee9aa-7040-489d-8b8c-17ff80465798": {
    "career": "Editorial Photographer",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Freelance artist visa possible in Berlin, but limited slots and German-language barrier."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Vision 2030",
        "reason": "Mega-events demand media content, but preference is for regional hires."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Singapore Economy 2030",
        "reason": "Media industry hub, but passes go to senior creatives with strong client lists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai’s media free zones grant freelance permits for seasoned photographers."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Global Talent visa covers top creatives, yet requires an award-winning portfolio."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct link, but media outlets in the US remain a large market for skilled photojournalists with O-1 visas."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4d4cc6c8-57c8-43bd-8f94-36eb88390f9b": {
    "career": "Electronics Practitioner",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Electronics engineers appear on CSOL with employer-sponsored visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Software & semiconductor engineers are invited in tech draws."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Automotive and renewables sectors need power-electronics talent."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV battery and electronics clusters in Java need PCB and power-electronics skills."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Med-tech and semiconductor fabs around Limerick need electronics engineers."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Highly Skilled Professional visa",
        "reason": "Government funds chip-making revival; electronics engineers get top points."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan positions Malaysia as global semiconductor hub; engineers receive fast visas and tax breaks."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Some openings in medical-device start-ups, but not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Defense and renewable mega-projects require electronics specialists."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Manufacturing 2030",
        "reason": "Electronics is 6% of GDP; Tech.Pass lures senior circuit designers."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing parks look for circuit-design engineers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Semiconductor and aerospace initiatives add electronics roles to shortage list."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Massive subsidies for semiconductor design and fab make electronics engineers a top priority."
      },
      "vietnam": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Aggressive target for 50,000 chip engineers by 2030; foreign talent welcomed."
      }
    }
  },
  "c313c7e5-5483-4835-8f81-49f778756a98": {
    "career": "Engine Developer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Mechanical engineers listed, yet limited domestic auto manufacturing keeps demand moderate."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Mobility sector grows but engines are not an explicit priority; still welcomed under general engineers stream."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Germany’s auto giants pivot to hybrid/EV and hire engine design talent aggressively."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel-based battery and EV assembly corridor actively recruiting power-train talent."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Highly Skilled Professional visa",
        "reason": "Legacy ICE champions and new hybrid platforms keep demand high for engine developers."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan names EV power-trains and component design as growth niches."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "NEOM and Red Sea projects include EV mobility and require power-train expertise."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Manufacturing 2030",
        "reason": "Precision-engineering cluster includes automotive R&D, but on smaller scale than chips/medtech."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing push includes auto components, but volumes still limited."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 prioritises EV/automotive R&D, especially in Midlands battery valley."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "EV power-train and advanced manufacturing incentives create large demand for combustion-to-battery engine specialists."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "National Master Plan 2021-2030",
        "reason": "Emerging EV makers like VinFast need engine and motor engineers."
      }
    }
  },
  "bf2612e8-8a0f-4aac-8ae2-fdbd8ea796b9": {
    "career": "Family Support Worker",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Community workers appear on regional skills lists in some states."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Care economy shortage and pathways for French-speaking social workers."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Youth-care roles allowed but language/professional recognition hurdles."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "NGOs petition for more social-care visas; small annual cap."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Migrant Category",
        "reason": "Shortage of social workers in child and family services."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Social workers removed from shortage list but some councils still recruit abroad."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Large social-services budget but no dedicated immigration channel."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "dc8efd32-a417-43c0-ab7c-b8332704f291": {
    "career": "Forestry Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Listed under environmental/land managers, mostly in Tasmania."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Massive boreal forests and retirements make forestry managers high-priority."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Climate-forest programmes need talent but German language is mandatory."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Huge push to curb deforestation and develop certified timber industry."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "",
        "reason": "Government aims to double forest cover; limited domestic experts."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "SSW agriculture/forestry track allows mid-skilled entry, language heavy."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "MADANI Economy",
        "reason": "Push for sustainable logging certification needs forest managers."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Green List covers forestry and agri-scientists with streamlined residency."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Reforestation grants exist but not on official shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Funds wildfire resilience and sustainable timber, creating limited visas for specialists."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "National Master Plan 2021-2030",
        "reason": "Plan targets bio-economy and carbon credits via managed forests."
      }
    }
  },
  "d9070ec4-0fae-4d32-8300-9c78be18e69f": {
    "career": "Global Media Specialist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Media visas require Japanese fluency; limited demand for foreigners."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Massive investment in entertainment and sports media for global branding."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Singapore Economy 2030",
        "reason": "Regional HQs of global news outlets cluster here; EPs granted for senior talent."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "We the UAE 2031",
        "reason": "Dubai Media City and Abu Dhabi twofour54 recruit international specialists."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries named as pillars; global media hubs in London and Manchester."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Largest media market but not a visa priority; H-1B possible under specialty occupation."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "3602204c-61f9-48ed-9456-eccb80393542": {
    "career": "Industrial Eng Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Engineers for defence and mining equipment manufacturing in demand."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Manufacturing plants offer priority visas for process-improvement engineers."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Industry 4.0 push needs plant managers with lean and automation skills."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV battery gigafactories hiring industrial engineering leadership."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma and med-device plants hire continuous-improvement leaders."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-factory and robotics sectors need lean managers."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Target to upskill 3,000 factories to Industry 4.0 levels."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Smaller manufacturing base; some opportunities in food processing."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "Mega-projects and localisation of manufacturing require experienced process managers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Manufacturing 2030",
        "reason": "Precision-engineering and pharma clusters recruit lean/automation managers."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Operation 300bn",
        "reason": "Ambition to quadruple industrial GDP creates strong demand for managers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "EV, aerospace and clean-energy factories expand, short on experienced IE managers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Reshoring advanced manufacturing and fabs need industrial engineering leadership."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "National Master Plan 2021-2030",
        "reason": "Electronics and semiconductor plants scaling need process optimisation expertise."
      }
    }
  },
  "a6921d29-2ebd-4cfb-a851-e4d0bb737c21": {
    "career": "Information Systems Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL lists software and ICT business analysts; IS researchers fit adjacent skills."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Canada prioritises AI, software and tech researchers for fast-track Express Entry."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialists and research institutes recruit IS PhDs via Blue Card and Chancenkarte."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Smart-city Nusantara needs IS expertise, yet foreign-talent pathways still forming."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List covers ICT professionals; IDA-funded labs seek information-systems academics."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP gives fast points for IT/AI researchers in smart-city and robotics projects."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan funds Industry 4.0 and requires enterprise-systems R&D talent."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Migrant Category",
        "reason": "ICT professionals recognised, but no dedicated researcher shortage list."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Digital transformation projects at NEOM/SDAIA need IS expertise but preference given to applied engineers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "National AI Strategy 2.0",
        "reason": "AIS2 funds digital-trust and enterprise-IT research; universities grant five-year PASS visas."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "UAE Centennial 2071",
        "reason": "Free-zone universities and government AI labs issue Golden Visas for tech researchers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Strategy funds digital/AI R&D; Global Talent visa eases entry for IS PhDs."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act pours billions into computing and information-science research, creating grants and H-1B demand for IS PhDs."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "National Master Plan 2021-2030",
        "reason": "Growing e-commerce and fintech sectors hire IS researchers, but policy focus is hardware engineers."
      }
    }
  },
  "e7a22e7a-c6c7-4bba-9cec-629559f79644": {
    "career": "Literary Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Migration Strategy 2023",
        "reason": "Regional universities sponsor humanities lecturers through 482 visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Express Entry Category-Based Selection",
        "reason": "French-speaking humanities scholars gain extra CRS points; universities outside Toronto need faculty."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Humanities researchers qualify via doctoral degree and job offer at German universities."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "International schools hire literature PhDs, but researcher roles scarce."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Irish universities hire literature scholars for post-colonial studies; standard work permits apply."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "Limited English-literature posts; points system rewards PhD but language barrier persists."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Private universities hire, yet humanities not on priority skills list."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Limited positions but PhD graduates receive open work visas."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Cultural institutes hire literature experts for translation projects, though nationals preferred."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "MOE universities do hire, but humanities not in National AI Strategy priority."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Branch campuses of UK/US universities recruit literature faculty on renewable contracts."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Graduate Route and Skilled Worker visa cover humanities academics; no shortage but large sector."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Universities recruit humanities PhDs; no specific immigration priority but J-1/H-1B caps rarely fill."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Some demand for English-language curriculum writers; immigration pathways generic."
      }
    }
  },
  "79ddbf55-def8-4239-a8f4-57aeb53370f9": {
    "career": "Modeling Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL lists data analysts and statisticians across mining, health and finance."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Data scientists and quantitative modellers are priority occupations for Express Entry."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Industries seek simulation engineers; Blue Card open for STEM grads."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "RPJPN 2025-2045",
        "reason": "EV battery and geothermal projects require simulation expertise, yet local talent pipeline growing."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Quantitative analysts and statisticians are named critical skills for visa waivers."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP encourages data scientists for robotics and smart manufacturing models."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "NIMP 2030",
        "reason": "Industry 4.0 and semiconductor fabs need process and yield modelling."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Migrant Category",
        "reason": "Civil engineering and insurance modelling roles exist but not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Mega-projects need demand forecasting, traffic and energy models."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Manufacturing 2030",
        "reason": "Financial modelling, risk analytics and precision-engineering simulations align with national plans."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Operation 300bn",
        "reason": "Financial services and smart-city projects hire quantitative modelers; Golden Visa possible."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean energy, fintech and aerospace sectors list modelling and data-science roles on shortage lists."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Advanced manufacturing, climate and defense projects need mathematical modeling talent."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Demand for yield and supply-chain models emerging but still nascent."
      }
    }
  },
  "31868513-9835-4d9c-abb7-662446703c4d": {
    "career": "Network Security Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL names cybersecurity engineers as high shortage; direct PR pathways available."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Cybersecurity is an Express Entry priority occupation with fast PR."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "BKA, auto and energy firms scramble for IT-sec talent; Blue Card eased."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Fintech boom needs security, but local talent pool rising; visas less clear."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "EU cyber-hub in Dublin needs network security engineers in finance and cloud."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Highly Skilled Professional visa",
        "reason": "Tokyo exchanges and auto giants hunt for bilingual cyber experts."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "NIMP 2030",
        "reason": "Industry 4.0 rollout drives demand for OT network security."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Migrant Category",
        "reason": "CERT-NZ highlights cyber skill gap, but not Green List Tier 1 yet."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "Digital-gov projects and NEOM require robust network security, offering tax-free packages."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "National AI Strategy 2.0",
        "reason": "Cybersecurity Agency of Singapore lists network security as critical skill; EP quotas relaxed."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Operation 300bn",
        "reason": "Banks and energy firms issue Golden Visas for cyber talent."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Shortage Occupation List includes cyber-security specialists; fast visa processing."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA funds critical-infrastructure cyber defences; DHS and contractors hire aggressively."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Growing tech hubs seek cyber talent, but immigration policies still evolving."
      }
    }
  },
  "da7e2af4-93c9-4cac-a5dc-c9a9af44748e": {
    "career": "Performance Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Sports scientists hired by clubs; general skilled visas apply."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Athletic therapist roles recognised but not on priority list."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Bundesliga teams hire, yet role not in immigration shortage lists."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Football clubs import some specialists, yet immigration quotas tight."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Rugby and GAA teams hire locally; limited visa sponsorship."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Olympic legacy created demand, yet work visas remain generic."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Sport universities hire few foreign strength coaches; priority lies elsewhere."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "High-performance sport NZ recruits occasionally; Green List excludes role."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Sports academies and mega-events hire foreign performance coaches to build national talent."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Sports Hub hires, but MOM raises salary bar; not strategic sector."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "We the UAE 2031",
        "reason": "Dubai Sports Council funds elite training centres importing specialists."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Premier League clubs recruit, but immigration points basic."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Sports science jobs exist, but no immigration priority."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Developing sports sector, but roles filled locally."
      }
    }
  },
  "f346908c-fbae-4c45-83fb-3b799e237beb": {
    "career": "Pharmacy Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Demand exists in university labs but role not on core list."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "STEM-focused stream lists pharmaceutical scientists as priority."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Big pharma clusters around Rhine recruit overseas researchers."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Ireland’s large API and biologics plants actively import PhD talent."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP targets biotech researchers but language barriers remain."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan backs pharma manufacturing; R&D hiring limited but present."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Migrant Category",
        "reason": "Small pharmaceutical sector; visas possible case-by-case."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Vision 2030",
        "reason": "Early-stage biotech zones in NEOM need limited researchers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Economy 2030",
        "reason": "Biomedical sciences are a national pillar; steady intake of PhD scientists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Operation 300bn",
        "reason": "Abu Dhabi bioclusters growing, but hiring volume still modest."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences pillar funds drug discovery and eases Skilled Worker visas."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds biotech R&D and fast-tracks visas for lab scientists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "620372cc-5df1-44f6-a774-b604e8ff9cb1": {
    "career": "Public Historian",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Museums hire internationals case-by-case but role not on core list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "French-language cultural professionals get modest immigration points."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Large museum sector can sponsor skilled foreign curators."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on list, but diaspora projects occasionally recruit."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Vision 2030",
        "reason": "AlUla heritage tourism drives demand for curators and storytellers."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "UAE Centennial 2071",
        "reason": "Louvre Abu Dhabi and new museums seek experienced historians."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industries pillar supports museums, archives and cultural exports."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Federal restoration projects fund heritage consultants sporadically."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "668c2a22-c2b7-4881-99d9-1c2e4a47da82": {
    "career": "Radiologic Technologist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "States list medical imaging technologists on their shortage lists."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Allied health occupations given priority points due to shortages."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Hospitals recruit foreign radiographers to cover ageing workforce."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Medical imaging professionals are listed for fast-track permits."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Hospitals in rural areas sponsor foreign technologists with language skills."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Private healthcare growth creates steady but limited demand."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Radiographers explicitly on Tier-1 fast-track list."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "New hospitals in giga-projects need imaging staff."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Singapore Economy 2030",
        "reason": "Public hospitals hire overseas radiographers but volumes modest."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "Private hospitals expand; licensing pathway clear for expats."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Radiographers remain on official shortage list despite policy tightening."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Hospital modernisation funds increase imaging staff demand."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "22884c78-0421-4801-993c-5e4552b92a49": {
    "career": "RN to APN Transition",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "Advanced practice nurses appear on core skills list with fast visas."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "RNs and NPs top the healthcare priority list for permanent residency."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe nursing shortage; hospitals sponsor higher-skilled APNs."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Government pushes local hiring; foreign APNs limited to private hospitals."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Advanced nurse practitioners can obtain Critical Skills permits."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "SSW covers nursing care; APN level roles rare but possible in private hospitals."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Hospitals recruit expat nurses but advanced roles limited."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "RN roles fast-tracked; APNs recognised but still developing."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Vision 2030",
        "reason": "New medical cities recruit experienced APNs for leadership."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "59",
        "policy": "Singapore Green Plan 2030",
        "reason": "MOH recruits experienced nurses but caps on foreigner ratio keep scores moderate."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "63",
        "policy": "We the UAE 2031",
        "reason": "Private hospitals value NP prescribing authority; DHA licence required."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Clinical nurse specialists still sponsored despite policy tightening."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Act funds community clinics expanding demand for nurse practitioners."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National Master Plan 2021-2030",
        "reason": "Foreign licensure difficult; demand focused on basic nursing."
      }
    }
  },
  "adbc82eb-232c-4120-8d7e-65a4c3821b9b": {
    "career": "Session Player",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Entertainment visas exist but numbers are limited and short-term."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Cultural-industry stream awards some points to experienced musicians."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Vision 2030",
        "reason": "New entertainment zones occasionally hire international band members."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s media city records jingles and film scores; short-term contracts common."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industries pillar includes recording sector; visas available through Tier 5 creative route."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Act’s arts earmarks indirectly expand studio employment in major cities."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "97415489-f721-449b-879f-47fcf808d315": {
    "career": "Social Policy Advisor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Public-sector policy work exists but teachers, nurses and engineers dominate the core skills list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Government departments need policy staff and French-speaking candidates gain extra CRS points, yet the occupation is outside the named shortage list."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Social scientists qualify under the degree-holder pathway, although the Act emphasises technical and health fields."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Skilled Migrant Category",
        "reason": "Smaller labour market admits qualified advisors but teachers, nurses and engineers are higher priority."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Green Plan 2030",
        "reason": "Some openings in social-housing and ageing-population policy, but role is peripheral to national talent hunt."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Think-tanks and Whitehall recruit policy advisors, though immigration policy currently prioritises STEM and advanced manufacturing."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Federal and state agencies continually hire analysts to design poverty-reduction and health programmes, but the role is not singled out in any priority legislation."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "7d854e78-a30c-4117-94ba-9becd7366c2a": {
    "career": "Social Studies Teacher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Secondary teachers appear on CSOL, giving direct visa pathways."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Express Entry Category-Based Selection",
        "reason": "K-12 teachers are explicitly targeted, especially for French-immersion and rural schools."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Severe teacher shortages allow visa points even though STEM is preferred."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 2)",
        "reason": "Primary and secondary teachers listed, granting streamlined residence."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "MOE hires some foreign teachers, yet nationals are preferred and role is outside talent lists."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Private international schools recruit expatriate teachers, although not a strategic priority."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Teacher shortages exist, but no dedicated federal immigration channel."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "31570433-9b2d-4243-a35f-457c6d25dec5": {
    "career": "Social Work Educator",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Migration Strategy 2023",
        "reason": "Chronic shortage of social-work academics drives streamlined visas for lecturers."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities given quotas to recruit PhD educators in health and community welfare."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Universities can sponsor professors; social services are expanding for ageing population."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Lecturer roles in health and welfare subjects qualify for Critical Skills permits."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Migrant Category",
        "reason": "Small but steady demand for social-work lecturers, though not on Green List."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Green Plan 2030",
        "reason": "Need for ageing-population social services creates niche academic posts."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "UAE Centennial 2071",
        "reason": "Private universities hire international faculty, but social sciences are not strategic."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Russell Group universities seek social-work lecturers amid child-protection reforms."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Federal funding for community health spurs universities to expand social-work faculties."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "753a849e-4bc7-4362-a04b-300c99a35c8d": {
    "career": "Space Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Migration Strategy 2023",
        "reason": "Growing civil-space sector; engineers fit under ‘advanced manufacturing’ stream."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "MDA and CSA hire, but occupation not on category-based lists."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Airbus and OHB recruit non-EU aero engineers under the Act."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "JAXA and growing private launch firms welcome qualified aerospace engineers."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Vision 2030",
        "reason": "King Abdulaziz City for Science & Technology invests in satellite manufacturing."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National AI Strategy 2.0",
        "reason": "Nanosatellite startups exist, but AI talent is bigger focus."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Operation 300bn",
        "reason": "Mohammed Bin Rashid Space Centre recruits global talent for Mars and lunar missions."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "UK Space Agency and reaction-engines projects place aerospace engineers on shortage list."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Massive NASA, DoD and commercial funding for launch systems, satellites and lunar programmes."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      }
    }
  },
  "9e127ac3-4db0-4dbb-98da-59560d4aec32": {
    "career": "Surgical Resident",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Doctors, especially in regional hospitals, top the priority list."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Physicians have a dedicated provincial nomination stream and fast-tracked licensing agreements."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe physician shortage; states expedite Berufserlaubnis for foreign doctors."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Doctors included; hospitals sponsor trainee surgeons."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1)",
        "reason": "Surgical trainees receive immediate residence pathway upon job offer."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Mega-hospital projects hire expatriate surgeons for training posts."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Some foreign residents accepted, but places are extremely limited and competitive."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Cleveland Clinic Abu Dhabi and others recruit residents amid healthcare expansion."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Hospital shortages exist but no special visa; long licensing path for IMGs."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      }
    }
  },
  "2bbbb001-3da5-4697-aab4-14e51c0f9ef3": {
    "career": "Tech Law Attorney",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Legal is not on CSOL, yet fintech and cyber firms in Sydney/Melbourne still source tech-savvy lawyers."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "No direct legal stream, but Toronto’s fast-growing tech firms hire counsel for privacy and AI compliance."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "EU tech regulation (GDPR, AI Act) drives niche demand despite no formal shortage listing."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on list, but Dublin’s big-tech EMEA HQs rely on tech-privacy counsel."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Language barrier restricts foreign lawyers, but HSP covers international IP experts in semiconductors and AI."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "NEOM/fintech projects need contract and data-protection counsel, but localisation rules limit visas."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "National AI Strategy 2.0",
        "reason": "Cross-border data and fintech rules create demand, but bar-admission restrictions keep hiring cautious."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "We the UAE 2031",
        "reason": "DIFC/ADGM expansion demands international tech and fintech lawyers familiar with cross-border regulations."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 explicitly cites senior legal services supporting digital, fintech and life-sciences clusters in London."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "CHIPS and Science Act",
        "reason": "Massive semiconductor and AI investments create IP, antitrust and data-privacy litigation that needs specialist attorneys."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "86ebd792-0e2a-47bb-8c4e-daacf789e912": {
    "career": "Technical Writer",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Tech hubs in Ontario and BC hire writers for software docs; no dedicated visa stream."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Export-oriented industry values English manuals; Chancenkarte may grant points but no priority."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on list, yet Dublin’s SaaS giants employ documentation teams."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "English manuals for robotics/export products sought; Japanese ability often required."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Semiconductor plants need SOP writers; salaries modest, no priority visa."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Vision 2030",
        "reason": "Mega-projects hire English writers for tenders and technical standards, yet roles often contract-based."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Singapore Economy 2030",
        "reason": "Fintech and biotech firms want writers; Employment Pass possible but competitive."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Operation 300bn",
        "reason": "Manufacturing push creates documentation needs, but visas tied to employer sponsorship."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Not on shortage list; niche openings in defence and aerospace firms."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Large federal projects need clear manuals and compliance docs but writers are not a shortage occupation."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Growing electronics sector hires English writers but prefers local talent for cost."
      }
    }
  },
  "8b9678ce-cf25-4588-ad07-fe9d33fffeb1": {
    "career": "Thesis Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Universities receive international PhD candidates with streamlined visas and scholarships."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities use Global Talent Stream to hire PhD candidates, but funding less abundant."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "DFG funding and tuition-free doctorates attract global researchers, especially in humanities."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "No direct list item, but Science Foundation Ireland offers scholarships."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "MEXT scholarships exist; language requirements vary by university."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Migrant Category",
        "reason": "PhD tuition subsidies exist but limited positions."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Singapore Economy 2030",
        "reason": "MOE fellowships attract PhDs but slots are competitive and STEM-heavy."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "UKRI funds doctoral training centres; universities actively recruit international PhDs."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Federal grants expand university research budgets across STEM and humanities alike."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "409a953d-514f-4ba3-a04c-815e8bbaada5": {
    "career": "Architectural Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Civil/structural engineers on CSOL; green-building expertise valued in large infrastructure projects."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Net-zero building codes push firms to hire building-physics specialists."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Strict energy-efficiency laws and prefab housing boom make building-science specialists high priority."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "RPJPN 2025-2045",
        "reason": "Nusantara capital project opens some roles for green-building scientists."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Construction PMs listed; research roles hired indirectly by big contractors."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Highly Skilled Professional visa",
        "reason": "Seismic and energy-saving standards drive niche demand, but Japanese required."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "NIMP 2030",
        "reason": "Green factories and smart-city pilots seek façade and thermal experts."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Green List (Tier 2)",
        "reason": "Sustainable construction roles listed, but small market size."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Vision 2030",
        "reason": "NEOM and giga-cities hire envelope and material scientists for extreme-climate designs."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Singapore Green Plan 2030",
        "reason": "BCA funds research on tropical high-rise cooling; roles limited but strategic."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "UAE Centennial 2071",
        "reason": "Net-zero urban planning in Masdar City and Expo legacy projects needs advanced building-science input."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Offshore wind and green-building goals raise demand for façade and daylighting researchers."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Tax credits for energy-efficient buildings fuel demand for building-science experts."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "National Master Plan 2021-2030",
        "reason": "Rapid urbanisation needs sustainable design guidance, yet few specialised visas."
      }
    }
  },
  "3c9fe88f-1d7e-4e0c-9aa4-3ec64ffb1cbb": {
    "career": "Biotech Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Migration Strategy 2023",
        "reason": "Medtech and ag-biotech sectors growing but still small market."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Canada accelerates vaccine and cell-therapy plants, hiring consultants for scaling."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Bio-pharma clusters in Bavaria and NRW seek regulatory and market-entry advisors."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Biopharma investment nascent; roles sporadic."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "World’s largest biopharma export base relies on consultants for CQV and FDA compliance."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Highly Skilled Professional visa",
        "reason": "Regenerative-medicine push opens doors for foreign biotech market experts."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "MADANI Economy",
        "reason": "NIMP highlights pharma and medical devices, generating some advisory work."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Niche ag-biotech projects; few high-value consulting roles."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Investment into pharma manufacturing needs external expertise on tech transfer."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Economy 2030",
        "reason": "Government funds cell therapy and mRNA plants; consultants help navigate GMP and global markets."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Operation 300bn",
        "reason": "Emerging biotech ambitions in Abu Dhabi’s health tech zone require strategic advisors."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Golden Triangle’s gene-therapy boom creates strong consulting demand for scale-up and regulation."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA pours billions into biomanufacturing and clean pharma, fuelling advisory demand."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National Master Plan 2021-2030",
        "reason": "Early-stage biotech ecosystem; consulting roles limited."
      }
    }
  },
  "6f7578ba-c2d9-4af4-bc2c-9738141a9db8": {
    "career": "Climate FinTech Specialist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "FinTech and AI professionals fit tech streams, though climate finance is not singled out."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Financial software talent welcomed but climate-finance not on shortage lists."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Rapid growth in e-payments and carbon-credit exchanges demands climate-fintech skills."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Fintech software engineers qualify; Dublin green-finance cluster growing."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "MADANI Economy",
        "reason": "Islamic green-finance initiatives need fintech talent."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "Massive push for fintech and carbon-credit exchanges around NEOM."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Singapore Green Plan 2030",
        "reason": "Singapore positions itself as Asia’s sustainable-finance hub; MAS grants and visas target this niche."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "UAE Centennial 2071",
        "reason": "DIFC/ADGM actively recruit sustainable-finance and fintech experts."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London leads in green bonds; visas fast-track senior financial-services talent."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Clean-energy tax credits spur carbon-market platforms and green-bond analytics, boosting need for sustainable-finance technologists."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National Master Plan 2021-2030",
        "reason": "Fintech mentioned but focus remains semiconductor/energy."
      }
    }
  },
  "82a2a6ce-8c6d-44bf-9f4c-7846729e1c20": {
    "career": "Communications Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Electrical and telecom engineers listed as high-priority shortages."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Electrical/telecom engineers receive extra CRS points under tech occupation draws."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "5G network expansion and Industry 4.0 need communications specialists."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "RPJPN 2025-2045",
        "reason": "National backbone upgrades need some telecom talent, but not on critical list."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Electrical engineers qualify, but telecom specialism not explicitly highlighted."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "Highly Skilled Professional visa",
        "reason": "6G and satellite IoT part of national digital strategy; telecom engineers fast-tracked."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "NIMP 2030",
        "reason": "5G rollout is important but priority lists favour semiconductor engineers."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Telecommunications network engineers appear on Tier 2 Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Vision 2030",
        "reason": "Mega-projects (NEOM) demand private 5G and satellite links."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Economy 2030",
        "reason": "Comms engineers support data-centre expansion, yet immigration priority sits with AI/cyber."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Operation 300bn",
        "reason": "Push for space and 6G R&D needs comms engineers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Telecoms engineers on shortage list due to fibre-to-home rollout."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "US$65 billion broadband roll-out needs telecom and 5G engineers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "59",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Telecom skills useful for electronics plants but not primary target."
      }
    }
  },
  "5d21a9a2-ed96-48be-a7c1-9450e1ccd8a6": {
    "career": "Digital Communication Specialist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "MADANI Economy",
        "reason": "Digital-economy push creates some openings in e-commerce marketing."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Mega-projects need digital content to market tourism and sports events."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Economy 2030",
        "reason": "Media companies hire, but role not on shortage lists; EP quotas still obtainable."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s media free zones actively hire digital comms talent for regional campaigns."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry visas skew toward senior creatives; mid-level specialists only modest demand."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "No federal talent policy for marketing roles, but large market size offers jobs."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "dabf18dd-cb6a-47c5-931a-1a4eae9283f9": {
    "career": "Drama Facilitator",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "24",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "22",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Growing entertainment sector hires facilitators for community theatre programmes."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Singapore Economy 2030",
        "reason": "National Arts Council funds community theatre; EP possible for experienced facilitators."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Dubai cultural initiatives need arts workshop leaders, but visas case-by-case."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry visas focus on senior creatives; facilitators have moderate demand."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Arts visas exist but limited; role not in national talent schemes."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "95306904-a157-4151-87c1-0dbf88eb92be": {
    "career": "GIS Developer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Software developers listed; GIS skills valued for bushfire and mining operations."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Software and data engineers, especially in climate and natural-resources GIS, receive priority CRS draws."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Smart-city and renewable projects demand spatial software; IT specialists fast-tracked."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital Nusantara and mining projects need spatial data platforms."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Software engineers with GIS backgrounds feed renewable-energy siting startups."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "Disaster-management systems and smart-city mapping seek GIS coders."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "NIMP 2030",
        "reason": "Spatial analytics supports semiconductor site selection but demand moderate."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "GIS developers fit under software engineer in Tier 1; critical for disaster planning."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Vision 2030",
        "reason": "NEOM and Red Sea gigaprojects rely on advanced geospatial modelling."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Green Plan 2030",
        "reason": "Urban-planning agencies use GIS, but broader AI/cyber roles rank higher."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Operation 300bn",
        "reason": "Smart-city digital twins and desert solar sites need GIS mapping."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Infrastructure and offshore wind planning require geospatial software talent."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Massive infrastructure and climate-resilience projects need spatial-data apps and dashboards."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "National Master Plan 2021-2030",
        "reason": "Transport and energy corridors rely on GIS, yet local developers fill many roles."
      }
    }
  },
  "6e8d0f55-854a-458f-b929-d15f61d06617": {
    "career": "Graphic Artist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Gigaprojects (NEOM, AlUla) need branding and visual storytelling talent."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Creative & media production is an explicit priority for Dubai’s content hubs."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries listed under IS-8 but immigration routes competitive."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Creative roles benefit from large media sector but are not part of federal talent priorities."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "9e448f7c-24f2-4063-a15e-2721dd706604": {
    "career": "Health Data Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Migration Strategy 2023",
        "reason": "Seeks data analysts for digital health records but not explicit Tier-1."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "AI and healthcare occupations top the category-based Express Entry lists."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialists and health-tech engineers fast-tracked; data science recognised."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Healthtech start-ups and government BPJS data modernisation need analysts."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Health analytics fits within data scientist and med-tech critical skills."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "Strategic push for AI/ML researchers in ageing-society healthcare."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "MADANI Economy",
        "reason": "Government hospitals digitising records; NIMP promotes AI talent."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Migrant Category",
        "reason": "Digital health programmes expanding but not on Green List yet."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Smart-hospital build-out requires analytics talent."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "National AI Strategy 2.0",
        "reason": "Health AI is one of five national flagship pillars with dedicated work-pass perks."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai Health Data Hub and Abu Dhabi Genomics Program courting AI scientists."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences and digital sectors prioritise health-AI roles, fast Global Talent visa."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Massive funding for AI/biotech convergence and NIH health-data initiatives."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National Master Plan 2021-2030",
        "reason": "E-health and AI in diagnostics highlighted but early-stage."
      }
    }
  },
  "5d5c545f-dee9-4cd5-8d5a-110a7ff3f265": {
    "career": "Interpreter",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Some demand in community services but not on CSOL."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Express Entry Category-Based Selection",
        "reason": "French-English interpreters aid bilingual public services; provincial nomination possible."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Courts and refugee integration need interpreters, yet not formally prioritised."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Tourism push creates demand for Arabic-English-Chinese interpreters."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Expo legacy drives multilingual events, but visas prefer STEM."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Public-sector interpreting contracts exist but not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "No federal talent priority, but court and medical systems still sponsor specialised interpreters."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "ae6604c9-5064-42e0-b178-5fa3eba8ebdc": {
    "career": "Litigation Associate",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Admissions hurdles and no listing on CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Foreign-trained lawyers must complete NCA; immigration preference lies elsewhere."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Civil-law system requires local qualification; not on shortage lists."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Requires Kings Inns and no critical-skills status."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Small market, must retrain locally."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "International arbitration demand in mega-projects but Saudization applies."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "UAE Centennial 2071",
        "reason": "DIFC courts recruit common-law litigators for cross-border disputes."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Not on shortage list; must pass SQE, but City firms still sponsor."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Bar-licensed roles are domestic; no shortage but large market offers H-1B for top graduates."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "2397caa8-6745-4103-bf16-9d5d54099fcc": {
    "career": "Medical Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Biomedical engineer listed within broader engineering shortage."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Med-tech engineers welcome under STEM Express Entry but not top shortage."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Germany’s med-tech cluster (Tuttlingen) actively recruits biomedical engineers."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "RPJPN 2025-2045",
        "reason": "Local health-tech ambitions exist but incentives focus on pharma and bio-manufacturing."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "World’s second-largest exporter of medical devices, constant engineer shortages."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "Aging society fuels demand for biomedical devices and robotics."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan names medical devices as a priority export sector."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Migrant Category",
        "reason": "Medical device start-ups growing but not Green List priority."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Mega-hospital projects and local device manufacturing need talent."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Economy 2030",
        "reason": "Biomedical production and R&D are key pillars with targeted work-pass benefits."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Operation 300bn",
        "reason": "Local biotech and med-tech manufacturing expansion in Abu Dhabi free zones."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences pillar seeks med-tech and device engineers; Global Talent visa fast-track."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA and BARDA funding boost medical device R&D and advanced manufacturing."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National Master Plan 2021-2030",
        "reason": "Growing med-tech manufacturing base courting foreign engineers."
      }
    }
  },
  "a75b7490-7f25-4d2a-960c-7a377fb8af54": {
    "career": "Organizational Psych Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "Academic roles qualify under higher-education stream but psychology research is not on core skills list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Strategy funds research chairs in people analytics but not formally on shortage lists."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Universities welcome PhDs; however, organisational psychology is peripheral to listed shortage occupations."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Critical Skills List excludes psychology; general researcher visas possible but competitive."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "Skilled Migrant Category",
        "reason": "Academic researchers receive points but profession not on Green List."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National AI Strategy 2.0",
        "reason": "Government funds human-machine interaction labs but field remains niche for work passes."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Behavioural science cited in productivity pillar but no dedicated shortage route."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "CHIPS and Science Act",
        "reason": "Act enlarges NSF social-science budgets; universities and tech firms fund workplace-behaviour studies to boost productivity."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "ca7e3d30-7dac-4e37-9437-9271c31dcde1": {
    "career": "Process Improvement Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Occupation recognised yet sits outside core skills list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Management consultants can qualify under general skilled worker stream but not targeted."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Consultants qualify on points, though profession isn’t shortage-listed."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "New capital construction and EV supply chain require consultants to streamline operations."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Not on Critical Skills List; companies rarely sponsor."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "Lean specialists valued in auto sector, but generic consultants score modest points."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan emphasises productivity and Industry 4.0 audits, boosting demand."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Generic management roles seldom sponsored unless tied to major construction firms."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Mega-projects and state firms hire process experts to localise supply chains."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Manufacturing 2030",
        "reason": "Firms hire efficiency consultants, yet EP quota tight for generic roles."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Operation 300bn",
        "reason": "Manufacturing push needs lean and Six-Sigma consultants."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Industry 4.0 agenda values efficiency experts, but no visa fast-track."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Large federal projects create demand for efficiency experts, but no visa priority."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National Master Plan 2021-2030",
        "reason": "Manufacturing upgradation strategy imports foreign process-improvement expertise."
      }
    }
  },
  "42ee8177-4d68-4b67-b777-bfcc296f1c3c": {
    "career": "R&D Tech",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Advanced manufacturing and defence R&D require physics technicians."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Government funds quantum and photonics hubs recruiting skilled lab staff."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Automotive, space and semiconductor giants face acute lab-tech shortages."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "RPJPN 2025-2045",
        "reason": "State labs in batteries and geothermal hire experimental technicians."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Chip fabs and med-tech plants value experienced lab technologists."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Highly Skilled Professional visa",
        "reason": "Nation prioritises semiconductor and robotics R&D, recruiting foreign lab talent."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Expansion of wafer-fab ecosystem drives demand for R&D technicians."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 2)",
        "reason": "Small but growing photonics and space sectors import R&D support staff."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "NEOM and KAUST fund clean-tech labs needing experimental technicians."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Manufacturing 2030",
        "reason": "Precision engineering hub offers Tech.Pass for advanced lab specialists."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Operation 300bn",
        "reason": "Space and biotech programmes expand R&D headcount including lab techs."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Catapult centres in advanced manufacturing recruit physics technicians."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Thousands of new semiconductor and quantum labs need technicians for prototyping and testing."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Chip design/testing parks need engineering-physics support staff quickly."
      }
    }
  },
  "1e36a16a-18f1-44e9-a94e-47370860eebe": {
    "career": "Radiographer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Radiographers on Priority Migration Skilled Occupation List."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Radiography listed under healthcare priority; expedited PR."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "83",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe hospital staffing gaps for imaging technologists."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Health Service Executive sponsors imaging professionals under Critical Skills permit."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Foreign licensing recognition limited; language barrier high."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "MADANI Economy",
        "reason": "New private hospitals in Klang Valley hiring foreign radiographers."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Radiographers granted Straight-to-Residence visas."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Private mega-hospitals actively recruit foreign imaging staff."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "MOH tightens foreign quotas; some demand persists in private hospitals."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Growing medical-tourism sector needs licensed radiographers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "",
        "reason": "NHS shortage occupation list includes diagnostic radiographers despite recent visa tightening."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Allied-health shortages exist but not covered by industrial bills; hospitals still sponsor."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "1d00b4ba-522e-465e-becb-1a03b30f3c6b": {
    "career": "Real Estate Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Not on Core Skills List; sponsorship rare outside mega-developers."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Role qualifies under general skilled worker but faces points competition."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Focus on construction trades, not property managers."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital Nusantara drives massive property management needs."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "MADANI Economy",
        "reason": "Klang Valley projects hire foreign managers, but localisation is rising."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Limited demand; local licence required."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Vision 2030",
        "reason": "Giga-projects (NEOM, Red Sea) import experienced managers for mixed-use property portfolios."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi mega-developments seek asset and facility managers."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Investor visa closed; property roles not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Visa pathways exist for senior executives only; no industrial priority."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National Master Plan 2021-2030",
        "reason": "Rapid urbanisation and foreign-owned malls demand experienced asset managers."
      }
    }
  },
  "477b6c78-18f0-4901-8506-00623abdc712": {
    "career": "Wildlife Policy Advisor",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Environmental scientists and conservation planners sit on CSOL; federal ‘Threatened Species Action Plan’ funds new advisory roles."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Stream welcomes environmental scientists; Canadian provinces urgently need policy staff for parks, First-Nations co-management and biodiversity targets."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Green Party leadership drives habitat and rewilding policies; government eases visas for ecology graduates."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List includes environmental scientists indirectly; biodiversity officers hired under CAP reforms but numbers modest."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "‘Green List’ specifically names ‘Environmental Research Scientist’; NZ has world-leading DOC and biodiversity offset schemes needing advisors."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Green Plan 2030",
        "reason": "Green Plan funds urban biodiversity advisors, but small headcount and citizen-first hiring."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 lists clean energy but not ecology; some demand through DEFRA and rewilding charities."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA allocates funds for land restoration and endangered-species programmes, but no acute migration shortage list exists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "2cb4358a-7c78-422b-a2da-b52d2b663889": {
    "career": "Youth Worker",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Migration Strategy 2023",
        "reason": "Community workers included in state nomination lists, though not on national CSOL."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Category recognises ‘social and community workers’; provinces list them as high-vacancy occupations."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Child-care and social-care shortages open pathways for qualified youth workers with B2 German."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on Critical list, but some NGOs can sponsor under general work permit."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Migrant Category",
        "reason": "Government lists ‘community and youth workers’ as skill-shortage; fast visa for qualified applicants."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "List sporadically adds ‘social workers’; funding uncertainty keeps demand moderate."
      },
      "united_states": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "fdac680d-69a1-4ff3-816f-571a66cd58ab": {
    "career": "Air Transport Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Migration Strategy 2023",
        "reason": "Large airport expansions (Western Sydney) drive demand, yet occupation sits on state, not national lists."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Strategy covers logistics and transport, but no specific aviation shortage list."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Airports like BER face staffing gaps; qualified managers eligible under general ‘managers in transport’ code."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "New capital’s airport, archipelago connectivity and tourism targets require aviation-management talent."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Dublin Airport recruitment mostly local; no critical-skills listing."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP covers transport management; Japan’s push to revive tourism creates need for English-speaking ops leaders."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "MADANI Economy",
        "reason": "Kuala Lumpur Aeropolis expansion under MADANI needs foreign expertise in cargo and route development."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Vision 2030",
        "reason": "NEOM, Riyadh Air and massive airport builds demand experienced foreign air-transport managers."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Economy 2030",
        "reason": "Changi Terminal 5 and air-cargo digitalisation sit in logistics pillar; foreign experts still welcomed."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi aim to triple passenger numbers; Operation 300bn backs smart-logistics leadership hires."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 lists advanced manufacturing; aviation mgmt not priority but Heathrow expansion spurs some demand."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA funds airport modernisation; carriers seek managers for digitised ground ops and sustainability compliance."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "National Master Plan 2021-2030",
        "reason": "Long Thanh mega-airport and low-cost carrier boom create high demand for seasoned managers."
      }
    }
  },
  "433909de-f72d-41ae-aa3d-ea97f2a84589": {
    "career": "Branding Consultant",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Critical Skills list excludes marketing; few sponsorships."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Vision 2030’s entertainment and sports push creates some demand for senior brand strategists."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Global brand agencies operate here, but not on Tier-1 list."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "We the UAE 2031",
        "reason": "Dubai media-hub status attracts foreign branding talent, though not officially prioritised."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 includes creative-industry seniors; Global Talent visa covers brand thinkers with awards/portfolio."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Creative roles not immigration priorities, but U.S. remains largest brand-consulting market."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "0964a3fc-f2a6-4a0e-9d6d-211aa02a7d29": {
    "career": "Building Design Advisor",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL lists architects and sustainability consultants; housing and infrastructure pipeline long to 2032."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Demand for sustainable-design professionals in booming housing markets; easier licensing pathways."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Energy-efficiency retrofit push and Bauhaus-era building stock create acute need for design specialists."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "New capital Nusantara demands global advisors for eco-friendly city planning."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List includes architects; housing crisis keeps demand solid."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-city and earthquake-resilient design projects qualify under HSP."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "NIMP promotes green buildings; foreign advisors welcomed for technology transfer."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Green List names architects and building surveyors; seismic upgrade rules intensify need."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Vision 2030",
        "reason": "Megacities NEOM and The Line recruit global design advisors for futuristic, climate-resilient structures."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Singapore Green Plan 2030",
        "reason": "Green Mark standards create ongoing but competitive demand for design consultants."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Operation 300bn",
        "reason": "Operation 300bn’s smart-city targets and Expo legacy drive demand for sustainable design consultants."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Net-zero building regulations require advisory expertise; shortage outside London."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA funds retrofits; advisors needed for energy-efficient design though licensing still required for sign-off."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "National Master Plan 2021-2030",
        "reason": "Rapid urbanisation and industrial parks need sustainable design guidance."
      }
    }
  },
  "2794a25c-f1c6-4052-b882-0bf3e81df6d4": {
    "career": "Chinese Instructor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Schools promote Asian languages, but Chinese teachers are not on the CSOL shortage list, so visas compete in general stream."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Growing Mandarin demand in schools and immigrant services yet language teachers are outside the Express Entry priority list."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Government pushes Mandarin in schools to support Belt-and-Road projects, though still a niche hire."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Private schools hire Mandarin teachers for tourism trade, but no fast-track under HSP or SSW."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Large ethnic Chinese population keeps steady demand, yet not part of NIMP 2030 talent priorities."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Mandarin added to school curriculum to deepen China ties, creating some demand, but visas handled ad-hoc."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Economy 2030",
        "reason": "Bilingual policy gives regular demand for Chinese curriculum specialists, yet role not on strategic shortage list."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "International schools hire Mandarin staff for expat children; however, not a named priority occupation."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "UK modern-languages shortage gives limited bursaries, yet Chinese is outside the Skilled Worker shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "US universities run large Chinese-language programs for diplomacy/business but the role is not on any federal talent list."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Mandarin important for trade, but education visas have no preferential channel."
      }
    }
  },
  "899dd6bc-3cdb-49d8-9c8c-c15de753794f": {
    "career": "Collaborative Artist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Vibrant music scene, yet arts roles excluded from Core Skills list."
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Jakarta’s growing film sector occasionally imports composers, but not strategic."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "J-pop and game studios work with foreign composers, yet no HSP prioritisation."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Vision 2030",
        "reason": "Huge state investment in music and live events (MDLBeast, Riyadh Season) actively recruits international collaborative artists."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Esplanade and media firms hire foreign artists on work passes, though outside national priority."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Dubai Media City and Abu Dhabi cultural districts hire musicians for film, TV and immersive experiences."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries are a named pillar; music professionals get streamlined Global Talent visas."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "",
        "reason": "Hollywood, Broadway and game studios hire composers and sound designers, though visas fall under general O-1 arts category."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "996c811c-0ff6-430e-9139-fce80f717cdb": {
    "career": "Crop Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Occupation ‘Agricultural Consultant’ on CSOL with rural sponsorship incentives."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Agricultural specialists score well under TEER code 2123 Agrologists, receiving extra rural points."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Agronomy degrees qualify, but quotas focus on engineers and nurses."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Food security pillar funds precision-agri advisers, especially for rice and palm estates."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Agri-food big in Ireland, but role not on Critical Skills List; General Work Permit possible."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "SSW covers farm workers; consultants need regular Engineer/Specialist visa without fast track."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Palm-oil sector hires advisors but NIMP 2030 focuses on industry 4.0, not agronomy."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "‘Agricultural Consultant’ is Green-List Tier-1, offering straight-to-residence visas."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "US agribusiness hires advisors, yet no immigration fast-track outside H-2A seasonal work."
      },
      "vietnam": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "National Master Plan 2021-2030",
        "reason": "Plan emphasises smart farming; foreign agronomists welcomed under digital-agri subprograms."
      }
    }
  },
  "315860e8-cea6-4e69-89ba-91f63e7aa6ad": {
    "career": "Digital Forensics Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Migration Strategy 2023",
        "reason": "Cyber analysts on Core Skills list with fast 3-day visa processing."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Cybersecurity and digital forensics are named priority codes for new streamlined work permits."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialists get Blue Card without degree requirement if salary met, covering forensics."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "RPJPN 2025-2045",
        "reason": "Fintech growth needs forensics, but no dedicated visa lane— general tech talent stream only."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "‘ICT security specialists’ on list; forensics falls under this code with 2-year work-to-residency."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP gives fast points for cybersecurity PhDs, but language barrier restricts roles."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Digital trust initiatives grow but formal priority on semiconductor rather than cyber yet."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Cyber roles compete in general Skilled Migrant Category—points but no Green-List slot."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Cybersecurity budgets rising, but preference for localised SOCs means moderate foreign intake."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "National AI Strategy 2.0",
        "reason": "Cyber & digital trust labeled ‘moonshot’; COMPASS points boost for sector roles."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Operation 300bn",
        "reason": "Fintech hubs (DIFC/ADGM) hunt for digital forensics to meet regulatory audits."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital/cyber security is an IS-8 pillar; shortage-list visas processed in two weeks."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Critical infrastructure cyber-security funding drives demand for forensics talent; H-1B approvals high for this SOC."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "IT security demand rising with fintech, though not yet in formal shortage lists."
      }
    }
  },
  "197bddb8-5014-4585-a07e-328219456f1e": {
    "career": "Drilling Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Occupation ‘Petroleum Engineer’ on CSOL with regional visas for LNG basins."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Oil-sands demand exists, yet immigration now favours green energy skills."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Geothermal and deep-sea oil targets need thousands of drilling engineers."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Some methane-hydrate R&D but minimal commercial drilling."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "MADANI Economy",
        "reason": "Petronas deep-water projects and CCS wells require experienced drillers."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "ARAMCO, Jafurah gas and deep-water Red Sea projects need advanced drilling talent."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Acts as rig-building hub, but pure drilling roles limited onshore."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "We the UAE 2031",
        "reason": "ADNOC expands sour-gas and offshore fields; engineers get Golden Visa points."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "North Sea decommissioning dominates; fresh drilling limited, visas scarce."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Shale industry rebounds; engineers sponsored under H-1B but no specific energy talent act."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "National Master Plan 2021-2030",
        "reason": "LNG-to-power and offshore gas keep steady drilling programmes."
      }
    }
  },
  "f4bc1b55-dc1c-4290-805b-746e1f47a5a5": {
    "career": "Environmental Project Manager",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "Renewable-energy and construction PM occupations are on the Core Skills list with fast-track visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Environmental engineers and project managers earn extra CRS points under the ‘STEM & sustainability’ draw."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Germany’s Energiewende creates shortage of managers who oversee wind, solar and brownfield clean-ups."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "RPJPN 2025-2045",
        "reason": "Nickel/EV supply-chain sites require impact mitigation PMs; expat roles possible but scarce."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Civil/environmental engineers on list; PM experience valued for EU-funded green builds."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Renewable-energy developers need bilingual PMs, but language barrier keeps demand moderate."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Semiconductor & EV plants must meet ESG requirements; limited senior PM openings."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Civil & environmental engineers on Green List; PM skills welcomed for infrastructure rebuilds."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Giga-projects like NEOM need environmental compliance but roles limited and Arabic preferred."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Green Plan 2030",
        "reason": "Carbon-management projects hire some env-PMs, yet role not on priority list."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Operation 300bn",
        "reason": "Industrial decarbonisation push creates some demand for sustainability PMs."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Offshore-wind, hydrogen and nuclear projects require disciplined environmental programme management."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Billions for clean-energy plants, battery factories and site remediation demands managers who can keep projects on-time and regulation-compliant."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "National Master Plan 2021-2030",
        "reason": "Offshore wind roll-out needs environmental oversight yet prefers local language skills."
      }
    }
  },
  "1cd02852-96e2-4cda-9c3c-28a18ed8a1c6": {
    "career": "Human Rights Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Migration Strategy 2023",
        "reason": "Global Talent visa includes ‘social sciences’ researchers; limited quota."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Federal strategy funds social-impact research, easing permanent residency for PhDs."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Points system rewards advanced degrees; Berlin hosts multiple human-rights institutes."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Irish Research Council funds human-rights scholarship; easier resident permits for researchers."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Universities host human-rights centres; EP issued to PhD researchers."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Some international NGOs operate in Dubai; small research headcounts."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "",
        "reason": "Global Talent visa and strong university/NGO network in London, Oxford, York."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "",
        "reason": "Universities, think tanks and NGOs sponsor H-1B/J-1 visas for social-science researchers."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "1f63a619-3690-41c8-b962-e24a72a6b205": {
    "career": "International Lawyer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Migration Strategy 2023",
        "reason": "Some demand in arbitration hubs like Sydney; recognition process lengthy."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Foreign-trained lawyers face provincial bar exams; limited fast-track pathways."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Post-Brexit, Dublin hosts expanding cross-border practices but competition high."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Mega-projects need contract specialists, but local partnership rules apply."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "As Asia’s arbitration hub, Singapore licenses certain foreign law practices under QFLP."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai International Financial Centre courts English-law specialists for trade and arbitration."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London positions senior legal services as priority; Solicitors Qualifying Exam now open to foreign grads."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "",
        "reason": "Global firms sponsor LLM grads for H-1B; NYC, DC and Silicon Valley house cross-border practices."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "0d16955f-fe36-438a-9ebe-c6eba18b1e00": {
    "career": "Language Teaching Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Secondary teachers in languages are listed; regional visas fast-tracked."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "French & foreign-language teachers given extra points; acute shortage outside Quebec."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Schools seek English & bilingual teachers; new card eases recruitment."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "ESL schools employ some foreign teachers on General Employment permits."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "JET Programme and private eikaiwa chains recruit ESL instructors."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Primary/secondary teachers on Green List with direct residency pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Vision 2030",
        "reason": "Private schools hire ESL teachers, but nationalisation policies tighten quotas."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "We the UAE 2031",
        "reason": "Private sector hires ESL teachers; competition from native speakers."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "J-1 cultural exchange and charter schools hire foreign language teachers but visa caps exist."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "71244d35-e11a-4073-8c43-8c07a50ade5d": {
    "career": "Media Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Creative roles possible but not on Core Skills list; points visa only."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Role not on priority lists; possible through general work permits."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Entertainment and sports megaprojects require senior media managers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Media managers hired but not on National AI Strategy priority list."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai Media City and Abu Dhabi creative hubs aggressively recruit experienced media managers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries named as growth pillar; senior media planners on Skilled Worker route."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Large media buyers sponsor visas through H-1B cap-exempt subsidiaries; Silicon Valley needs content strategists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "31b6094c-a543-44c7-936b-8930c0967fcf": {
    "career": "Mental Health OT",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "State nomination lists include occupational therapists for mental-health settings, easing visa sponsorship."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Occupational therapists named in the healthcare target category; straightforward PR pathway with extra CRS points."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Act expanded to cover therapists; clinics fast-track visas for mental-health OT."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on critical list, yet HSE recruits OTs under general permit category."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Mental-health care demand rising; OT not on SSW list but hospitals sponsor under general work visa."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Occupational therapists appear on Tier 1 list with immediate residence pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Vision 2030",
        "reason": "New behavioural-health hospitals and mega-city clinics actively recruit foreign OTs."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "We the UAE 2031",
        "reason": "Government mental-health strategy drives hiring in Abu Dhabi and Dubai private hospitals."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Occupational therapists still qualify for skilled-worker visa, but NHS budgets tight."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Ageing-population funding raises demand for licensed allied-health workers, though OT not a federal priority list occupation."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "f6dd88d9-7d26-4ccd-8eef-9380fb120eb6": {
    "career": "Physiology Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Exercise physiologists on state lists for chronic-disease and aged-care programs."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "General demand for medical scientists; no dedicated sports-science stream."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Universities hire clinical physiologists; niche outside elite sport."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Roles exist in high-performance sport but limited visa quotas."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Massive investment in pro sports leagues and wellness tourism needs performance consultants."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Economy 2030",
        "reason": "Small but growing sports-tech scene; hiring selective."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai Sports City and clinics hire sports-science experts for elite teams."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industries pillar includes elite sport tech; roles exist but sponsorship limited."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds veteran rehab and community sports medicine, creating consultancy demand."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "1684f03e-5def-48ff-b801-2eebf57cddfd": {
    "career": "Playwright",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Vision 2030",
        "reason": "Entertainment districts need Arabic and English scriptwriters for new theatres."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Dubai Opera and media free zones hire experienced playwrights for festivals."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industries growth funds regional theatres and new writing labs."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "No direct policy support; large commercial theatre market offers opportunities despite lack of incentives."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "ce2fb4bc-e616-470a-bb24-aec8447e9a56": {
    "career": "Production Coordinator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Migration Strategy 2023",
        "reason": "Some productions in Queensland hire foreigners, yet not on core skills list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Film tax credits create work, but immigration points favour tech roles."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "New film studios at NEOM recruit experienced coordinators to train locals."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "We the UAE 2031",
        "reason": "Dubai Media City and Abu Dhabi backlot growth boost demand for bilingual production staff."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Government targets creative-industry jobs; large studio builds around London need coordinators."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Large studio expansions in Georgia and New Mexico need logistics staff despite no formal federal priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "74652e8e-d099-459f-aad0-996c8f8e5f50": {
    "career": "Responsible Innovation Designer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Clean-tech start-ups need designers but visas prioritise engineers."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Strategy highlights sustainable tech and welcomes experienced designers."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Circular-economy regulations drive high demand for sustainable product designers in Mittelstand manufacturing."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "List focuses on software and pharma; design roles rarely sponsored."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-city and robotics firms value responsible design but hire few foreigners."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Push for sustainable manufacturing opens some roles."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Small market; few visas for design specialists."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Mega-projects need sustainability consultants, but engineering roles take priority."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Singapore Green Plan 2030",
        "reason": "Nation’s circular-economy goals drive demand for sustainability-minded product designers."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Operation 300bn",
        "reason": "Manufacturing diversification needs designers but sponsorship selective."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 backs clean manufacturing and creative-industry design leadership."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA’s climate incentives push companies to redesign products for circularity and low carbon."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "cd4224b6-7598-4230-a7ff-6e8e89b81aa4": {
    "career": "Sports Program Leader",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Active sports culture and government grants, but occupation is outside the Core Skills list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Demand exists through community recreation and varsity sports, yet immigration points do not favour sports managers."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Community-sport roles available, but not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Massive investment in sports clubs and mega-events (e.g., NEOM games) needs program leaders."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Growth of sports tourism (Dubai Fitness Challenge, Abu Dhabi F1) drives demand for event-centric leaders."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Huge commercial sports ecosystem creates jobs, but role is not on any federal priority list."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "79a07c84-0bae-4b76-bb77-cdbe0ba151f8": {
    "career": "Technical Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Manufacturing modernisation and critical-skills visas include engineering managers."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Fast-track pathways for experienced engineers and plant managers."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Automotive and machinery clusters urgently seek bilingual technical leaders."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel-to-battery supply chain needs technical supervisors."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Med-tech and pharma plants hire, yet Critical Skills List prefers pure engineers."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "Semiconductor fabs and robotics manufacturers recruit foreign managers with Kaizen expertise."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Large incentives for EV and semiconductor facilities demand leadership talent."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Some demand in food-processing plants, but not Green-List priority."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Vision 2030",
        "reason": "Gigafactories and mega-projects require expat manufacturing managers during ramp-up."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Manufacturing 2030",
        "reason": "Pharma and precision-engineering plants seek managers fluent in Industry 4.0."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Operation 300bn",
        "reason": "Ambition to triple industrial output depends on seasoned technical managers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "EV, aerospace and clean-energy sectors need plant leadership but visas not automatic."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act funds advanced manufacturing plants that need engineering-savvy managers."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Rapidly expanding chip-assembly plants value experienced line managers."
      }
    }
  },
  "1961ad71-1d4a-46b5-8a83-f9f4d1f47527": {
    "career": "Advertising Specialist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Government is pumping money into tourism branding and sports sponsorships."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Dubai aims to be a global media hub; creative visas available for senior advertisers."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Creative visa for top talent exists but quotas are tight; advertising not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Huge ad market but no immigration priority; H-1B odds are low for generic creatives."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "a23933fe-42a3-4206-8968-f3489800b495": {
    "career": "Analytical Bioscientist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Med-tech and biosecurity emphasis creates research vacancies."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Pharma and med-tech hubs actively invite scientists, though not explicitly listed."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Biotech roles qualify, but quotas favour engineers and IT first."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "RPJPN 2025-2045",
        "reason": "Biopharma expansion to reduce imports relies on foreign expertise."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Biopharma plants and research centres have chronic scientist shortages."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Highly Skilled Professional visa",
        "reason": "Government funds regenerative-medicine and biotech research, awarding fast-track points."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "MADANI Economy",
        "reason": "NIMP 2030 targets pharma and med-dev R&D requiring bioscientists."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Migrant Category",
        "reason": "Agri-biotech and food science labs need analytical scientists."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "New biotech parks (e.g., KAUST, NEOM) recruit R&D talent."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Singapore Economy 2030",
        "reason": "Biomed cluster (Biopolis) offers EP/S-Pass prioritisation for bio-analytics specialists."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "We the UAE 2031",
        "reason": "Genome Programme and biotech clusters offer golden visas for researchers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences pillar seeks genomics and cell-therapy experts."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Massive federal funding for biotech and biomanufacturing R&D."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "National Master Plan 2021-2030",
        "reason": "Agritech and vaccine research scale-ups need analytical talent."
      }
    }
  },
  "c976016d-a5a4-489e-90ae-59d16bb1f29c": {
    "career": "Ancient History Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "",
        "reason": "ARC humanities funding attracts foreign PhDs under Temporary Skill visa."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "SSHRC grants and tenure-track openings, though Express Entry points moderate."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "67",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "DAAD-funded archaeology institutes hire international scholars."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Irish heritage projects sponsor occasional fellowships."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Universities hire English-language researchers for Silk Road studies; competition high."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Limited university seats but some Maori/Polynesian history grants."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "SMU and NUS fund Southeast-Asian history chairs; positions rare but possible."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Museum-boom (Louvre Abu Dhabi) creates some research posts, yet visas discretionary."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "",
        "reason": "World-class classics departments; Global Talent visa fits senior researchers."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Universities fund classical studies; H-1B cap-exempt research visas available."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "37c8bf2f-73a9-4588-9c88-3de55bf194c8": {
    "career": "Atmospheric Physicist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Migration Strategy 2023",
        "reason": "Climate research roles qualify under STEM researcher pathway with priority processing."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Strategy names climate-science and environmental STEM as focus areas eligible for fast Express Entry."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Renewable-energy and climate modelling institutes actively recruit non-EU atmospheric scientists."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Early plans for climate-risk modelling; few dedicated research posts currently."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Environmental scientists qualify for Critical Skills permit though scale is modest."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP visa rewards PhD climate researchers supporting typhoon and pollution monitoring."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Need for haze-forecasting scientists exists but not top-tier priority."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Environmental scientists appear on Tier-2 list; pathway to residence but limited research budgets."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Smart-city projects (NEOM) need weather & dust-storm modelling but roles are niche."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Green Plan 2030",
        "reason": "Tropical weather research supported but hiring volumes small; not Tier-1."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "National Center of Meteorology hires specialists yet numbers remain small."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Met Office & clean-energy clusters seek atmospheric modellers, but not a listed shortage occupation."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA funds NOAA/NASA weather-climate modelling and satellite programmes, driving demand for atmospheric scientists."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "National Master Plan 2021-2030",
        "reason": "Climate-change adaptation work growing yet budgets remain limited."
      }
    }
  },
  "d6300d93-3963-4740-8c63-1c8d762b4824": {
    "career": "Audit Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Accountants recently removed from high-priority list, only general skilled visa pathway."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Express Entry Category-Based Selection",
        "reason": "French-speaking CPAs gain points, yet generic finance not a priority category."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Accountants qualify as skilled workers but language barrier limits demand."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Chartered accountants and external auditors receive Critical Skills permits."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Financial governance strengthening drives steady demand for experienced auditors."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Economy 2030",
        "reason": "Sustainable-finance hub values IFRS/ESG audit leadership; Employment Pass processing favours experienced managers."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai and Abu Dhabi financial centres court qualified audit professionals for IFRS compliance."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London’s financial-services focus keeps Big-Four audit managers on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Accounting roles plentiful but not targeted by federal talent programmes."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "6a7f609d-28ce-4885-b911-786678776393": {
    "career": "Bioenergy Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Renewable-energy engineers on CSOL; regional biofuel plants expanding."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Clean-tech engineers receive priority invitation under climate-action stream."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Germany’s Energiewende relies on biogas/biomethane engineers; simplified Blue Card rules."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "RPJPN 2025-2045",
        "reason": "Plans for bioethanol and biogas from agri-residue tie to energy security."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Energy engineers accepted but project pipeline smaller."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Highly Skilled Professional visa",
        "reason": "Biomass co-firing projects drive demand under carbon-neutral roadmap."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "MADANI Economy",
        "reason": "Palm-oil waste-to-energy initiatives seek process engineers with biomass expertise."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Green List covers renewable energy engineers with straight-to-residence pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Circular Carbon programme funds bioenergy pilot plants, hiring international experts."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Green Plan 2030",
        "reason": "Waste-to-energy R&D centres recruit bioenergy process engineers, but limited plant scale."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Operation 300bn",
        "reason": "Masdar invests in waste-to-energy facilities, attracting specialised engineers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "BECCS and hydrogen clusters need bioenergy process engineers; on Shortage List."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA pumps billions into advanced biofuels, creating R&D and plant-design roles."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "National Master Plan 2021-2030",
        "reason": "Bioenergy crucial for net-zero pledge; incentives for foreign specialists."
      }
    }
  },
  "a9229e7a-4541-4a6e-b33c-817e6ffa2018": {
    "career": "Club Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Roles exist in private clubs, yet not on CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Hospitality stream prioritises chefs, not club managers."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Sports clubs prefer local hires; permit quotas tight."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Massive investment in sports and entertainment complexes needs experienced club managers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "",
        "reason": "Prestige clubs employ some foreigners but quotas shrinking."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "High-end golf and yacht clubs in Dubai/Abu Dhabi recruit international managers."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Hospitality roles accessible but not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Large sports and leisure sector offers roles but no dedicated immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      }
    }
  },
  "977798a6-c4c2-4783-951d-b84d6864ce65": {
    "career": "Computer Systems Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "ICT managers feature on Core Skills list with priority processing."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Tech managers in AI/cybersecurity streams get fast permits."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT-Leiter roles qualify under new Blue Card salary thresholds."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Digital economy initiatives create demand, but localisation rules apply."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Tech multinationals in Dublin constantly sponsor ICT managers."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP covers ICT experts but language hurdles remain."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Digitalisation push opens roles, yet salary thresholds moderate."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Software managers appear on Tier-2 but few large enterprises."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "Smart-city and fintech projects need experienced IT managers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "National AI Strategy 2.0",
        "reason": "Banks and data-centre giants need seasoned systems managers; EP processing quick."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "UAE Centennial 2071",
        "reason": "Financial hubs recruit CIOs and systems managers for digital transformation."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital/AI pillar lists senior IT roles on Shortage List."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Massive semiconductor and AI investments demand leaders who can scale enterprise IT."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "National Master Plan 2021-2030",
        "reason": "Fast-growing tech outsourcing sector hires some foreign IT managers."
      }
    }
  },
  "c9c3b922-6cdc-488e-9704-da7b591a673e": {
    "career": "Contemporary Music Performer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Migration Strategy 2023",
        "reason": "Allows Distinguished Talent visas for arts yet not on priority occupation lists."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Programme has a small stream for cultural talent but music is not on core shortage lists."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Entertainment megaprojects (NEOM, AlUla) need live performers, but hiring remains event-based."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Dubai/Abu Dhabi invest in cultural districts; visas available yet numbers limited."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry listed, but quotas favour senior award-winning artists."
      },
      "united_states": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "d91094da-0497-49b1-bda7-d7dff1d823d9": {
    "career": "Corporate Lawyer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "Some openings for senior solicitors yet not on Core Skills list."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Legal profession not on priority list; possible only via general points route."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Fintech and pharma HQs drive steady demand for corporate solicitors."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Mega-projects need international contract experts, but Saudisation preference keeps quotas modest."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "National AI Strategy 2.0",
        "reason": "Cross-border tech deals need counsel; still no explicit shortage listing."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "UAE Centennial 2071",
        "reason": "DIFC/ADGM seek cross-border M&A and finance lawyers; English law expertise valued."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City of London identifies senior legal services as critical to global competitiveness."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "CHIPS and Science Act",
        "reason": "Complex tech transactions create some demand for specialist counsel, but no immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "699e0a68-1db4-45e2-95d6-18f85bd85a61": {
    "career": "Foreign Service Officer",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Think-tank and multilateral liaison roles open to expatriates with diplomatic skills."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Regional organisations in Abu Dhabi/Dubai hire international relations professionals."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Think-tanks and Commonwealth bodies seek policy analysts, not official diplomats."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct link; public-sector roles rarely sponsored for foreigners."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "b4dcd1ab-0f10-4687-b71d-b0fb3f4fa8eb": {
    "career": "GIS Technician",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Spatial scientist and surveying roles explicitly listed for regional visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "IT and construction tech profiles gain extra points, especially with French skills."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Renewables and transport sectors hire GIS specialists, but not shortage-critical."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "RPJPN 2025-2045",
        "reason": "New capital Nusantara requires extensive spatial datasets."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "GIS falls under software/dev but gains no automatic permit; still recruit for utilities."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Infrastructure renewal employs GIS but role sits in contractor IT teams."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Smart manufacturing and land-use planning need geospatial mapping."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Green List (Tier 2)",
        "reason": "Spatial scientists qualify for straight-to-residence after job offer."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Smart-city and mega-project planning relies on GIS layers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Economy 2030",
        "reason": "Smart Nation projects rely on GIS yet supply of local grads is adequate."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Operation 300bn",
        "reason": "Urban digital twins and logistics hubs need geodata, but hiring is project-based."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Offshore wind siting and HS2 project fuel demand, yet not on shortage list."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Massive infrastructure mapping projects need geospatial talent for roads, utilities and climate resilience."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National Master Plan 2021-2030",
        "reason": "Transport corridors and offshore wind mapping create moderate demand."
      }
    }
  },
  "06a99f9c-24b8-45ef-8f59-ab73a6ce2afa": {
    "career": "Midwifery Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Migration Strategy 2023",
        "reason": "Severe perinatal staff shortages; research roles fast-tracked under health priority."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Health-occupation stream gives top ranking to midwives and nurse researchers."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Maternity care crisis pushes hospitals to recruit research-active midwives."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Focus on reducing maternal mortality opens consulting roles."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Severe shortage of advanced midwives and maternal researchers."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "Aging society invests in maternal-child outcomes; research posts sponsor foreigners."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "MADANI Economy",
        "reason": "Health research expanding yet funding smaller; limited slots for expatriates."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Midwives on straight-to-residence list; universities add research fellow visas."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Large women-and-child hospitals under construction need evidence-based practice leaders."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Green Plan 2030",
        "reason": "Biomedical campus funds maternal-fetal health studies; foreign PhDs welcomed."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Maternal-health innovation hubs in Abu Dhabi recruit PhD midwives."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences R&D includes clinical midwifery trials; funding via NIHR."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "CHIPS and Science Act",
        "reason": "Act boosts NSF/National Science Foundation health grants, indirectly funding maternal research."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National Master Plan 2021-2030",
        "reason": "Maternal health projects need advisors but on short contracts."
      }
    }
  },
  "051ed57a-daa0-46d2-817d-56e43f0a2016": {
    "career": "Museum Educator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Museology not on CSOL; state sponsorship only case-by-case."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Cultural occupations can still qualify through points, yet not in targeted shortage lists."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Degree holders in cultural pedagogy are eligible but demand is modest."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Not on Green List; arts visa possible with employer sponsorship."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "We the UAE 2031",
        "reason": "Plan boosts cultural tourism; a few expatriate museum-education posts open."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative sector is strategic, but museum education specifically is not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Museums benefit from NEA grants but role is outside industrial-policy focus; H-1B possible if master’s holder."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "20",
        "policy": "",
        "reason": ""
      }
    }
  },
  "380d4166-7aa1-46ba-b739-4994aeba90a3": {
    "career": "Peace Program Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Role is off CSOL; visas depend on NGO sponsorship."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Peacebuilding managers qualify via general points but not in targeted categories."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "GIZ and humanitarian NGOs face talent gaps; Act eases entry for experienced managers."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Irish Aid funds peace projects, but role not on Critical Skills List."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Regional diplomacy and humanitarian initiatives create limited openings for expatriate experts."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Regional NGO hubs exist, but role outside national priority areas."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai- and Abu Dhabi-based aid foundations recruit international programme leads."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "63",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "FCDO and large charities consider conflict-management strategic; visas possible under Skilled Worker."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "USAID, State-funded NGOs hire but occupation outside federal skills lists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "d533594c-cb77-4310-a6ba-14bbaf43497c": {
    "career": "Publications Contributor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Journalists absent from CSOL; sponsorship rare."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Cultural writers qualify under regular points, not priority categories."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Creative professionals can self-sponsor if German-speaking, but not shortage."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Role not on Critical Skills List; freelance possibilities only."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Regional media hub, yet role outside top talent list."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Dubai Media City attracts expat writers, yet visas favour senior editors."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries strategic; experienced contributors can secure Skilled Worker visas."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Large media market but no policy incentives; H-1B cap competitive."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "f2b77244-d1ae-48b4-8abd-237dab6c571d": {
    "career": "Range Ecologist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Environmental scientists and land-management roles are recognised shortages, especially in rangeland states."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Category-based draws favour environmental scientists and agri specialists combating climate change."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Climate adaptation projects exist but profession not on top shortage lists."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "RPJPN 2025-2045",
        "reason": "Large land-use change and forest programmes need ecologists though mining/EV dominate."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Agri-environment schemes create some demand but not on Critical Skills List."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Environmental consultancy hiring exists, yet visa points lower than for robotics/semiconductors."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "MADANI Economy",
        "reason": "Eco-tourism and palm-oil sustainability drive some demand, not headline priority."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Ecologists fit Tier-2 environmental scientist category for priority residence."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Desert restoration and nature reserves require ecological expertise, though in modest numbers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Green Plan 2030",
        "reason": "Urban biodiversity projects exist but limited scale."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Mangrove-planting and biodiversity projects open limited ecology positions."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Renewable projects need ecological impact studies; role not on shortage list but hires occur."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds large-scale land restoration and climate resilience, creating strong demand for rangeland ecology expertise."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "47",
        "policy": "National Master Plan 2021-2030",
        "reason": "Policy stresses biodiversity and coastal restoration but stronger focus on energy."
      }
    }
  },
  "c08799a8-38e2-4950-ba0d-735cc38a1f46": {
    "career": "Recreation Director",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Seasonal shortages in outback resorts but not on CSOL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Tourism roles not in category-based selection, though hiring exists in ski and summer resorts."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Tourism jobs available yet not prioritised under Skilled Immigration Act."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "New capital city and resort islands drive moderate demand for leisure managers."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Hotel staffing pathway exists, but management positions rarely granted to foreigners."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Eco-resort expansion creates some need, yet immigration policy neutral."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Adventure tourism relies on overseas staff, still outside Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Giga-projects (NEOM, Red Sea) urgently recruit expatriate recreation and resort leaders."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Integrated resorts hire, but Singapore focuses visas on tech and finance."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "UAE Centennial 2071",
        "reason": "Luxury resorts and cruise hubs need recreation directors for experience economy goals."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Role common in resorts and parks but outside federal skills acts."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "",
        "reason": "Coastal tourism zones hire foreign recreation leads on project basis."
      }
    }
  },
  "97fe931c-eda1-4d6c-8576-5f35803c761f": {
    "career": "Sustainability Coordinator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Climate disclosures growing, yet job is not on CSOL; possible via general skilled migration with average points."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Role supports, but is not listed among priority shortage occupations; points may accrue under French/education extras."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "German firms seek ESG staff for EU reporting, but occupation not explicitly on shortage lists—still viable with degree + German B1."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "ESG jobs exist in multinationals but are outside Critical Skills; General Employment Permit needed."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "Environmental management qualifies for HSP if high salary and points; not nationally prioritised."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "MADANI Economy",
        "reason": "Sustainability reporting rising in palm-oil and electronics, but not a named NIMP priority role."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "No direct Green List listing; sustainability officers can enter via points if salary threshold met."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Vision 2030",
        "reason": "Mega-projects need ESG officers, yet Saudization favours nationals; foreign specialist roles exist but finite."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Green Plan 2030",
        "reason": "Carbon-management specialists are Tier-1; coordinators with carbon accounting experience welcomed under Employment Pass."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Dubai/ADGM firms hiring sustainability specialists for green finance and COP28 follow-ups."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Mandatory climate disclosures push demand even though role not on Shortage List; Skilled Worker visa possible."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Corporate ESG reporting and carbon-foot-print tracking skills are in demand as firms claim IRA clean-energy tax incentives."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "eba3627d-2f66-4e35-b69a-0a5942eecbce": {
    "career": "Urban Ecology Advisor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Green-infrastructure expertise welcome but not explicitly on CSOL; possible under environmental consultant code."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Large municipal projects in Toronto/Vancouver value advisors, but occupation not on category-based selection lists."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "German cities invest in Schwammstadt (sponge city) concepts; candidates need C1 German to compete."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "New capital Nusantara touts forest city; small advisory teams needed but hiring sporadic."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Some work on greenways and floodplain restoration, but not a listed shortage."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Highly Skilled Professional visa",
        "reason": "Smart-city pilots (e.g., Woven City) include ecology components; limited but possible."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Skilled Migrant Category",
        "reason": "Limited roles in Auckland/Wellington councils; points route only."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "NEOM, Red Sea and AlUla hire ecologists to integrate wildlife corridors into futuristic city plans."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Singapore Green Plan 2030",
        "reason": "City-in-Nature initiative actively recruits ecologists for park connectors and biodiversity survey."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Dubai Urban Master Plan 2040 needs nature-based solutions specialists; niche yet funded."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Mandatory biodiversity-net-gain rules make local authorities contract urban ecology consultants."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Federal funding for climate-resilient infrastructure pushes cities to hire biodiversity and heat-island experts."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "516910d7-40e4-4de4-9476-d2181e609f21": {
    "career": "Agriculture Teacher",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "STEM and rural-school teachers sit high on CSOL; agriculture fits under secondary science."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Secondary teachers, especially agri-science in rural provinces, receive targeted invitations."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Teacher pathway exists but demands C2 German and state recognition, limiting foreign hires."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Teaching excluded; small demand in agri colleges only."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Secondary teachers on Tier 1; offers Straight-to-Residence visa."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "UAE Centennial 2071",
        "reason": "Some demand in vocational colleges, but not national priority."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Teaching removed from shortage list in 2025; sponsorship still possible but harder."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Teacher shortages exist but agriculture not a federal priority; state licensure required."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      }
    }
  },
  "aa09d0ac-f8ae-4a68-8bba-4c9a6ec456c8": {
    "career": "Art Technologist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Berlin new-media scene offers roles; not a shortage but points route available."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Gaming and animation sector growing but not on Critical Skills—General Employment Permit possible."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Highly Skilled Professional visa",
        "reason": "Tokyo’s media-arts scene needs projection-mapping engineers; HSP path if high points."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Vision 2030",
        "reason": "Entertainment megaprojects hire immersive media experts for museums and esports arenas."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "National AI Strategy 2.0",
        "reason": "Museums and Marina Bay events use AI-driven immersive art; Tech.Pass facilitates high-earning creatives."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai’s creative-media free zones aggressively court AR/VR artists and tech specialists."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry seniors (film, TV, gaming) explicitly prioritised; London & Manchester studios hiring art-tech roles."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "CHIPS and Science Act",
        "reason": "Media labs and museums partner with semiconductor/AI grants for immersive art installations."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      }
    }
  },
  "6fb57e31-d1de-4106-9c34-00925ba7d7c8": {
    "career": "Bioresource Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Migration Strategy 2023",
        "reason": "Renewable-energy list favours solar/wind; bioenergy projects fewer yet growing in sugarcane regions."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Canada promotes bio-economy in forestry and agriculture but occupation bundled within general chemical/bioprocess engineers."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Biogas and biomass plants expanding under Energiewende, shortage of bioresource and process engineers."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Large palm and sugar waste streams for bioethanol and SAF create demand for process engineers."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Agri-biogas startups hiring but not on official list; general engineer permit possible."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Highly Skilled Professional visa",
        "reason": "Hokkaido biomass plants and algae biofuel R&D need specialists; HSP points favourable."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan targets palm-waste valorisation and bio-based chemicals; foreign engineers welcomed."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Some biomass research roles exist, but not on Green List—points path only."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Vision 2030",
        "reason": "Interest in waste-to-energy for giga-projects; roles limited."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Green Plan 2030",
        "reason": "R&D in algae biofuels exists, but small headcount."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Operation 300bn",
        "reason": "Bio-based plastics and aviation biofuels discussed but early-stage."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "CCUS and bioenergy with carbon capture (BECCS) backed by UK strategy; engineers required."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Tax credits for biofuels and biomaterials drive demand for engineers converting crop waste to energy."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "National Master Plan 2021-2030",
        "reason": "Bioenergy in early stage; opportunities small but growing."
      }
    }
  },
  "00864a80-fea7-4073-aaf6-002b5772d41b": {
    "career": "Biotechnology Project Manager",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Biotech listed only in broader STEM category; demand solid but not priority."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Life-sciences clusters in Toronto/Montreal actively recruit foreign PMs for vaccine and cell-therapy facilities."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Welcomes STEM managers yet biotech shortages less acute than engineering."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Focus on biopharma raw-material processing, limited project-management roles today."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma-biotech giants in Cork & Dublin rely on imported PM talent."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP covers biotech researchers; PMs qualify if they hold advanced degrees."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan encourages biopharma expansion; demand moderate."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Skilled Migrant Category",
        "reason": "Small but growing agri-biotech sector; limited openings."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Vision 2030",
        "reason": "Govt funds genomic medicine projects, yet hiring still nascent."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Singapore Economy 2030",
        "reason": "Biomed manufacturing is core; PMs needed for modular plant builds."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Operation 300bn",
        "reason": "Biotech listed among future industries; PM roles exist but few."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences named pillar; Oxford-Cambridge-London corridor hungry for biotech programme managers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Massive federal grants for domestic bio-manufacturing plants and R&D programmes need experienced project leaders."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "National Master Plan 2021-2030",
        "reason": "Early-stage biotech ecosystem—few senior PM opportunities yet."
      }
    }
  },
  "0cea8d6d-344b-4fd2-b496-499b11bf717d": {
    "career": "Commercial Litigator",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Legal services not on Core Skills List; some BigLaw demand."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Express Entry favours solicitors in French or rural areas, not city litigators."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "German language and EU law barriers limit foreign litigators."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Post-Brexit Dublin growing but prefers EEA-qualified lawyers."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Foreign attorneys limited to advising on home jurisdiction law."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Local bar restrictions—foreigners can only be consultants."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Small commercial bar; no shortage designation."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Mega-projects generate disputes; foreign counsel permitted via JV licences."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Singapore Economy 2030",
        "reason": "International Commercial Court and major arbitration centre need cross-border litigators."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "We the UAE 2031",
        "reason": "DIFC & ADGM courts actively seek common-law litigators for global finance cases."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Senior legal services highlighted; London’s commercial courts recruit international talent."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "Large market for litigators, but no immigration priority; tough H-1B cap."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "3edb5946-03b2-4957-b055-99d98050ad26": {
    "career": "European Affairs Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Limited demand outside academia and consultancy."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Niche policy role; Express Entry unlikely to target."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Berlin & Brussels offices seek non-EU experts for Indo-EU trade advisory."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Dublin think-tanks and tech firms track Brussels rules post-Brexit."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Role confined to multinational HQs only."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Geographic distance makes role rare."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Singapore Economy 2030",
        "reason": "Regional HQs value EU trade experts, but not priority occupation."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Some diplomatic consulting, but not manpower shortage."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Post-Brexit businesses need EU regulatory advisors."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Think-tanks hire EU analysts, but no visa priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      }
    }
  },
  "dbb8a0f9-f05f-46c9-bd15-d76760fbace7": {
    "career": "Health Information Manager",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Migration Strategy 2023",
        "reason": "EHR roll-out in public hospitals faces staffing gaps."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Hospitals need RHIA-equivalent professionals as records go digital nationwide."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "eHealth reforms create roles, but German language a barrier."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Digitisation projects emerging but not immigration focus."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Health IT appears on list indirectly via data roles."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Hospitals adopting EHR slowly; language barriers large."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "MADANI Economy",
        "reason": "Government pilots national EHR—demand still early stage."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Smaller system, yet Green List covers health IT managers soon."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Mega-hospitals in NEOM seeking HIS talent but openings limited."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Green Plan 2030",
        "reason": "Smart Nation health initiatives create steady need for data-savvy HIMs."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "Private hospital chains digitising records recruit abroad."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "NHS digitalisation ongoing; roles exist but not shortage-listed."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Federal hospital-modernisation funds drive demand for electronic health record (EHR) managers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "EHR market small; preference for local language experts."
      }
    }
  },
  "28b9d0ad-515a-4ab3-9704-5c4d3a59daa5": {
    "career": "Implementation Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Migration Strategy 2023",
        "reason": "Demand exists in mining equipment rollouts, not on CSL."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Manufacturing plants upgrading but role not priority."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz",
        "reason": "Industry 4.0 upgrades require specialists to deploy new lines."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "EV battery gigafactories require rollout specialists."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Med-device factories expanding; skills adjacent to listed roles."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics companies hire foreigners to deploy lines overseas."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Nation aims to upgrade semiconductor and aerospace plants—direct skills match."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Few large plants; niche demand."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Gigaproject factories and renewable plants need rollout experts."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Manufacturing 2030",
        "reason": "High-mix, low-volume plants adopt new tech frequently."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Operation 300bn",
        "reason": "Push for advanced manufacturing brings MES/ERP implementation openings."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean-energy equipment plants require specialists, but visa list not explicit."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Factory modernisation grants need tech leads to install MES/robotics."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "New fabs need engineers to implement equipment and software."
      }
    }
  },
  "7b9cbdf2-905c-401b-98c5-0d602934df66": {
    "career": "Journalism Policy Advisor",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Growing entertainment and media sector needs policy advisors, but foreigners face strong localisation rules."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Media policy experts hired by IMDA, yet role is not in National AI Strategy 2.0 priority list."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "We the UAE 2031",
        "reason": "Dubai Media City and Abu Dhabi’s twofour54 hire senior media-policy talent, yet not on critical shortage list."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry policy expertise valued for Ofcom and DCMS, but not officially shortage-listed."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Think-tanks and FCC routinely hire speech and media-policy experts, but journalists are not on federal talent shortage lists."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "29",
        "policy": "",
        "reason": ""
      }
    }
  },
  "1a4dc868-f210-4559-a4a9-8c3230416a5c": {
    "career": "Legal Anthropologist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Academic researcher category gives priority visas though social sciences not explicitly listed."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities can fast-track research professors in social sciences."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "New points system rewards PhDs and research contracts at German universities."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Irish Research Council funds niche socio-legal studies though not on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Highly Skilled Professional visa",
        "reason": "PhD points allow residency, but limited anthropology posts."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Skilled Migrant Category values PhDs, but role not on Green List."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National AI Strategy 2.0",
        "reason": "Interdisciplinary ethics and governance research attracts funding, though humanities not top tier."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "UAE Centennial 2071",
        "reason": "New research universities hire social scientists, but not priority field."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Global Talent visa covers humanities researchers; UKRI funds socio-legal projects."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "CHIPS and Science Act",
        "reason": "Act expands NSF social-science grants; universities recruit interdisciplinary legal-culture scholars."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "76680f26-9ca8-4c82-b127-6dae892b9d7a": {
    "career": "Process Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Chemical and process engineers are on the list, supporting mining and hydrogen projects."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Chemical engineers sit within STEM priority stream."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Germany’s large chemical industry has persistent process-engineering shortages."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel/EV battery refining needs process experts to boost yield and cut emissions."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Biopharma and med-device plants require process optimisation talent."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Highly Skilled Professional visa",
        "reason": "Chemical manufacturers value consultants, but no explicit shortage."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Specialty chemicals and semiconductor packaging rely on advanced process consulting."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Not on Green List, but large dairy and bio-process plants hire specialists."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Gigantic petrochemical expansions and hydrogen projects require elite process consultants."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Manufacturing 2030",
        "reason": "Jurong Island’s chemical hub hires consultants for continuous improvement and decarbonisation."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Operation 300bn",
        "reason": "Abu Dhabi chemical clusters push for efficiency and carbon-capture processes."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "59",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Clean energy clusters need process engineers, yet shortages less acute than in pharma, auto."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds green chemical and battery plants that need process-optimisation experts."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "",
        "reason": "Some demand in electronics manufacturing; not priority occupation."
      }
    }
  },
  "091b2d52-990d-4ea8-94f2-cbad863d0d16": {
    "career": "Professional Actor",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Large film tax credits attract actors, yet immigration paths rely on employer-specific work permits."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Growing film set tax incentives but local casting dominates."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Massive investment in film and live entertainment seeks global talent."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Mediacorp occasionally casts foreigners but role not in priority industries."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "We the UAE 2031",
        "reason": "Dubai and Abu Dhabi studios recruit international actors for regional productions."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry is a named priority; Global Talent visa streamlines entry for proven actors."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "",
        "reason": "Hollywood unions sponsor O-1 visas for extraordinary talent, but not a shortage occupation."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "bbe50601-5c8b-4424-870a-db197b8e9c12": {
    "career": "Public Policy Advisor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Policy officers receive visas, but not a priority occupation."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Government hires policy analysts yet Express Entry prioritises health, tech and trades."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Critical Skills focuses on tech and engineering."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "Ministries hire foreign advisors to execute megaproject reforms."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Singapore Green Plan 2030",
        "reason": "Climate-policy units hire foreigners with niche expertise, though local preference applies."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Think-tanks and ministries recruit expatriate policy experts across sustainability, AI and trade."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "",
        "reason": "Global Talent: ‘leadership in public policy’ possible, but not on shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "59",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Federal agencies need advisors to steer IIJA funds, but not on shortage list."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "3dad1863-2c09-476b-b732-b2c0d9b14bc0": {
    "career": "Special Needs Educator",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "CSOL lists secondary teachers; states add special-education to their skilled lists."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Express Entry Category-Based Selection",
        "reason": "K-12 and early-childhood teachers are one of Canada’s new invitation categories."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe teacher shortage, especially inclusive education, fast-track recognition rules apply."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Niche demand in private inclusive education, no dedicated visa pathway."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Teacher shortages acknowledged, yet special-needs not on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Some demand at international schools; not covered by SSW or HSP priority."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Private inclusive schools hire expatriates but no national shortage policy."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Special-needs teachers included in Green List Tier 1 with residence fast track."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Private special-education schools recruiting foreigners, but Saudization limits public roles."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "MOE prefers domestic hires; private centres recruit but outside Tier 1 list."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "We the UAE 2031",
        "reason": "Demand exists in private schools, yet education not a headline migration priority."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Shortage list recently dropped most teachers but special-needs still receives targeted visas."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Stable demand for K-12 special educators but not a named federal talent-shortage priority."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Growing international school sector, yet teachers not a migration focus."
      }
    }
  },
  "4dd4bb30-7603-431a-ab2e-99ca8ec3597a": {
    "career": "Botanist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Agri-science and conservation roles added to state nomination lists in drought-hit regions."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Agri-tech scientists receive points boosts under revamped Express Entry science streams."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Green hydrogen and biodiversity projects open spots, but not core shortage."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Food security and biodiversity restoration list agri-scientists as key foreign-talent category."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Food-tech cluster recruits some botanists, but Critical Skills list focuses on engineers."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Plant-science posts possible under HSP points system, yet lower national priority."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Palm-oil sustainability programmes create modest demand for plant scientists."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Primary-sector R&D hires botanists, yet role not on Green List; employer sponsorship required."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Limited to desert-greening projects; jobs exist but niche."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Focus on biotech and precision agriculture tech; pure botany seldom sponsored."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Urban farming push hires plant scientists, still secondary to tech priorities."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Botany research mainly university-funded; not on shortage list after 2025 review."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Research funding exists but plants not singled out in priority visa schemes."
      },
      "vietnam": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "National Master Plan 2021-2030",
        "reason": "Agritech and biotech are headline sectors; plant genetics labs actively sponsor visas."
      }
    }
  },
  "ff07930a-35c5-4e6b-8144-e708897ef407": {
    "career": "Clinical Bioinformatics Dev",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Migration Strategy 2023",
        "reason": "Genomics added to priority medical researcher list but below nursing/IT in urgency."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "AI + health tech targeted; bioinformaticians qualify under STEM stream."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Bioinformatics in precision-medicine clusters (Heidelberg, Munich) given extra points."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Biopharma R&D emerging but not yet a designated talent category."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Bioinformatics scientists explicitly listed; pharma cluster sponsors visas quickly."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Highly Skilled Professional visa",
        "reason": "Genome medicine labs score high HSP points but competition for English speakers."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "NIMP 2030",
        "reason": "Bio-medical R&D encouraged, though semiconductor still dominates hiring."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Small but growing genomics groups; case-by-case employer sponsorship."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "National Genome Program hires talent, though healthcare staffing ranks higher."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Singapore Economy 2030",
        "reason": "Biomed & med-tech are core pillars; A*STAR and hospitals actively court bioinformaticians."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "We the UAE 2031",
        "reason": "Dubai Genomics Council recruiting, yet role not on headline lists."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences pillar funds NHS Genomics England; Skilled-Worker fast track."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act pours billions into biotech R&D and genomics; NIH-funded labs sponsor visas."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Nascent biotech scene; few employers can sponsor."
      }
    }
  },
  "c60eb669-d6bc-45cf-899e-447bb7fd1d5f": {
    "career": "Community College Instructor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "TAFE hiring exists but teaching visas prioritise STEM and K-12, not vocational faculty."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Colleges recruit overseas instructors, gaining points under French-speaker or educator streams."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Adult-education staff rarely obtain Blue Cards; German language a barrier."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Vocational educators hired on contracts, no fast-track immigration."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Focus on university-level research staff rather than FE lecturers."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Technical colleges prefer bilingual Japanese instructors; visa points modest."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Private colleges hire foreigners but easier local supply keeps demand modest."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Polytechs hire internationally but roles not on Green List; employer sponsorship needed."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Vision 2030",
        "reason": "Vocational colleges expanding, yet focus on engineering and tourism trainers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "ITE and polytechnics mainly employ PRs; foreign hires require proven industry fame."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Higher Colleges of Technology hire expats, though not a national shortage job."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Further-education lecturers removed from shortage list in 2025 review."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "Huge community-college system seeks faculty, yet not on federal talent lists."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "",
        "reason": "Some English-medium community colleges; visas possible but limited."
      }
    }
  },
  "cd1938ad-5790-47eb-b146-7223e2da8c4c": {
    "career": "Community Health Manager",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "Aged-care & public-health management included in priority healthcare occupations."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Healthcare administrators receive high CRS boosts and provincial nominations."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Hospitals seek managers for migrant integration and ageing population, but clinicians ranked higher."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Community health posts often government-reserved; limited foreign roles."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "HSE shortages mainly clinical; managers recruited but not on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Healthcare administrators rarely sponsored; language barrier significant."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "MADANI Economy",
        "reason": "Public-health campaigns expanding but local graduates plentiful."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "",
        "reason": "District health boards sponsor managers; not on Green List yet."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Vision 2030",
        "reason": "Mega-hospital projects and mandatory insurance spur demand for public-health managers."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Singapore Green Plan 2030",
        "reason": "Ageing-population initiatives need health-services managers, but local talent preferred."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "We the UAE 2031",
        "reason": "Health-tech hubs and medical tourism create immediate openings for non-clinical managers."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "NHS hires but current immigration priority focuses on nurses and R&D scientists."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "",
        "reason": "Public-health vacancies persist, but role not in federal STEM visa priority."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "NGOs hire some managers; no national priority designation."
      }
    }
  },
  "a755d41f-9a79-4e6d-b251-5105f3f3f9fc": {
    "career": "Culinary Specialist",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Chefs appear on state CSOL lists for tourism regions, though not federal Tier-1."
      },
      "canada": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Hotel/restaurant cooks allowed under SSW hospitality category but with language hurdles."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Chefs are periodically added to hospitality shortages, but below health and tech roles."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Luxury resort projects (NEOM, Red Sea) aggressively recruit world-class culinary talent for tourism goals."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai & Abu Dhabi position themselves as global dining hubs; high demand for skilled chefs."
      },
      "united_kingdom": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct policy, but steady demand from large food-service sector tied to infrastructure projects and tourism."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "4f1a8108-9e4c-4707-ba9b-14d7cdcd15b9": {
    "career": "Data Modeler",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Data analysts in health tech fall under priority tech skills list."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "AI/data specialists and healthcare analysts are top immigration targets."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT specialists and health analysts fast-tracked via Blue Card."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma and med-tech clusters in Dublin/Cork need data scientists."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Highly Skilled Professional visa",
        "reason": "Health-tech data science allowed but language barrier keeps priority moderate."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "Demand exists but below engineer and nurse shortages."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Vision 2030",
        "reason": "Health data modernization projects, but local hiring preferred."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "National AI Strategy 2.0",
        "reason": "Public-health analytics called out in AI strategy; good but not top-five field."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "We the UAE 2031",
        "reason": "Government pushes for advanced health analytics in Dubai Health Authority."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life-sciences R&D segment values epidemiological data modellers for drug trials."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "CHIPS and Science Act",
        "reason": "Public-health data infrastructure funding seeks epidemiology data experts."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "National Master Plan 2021-2030",
        "reason": "E-health projects growing but no special visa route."
      }
    }
  },
  "118213fc-b1fb-43fd-9100-6e1bbbf84b00": {
    "career": "Deep Learning Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Migration Strategy 2023",
        "reason": "Tech priority list includes AI engineers but scale smaller than North America."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "AI/ML is headline field; fast visas and grants in Toronto/Montréal hubs."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz",
        "reason": "Federal funding for Industry 4.0 and autonomous vehicles relies on DL talent."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "RPJPN 2025-2045",
        "reason": "Fintech and e-commerce need AI but not an official shortage list."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Dublin multinationals (Meta, Google) heavily recruit deep-learning talent."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Highly Skilled Professional visa",
        "reason": "Robotics and automotive giants need DL for smart factories."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "NIMP 2030",
        "reason": "AI roles exist within semiconductor strategy but still emerging."
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "King Abdullah City for AI and mega-projects recruiting global ML talent."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "National AI Strategy 2.0",
        "reason": "AI engineers explicitly Tier-1, with high salaries and EP schemes."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Operation 300bn",
        "reason": "Government AI office offers golden visas; strong demand in fintech and govtech."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Front-rank AI clusters in Cambridge, London; shortage occupation list includes ML specialists."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Frontier AI research and semiconductor incentives create massive demand."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Growing AI outsourcing, yet higher priority on hardware engineers."
      }
    }
  },
  "a8591721-a749-42b0-ad17-c20696b789ba": {
    "career": "Emergency Manager",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Migration Strategy 2023",
        "reason": "Bushfire and cyclone risks push states to recruit skilled disaster managers."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Climate-driven wildfire and flood response create demand for emergency planners."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Need exists but overshadowed by engineering shortages; some roles in civil protection."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "RPJPN 2025-2045",
        "reason": "Volcano, tsunami risk drive some demand but preference for locals."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Highly Skilled Professional visa",
        "reason": "Earthquake response expertise valued, but language/legal barriers high."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Skilled Migrant Category",
        "reason": "Earthquake-prone nation values emergency planners, though numbers are small."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Mega-city projects include risk management, but security clearances favour locals."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "We the UAE 2031",
        "reason": "Civil defence upgrading but positions limited."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Climate adaptation plans create some local authority roles, not nationally prioritised."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Bill allocates funds for climate resilience and disaster preparedness roles."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      }
    }
  },
  "ba5d624c-1ed5-49fa-bebc-9a0a2dbf71f8": {
    "career": "Fashion Entrepreneur",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Berlin's creative startup scene offers pathways but not policy-backed."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Vision 2030",
        "reason": "Entertainment and lifestyle sectors growing, but fashion still emerging."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Singapore Economy 2030",
        "reason": "DesignSingapore Council offers grants but fashion not Tier-1."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Dubai Design District offers visas and free-zone benefits for fashion start-ups."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industries recognised; Innovator Founder visa supports fashion enterprises."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "No direct policy but large consumer market and New York fashion ecosystem."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "557e45da-1219-48d8-967f-af99315ad2ab": {
    "career": "Health Policy Advisor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "States hire health-policy planners for ageing-care reforms, yet role is outside the Core Skills Occupation List."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "53",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Ottawa adds public-health strategists to strengthen universal healthcare sustainability; no formal shortage list, but steady hiring in provinces."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Federal and Länder institutes recruit health-policy experts to modernise insurance and eldercare, but not a listed shortage occupation."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "26",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Department of Health hires advisors for Sláintecare reforms, yet not on Critical Skills list; standard work permits still possible."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Skilled Migrant Category",
        "reason": "Te Whatu Ora seeks policy staff for Māori health equity; immigration pathway available but no formal Green List priority."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Green Plan 2030",
        "reason": "MOH Office for Healthcare Transformation hires some policy talent, yet role is not in National AI or Manufacturing priority lists."
      },
      "uae": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "NHS England recruits policy advisers for workforce planning, but role falls outside IS-8 priority clusters."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA’s expansion of public-health funding drives demand for analysts who can translate epidemiological data into state and federal policy."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "c8e3a473-2904-4f23-9734-59fa9ba72ea8": {
    "career": "Molecular Research Scientist",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Migration Strategy 2023",
        "reason": "Growing med-tech and vaccine manufacturing ecosystems seek molecular biologists, though not on Core List top tier."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Life-science PhDs qualify under STEM stream; strong demand in Toronto-Montreal pharma corridor."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Bio-pharma clusters in Bavaria and NRW actively hire non-EU researchers via fast-track Blue Card."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Focus on biopharma localisation, yet R&D roles are emerging rather than established."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma giants in Cork and Dublin rely on foreign molecular biologists; role sits on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "Government funds regenerative medicine; HSP visa rewards PhD-level biotech talent."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Plan includes medical devices and vaccines, but budgets smaller than regional rivals."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Skilled Migrant Category",
        "reason": "Limited but present biotech R&D; visas possible yet small market size."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "NEOM and KAUST invest in genomics, offering niche researcher roles."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Singapore Economy 2030",
        "reason": "Biopolis and A*STAR aggressively court molecular scientists, though quota caps keep Tier 2 status."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Operation 300bn",
        "reason": "Dubai Science Park and Abu Dhabi’s M42 recruit molecular scientists for precision medicine pilots."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "IS-8 highlights life-sciences; Oxford-Cambridge-London Golden Triangle aggressively recruits molecular scientists."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA funds biomanufacturing and advanced therapeutics, fuelling NIH and biotech hiring."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "49",
        "policy": "National Master Plan 2021-2030",
        "reason": "Nascent biotech sector; limited senior research funding."
      }
    }
  },
  "17a0eaab-0756-40d1-a1d7-47a71697439a": {
    "career": "Philosopher of Science",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Migration Strategy 2023",
        "reason": "Group of Eight universities sponsor academics; teaching demand stable."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Universities use Global Skills Stream for tenure-track humanities, although fewer positions exist."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "67",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "DAAD and Max Planck institutes fund philosophy of science projects; English programs expanding."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on Critical Skills list but universities can sponsor under Atypical Permissions."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Highly Skilled Professional visa",
        "reason": "Limited English-medium philosophy positions, but research institutes may hire distinguished scholars."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Migrant Category",
        "reason": "Small number of philosophy departments; visas possible but competition fierce."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "National AI Strategy 2.0",
        "reason": "NUS and NTU keep small philosophy-of-science units to debate ethics of AI."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "UAE Centennial 2071",
        "reason": "Branch campuses (NYU Abu Dhabi, Sorbonne) occasionally recruit philosophers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "World-class philosophy faculties remain; Skilled Worker visa accessible."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Large research universities still sponsor visas for humanities scholars despite STEM-heavy funding."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "ef1027a0-f756-49ad-be83-cdfa55a21977": {
    "career": "School Nurse",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Migration Strategy 2023",
        "reason": "Nursing shortages acute; states sponsor school and community nurses under Core Skills List."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "RNs are top priority; provinces add school-health positions due to mental-health push."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz",
        "reason": "Nationwide nursing deficit covers public-health school programmes."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "RNs on Critical Skills list; HSE funds school immunisation teams."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "RNs on Green List; MOE funds school-based services in rural areas."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Vision 2030",
        "reason": "Private international schools import foreign RNs for on-campus clinics."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Singapore Green Plan 2030",
        "reason": "MOE requires on-site health officers; foreign RNs hired but quotas tight."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "KHDA requires every Dubai school to employ a licensed nurse; visas streamlined."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Nursing remains shortage occupation, but funding constraints limit openings."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Federal funds boost K-12 health services to combat post-COVID gaps."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "3b9fbd70-3ab5-44d0-80a2-6f3ae1e63fe1": {
    "career": "Social Work Attorney",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Access to justice programmes recruit legal aid lawyers, but licensure transfer complex."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on Critical Skills list; NGOs can sponsor under Atypical Scheme."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "46",
        "policy": "Skilled Migrant Category",
        "reason": "Some demand in family courts; must retrain in NZ law."
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Legal aid shortage, but immigration caps and funding cuts restrict openings."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Federal funding for community justice increases public-interest legal roles, though not priority visa occupation."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "078ce38e-f30d-41c0-9842-26c1f68021a1": {
    "career": "Social Work Researcher",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Roles exist in universities and government think-tanks but not on the Core Skills Occupation List."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Researchers with a PhD score high CRS points and may be selected under the ‘academic’ or French-language streams."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Social scientists qualify under the Act’s ‘academic expert’ clause; English-language research posts rising."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Funding via Irish Research Council but not on Critical Skills List."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Highly Skilled Professional visa",
        "reason": "HSP points for PhD researchers; English-language social science labs limited."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Skilled Migrant Category",
        "reason": "Can qualify on points system but no dedicated shortage listing."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Vision 2030",
        "reason": "Government funds social development think-tanks to measure societal transformation."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "National AI Strategy 2.0",
        "reason": "Social service offices use data-driven policy labs, but numbers small and citizenship bias strong."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "We the UAE 2031",
        "reason": "Policy labs need impact evaluators for education, family and youth initiatives."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Universities and charities recruit researchers; post-study work route eases entry."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "",
        "reason": "University-based social policy centres can use cap-exempt H-1B and J-1 visas for research staff."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "94193ccc-d018-443d-8d8e-896ac2b4cc36": {
    "career": "Solar Engineer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Migration Strategy 2023",
        "reason": "Massive solar farms in the Northern Territory need design and commissioning talent on the Core Skills list."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "New tax credits for renewables and express-entry priority for clean-tech engineers."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Energiewende accelerates rooftop and utility solar; firms sponsor Blue-Card engineers quickly."
      },
      "indonesia": {
        "tier": "Tier 1",
        "score": "81",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Archipelago micro-grid and floating PV push needs engineers alongside geothermal and battery projects."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Solar design engineers included under electrical engineers shortage."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Highly Skilled Professional visa",
        "reason": "Feed-in tariffs keep utility solar growing; HSP route favours engineers with graduate degrees."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "69",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "NIMP targets 40 % renewable mix, boosting rooftop and floating solar manufacturing."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Solar engineers newly added to Tier 2 of the Green List enabling fast residency."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Vision 2030",
        "reason": "Gigawatt-scale NEOM and Red Sea projects rely on desert solar R&D and EPC expertise."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Singapore Green Plan 2030",
        "reason": "Limited land for solar but floating-PV and regional power-grid research create niche roles."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Operation 300bn",
        "reason": "Mohammed bin Rashid Al Maktoum Solar Park expansion recruits PV design and O&M engineers."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Offshore wind dominant, yet IS-8 also funds solar storage hybrid plants requiring systems engineers."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "IRA pours US$370 B into solar manufacture, grid integration and utility-scale projects, driving huge demand for engineers."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "67",
        "policy": "National Master Plan 2021-2030",
        "reason": "DPPA and FiT 2 attract foreign solar EPCs needing design talent."
      }
    }
  },
  "0dfe2d6e-caaf-4573-8cdc-0073d903754d": {
    "career": "Sustainable Building Designer",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Migration Strategy 2023",
        "reason": "Net-zero construction code creates shortage of ESD (environmentally sustainable design) professionals."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Green-building architects receive high CRS for STEM degrees and climate skills."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Stricter EnEV standards and massive retrofit grants need passive-house designers."
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "63",
        "policy": "RPJPN 2025-2045",
        "reason": "Nusantara smart-city build emphasises green design principles and tropical passive cooling."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Sustainability skills valued but only senior architects receive Critical Skills permits."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "ZEB (Zero-Energy Building) roadmap encourages HSP hires, yet language and seismic code mastery required."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "64",
        "policy": "MADANI Economy",
        "reason": "Klang Valley high-rise boom includes GBI (Green Building Index) targets."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Tier-2 list includes construction project managers with green-build expertise."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Vision 2030",
        "reason": "NEOM and Red Sea projects aim for net-zero campuses, recruiting sustainable design teams."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Singapore Green Plan 2030",
        "reason": "80 % of buildings must be Green-Mark certified by 2030, sustaining demand for integrative designers."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "81",
        "policy": "Operation 300bn",
        "reason": "Dubai’s Green Building Regulations mandate energy modelling for all new large structures."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Heat-pump retrofits and carbon-neutral campuses funded under IS-8 create steady demand."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "IIJA allocates billions for energy-efficient public buildings, demanding LEED-savvy designers."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "59",
        "policy": "National Master Plan 2021-2030",
        "reason": "Urban cooling mandates open niche but pay lower than global average."
      }
    }
  },
  "4ff6df36-9c46-49d9-9dca-95995d713ebe": {
    "career": "Visual Development Artist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "",
        "reason": "Tax incentives keep Vancouver-Montreal animation hubs hiring but competition fierce."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "",
        "reason": "Cartoon Saloon and gaming tax credits create boutique demand."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Anime and game giants value strong portfolios; language still barrier."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "",
        "reason": "Wētā and game studios recruit internationals on project visas."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Vision 2030",
        "reason": "Entertainment push funds new animation studios like Manga Productions."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "",
        "reason": "Lucasfilm and Ubisoft hubs hire artists under media development grants but quota small."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Government grants for gaming and media clusters in Abu Dhabi/Dubai."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry seniors listed; London and Manchester studios need IP visualisation experts."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "",
        "reason": "Hollywood and streaming platforms remain largest employers despite no dedicated federal policy."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      }
    }
  },
  "2d914371-fec6-4ef6-b0a9-5015610d5840": {
    "career": "Brand Communications Manager",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "31",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Tourism and giga-projects need English-speaking brand leads, though expatriate quotas tightening."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "",
        "reason": "Regional HQs base brand teams here, but COMPASS points system favours locals."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "We the UAE 2031",
        "reason": "Dubai’s global events and free-zone media clusters continuously hire mid-senior brand managers."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "43",
        "policy": "",
        "reason": "Large agencies recruit, but the Skilled Worker visa minimum salary is a hurdle."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "",
        "reason": "Role exists widely but no immigration priority; competition with domestic marketing grads."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "41ec9f0c-7065-4e78-8e26-6ce452e68c00": {
    "career": "Budget Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Migration Strategy 2023",
        "reason": "Role not on Core Skills list yet needed across government departments."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Finance not on priority list, but public-sector budgeting still gets points under general skilled category."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Controller/Budgeter counted as business specialists under new points system."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on CSOL; demand limited to corporate HQ budgeting."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Generic business analysts acceptable for points but no shortage listing."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Vision 2030",
        "reason": "Mega-projects (NEOM, Red Sea) require rigorous budget oversight talents."
      },
      "singapore": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "uae": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "We the UAE 2031",
        "reason": "Federal and emirate entities scaling finance teams for diversification plans."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Finance not on shortage list but openings exist in local councils."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Federal and state agencies hiring analysts to track multi-billion-dollar infrastructure outlays."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "25",
        "policy": "",
        "reason": ""
      }
    }
  },
  "df61027d-2c5d-428e-b3a8-08f9183a1134": {
    "career": "Business Systems Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Business and Systems Analysts explicitly listed on Medium-Term Skill Shortage list."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Software and IT professionals get top immigration priority; BSA roles map to NOC 21221."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "IT Spezialist category allows visa without degree for analysts with experience."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Digital public services and e-commerce ecosystem expansion require BSA skills."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "ICT Business & Systems Analysts are specifically named on Critical Skills list."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Highly Skilled Professional visa",
        "reason": "High points for IT specialists bridging systems design and operations."
      },
      "malaysia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Industry 4.0 rollouts rely on analysts who can redesign legacy processes."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Migrant Category",
        "reason": "IT business analysts score high points though not on Green List."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Vision 2030",
        "reason": "Digital platforms for tourism, fintech and healthcare drive demand for systems analysts."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "National AI Strategy 2.0",
        "reason": "Analysts valued to align AI projects with business KPIs."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Operation 300bn",
        "reason": "Smart government and fintech expansion need analysts to bridge business and tech."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Digital/AI specialists on shortage list; BSAs qualify under SOC 2135."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "CHIPS and Science Act",
        "reason": "Digital transformation talent needed across semiconductor and advanced manufacturing projects."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Electronics manufacturers need analysts for ERP and supply-chain systems."
      }
    }
  },
  "7ade862b-294c-4c8c-9cb8-302a849c9660": {
    "career": "Cell Biology Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Migration Strategy 2023",
        "reason": "Bio-medical scientists receive priority under research stream visas."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Biotech researchers fall under high-skilled STEM emphasis."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Life-science labs struggle to staff cell culture & analytics roles."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "RPJPN 2025-2045",
        "reason": "Government wants biopharma capability but infrastructure still building."
      },
      "ireland": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Pharma and med-tech clusters (Cork, Dublin) hire cell scientists aggressively."
      },
      "japan": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Highly Skilled Professional visa",
        "reason": "Regenerative medicine labs actively recruit foreign researchers."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "NIMP 2030",
        "reason": "Biopharma is a growth pillar but hiring pace still moderate."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Skilled Migrant Category",
        "reason": "No specific shortage, but points for PhD in STEM."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Nascent biotech clusters need limited but growing cell biology expertise."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "Singapore Economy 2030",
        "reason": "Biomedical manufacturing 2030 roadmap lists cell therapy R&D as core."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "UAE Centennial 2071",
        "reason": "Government funding Abu Dhabi Biotech Hub; visas streamlined for researchers."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Life sciences and cell-therapy manufacturing are headline focus areas."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Act pours billions into life-science R&D, especially cellular therapeutics and bio-manufacturing."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "National Master Plan 2021-2030",
        "reason": "Early-stage biotech ecosystem—roles limited to a few research parks."
      }
    }
  },
  "e3f74376-1395-49ca-b073-974852560abd": {
    "career": "Clinical Leader",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Aged-care and hospital nurse unit managers flagged as critical shortages."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Nurse managers and clinical supervisors on healthcare priority list."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Severe nurse shortage; leadership posts fast-tracked after B2 German."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Clinical nurse managers included in Critical Skills list."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Focus on caregiving aides; leadership visas less common."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "MADANI Economy",
        "reason": "Private hospitals import some nurse leaders but no fast-track scheme."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Registered Nurse leaders get straight-to-residence pathways."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Vision 2030",
        "reason": "International hospital groups need clinical directors for mega-cities."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Green Plan 2030",
        "reason": "Hospitals hire foreign RNs, but leadership roles usually require local registration and experience."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "We the UAE 2031",
        "reason": "Private hospitals and medical tourism demand seasoned nurse leaders."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "Nurse shortages continue, but leadership visas capped post-2025."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Funding boosts community hospitals, but role not singled out for visas."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "c59ebcf8-ed19-4496-a597-f28e41140cbb": {
    "career": "Creative Strategist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Marketing not on priority lists; generic skilled pathway only."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Entertainment & sports boom drives demand for senior brand storytellers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Economy 2030",
        "reason": "Creative sector exists but not in priority clusters of AI or semiconductor."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "We the UAE 2031",
        "reason": "Dubai Media City courts global creative talent for regional campaigns."
      },
      "united_kingdom": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative industry seniors explicitly targeted; London agencies sponsor visas."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct policy support; roles exist but not visa-prioritised."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "5a0fb9f6-d508-4d5b-9780-8a920b4e8f58": {
    "career": "Cultural Attaché",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "29",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Not a fit",
        "score": "37",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Kingdom invests in cultural diplomacy to rebrand internationally—embassies seek specialists."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Singapore Economy 2030",
        "reason": "City-state uses cultural diplomacy for soft power but not a stated manpower priority."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "66",
        "policy": "We the UAE 2031",
        "reason": "Government promotes soft power and cultural exchange through Dubai/Abu Dhabi cultural districts."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry promotion indirectly favours cultural officers but not listed shortage."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Soft-power cultural diplomacy supports tourism and creative exports but is not an explicit labour-shortage occupation."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "28",
        "policy": "",
        "reason": ""
      }
    }
  },
  "c3fe73ef-7e52-4f4f-8fdd-ce1c22b7a2fa": {
    "career": "ESP Instructor",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "56",
        "policy": "Migration Strategy 2023",
        "reason": "Adult-education teachers recognised but not on Core Skills Occupation List."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "59",
        "policy": "Express Entry Category-Based Selection",
        "reason": "French-speaker preference limits demand; ESL instructors only moderate need."
      },
      "germany": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "indonesia": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Nickel-EV and tourism projects require English workplace skills for local staff."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Vocational schools seek ESP teachers for hospitality and aviation under SSW hiring."
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "MADANI Economy",
        "reason": "Growth of aerospace and semiconductor sectors increases need for technical-English training."
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Skilled Migrant Category",
        "reason": "International-education sector seeks ESP teachers for migrants and vocational colleges."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Vision 2030",
        "reason": "Massive upskilling push in tourism and defence sectors drives high demand for specialised English trainers."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "National AI Strategy 2.0",
        "reason": "English is already main working language; niche ESP demand filled locally."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "We the UAE 2031",
        "reason": "Free-zone universities and aviation/fintech hubs recruit ESP faculty for workforce localisation."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "List recently removed generic language teachers; niche demand persists in aviation and maritime colleges."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Vocational English tied to workforce upskilling for infrastructure projects but not a shortage occupation."
      },
      "vietnam": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "National Master Plan 2021-2030",
        "reason": "Government funded ESP programmes in high-tech parks and tourism zones."
      }
    }
  },
  "cdc71411-b517-472a-bc04-1c37bac5a841": {
    "career": "Failure Analyst",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Mining-equipment and defence manufacturing rely on failure analysis for safety."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Emerging battery-materials and aerospace clusters require reliability specialists."
      },
      "germany": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Automotive and renewable-energy sectors urgently need materials and failure experts."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "59",
        "policy": "RPJPN 2025-2045",
        "reason": "EV battery plants will eventually require failure analysts but pipeline still small."
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "57",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Med-device manufacturers employ failure analysts, but numbers are modest."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Highly Skilled Professional visa",
        "reason": "Semiconductor and robotics giants prize micro-failure experts."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "IC packaging and aerospace clusters list failure analysis as critical skill."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Limited but growing aerospace and med-device firms look for reliability engineers."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Megaprojects and defence manufacturing require robust failure investigations."
      },
      "singapore": {
        "tier": "Tier 2",
        "score": "76",
        "policy": "Manufacturing 2030",
        "reason": "Precision-engineering and medtech firms run dedicated failure-analysis labs."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Operation 300bn",
        "reason": "Push for advanced manufacturing includes need for lab-level failure analysis."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Aerospace and clean-energy OEMs list reliability engineers on shortage lists."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "Semiconductor fabs and EV battery plants need engineers to diagnose component failures quickly."
      },
      "vietnam": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "New fabs need reliability and failure specialists to hit export quality."
      }
    }
  },
  "8e65b3f1-28d1-4059-8775-f98f2b9e707a": {
    "career": "Fashion Technologist",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Technical-textile clusters in Saxony recruit limited fashion technologists."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "53",
        "policy": "Golden Indonesia 2045 Vision (Indonesia Emas 2045)",
        "reason": "Textile sector modernisation needs digital-fabric tech but not prioritised."
      },
      "ireland": {
        "tier": "Not a fit",
        "score": "39",
        "policy": "",
        "reason": ""
      },
      "japan": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Highly Skilled Professional visa",
        "reason": "Wearable-tech and smart-textile R&D recruits niche foreign talent."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "36",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Vision 2030",
        "reason": "New entertainment and retail zones seek tech-forward fashion innovation."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Green Plan 2030",
        "reason": "Fashion tech too small to rank among manufacturing priorities."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "We the UAE 2031",
        "reason": "Dubai Design District promotes smart textiles and 3D-printed fashion."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industry pillar backs sustainable fashion tech, 3D knitting, and circular economy."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "54",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Sustainable-materials R&D aligns with green manufacturing goals but niche hiring."
      },
      "vietnam": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "National Master Plan 2021-2030",
        "reason": "Large garment industry experimenting with digital pattern-making and automation."
      }
    }
  },
  "35498356-90de-4a43-9eb2-5655ce89fe75": {
    "career": "Forensic Mental Health Clinician",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "85",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Forensic psychiatrists and psychologists on priority list for regional hospitals and prisons."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "90",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Severe shortage of psychiatrists and clinical psychologists, especially in correctional services."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Mental-health professionals needed; forensic specialism valued but language barrier slows uptake."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "33",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Forensic mental-health roles fall under doctor/psychologist shortages."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "MADANI Economy",
        "reason": "Mental-health clinicians in demand but visas prioritise industrial skills."
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Forensic psychologists and psychiatrists explicitly listed for immediate residence pathway."
      },
      "saudi_arabia": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Vision 2030",
        "reason": "Prison reform and new mental-health hospitals drive demand for specialised clinicians."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "58",
        "policy": "Singapore Green Plan 2030",
        "reason": "Mental-health roles exist but are not top manpower priorities."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "UAE Centennial 2071",
        "reason": "Private forensic psychiatry centres serving courts require international talent."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "74",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "NHS shortage of forensic psychiatrists keeps role on shortage list despite broader healthcare cuts."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "Indirect demand via funded community-justice programmes, but not an immigration priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      }
    }
  },
  "d7142fe0-64c8-478a-95d3-4e6fce9baa01": {
    "career": "Infrastructure Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Civil engineers and construction PMs are priority occupations for permanent residency."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Civil engineers receive extra CRS points; provinces list infrastructure planners as in-demand."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "78",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Nationwide shortage of civil engineers to modernise rail, bridges and renewables grids."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Civil engineers are eligible yet overall project volume is modest compared to Tier-1 countries."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Ageing bridges and seismic retrofits create need, but language/licensing barriers lower attractiveness."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "Green List (Tier 2)",
        "reason": "Post-earthquake rebuild and housing push put civil/infrastructure consultants on fast-track visa list."
      },
      "saudi_arabia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Vision 2030",
        "reason": "Gigaprojects like NEOM and Red Sea require international infrastructure consultants for planning and sustainability audits."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Green Plan 2030",
        "reason": "Limited land but steady MRT and reclamation projects sustain niche consultancy demand."
      },
      "uae": {
        "tier": "Tier 1",
        "score": "81",
        "policy": "We the UAE 2031",
        "reason": "Smart-city and transport corridors need consultants versed in mega-project governance."
      },
      "united_kingdom": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Infrastructure is funded, but skilled-worker visa now favors advanced manufacturing over general civil roles."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "USD1.2 trillion federal spend on roads, bridges and broadband drives demand for civil engineers who can advise on project planning and risk."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "32",
        "policy": "",
        "reason": ""
      }
    }
  },
  "54db9b29-3613-4c93-91e0-4d8790aacd4f": {
    "career": "Microengineer",
    "countries": {
      "australia": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "Migration Strategy 2023",
        "reason": "Electronics engineers get points though country lacks major fabs."
      },
      "canada": {
        "tier": "Tier 2",
        "score": "68",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Canada courting chip designers for Ontario ‘Silicon Valley North’, but scale remains small."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "70",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Intel and TSMC Dresden investments create strong demand for semiconductor process engineers."
      },
      "indonesia": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "RPJPN 2025-2045",
        "reason": "Focus on battery supply chain; semiconductor roles mostly packaging not design."
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "75",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Intel’s Leixlip expansion and Analog Devices Cork keep microengineers in high demand."
      },
      "japan": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Highly Skilled Professional visa",
        "reason": "TSMC-Sony joint fab and national push for chip self-reliance require advanced microengineering talent."
      },
      "malaysia": {
        "tier": "Tier 1",
        "score": "84",
        "policy": "New Industrial Master Plan 2030 (NIMP 2030)",
        "reason": "Penang’s ‘Silicon Island’ programme needs IC design and wafer-fab engineers now."
      },
      "new_zealand": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Skilled Migrant Category",
        "reason": "Tiny domestic chip sector; roles limited to university labs."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Government exploring local fab initiatives but talent demand still emerging."
      },
      "singapore": {
        "tier": "Tier 1",
        "score": "88",
        "policy": "Manufacturing 2030",
        "reason": "Govt funds GlobalFoundries and Micron expansions; microengineers qualify for one-year EP fast-track."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Operation 300bn",
        "reason": "Advanced manufacturing push mentions semiconductors; ecosystem nascent."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Compound-semiconductor cluster in Wales seeks designers, but scale below Tier-1."
      },
      "united_states": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "CHIPS and Science Act",
        "reason": "USD52 billion incentives for domestic semiconductor R&D and fabs place microengineers at the centre of national strategy."
      },
      "vietnam": {
        "tier": "Tier 1",
        "score": "82",
        "policy": "Semiconductor Industry Strategy (Decision 1018)",
        "reason": "Country targets 50,000 chip engineers by 2030; generous work permits for foreign experts."
      }
    }
  },
  "22332621-f3af-42cf-8f9f-9f46e15f4ac5": {
    "career": "Optometrist",
    "countries": {
      "australia": {
        "tier": "Tier 1",
        "score": "86",
        "policy": "Core Skills Occupation List (CSOL)",
        "reason": "Optometrists on Medium-Long Term Strategic Skills List; easy path to 189 visa."
      },
      "canada": {
        "tier": "Tier 1",
        "score": "92",
        "policy": "Express Entry Category-Based Selection",
        "reason": "Healthcare occupations get highest CRS boosts; rural provinces offer immediate PR for optometrists."
      },
      "germany": {
        "tier": "Tier 2",
        "score": "72",
        "policy": "Skilled Immigration Act (Fachkräfteeinwanderungsgesetz)",
        "reason": "Ageing population increases need for eye care; extra language exam required."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 2",
        "score": "63",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Listed health profession; fast residence but small market size."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Specified Skilled Worker (SSW)",
        "reason": "Work available in eyewear retail; language and licensure hurdles remain."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Tier 1",
        "score": "80",
        "policy": "Green List (Tier 1/Tier 2)",
        "reason": "Listed under Tier-1 health roles, offering straight-to-residence visas."
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "Vision 2030",
        "reason": "Private hospital boom demands expat eye-care staff, but Saudization quotas rising."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Singapore Green Plan 2030",
        "reason": "Demand steady but quota-tight; foreign Optometry Council exam needed."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "We the UAE 2031",
        "reason": "Large optical retail chains import optometrists for malls and clinics."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Skilled Worker visa Temporary Shortage List",
        "reason": "NHS shortage means quick sponsorship, though new salary thresholds apply."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Indirectly funds community clinics; visas limited, but private chains recruit."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "27fa482e-3851-440d-a939-b42c72f0281e": {
    "career": "People Management Consultant",
    "countries": {
      "australia": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Migration Strategy 2023",
        "reason": "HR professionals removed from priority lists in 2024 review."
      },
      "canada": {
        "tier": "Tier 3",
        "score": "50",
        "policy": "International Talent Attraction Strategy 2026",
        "reason": "Tech companies hire HR advisors, yet immigration focus is technical roles."
      },
      "germany": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "HR skills count for points but preference given to STEM profiles."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "48",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not on critical list, but multinationals in Dublin still engage HR consultants."
      },
      "japan": {
        "tier": "Tier 3",
        "score": "44",
        "policy": "Highly Skilled Professional visa",
        "reason": "Language-heavy HR advisory limits openings for foreigners."
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Tier 3",
        "score": "52",
        "policy": "Vision 2030",
        "reason": "Mega-projects hire culture consultants, though roles often short-term."
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "49",
        "policy": "National AI Strategy 2.0",
        "reason": "HR tech startups need people-analytics consultants, but not a Tier-1 priority."
      },
      "uae": {
        "tier": "Tier 2",
        "score": "60",
        "policy": "UAE Centennial 2071",
        "reason": "Free-zone multinationals outsource HR transformation to consultants."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "62",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "City firms pay for HR analytics to retain international staff post-Brexit."
      },
      "united_states": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Inflation Reduction Act (IRA)",
        "reason": "Corporate transformations funded by incentives need change-management advisors, but not a named priority."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  },
  "7f09fd9c-7504-400a-a96f-f352c45b6bb9": {
    "career": "Performing Arts Educator",
    "countries": {
      "australia": {
        "tier": "Not a fit",
        "score": "35",
        "policy": "",
        "reason": ""
      },
      "canada": {
        "tier": "Not a fit",
        "score": "38",
        "policy": "",
        "reason": ""
      },
      "germany": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Opportunity Card (Chancenkarte)",
        "reason": "Kulturförderung funds some roles, but visas prioritise STEM."
      },
      "indonesia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "ireland": {
        "tier": "Tier 3",
        "score": "45",
        "policy": "Critical Skills Occupations List (DETE)",
        "reason": "Not critical, but EU arts grants support some non-EU educators."
      },
      "japan": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "malaysia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "new_zealand": {
        "tier": "Not a fit",
        "score": "34",
        "policy": "",
        "reason": ""
      },
      "saudi_arabia": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      },
      "singapore": {
        "tier": "Tier 3",
        "score": "40",
        "policy": "Singapore Economy 2030",
        "reason": "Art schools hire specialists, but role not in Tier-1 list."
      },
      "uae": {
        "tier": "Tier 3",
        "score": "42",
        "policy": "UAE Centennial 2071",
        "reason": "Dubai’s creative hubs hire foreign dance and drama teachers on project visas."
      },
      "united_kingdom": {
        "tier": "Tier 2",
        "score": "65",
        "policy": "Modern Industrial Strategy (IS-8)",
        "reason": "Creative-industries push keeps conservatoires hiring, though not on official shortage list."
      },
      "united_states": {
        "tier": "Tier 3",
        "score": "55",
        "policy": "Infrastructure Investment and Jobs Act (IIJA)",
        "reason": "No direct link; demand exists in private schools and community programs, not policy-driven."
      },
      "vietnam": {
        "tier": "Not a fit",
        "score": "30",
        "policy": "",
        "reason": ""
      }
    }
  }
};
